import { jsx as H, jsxs as ie, Fragment as De } from "react/jsx-runtime";
import * as ue from "react";
import oe, { useState as ne, useRef as J, useEffect as re, useCallback as he, useContext as ze, createContext as Ze, useMemo as ge, cloneElement as en, Children as He, useLayoutEffect as na, isValidElement as pn, useReducer as Ii, forwardRef as Se, Fragment as st, createElement as se, createRef as ry } from "react";
import * as ay from "react-dom";
import iy, { flushSync as zc, createPortal as Di } from "react-dom";
function ch(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (n = ch(e[t])) && (r && (r += " "), r += n);
    else
      for (t in e)
        e[t] && (r && (r += " "), r += t);
  return r;
}
function _n() {
  for (var e, t, n = 0, r = ""; n < arguments.length; )
    (e = arguments[n++]) && (t = ch(e)) && (r && (r += " "), r += t);
  return r;
}
function oy() {
  for (var e = 0, t, n, r = ""; e < arguments.length; )
    (t = arguments[e++]) && (n = uh(t)) && (r && (r += " "), r += n);
  return r;
}
function uh(e) {
  if (typeof e == "string")
    return e;
  for (var t, n = "", r = 0; r < e.length; r++)
    e[r] && (t = uh(e[r])) && (n && (n += " "), n += t);
  return n;
}
var Mc = "-";
function ly(e) {
  var t = cy(e), n = e.conflictingClassGroups, r = e.conflictingClassGroupModifiers, a = r === void 0 ? {} : r;
  function i(l) {
    var s = l.split(Mc);
    return s[0] === "" && s.length !== 1 && s.shift(), dh(s, t) || sy(l);
  }
  function o(l, s) {
    var u = n[l] || [];
    return s && a[l] ? [].concat(u, a[l]) : u;
  }
  return {
    getClassGroupId: i,
    getConflictingClassGroupIds: o
  };
}
function dh(e, t) {
  var o;
  if (e.length === 0)
    return t.classGroupId;
  var n = e[0], r = t.nextPart.get(n), a = r ? dh(e.slice(1), r) : void 0;
  if (a)
    return a;
  if (t.validators.length !== 0) {
    var i = e.join(Mc);
    return (o = t.validators.find(function(l) {
      var s = l.validator;
      return s(i);
    })) == null ? void 0 : o.classGroupId;
  }
}
var Y1 = /^\[(.+)\]$/;
function sy(e) {
  if (Y1.test(e)) {
    var t = Y1.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function cy(e) {
  var t = e.theme, n = e.prefix, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, a = dy(Object.entries(e.classGroups), n);
  return a.forEach(function(i) {
    var o = i[0], l = i[1];
    qs(l, r, o, t);
  }), r;
}
function qs(e, t, n, r) {
  e.forEach(function(a) {
    if (typeof a == "string") {
      var i = a === "" ? t : X1(t, a);
      i.classGroupId = n;
      return;
    }
    if (typeof a == "function") {
      if (uy(a)) {
        qs(a(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: a,
        classGroupId: n
      });
      return;
    }
    Object.entries(a).forEach(function(o) {
      var l = o[0], s = o[1];
      qs(s, X1(t, l), n, r);
    });
  });
}
function X1(e, t) {
  var n = e;
  return t.split(Mc).forEach(function(r) {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}
function uy(e) {
  return e.isThemeGetter;
}
function dy(e, t) {
  return t ? e.map(function(n) {
    var r = n[0], a = n[1], i = a.map(function(o) {
      return typeof o == "string" ? t + o : typeof o == "object" ? Object.fromEntries(Object.entries(o).map(function(l) {
        var s = l[0], u = l[1];
        return [t + s, u];
      })) : o;
    });
    return [r, i];
  }) : e;
}
function fy(e) {
  if (e < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  function a(i, o) {
    n.set(i, o), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get: function(o) {
      var l = n.get(o);
      if (l !== void 0)
        return l;
      if ((l = r.get(o)) !== void 0)
        return a(o, l), l;
    },
    set: function(o, l) {
      n.has(o) ? n.set(o, l) : a(o, l);
    }
  };
}
var fh = "!";
function py(e) {
  var t = e.separator || ":", n = t.length === 1, r = t[0], a = t.length;
  return function(o) {
    for (var l = [], s = 0, u = 0, f, h = 0; h < o.length; h++) {
      var g = o[h];
      if (s === 0) {
        if (g === r && (n || o.slice(h, h + a) === t)) {
          l.push(o.slice(u, h)), u = h + a;
          continue;
        }
        if (g === "/") {
          f = h;
          continue;
        }
      }
      g === "[" ? s++ : g === "]" && s--;
    }
    var v = l.length === 0 ? o : o.substring(u), E = v.startsWith(fh), b = E ? v.substring(1) : v, w = f && f > u ? f - u : void 0;
    return {
      modifiers: l,
      hasImportantModifier: E,
      baseClassName: b,
      maybePostfixModifierPosition: w
    };
  };
}
function hy(e) {
  if (e.length <= 1)
    return e;
  var t = [], n = [];
  return e.forEach(function(r) {
    var a = r[0] === "[";
    a ? (t.push.apply(t, n.sort().concat([r])), n = []) : n.push(r);
  }), t.push.apply(t, n.sort()), t;
}
function vy(e) {
  return {
    cache: fy(e.cacheSize),
    splitModifiers: py(e),
    ...ly(e)
  };
}
var my = /\s+/;
function gy(e, t) {
  var n = t.splitModifiers, r = t.getClassGroupId, a = t.getConflictingClassGroupIds, i = /* @__PURE__ */ new Set();
  return e.trim().split(my).map(function(o) {
    var l = n(o), s = l.modifiers, u = l.hasImportantModifier, f = l.baseClassName, h = l.maybePostfixModifierPosition, g = r(h ? f.substring(0, h) : f), v = !!h;
    if (!g) {
      if (!h)
        return {
          isTailwindClass: !1,
          originalClassName: o
        };
      if (g = r(f), !g)
        return {
          isTailwindClass: !1,
          originalClassName: o
        };
      v = !1;
    }
    var E = hy(s).join(":"), b = u ? E + fh : E;
    return {
      isTailwindClass: !0,
      modifierId: b,
      classGroupId: g,
      originalClassName: o,
      hasPostfixModifier: v
    };
  }).reverse().filter(function(o) {
    if (!o.isTailwindClass)
      return !0;
    var l = o.modifierId, s = o.classGroupId, u = o.hasPostfixModifier, f = l + s;
    return i.has(f) ? !1 : (i.add(f), a(s, u).forEach(function(h) {
      return i.add(l + h);
    }), !0);
  }).reverse().map(function(o) {
    return o.originalClassName;
  }).join(" ");
}
function J1() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r, a, i, o = l;
  function l(u) {
    var f = t[0], h = t.slice(1), g = h.reduce(function(v, E) {
      return E(v);
    }, f());
    return r = vy(g), a = r.cache.get, i = r.cache.set, o = s, s(u);
  }
  function s(u) {
    var f = a(u);
    if (f)
      return f;
    var h = gy(u, r);
    return i(u, h), h;
  }
  return function() {
    return o(oy.apply(null, arguments));
  };
}
function Me(e) {
  var t = function(r) {
    return r[e] || [];
  };
  return t.isThemeGetter = !0, t;
}
var ph = /^\[(?:([a-z-]+):)?(.+)\]$/i, yy = /^\d+\/\d+$/, by = /* @__PURE__ */ new Set(["px", "full", "screen"]), wy = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, xy = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Ey = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function Tt(e) {
  return On(e) || by.has(e) || yy.test(e) || Zs(e);
}
function Zs(e) {
  return Rn(e, "length", Ty);
}
function $y(e) {
  return Rn(e, "size", hh);
}
function Py(e) {
  return Rn(e, "position", hh);
}
function Cy(e) {
  return Rn(e, "url", Ay);
}
function ba(e) {
  return Rn(e, "number", On);
}
function On(e) {
  return !Number.isNaN(Number(e));
}
function Sy(e) {
  return e.endsWith("%") && On(e.slice(0, -1));
}
function Er(e) {
  return Q1(e) || Rn(e, "number", Q1);
}
function Ee(e) {
  return ph.test(e);
}
function $r() {
  return !0;
}
function sn(e) {
  return wy.test(e);
}
function ky(e) {
  return Rn(e, "", Oy);
}
function Rn(e, t, n) {
  var r = ph.exec(e);
  return r ? r[1] ? r[1] === t : n(r[2]) : !1;
}
function Ty(e) {
  return xy.test(e);
}
function hh() {
  return !1;
}
function Ay(e) {
  return e.startsWith("url(");
}
function Q1(e) {
  return Number.isInteger(Number(e));
}
function Oy(e) {
  return Ey.test(e);
}
function e0() {
  var e = Me("colors"), t = Me("spacing"), n = Me("blur"), r = Me("brightness"), a = Me("borderColor"), i = Me("borderRadius"), o = Me("borderSpacing"), l = Me("borderWidth"), s = Me("contrast"), u = Me("grayscale"), f = Me("hueRotate"), h = Me("invert"), g = Me("gap"), v = Me("gradientColorStops"), E = Me("gradientColorStopPositions"), b = Me("inset"), w = Me("margin"), S = Me("opacity"), T = Me("padding"), A = Me("saturate"), V = Me("scale"), $ = Me("sepia"), _ = Me("skew"), y = Me("space"), c = Me("translate"), p = function() {
    return ["auto", "contain", "none"];
  }, d = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, m = function() {
    return ["auto", Ee, t];
  }, O = function() {
    return [Ee, t];
  }, x = function() {
    return ["", Tt];
  }, P = function() {
    return ["auto", On, Ee];
  }, N = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, D = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, I = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, C = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, L = function() {
    return ["", "0", Ee];
  }, k = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, M = function() {
    return [On, ba];
  }, F = function() {
    return [On, Ee];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [$r],
      spacing: [Tt],
      blur: ["none", "", sn, Ee],
      brightness: M(),
      borderColor: [e],
      borderRadius: ["none", "", "full", sn, Ee],
      borderSpacing: O(),
      borderWidth: x(),
      contrast: M(),
      grayscale: L(),
      hueRotate: F(),
      invert: L(),
      gap: O(),
      gradientColorStops: [e],
      gradientColorStopPositions: [Sy, Zs],
      inset: m(),
      margin: m(),
      opacity: M(),
      padding: O(),
      saturate: M(),
      scale: M(),
      sepia: L(),
      skew: F(),
      space: O(),
      translate: O()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", Ee]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [sn]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": k()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": k()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(N(), [Ee])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: d()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": d()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": d()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: p()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": p()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": p()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [b]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [b]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [b]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [b]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [b]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [b]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [b]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [b]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [b]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", Er]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: m()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", Ee]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: L()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: L()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", Er]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [$r]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", Er]
        }, Ee]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": P()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": P()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [$r]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [Er]
        }, Ee]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": P()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": P()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", Ee]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", Ee]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [g]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [g]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [g]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(C())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(C(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(C(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [T]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [T]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [T]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [T]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [T]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [T]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [T]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [T]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [T]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [w]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [w]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [w]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [w]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [w]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [w]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [w]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [w]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [w]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [y]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [y]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", Ee, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", Ee, Tt]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [sn]
        }, sn, Ee]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [Ee, t, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", Ee, Tt]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [Ee, t, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", sn, Zs]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", ba]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [$r]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", Ee]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", On, ba]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", Ee, Tt]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", Ee]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", Ee]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [S]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [S]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(D(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Tt]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", Ee, Tt]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: O()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", Ee]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", Ee]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [S]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(N(), [Py])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", $y]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, Cy]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [E]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [E]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [E]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [v]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [v]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [v]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [i]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [i]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [i]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [i]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [i]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [i]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [i]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [i]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [i]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [i]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [i]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [i]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [i]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [i]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [i]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [l]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [l]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [l]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [l]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [l]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [l]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [l]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [l]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [l]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [S]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(D(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [l]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [l]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [S]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: D()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [a]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [a]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [a]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [a]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [a]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [a]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [a]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [a]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(D())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [Ee, Tt]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Tt]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: x()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [S]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Tt]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", sn, ky]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [$r]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [S]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": I()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": I()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [s]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", sn, Ee]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [f]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [h]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [A]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [$]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [s]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [f]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [h]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [S]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [A]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [$]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [o]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [o]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [o]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", Ee]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: F()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", Ee]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: F()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", Ee]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [V]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [V]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [V]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [Er, Ee]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [c]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [c]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [_]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [_]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", Ee]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", Ee]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": O()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": O()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": O()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": O()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": O()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": O()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": O()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": O()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": O()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": O()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": O()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": O()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": O()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": O()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": O()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": O()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": O()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": O()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", Ee]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Tt, ba]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
function zy(e, t) {
  for (var n in t)
    vh(e, n, t[n]);
  return e;
}
var My = Object.prototype.hasOwnProperty, _y = /* @__PURE__ */ new Set(["string", "number", "boolean"]);
function vh(e, t, n) {
  if (!My.call(e, t) || _y.has(typeof n) || n === null) {
    e[t] = n;
    return;
  }
  if (Array.isArray(n) && Array.isArray(e[t])) {
    e[t] = e[t].concat(n);
    return;
  }
  if (typeof n == "object" && typeof e[t] == "object") {
    if (e[t] === null) {
      e[t] = n;
      return;
    }
    for (var r in n)
      vh(e[t], r, n[r]);
  }
}
function Ly(e) {
  for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), r = 1; r < t; r++)
    n[r - 1] = arguments[r];
  return typeof e == "function" ? J1.apply(void 0, [e0, e].concat(n)) : J1.apply(void 0, [function() {
    return zy(e0(), e);
  }].concat(n));
}
const mh = {
  /**
   *  Why is this here and not in typography.css?
   *
   * This is added here instead of in typography.css in order to enable
   * autocomplete by Intellisense. If issue #227 on
   * tailwindlabs/tailwindcss-intellisense is solved, please delete this
   * abomination and move definitions to typography.css and use below structure.
   *
   * @layer utilities {
   *    .text-body { @apply text-lg [...] }
   * }
   *
   * Why are we using absolute px units and not relative rem units?
   *
   * The Figma is using absolute values for everything and it seems there's a
   * bit of confusion as to what the html font size should be. If we wanna make
   * the complete switch to relative units it should be a matter of going
   * through all definitions and replacing [n]px with [n/base]rem. Where base is
   * hopefully equal to 16.
   *
   * Why would we want relative values?
   *
   * The entire system is built around the notion that 1rem=16px. This allows
   * users to adjust just the font size (done through some accessibility
   * software) and scale the entire UI. This is especially important for users
   * with visual impairments.
   */
  /**
   * Label styles
   */
  ".text-label-xs": {
    "@apply text-[12px]/[16px] font-normal": {}
  },
  ".text-label-xs-bold": {
    "@apply text-[12px]/[16px] font-bold": {}
  },
  ".text-label-sm": {
    "@apply text-[14px]/[20px] font-normal": {}
  },
  ".text-label-sm-bold": {
    "@apply text-[14px]/[20px] font-bold": {}
  },
  ".text-label-md": {
    "@apply text-[16px]/[22px] font-normal": {}
  },
  ".text-label-md-bold": {
    "@apply text-[16px]/[22px] font-bold": {}
  },
  ".text-label-lg": {
    "@apply text-[18px]/[24px] font-normal": {}
  },
  ".text-label-lg-bold": {
    "@apply text-[18px]/[24px] font-bold": {}
  },
  ".text-label-xl": {
    "@apply text-[20px]/[26px] font-normal -tracking-[0.45px]": {}
  },
  ".text-label-xl-bold": {
    "@apply text-[20px]/[26px] font-bold -tracking-[0.45]": {}
  },
  /*
   * Paragraph styles
   */
  ".text-body": {
    "@apply text-[18px]/[28px] font-normal -tracking-[0.4px]": {}
  },
  ".text-body-bold": {
    "@apply text-[18px]/[28px] font-bold -tracking-[0.4px]": {}
  },
  ".text-small-body": {
    "@apply text-[16px]/[24px] font-normal -tracking-[0.4px]": {}
  },
  ".text-small-body-bold": {
    "@apply text-[16px]/[24px] font-bold -tracking-[0.4px]": {}
  },
  ".text-footnote": {
    "@apply text-[14px]/[21px] font-normal -tracking-[0.35px]": {}
  },
  ".text-footnote-bold": {
    "@apply text-[14px]/[21px] font-bold -tracking-[0.35px]": {}
  },
  ".text-caption": {
    "@apply text-[12px]/[18px] font-normal -tracking-[0.3px]": {}
  },
  ".text-caption-bold": {
    "@apply text-[12px]/[18px] font-bold -tracking-[0.3px]": {}
  },
  ".text-subtitle": {
    "@apply text-[20px]/[24px] font-normal -tracking-[0.4px]": {}
  },
  ".text-eyebrow": {
    "@apply text-[14px]/[17px] font-bold uppercase tracking-[1.4px]": {}
  },
  /**
   * Desktop styles
   */
  ".desktop-d1": {
    "@apply text-[128px]/[135px] font-normal -tracking-[5px]": {}
  },
  ".desktop-d2": {
    "@apply text-[104px]/[110px] font-normal -tracking-[4px]": {}
  },
  ".desktop-d3": {
    "@apply text-[88px]/[90px] font-normal -tracking-[2.5px]": {}
  },
  ".desktop-d4": {
    "@apply text-[72px]/[74px] font-normal -tracking-[1.5px]": {}
  },
  ".desktop-d1-bold": {
    "@apply text-[128px]/[135px] font-bold -tracking-[5px]": {}
  },
  ".desktop-d2-bold": {
    "@apply text-[104px]/[110px] font-bold -tracking-[2.5px]": {}
  },
  ".desktop-d3-bold": {
    "@apply text-[88px]/[92px] font-bold -tracking-[2px]": {}
  },
  ".desktop-d4-bold": {
    "@apply text-[72px]/[76px] font-bold -tracking-[1px]": {}
  },
  ".desktop-d1-black": {
    "@apply text-[128px]/[135px] font-black -tracking-[5px]": {}
  },
  ".desktop-d2-black": {
    "@apply text-[104px]/[110px] font-black -tracking-[2.5px]": {}
  },
  ".desktop-d3-black": {
    "@apply text-[88px]/[92px] font-black -tracking-[2px]": {}
  },
  ".desktop-d4-black": {
    "@apply text-[72px]/[76px] font-black -tracking-[1px]": {}
  },
  ".desktop-h1": {
    "@apply text-[56px]/[60px] font-normal -tracking-[1.75px]": {}
  },
  ".desktop-h2": {
    "@apply text-[48px]/[54px] font-normal -tracking-[1.2px]": {}
  },
  ".desktop-h3": {
    "@apply text-[40px]/[46px] font-normal -tracking-[1px]": {}
  },
  ".desktop-h4": {
    "@apply text-[32px]/[38px] font-normal -tracking-[0.6px]": {}
  },
  ".desktop-h5": {
    "@apply text-[24px]/[28px] font-normal -tracking-[0.5px]": {}
  },
  ".desktop-h1-bold": {
    "@apply text-[56px]/[62px] font-bold -tracking-[1.2px]": {}
  },
  ".desktop-h2-bold": {
    "@apply text-[48px]/[54px] font-bold -tracking-[0.9px]": {}
  },
  ".desktop-h3-bold": {
    "@apply text-[40px]/[46px] font-bold -tracking-[0.75px]": {}
  },
  ".desktop-h4-bold": {
    "@apply text-[32px]/[38px] font-bold -tracking-[0.6px]": {}
  },
  ".desktop-h5-bold": {
    "@apply text-[24px]/[28px] font-bold -tracking-[0.5px]": {}
  },
  /**
   * Tablet styles
   */
  ".tablet-d1": {
    "@apply text-[104px]/[110px] font-normal -tracking-[4px]": {}
  },
  ".tablet-d2": {
    "@apply text-[84px]/[88px] font-normal -tracking-[3.5px]": {}
  },
  ".tablet-d3": {
    "@apply text-[64px]/[67px] font-normal -tracking-[2.5px]": {}
  },
  ".tablet-d4": {
    "@apply text-[56px]/[58px] font-normal -tracking-[2px]": {}
  },
  ".tablet-d1-bold": {
    "@apply text-[104px]/[110px] font-bold -tracking-[4px]": {}
  },
  ".tablet-d2-bold": {
    "@apply text-[84px]/[88px] font-bold -tracking-[3.5px]": {}
  },
  ".tablet-d3-bold": {
    "@apply text-[64px]/[67px] font-bold -tracking-[2.5px]": {}
  },
  ".tablet-d4-bold": {
    "@apply text-[56px]/[60px] font-bold -tracking-[2px]": {}
  },
  ".tablet-d1-black": {
    "@apply text-[104px]/[110px] font-black -tracking-[4px]": {}
  },
  ".tablet-d2-black": {
    "@apply text-[84px]/[88px] font-black -tracking-[3.5px]": {}
  },
  ".tablet-d3-black": {
    "@apply text-[64px]/[67px] font-black -tracking-[2.5px]": {}
  },
  ".tablet-d4-black": {
    "@apply text-[56px]/[60px] font-black -tracking-[2px]": {}
  },
  ".tablet-h1": {
    "@apply text-[48px]/[56px] font-normal -tracking-[0.6px]": {}
  },
  ".tablet-h2": {
    "@apply text-[40px]/[48px] font-normal -tracking-[0.5px]": {}
  },
  ".tablet-h3": {
    "@apply text-[32px]/[40px] font-normal -tracking-[0.45px]": {}
  },
  ".tablet-h4": {
    "@apply text-[24px]/[32px] font-normal -tracking-[0.6px]": {}
  },
  ".tablet-h5": {
    "@apply text-[20px]/[24px] font-normal -tracking-[0.5px]": {}
  },
  ".tablet-h1-bold": {
    "@apply text-[48px]/[56px] font-bold -tracking-[0.6px]": {}
  },
  ".tablet-h2-bold": {
    "@apply text-[40px]/[48px] font-bold -tracking-[0.5px]": {}
  },
  ".tablet-h3-bold": {
    "@apply text-[32px]/[40px] font-bold -tracking-[0.45px]": {}
  },
  ".tablet-h4-bold": {
    "@apply text-[24px]/[32px] font-bold -tracking-[0.6px]": {}
  },
  ".tablet-h5-bold": {
    "@apply text-[20px]/[24px] font-bold -tracking-[0.5px]": {}
  },
  /**
   * Mobile styles
   */
  ".mobile-d1": {
    "@apply text-[84px]/[90px] font-normal -tracking-[3px]": {}
  },
  ".mobile-d2": {
    "@apply text-[72px]/[77px] font-normal -tracking-[2px]": {}
  },
  ".mobile-d3": {
    "@apply text-[66px]/[66px] font-normal -tracking-[2px]": {}
  },
  ".mobile-d4": {
    "@apply text-[56px]/[62px] font-normal -tracking-[1.5px]": {}
  },
  ".mobile-d1-bold": {
    "@apply text-[84px]/[90px] font-bold -tracking-[2.5px]": {}
  },
  ".mobile-d2-bold": {
    "@apply text-[72px]/[79px] font-bold -tracking-[2px]": {}
  },
  ".mobile-d3-bold": {
    "@apply text-[66px]/[69px] font-bold -tracking-[2px]": {}
  },
  ".mobile-d4-bold": {
    "@apply text-[56px]/[62px] font-bold -tracking-[1px]": {}
  },
  ".mobile-d1-black": {
    "@apply text-[84px]/[90px] font-black -tracking-[2.5px]": {}
  },
  ".mobile-d2-black": {
    "@apply text-[72px]/[79px] font-black -tracking-[2px]": {}
  },
  ".mobile-d3-black": {
    "@apply text-[66px]/[69px] font-black -tracking-[2px]": {}
  },
  ".mobile-d4-black": {
    "@apply text-[56px]/[62px] font-black -tracking-[1px]": {}
  },
  ".mobile-h1": {
    "@apply text-[48px]/[52px] font-normal -tracking-[1px]": {}
  },
  ".mobile-h2": {
    "@apply text-[40px]/[44px] font-normal -tracking-[0.5px]": {}
  },
  ".mobile-h3": {
    "@apply text-[32px]/[38px] font-normal -tracking-[0.45px]": {}
  },
  ".mobile-h4": {
    "@apply text-[24px]/[28px] font-normal -tracking-[0.45px]": {}
  },
  ".mobile-h5": {
    "@apply text-[20px]/[24px] font-normal -tracking-[0.45px]": {}
  },
  ".mobile-h1-bold": {
    "@apply text-[48px]/[54px] font-bold -tracking-[1px]": {}
  },
  ".mobile-h2-bold": {
    "@apply text-[40px]/[46px] font-bold -tracking-[0.5px]": {}
  },
  ".mobile-h3-bold": {
    "@apply text-[32px]/[38px] font-bold -tracking-[0.45px]": {}
  },
  ".mobile-h4-bold": {
    "@apply text-[24px]/[30px] font-bold -tracking-[0.45px]": {}
  },
  ".mobile-h5-bold": {
    "@apply text-[20px]/[24px] font-bold -tracking-[0.45px]": {}
  }
}, Iy = Object.keys(mh).filter((e) => e.startsWith(".text-")).map((e) => e.replace(".text-", "")), Co = Object.keys(mh).filter((e) => e.startsWith(".desktop-")).map((e) => e.replace(".desktop-", "")), ae = Ly({
  classGroups: {
    "font-size": [
      {
        text: Iy,
        desktop: Co,
        tablet: Co,
        mobile: Co
      }
    ]
  }
}), gh = ({
  open: e = !1,
  intent: t = "black",
  className: n,
  ...r
}) => /* @__PURE__ */ H(
  "svg",
  {
    className: ae("inline-block h-4 w-4 align-middle", n),
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    "data-cy": "gudl-chevron",
    ...r,
    children: /* @__PURE__ */ ie("g", { className: "transition-transform", children: [
      /* @__PURE__ */ H(
        "path",
        {
          d: "M2 2L8 8",
          strokeWidth: "2",
          strokeLinecap: "round",
          className: _n(
            e ? "-translate-y-1 -rotate-90" : "translate-y-1 rotate-0",
            t === "black" ? "stroke-black" : "stroke-white",
            "origin-[8px_8px] transition-transform"
          )
        }
      ),
      /* @__PURE__ */ H(
        "path",
        {
          d: "M8 8L14 2",
          strokeWidth: "2",
          strokeLinecap: "round",
          className: _n(
            e ? "-translate-y-1 rotate-90" : "translate-y-1 rotate-0",
            t === "black" ? "stroke-black" : "stroke-white",
            "origin-[8px_8px] transition-transform"
          )
        }
      )
    ] })
  }
), t0 = (e) => typeof e == "boolean" ? "".concat(e) : e === 0 ? "0" : e, n0 = _n, de = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null)
    return n0(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: a, defaultVariants: i } = t, o = Object.keys(a).map((u) => {
    const f = n == null ? void 0 : n[u], h = i == null ? void 0 : i[u];
    if (f === null)
      return null;
    const g = t0(f) || t0(h);
    return a[u][g];
  }), l = n && Object.entries(n).reduce((u, f) => {
    let [h, g] = f;
    return g === void 0 || (u[h] = g), u;
  }, {}), s = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((u, f) => {
    let { class: h, className: g, ...v } = f;
    return Object.entries(v).every((E) => {
      let [b, w] = E;
      return Array.isArray(w) ? w.includes({
        ...i,
        ...l
      }[b]) : {
        ...i,
        ...l
      }[b] === w;
    }) ? [
      ...u,
      h,
      g
    ] : u;
  }, []);
  return n0(e, o, s, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
}, Dy = {
  "display-1": ["mobile-d1", "md:tablet-d1", "lg:desktop-d1"],
  "display-2": ["mobile-d2", "md:tablet-d2", "lg:desktop-d2"],
  "display-3": ["mobile-d3", "md:tablet-d3", "lg:desktop-d3"],
  "display-4": ["mobile-d4", "md:tablet-d4", "lg:desktop-d4"],
  "display-1-bold": [
    "mobile-d1-bold",
    "md:tablet-d1-bold",
    "lg:desktop-d1-bold"
  ],
  "display-2-bold": [
    "mobile-d2-bold",
    "md:tablet-d2-bold",
    "lg:desktop-d2-bold"
  ],
  "display-3-bold": [
    "mobile-d3-bold",
    "md:tablet-d3-bold",
    "lg:desktop-d3-bold"
  ],
  "display-4-bold": [
    "mobile-d4-bold",
    "md:tablet-d4-bold",
    "lg:desktop-d4-bold"
  ],
  "display-1-black": [
    "mobile-d1-black",
    "md:tablet-d1-black",
    "lg:desktop-d1-black"
  ],
  "display-2-black": [
    "mobile-d2-black",
    "md:tablet-d2-black",
    "lg:desktop-d2-black"
  ],
  "display-3-black": [
    "mobile-d3-black",
    "md:tablet-d3-black",
    "lg:desktop-d3-black"
  ],
  "display-4-black": [
    "mobile-d4-black",
    "md:tablet-d4-black",
    "lg:desktop-d4-black"
  ],
  "heading-1": ["mobile-h1", "md:tablet-h1", "lg:desktop-h1"],
  "heading-2": ["mobile-h2", "md:tablet-h2", "lg:desktop-h2"],
  "heading-3": ["mobile-h3", "md:tablet-h3", "lg:desktop-h3"],
  "heading-4": ["mobile-h4", "md:tablet-h4", "lg:desktop-h4"],
  "heading-5": ["mobile-h5", "md:tablet-h5", "lg:desktop-h5"],
  "heading-1-bold": [
    "mobile-h1-bold",
    "md:tablet-h1-bold",
    "lg:desktop-h1-bold"
  ],
  "heading-2-bold": [
    "mobile-h2-bold",
    "md:tablet-h2-bold",
    "lg:desktop-h2-bold"
  ],
  "heading-3-bold": [
    "mobile-h3-bold",
    "md:tablet-h3-bold",
    "lg:desktop-h3-bold"
  ],
  "heading-4-bold": [
    "mobile-h4-bold",
    "md:tablet-h4-bold",
    "lg:desktop-h4-bold"
  ],
  "heading-5-bold": [
    "mobile-h5-bold",
    "md:tablet-h5-bold",
    "lg:desktop-h5-bold"
  ],
  "label-xs": "text-label-xs",
  "label-sm": "text-label-sm",
  "label-md": "text-label-md",
  "label-lg": "text-label-lg",
  "label-xl": "text-label-xl",
  "label-xs-bold": "text-label-xs-bold",
  "label-sm-bold": "text-label-sm-bold",
  "label-md-bold": "text-label-md-bold",
  "label-lg-bold": "text-label-lg-bold",
  "label-xl-bold": "text-label-xl-bold",
  "paragraph-body": "text-body",
  "paragraph-small-body": "text-small-body",
  "paragraph-footnote": "text-footnote",
  "paragraph-caption": "text-caption",
  "paragraph-body-bold": "text-body-bold",
  "paragraph-small-body-bold": "text-small-body-bold",
  "paragraph-footnote-bold": "text-footnote-bold",
  "paragraph-caption-bold": "text-caption-bold",
  "special-subtitle": "text-subtitle",
  "special-eyebrow": "text-eyebrow"
}, Ny = de("luik-text", {
  variants: {
    variant: Dy
  }
});
function Ry(e) {
  if (e.includes("label"))
    return "span";
  if (e.includes("heading")) {
    const t = "heading", n = e.indexOf(t);
    return `h${e[n + t.length + 1]}`;
  } else
    return e.includes("display") ? "h1" : "p";
}
const Ye = ({
  as: e,
  variant: t = "paragraph-body",
  aria: n,
  children: r,
  role: a,
  className: i,
  ...o
}) => {
  const l = e ?? Ry(t);
  return /* @__PURE__ */ H(
    l,
    {
      className: Ny({ variant: t, className: i }),
      role: a,
      ...n,
      ...o,
      children: r
    }
  );
}, By = de(
  "gudl-accordion-item cursor-pointer border-b pb-4 pt-6",
  {
    variants: {
      /**
       * Intent of the accordion item.
       */
      intent: {
        black: "border-neutral-300",
        white: "border-neutral-50"
      }
    },
    defaultVariants: {
      intent: "black"
    }
  }
), Vy = de("gudl-accordion-item-title", {
  variants: {
    intent: {
      black: "text-black",
      white: "text-white"
    }
  },
  defaultVariants: {
    intent: "black"
  }
}), GD = ({
  className: e,
  data: t,
  startsOpen: n,
  intent: r = "black"
}) => {
  const [a, i] = ne(n ? 0 : null);
  return /* @__PURE__ */ H("div", { className: e, children: t.map((o, l) => /* @__PURE__ */ H(
    Fy,
    {
      title: o.title,
      setActiveIndex: i,
      index: l,
      activeIndex: a,
      intent: r,
      children: o.children
    },
    l
  )) });
}, Fy = ({
  className: e,
  title: t,
  children: n,
  index: r,
  activeIndex: a,
  setActiveIndex: i,
  intent: o = "black"
}) => {
  var u;
  const l = (f) => {
    i(a !== f ? f : null);
  }, s = a !== null ? (u = document.getElementById(`sect${a + 1}`)) == null ? void 0 : u.scrollHeight : 0;
  return /* @__PURE__ */ ie(
    "div",
    {
      className: ae(By({ intent: o }), e),
      onClick: () => l(r),
      children: [
        /* @__PURE__ */ H("h5", { children: /* @__PURE__ */ ie(
          "button",
          {
            className: "flex w-full items-center justify-between gap-4 pb-2 text-start",
            "aria-expanded": r === a ? "true" : "false",
            "aria-controls": `sect${r + 1}`,
            "data-info": r === a ? "less" : "more",
            id: `accordion${r + 1}id`,
            children: [
              /* @__PURE__ */ H(
                Ye,
                {
                  variant: "heading-5",
                  className: Vy({ intent: o }),
                  children: t
                }
              ),
              /* @__PURE__ */ H(
                gh,
                {
                  open: r === a,
                  intent: o === null ? void 0 : o
                }
              )
            ]
          }
        ) }),
        /* @__PURE__ */ H(
          "section",
          {
            style: r === a ? { maxHeight: s } : { maxHeight: 0 },
            className: "ease-expressive transition-height -mx-2 -mb-2 overflow-hidden pb-2 duration-300 motion-reduce:transition-none",
            id: `sect${r + 1}`,
            "aria-labelledby": `accordion${r + 1}id`,
            children: typeof n == "string" ? /* @__PURE__ */ H(
              "p",
              {
                className: _n(
                  o === "black" ? "text-black" : "text-white",
                  "text-body m-2"
                ),
                children: n
              }
            ) : /* @__PURE__ */ H("div", { className: "m-2", children: n })
          }
        )
      ]
    }
  );
};
var yh = {};
yh = {
  breadcrumbs: "عناصر الواجهة"
};
var bh = {};
bh = {
  breadcrumbs: "Трохи хляб"
};
var wh = {};
wh = {
  breadcrumbs: "Popis cesty"
};
var xh = {};
xh = {
  breadcrumbs: "Brødkrummer"
};
var Eh = {};
Eh = {
  breadcrumbs: "Breadcrumbs"
};
var $h = {};
$h = {
  breadcrumbs: "Πλοηγήσεις breadcrumb"
};
var Ph = {};
Ph = {
  breadcrumbs: "Breadcrumbs"
};
var Ch = {};
Ch = {
  breadcrumbs: "Migas de pan"
};
var Sh = {};
Sh = {
  breadcrumbs: "Lingiread"
};
var kh = {};
kh = {
  breadcrumbs: "Navigointilinkit"
};
var Th = {};
Th = {
  breadcrumbs: "Chemin de navigation"
};
var Ah = {};
Ah = {
  breadcrumbs: "שבילי ניווט"
};
var Oh = {};
Oh = {
  breadcrumbs: "Navigacijski putovi"
};
var zh = {};
zh = {
  breadcrumbs: "Morzsamenü"
};
var Mh = {};
Mh = {
  breadcrumbs: "Breadcrumb"
};
var _h = {};
_h = {
  breadcrumbs: "パンくずリスト"
};
var Lh = {};
Lh = {
  breadcrumbs: "탐색 표시"
};
var Ih = {};
Ih = {
  breadcrumbs: "Naršymo kelias"
};
var Dh = {};
Dh = {
  breadcrumbs: "Atpakaļceļi"
};
var Nh = {};
Nh = {
  breadcrumbs: "Navigasjonsstier"
};
var Rh = {};
Rh = {
  breadcrumbs: "Broodkruimels"
};
var Bh = {};
Bh = {
  breadcrumbs: "Struktura nawigacyjna"
};
var Vh = {};
Vh = {
  breadcrumbs: "Caminho detalhado"
};
var Fh = {};
Fh = {
  breadcrumbs: "Categorias"
};
var Hh = {};
Hh = {
  breadcrumbs: "Miez de pâine"
};
var Kh = {};
Kh = {
  breadcrumbs: "Навигация"
};
var jh = {};
jh = {
  breadcrumbs: "Navigačné prvky Breadcrumbs"
};
var Uh = {};
Uh = {
  breadcrumbs: "Drobtine"
};
var Wh = {};
Wh = {
  breadcrumbs: "Putanje navigacije"
};
var qh = {};
qh = {
  breadcrumbs: "Sökvägar"
};
var Zh = {};
Zh = {
  breadcrumbs: "İçerik haritaları"
};
var Gh = {};
Gh = {
  breadcrumbs: "Навігаційна стежка"
};
var Yh = {};
Yh = {
  breadcrumbs: "导航栏"
};
var Xh = {};
Xh = {
  breadcrumbs: "導覽列"
};
function Bn(e, t, n) {
  let [r, a] = ne(e || t), i = J(e !== void 0), o = e !== void 0;
  re(() => {
    let u = i.current;
    u !== o && console.warn(`WARN: A component changed from ${u ? "controlled" : "uncontrolled"} to ${o ? "controlled" : "uncontrolled"}.`), i.current = o;
  }, [
    o
  ]);
  let l = o ? e : r, s = he((u, ...f) => {
    let h = (g, ...v) => {
      n && (Object.is(l, g) || n(g, ...v)), o || (l = g);
    };
    typeof u == "function" ? (console.warn("We can not support a function callback. See Github Issues for details https://github.com/adobe/react-spectrum/issues/2320"), a((v, ...E) => {
      let b = u(o ? l : v, ...E);
      return h(b, ...f), o ? v : b;
    })) : (o || a(u), h(u, ...f));
  }, [
    o,
    l,
    n
  ]);
  return [
    l,
    s
  ];
}
const fi = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, Jh = /* @__PURE__ */ oe.createContext(fi), Hy = /* @__PURE__ */ oe.createContext(!1);
let Ky = !!(typeof window < "u" && window.document && window.document.createElement), So = /* @__PURE__ */ new WeakMap();
function jy(e = !1) {
  let t = ze(Jh), n = J(null);
  if (n.current === null && !e) {
    var r, a;
    let i = (a = oe.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || a === void 0 || (r = a.ReactCurrentOwner) === null || r === void 0 ? void 0 : r.current;
    if (i) {
      let o = So.get(i);
      o == null ? So.set(i, {
        id: t.current,
        state: i.memoizedState
      }) : i.memoizedState !== o.state && (t.current = o.id, So.delete(i));
    }
    n.current = ++t.current;
  }
  return n.current;
}
function Uy(e) {
  let t = ze(Jh);
  t === fi && !Ky && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let n = jy(!!e), r = t === fi && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${t.prefix}`;
  return e || `${r}-${n}`;
}
function Wy(e) {
  let t = oe.useId(), [n] = ne(Qh()), r = n || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${fi.prefix}`;
  return e || `${r}-${t}`;
}
const qy = typeof oe.useId == "function" ? Wy : Uy;
function Zy() {
  return !1;
}
function Gy() {
  return !0;
}
function Yy(e) {
  return () => {
  };
}
function Qh() {
  return typeof oe.useSyncExternalStore == "function" ? oe.useSyncExternalStore(Yy, Zy, Gy) : ze(Hy);
}
const tn = typeof document < "u" ? oe.useLayoutEffect : () => {
};
function lt(e) {
  const t = J(null);
  return tn(() => {
    t.current = e;
  }, [
    e
  ]), he((...n) => {
    const r = t.current;
    return r(...n);
  }, []);
}
function Xy(e) {
  let [t, n] = ne(e), r = J(null), a = lt(() => {
    let o = r.current.next();
    if (o.done) {
      r.current = null;
      return;
    }
    t === o.value ? a() : n(o.value);
  });
  tn(() => {
    r.current && a();
  });
  let i = lt((o) => {
    r.current = o(t), a();
  });
  return [
    t,
    i
  ];
}
let Jy = !!(typeof window < "u" && window.document && window.document.createElement), pi = /* @__PURE__ */ new Map();
function Yt(e) {
  let [t, n] = ne(e), r = J(null), a = qy(t), i = he((o) => {
    r.current = o;
  }, []);
  return Jy && pi.set(a, i), tn(() => {
    let o = a;
    return () => {
      pi.delete(o);
    };
  }, [
    a
  ]), re(() => {
    let o = r.current;
    o && (r.current = null, n(o));
  }), a;
}
function Qy(e, t) {
  if (e === t)
    return e;
  let n = pi.get(e);
  if (n)
    return n(t), t;
  let r = pi.get(t);
  return r ? (r(e), e) : t;
}
function hi(e = []) {
  let t = Yt(), [n, r] = Xy(t), a = he(() => {
    r(function* () {
      yield t, yield document.getElementById(t) ? t : void 0;
    });
  }, [
    t,
    r
  ]);
  return tn(a, [
    t,
    a,
    ...e
  ]), n;
}
function _c(...e) {
  return (...t) => {
    for (let n of e)
      typeof n == "function" && n(...t);
  };
}
const zt = (e) => {
  var t;
  return (t = e == null ? void 0 : e.ownerDocument) !== null && t !== void 0 ? t : document;
}, Yr = (e) => e && "window" in e && e.window === e ? e : zt(e).defaultView || window;
function Pe(...e) {
  let t = {
    ...e[0]
  };
  for (let n = 1; n < e.length; n++) {
    let r = e[n];
    for (let a in r) {
      let i = t[a], o = r[a];
      typeof i == "function" && typeof o == "function" && // This is a lot faster than a regex.
      a[0] === "o" && a[1] === "n" && a.charCodeAt(2) >= /* 'A' */
      65 && a.charCodeAt(2) <= /* 'Z' */
      90 ? t[a] = _c(i, o) : (a === "className" || a === "UNSAFE_className") && typeof i == "string" && typeof o == "string" ? t[a] = _n(i, o) : a === "id" && i && o ? t.id = Qy(i, o) : t[a] = o !== void 0 ? o : i;
    }
  }
  return t;
}
const eb = /* @__PURE__ */ new Set([
  "id"
]), tb = /* @__PURE__ */ new Set([
  "aria-label",
  "aria-labelledby",
  "aria-describedby",
  "aria-details"
]), nb = /* @__PURE__ */ new Set([
  "href",
  "target",
  "rel",
  "download",
  "ping",
  "referrerPolicy"
]), rb = /^(data-.*)$/;
function Bt(e, t = {}) {
  let { labelable: n, isLink: r, propNames: a } = t, i = {};
  for (const o in e)
    Object.prototype.hasOwnProperty.call(e, o) && (eb.has(o) || n && tb.has(o) || r && nb.has(o) || a != null && a.has(o) || rb.test(o)) && (i[o] = e[o]);
  return i;
}
function qt(e) {
  if (ab())
    e.focus({
      preventScroll: !0
    });
  else {
    let t = ib(e);
    e.focus(), ob(t);
  }
}
let wa = null;
function ab() {
  if (wa == null) {
    wa = !1;
    try {
      var e = document.createElement("div");
      e.focus({
        get preventScroll() {
          return wa = !0, !0;
        }
      });
    } catch {
    }
  }
  return wa;
}
function ib(e) {
  for (var t = e.parentNode, n = [], r = document.scrollingElement || document.documentElement; t instanceof HTMLElement && t !== r; )
    (t.offsetHeight < t.scrollHeight || t.offsetWidth < t.scrollWidth) && n.push({
      element: t,
      scrollTop: t.scrollTop,
      scrollLeft: t.scrollLeft
    }), t = t.parentNode;
  return r instanceof HTMLElement && n.push({
    element: r,
    scrollTop: r.scrollTop,
    scrollLeft: r.scrollLeft
  }), n;
}
function ob(e) {
  for (let { element: t, scrollTop: n, scrollLeft: r } of e)
    t.scrollTop = n, t.scrollLeft = r;
}
function Ni(e) {
  var t;
  return typeof window > "u" || window.navigator == null ? !1 : ((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands.some((n) => e.test(n.brand))) || e.test(window.navigator.userAgent);
}
function Lc(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function hn() {
  return Lc(/^Mac/i);
}
function lb() {
  return Lc(/^iPhone/i);
}
function e2() {
  return Lc(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  hn() && navigator.maxTouchPoints > 1;
}
function Ic() {
  return lb() || e2();
}
function ii() {
  return hn() || Ic();
}
function t2() {
  return Ni(/AppleWebKit/i) && !sb();
}
function sb() {
  return Ni(/Chrome/i);
}
function n2() {
  return Ni(/Android/i);
}
function cb() {
  return Ni(/Firefox/i);
}
const ub = /* @__PURE__ */ Ze({
  isNative: !0,
  open: pb
});
function Ri() {
  return ze(ub);
}
function db(e, t) {
  let n = e.getAttribute("target");
  return (!n || n === "_self") && e.origin === location.origin && !e.hasAttribute("download") && !t.metaKey && // open in new tab (mac)
  !t.ctrlKey && // open in new tab (windows)
  !t.altKey && // download
  !t.shiftKey;
}
function Ln(e, t, n = !0) {
  var r, a;
  let { metaKey: i, ctrlKey: o, altKey: l, shiftKey: s } = t;
  cb() && (!((a = window.event) === null || a === void 0 || (r = a.type) === null || r === void 0) && r.startsWith("key")) && e.target === "_blank" && (hn() ? i = !0 : o = !0);
  let u = t2() && hn() && !e2() ? new KeyboardEvent("keydown", {
    keyIdentifier: "Enter",
    metaKey: i,
    ctrlKey: o,
    altKey: l,
    shiftKey: s
  }) : new MouseEvent("click", {
    metaKey: i,
    ctrlKey: o,
    altKey: l,
    shiftKey: s,
    bubbles: !0,
    cancelable: !0
  });
  Ln.isOpening = n, qt(e), e.dispatchEvent(u), Ln.isOpening = !1;
}
Ln.isOpening = !1;
function fb(e, t) {
  if (e instanceof HTMLAnchorElement)
    t(e);
  else if (e.hasAttribute("data-href")) {
    let n = document.createElement("a");
    n.href = e.getAttribute("data-href"), e.hasAttribute("data-target") && (n.target = e.getAttribute("data-target")), e.hasAttribute("data-rel") && (n.rel = e.getAttribute("data-rel")), e.hasAttribute("data-download") && (n.download = e.getAttribute("data-download")), e.hasAttribute("data-ping") && (n.ping = e.getAttribute("data-ping")), e.hasAttribute("data-referrer-policy") && (n.referrerPolicy = e.getAttribute("data-referrer-policy")), e.appendChild(n), t(n), e.removeChild(n);
  }
}
function pb(e, t) {
  fb(e, (n) => Ln(n, t));
}
let ir = /* @__PURE__ */ new Map(), Gs = /* @__PURE__ */ new Set();
function r0() {
  if (typeof window > "u")
    return;
  let e = (n) => {
    let r = ir.get(n.target);
    r || (r = /* @__PURE__ */ new Set(), ir.set(n.target, r), n.target.addEventListener("transitioncancel", t)), r.add(n.propertyName);
  }, t = (n) => {
    let r = ir.get(n.target);
    if (r && (r.delete(n.propertyName), r.size === 0 && (n.target.removeEventListener("transitioncancel", t), ir.delete(n.target)), ir.size === 0)) {
      for (let a of Gs)
        a();
      Gs.clear();
    }
  };
  document.body.addEventListener("transitionrun", e), document.body.addEventListener("transitionend", t);
}
typeof document < "u" && (document.readyState !== "loading" ? r0() : document.addEventListener("DOMContentLoaded", r0));
function r2(e) {
  requestAnimationFrame(() => {
    ir.size === 0 ? e() : Gs.add(e);
  });
}
function a2() {
  let e = J(/* @__PURE__ */ new Map()), t = he((a, i, o, l) => {
    let s = l != null && l.once ? (...u) => {
      e.current.delete(o), o(...u);
    } : o;
    e.current.set(o, {
      type: i,
      eventTarget: a,
      fn: s,
      options: l
    }), a.addEventListener(i, o, l);
  }, []), n = he((a, i, o, l) => {
    var s;
    let u = ((s = e.current.get(o)) === null || s === void 0 ? void 0 : s.fn) || o;
    a.removeEventListener(i, u, l), e.current.delete(o);
  }, []), r = he(() => {
    e.current.forEach((a, i) => {
      n(a.eventTarget, a.type, i, a.options);
    });
  }, [
    n
  ]);
  return re(() => r, [
    r
  ]), {
    addGlobalListener: t,
    removeGlobalListener: n,
    removeAllGlobalListeners: r
  };
}
function Xr(e, t) {
  let { id: n, "aria-label": r, "aria-labelledby": a } = e;
  return n = Yt(n), a && r ? a = [
    .../* @__PURE__ */ new Set([
      n,
      ...a.trim().split(/\s+/)
    ])
  ].join(" ") : a && (a = a.trim().split(/\s+/).join(" ")), !r && !a && t && (r = t), {
    id: n,
    "aria-label": r,
    "aria-labelledby": a
  };
}
function i2(e, t) {
  tn(() => {
    if (e && e.ref && t)
      return e.ref.current = t.current, () => {
        e.ref.current = null;
      };
  });
}
function a0(e, t) {
  for (vi(e, t) && (e = e.parentElement); e && !vi(e, t); )
    e = e.parentElement;
  return e || document.scrollingElement || document.documentElement;
}
function vi(e, t) {
  let n = window.getComputedStyle(e), r = /(auto|scroll)/.test(n.overflow + n.overflowX + n.overflowY);
  return r && t && (r = e.scrollHeight !== e.clientHeight || e.scrollWidth !== e.clientWidth), r;
}
let hb = 0;
const ko = /* @__PURE__ */ new Map();
function vb(e) {
  let [t, n] = ne(void 0);
  return tn(() => {
    if (!e)
      return;
    let r = ko.get(e);
    if (r)
      n(r.element.id);
    else {
      let a = `react-aria-description-${hb++}`;
      n(a);
      let i = document.createElement("div");
      i.id = a, i.style.display = "none", i.textContent = e, document.body.appendChild(i), r = {
        refCount: 0,
        element: i
      }, ko.set(e, r);
    }
    return r.refCount++, () => {
      --r.refCount === 0 && (r.element.remove(), ko.delete(e));
    };
  }, [
    e
  ]), {
    "aria-describedby": e ? t : void 0
  };
}
function mb(e, t, n, r) {
  let a = lt(n), i = n == null;
  re(() => {
    if (i)
      return;
    let o = e.current;
    return o.addEventListener(t, a, r), () => {
      o.removeEventListener(t, a, r);
    };
  }, [
    e,
    t,
    r,
    i,
    a
  ]);
}
function o2(e, t) {
  let n = i0(e, t, "left"), r = i0(e, t, "top"), a = t.offsetWidth, i = t.offsetHeight, o = e.scrollLeft, l = e.scrollTop, { borderTopWidth: s, borderLeftWidth: u } = getComputedStyle(e), f = e.scrollLeft + parseInt(u, 10), h = e.scrollTop + parseInt(s, 10), g = f + e.clientWidth, v = h + e.clientHeight;
  n <= o ? o = n - parseInt(u, 10) : n + a > g && (o += n + a - g), r <= h ? l = r - parseInt(s, 10) : r + i > v && (l += r + i - v), e.scrollLeft = o, e.scrollTop = l;
}
function i0(e, t, n) {
  const r = n === "left" ? "offsetLeft" : "offsetTop";
  let a = 0;
  for (; t.offsetParent && (a += t[r], t.offsetParent !== e); ) {
    if (t.offsetParent.contains(e)) {
      a -= e[r];
      break;
    }
    t = t.offsetParent;
  }
  return a;
}
function o0(e, t) {
  if (document.contains(e)) {
    let o = document.scrollingElement || document.documentElement;
    if (window.getComputedStyle(o).overflow === "hidden") {
      let s = a0(e);
      for (; e && s && e !== o && s !== o; )
        o2(s, e), e = s, s = a0(e);
    } else {
      var n;
      let { left: s, top: u } = e.getBoundingClientRect();
      e == null || (n = e.scrollIntoView) === null || n === void 0 || n.call(e, {
        block: "nearest"
      });
      let { left: f, top: h } = e.getBoundingClientRect();
      if (Math.abs(s - f) > 1 || Math.abs(u - h) > 1) {
        var r, a, i;
        t == null || (a = t.containingElement) === null || a === void 0 || (r = a.scrollIntoView) === null || r === void 0 || r.call(a, {
          block: "center",
          inline: "center"
        }), (i = e.scrollIntoView) === null || i === void 0 || i.call(e, {
          block: "nearest"
        });
      }
    }
  }
}
function Ys(e) {
  return e.mozInputSource === 0 && e.isTrusted ? !0 : n2() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
function gb(e) {
  return !n2() && e.width === 0 && e.height === 0 || e.width === 1 && e.height === 1 && e.pressure === 0 && e.detail === 0 && e.pointerType === "mouse";
}
function Dc(e, t, n) {
  let r = J(t), a = lt(() => {
    n && n(r.current);
  });
  re(() => {
    var i;
    let o = e == null || (i = e.current) === null || i === void 0 ? void 0 : i.form;
    return o == null || o.addEventListener("reset", a), () => {
      o == null || o.removeEventListener("reset", a);
    };
  }, [
    e,
    a
  ]);
}
function yb(e, t) {
  return t.get ? t.get.call(e) : t.value;
}
function l2(e, t, n) {
  if (!t.has(e))
    throw new TypeError("attempted to " + n + " private field on non-instance");
  return t.get(e);
}
function bb(e, t) {
  var n = l2(e, t, "get");
  return yb(e, n);
}
function wb(e, t) {
  if (t.has(e))
    throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function xb(e, t, n) {
  wb(e, t), t.set(e, n);
}
function Eb(e, t, n) {
  if (t.set)
    t.set.call(e, n);
  else {
    if (!t.writable)
      throw new TypeError("attempted to set read only private field");
    t.value = n;
  }
}
function l0(e, t, n) {
  var r = l2(e, t, "set");
  return Eb(e, r, n), n;
}
let lr = "default", Xs = "", oi = /* @__PURE__ */ new WeakMap();
function s0(e) {
  if (Ic()) {
    if (lr === "default") {
      const t = zt(e);
      Xs = t.documentElement.style.webkitUserSelect, t.documentElement.style.webkitUserSelect = "none";
    }
    lr = "disabled";
  } else
    (e instanceof HTMLElement || e instanceof SVGElement) && (oi.set(e, e.style.userSelect), e.style.userSelect = "none");
}
function xa(e) {
  if (Ic()) {
    if (lr !== "disabled")
      return;
    lr = "restoring", setTimeout(() => {
      r2(() => {
        if (lr === "restoring") {
          const t = zt(e);
          t.documentElement.style.webkitUserSelect === "none" && (t.documentElement.style.webkitUserSelect = Xs || ""), Xs = "", lr = "default";
        }
      });
    }, 300);
  } else if ((e instanceof HTMLElement || e instanceof SVGElement) && e && oi.has(e)) {
    let t = oi.get(e);
    e.style.userSelect === "none" && (e.style.userSelect = t), e.getAttribute("style") === "" && e.removeAttribute("style"), oi.delete(e);
  }
}
const s2 = oe.createContext({
  register: () => {
  }
});
s2.displayName = "PressResponderContext";
function $b(e) {
  let t = ze(s2);
  if (t) {
    let { register: n, ...r } = t;
    e = Pe(r, e), n();
  }
  return i2(t, e.ref), e;
}
var Ea = /* @__PURE__ */ new WeakMap();
class $a {
  continuePropagation() {
    l0(this, Ea, !1);
  }
  get shouldStopPropagation() {
    return bb(this, Ea);
  }
  constructor(t, n, r) {
    xb(this, Ea, {
      writable: !0,
      value: void 0
    }), l0(this, Ea, !0), this.type = t, this.pointerType = n, this.target = r.currentTarget, this.shiftKey = r.shiftKey, this.metaKey = r.metaKey, this.ctrlKey = r.ctrlKey, this.altKey = r.altKey;
  }
}
const c0 = Symbol("linkClicked");
function vn(e) {
  let {
    onPress: t,
    onPressChange: n,
    onPressStart: r,
    onPressEnd: a,
    onPressUp: i,
    isDisabled: o,
    isPressed: l,
    preventFocusOnPress: s,
    shouldCancelOnPointerExit: u,
    allowTextSelectionOnPress: f,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    ref: h,
    ...g
  } = $b(e), [v, E] = ne(!1), b = J({
    isPressed: !1,
    ignoreEmulatedMouseEvents: !1,
    ignoreClickAfterPress: !1,
    didFirePressStart: !1,
    isTriggeringEvent: !1,
    activePointerId: null,
    target: null,
    isOverTarget: !1,
    pointerType: null
  }), { addGlobalListener: w, removeAllGlobalListeners: S } = a2(), T = lt((c, p) => {
    let d = b.current;
    if (o || d.didFirePressStart)
      return !1;
    let m = !0;
    if (d.isTriggeringEvent = !0, r) {
      let O = new $a("pressstart", p, c);
      r(O), m = O.shouldStopPropagation;
    }
    return n && n(!0), d.isTriggeringEvent = !1, d.didFirePressStart = !0, E(!0), m;
  }), A = lt((c, p, d = !0) => {
    let m = b.current;
    if (!m.didFirePressStart)
      return !1;
    m.ignoreClickAfterPress = !0, m.didFirePressStart = !1, m.isTriggeringEvent = !0;
    let O = !0;
    if (a) {
      let x = new $a("pressend", p, c);
      a(x), O = x.shouldStopPropagation;
    }
    if (n && n(!1), E(!1), t && d && !o) {
      let x = new $a("press", p, c);
      t(x), O && (O = x.shouldStopPropagation);
    }
    return m.isTriggeringEvent = !1, O;
  }), V = lt((c, p) => {
    let d = b.current;
    if (o)
      return !1;
    if (i) {
      d.isTriggeringEvent = !0;
      let m = new $a("pressup", p, c);
      return i(m), d.isTriggeringEvent = !1, m.shouldStopPropagation;
    }
    return !0;
  }), $ = lt((c) => {
    let p = b.current;
    p.isPressed && p.target && (p.isOverTarget && p.pointerType != null && A(Ft(p.target, c), p.pointerType, !1), p.isPressed = !1, p.isOverTarget = !1, p.activePointerId = null, p.pointerType = null, S(), f || xa(p.target));
  }), _ = lt((c) => {
    u && $(c);
  }), y = ge(() => {
    let c = b.current, p = {
      onKeyDown(m) {
        if (To(m.nativeEvent, m.currentTarget) && m.currentTarget.contains(m.target)) {
          var O;
          d0(m.target, m.key) && m.preventDefault();
          let x = !0;
          !c.isPressed && !m.repeat && (c.target = m.currentTarget, c.isPressed = !0, x = T(m, "keyboard"), w(zt(m.currentTarget), "keyup", d, !1)), x && m.stopPropagation(), m.metaKey && hn() && ((O = c.metaKeyEvents) === null || O === void 0 || O.set(m.key, m.nativeEvent));
        } else
          m.key === "Meta" && (c.metaKeyEvents = /* @__PURE__ */ new Map());
      },
      onKeyUp(m) {
        To(m.nativeEvent, m.currentTarget) && !m.repeat && m.currentTarget.contains(m.target) && c.target && V(Ft(c.target, m), "keyboard");
      },
      onClick(m) {
        if (!(m && !m.currentTarget.contains(m.target)) && m && m.button === 0 && !c.isTriggeringEvent && !Ln.isOpening) {
          let O = !0;
          if (o && m.preventDefault(), !c.ignoreClickAfterPress && !c.ignoreEmulatedMouseEvents && !c.isPressed && (c.pointerType === "virtual" || Ys(m.nativeEvent))) {
            !o && !s && qt(m.currentTarget);
            let x = T(m, "virtual"), P = V(m, "virtual"), N = A(m, "virtual");
            O = x && P && N;
          }
          c.ignoreEmulatedMouseEvents = !1, c.ignoreClickAfterPress = !1, O && m.stopPropagation();
        }
      }
    }, d = (m) => {
      var O;
      if (c.isPressed && c.target && To(m, c.target)) {
        var x;
        d0(m.target, m.key) && m.preventDefault();
        let N = m.target, D = A(Ft(c.target, m), "keyboard", c.target.contains(N));
        S(), D && m.stopPropagation(), m.key !== "Enter" && Nc(c.target) && c.target.contains(N) && !m[c0] && (m[c0] = !0, Ln(c.target, m, !1)), c.isPressed = !1, (x = c.metaKeyEvents) === null || x === void 0 || x.delete(m.key);
      } else if (m.key === "Meta" && (!((O = c.metaKeyEvents) === null || O === void 0) && O.size)) {
        var P;
        let N = c.metaKeyEvents;
        c.metaKeyEvents = void 0;
        for (let D of N.values())
          (P = c.target) === null || P === void 0 || P.dispatchEvent(new KeyboardEvent("keyup", D));
      }
    };
    if (typeof PointerEvent < "u") {
      p.onPointerDown = (P) => {
        if (P.button !== 0 || !P.currentTarget.contains(P.target))
          return;
        if (gb(P.nativeEvent)) {
          c.pointerType = "virtual";
          return;
        }
        Ao(P.currentTarget) && P.preventDefault(), c.pointerType = P.pointerType;
        let N = !0;
        c.isPressed || (c.isPressed = !0, c.isOverTarget = !0, c.activePointerId = P.pointerId, c.target = P.currentTarget, !o && !s && qt(P.currentTarget), f || s0(c.target), N = T(P, c.pointerType), w(zt(P.currentTarget), "pointermove", m, !1), w(zt(P.currentTarget), "pointerup", O, !1), w(zt(P.currentTarget), "pointercancel", x, !1)), N && P.stopPropagation();
      }, p.onMouseDown = (P) => {
        P.currentTarget.contains(P.target) && P.button === 0 && (Ao(P.currentTarget) && P.preventDefault(), P.stopPropagation());
      }, p.onPointerUp = (P) => {
        !P.currentTarget.contains(P.target) || c.pointerType === "virtual" || P.button === 0 && jn(P, P.currentTarget) && V(P, c.pointerType || P.pointerType);
      };
      let m = (P) => {
        P.pointerId === c.activePointerId && (c.target && jn(P, c.target) ? !c.isOverTarget && c.pointerType != null && (c.isOverTarget = !0, T(Ft(c.target, P), c.pointerType)) : c.target && c.isOverTarget && c.pointerType != null && (c.isOverTarget = !1, A(Ft(c.target, P), c.pointerType, !1), _(P)));
      }, O = (P) => {
        P.pointerId === c.activePointerId && c.isPressed && P.button === 0 && c.target && (jn(P, c.target) && c.pointerType != null ? A(Ft(c.target, P), c.pointerType) : c.isOverTarget && c.pointerType != null && A(Ft(c.target, P), c.pointerType, !1), c.isPressed = !1, c.isOverTarget = !1, c.activePointerId = null, c.pointerType = null, S(), f || xa(c.target));
      }, x = (P) => {
        $(P);
      };
      p.onDragStart = (P) => {
        P.currentTarget.contains(P.target) && $(P);
      };
    } else {
      p.onMouseDown = (x) => {
        if (x.button !== 0 || !x.currentTarget.contains(x.target))
          return;
        if (Ao(x.currentTarget) && x.preventDefault(), c.ignoreEmulatedMouseEvents) {
          x.stopPropagation();
          return;
        }
        c.isPressed = !0, c.isOverTarget = !0, c.target = x.currentTarget, c.pointerType = Ys(x.nativeEvent) ? "virtual" : "mouse", !o && !s && qt(x.currentTarget), T(x, c.pointerType) && x.stopPropagation(), w(zt(x.currentTarget), "mouseup", m, !1);
      }, p.onMouseEnter = (x) => {
        if (!x.currentTarget.contains(x.target))
          return;
        let P = !0;
        c.isPressed && !c.ignoreEmulatedMouseEvents && c.pointerType != null && (c.isOverTarget = !0, P = T(x, c.pointerType)), P && x.stopPropagation();
      }, p.onMouseLeave = (x) => {
        if (!x.currentTarget.contains(x.target))
          return;
        let P = !0;
        c.isPressed && !c.ignoreEmulatedMouseEvents && c.pointerType != null && (c.isOverTarget = !1, P = A(x, c.pointerType, !1), _(x)), P && x.stopPropagation();
      }, p.onMouseUp = (x) => {
        x.currentTarget.contains(x.target) && !c.ignoreEmulatedMouseEvents && x.button === 0 && V(x, c.pointerType || "mouse");
      };
      let m = (x) => {
        if (x.button === 0) {
          if (c.isPressed = !1, S(), c.ignoreEmulatedMouseEvents) {
            c.ignoreEmulatedMouseEvents = !1;
            return;
          }
          c.target && jn(x, c.target) && c.pointerType != null ? A(Ft(c.target, x), c.pointerType) : c.target && c.isOverTarget && c.pointerType != null && A(Ft(c.target, x), c.pointerType, !1), c.isOverTarget = !1;
        }
      };
      p.onTouchStart = (x) => {
        if (!x.currentTarget.contains(x.target))
          return;
        let P = Pb(x.nativeEvent);
        if (!P)
          return;
        c.activePointerId = P.identifier, c.ignoreEmulatedMouseEvents = !0, c.isOverTarget = !0, c.isPressed = !0, c.target = x.currentTarget, c.pointerType = "touch", !o && !s && qt(x.currentTarget), f || s0(c.target), T(x, c.pointerType) && x.stopPropagation(), w(Yr(x.currentTarget), "scroll", O, !0);
      }, p.onTouchMove = (x) => {
        if (!x.currentTarget.contains(x.target))
          return;
        if (!c.isPressed) {
          x.stopPropagation();
          return;
        }
        let P = u0(x.nativeEvent, c.activePointerId), N = !0;
        P && jn(P, x.currentTarget) ? !c.isOverTarget && c.pointerType != null && (c.isOverTarget = !0, N = T(x, c.pointerType)) : c.isOverTarget && c.pointerType != null && (c.isOverTarget = !1, N = A(x, c.pointerType, !1), _(x)), N && x.stopPropagation();
      }, p.onTouchEnd = (x) => {
        if (!x.currentTarget.contains(x.target))
          return;
        if (!c.isPressed) {
          x.stopPropagation();
          return;
        }
        let P = u0(x.nativeEvent, c.activePointerId), N = !0;
        P && jn(P, x.currentTarget) && c.pointerType != null ? (V(x, c.pointerType), N = A(x, c.pointerType)) : c.isOverTarget && c.pointerType != null && (N = A(x, c.pointerType, !1)), N && x.stopPropagation(), c.isPressed = !1, c.activePointerId = null, c.isOverTarget = !1, c.ignoreEmulatedMouseEvents = !0, c.target && !f && xa(c.target), S();
      }, p.onTouchCancel = (x) => {
        x.currentTarget.contains(x.target) && (x.stopPropagation(), c.isPressed && $(x));
      };
      let O = (x) => {
        c.isPressed && x.target.contains(c.target) && $({
          currentTarget: c.target,
          shiftKey: !1,
          ctrlKey: !1,
          metaKey: !1,
          altKey: !1
        });
      };
      p.onDragStart = (x) => {
        x.currentTarget.contains(x.target) && $(x);
      };
    }
    return p;
  }, [
    w,
    o,
    s,
    S,
    f,
    $,
    _,
    A,
    T,
    V
  ]);
  return re(() => () => {
    var c;
    f || xa((c = b.current.target) !== null && c !== void 0 ? c : void 0);
  }, [
    f
  ]), {
    isPressed: l || v,
    pressProps: Pe(g, y)
  };
}
function Nc(e) {
  return e.tagName === "A" && e.hasAttribute("href");
}
function To(e, t) {
  const { key: n, code: r } = e, a = t, i = a.getAttribute("role");
  return (n === "Enter" || n === " " || n === "Spacebar" || r === "Space") && !(a instanceof Yr(a).HTMLInputElement && !c2(a, n) || a instanceof Yr(a).HTMLTextAreaElement || a.isContentEditable) && // Links should only trigger with Enter key
  !((i === "link" || !i && Nc(a)) && n !== "Enter");
}
function Pb(e) {
  const { targetTouches: t } = e;
  return t.length > 0 ? t[0] : null;
}
function u0(e, t) {
  const n = e.changedTouches;
  for (let r = 0; r < n.length; r++) {
    const a = n[r];
    if (a.identifier === t)
      return a;
  }
  return null;
}
function Ft(e, t) {
  return {
    currentTarget: e,
    shiftKey: t.shiftKey,
    ctrlKey: t.ctrlKey,
    metaKey: t.metaKey,
    altKey: t.altKey
  };
}
function Cb(e) {
  let t = 0, n = 0;
  return e.width !== void 0 ? t = e.width / 2 : e.radiusX !== void 0 && (t = e.radiusX), e.height !== void 0 ? n = e.height / 2 : e.radiusY !== void 0 && (n = e.radiusY), {
    top: e.clientY - n,
    right: e.clientX + t,
    bottom: e.clientY + n,
    left: e.clientX - t
  };
}
function Sb(e, t) {
  return !(e.left > t.right || t.left > e.right || e.top > t.bottom || t.top > e.bottom);
}
function jn(e, t) {
  let n = t.getBoundingClientRect(), r = Cb(e);
  return Sb(n, r);
}
function Ao(e) {
  return !(e instanceof HTMLElement) || !e.hasAttribute("draggable");
}
function d0(e, t) {
  return e instanceof HTMLInputElement ? !c2(e, t) : e instanceof HTMLButtonElement ? e.type !== "submit" && e.type !== "reset" : !Nc(e);
}
const kb = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function c2(e, t) {
  return e.type === "checkbox" || e.type === "radio" ? t === " " : kb.has(e.type);
}
class Tb {
  isDefaultPrevented() {
    return this.nativeEvent.defaultPrevented;
  }
  preventDefault() {
    this.defaultPrevented = !0, this.nativeEvent.preventDefault();
  }
  stopPropagation() {
    this.nativeEvent.stopPropagation(), this.isPropagationStopped = () => !0;
  }
  isPropagationStopped() {
    return !1;
  }
  persist() {
  }
  constructor(t, n) {
    this.nativeEvent = n, this.target = n.target, this.currentTarget = n.currentTarget, this.relatedTarget = n.relatedTarget, this.bubbles = n.bubbles, this.cancelable = n.cancelable, this.defaultPrevented = n.defaultPrevented, this.eventPhase = n.eventPhase, this.isTrusted = n.isTrusted, this.timeStamp = n.timeStamp, this.type = t;
  }
}
function u2(e) {
  let t = J({
    isFocused: !1,
    observer: null
  });
  tn(() => {
    const r = t.current;
    return () => {
      r.observer && (r.observer.disconnect(), r.observer = null);
    };
  }, []);
  let n = lt((r) => {
    e == null || e(r);
  });
  return he((r) => {
    if (r.target instanceof HTMLButtonElement || r.target instanceof HTMLInputElement || r.target instanceof HTMLTextAreaElement || r.target instanceof HTMLSelectElement) {
      t.current.isFocused = !0;
      let a = r.target, i = (o) => {
        t.current.isFocused = !1, a.disabled && n(new Tb("blur", o)), t.current.observer && (t.current.observer.disconnect(), t.current.observer = null);
      };
      a.addEventListener("focusout", i, {
        once: !0
      }), t.current.observer = new MutationObserver(() => {
        if (t.current.isFocused && a.disabled) {
          var o;
          (o = t.current.observer) === null || o === void 0 || o.disconnect();
          let l = a === document.activeElement ? null : document.activeElement;
          a.dispatchEvent(new FocusEvent("blur", {
            relatedTarget: l
          })), a.dispatchEvent(new FocusEvent("focusout", {
            bubbles: !0,
            relatedTarget: l
          }));
        }
      }), t.current.observer.observe(a, {
        attributes: !0,
        attributeFilter: [
          "disabled"
        ]
      });
    }
  }, [
    n
  ]);
}
function d2(e) {
  let { isDisabled: t, onFocus: n, onBlur: r, onFocusChange: a } = e;
  const i = he((s) => {
    if (s.target === s.currentTarget)
      return r && r(s), a && a(!1), !0;
  }, [
    r,
    a
  ]), o = u2(i), l = he((s) => {
    s.target === s.currentTarget && document.activeElement === s.target && (n && n(s), a && a(!0), o(s));
  }, [
    a,
    n,
    o
  ]);
  return {
    focusProps: {
      onFocus: !t && (n || a || r) ? l : void 0,
      onBlur: !t && (r || a) ? i : void 0
    }
  };
}
let Vn = null, Js = /* @__PURE__ */ new Set(), f0 = !1, In = !1, Qs = !1;
const Ab = {
  Tab: !0,
  Escape: !0
};
function Bi(e, t) {
  for (let n of Js)
    n(e, t);
}
function Ob(e) {
  return !(e.metaKey || !hn() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function p0(e) {
  In = !0, Ob(e) && (Vn = "keyboard", Bi("keyboard", e));
}
function Un(e) {
  Vn = "pointer", (e.type === "mousedown" || e.type === "pointerdown") && (In = !0, Bi("pointer", e));
}
function zb(e) {
  Ys(e) && (In = !0, Vn = "virtual");
}
function Mb(e) {
  e.target === window || e.target === document || (!In && !Qs && (Vn = "virtual", Bi("virtual", e)), In = !1, Qs = !1);
}
function _b() {
  In = !1, Qs = !0;
}
function ec() {
  if (typeof window > "u" || f0)
    return;
  let e = HTMLElement.prototype.focus;
  HTMLElement.prototype.focus = function() {
    In = !0, e.apply(this, arguments);
  }, document.addEventListener("keydown", p0, !0), document.addEventListener("keyup", p0, !0), document.addEventListener("click", zb, !0), window.addEventListener("focus", Mb, !0), window.addEventListener("blur", _b, !1), typeof PointerEvent < "u" ? (document.addEventListener("pointerdown", Un, !0), document.addEventListener("pointermove", Un, !0), document.addEventListener("pointerup", Un, !0)) : (document.addEventListener("mousedown", Un, !0), document.addEventListener("mousemove", Un, !0), document.addEventListener("mouseup", Un, !0)), f0 = !0;
}
typeof document < "u" && (document.readyState !== "loading" ? ec() : document.addEventListener("DOMContentLoaded", ec));
function mi() {
  return Vn !== "pointer";
}
function tc() {
  return Vn;
}
function Lb(e) {
  Vn = e, Bi(e, null);
}
const Ib = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
function Db(e, t, n) {
  var r;
  return e = e || (n == null ? void 0 : n.target) instanceof HTMLInputElement && !Ib.has(n == null || (r = n.target) === null || r === void 0 ? void 0 : r.type) || (n == null ? void 0 : n.target) instanceof HTMLTextAreaElement || (n == null ? void 0 : n.target) instanceof HTMLElement && (n == null ? void 0 : n.target.isContentEditable), !(e && t === "keyboard" && n instanceof KeyboardEvent && !Ab[n.key]);
}
function Nb(e, t, n) {
  ec(), re(() => {
    let r = (a, i) => {
      Db(!!(n != null && n.isTextInput), a, i) && e(mi());
    };
    return Js.add(r), () => {
      Js.delete(r);
    };
  }, t);
}
function ra(e) {
  let { isDisabled: t, onBlurWithin: n, onFocusWithin: r, onFocusWithinChange: a } = e, i = J({
    isFocusWithin: !1
  }), o = he((u) => {
    i.current.isFocusWithin && !u.currentTarget.contains(u.relatedTarget) && (i.current.isFocusWithin = !1, n && n(u), a && a(!1));
  }, [
    n,
    a,
    i
  ]), l = u2(o), s = he((u) => {
    !i.current.isFocusWithin && document.activeElement === u.target && (r && r(u), a && a(!0), i.current.isFocusWithin = !0, l(u));
  }, [
    r,
    a,
    l
  ]);
  return t ? {
    focusWithinProps: {
      // These should not have been null, that would conflict in mergeProps
      onFocus: void 0,
      onBlur: void 0
    }
  } : {
    focusWithinProps: {
      onFocus: s,
      onBlur: o
    }
  };
}
let gi = !1, Oo = 0;
function nc() {
  gi = !0, setTimeout(() => {
    gi = !1;
  }, 50);
}
function h0(e) {
  e.pointerType === "touch" && nc();
}
function Rb() {
  if (!(typeof document > "u"))
    return typeof PointerEvent < "u" ? document.addEventListener("pointerup", h0) : document.addEventListener("touchend", nc), Oo++, () => {
      Oo--, !(Oo > 0) && (typeof PointerEvent < "u" ? document.removeEventListener("pointerup", h0) : document.removeEventListener("touchend", nc));
    };
}
function Bb(e) {
  let { onHoverStart: t, onHoverChange: n, onHoverEnd: r, isDisabled: a } = e, [i, o] = ne(!1), l = J({
    isHovered: !1,
    ignoreEmulatedMouseEvents: !1,
    pointerType: "",
    target: null
  }).current;
  re(Rb, []);
  let { hoverProps: s, triggerHoverEnd: u } = ge(() => {
    let f = (v, E) => {
      if (l.pointerType = E, a || E === "touch" || l.isHovered || !v.currentTarget.contains(v.target))
        return;
      l.isHovered = !0;
      let b = v.currentTarget;
      l.target = b, t && t({
        type: "hoverstart",
        target: b,
        pointerType: E
      }), n && n(!0), o(!0);
    }, h = (v, E) => {
      if (l.pointerType = "", l.target = null, E === "touch" || !l.isHovered)
        return;
      l.isHovered = !1;
      let b = v.currentTarget;
      r && r({
        type: "hoverend",
        target: b,
        pointerType: E
      }), n && n(!1), o(!1);
    }, g = {};
    return typeof PointerEvent < "u" ? (g.onPointerEnter = (v) => {
      gi && v.pointerType === "mouse" || f(v, v.pointerType);
    }, g.onPointerLeave = (v) => {
      !a && v.currentTarget.contains(v.target) && h(v, v.pointerType);
    }) : (g.onTouchStart = () => {
      l.ignoreEmulatedMouseEvents = !0;
    }, g.onMouseEnter = (v) => {
      !l.ignoreEmulatedMouseEvents && !gi && f(v, "mouse"), l.ignoreEmulatedMouseEvents = !1;
    }, g.onMouseLeave = (v) => {
      !a && v.currentTarget.contains(v.target) && h(v, "mouse");
    }), {
      hoverProps: g,
      triggerHoverEnd: h
    };
  }, [
    t,
    n,
    r,
    a,
    l
  ]);
  return re(() => {
    a && u({
      currentTarget: l.target
    }, l.pointerType);
  }, [
    a
  ]), {
    hoverProps: s,
    isHovered: i
  };
}
function Vb(e) {
  let { ref: t, onInteractOutside: n, isDisabled: r, onInteractOutsideStart: a } = e, i = J({
    isPointerDown: !1,
    ignoreEmulatedMouseEvents: !1
  }), o = lt((s) => {
    n && Pa(s, t) && (a && a(s), i.current.isPointerDown = !0);
  }), l = lt((s) => {
    n && n(s);
  });
  re(() => {
    let s = i.current;
    if (r)
      return;
    const u = t.current, f = zt(u);
    if (typeof PointerEvent < "u") {
      let h = (g) => {
        s.isPointerDown && Pa(g, t) && l(g), s.isPointerDown = !1;
      };
      return f.addEventListener("pointerdown", o, !0), f.addEventListener("pointerup", h, !0), () => {
        f.removeEventListener("pointerdown", o, !0), f.removeEventListener("pointerup", h, !0);
      };
    } else {
      let h = (v) => {
        s.ignoreEmulatedMouseEvents ? s.ignoreEmulatedMouseEvents = !1 : s.isPointerDown && Pa(v, t) && l(v), s.isPointerDown = !1;
      }, g = (v) => {
        s.ignoreEmulatedMouseEvents = !0, s.isPointerDown && Pa(v, t) && l(v), s.isPointerDown = !1;
      };
      return f.addEventListener("mousedown", o, !0), f.addEventListener("mouseup", h, !0), f.addEventListener("touchstart", o, !0), f.addEventListener("touchend", g, !0), () => {
        f.removeEventListener("mousedown", o, !0), f.removeEventListener("mouseup", h, !0), f.removeEventListener("touchstart", o, !0), f.removeEventListener("touchend", g, !0);
      };
    }
  }, [
    t,
    r,
    o,
    l
  ]);
}
function Pa(e, t) {
  if (e.button > 0)
    return !1;
  if (e.target) {
    const n = e.target.ownerDocument;
    if (!n || !n.documentElement.contains(e.target) || e.target.closest("[data-react-aria-top-layer]"))
      return !1;
  }
  return t.current && !t.current.contains(e.target);
}
function v0(e) {
  if (!e)
    return;
  let t = !0;
  return (n) => {
    let r = {
      ...n,
      preventDefault() {
        n.preventDefault();
      },
      isDefaultPrevented() {
        return n.isDefaultPrevented();
      },
      stopPropagation() {
        console.error("stopPropagation is now the default behavior for events in React Spectrum. You can use continuePropagation() to revert this behavior.");
      },
      continuePropagation() {
        t = !1;
      }
    };
    e(r), t && n.stopPropagation();
  };
}
function Fb(e) {
  return {
    keyboardProps: e.isDisabled ? {} : {
      onKeyDown: v0(e.onKeyDown),
      onKeyUp: v0(e.onKeyUp)
    }
  };
}
const Hb = 500;
function f2(e) {
  let { isDisabled: t, onLongPressStart: n, onLongPressEnd: r, onLongPress: a, threshold: i = Hb, accessibilityDescription: o } = e;
  const l = J();
  let { addGlobalListener: s, removeGlobalListener: u } = a2(), { pressProps: f } = vn({
    isDisabled: t,
    onPressStart(g) {
      if (g.continuePropagation(), (g.pointerType === "mouse" || g.pointerType === "touch") && (n && n({
        ...g,
        type: "longpressstart"
      }), l.current = setTimeout(() => {
        g.target.dispatchEvent(new PointerEvent("pointercancel", {
          bubbles: !0
        })), a && a({
          ...g,
          type: "longpress"
        }), l.current = void 0;
      }, i), g.pointerType === "touch")) {
        let v = (E) => {
          E.preventDefault();
        };
        s(g.target, "contextmenu", v, {
          once: !0
        }), s(window, "pointerup", () => {
          setTimeout(() => {
            u(g.target, "contextmenu", v);
          }, 30);
        }, {
          once: !0
        });
      }
    },
    onPressEnd(g) {
      l.current && clearTimeout(l.current), r && (g.pointerType === "mouse" || g.pointerType === "touch") && r({
        ...g,
        type: "longpressend"
      });
    }
  }), h = vb(a && !t ? o : void 0);
  return {
    longPressProps: Pe(f, h)
  };
}
function yi(e) {
  const t = zt(e);
  if (tc() === "virtual") {
    let n = t.activeElement;
    r2(() => {
      t.activeElement === n && e.isConnected && qt(e);
    });
  } else
    qt(e);
}
function Kb(e) {
  const t = Yr(e);
  if (!(e instanceof t.HTMLElement) && !(e instanceof t.SVGElement))
    return !1;
  let { display: n, visibility: r } = e.style, a = n !== "none" && r !== "hidden" && r !== "collapse";
  if (a) {
    const { getComputedStyle: i } = e.ownerDocument.defaultView;
    let { display: o, visibility: l } = i(e);
    a = o !== "none" && l !== "hidden" && l !== "collapse";
  }
  return a;
}
function jb(e, t) {
  return !e.hasAttribute("hidden") && (e.nodeName === "DETAILS" && t && t.nodeName !== "SUMMARY" ? e.hasAttribute("open") : !0);
}
function p2(e, t) {
  return e.nodeName !== "#comment" && Kb(e) && jb(e, t) && (!e.parentElement || p2(e.parentElement, e));
}
let Ub = null;
const Rc = [
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "a[href]",
  "area[href]",
  "summary",
  "iframe",
  "object",
  "embed",
  "audio[controls]",
  "video[controls]",
  "[contenteditable]"
], Wb = Rc.join(":not([hidden]),") + ",[tabindex]:not([disabled]):not([hidden])";
Rc.push('[tabindex]:not([tabindex="-1"]):not([disabled])');
const qb = Rc.join(':not([hidden]):not([tabindex="-1"]),');
function Bc(e, t) {
  return !e || !t ? !1 : t.some((n) => n.contains(e));
}
function Zb(e, t = null) {
  if (e instanceof Element && e.closest("[data-react-aria-top-layer]"))
    return !0;
  for (let { scopeRef: n } of g0.traverse(g0.getTreeNode(t)))
    if (n && Bc(e, n.current))
      return !0;
  return !1;
}
function Gb(e) {
  return Zb(e, Ub);
}
function Vc(e, t, n) {
  let r = t != null && t.tabbable ? qb : Wb, a = zt(e).createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode(i) {
      var o;
      return !(t == null || (o = t.from) === null || o === void 0) && o.contains(i) ? NodeFilter.FILTER_REJECT : i.matches(r) && p2(i) && (!n || Bc(i, n)) && (!(t != null && t.accept) || t.accept(i)) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  return t != null && t.from && (a.currentNode = t.from), a;
}
class Fc {
  get size() {
    return this.fastMap.size;
  }
  getTreeNode(t) {
    return this.fastMap.get(t);
  }
  addTreeNode(t, n, r) {
    let a = this.fastMap.get(n ?? null);
    if (!a)
      return;
    let i = new m0({
      scopeRef: t
    });
    a.addChild(i), i.parent = a, this.fastMap.set(t, i), r && (i.nodeToRestore = r);
  }
  addNode(t) {
    this.fastMap.set(t.scopeRef, t);
  }
  removeTreeNode(t) {
    if (t === null)
      return;
    let n = this.fastMap.get(t);
    if (!n)
      return;
    let r = n.parent;
    for (let i of this.traverse())
      i !== n && n.nodeToRestore && i.nodeToRestore && n.scopeRef && n.scopeRef.current && Bc(i.nodeToRestore, n.scopeRef.current) && (i.nodeToRestore = n.nodeToRestore);
    let a = n.children;
    r && (r.removeChild(n), a.size > 0 && a.forEach((i) => r && r.addChild(i))), this.fastMap.delete(n.scopeRef);
  }
  // Pre Order Depth First
  *traverse(t = this.root) {
    if (t.scopeRef != null && (yield t), t.children.size > 0)
      for (let n of t.children)
        yield* this.traverse(n);
  }
  clone() {
    var t;
    let n = new Fc();
    var r;
    for (let a of this.traverse())
      n.addTreeNode(a.scopeRef, (r = (t = a.parent) === null || t === void 0 ? void 0 : t.scopeRef) !== null && r !== void 0 ? r : null, a.nodeToRestore);
    return n;
  }
  constructor() {
    this.fastMap = /* @__PURE__ */ new Map(), this.root = new m0({
      scopeRef: null
    }), this.fastMap.set(null, this.root);
  }
}
class m0 {
  addChild(t) {
    this.children.add(t), t.parent = this;
  }
  removeChild(t) {
    this.children.delete(t), t.parent = void 0;
  }
  constructor(t) {
    this.children = /* @__PURE__ */ new Set(), this.contain = !1, this.scopeRef = t.scopeRef;
  }
}
let g0 = new Fc();
function vr(e = {}) {
  let { autoFocus: t = !1, isTextInput: n, within: r } = e, a = J({
    isFocused: !1,
    isFocusVisible: t || mi()
  }), [i, o] = ne(!1), [l, s] = ne(() => a.current.isFocused && a.current.isFocusVisible), u = he(() => s(a.current.isFocused && a.current.isFocusVisible), []), f = he((v) => {
    a.current.isFocused = v, o(v), u();
  }, [
    u
  ]);
  Nb((v) => {
    a.current.isFocusVisible = v, u();
  }, [], {
    isTextInput: n
  });
  let { focusProps: h } = d2({
    isDisabled: r,
    onFocusChange: f
  }), { focusWithinProps: g } = ra({
    isDisabled: !r,
    onFocusWithinChange: f
  });
  return {
    isFocused: i,
    isFocusVisible: l,
    focusProps: r ? g : h
  };
}
let Yb = /* @__PURE__ */ oe.createContext(null);
function Xb(e) {
  let t = ze(Yb) || {};
  i2(t, e);
  let { ref: n, ...r } = t;
  return r;
}
function aa(e, t) {
  let { focusProps: n } = d2(e), { keyboardProps: r } = Fb(e), a = Pe(n, r), i = Xb(t), o = e.isDisabled ? {} : i, l = J(e.autoFocus);
  return re(() => {
    l.current && t.current && yi(t.current), l.current = !1;
  }, [
    t
  ]), {
    focusableProps: Pe({
      ...a,
      tabIndex: e.excludeFromTabOrder && !e.isDisabled ? -1 : void 0
    }, o)
  };
}
function Jb(e, t) {
  let n = t == null ? void 0 : t.isDisabled, [r, a] = ne(!1);
  return tn(() => {
    if (e != null && e.current && !n) {
      let i = () => {
        if (e.current) {
          let l = Vc(e.current, {
            tabbable: !0
          });
          a(!!l.nextNode());
        }
      };
      i();
      let o = new MutationObserver(i);
      return o.observe(e.current, {
        subtree: !0,
        childList: !0,
        attributes: !0,
        attributeFilter: [
          "tabIndex",
          "disabled"
        ]
      }), () => {
        o.disconnect();
      };
    }
  }), n ? !1 : r;
}
function h2(e, t) {
  let {
    elementType: n = "a",
    onPress: r,
    onPressStart: a,
    onPressEnd: i,
    // @ts-ignore
    onClick: o,
    isDisabled: l,
    ...s
  } = e, u = {};
  n !== "a" && (u = {
    role: "link",
    tabIndex: l ? void 0 : 0
  });
  let { focusableProps: f } = aa(e, t), { pressProps: h, isPressed: g } = vn({
    onPress: r,
    onPressStart: a,
    onPressEnd: i,
    isDisabled: l,
    ref: t
  }), v = Bt(s, {
    labelable: !0,
    isLink: n === "a"
  }), E = Pe(f, h), b = Ri();
  return {
    isPressed: g,
    linkProps: Pe(v, {
      ...E,
      ...u,
      "aria-disabled": l || void 0,
      "aria-current": e["aria-current"],
      onClick: (w) => {
        var S;
        (S = h.onClick) === null || S === void 0 || S.call(h, w), o && (o(w), console.warn("onClick is deprecated, please use onPress")), !b.isNative && w.currentTarget instanceof HTMLAnchorElement && w.currentTarget.href && // If props are applied to a router Link component, it may have already prevented default.
        !w.isDefaultPrevented() && db(w.currentTarget, w) && (w.preventDefault(), b.open(w.currentTarget, w));
      }
    })
  };
}
const Qb = Symbol.for("react-aria.i18n.locale"), e5 = Symbol.for("react-aria.i18n.strings");
let Wn;
class Vi {
  /** Returns a localized string for the given key and locale. */
  getStringForLocale(t, n) {
    let a = this.getStringsForLocale(n)[t];
    if (!a)
      throw new Error(`Could not find intl message ${t} in ${n} locale`);
    return a;
  }
  /** Returns all localized strings for the given locale. */
  getStringsForLocale(t) {
    let n = this.strings[t];
    return n || (n = t5(t, this.strings, this.defaultLocale), this.strings[t] = n), n;
  }
  static getGlobalDictionaryForPackage(t) {
    if (typeof window > "u")
      return null;
    let n = window[Qb];
    if (Wn === void 0) {
      let a = window[e5];
      if (!a)
        return null;
      Wn = {};
      for (let i in a)
        Wn[i] = new Vi({
          [n]: a[i]
        }, n);
    }
    let r = Wn == null ? void 0 : Wn[t];
    if (!r)
      throw new Error(`Strings for package "${t}" were not included by LocalizedStringProvider. Please add it to the list passed to createLocalizedStringDictionary.`);
    return r;
  }
  constructor(t, n = "en-US") {
    this.strings = {
      ...t
    }, this.defaultLocale = n;
  }
}
function t5(e, t, n = "en-US") {
  if (t[e])
    return t[e];
  let r = n5(e);
  if (t[r])
    return t[r];
  for (let a in t)
    if (a.startsWith(r + "-"))
      return t[a];
  return t[n];
}
function n5(e) {
  return Intl.Locale ? new Intl.Locale(e).language : e.split("-")[0];
}
const y0 = /* @__PURE__ */ new Map(), b0 = /* @__PURE__ */ new Map();
class r5 {
  /** Formats a localized string for the given key with the provided variables. */
  format(t, n) {
    let r = this.strings.getStringForLocale(t, this.locale);
    return typeof r == "function" ? r(n, this) : r;
  }
  plural(t, n, r = "cardinal") {
    let a = n["=" + t];
    if (a)
      return typeof a == "function" ? a() : a;
    let i = this.locale + ":" + r, o = y0.get(i);
    o || (o = new Intl.PluralRules(this.locale, {
      type: r
    }), y0.set(i, o));
    let l = o.select(t);
    return a = n[l] || n.other, typeof a == "function" ? a() : a;
  }
  number(t) {
    let n = b0.get(this.locale);
    return n || (n = new Intl.NumberFormat(this.locale), b0.set(this.locale, n)), n.format(t);
  }
  select(t, n) {
    let r = t[n] || t.other;
    return typeof r == "function" ? r() : r;
  }
  constructor(t, n) {
    this.locale = t, this.strings = n;
  }
}
const a5 = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), i5 = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function o5(e) {
  if (Intl.Locale) {
    let n = new Intl.Locale(e).maximize(), r = typeof n.getTextInfo == "function" ? n.getTextInfo() : n.textInfo;
    if (r)
      return r.direction === "rtl";
    if (n.script)
      return a5.has(n.script);
  }
  let t = e.split("-")[0];
  return i5.has(t);
}
const l5 = Symbol.for("react-aria.i18n.locale");
function v2() {
  let e = typeof window < "u" && window[l5] || typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      e
    ]);
  } catch {
    e = "en-US";
  }
  return {
    locale: e,
    direction: o5(e) ? "rtl" : "ltr"
  };
}
let rc = v2(), Kr = /* @__PURE__ */ new Set();
function w0() {
  rc = v2();
  for (let e of Kr)
    e(rc);
}
function s5() {
  let e = Qh(), [t, n] = ne(rc);
  return re(() => (Kr.size === 0 && window.addEventListener("languagechange", w0), Kr.add(n), () => {
    Kr.delete(n), Kr.size === 0 && window.removeEventListener("languagechange", w0);
  }), []), e ? {
    locale: "en-US",
    direction: "ltr"
  } : t;
}
const c5 = /* @__PURE__ */ oe.createContext(null);
function ia() {
  let e = s5();
  return ze(c5) || e;
}
const x0 = /* @__PURE__ */ new WeakMap();
function u5(e) {
  let t = x0.get(e);
  return t || (t = new Vi(e), x0.set(e, t)), t;
}
function d5(e, t) {
  return t && Vi.getGlobalDictionaryForPackage(t) || u5(e);
}
function Hc(e, t) {
  let { locale: n } = ia(), r = d5(e, t);
  return ge(() => new r5(n, r), [
    n,
    r
  ]);
}
let zo = /* @__PURE__ */ new Map();
function m2(e) {
  let { locale: t } = ia(), n = t + (e ? Object.entries(e).sort((a, i) => a[0] < i[0] ? -1 : 1).join() : "");
  if (zo.has(n))
    return zo.get(n);
  let r = new Intl.Collator(t, e);
  return zo.set(n, r), r;
}
function f5(e) {
  let t = m2({
    usage: "search",
    ...e
  }), n = he((i, o) => o.length === 0 ? !0 : (i = i.normalize("NFC"), o = o.normalize("NFC"), t.compare(i.slice(0, o.length), o) === 0), [
    t
  ]), r = he((i, o) => o.length === 0 ? !0 : (i = i.normalize("NFC"), o = o.normalize("NFC"), t.compare(i.slice(-o.length), o) === 0), [
    t
  ]), a = he((i, o) => {
    if (o.length === 0)
      return !0;
    i = i.normalize("NFC"), o = o.normalize("NFC");
    let l = 0, s = o.length;
    for (; l + s <= i.length; l++) {
      let u = i.slice(l, l + s);
      if (t.compare(o, u) === 0)
        return !0;
    }
    return !1;
  }, [
    t
  ]);
  return ge(() => ({
    startsWith: n,
    endsWith: r,
    contains: a
  }), [
    n,
    r,
    a
  ]);
}
var Dt = function() {
  return Dt = Object.assign || function(t) {
    for (var n, r = 1, a = arguments.length; r < a; r++) {
      n = arguments[r];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, Dt.apply(this, arguments);
};
function g2(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, r = Object.getOwnPropertySymbols(e); a < r.length; a++)
      t.indexOf(r[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[a]) && (n[r[a]] = e[r[a]]);
  return n;
}
function p5(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, a = t.length, i; r < a; r++)
      (i || !(r in t)) && (i || (i = Array.prototype.slice.call(t, 0, r)), i[r] = t[r]);
  return e.concat(i || Array.prototype.slice.call(t));
}
function h5(e) {
  return e && e.__esModule ? e.default : e;
}
function v5(e, t) {
  let { isCurrent: n, isDisabled: r, "aria-current": a, elementType: i = "a", ...o } = e, { linkProps: l } = h2({
    isDisabled: r || n,
    elementType: i,
    ...o
  }, t), s = /^h[1-6]$/.test(i), u = {};
  return s || (u = l), n && (u["aria-current"] = a || "page", u.tabIndex = e.autoFocus ? -1 : void 0), {
    itemProps: {
      "aria-disabled": r,
      ...u
    }
  };
}
var y2 = {};
y2 = {
  "ar-AE": yh,
  "bg-BG": bh,
  "cs-CZ": wh,
  "da-DK": xh,
  "de-DE": Eh,
  "el-GR": $h,
  "en-US": Ph,
  "es-ES": Ch,
  "et-EE": Sh,
  "fi-FI": kh,
  "fr-FR": Th,
  "he-IL": Ah,
  "hr-HR": Oh,
  "hu-HU": zh,
  "it-IT": Mh,
  "ja-JP": _h,
  "ko-KR": Lh,
  "lt-LT": Ih,
  "lv-LV": Dh,
  "nb-NO": Nh,
  "nl-NL": Rh,
  "pl-PL": Bh,
  "pt-BR": Vh,
  "pt-PT": Fh,
  "ro-RO": Hh,
  "ru-RU": Kh,
  "sk-SK": jh,
  "sl-SI": Uh,
  "sr-SP": Wh,
  "sv-SE": qh,
  "tr-TR": Zh,
  "uk-UA": Gh,
  "zh-CN": Yh,
  "zh-TW": Xh
};
function m5(e) {
  let { "aria-label": t, ...n } = e, r = Hc(/* @__PURE__ */ h5(y2), "@react-aria/breadcrumbs");
  return {
    navProps: {
      ...Bt(n, {
        labelable: !0
      }),
      "aria-label": t || r.format("breadcrumbs")
    }
  };
}
function Fi(e, t) {
  let {
    elementType: n = "button",
    isDisabled: r,
    onPress: a,
    onPressStart: i,
    onPressEnd: o,
    onPressUp: l,
    onPressChange: s,
    preventFocusOnPress: u,
    allowFocusWhenDisabled: f,
    // @ts-ignore
    onClick: h,
    href: g,
    target: v,
    rel: E,
    type: b = "button"
  } = e, w;
  n === "button" ? w = {
    type: b,
    disabled: r
  } : w = {
    role: "button",
    tabIndex: r ? void 0 : 0,
    href: n === "a" && r ? void 0 : g,
    target: n === "a" ? v : void 0,
    type: n === "input" ? b : void 0,
    disabled: n === "input" ? r : void 0,
    "aria-disabled": !r || n === "input" ? void 0 : r,
    rel: n === "a" ? E : void 0
  };
  let { pressProps: S, isPressed: T } = vn({
    onPressStart: i,
    onPressEnd: o,
    onPressChange: s,
    onPress: a,
    onPressUp: l,
    isDisabled: r,
    preventFocusOnPress: u,
    ref: t
  }), { focusableProps: A } = aa(e, t);
  f && (A.tabIndex = r ? -1 : A.tabIndex);
  let V = Pe(A, S, Bt(e, {
    labelable: !0
  }));
  return {
    isPressed: T,
    buttonProps: Pe(w, V, {
      "aria-haspopup": e["aria-haspopup"],
      "aria-expanded": e["aria-expanded"],
      "aria-controls": e["aria-controls"],
      "aria-pressed": e["aria-pressed"],
      onClick: ($) => {
        h && (h($), console.warn("onClick is deprecated, please use onPress"));
      }
    })
  };
}
function g5(e, t, n) {
  const { isSelected: r } = t, { isPressed: a, buttonProps: i } = Fi({
    ...e,
    onPress: _c(t.toggle, e.onPress)
  }, n);
  return {
    isPressed: a,
    buttonProps: Pe(i, {
      "aria-pressed": r
    })
  };
}
const b2 = 7e3;
let Mo = null;
function _o(e, t = "assertive", n = b2) {
  Mo || (Mo = new y5()), Mo.announce(e, t, n);
}
class y5 {
  createLog(t) {
    let n = document.createElement("div");
    return n.setAttribute("role", "log"), n.setAttribute("aria-live", t), n.setAttribute("aria-relevant", "additions"), n;
  }
  destroy() {
    this.node && (document.body.removeChild(this.node), this.node = null);
  }
  announce(t, n = "assertive", r = b2) {
    if (!this.node)
      return;
    let a = document.createElement("div");
    a.textContent = t, n === "assertive" ? this.assertiveLog.appendChild(a) : this.politeLog.appendChild(a), t !== "" && setTimeout(() => {
      a.remove();
    }, r);
  }
  clear(t) {
    this.node && ((!t || t === "assertive") && (this.assertiveLog.innerHTML = ""), (!t || t === "polite") && (this.politeLog.innerHTML = ""));
  }
  constructor() {
    this.node = document.createElement("div"), this.node.dataset.liveAnnouncer = "true", Object.assign(this.node.style, {
      border: 0,
      clip: "rect(0 0 0 0)",
      clipPath: "inset(50%)",
      height: "1px",
      margin: "-1px",
      overflow: "hidden",
      padding: 0,
      position: "absolute",
      width: "1px",
      whiteSpace: "nowrap"
    }), this.assertiveLog = this.createLog("assertive"), this.node.appendChild(this.assertiveLog), this.politeLog = this.createLog("polite"), this.node.appendChild(this.politeLog), document.body.prepend(this.node);
  }
}
function Kc(e, t, n) {
  let { validationBehavior: r, focus: a } = e;
  tn(() => {
    if (r === "native" && (n != null && n.current)) {
      let s = t.realtimeValidation.isInvalid ? t.realtimeValidation.validationErrors.join(" ") || "Invalid value." : "";
      n.current.setCustomValidity(s), n.current.hasAttribute("title") || (n.current.title = ""), t.realtimeValidation.isInvalid || t.updateValidation(w5(n.current));
    }
  });
  let i = lt(() => {
    t.resetValidation();
  }), o = lt((s) => {
    var u;
    t.displayValidation.isInvalid || t.commitValidation();
    let f = n == null || (u = n.current) === null || u === void 0 ? void 0 : u.form;
    if (!s.defaultPrevented && n && f && x5(f) === n.current) {
      var h;
      a ? a() : (h = n.current) === null || h === void 0 || h.focus(), Lb("keyboard");
    }
    s.preventDefault();
  }), l = lt(() => {
    t.commitValidation();
  });
  re(() => {
    let s = n == null ? void 0 : n.current;
    if (!s)
      return;
    let u = s.form;
    return s.addEventListener("invalid", o), s.addEventListener("change", l), u == null || u.addEventListener("reset", i), () => {
      s.removeEventListener("invalid", o), s.removeEventListener("change", l), u == null || u.removeEventListener("reset", i);
    };
  }, [
    n,
    o,
    l,
    i,
    r
  ]);
}
function b5(e) {
  let t = e.validity;
  return {
    badInput: t.badInput,
    customError: t.customError,
    patternMismatch: t.patternMismatch,
    rangeOverflow: t.rangeOverflow,
    rangeUnderflow: t.rangeUnderflow,
    stepMismatch: t.stepMismatch,
    tooLong: t.tooLong,
    tooShort: t.tooShort,
    typeMismatch: t.typeMismatch,
    valueMissing: t.valueMissing,
    valid: t.valid
  };
}
function w5(e) {
  return {
    isInvalid: !e.validity.valid,
    validationDetails: b5(e),
    validationErrors: e.validationMessage ? [
      e.validationMessage
    ] : []
  };
}
function x5(e) {
  for (let t = 0; t < e.elements.length; t++) {
    let n = e.elements[t];
    if (!n.validity.valid)
      return n;
  }
  return null;
}
const w2 = {
  badInput: !1,
  customError: !1,
  patternMismatch: !1,
  rangeOverflow: !1,
  rangeUnderflow: !1,
  stepMismatch: !1,
  tooLong: !1,
  tooShort: !1,
  typeMismatch: !1,
  valueMissing: !1,
  valid: !0
}, x2 = {
  ...w2,
  customError: !0,
  valid: !1
}, Pr = {
  isInvalid: !1,
  validationDetails: w2,
  validationErrors: []
}, E5 = Ze({}), ac = "__formValidationState" + Date.now();
function Hi(e) {
  if (e[ac]) {
    let { realtimeValidation: t, displayValidation: n, updateValidation: r, resetValidation: a, commitValidation: i } = e[ac];
    return {
      realtimeValidation: t,
      displayValidation: n,
      updateValidation: r,
      resetValidation: a,
      commitValidation: i
    };
  }
  return $5(e);
}
function $5(e) {
  let { isInvalid: t, validationState: n, name: r, value: a, builtinValidation: i, validate: o, validationBehavior: l = "aria" } = e;
  n && (t || (t = n === "invalid"));
  let s = t ? {
    isInvalid: !0,
    validationErrors: [],
    validationDetails: x2
  } : null, u = ge(() => E0(P5(o, a)), [
    o,
    a
  ]);
  i != null && i.validationDetails.valid && (i = null);
  let f = ze(E5), h = ge(() => r ? Array.isArray(r) ? r.flatMap((d) => ic(f[d])) : ic(f[r]) : [], [
    f,
    r
  ]), [g, v] = ne(f), [E, b] = ne(!1);
  f !== g && (v(f), b(!1));
  let w = ge(() => E0(E ? [] : h), [
    E,
    h
  ]), S = J(Pr), [T, A] = ne(Pr), V = J(Pr), $ = () => {
    if (!_)
      return;
    y(!1);
    let d = u || i || S.current;
    Lo(d, V.current) || (V.current = d, A(d));
  }, [_, y] = ne(!1);
  return re($), {
    realtimeValidation: s || w || u || i || Pr,
    displayValidation: l === "native" ? s || w || T : s || w || u || i || T,
    updateValidation(d) {
      l === "aria" && !Lo(T, d) ? A(d) : S.current = d;
    },
    resetValidation() {
      let d = Pr;
      Lo(d, V.current) || (V.current = d, A(d)), l === "native" && y(!1), b(!0);
    },
    commitValidation() {
      l === "native" && y(!0), b(!0);
    }
  };
}
function ic(e) {
  return e ? Array.isArray(e) ? e : [
    e
  ] : [];
}
function P5(e, t) {
  if (typeof e == "function") {
    let n = e(t);
    if (n && typeof n != "boolean")
      return ic(n);
  }
  return [];
}
function E0(e) {
  return e.length ? {
    isInvalid: !0,
    validationErrors: e,
    validationDetails: x2
  } : null;
}
function Lo(e, t) {
  return e === t ? !0 : e && t && e.isInvalid === t.isInvalid && e.validationErrors.length === t.validationErrors.length && e.validationErrors.every((n, r) => n === t.validationErrors[r]) && Object.entries(e.validationDetails).every(([n, r]) => t.validationDetails[n] === r);
}
function C5(e, t, n) {
  let { isDisabled: r = !1, isReadOnly: a = !1, value: i, name: o, children: l, "aria-label": s, "aria-labelledby": u, validationState: f = "valid", isInvalid: h } = e, g = (_) => {
    _.stopPropagation(), t.setSelected(_.target.checked);
  }, v = l != null, E = s != null || u != null;
  !v && !E && console.warn("If you do not provide children, you must specify an aria-label for accessibility");
  let { pressProps: b, isPressed: w } = vn({
    isDisabled: r
  }), { pressProps: S, isPressed: T } = vn({
    isDisabled: r || a,
    onPress() {
      t.toggle();
    }
  }), { focusableProps: A } = aa(e, n), V = Pe(b, A), $ = Bt(e, {
    labelable: !0
  });
  return Dc(n, t.isSelected, t.setSelected), {
    labelProps: Pe(S, {
      onClick: (_) => _.preventDefault()
    }),
    inputProps: Pe($, {
      "aria-invalid": h || f === "invalid" || void 0,
      "aria-errormessage": e["aria-errormessage"],
      "aria-controls": e["aria-controls"],
      "aria-readonly": a || void 0,
      onChange: g,
      disabled: r,
      ...i == null ? {} : {
        value: i
      },
      name: o,
      type: "checkbox",
      ...V
    }),
    isSelected: t.isSelected,
    isPressed: w || T,
    isDisabled: r,
    isReadOnly: a,
    isInvalid: h || f === "invalid"
  };
}
function E2(e) {
  let { id: t, label: n, "aria-labelledby": r, "aria-label": a, labelElementType: i = "label" } = e;
  t = Yt(t);
  let o = Yt(), l = {};
  n ? (r = r ? `${o} ${r}` : o, l = {
    id: o,
    htmlFor: i === "label" ? t : void 0
  }) : !r && !a && console.warn("If you do not provide a visible label, you must specify an aria-label or aria-labelledby attribute for accessibility");
  let s = Xr({
    id: t,
    "aria-label": a,
    "aria-labelledby": r
  });
  return {
    labelProps: l,
    fieldProps: s
  };
}
function $2(e) {
  let { description: t, errorMessage: n, isInvalid: r, validationState: a } = e, { labelProps: i, fieldProps: o } = E2(e), l = hi([
    !!t,
    !!n,
    r,
    a
  ]), s = hi([
    !!t,
    !!n,
    r,
    a
  ]);
  return o = Pe(o, {
    "aria-describedby": [
      l,
      // Use aria-describedby for error message because aria-errormessage is unsupported using VoiceOver or NVDA. See https://github.com/adobe/react-spectrum/issues/1346#issuecomment-740136268
      s,
      e["aria-describedby"]
    ].filter(Boolean).join(" ") || void 0
  }), {
    labelProps: i,
    fieldProps: o,
    descriptionProps: {
      id: l
    },
    errorMessageProps: {
      id: s
    }
  };
}
function P2(e = {}) {
  let { isReadOnly: t } = e, [n, r] = Bn(e.isSelected, e.defaultSelected || !1, e.onChange);
  function a(o) {
    t || r(o);
  }
  function i() {
    t || r(!n);
  }
  return {
    isSelected: n,
    setSelected: a,
    toggle: i
  };
}
function S5(e, t, n) {
  let r = Hi({
    ...e,
    value: t.isSelected
  }), { isInvalid: a, validationErrors: i, validationDetails: o } = r.displayValidation, { labelProps: l, inputProps: s, isSelected: u, isPressed: f, isDisabled: h, isReadOnly: g } = C5({
    ...e,
    isInvalid: a
  }, t, n);
  Kc(e, r, n);
  let { isIndeterminate: v, isRequired: E, validationBehavior: b = "aria" } = e;
  return re(() => {
    n.current && (n.current.indeterminate = !!v);
  }), {
    labelProps: l,
    inputProps: {
      ...s,
      checked: u,
      "aria-required": E && b === "aria" || void 0,
      required: E && b === "native"
    },
    isSelected: u,
    isPressed: f,
    isDisabled: h,
    isReadOnly: g,
    isInvalid: a,
    validationErrors: i,
    validationDetails: o
  };
}
var C2 = {};
C2 = {
  buttonLabel: "عرض المقترحات",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} خيار`,
    other: () => `${t.number(e.optionCount)} خيارات`
  })} متاحة.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `المجموعة المدخلة ${e.groupTitle}, مع ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} خيار`,
      other: () => `${t.number(e.groupCount)} خيارات`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", محدد",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "مقترحات",
  selectedAnnouncement: (e) => `${e.optionText}، محدد`
};
var S2 = {};
S2 = {
  buttonLabel: "Покажи предложения",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} опция`,
    other: () => `${t.number(e.optionCount)} опции`
  })} на разположение.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Въведена група ${e.groupTitle}, с ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} опция`,
      other: () => `${t.number(e.groupCount)} опции`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", избрани",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Предложения",
  selectedAnnouncement: (e) => `${e.optionText}, избрани`
};
var k2 = {};
k2 = {
  buttonLabel: "Zobrazit doporučení",
  countAnnouncement: (e, t) => `K dispozici ${t.plural(e.optionCount, {
    one: () => `je ${t.number(e.optionCount)} možnost`,
    other: () => `jsou/je ${t.number(e.optionCount)} možnosti/-í`
  })}.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Zadaná skupina „${e.groupTitle}“ ${t.plural(e.groupCount, {
      one: () => `s ${t.number(e.groupCount)} možností`,
      other: () => `se ${t.number(e.groupCount)} možnostmi`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: " (vybráno)",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Návrhy",
  selectedAnnouncement: (e) => `${e.optionText}, vybráno`
};
var T2 = {};
T2 = {
  buttonLabel: "Vis forslag",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} mulighed tilgængelig`,
    other: () => `${t.number(e.optionCount)} muligheder tilgængelige`
  })}.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Angivet gruppe ${e.groupTitle}, med ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} mulighed`,
      other: () => `${t.number(e.groupCount)} muligheder`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", valgt",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Forslag",
  selectedAnnouncement: (e) => `${e.optionText}, valgt`
};
var A2 = {};
A2 = {
  buttonLabel: "Empfehlungen anzeigen",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} Option`,
    other: () => `${t.number(e.optionCount)} Optionen`
  })} verfügbar.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Eingetretene Gruppe ${e.groupTitle}, mit ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} Option`,
      other: () => `${t.number(e.groupCount)} Optionen`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", ausgewählt",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Empfehlungen",
  selectedAnnouncement: (e) => `${e.optionText}, ausgewählt`
};
var O2 = {};
O2 = {
  buttonLabel: "Προβολή προτάσεων",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} επιλογή`,
    other: () => `${t.number(e.optionCount)} επιλογές `
  })} διαθέσιμες.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Εισαγμένη ομάδα ${e.groupTitle}, με ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} επιλογή`,
      other: () => `${t.number(e.groupCount)} επιλογές`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", επιλεγμένο",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Προτάσεις",
  selectedAnnouncement: (e) => `${e.optionText}, επιλέχθηκε`
};
var z2 = {};
z2 = {
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Entered group ${e.groupTitle}, with ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} option`,
      other: () => `${t.number(e.groupCount)} options`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", selected",
    other: ""
  }, e.isSelected)}`,
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} option`,
    other: () => `${t.number(e.optionCount)} options`
  })} available.`,
  selectedAnnouncement: (e) => `${e.optionText}, selected`,
  buttonLabel: "Show suggestions",
  listboxLabel: "Suggestions"
};
var M2 = {};
M2 = {
  buttonLabel: "Mostrar sugerencias",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} opción`,
    other: () => `${t.number(e.optionCount)} opciones`
  })} disponible(s).`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Se ha unido al grupo ${e.groupTitle}, con ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} opción`,
      other: () => `${t.number(e.groupCount)} opciones`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", seleccionado",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Sugerencias",
  selectedAnnouncement: (e) => `${e.optionText}, seleccionado`
};
var _2 = {};
_2 = {
  buttonLabel: "Kuva soovitused",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} valik`,
    other: () => `${t.number(e.optionCount)} valikud`
  })} saadaval.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Sisestatud rühm ${e.groupTitle}, valikuga ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} valik`,
      other: () => `${t.number(e.groupCount)} valikud`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", valitud",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Soovitused",
  selectedAnnouncement: (e) => `${e.optionText}, valitud`
};
var L2 = {};
L2 = {
  buttonLabel: "Näytä ehdotukset",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} vaihtoehto`,
    other: () => `${t.number(e.optionCount)} vaihtoehdot`
  })} saatavilla.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Mentiin ryhmään ${e.groupTitle}, ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} vaihtoehdon`,
      other: () => `${t.number(e.groupCount)} vaihtoehdon`
    })} kanssa.`,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", valittu",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Ehdotukset",
  selectedAnnouncement: (e) => `${e.optionText}, valittu`
};
var I2 = {};
I2 = {
  buttonLabel: "Afficher les suggestions",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} option`,
    other: () => `${t.number(e.optionCount)} options`
  })} disponible(s).`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Groupe ${e.groupTitle} saisi, avec ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} option`,
      other: () => `${t.number(e.groupCount)} options`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", sélectionné(s)",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Suggestions",
  selectedAnnouncement: (e) => `${e.optionText}, sélectionné`
};
var D2 = {};
D2 = {
  buttonLabel: "הצג הצעות",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `אפשרות ${t.number(e.optionCount)}`,
    other: () => `${t.number(e.optionCount)} אפשרויות`
  })} במצב זמין.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `נכנס לקבוצה ${e.groupTitle}, עם ${t.plural(e.groupCount, {
      one: () => `אפשרות ${t.number(e.groupCount)}`,
      other: () => `${t.number(e.groupCount)} אפשרויות`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", נבחר",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "הצעות",
  selectedAnnouncement: (e) => `${e.optionText}, נבחר`
};
var N2 = {};
N2 = {
  buttonLabel: "Prikaži prijedloge",
  countAnnouncement: (e, t) => `Dostupno još: ${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} opcija`,
    other: () => `${t.number(e.optionCount)} opcije/a`
  })}.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Unesena skupina ${e.groupTitle}, s ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} opcijom`,
      other: () => `${t.number(e.groupCount)} opcije/a`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", odabranih",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Prijedlozi",
  selectedAnnouncement: (e) => `${e.optionText}, odabrano`
};
var R2 = {};
R2 = {
  buttonLabel: "Javaslatok megjelenítése",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} lehetőség`,
    other: () => `${t.number(e.optionCount)} lehetőség`
  })} áll rendelkezésre.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Belépett a(z) ${e.groupTitle} csoportba, amely ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} lehetőséget`,
      other: () => `${t.number(e.groupCount)} lehetőséget`
    })} tartalmaz. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", kijelölve",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Javaslatok",
  selectedAnnouncement: (e) => `${e.optionText}, kijelölve`
};
var B2 = {};
B2 = {
  buttonLabel: "Mostra suggerimenti",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} opzione disponibile`,
    other: () => `${t.number(e.optionCount)} opzioni disponibili`
  })}.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Ingresso nel gruppo ${e.groupTitle}, con ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} opzione`,
      other: () => `${t.number(e.groupCount)} opzioni`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", selezionato",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Suggerimenti",
  selectedAnnouncement: (e) => `${e.optionText}, selezionato`
};
var V2 = {};
V2 = {
  buttonLabel: "候補を表示",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} 個のオプション`,
    other: () => `${t.number(e.optionCount)} 個のオプション`
  })}を利用できます。`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `入力されたグループ ${e.groupTitle}、${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} 個のオプション`,
      other: () => `${t.number(e.groupCount)} 個のオプション`
    })}を含む。`,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: "、選択済み",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "候補",
  selectedAnnouncement: (e) => `${e.optionText}、選択済み`
};
var F2 = {};
F2 = {
  buttonLabel: "제안 사항 표시",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)}개 옵션`,
    other: () => `${t.number(e.optionCount)}개 옵션`
  })}을 사용할 수 있습니다.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `입력한 그룹 ${e.groupTitle}, ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)}개 옵션`,
      other: () => `${t.number(e.groupCount)}개 옵션`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", 선택됨",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "제안",
  selectedAnnouncement: (e) => `${e.optionText}, 선택됨`
};
var H2 = {};
H2 = {
  buttonLabel: "Rodyti pasiūlymus",
  countAnnouncement: (e, t) => `Yra ${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} parinktis`,
    other: () => `${t.number(e.optionCount)} parinktys (-ių)`
  })}.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Įvesta grupė ${e.groupTitle}, su ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} parinktimi`,
      other: () => `${t.number(e.groupCount)} parinktimis (-ių)`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", pasirinkta",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Pasiūlymai",
  selectedAnnouncement: (e) => `${e.optionText}, pasirinkta`
};
var K2 = {};
K2 = {
  buttonLabel: "Rādīt ieteikumus",
  countAnnouncement: (e, t) => `Pieejamo opciju skaits: ${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} opcija`,
    other: () => `${t.number(e.optionCount)} opcijas`
  })}.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Ievadīta grupa ${e.groupTitle}, ar ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} opciju`,
      other: () => `${t.number(e.groupCount)} opcijām`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", atlasīta",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Ieteikumi",
  selectedAnnouncement: (e) => `${e.optionText}, atlasīta`
};
var j2 = {};
j2 = {
  buttonLabel: "Vis forslag",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} alternativ`,
    other: () => `${t.number(e.optionCount)} alternativer`
  })} finnes.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Angitt gruppe ${e.groupTitle}, med ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} alternativ`,
      other: () => `${t.number(e.groupCount)} alternativer`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", valgt",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Forslag",
  selectedAnnouncement: (e) => `${e.optionText}, valgt`
};
var U2 = {};
U2 = {
  buttonLabel: "Suggesties weergeven",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} optie`,
    other: () => `${t.number(e.optionCount)} opties`
  })} beschikbaar.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Groep ${e.groupTitle} ingevoerd met ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} optie`,
      other: () => `${t.number(e.groupCount)} opties`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", geselecteerd",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Suggesties",
  selectedAnnouncement: (e) => `${e.optionText}, geselecteerd`
};
var W2 = {};
W2 = {
  buttonLabel: "Wyświetlaj sugestie",
  countAnnouncement: (e, t) => `dostępna/dostępne(-nych) ${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} opcja`,
    other: () => `${t.number(e.optionCount)} opcje(-i)`
  })}.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Dołączono do grupy ${e.groupTitle}, z ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} opcją`,
      other: () => `${t.number(e.groupCount)} opcjami`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", wybrano",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Sugestie",
  selectedAnnouncement: (e) => `${e.optionText}, wybrano`
};
var q2 = {};
q2 = {
  buttonLabel: "Mostrar sugestões",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} opção`,
    other: () => `${t.number(e.optionCount)} opções`
  })} disponível.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Grupo inserido ${e.groupTitle}, com ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} opção`,
      other: () => `${t.number(e.groupCount)} opções`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", selecionado",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Sugestões",
  selectedAnnouncement: (e) => `${e.optionText}, selecionado`
};
var Z2 = {};
Z2 = {
  buttonLabel: "Apresentar sugestões",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} opção`,
    other: () => `${t.number(e.optionCount)} opções`
  })} disponível.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Grupo introduzido ${e.groupTitle}, com ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} opção`,
      other: () => `${t.number(e.groupCount)} opções`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", selecionado",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Sugestões",
  selectedAnnouncement: (e) => `${e.optionText}, selecionado`
};
var G2 = {};
G2 = {
  buttonLabel: "Afișare sugestii",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} opțiune`,
    other: () => `${t.number(e.optionCount)} opțiuni`
  })} disponibile.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Grup ${e.groupTitle} introdus, cu ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} opțiune`,
      other: () => `${t.number(e.groupCount)} opțiuni`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", selectat",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Sugestii",
  selectedAnnouncement: (e) => `${e.optionText}, selectat`
};
var Y2 = {};
Y2 = {
  buttonLabel: "Показать предложения",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} параметр`,
    other: () => `${t.number(e.optionCount)} параметров`
  })} доступно.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Введенная группа ${e.groupTitle}, с ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} параметром`,
      other: () => `${t.number(e.groupCount)} параметрами`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", выбранными",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Предложения",
  selectedAnnouncement: (e) => `${e.optionText}, выбрано`
};
var X2 = {};
X2 = {
  buttonLabel: "Zobraziť návrhy",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} možnosť`,
    other: () => `${t.number(e.optionCount)} možnosti/-í`
  })} k dispozícii.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Zadaná skupina ${e.groupTitle}, s ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} možnosťou`,
      other: () => `${t.number(e.groupCount)} možnosťami`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", vybraté",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Návrhy",
  selectedAnnouncement: (e) => `${e.optionText}, vybraté`
};
var J2 = {};
J2 = {
  buttonLabel: "Prikaži predloge",
  countAnnouncement: (e, t) => `Na voljo je ${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} opcija`,
    other: () => `${t.number(e.optionCount)} opcije`
  })}.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Vnesena skupina ${e.groupTitle}, z ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} opcija`,
      other: () => `${t.number(e.groupCount)} opcije`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", izbrano",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Predlogi",
  selectedAnnouncement: (e) => `${e.optionText}, izbrano`
};
var Q2 = {};
Q2 = {
  buttonLabel: "Prikaži predloge",
  countAnnouncement: (e, t) => `Dostupno još: ${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} opcija`,
    other: () => `${t.number(e.optionCount)} opcije/a`
  })}.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Unesena grupa ${e.groupTitle}, s ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} opcijom`,
      other: () => `${t.number(e.groupCount)} optione/a`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", izabranih",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Predlozi",
  selectedAnnouncement: (e) => `${e.optionText}, izabrano`
};
var ev = {};
ev = {
  buttonLabel: "Visa förslag",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} alternativ`,
    other: () => `${t.number(e.optionCount)} alternativ`
  })} tillgängliga.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Ingick i gruppen ${e.groupTitle} med ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} alternativ`,
      other: () => `${t.number(e.groupCount)} alternativ`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", valda",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Förslag",
  selectedAnnouncement: (e) => `${e.optionText}, valda`
};
var tv = {};
tv = {
  buttonLabel: "Önerileri göster",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} seçenek`,
    other: () => `${t.number(e.optionCount)} seçenekler`
  })} kullanılabilir.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Girilen grup ${e.groupTitle}, ile ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} seçenek`,
      other: () => `${t.number(e.groupCount)} seçenekler`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", seçildi",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Öneriler",
  selectedAnnouncement: (e) => `${e.optionText}, seçildi`
};
var nv = {};
nv = {
  buttonLabel: "Показати пропозиції",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} параметр`,
    other: () => `${t.number(e.optionCount)} параметри(-ів)`
  })} доступно.`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `Введена група ${e.groupTitle}, з ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} параметр`,
      other: () => `${t.number(e.groupCount)} параметри(-ів)`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", вибрано",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "Пропозиції",
  selectedAnnouncement: (e) => `${e.optionText}, вибрано`
};
var rv = {};
rv = {
  buttonLabel: "显示建议",
  countAnnouncement: (e, t) => `有 ${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} 个选项`,
    other: () => `${t.number(e.optionCount)} 个选项`
  })}可用。`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `进入了 ${e.groupTitle} 组，其中有 ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} 个选项`,
      other: () => `${t.number(e.groupCount)} 个选项`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", 已选择",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "建议",
  selectedAnnouncement: (e) => `${e.optionText}, 已选择`
};
var av = {};
av = {
  buttonLabel: "顯示建議",
  countAnnouncement: (e, t) => `${t.plural(e.optionCount, {
    one: () => `${t.number(e.optionCount)} 選項`,
    other: () => `${t.number(e.optionCount)} 選項`
  })} 可用。`,
  focusAnnouncement: (e, t) => `${t.select({
    true: () => `輸入的群組 ${e.groupTitle}, 有 ${t.plural(e.groupCount, {
      one: () => `${t.number(e.groupCount)} 選項`,
      other: () => `${t.number(e.groupCount)} 選項`
    })}. `,
    other: ""
  }, e.isGroupChange)}${e.optionText}${t.select({
    true: ", 已選取",
    other: ""
  }, e.isSelected)}`,
  listboxLabel: "建議",
  selectedAnnouncement: (e) => `${e.optionText}, 已選取`
};
const $0 = {
  border: 0,
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  margin: "-1px",
  overflow: "hidden",
  padding: 0,
  position: "absolute",
  width: "1px",
  whiteSpace: "nowrap"
};
function k5(e = {}) {
  let { style: t, isFocusable: n } = e, [r, a] = ne(!1), { focusWithinProps: i } = ra({
    isDisabled: !n,
    onFocusWithinChange: (l) => a(l)
  }), o = ge(() => r ? t : t ? {
    ...$0,
    ...t
  } : $0, [
    r
  ]);
  return {
    visuallyHiddenProps: {
      ...i,
      style: o
    }
  };
}
function iv(e) {
  let { children: t, elementType: n = "div", isFocusable: r, style: a, ...i } = e, { visuallyHiddenProps: o } = k5(e);
  return /* @__PURE__ */ oe.createElement(n, Pe(i, o), t);
}
const T5 = /* @__PURE__ */ new WeakMap(), Ht = [];
function A5(e, t) {
  let { onClose: n, shouldCloseOnBlur: r, isOpen: a, isDismissable: i = !1, isKeyboardDismissDisabled: o = !1, shouldCloseOnInteractOutside: l } = e;
  re(() => (a && Ht.push(t), () => {
    let E = Ht.indexOf(t);
    E >= 0 && Ht.splice(E, 1);
  }), [
    a,
    t
  ]);
  let s = () => {
    Ht[Ht.length - 1] === t && n && n();
  }, u = (E) => {
    (!l || l(E.target)) && Ht[Ht.length - 1] === t && (E.stopPropagation(), E.preventDefault());
  }, f = (E) => {
    (!l || l(E.target)) && (Ht[Ht.length - 1] === t && (E.stopPropagation(), E.preventDefault()), s());
  }, h = (E) => {
    E.key === "Escape" && !o && (E.stopPropagation(), E.preventDefault(), s());
  };
  Vb({
    ref: t,
    onInteractOutside: i && a ? f : null,
    onInteractOutsideStart: u
  });
  let { focusWithinProps: g } = ra({
    isDisabled: !r,
    onBlurWithin: (E) => {
      !E.relatedTarget || Gb(E.relatedTarget) || (!l || l(E.relatedTarget)) && n();
    }
  }), v = (E) => {
    E.target === E.currentTarget && E.preventDefault();
  };
  return {
    overlayProps: {
      onKeyDown: h,
      ...g
    },
    underlayProps: {
      onPointerDown: v
    }
  };
}
function O5(e, t, n) {
  let { type: r } = e, { isOpen: a } = t;
  re(() => {
    n && n.current && T5.set(n.current, t.close);
  });
  let i;
  r === "menu" ? i = !0 : r === "listbox" && (i = "listbox");
  let o = Yt();
  return {
    triggerProps: {
      "aria-haspopup": i,
      "aria-expanded": a,
      "aria-controls": a ? o : null,
      onPress: t.toggle
    },
    overlayProps: {
      id: o
    }
  };
}
let Cr = /* @__PURE__ */ new WeakMap(), wt = [];
function z5(e, t = document.body) {
  let n = new Set(e), r = /* @__PURE__ */ new Set(), a = (s) => {
    for (let g of s.querySelectorAll("[data-live-announcer], [data-react-aria-top-layer]"))
      n.add(g);
    let u = (g) => {
      if (n.has(g) || r.has(g.parentElement) && g.parentElement.getAttribute("role") !== "row")
        return NodeFilter.FILTER_REJECT;
      for (let v of n)
        if (g.contains(v))
          return NodeFilter.FILTER_SKIP;
      return NodeFilter.FILTER_ACCEPT;
    }, f = document.createTreeWalker(s, NodeFilter.SHOW_ELEMENT, {
      acceptNode: u
    }), h = u(s);
    if (h === NodeFilter.FILTER_ACCEPT && i(s), h !== NodeFilter.FILTER_REJECT) {
      let g = f.nextNode();
      for (; g != null; )
        i(g), g = f.nextNode();
    }
  }, i = (s) => {
    var u;
    let f = (u = Cr.get(s)) !== null && u !== void 0 ? u : 0;
    s.getAttribute("aria-hidden") === "true" && f === 0 || (f === 0 && s.setAttribute("aria-hidden", "true"), r.add(s), Cr.set(s, f + 1));
  };
  wt.length && wt[wt.length - 1].disconnect(), a(t);
  let o = new MutationObserver((s) => {
    for (let u of s)
      if (!(u.type !== "childList" || u.addedNodes.length === 0) && ![
        ...n,
        ...r
      ].some((f) => f.contains(u.target))) {
        for (let f of u.removedNodes)
          f instanceof Element && (n.delete(f), r.delete(f));
        for (let f of u.addedNodes)
          (f instanceof HTMLElement || f instanceof SVGElement) && (f.dataset.liveAnnouncer === "true" || f.dataset.reactAriaTopLayer === "true") ? n.add(f) : f instanceof Element && a(f);
      }
  });
  o.observe(t, {
    childList: !0,
    subtree: !0
  });
  let l = {
    observe() {
      o.observe(t, {
        childList: !0,
        subtree: !0
      });
    },
    disconnect() {
      o.disconnect();
    }
  };
  return wt.push(l), () => {
    o.disconnect();
    for (let s of r) {
      let u = Cr.get(s);
      u === 1 ? (s.removeAttribute("aria-hidden"), Cr.delete(s)) : Cr.set(s, u - 1);
    }
    l === wt[wt.length - 1] ? (wt.pop(), wt.length && wt[wt.length - 1].observe()) : wt.splice(wt.indexOf(l), 1);
  };
}
function oc(e) {
  return ii() ? e.altKey : e.ctrlKey;
}
function or(e) {
  return hn() ? e.metaKey : e.ctrlKey;
}
const M5 = 1e3;
function _5(e) {
  let { keyboardDelegate: t, selectionManager: n, onTypeSelect: r } = e, a = J({
    search: "",
    timeout: null
  }).current, i = (o) => {
    let l = L5(o.key);
    if (!l || o.ctrlKey || o.metaKey || !o.currentTarget.contains(o.target))
      return;
    l === " " && a.search.trim().length > 0 && (o.preventDefault(), "continuePropagation" in o || o.stopPropagation()), a.search += l;
    let s = t.getKeyForSearch(a.search, n.focusedKey);
    s == null && (s = t.getKeyForSearch(a.search)), s != null && (n.setFocusedKey(s), r && r(s)), clearTimeout(a.timeout), a.timeout = setTimeout(() => {
      a.search = "";
    }, M5);
  };
  return {
    typeSelectProps: {
      // Using a capturing listener to catch the keydown event before
      // other hooks in order to handle the Spacebar event.
      onKeyDownCapture: t.getKeyForSearch ? i : null
    }
  };
}
function L5(e) {
  return e.length === 1 || !/^[A-Z]/i.test(e) ? e : "";
}
function jc(e) {
  let { selectionManager: t, keyboardDelegate: n, ref: r, autoFocus: a = !1, shouldFocusWrap: i = !1, disallowEmptySelection: o = !1, disallowSelectAll: l = !1, selectOnFocus: s = t.selectionBehavior === "replace", disallowTypeAhead: u = !1, shouldUseVirtualFocus: f, allowsTabNavigation: h = !1, isVirtualized: g, scrollRef: v = r, linkBehavior: E = "action" } = e, { direction: b } = ia(), w = Ri(), S = (d) => {
    if (d.altKey && d.key === "Tab" && d.preventDefault(), !r.current.contains(d.target))
      return;
    const m = (k, M) => {
      if (k != null) {
        if (t.isLink(k) && E === "selection" && s && !oc(d)) {
          zc(() => {
            t.setFocusedKey(k, M);
          });
          let F = v.current.querySelector(`[data-key="${CSS.escape(k.toString())}"]`);
          w.open(F, d);
          return;
        }
        if (t.setFocusedKey(k, M), t.isLink(k) && E === "override")
          return;
        d.shiftKey && t.selectionMode === "multiple" ? t.extendSelection(k) : s && !oc(d) && t.replaceSelection(k);
      }
    };
    switch (d.key) {
      case "ArrowDown":
        if (n.getKeyBelow) {
          var O, x;
          d.preventDefault();
          let k = t.focusedKey != null ? n.getKeyBelow(t.focusedKey) : (O = n.getFirstKey) === null || O === void 0 ? void 0 : O.call(n);
          k == null && i && (k = (x = n.getFirstKey) === null || x === void 0 ? void 0 : x.call(n, t.focusedKey)), m(k);
        }
        break;
      case "ArrowUp":
        if (n.getKeyAbove) {
          var P, N;
          d.preventDefault();
          let k = t.focusedKey != null ? n.getKeyAbove(t.focusedKey) : (P = n.getLastKey) === null || P === void 0 ? void 0 : P.call(n);
          k == null && i && (k = (N = n.getLastKey) === null || N === void 0 ? void 0 : N.call(n, t.focusedKey)), m(k);
        }
        break;
      case "ArrowLeft":
        if (n.getKeyLeftOf) {
          var D, I;
          d.preventDefault();
          let k = n.getKeyLeftOf(t.focusedKey);
          k == null && i && (k = b === "rtl" ? (D = n.getFirstKey) === null || D === void 0 ? void 0 : D.call(n, t.focusedKey) : (I = n.getLastKey) === null || I === void 0 ? void 0 : I.call(n, t.focusedKey)), m(k, b === "rtl" ? "first" : "last");
        }
        break;
      case "ArrowRight":
        if (n.getKeyRightOf) {
          var C, L;
          d.preventDefault();
          let k = n.getKeyRightOf(t.focusedKey);
          k == null && i && (k = b === "rtl" ? (C = n.getLastKey) === null || C === void 0 ? void 0 : C.call(n, t.focusedKey) : (L = n.getFirstKey) === null || L === void 0 ? void 0 : L.call(n, t.focusedKey)), m(k, b === "rtl" ? "last" : "first");
        }
        break;
      case "Home":
        if (n.getFirstKey) {
          d.preventDefault();
          let k = n.getFirstKey(t.focusedKey, or(d));
          t.setFocusedKey(k), or(d) && d.shiftKey && t.selectionMode === "multiple" ? t.extendSelection(k) : s && t.replaceSelection(k);
        }
        break;
      case "End":
        if (n.getLastKey) {
          d.preventDefault();
          let k = n.getLastKey(t.focusedKey, or(d));
          t.setFocusedKey(k), or(d) && d.shiftKey && t.selectionMode === "multiple" ? t.extendSelection(k) : s && t.replaceSelection(k);
        }
        break;
      case "PageDown":
        if (n.getKeyPageBelow) {
          d.preventDefault();
          let k = n.getKeyPageBelow(t.focusedKey);
          m(k);
        }
        break;
      case "PageUp":
        if (n.getKeyPageAbove) {
          d.preventDefault();
          let k = n.getKeyPageAbove(t.focusedKey);
          m(k);
        }
        break;
      case "a":
        or(d) && t.selectionMode === "multiple" && l !== !0 && (d.preventDefault(), t.selectAll());
        break;
      case "Escape":
        d.preventDefault(), o || t.clearSelection();
        break;
      case "Tab":
        if (!h) {
          if (d.shiftKey)
            r.current.focus();
          else {
            let k = Vc(r.current, {
              tabbable: !0
            }), M, F;
            do
              F = k.lastChild(), F && (M = F);
            while (F);
            M && !M.contains(document.activeElement) && qt(M);
          }
          break;
        }
    }
  }, T = J({
    top: 0,
    left: 0
  });
  mb(v, "scroll", g ? null : () => {
    T.current = {
      top: v.current.scrollTop,
      left: v.current.scrollLeft
    };
  });
  let A = (d) => {
    if (t.isFocused) {
      d.currentTarget.contains(d.target) || t.setFocused(!1);
      return;
    }
    if (d.currentTarget.contains(d.target)) {
      if (t.setFocused(!0), t.focusedKey == null) {
        let x = (N) => {
          N != null && (t.setFocusedKey(N), s && t.replaceSelection(N));
        }, P = d.relatedTarget;
        var m, O;
        P && d.currentTarget.compareDocumentPosition(P) & Node.DOCUMENT_POSITION_FOLLOWING ? x((m = t.lastSelectedKey) !== null && m !== void 0 ? m : n.getLastKey()) : x((O = t.firstSelectedKey) !== null && O !== void 0 ? O : n.getFirstKey());
      } else
        g || (v.current.scrollTop = T.current.top, v.current.scrollLeft = T.current.left);
      if (!g && t.focusedKey != null) {
        let x = v.current.querySelector(`[data-key="${CSS.escape(t.focusedKey.toString())}"]`);
        x && (x.contains(document.activeElement) || qt(x), tc() === "keyboard" && o0(x, {
          containingElement: r.current
        }));
      }
    }
  }, V = (d) => {
    d.currentTarget.contains(d.relatedTarget) || t.setFocused(!1);
  };
  const $ = J(a);
  re(() => {
    if ($.current) {
      let d = null;
      a === "first" && (d = n.getFirstKey()), a === "last" && (d = n.getLastKey());
      let m = t.selectedKeys;
      if (m.size) {
        for (let O of m)
          if (t.canSelectItem(O)) {
            d = O;
            break;
          }
      }
      t.setFocused(!0), t.setFocusedKey(d), d == null && !f && yi(r.current);
    }
  }, []);
  let _ = J(t.focusedKey);
  re(() => {
    let d = tc();
    if (t.isFocused && t.focusedKey != null && (v != null && v.current)) {
      let m = v.current.querySelector(`[data-key="${CSS.escape(t.focusedKey.toString())}"]`);
      m && (d === "keyboard" || $.current) && (g || o2(v.current, m), o0(m, {
        containingElement: r.current
      }));
    }
    t.isFocused && t.focusedKey == null && _.current != null && yi(r.current), _.current = t.focusedKey, $.current = !1;
  }, [
    g,
    v,
    t.focusedKey,
    t.isFocused,
    r
  ]);
  let y = {
    onKeyDown: S,
    onFocus: A,
    onBlur: V,
    onMouseDown(d) {
      v.current === d.target && d.preventDefault();
    }
  }, { typeSelectProps: c } = _5({
    keyboardDelegate: n,
    selectionManager: t
  });
  u || (y = Pe(c, y));
  let p;
  return f || (p = t.focusedKey == null ? 0 : -1), {
    collectionProps: {
      ...y,
      tabIndex: p
    }
  };
}
function ov(e) {
  let { selectionManager: t, key: n, ref: r, shouldSelectOnPressUp: a, shouldUseVirtualFocus: i, focus: o, isDisabled: l, onAction: s, allowsDifferentPressOrigin: u, linkBehavior: f = "action" } = e, h = Ri(), g = (I) => {
    if (I.pointerType === "keyboard" && oc(I))
      t.toggleSelection(n);
    else {
      if (t.selectionMode === "none")
        return;
      if (t.isLink(n)) {
        if (f === "selection") {
          h.open(r.current, I), t.setSelectedKeys(t.selectedKeys);
          return;
        } else if (f === "override" || f === "none")
          return;
      }
      t.selectionMode === "single" ? t.isSelected(n) && !t.disallowEmptySelection ? t.toggleSelection(n) : t.replaceSelection(n) : I && I.shiftKey ? t.extendSelection(n) : t.selectionBehavior === "toggle" || I && (or(I) || I.pointerType === "touch" || I.pointerType === "virtual") ? t.toggleSelection(n) : t.replaceSelection(n);
    }
  };
  re(() => {
    n === t.focusedKey && t.isFocused && !i && (o ? o() : document.activeElement !== r.current && yi(r.current));
  }, [
    r,
    n,
    t.focusedKey,
    t.childFocusStrategy,
    t.isFocused,
    i
  ]), l = l || t.isDisabled(n);
  let v = {};
  !i && !l ? v = {
    tabIndex: n === t.focusedKey ? 0 : -1,
    onFocus(I) {
      I.target === r.current && t.setFocusedKey(n);
    }
  } : l && (v.onMouseDown = (I) => {
    I.preventDefault();
  });
  let E = t.isLink(n) && f === "override", b = t.isLink(n) && f !== "selection" && f !== "none", w = !l && t.canSelectItem(n) && !E, S = (s || b) && !l, T = S && (t.selectionBehavior === "replace" ? !w : !w || t.isEmpty), A = S && w && t.selectionBehavior === "replace", V = T || A, $ = J(null), _ = V && w, y = J(!1), c = J(!1), p = (I) => {
    s && s(), b && h.open(r.current, I);
  }, d = {};
  a ? (d.onPressStart = (I) => {
    $.current = I.pointerType, y.current = _, I.pointerType === "keyboard" && (!V || C0()) && g(I);
  }, u ? (d.onPressUp = T ? null : (I) => {
    I.pointerType !== "keyboard" && w && g(I);
  }, d.onPress = T ? p : null) : d.onPress = (I) => {
    if (T || A && I.pointerType !== "mouse") {
      if (I.pointerType === "keyboard" && !P0())
        return;
      p(I);
    } else
      I.pointerType !== "keyboard" && w && g(I);
  }) : (d.onPressStart = (I) => {
    $.current = I.pointerType, y.current = _, c.current = T, w && (I.pointerType === "mouse" && !T || I.pointerType === "keyboard" && (!S || C0())) && g(I);
  }, d.onPress = (I) => {
    (I.pointerType === "touch" || I.pointerType === "pen" || I.pointerType === "virtual" || I.pointerType === "keyboard" && V && P0() || I.pointerType === "mouse" && c.current) && (V ? p(I) : w && g(I));
  }), v["data-key"] = n, d.preventFocusOnPress = i;
  let { pressProps: m, isPressed: O } = vn(d), x = A ? (I) => {
    $.current === "mouse" && (I.stopPropagation(), I.preventDefault(), p(I));
  } : void 0, { longPressProps: P } = f2({
    isDisabled: !_,
    onLongPress(I) {
      I.pointerType === "touch" && (g(I), t.setSelectionBehavior("toggle"));
    }
  }), N = (I) => {
    $.current === "touch" && y.current && I.preventDefault();
  }, D = t.isLink(n) ? (I) => {
    Ln.isOpening || I.preventDefault();
  } : void 0;
  return {
    itemProps: Pe(v, w || T ? m : {}, _ ? P : {}, {
      onDoubleClick: x,
      onDragStartCapture: N,
      onClick: D
    }),
    isPressed: O,
    isSelected: t.isSelected(n),
    isFocused: t.isFocused && t.focusedKey === n,
    isDisabled: l,
    allowsSelection: w,
    hasAction: V
  };
}
function P0() {
  let e = window.event;
  return (e == null ? void 0 : e.key) === "Enter";
}
function C0() {
  let e = window.event;
  return (e == null ? void 0 : e.key) === " " || (e == null ? void 0 : e.code) === "Space";
}
class lv {
  getNextKey(t) {
    for (t = this.collection.getKeyAfter(t); t != null; ) {
      if (this.collection.getItem(t).type === "item" && !this.disabledKeys.has(t))
        return t;
      t = this.collection.getKeyAfter(t);
    }
    return null;
  }
  getPreviousKey(t) {
    for (t = this.collection.getKeyBefore(t); t != null; ) {
      if (this.collection.getItem(t).type === "item" && !this.disabledKeys.has(t))
        return t;
      t = this.collection.getKeyBefore(t);
    }
    return null;
  }
  findKey(t, n, r) {
    let a = this.getItem(t);
    if (!a)
      return null;
    let i = a.getBoundingClientRect();
    do
      t = n(t), a = this.getItem(t);
    while (a && r(i, a.getBoundingClientRect()));
    return t;
  }
  isSameRow(t, n) {
    return t.top === n.top || t.left !== n.left;
  }
  isSameColumn(t, n) {
    return t.left === n.left || t.top !== n.top;
  }
  getKeyBelow(t) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(t, (n) => this.getNextKey(n), this.isSameRow) : this.getNextKey(t);
  }
  getKeyAbove(t) {
    return this.layout === "grid" && this.orientation === "vertical" ? this.findKey(t, (n) => this.getPreviousKey(n), this.isSameRow) : this.getPreviousKey(t);
  }
  getNextColumn(t, n) {
    return n ? this.getPreviousKey(t) : this.getNextKey(t);
  }
  getKeyRightOf(t) {
    return this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(t, this.direction === "rtl") : this.findKey(t, (n) => this.getNextColumn(n, this.direction === "rtl"), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(t, this.direction === "rtl") : null;
  }
  getKeyLeftOf(t) {
    return this.layout === "grid" ? this.orientation === "vertical" ? this.getNextColumn(t, this.direction === "ltr") : this.findKey(t, (n) => this.getNextColumn(n, this.direction === "ltr"), this.isSameColumn) : this.orientation === "horizontal" ? this.getNextColumn(t, this.direction === "ltr") : null;
  }
  getFirstKey() {
    let t = this.collection.getFirstKey();
    for (; t != null; ) {
      if (this.collection.getItem(t).type === "item" && !this.disabledKeys.has(t))
        return t;
      t = this.collection.getKeyAfter(t);
    }
    return null;
  }
  getLastKey() {
    let t = this.collection.getLastKey();
    for (; t != null; ) {
      if (this.collection.getItem(t).type === "item" && !this.disabledKeys.has(t))
        return t;
      t = this.collection.getKeyBefore(t);
    }
    return null;
  }
  getItem(t) {
    return this.ref.current.querySelector(`[data-key="${CSS.escape(t.toString())}"]`);
  }
  getKeyPageAbove(t) {
    let n = this.ref.current, r = this.getItem(t);
    if (!r)
      return null;
    if (!vi(n))
      return this.getFirstKey();
    let a = n.getBoundingClientRect(), i = r.getBoundingClientRect();
    if (this.orientation === "horizontal") {
      let o = a.x - n.scrollLeft, l = Math.max(0, i.x - o + i.width - a.width);
      for (; r && i.x - o > l; )
        t = this.getKeyAbove(t), r = t == null ? null : this.getItem(t), i = r == null ? void 0 : r.getBoundingClientRect();
    } else {
      let o = a.y - n.scrollTop, l = Math.max(0, i.y - o + i.height - a.height);
      for (; r && i.y - o > l; )
        t = this.getKeyAbove(t), r = t == null ? null : this.getItem(t), i = r == null ? void 0 : r.getBoundingClientRect();
    }
    return t ?? this.getFirstKey();
  }
  getKeyPageBelow(t) {
    let n = this.ref.current, r = this.getItem(t);
    if (!r)
      return null;
    if (!vi(n))
      return this.getLastKey();
    let a = n.getBoundingClientRect(), i = r.getBoundingClientRect();
    if (this.orientation === "horizontal") {
      let o = a.x - n.scrollLeft, l = Math.min(n.scrollWidth, i.x - o - i.width + a.width);
      for (; r && i.x - o < l; )
        t = this.getKeyBelow(t), r = t == null ? null : this.getItem(t), i = r == null ? void 0 : r.getBoundingClientRect();
    } else {
      let o = a.y - n.scrollTop, l = Math.min(n.scrollHeight, i.y - o - i.height + a.height);
      for (; r && i.y - o < l; )
        t = this.getKeyBelow(t), r = t == null ? null : this.getItem(t), i = r == null ? void 0 : r.getBoundingClientRect();
    }
    return t ?? this.getLastKey();
  }
  getKeyForSearch(t, n) {
    if (!this.collator)
      return null;
    let r = this.collection, a = n || this.getFirstKey();
    for (; a != null; ) {
      let i = r.getItem(a), o = i.textValue.slice(0, t.length);
      if (i.textValue && this.collator.compare(o, t) === 0)
        return a;
      a = this.getKeyBelow(a);
    }
    return null;
  }
  constructor(...t) {
    if (t.length === 1) {
      let n = t[0];
      this.collection = n.collection, this.ref = n.ref, this.collator = n.collator, this.disabledKeys = n.disabledKeys || /* @__PURE__ */ new Set(), this.orientation = n.orientation, this.direction = n.direction, this.layout = n.layout || "stack";
    } else
      this.collection = t[0], this.disabledKeys = t[1], this.ref = t[2], this.collator = t[3], this.layout = "stack", this.orientation = "vertical";
    this.layout === "stack" && this.orientation === "vertical" && (this.getKeyLeftOf = void 0, this.getKeyRightOf = void 0);
  }
}
function I5(e) {
  let { selectionManager: t, collection: n, disabledKeys: r, ref: a, keyboardDelegate: i } = e, o = m2({
    usage: "search",
    sensitivity: "base"
  }), l = t.disabledBehavior, s = ge(() => i || new lv(n, l === "selection" ? /* @__PURE__ */ new Set() : r, a, o), [
    i,
    n,
    r,
    a,
    o,
    l
  ]), { collectionProps: u } = jc({
    ...e,
    ref: a,
    selectionManager: t,
    keyboardDelegate: s
  });
  return {
    listProps: u
  };
}
function sv(e) {
  return null;
}
sv.getCollectionNode = function* (t, n) {
  let { childItems: r, title: a, children: i } = t, o = t.title || t.children, l = t.textValue || (typeof o == "string" ? o : "") || t["aria-label"] || "";
  !l && !(n != null && n.suppressTextValueWarning) && console.warn("<Item> with non-plain text contents is unsupported by type to select for accessibility. Please add a `textValue` prop."), yield {
    type: "item",
    props: t,
    rendered: o,
    textValue: l,
    "aria-label": t["aria-label"],
    hasChildNodes: D5(t),
    *childNodes() {
      if (r)
        for (let s of r)
          yield {
            type: "item",
            value: s
          };
      else if (a) {
        let s = [];
        oe.Children.forEach(i, (u) => {
          s.push({
            type: "item",
            element: u
          });
        }), yield* s;
      }
    }
  };
};
function D5(e) {
  return e.hasChildItems != null ? e.hasChildItems : !!(e.childItems || e.title && oe.Children.count(e.children) > 0);
}
let N5 = sv;
class R5 {
  build(t, n) {
    return this.context = n, S0(() => this.iterateCollection(t));
  }
  *iterateCollection(t) {
    let { children: n, items: r } = t;
    if (typeof n == "function") {
      if (!r)
        throw new Error("props.children was a function but props.items is missing");
      for (let a of t.items)
        yield* this.getFullNode({
          value: a
        }, {
          renderer: n
        });
    } else {
      let a = [];
      oe.Children.forEach(n, (o) => {
        a.push(o);
      });
      let i = 0;
      for (let o of a) {
        let l = this.getFullNode({
          element: o,
          index: i
        }, {});
        for (let s of l)
          i++, yield s;
      }
    }
  }
  getKey(t, n, r, a) {
    if (t.key != null)
      return t.key;
    if (n.type === "cell" && n.key != null)
      return `${a}${n.key}`;
    let i = n.value;
    if (i != null) {
      var o;
      let l = (o = i.key) !== null && o !== void 0 ? o : i.id;
      if (l == null)
        throw new Error("No key found for item");
      return l;
    }
    return a ? `${a}.${n.index}` : `$.${n.index}`;
  }
  getChildState(t, n) {
    return {
      renderer: n.renderer || t.renderer
    };
  }
  *getFullNode(t, n, r, a) {
    let i = t.element;
    if (!i && t.value && n && n.renderer) {
      let s = this.cache.get(t.value);
      if (s && (!s.shouldInvalidate || !s.shouldInvalidate(this.context))) {
        s.index = t.index, s.parentKey = a ? a.key : null, yield s;
        return;
      }
      i = n.renderer(t.value);
    }
    if (oe.isValidElement(i)) {
      let s = i.type;
      if (typeof s != "function" && typeof s.getCollectionNode != "function") {
        let g = typeof i.type == "function" ? i.type.name : i.type;
        throw new Error(`Unknown element <${g}> in collection.`);
      }
      let u = s.getCollectionNode(i.props, this.context), f = t.index, h = u.next();
      for (; !h.done && h.value; ) {
        let g = h.value;
        t.index = f;
        let v = g.key;
        v || (v = g.element ? null : this.getKey(i, t, n, r));
        let b = [
          ...this.getFullNode({
            ...g,
            key: v,
            index: f,
            wrapper: B5(t.wrapper, g.wrapper)
          }, this.getChildState(n, g), r ? `${r}${i.key}` : i.key, a)
        ];
        for (let w of b) {
          if (w.value = g.value || t.value, w.value && this.cache.set(w.value, w), t.type && w.type !== t.type)
            throw new Error(`Unsupported type <${Io(w.type)}> in <${Io(a.type)}>. Only <${Io(t.type)}> is supported.`);
          f++, yield w;
        }
        h = u.next(b);
      }
      return;
    }
    if (t.key == null)
      return;
    let o = this, l = {
      type: t.type,
      props: t.props,
      key: t.key,
      parentKey: a ? a.key : null,
      value: t.value,
      level: a ? a.level + 1 : 0,
      index: t.index,
      rendered: t.rendered,
      textValue: t.textValue,
      "aria-label": t["aria-label"],
      wrapper: t.wrapper,
      shouldInvalidate: t.shouldInvalidate,
      hasChildNodes: t.hasChildNodes,
      childNodes: S0(function* () {
        if (!t.hasChildNodes)
          return;
        let s = 0;
        for (let u of t.childNodes()) {
          u.key != null && (u.key = `${l.key}${u.key}`), u.index = s;
          let f = o.getFullNode(u, o.getChildState(n, u), l.key, l);
          for (let h of f)
            s++, yield h;
        }
      })
    };
    yield l;
  }
  constructor() {
    this.cache = /* @__PURE__ */ new WeakMap();
  }
}
function S0(e) {
  let t = [], n = null;
  return {
    *[Symbol.iterator]() {
      for (let r of t)
        yield r;
      n || (n = e());
      for (let r of n)
        t.push(r), yield r;
    }
  };
}
function B5(e, t) {
  if (e && t)
    return (n) => e(t(n));
  if (e)
    return e;
  if (t)
    return t;
}
function Io(e) {
  return e[0].toUpperCase() + e.slice(1);
}
function V5(e, t, n) {
  let r = ge(() => new R5(), []), { children: a, items: i, collection: o } = e;
  return ge(() => {
    if (o)
      return o;
    let s = r.build({
      children: a,
      items: i
    }, n);
    return t(s);
  }, [
    r,
    a,
    i,
    o,
    n,
    t
  ]);
}
function Ki(e, t) {
  return typeof t.getChildren == "function" ? t.getChildren(e.key) : e.childNodes;
}
function F5(e) {
  return H5(e, 0);
}
function H5(e, t) {
  if (t < 0)
    return;
  let n = 0;
  for (let r of e) {
    if (n === t)
      return r;
    n++;
  }
}
function Do(e, t, n) {
  if (t.parentKey === n.parentKey)
    return t.index - n.index;
  let r = [
    ...k0(e, t),
    t
  ], a = [
    ...k0(e, n),
    n
  ], i = r.slice(0, a.length).findIndex((o, l) => o !== a[l]);
  return i !== -1 ? (t = r[i], n = a[i], t.index - n.index) : r.findIndex((o) => o === n) >= 0 ? 1 : (a.findIndex((o) => o === t) >= 0, -1);
}
function k0(e, t) {
  let n = [];
  for (; (t == null ? void 0 : t.parentKey) != null; )
    t = e.getItem(t.parentKey), n.unshift(t);
  return n;
}
const T0 = /* @__PURE__ */ new WeakMap();
function cv(e) {
  let t = T0.get(e);
  if (t != null)
    return t;
  t = 0;
  let n = (r) => {
    for (let a of r)
      a.type === "section" ? n(Ki(a, e)) : t++;
  };
  return n(e), T0.set(e, t), t;
}
const ji = /* @__PURE__ */ new WeakMap();
function K5(e) {
  return typeof e == "string" ? e.replace(/\s*/g, "") : "" + e;
}
function uv(e, t) {
  let n = ji.get(e);
  if (!n)
    throw new Error("Unknown list");
  return `${n.id}-option-${K5(t)}`;
}
function j5(e, t, n) {
  let r = Bt(e, {
    labelable: !0
  }), a = e.selectionBehavior || "toggle", i = e.linkBehavior || (a === "replace" ? "action" : "override");
  a === "toggle" && i === "action" && (i = "override");
  let { listProps: o } = I5({
    ...e,
    ref: n,
    selectionManager: t.selectionManager,
    collection: t.collection,
    disabledKeys: t.disabledKeys,
    linkBehavior: i
  }), { focusWithinProps: l } = ra({
    onFocusWithin: e.onFocus,
    onBlurWithin: e.onBlur,
    onFocusWithinChange: e.onFocusChange
  }), s = Yt(e.id);
  ji.set(t, {
    id: s,
    shouldUseVirtualFocus: e.shouldUseVirtualFocus,
    shouldSelectOnPressUp: e.shouldSelectOnPressUp,
    shouldFocusOnHover: e.shouldFocusOnHover,
    isVirtualized: e.isVirtualized,
    onAction: e.onAction,
    linkBehavior: i
  });
  let { labelProps: u, fieldProps: f } = E2({
    ...e,
    id: s,
    // listbox is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span"
  });
  return {
    labelProps: u,
    listBoxProps: Pe(r, l, t.selectionManager.selectionMode === "multiple" ? {
      "aria-multiselectable": "true"
    } : {}, {
      role: "listbox",
      ...Pe(f, o)
    })
  };
}
function U5(e, t, n) {
  var r;
  let { key: a } = e, i = ji.get(t);
  var o;
  let l = (o = e.isDisabled) !== null && o !== void 0 ? o : t.disabledKeys.has(a);
  var s;
  let u = (s = e.isSelected) !== null && s !== void 0 ? s : t.selectionManager.isSelected(a);
  var f;
  let h = (f = e.shouldSelectOnPressUp) !== null && f !== void 0 ? f : i == null ? void 0 : i.shouldSelectOnPressUp;
  var g;
  let v = (g = e.shouldFocusOnHover) !== null && g !== void 0 ? g : i == null ? void 0 : i.shouldFocusOnHover;
  var E;
  let b = (E = e.shouldUseVirtualFocus) !== null && E !== void 0 ? E : i == null ? void 0 : i.shouldUseVirtualFocus;
  var w;
  let S = (w = e.isVirtualized) !== null && w !== void 0 ? w : i == null ? void 0 : i.isVirtualized, T = hi(), A = hi(), V = {
    role: "option",
    "aria-disabled": l || void 0,
    "aria-selected": t.selectionManager.selectionMode !== "none" ? u : void 0
  };
  hn() && t2() || (V["aria-label"] = e["aria-label"], V["aria-labelledby"] = T, V["aria-describedby"] = A);
  let $ = t.collection.getItem(a);
  if (S) {
    let x = Number($ == null ? void 0 : $.index);
    V["aria-posinset"] = Number.isNaN(x) ? void 0 : x + 1, V["aria-setsize"] = cv(t.collection);
  }
  let { itemProps: _, isPressed: y, isFocused: c, hasAction: p, allowsSelection: d } = ov({
    selectionManager: t.selectionManager,
    key: a,
    ref: n,
    shouldSelectOnPressUp: h,
    allowsDifferentPressOrigin: h && v,
    isVirtualized: S,
    shouldUseVirtualFocus: b,
    isDisabled: l,
    onAction: i != null && i.onAction ? () => {
      var x;
      return i == null || (x = i.onAction) === null || x === void 0 ? void 0 : x.call(i, a);
    } : void 0,
    linkBehavior: i == null ? void 0 : i.linkBehavior
  }), { hoverProps: m } = Bb({
    isDisabled: l || !v,
    onHoverStart() {
      mi() || (t.selectionManager.setFocused(!0), t.selectionManager.setFocusedKey(a));
    }
  }), O = Bt($ == null ? void 0 : $.props, {
    isLink: !!(!($ == null || (r = $.props) === null || r === void 0) && r.href)
  });
  return delete O.id, {
    optionProps: {
      ...V,
      ...Pe(O, _, m),
      id: uv(t, a)
    },
    labelProps: {
      id: T
    },
    descriptionProps: {
      id: A
    },
    isFocused: c,
    isFocusVisible: c && mi(),
    isSelected: u,
    isDisabled: l,
    isPressed: y,
    allowsSelection: d,
    hasAction: p
  };
}
var dv = {};
dv = {
  longPressMessage: "اضغط مطولاً أو اضغط على Alt + السهم لأسفل لفتح القائمة"
};
var fv = {};
fv = {
  longPressMessage: "Натиснете продължително или натиснете Alt+ стрелка надолу, за да отворите менюто"
};
var pv = {};
pv = {
  longPressMessage: "Dlouhým stiskem nebo stisknutím kláves Alt + šipka dolů otevřete nabídku"
};
var hv = {};
hv = {
  longPressMessage: "Langt tryk eller tryk på Alt + pil ned for at åbne menuen"
};
var vv = {};
vv = {
  longPressMessage: "Drücken Sie lange oder drücken Sie Alt + Nach-unten, um das Menü zu öffnen"
};
var mv = {};
mv = {
  longPressMessage: "Πιέστε παρατεταμένα ή πατήστε Alt + κάτω βέλος για να ανοίξετε το μενού"
};
var gv = {};
gv = {
  longPressMessage: "Long press or press Alt + ArrowDown to open menu"
};
var yv = {};
yv = {
  longPressMessage: "Mantenga pulsado o pulse Alt + flecha abajo para abrir el menú"
};
var bv = {};
bv = {
  longPressMessage: "Menüü avamiseks vajutage pikalt või vajutage klahve Alt + allanool"
};
var wv = {};
wv = {
  longPressMessage: "Avaa valikko painamalla pohjassa tai näppäinyhdistelmällä Alt + Alanuoli"
};
var xv = {};
xv = {
  longPressMessage: "Appuyez de manière prolongée ou appuyez sur Alt + Flèche vers le bas pour ouvrir le menu."
};
var Ev = {};
Ev = {
  longPressMessage: "לחץ לחיצה ארוכה או הקש Alt + ArrowDown כדי לפתוח את התפריט"
};
var $v = {};
$v = {
  longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dolje za otvaranje izbornika"
};
var Pv = {};
Pv = {
  longPressMessage: "Nyomja meg hosszan, vagy nyomja meg az Alt + lefele nyíl gombot a menü megnyitásához"
};
var Cv = {};
Cv = {
  longPressMessage: "Premere a lungo o premere Alt + Freccia giù per aprire il menu"
};
var Sv = {};
Sv = {
  longPressMessage: "長押しまたは Alt+下矢印キーでメニューを開く"
};
var kv = {};
kv = {
  longPressMessage: "길게 누르거나 Alt + 아래쪽 화살표를 눌러 메뉴 열기"
};
var Tv = {};
Tv = {
  longPressMessage: "Norėdami atidaryti meniu, nuspaudę palaikykite arba paspauskite „Alt + ArrowDown“."
};
var Av = {};
Av = {
  longPressMessage: "Lai atvērtu izvēlni, turiet nospiestu vai nospiediet taustiņu kombināciju Alt + lejupvērstā bultiņa"
};
var Ov = {};
Ov = {
  longPressMessage: "Langt trykk eller trykk Alt + PilNed for å åpne menyen"
};
var zv = {};
zv = {
  longPressMessage: "Druk lang op Alt + pijl-omlaag of druk op Alt om het menu te openen"
};
var Mv = {};
Mv = {
  longPressMessage: "Naciśnij i przytrzymaj lub naciśnij klawisze Alt + Strzałka w dół, aby otworzyć menu"
};
var _v = {};
_v = {
  longPressMessage: "Pressione e segure ou pressione Alt + Seta para baixo para abrir o menu"
};
var Lv = {};
Lv = {
  longPressMessage: "Prima continuamente ou prima Alt + Seta Para Baixo para abrir o menu"
};
var Iv = {};
Iv = {
  longPressMessage: "Apăsați lung sau apăsați pe Alt + săgeată în jos pentru a deschide meniul"
};
var Dv = {};
Dv = {
  longPressMessage: "Нажмите и удерживайте или нажмите Alt + Стрелка вниз, чтобы открыть меню"
};
var Nv = {};
Nv = {
  longPressMessage: "Ponuku otvoríte dlhým stlačením alebo stlačením klávesu Alt + klávesu so šípkou nadol"
};
var Rv = {};
Rv = {
  longPressMessage: "Za odprtje menija pritisnite in držite gumb ali pritisnite Alt+puščica navzdol"
};
var Bv = {};
Bv = {
  longPressMessage: "Dugo pritisnite ili pritisnite Alt + strelicu prema dole da otvorite meni"
};
var Vv = {};
Vv = {
  longPressMessage: "Håll nedtryckt eller tryck på Alt + pil nedåt för att öppna menyn"
};
var Fv = {};
Fv = {
  longPressMessage: "Menüyü açmak için uzun basın veya Alt + Aşağı Ok tuşuna basın"
};
var Hv = {};
Hv = {
  longPressMessage: "Довго або звичайно натисніть комбінацію клавіш Alt і стрілка вниз, щоб відкрити меню"
};
var Kv = {};
Kv = {
  longPressMessage: "长按或按 Alt + 向下方向键以打开菜单"
};
var jv = {};
jv = {
  longPressMessage: "長按或按 Alt+向下鍵以開啟功能表"
};
function W5(e) {
  return e && e.__esModule ? e.default : e;
}
var Uv = {};
Uv = {
  "ar-AE": dv,
  "bg-BG": fv,
  "cs-CZ": pv,
  "da-DK": hv,
  "de-DE": vv,
  "el-GR": mv,
  "en-US": gv,
  "es-ES": yv,
  "et-EE": bv,
  "fi-FI": wv,
  "fr-FR": xv,
  "he-IL": Ev,
  "hr-HR": $v,
  "hu-HU": Pv,
  "it-IT": Cv,
  "ja-JP": Sv,
  "ko-KR": kv,
  "lt-LT": Tv,
  "lv-LV": Av,
  "nb-NO": Ov,
  "nl-NL": zv,
  "pl-PL": Mv,
  "pt-BR": _v,
  "pt-PT": Lv,
  "ro-RO": Iv,
  "ru-RU": Dv,
  "sk-SK": Nv,
  "sl-SI": Rv,
  "sr-SP": Bv,
  "sv-SE": Vv,
  "tr-TR": Fv,
  "uk-UA": Hv,
  "zh-CN": Kv,
  "zh-TW": jv
};
function q5(e, t, n) {
  let { type: r = "menu", isDisabled: a, trigger: i = "press" } = e, o = Yt(), { triggerProps: l, overlayProps: s } = O5({
    type: r
  }, t, n), u = (v) => {
    if (!a && !(i === "longPress" && !v.altKey) && n && n.current)
      switch (v.key) {
        case "Enter":
        case " ":
          if (i === "longPress")
            return;
        case "ArrowDown":
          "continuePropagation" in v || v.stopPropagation(), v.preventDefault(), t.toggle("first");
          break;
        case "ArrowUp":
          "continuePropagation" in v || v.stopPropagation(), v.preventDefault(), t.toggle("last");
          break;
        default:
          "continuePropagation" in v && v.continuePropagation();
      }
  }, f = Hc(/* @__PURE__ */ W5(Uv), "@react-aria/menu"), { longPressProps: h } = f2({
    isDisabled: a || i !== "longPress",
    accessibilityDescription: f.format("longPressMessage"),
    onLongPressStart() {
      t.close();
    },
    onLongPress() {
      t.open("first");
    }
  }), g = {
    onPressStart(v) {
      v.pointerType !== "touch" && v.pointerType !== "keyboard" && !a && t.toggle(v.pointerType === "virtual" ? "first" : null);
    },
    onPress(v) {
      v.pointerType === "touch" && !a && t.toggle();
    }
  };
  return delete l.onPress, {
    menuTriggerProps: {
      ...l,
      ...i === "press" ? g : h,
      id: o,
      onKeyDown: u
    },
    menuProps: {
      ...s,
      "aria-labelledby": o,
      autoFocus: t.focusStrategy || !0,
      onClose: t.close
    }
  };
}
function Uc(e, t) {
  let { inputElementType: n = "input", isDisabled: r = !1, isRequired: a = !1, isReadOnly: i = !1, type: o = "text", validationBehavior: l = "aria" } = e, [s, u] = Bn(e.value, e.defaultValue || "", e.onChange), { focusableProps: f } = aa(e, t), h = Hi({
    ...e,
    value: s
  }), { isInvalid: g, validationErrors: v, validationDetails: E } = h.displayValidation, { labelProps: b, fieldProps: w, descriptionProps: S, errorMessageProps: T } = $2({
    ...e,
    isInvalid: g,
    errorMessage: e.errorMessage || v
  }), A = Bt(e, {
    labelable: !0
  });
  const V = {
    type: o,
    pattern: e.pattern
  };
  return Dc(t, s, u), Kc(e, h, t), re(() => {
    if (t.current instanceof Yr(t.current).HTMLTextAreaElement) {
      let $ = t.current;
      Object.defineProperty($, "defaultValue", {
        get: () => $.value,
        set: () => {
        },
        configurable: !0
      });
    }
  }, [
    t
  ]), {
    labelProps: b,
    inputProps: Pe(A, n === "input" && V, {
      disabled: r,
      readOnly: i,
      required: a && l === "native",
      "aria-required": a && l === "aria" || void 0,
      "aria-invalid": g || void 0,
      "aria-errormessage": e["aria-errormessage"],
      "aria-activedescendant": e["aria-activedescendant"],
      "aria-autocomplete": e["aria-autocomplete"],
      "aria-haspopup": e["aria-haspopup"],
      value: s,
      onChange: ($) => u($.target.value),
      autoComplete: e.autoComplete,
      autoCapitalize: e.autoCapitalize,
      maxLength: e.maxLength,
      minLength: e.minLength,
      name: e.name,
      placeholder: e.placeholder,
      inputMode: e.inputMode,
      // Clipboard events
      onCopy: e.onCopy,
      onCut: e.onCut,
      onPaste: e.onPaste,
      // Composition events
      onCompositionEnd: e.onCompositionEnd,
      onCompositionStart: e.onCompositionStart,
      onCompositionUpdate: e.onCompositionUpdate,
      // Selection events
      onSelect: e.onSelect,
      // Input events
      onBeforeInput: e.onBeforeInput,
      onInput: e.onInput,
      ...f,
      ...w
    }),
    descriptionProps: S,
    errorMessageProps: T,
    isInvalid: g,
    validationErrors: v,
    validationDetails: E
  };
}
function Z5(e) {
  return e && e.__esModule ? e.default : e;
}
var Wv = {};
Wv = {
  "ar-AE": C2,
  "bg-BG": S2,
  "cs-CZ": k2,
  "da-DK": T2,
  "de-DE": A2,
  "el-GR": O2,
  "en-US": z2,
  "es-ES": M2,
  "et-EE": _2,
  "fi-FI": L2,
  "fr-FR": I2,
  "he-IL": D2,
  "hr-HR": N2,
  "hu-HU": R2,
  "it-IT": B2,
  "ja-JP": V2,
  "ko-KR": F2,
  "lt-LT": H2,
  "lv-LV": K2,
  "nb-NO": j2,
  "nl-NL": U2,
  "pl-PL": W2,
  "pt-BR": q2,
  "pt-PT": Z2,
  "ro-RO": G2,
  "ru-RU": Y2,
  "sk-SK": X2,
  "sl-SI": J2,
  "sr-SP": Q2,
  "sv-SE": ev,
  "tr-TR": tv,
  "uk-UA": nv,
  "zh-CN": rv,
  "zh-TW": av
};
function G5(e, t) {
  let { buttonRef: n, popoverRef: r, inputRef: a, listBoxRef: i, keyboardDelegate: o, shouldFocusWrap: l, isReadOnly: s, isDisabled: u } = e, f = Hc(/* @__PURE__ */ Z5(Wv), "@react-aria/combobox"), { menuTriggerProps: h, menuProps: g } = q5({
    type: "listbox",
    isDisabled: u || s
  }, t, n);
  ji.set(t, {
    id: g.id
  });
  let v = ge(() => o || new lv(t.collection, t.disabledKeys, i), [
    o,
    t.collection,
    t.disabledKeys,
    i
  ]), { collectionProps: E } = jc({
    selectionManager: t.selectionManager,
    keyboardDelegate: v,
    disallowTypeAhead: !0,
    disallowEmptySelection: !0,
    shouldFocusWrap: l,
    ref: a,
    // Prevent item scroll behavior from being applied here, should be handled in the user's Popover + ListBox component
    isVirtualized: !0
  }), b = Ri(), w = (W) => {
    switch (W.key) {
      case "Enter":
      case "Tab":
        if (t.isOpen && W.key === "Enter" && W.preventDefault(), t.isOpen && t.selectionManager.focusedKey != null && t.selectionManager.isLink(t.selectionManager.focusedKey)) {
          if (W.key === "Enter") {
            let q = i.current.querySelector(`[data-key="${CSS.escape(t.selectionManager.focusedKey.toString())}"]`);
            q instanceof HTMLAnchorElement && b.open(q, W);
          }
          t.close();
        } else
          t.commit();
        break;
      case "Escape":
        (t.selectedKey !== null || t.inputValue === "" || e.allowsCustomValue) && W.continuePropagation(), t.revert();
        break;
      case "ArrowDown":
        t.open("first", "manual");
        break;
      case "ArrowUp":
        t.open("last", "manual");
        break;
      case "ArrowLeft":
      case "ArrowRight":
        t.selectionManager.setFocusedKey(null);
        break;
    }
  }, S = (W) => {
    var q;
    W.relatedTarget === (n == null ? void 0 : n.current) || !((q = r.current) === null || q === void 0) && q.contains(W.relatedTarget) || (e.onBlur && e.onBlur(W), t.setFocused(!1));
  }, T = (W) => {
    t.isFocused || (e.onFocus && e.onFocus(W), t.setFocused(!0));
  }, { isInvalid: A, validationErrors: V, validationDetails: $ } = t.displayValidation, { labelProps: _, inputProps: y, descriptionProps: c, errorMessageProps: p } = Uc({
    ...e,
    onChange: t.setInputValue,
    onKeyDown: s ? e.onKeyDown : _c(t.isOpen && E.onKeyDown, w, e.onKeyDown),
    onBlur: S,
    value: t.inputValue,
    onFocus: T,
    autoComplete: "off",
    validate: void 0,
    [ac]: t
  }, a), d = (W) => {
    W.pointerType === "touch" && (a.current.focus(), t.toggle(null, "manual"));
  }, m = (W) => {
    W.pointerType !== "touch" && (a.current.focus(), t.toggle(W.pointerType === "keyboard" || W.pointerType === "virtual" ? "first" : null, "manual"));
  }, O = Xr({
    id: h.id,
    "aria-label": f.format("buttonLabel"),
    "aria-labelledby": e["aria-labelledby"] || _.id
  }), x = Xr({
    id: g.id,
    "aria-label": f.format("listboxLabel"),
    "aria-labelledby": e["aria-labelledby"] || _.id
  }), P = J(0), N = (W) => {
    if (u || s)
      return;
    if (W.timeStamp - P.current < 500) {
      W.preventDefault(), a.current.focus();
      return;
    }
    let q = W.target.getBoundingClientRect(), ee = W.changedTouches[0], te = Math.ceil(q.left + 0.5 * q.width), le = Math.ceil(q.top + 0.5 * q.height);
    ee.clientX === te && ee.clientY === le && (W.preventDefault(), a.current.focus(), t.toggle(null, "manual"), P.current = W.timeStamp);
  }, D = t.selectionManager.focusedKey != null && t.isOpen ? t.collection.getItem(t.selectionManager.focusedKey) : void 0;
  var I;
  let C = (I = D == null ? void 0 : D.parentKey) !== null && I !== void 0 ? I : null;
  var L;
  let k = (L = t.selectionManager.focusedKey) !== null && L !== void 0 ? L : null, M = J(C), F = J(k);
  re(() => {
    if (ii() && D != null && k !== F.current) {
      let W = t.selectionManager.isSelected(k), q = C != null ? t.collection.getItem(C) : null, ee = (q == null ? void 0 : q["aria-label"]) || (typeof (q == null ? void 0 : q.rendered) == "string" ? q.rendered : "") || "", te = f.format("focusAnnouncement", {
        isGroupChange: q && C !== M.current,
        groupTitle: ee,
        groupCount: q ? [
          ...Ki(q, t.collection)
        ].length : 0,
        optionText: D["aria-label"] || D.textValue || "",
        isSelected: W
      });
      _o(te);
    }
    M.current = C, F.current = k;
  });
  let j = cv(t.collection), U = J(j), G = J(t.isOpen);
  re(() => {
    let W = t.isOpen !== G.current && (t.selectionManager.focusedKey == null || ii());
    if (t.isOpen && (W || j !== U.current)) {
      let q = f.format("countAnnouncement", {
        optionCount: j
      });
      _o(q);
    }
    U.current = j, G.current = t.isOpen;
  });
  let X = J(t.selectedKey);
  return re(() => {
    if (ii() && t.isFocused && t.selectedItem && t.selectedKey !== X.current) {
      let W = t.selectedItem["aria-label"] || t.selectedItem.textValue || "", q = f.format("selectedAnnouncement", {
        optionText: W
      });
      _o(q);
    }
    X.current = t.selectedKey;
  }), re(() => {
    if (t.isOpen)
      return z5([
        a.current,
        r.current
      ]);
  }, [
    t.isOpen,
    a,
    r
  ]), {
    labelProps: _,
    buttonProps: {
      ...h,
      ...O,
      excludeFromTabOrder: !0,
      onPress: d,
      onPressStart: m,
      isDisabled: u || s
    },
    inputProps: Pe(y, {
      role: "combobox",
      "aria-expanded": h["aria-expanded"],
      "aria-controls": t.isOpen ? g.id : void 0,
      // TODO: readd proper logic for completionMode = complete (aria-autocomplete: both)
      "aria-autocomplete": "list",
      "aria-activedescendant": D ? uv(t, D.key) : void 0,
      onTouchEnd: N,
      // This disable's iOS's autocorrect suggestions, since the combo box provides its own suggestions.
      autoCorrect: "off",
      // This disable's the macOS Safari spell check auto corrections.
      spellCheck: "false"
    }),
    listBoxProps: Pe(g, x, {
      autoFocus: t.focusStrategy,
      shouldUseVirtualFocus: !0,
      shouldSelectOnPressUp: !0,
      shouldFocusOnHover: !0,
      linkBehavior: "selection"
    }),
    descriptionProps: c,
    errorMessageProps: p,
    isInvalid: A,
    validationErrors: V,
    validationDetails: $
  };
}
const qv = /* @__PURE__ */ new WeakMap();
function Y5(e, t, n) {
  let { value: r, children: a, "aria-label": i, "aria-labelledby": o } = e;
  const l = e.isDisabled || t.isDisabled;
  let s = a != null, u = i != null || o != null;
  !s && !u && console.warn("If you do not provide children, you must specify an aria-label for accessibility");
  let f = t.selectedValue === r, h = (c) => {
    c.stopPropagation(), t.setSelectedValue(r);
  }, { pressProps: g, isPressed: v } = vn({
    isDisabled: l
  }), { pressProps: E, isPressed: b } = vn({
    isDisabled: l,
    onPress() {
      t.setSelectedValue(r);
    }
  }), { focusableProps: w } = aa(Pe(e, {
    onFocus: () => t.setLastFocusedValue(r)
  }), n), S = Pe(g, w), T = Bt(e, {
    labelable: !0
  }), A = -1;
  t.selectedValue != null ? t.selectedValue === r && (A = 0) : (t.lastFocusedValue === r || t.lastFocusedValue == null) && (A = 0), l && (A = void 0);
  let { name: V, descriptionId: $, errorMessageId: _, validationBehavior: y } = qv.get(t);
  return Dc(n, t.selectedValue, t.setSelectedValue), Kc({
    validationBehavior: y
  }, t, n), {
    labelProps: Pe(E, {
      onClick: (c) => c.preventDefault()
    }),
    inputProps: Pe(T, {
      ...S,
      type: "radio",
      name: V,
      tabIndex: A,
      disabled: l,
      required: t.isRequired && y === "native",
      checked: f,
      value: r,
      onChange: h,
      "aria-describedby": [
        e["aria-describedby"],
        t.isInvalid ? _ : null,
        $
      ].filter(Boolean).join(" ") || void 0
    }),
    isDisabled: l,
    isSelected: f,
    isPressed: v || b
  };
}
function X5(e, t) {
  let { name: n, isReadOnly: r, isRequired: a, isDisabled: i, orientation: o = "vertical", validationBehavior: l = "aria" } = e, { direction: s } = ia(), { isInvalid: u, validationErrors: f, validationDetails: h } = t.displayValidation, { labelProps: g, fieldProps: v, descriptionProps: E, errorMessageProps: b } = $2({
    ...e,
    // Radio group is not an HTML input element so it
    // shouldn't be labeled by a <label> element.
    labelElementType: "span",
    isInvalid: t.isInvalid,
    errorMessage: e.errorMessage || f
  }), w = Bt(e, {
    labelable: !0
  }), { focusWithinProps: S } = ra({
    onBlurWithin(V) {
      var $;
      ($ = e.onBlur) === null || $ === void 0 || $.call(e, V), t.selectedValue || t.setLastFocusedValue(null);
    },
    onFocusWithin: e.onFocus,
    onFocusWithinChange: e.onFocusChange
  }), T = (V) => {
    let $;
    switch (V.key) {
      case "ArrowRight":
        s === "rtl" && o !== "vertical" ? $ = "prev" : $ = "next";
        break;
      case "ArrowLeft":
        s === "rtl" && o !== "vertical" ? $ = "next" : $ = "prev";
        break;
      case "ArrowDown":
        $ = "next";
        break;
      case "ArrowUp":
        $ = "prev";
        break;
      default:
        return;
    }
    V.preventDefault();
    let _ = Vc(V.currentTarget, {
      from: V.target
    }), y;
    $ === "next" ? (y = _.nextNode(), y || (_.currentNode = V.currentTarget, y = _.firstChild())) : (y = _.previousNode(), y || (_.currentNode = V.currentTarget, y = _.lastChild())), y && (y.focus(), t.setSelectedValue(y.value));
  }, A = Yt(n);
  return qv.set(t, {
    name: A,
    descriptionId: E.id,
    errorMessageId: b.id,
    validationBehavior: l
  }), {
    radioGroupProps: Pe(w, {
      // https://www.w3.org/TR/wai-aria-1.2/#radiogroup
      role: "radiogroup",
      onKeyDown: T,
      "aria-invalid": t.isInvalid || void 0,
      "aria-errormessage": e["aria-errormessage"],
      "aria-readonly": r || void 0,
      "aria-required": a || void 0,
      "aria-disabled": i || void 0,
      "aria-orientation": o,
      ...v,
      ...S
    }),
    labelProps: g,
    descriptionProps: E,
    errorMessageProps: b,
    isInvalid: u,
    validationErrors: f,
    validationDetails: h
  };
}
const Zv = /* @__PURE__ */ new WeakMap();
function bi(e, t, n) {
  return typeof t == "string" && (t = t.replace(/\s+/g, "")), `${Zv.get(e)}-${n}-${t}`;
}
function J5(e, t, n) {
  var r;
  let { key: a, isDisabled: i, shouldSelectOnPressUp: o } = e, { selectionManager: l, selectedKey: s } = t, u = a === s, f = i || t.isDisabled || t.disabledKeys.has(a), { itemProps: h, isPressed: g } = ov({
    selectionManager: l,
    key: a,
    ref: n,
    isDisabled: f,
    shouldSelectOnPressUp: o,
    linkBehavior: "selection"
  }), v = bi(t, a, "tab"), E = bi(t, a, "tabpanel"), { tabIndex: b } = h, w = t.collection.getItem(a), S = Bt(w == null ? void 0 : w.props, {
    isLink: !!(!(w == null || (r = w.props) === null || r === void 0) && r.href),
    labelable: !0
  });
  return delete S.id, {
    tabProps: Pe(S, h, {
      id: v,
      "aria-selected": u,
      "aria-disabled": f || void 0,
      "aria-controls": u ? E : void 0,
      tabIndex: f ? void 0 : b,
      role: "tab"
    }),
    isSelected: u,
    isDisabled: f,
    isPressed: g
  };
}
function Q5(e, t, n) {
  let r = Jb(n) ? void 0 : 0;
  var a;
  const i = bi(t, (a = e.id) !== null && a !== void 0 ? a : t == null ? void 0 : t.selectedKey, "tabpanel"), o = Xr({
    ...e,
    id: i,
    "aria-labelledby": bi(t, t == null ? void 0 : t.selectedKey, "tab")
  });
  return {
    tabPanelProps: Pe(o, {
      tabIndex: r,
      role: "tabpanel",
      "aria-describedby": e["aria-describedby"],
      "aria-details": e["aria-details"]
    })
  };
}
class e4 {
  getKeyLeftOf(t) {
    return this.flipDirection ? this.getNextKey(t) : this.getPreviousKey(t);
  }
  getKeyRightOf(t) {
    return this.flipDirection ? this.getPreviousKey(t) : this.getNextKey(t);
  }
  getKeyAbove(t) {
    return this.getPreviousKey(t);
  }
  getKeyBelow(t) {
    return this.getNextKey(t);
  }
  getFirstKey() {
    let t = this.collection.getFirstKey();
    return t != null && this.disabledKeys.has(t) && (t = this.getNextKey(t)), t;
  }
  getLastKey() {
    let t = this.collection.getLastKey();
    return t != null && this.disabledKeys.has(t) && (t = this.getPreviousKey(t)), t;
  }
  getNextKey(t) {
    do
      t = this.collection.getKeyAfter(t), t == null && (t = this.collection.getFirstKey());
    while (this.disabledKeys.has(t));
    return t;
  }
  getPreviousKey(t) {
    do
      t = this.collection.getKeyBefore(t), t == null && (t = this.collection.getLastKey());
    while (this.disabledKeys.has(t));
    return t;
  }
  constructor(t, n, r, a = /* @__PURE__ */ new Set()) {
    this.collection = t, this.flipDirection = n === "rtl" && r === "horizontal", this.disabledKeys = a;
  }
}
function t4(e, t, n) {
  let { orientation: r = "horizontal", keyboardActivation: a = "automatic" } = e, { collection: i, selectionManager: o, disabledKeys: l } = t, { direction: s } = ia(), u = ge(() => new e4(i, s, r, l), [
    i,
    l,
    r,
    s
  ]), { collectionProps: f } = jc({
    ref: n,
    selectionManager: o,
    keyboardDelegate: u,
    selectOnFocus: a === "automatic",
    disallowEmptySelection: !0,
    scrollRef: n,
    linkBehavior: "selection"
  }), h = Yt();
  Zv.set(t, h);
  let g = Xr({
    ...e,
    id: h
  });
  return {
    tabListProps: {
      ...Pe(f, g),
      role: "tablist",
      "aria-orientation": r,
      tabIndex: void 0
    }
  };
}
var n4 = Object.create, Gv = Object.defineProperty, r4 = Object.getOwnPropertyDescriptor, a4 = Object.getOwnPropertyNames, i4 = Object.getPrototypeOf, o4 = Object.prototype.hasOwnProperty, Ui = (e, t) => () => (t || e((t = { exports: {} }).exports, t), t.exports), l4 = (e, t, n, r) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let a of a4(t))
      !o4.call(e, a) && a !== n && Gv(e, a, { get: () => t[a], enumerable: !(r = r4(t, a)) || r.enumerable });
  return e;
}, R = (e, t, n) => (n = e != null ? n4(i4(e)) : {}, l4(t || !e || !e.__esModule ? Gv(n, "default", { value: e, enumerable: !0 }) : n, e)), Yv = Ui((e, t) => {
  var n = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, a = Object.prototype.propertyIsEnumerable;
  function i(l) {
    if (l == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(l);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var l = new String("abc");
      if (l[5] = "de", Object.getOwnPropertyNames(l)[0] === "5")
        return !1;
      for (var s = {}, u = 0; u < 10; u++)
        s["_" + String.fromCharCode(u)] = u;
      var f = Object.getOwnPropertyNames(s).map(function(g) {
        return s[g];
      });
      if (f.join("") !== "0123456789")
        return !1;
      var h = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(g) {
        h[g] = g;
      }), Object.keys(Object.assign({}, h)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  t.exports = o() ? Object.assign : function(l, s) {
    for (var u, f = i(l), h, g = 1; g < arguments.length; g++) {
      u = Object(arguments[g]);
      for (var v in u)
        r.call(u, v) && (f[v] = u[v]);
      if (n) {
        h = n(u);
        for (var E = 0; E < h.length; E++)
          a.call(u, h[E]) && (f[h[E]] = u[h[E]]);
      }
    }
    return f;
  };
}), s4 = Ui((e) => {
  var t = Yv(), n = 60103, r = 60106;
  e.Fragment = 60107, e.StrictMode = 60108, e.Profiler = 60114;
  var a = 60109, i = 60110, o = 60112;
  e.Suspense = 60113;
  var l = 60115, s = 60116;
  typeof Symbol == "function" && Symbol.for && (u = Symbol.for, n = u("react.element"), r = u("react.portal"), e.Fragment = u("react.fragment"), e.StrictMode = u("react.strict_mode"), e.Profiler = u("react.profiler"), a = u("react.provider"), i = u("react.context"), o = u("react.forward_ref"), e.Suspense = u("react.suspense"), l = u("react.memo"), s = u("react.lazy"));
  var u, f = typeof Symbol == "function" && Symbol.iterator;
  function h(C) {
    return C === null || typeof C != "object" ? null : (C = f && C[f] || C["@@iterator"], typeof C == "function" ? C : null);
  }
  function g(C) {
    for (var L = "https://reactjs.org/docs/error-decoder.html?invariant=" + C, k = 1; k < arguments.length; k++)
      L += "&args[]=" + encodeURIComponent(arguments[k]);
    return "Minified React error #" + C + "; visit " + L + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var v = { isMounted: function() {
    return !1;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, E = {};
  function b(C, L, k) {
    this.props = C, this.context = L, this.refs = E, this.updater = k || v;
  }
  b.prototype.isReactComponent = {}, b.prototype.setState = function(C, L) {
    if (typeof C != "object" && typeof C != "function" && C != null)
      throw Error(g(85));
    this.updater.enqueueSetState(this, C, L, "setState");
  }, b.prototype.forceUpdate = function(C) {
    this.updater.enqueueForceUpdate(this, C, "forceUpdate");
  };
  function w() {
  }
  w.prototype = b.prototype;
  function S(C, L, k) {
    this.props = C, this.context = L, this.refs = E, this.updater = k || v;
  }
  var T = S.prototype = new w();
  T.constructor = S, t(T, b.prototype), T.isPureReactComponent = !0;
  var A = { current: null }, V = Object.prototype.hasOwnProperty, $ = { key: !0, ref: !0, __self: !0, __source: !0 };
  function _(C, L, k) {
    var M, F = {}, j = null, U = null;
    if (L != null)
      for (M in L.ref !== void 0 && (U = L.ref), L.key !== void 0 && (j = "" + L.key), L)
        V.call(L, M) && !$.hasOwnProperty(M) && (F[M] = L[M]);
    var G = arguments.length - 2;
    if (G === 1)
      F.children = k;
    else if (1 < G) {
      for (var X = Array(G), W = 0; W < G; W++)
        X[W] = arguments[W + 2];
      F.children = X;
    }
    if (C && C.defaultProps)
      for (M in G = C.defaultProps, G)
        F[M] === void 0 && (F[M] = G[M]);
    return { $$typeof: n, type: C, key: j, ref: U, props: F, _owner: A.current };
  }
  function y(C, L) {
    return { $$typeof: n, type: C.type, key: L, ref: C.ref, props: C.props, _owner: C._owner };
  }
  function c(C) {
    return typeof C == "object" && C !== null && C.$$typeof === n;
  }
  function p(C) {
    var L = { "=": "=0", ":": "=2" };
    return "$" + C.replace(/[=:]/g, function(k) {
      return L[k];
    });
  }
  var d = /\/+/g;
  function m(C, L) {
    return typeof C == "object" && C !== null && C.key != null ? p("" + C.key) : L.toString(36);
  }
  function O(C, L, k, M, F) {
    var j = typeof C;
    (j === "undefined" || j === "boolean") && (C = null);
    var U = !1;
    if (C === null)
      U = !0;
    else
      switch (j) {
        case "string":
        case "number":
          U = !0;
          break;
        case "object":
          switch (C.$$typeof) {
            case n:
            case r:
              U = !0;
          }
      }
    if (U)
      return U = C, F = F(U), C = M === "" ? "." + m(U, 0) : M, Array.isArray(F) ? (k = "", C != null && (k = C.replace(d, "$&/") + "/"), O(F, L, k, "", function(W) {
        return W;
      })) : F != null && (c(F) && (F = y(F, k + (!F.key || U && U.key === F.key ? "" : ("" + F.key).replace(d, "$&/") + "/") + C)), L.push(F)), 1;
    if (U = 0, M = M === "" ? "." : M + ":", Array.isArray(C))
      for (var G = 0; G < C.length; G++) {
        j = C[G];
        var X = M + m(j, G);
        U += O(j, L, k, X, F);
      }
    else if (X = h(C), typeof X == "function")
      for (C = X.call(C), G = 0; !(j = C.next()).done; )
        j = j.value, X = M + m(j, G++), U += O(j, L, k, X, F);
    else if (j === "object")
      throw L = "" + C, Error(g(31, L === "[object Object]" ? "object with keys {" + Object.keys(C).join(", ") + "}" : L));
    return U;
  }
  function x(C, L, k) {
    if (C == null)
      return C;
    var M = [], F = 0;
    return O(C, M, "", "", function(j) {
      return L.call(k, j, F++);
    }), M;
  }
  function P(C) {
    if (C._status === -1) {
      var L = C._result;
      L = L(), C._status = 0, C._result = L, L.then(function(k) {
        C._status === 0 && (k = k.default, C._status = 1, C._result = k);
      }, function(k) {
        C._status === 0 && (C._status = 2, C._result = k);
      });
    }
    if (C._status === 1)
      return C._result;
    throw C._result;
  }
  var N = { current: null };
  function D() {
    var C = N.current;
    if (C === null)
      throw Error(g(321));
    return C;
  }
  var I = { ReactCurrentDispatcher: N, ReactCurrentBatchConfig: { transition: 0 }, ReactCurrentOwner: A, IsSomeRendererActing: { current: !1 }, assign: t };
  e.Children = { map: x, forEach: function(C, L, k) {
    x(C, function() {
      L.apply(this, arguments);
    }, k);
  }, count: function(C) {
    var L = 0;
    return x(C, function() {
      L++;
    }), L;
  }, toArray: function(C) {
    return x(C, function(L) {
      return L;
    }) || [];
  }, only: function(C) {
    if (!c(C))
      throw Error(g(143));
    return C;
  } }, e.Component = b, e.PureComponent = S, e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = I, e.cloneElement = function(C, L, k) {
    if (C == null)
      throw Error(g(267, C));
    var M = t({}, C.props), F = C.key, j = C.ref, U = C._owner;
    if (L != null) {
      if (L.ref !== void 0 && (j = L.ref, U = A.current), L.key !== void 0 && (F = "" + L.key), C.type && C.type.defaultProps)
        var G = C.type.defaultProps;
      for (X in L)
        V.call(L, X) && !$.hasOwnProperty(X) && (M[X] = L[X] === void 0 && G !== void 0 ? G[X] : L[X]);
    }
    var X = arguments.length - 2;
    if (X === 1)
      M.children = k;
    else if (1 < X) {
      G = Array(X);
      for (var W = 0; W < X; W++)
        G[W] = arguments[W + 2];
      M.children = G;
    }
    return { $$typeof: n, type: C.type, key: F, ref: j, props: M, _owner: U };
  }, e.createContext = function(C, L) {
    return L === void 0 && (L = null), C = { $$typeof: i, _calculateChangedBits: L, _currentValue: C, _currentValue2: C, _threadCount: 0, Provider: null, Consumer: null }, C.Provider = { $$typeof: a, _context: C }, C.Consumer = C;
  }, e.createElement = _, e.createFactory = function(C) {
    var L = _.bind(null, C);
    return L.type = C, L;
  }, e.createRef = function() {
    return { current: null };
  }, e.forwardRef = function(C) {
    return { $$typeof: o, render: C };
  }, e.isValidElement = c, e.lazy = function(C) {
    return { $$typeof: s, _payload: { _status: -1, _result: C }, _init: P };
  }, e.memo = function(C, L) {
    return { $$typeof: l, type: C, compare: L === void 0 ? null : L };
  }, e.useCallback = function(C, L) {
    return D().useCallback(C, L);
  }, e.useContext = function(C, L) {
    return D().useContext(C, L);
  }, e.useDebugValue = function() {
  }, e.useEffect = function(C, L) {
    return D().useEffect(C, L);
  }, e.useImperativeHandle = function(C, L, k) {
    return D().useImperativeHandle(C, L, k);
  }, e.useLayoutEffect = function(C, L) {
    return D().useLayoutEffect(C, L);
  }, e.useMemo = function(C, L) {
    return D().useMemo(C, L);
  }, e.useReducer = function(C, L, k) {
    return D().useReducer(C, L, k);
  }, e.useRef = function(C) {
    return D().useRef(C);
  }, e.useState = function(C) {
    return D().useState(C);
  }, e.version = "17.0.2";
}), c4 = Ui((e) => {
  process.env.NODE_ENV !== "production" && function() {
    var t = Yv(), n = "17.0.2", r = 60103, a = 60106;
    e.Fragment = 60107, e.StrictMode = 60108, e.Profiler = 60114;
    var i = 60109, o = 60110, l = 60112;
    e.Suspense = 60113;
    var s = 60120, u = 60115, f = 60116, h = 60121, g = 60122, v = 60117, E = 60129, b = 60131;
    if (typeof Symbol == "function" && Symbol.for) {
      var w = Symbol.for;
      r = w("react.element"), a = w("react.portal"), e.Fragment = w("react.fragment"), e.StrictMode = w("react.strict_mode"), e.Profiler = w("react.profiler"), i = w("react.provider"), o = w("react.context"), l = w("react.forward_ref"), e.Suspense = w("react.suspense"), s = w("react.suspense_list"), u = w("react.memo"), f = w("react.lazy"), h = w("react.block"), g = w("react.server.block"), v = w("react.fundamental"), w("react.scope"), w("react.opaque.id"), E = w("react.debug_trace_mode"), w("react.offscreen"), b = w("react.legacy_hidden");
    }
    var S = typeof Symbol == "function" && Symbol.iterator, T = "@@iterator";
    function A(z) {
      if (z === null || typeof z != "object")
        return null;
      var K = S && z[S] || z[T];
      return typeof K == "function" ? K : null;
    }
    var V = { current: null }, $ = { transition: 0 }, _ = { current: null }, y = {}, c = null;
    function p(z) {
      c = z;
    }
    y.setExtraStackFrame = function(z) {
      c = z;
    }, y.getCurrentStack = null, y.getStackAddendum = function() {
      var z = "";
      c && (z += c);
      var K = y.getCurrentStack;
      return K && (z += K() || ""), z;
    };
    var d = { current: !1 }, m = { ReactCurrentDispatcher: V, ReactCurrentBatchConfig: $, ReactCurrentOwner: _, IsSomeRendererActing: d, assign: t };
    m.ReactDebugCurrentFrame = y;
    function O(z) {
      {
        for (var K = arguments.length, Z = new Array(K > 1 ? K - 1 : 0), Q = 1; Q < K; Q++)
          Z[Q - 1] = arguments[Q];
        P("warn", z, Z);
      }
    }
    function x(z) {
      {
        for (var K = arguments.length, Z = new Array(K > 1 ? K - 1 : 0), Q = 1; Q < K; Q++)
          Z[Q - 1] = arguments[Q];
        P("error", z, Z);
      }
    }
    function P(z, K, Z) {
      {
        var Q = m.ReactDebugCurrentFrame, ce = Q.getStackAddendum();
        ce !== "" && (K += "%s", Z = Z.concat([ce]));
        var ve = Z.map(function(me) {
          return "" + me;
        });
        ve.unshift("Warning: " + K), Function.prototype.apply.call(console[z], console, ve);
      }
    }
    var N = {};
    function D(z, K) {
      {
        var Z = z.constructor, Q = Z && (Z.displayName || Z.name) || "ReactClass", ce = Q + "." + K;
        if (N[ce])
          return;
        x("Can't call %s on a component that is not yet mounted. This is a no-op, but it might indicate a bug in your application. Instead, assign to `this.state` directly or define a `state = {};` class property with the desired state in the %s component.", K, Q), N[ce] = !0;
      }
    }
    var I = { isMounted: function(z) {
      return !1;
    }, enqueueForceUpdate: function(z, K, Z) {
      D(z, "forceUpdate");
    }, enqueueReplaceState: function(z, K, Z, Q) {
      D(z, "replaceState");
    }, enqueueSetState: function(z, K, Z, Q) {
      D(z, "setState");
    } }, C = {};
    Object.freeze(C);
    function L(z, K, Z) {
      this.props = z, this.context = K, this.refs = C, this.updater = Z || I;
    }
    L.prototype.isReactComponent = {}, L.prototype.setState = function(z, K) {
      if (!(typeof z == "object" || typeof z == "function" || z == null))
        throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
      this.updater.enqueueSetState(this, z, K, "setState");
    }, L.prototype.forceUpdate = function(z) {
      this.updater.enqueueForceUpdate(this, z, "forceUpdate");
    };
    {
      var k = { isMounted: ["isMounted", "Instead, make sure to clean up subscriptions and pending requests in componentWillUnmount to prevent memory leaks."], replaceState: ["replaceState", "Refactor your code to use setState instead (see https://github.com/facebook/react/issues/3236)."] }, M = function(z, K) {
        Object.defineProperty(L.prototype, z, { get: function() {
          O("%s(...) is deprecated in plain JavaScript React classes. %s", K[0], K[1]);
        } });
      };
      for (var F in k)
        k.hasOwnProperty(F) && M(F, k[F]);
    }
    function j() {
    }
    j.prototype = L.prototype;
    function U(z, K, Z) {
      this.props = z, this.context = K, this.refs = C, this.updater = Z || I;
    }
    var G = U.prototype = new j();
    G.constructor = U, t(G, L.prototype), G.isPureReactComponent = !0;
    function X() {
      var z = { current: null };
      return Object.seal(z), z;
    }
    function W(z, K, Z) {
      var Q = K.displayName || K.name || "";
      return z.displayName || (Q !== "" ? Z + "(" + Q + ")" : Z);
    }
    function q(z) {
      return z.displayName || "Context";
    }
    function ee(z) {
      if (z == null)
        return null;
      if (typeof z.tag == "number" && x("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof z == "function")
        return z.displayName || z.name || null;
      if (typeof z == "string")
        return z;
      switch (z) {
        case e.Fragment:
          return "Fragment";
        case a:
          return "Portal";
        case e.Profiler:
          return "Profiler";
        case e.StrictMode:
          return "StrictMode";
        case e.Suspense:
          return "Suspense";
        case s:
          return "SuspenseList";
      }
      if (typeof z == "object")
        switch (z.$$typeof) {
          case o:
            var K = z;
            return q(K) + ".Consumer";
          case i:
            var Z = z;
            return q(Z._context) + ".Provider";
          case l:
            return W(z, z.render, "ForwardRef");
          case u:
            return ee(z.type);
          case h:
            return ee(z._render);
          case f: {
            var Q = z, ce = Q._payload, ve = Q._init;
            try {
              return ee(ve(ce));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var te = Object.prototype.hasOwnProperty, le = { key: !0, ref: !0, __self: !0, __source: !0 }, Y, ye, Ce;
    Ce = {};
    function Ke(z) {
      if (te.call(z, "ref")) {
        var K = Object.getOwnPropertyDescriptor(z, "ref").get;
        if (K && K.isReactWarning)
          return !1;
      }
      return z.ref !== void 0;
    }
    function We(z) {
      if (te.call(z, "key")) {
        var K = Object.getOwnPropertyDescriptor(z, "key").get;
        if (K && K.isReactWarning)
          return !1;
      }
      return z.key !== void 0;
    }
    function nt(z, K) {
      var Z = function() {
        Y || (Y = !0, x("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", K));
      };
      Z.isReactWarning = !0, Object.defineProperty(z, "key", { get: Z, configurable: !0 });
    }
    function qe(z, K) {
      var Z = function() {
        ye || (ye = !0, x("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", K));
      };
      Z.isReactWarning = !0, Object.defineProperty(z, "ref", { get: Z, configurable: !0 });
    }
    function we(z) {
      if (typeof z.ref == "string" && _.current && z.__self && _.current.stateNode !== z.__self) {
        var K = ee(_.current.type);
        Ce[K] || (x('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', K, z.ref), Ce[K] = !0);
      }
    }
    var $e = function(z, K, Z, Q, ce, ve, me) {
      var pe = { $$typeof: r, type: z, key: K, ref: Z, props: me, _owner: ve };
      return pe._store = {}, Object.defineProperty(pe._store, "validated", { configurable: !1, enumerable: !1, writable: !0, value: !1 }), Object.defineProperty(pe, "_self", { configurable: !1, enumerable: !1, writable: !1, value: Q }), Object.defineProperty(pe, "_source", { configurable: !1, enumerable: !1, writable: !1, value: ce }), Object.freeze && (Object.freeze(pe.props), Object.freeze(pe)), pe;
    };
    function Ve(z, K, Z) {
      var Q, ce = {}, ve = null, me = null, pe = null, Oe = null;
      if (K != null) {
        Ke(K) && (me = K.ref, we(K)), We(K) && (ve = "" + K.key), pe = K.__self === void 0 ? null : K.__self, Oe = K.__source === void 0 ? null : K.__source;
        for (Q in K)
          te.call(K, Q) && !le.hasOwnProperty(Q) && (ce[Q] = K[Q]);
      }
      var _e = arguments.length - 2;
      if (_e === 1)
        ce.children = Z;
      else if (_e > 1) {
        for (var Ne = Array(_e), je = 0; je < _e; je++)
          Ne[je] = arguments[je + 2];
        Object.freeze && Object.freeze(Ne), ce.children = Ne;
      }
      if (z && z.defaultProps) {
        var ft = z.defaultProps;
        for (Q in ft)
          ce[Q] === void 0 && (ce[Q] = ft[Q]);
      }
      if (ve || me) {
        var ut = typeof z == "function" ? z.displayName || z.name || "Unknown" : z;
        ve && nt(ce, ut), me && qe(ce, ut);
      }
      return $e(z, ve, me, pe, Oe, _.current, ce);
    }
    function mo(z, K) {
      var Z = $e(z.type, K, z.ref, z._self, z._source, z._owner, z.props);
      return Z;
    }
    function go(z, K, Z) {
      if (z == null)
        throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + z + ".");
      var Q, ce = t({}, z.props), ve = z.key, me = z.ref, pe = z._self, Oe = z._source, _e = z._owner;
      if (K != null) {
        Ke(K) && (me = K.ref, _e = _.current), We(K) && (ve = "" + K.key);
        var Ne;
        z.type && z.type.defaultProps && (Ne = z.type.defaultProps);
        for (Q in K)
          te.call(K, Q) && !le.hasOwnProperty(Q) && (K[Q] === void 0 && Ne !== void 0 ? ce[Q] = Ne[Q] : ce[Q] = K[Q]);
      }
      var je = arguments.length - 2;
      if (je === 1)
        ce.children = Z;
      else if (je > 1) {
        for (var ft = Array(je), ut = 0; ut < je; ut++)
          ft[ut] = arguments[ut + 2];
        ce.children = ft;
      }
      return $e(z.type, ve, me, pe, Oe, _e, ce);
    }
    function ln(z) {
      return typeof z == "object" && z !== null && z.$$typeof === r;
    }
    var da = ".", h3 = ":";
    function v3(z) {
      var K = /[=:]/g, Z = { "=": "=0", ":": "=2" }, Q = z.replace(K, function(ce) {
        return Z[ce];
      });
      return "$" + Q;
    }
    var P1 = !1, m3 = /\/+/g;
    function C1(z) {
      return z.replace(m3, "$&/");
    }
    function yo(z, K) {
      return typeof z == "object" && z !== null && z.key != null ? v3("" + z.key) : K.toString(36);
    }
    function fa(z, K, Z, Q, ce) {
      var ve = typeof z;
      (ve === "undefined" || ve === "boolean") && (z = null);
      var me = !1;
      if (z === null)
        me = !0;
      else
        switch (ve) {
          case "string":
          case "number":
            me = !0;
            break;
          case "object":
            switch (z.$$typeof) {
              case r:
              case a:
                me = !0;
            }
        }
      if (me) {
        var pe = z, Oe = ce(pe), _e = Q === "" ? da + yo(pe, 0) : Q;
        if (Array.isArray(Oe)) {
          var Ne = "";
          _e != null && (Ne = C1(_e) + "/"), fa(Oe, K, Ne, "", function(ny) {
            return ny;
          });
        } else
          Oe != null && (ln(Oe) && (Oe = mo(Oe, Z + (Oe.key && (!pe || pe.key !== Oe.key) ? C1("" + Oe.key) + "/" : "") + _e)), K.push(Oe));
        return 1;
      }
      var je, ft, ut = 0, bt = Q === "" ? da : Q + h3;
      if (Array.isArray(z))
        for (var ya = 0; ya < z.length; ya++)
          je = z[ya], ft = bt + yo(je, ya), ut += fa(je, K, Z, ft, ce);
      else {
        var Po = A(z);
        if (typeof Po == "function") {
          var q1 = z;
          Po === q1.entries && (P1 || O("Using Maps as children is not supported. Use an array of keyed ReactElements instead."), P1 = !0);
          for (var ey = Po.call(q1), Z1, ty = 0; !(Z1 = ey.next()).done; )
            je = Z1.value, ft = bt + yo(je, ty++), ut += fa(je, K, Z, ft, ce);
        } else if (ve === "object") {
          var G1 = "" + z;
          throw Error("Objects are not valid as a React child (found: " + (G1 === "[object Object]" ? "object with keys {" + Object.keys(z).join(", ") + "}" : G1) + "). If you meant to render a collection of children, use an array instead.");
        }
      }
      return ut;
    }
    function pa(z, K, Z) {
      if (z == null)
        return z;
      var Q = [], ce = 0;
      return fa(z, Q, "", "", function(ve) {
        return K.call(Z, ve, ce++);
      }), Q;
    }
    function g3(z) {
      var K = 0;
      return pa(z, function() {
        K++;
      }), K;
    }
    function y3(z, K, Z) {
      pa(z, function() {
        K.apply(this, arguments);
      }, Z);
    }
    function b3(z) {
      return pa(z, function(K) {
        return K;
      }) || [];
    }
    function w3(z) {
      if (!ln(z))
        throw Error("React.Children.only expected to receive a single React element child.");
      return z;
    }
    function x3(z, K) {
      K === void 0 ? K = null : K !== null && typeof K != "function" && x("createContext: Expected the optional second argument to be a function. Instead received: %s", K);
      var Z = { $$typeof: o, _calculateChangedBits: K, _currentValue: z, _currentValue2: z, _threadCount: 0, Provider: null, Consumer: null };
      Z.Provider = { $$typeof: i, _context: Z };
      var Q = !1, ce = !1, ve = !1;
      {
        var me = { $$typeof: o, _context: Z, _calculateChangedBits: Z._calculateChangedBits };
        Object.defineProperties(me, { Provider: { get: function() {
          return ce || (ce = !0, x("Rendering <Context.Consumer.Provider> is not supported and will be removed in a future major release. Did you mean to render <Context.Provider> instead?")), Z.Provider;
        }, set: function(pe) {
          Z.Provider = pe;
        } }, _currentValue: { get: function() {
          return Z._currentValue;
        }, set: function(pe) {
          Z._currentValue = pe;
        } }, _currentValue2: { get: function() {
          return Z._currentValue2;
        }, set: function(pe) {
          Z._currentValue2 = pe;
        } }, _threadCount: { get: function() {
          return Z._threadCount;
        }, set: function(pe) {
          Z._threadCount = pe;
        } }, Consumer: { get: function() {
          return Q || (Q = !0, x("Rendering <Context.Consumer.Consumer> is not supported and will be removed in a future major release. Did you mean to render <Context.Consumer> instead?")), Z.Consumer;
        } }, displayName: { get: function() {
          return Z.displayName;
        }, set: function(pe) {
          ve || (O("Setting `displayName` on Context.Consumer has no effect. You should set it directly on the context with Context.displayName = '%s'.", pe), ve = !0);
        } } }), Z.Consumer = me;
      }
      return Z._currentRenderer = null, Z._currentRenderer2 = null, Z;
    }
    var E3 = -1, bo = 0, S1 = 1, $3 = 2;
    function P3(z) {
      if (z._status === E3) {
        var K = z._result, Z = K(), Q = z;
        Q._status = bo, Q._result = Z, Z.then(function(ce) {
          if (z._status === bo) {
            var ve = ce.default;
            ve === void 0 && x(`lazy: Expected the result of a dynamic import() call. Instead received: %s

Your code should look like: 
  const MyComponent = lazy(() => import('./MyComponent'))`, ce);
            var me = z;
            me._status = S1, me._result = ve;
          }
        }, function(ce) {
          if (z._status === bo) {
            var ve = z;
            ve._status = $3, ve._result = ce;
          }
        });
      }
      if (z._status === S1)
        return z._result;
      throw z._result;
    }
    function C3(z) {
      var K = { _status: -1, _result: z }, Z = { $$typeof: f, _payload: K, _init: P3 };
      {
        var Q, ce;
        Object.defineProperties(Z, { defaultProps: { configurable: !0, get: function() {
          return Q;
        }, set: function(ve) {
          x("React.lazy(...): It is not supported to assign `defaultProps` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), Q = ve, Object.defineProperty(Z, "defaultProps", { enumerable: !0 });
        } }, propTypes: { configurable: !0, get: function() {
          return ce;
        }, set: function(ve) {
          x("React.lazy(...): It is not supported to assign `propTypes` to a lazy component import. Either specify them where the component is defined, or create a wrapping component around it."), ce = ve, Object.defineProperty(Z, "propTypes", { enumerable: !0 });
        } } });
      }
      return Z;
    }
    function S3(z) {
      z != null && z.$$typeof === u ? x("forwardRef requires a render function but received a `memo` component. Instead of forwardRef(memo(...)), use memo(forwardRef(...)).") : typeof z != "function" ? x("forwardRef requires a render function but was given %s.", z === null ? "null" : typeof z) : z.length !== 0 && z.length !== 2 && x("forwardRef render functions accept exactly two parameters: props and ref. %s", z.length === 1 ? "Did you forget to use the ref parameter?" : "Any additional parameter will be undefined."), z != null && (z.defaultProps != null || z.propTypes != null) && x("forwardRef render functions do not support propTypes or defaultProps. Did you accidentally pass a React component?");
      var K = { $$typeof: l, render: z };
      {
        var Z;
        Object.defineProperty(K, "displayName", { enumerable: !1, configurable: !0, get: function() {
          return Z;
        }, set: function(Q) {
          Z = Q, z.displayName == null && (z.displayName = Q);
        } });
      }
      return K;
    }
    var k3 = !1;
    function k1(z) {
      return !!(typeof z == "string" || typeof z == "function" || z === e.Fragment || z === e.Profiler || z === E || z === e.StrictMode || z === e.Suspense || z === s || z === b || k3 || typeof z == "object" && z !== null && (z.$$typeof === f || z.$$typeof === u || z.$$typeof === i || z.$$typeof === o || z.$$typeof === l || z.$$typeof === v || z.$$typeof === h || z[0] === g));
    }
    function T3(z, K) {
      k1(z) || x("memo: The first argument must be a component. Instead received: %s", z === null ? "null" : typeof z);
      var Z = { $$typeof: u, type: z, compare: K === void 0 ? null : K };
      {
        var Q;
        Object.defineProperty(Z, "displayName", { enumerable: !1, configurable: !0, get: function() {
          return Q;
        }, set: function(ce) {
          Q = ce, z.displayName == null && (z.displayName = ce);
        } });
      }
      return Z;
    }
    function _t() {
      var z = V.current;
      if (z === null)
        throw Error(`Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:
1. You might have mismatching versions of React and the renderer (such as React DOM)
2. You might be breaking the Rules of Hooks
3. You might have more than one copy of React in the same app
See https://reactjs.org/link/invalid-hook-call for tips about how to debug and fix this problem.`);
      return z;
    }
    function A3(z, K) {
      var Z = _t();
      if (K !== void 0 && x("useContext() second argument is reserved for future use in React. Passing it is not supported. You passed: %s.%s", K, typeof K == "number" && Array.isArray(arguments[2]) ? `

Did you call array.map(useContext)? Calling Hooks inside a loop is not supported. Learn more at https://reactjs.org/link/rules-of-hooks` : ""), z._context !== void 0) {
        var Q = z._context;
        Q.Consumer === z ? x("Calling useContext(Context.Consumer) is not supported, may cause bugs, and will be removed in a future major release. Did you mean to call useContext(Context) instead?") : Q.Provider === z && x("Calling useContext(Context.Provider) is not supported. Did you mean to call useContext(Context) instead?");
      }
      return Z.useContext(z, K);
    }
    function O3(z) {
      var K = _t();
      return K.useState(z);
    }
    function z3(z, K, Z) {
      var Q = _t();
      return Q.useReducer(z, K, Z);
    }
    function M3(z) {
      var K = _t();
      return K.useRef(z);
    }
    function _3(z, K) {
      var Z = _t();
      return Z.useEffect(z, K);
    }
    function L3(z, K) {
      var Z = _t();
      return Z.useLayoutEffect(z, K);
    }
    function I3(z, K) {
      var Z = _t();
      return Z.useCallback(z, K);
    }
    function D3(z, K) {
      var Z = _t();
      return Z.useMemo(z, K);
    }
    function N3(z, K, Z) {
      var Q = _t();
      return Q.useImperativeHandle(z, K, Z);
    }
    function R3(z, K) {
      {
        var Z = _t();
        return Z.useDebugValue(z, K);
      }
    }
    var xr = 0, T1, A1, O1, z1, M1, _1, L1;
    function I1() {
    }
    I1.__reactDisabledLog = !0;
    function B3() {
      {
        if (xr === 0) {
          T1 = console.log, A1 = console.info, O1 = console.warn, z1 = console.error, M1 = console.group, _1 = console.groupCollapsed, L1 = console.groupEnd;
          var z = { configurable: !0, enumerable: !0, value: I1, writable: !0 };
          Object.defineProperties(console, { info: z, log: z, warn: z, error: z, group: z, groupCollapsed: z, groupEnd: z });
        }
        xr++;
      }
    }
    function V3() {
      {
        if (xr--, xr === 0) {
          var z = { configurable: !0, enumerable: !0, writable: !0 };
          Object.defineProperties(console, { log: t({}, z, { value: T1 }), info: t({}, z, { value: A1 }), warn: t({}, z, { value: O1 }), error: t({}, z, { value: z1 }), group: t({}, z, { value: M1 }), groupCollapsed: t({}, z, { value: _1 }), groupEnd: t({}, z, { value: L1 }) });
        }
        xr < 0 && x("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var wo = m.ReactCurrentDispatcher, xo;
    function ha(z, K, Z) {
      {
        if (xo === void 0)
          try {
            throw Error();
          } catch (ce) {
            var Q = ce.stack.trim().match(/\n( *(at )?)/);
            xo = Q && Q[1] || "";
          }
        return `
` + xo + z;
      }
    }
    var Eo = !1, va;
    {
      var F3 = typeof WeakMap == "function" ? WeakMap : Map;
      va = new F3();
    }
    function D1(z, K) {
      if (!z || Eo)
        return "";
      {
        var Z = va.get(z);
        if (Z !== void 0)
          return Z;
      }
      var Q;
      Eo = !0;
      var ce = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var ve;
      ve = wo.current, wo.current = null, B3();
      try {
        if (K) {
          var me = function() {
            throw Error();
          };
          if (Object.defineProperty(me.prototype, "props", { set: function() {
            throw Error();
          } }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(me, []);
            } catch (bt) {
              Q = bt;
            }
            Reflect.construct(z, [], me);
          } else {
            try {
              me.call();
            } catch (bt) {
              Q = bt;
            }
            z.call(me.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (bt) {
            Q = bt;
          }
          z();
        }
      } catch (bt) {
        if (bt && Q && typeof bt.stack == "string") {
          for (var pe = bt.stack.split(`
`), Oe = Q.stack.split(`
`), _e = pe.length - 1, Ne = Oe.length - 1; _e >= 1 && Ne >= 0 && pe[_e] !== Oe[Ne]; )
            Ne--;
          for (; _e >= 1 && Ne >= 0; _e--, Ne--)
            if (pe[_e] !== Oe[Ne]) {
              if (_e !== 1 || Ne !== 1)
                do
                  if (_e--, Ne--, Ne < 0 || pe[_e] !== Oe[Ne]) {
                    var je = `
` + pe[_e].replace(" at new ", " at ");
                    return typeof z == "function" && va.set(z, je), je;
                  }
                while (_e >= 1 && Ne >= 0);
              break;
            }
        }
      } finally {
        Eo = !1, wo.current = ve, V3(), Error.prepareStackTrace = ce;
      }
      var ft = z ? z.displayName || z.name : "", ut = ft ? ha(ft) : "";
      return typeof z == "function" && va.set(z, ut), ut;
    }
    function N1(z, K, Z) {
      return D1(z, !1);
    }
    function H3(z) {
      var K = z.prototype;
      return !!(K && K.isReactComponent);
    }
    function ma(z, K, Z) {
      if (z == null)
        return "";
      if (typeof z == "function")
        return D1(z, H3(z));
      if (typeof z == "string")
        return ha(z);
      switch (z) {
        case e.Suspense:
          return ha("Suspense");
        case s:
          return ha("SuspenseList");
      }
      if (typeof z == "object")
        switch (z.$$typeof) {
          case l:
            return N1(z.render);
          case u:
            return ma(z.type, K, Z);
          case h:
            return N1(z._render);
          case f: {
            var Q = z, ce = Q._payload, ve = Q._init;
            try {
              return ma(ve(ce), K, Z);
            } catch {
            }
          }
        }
      return "";
    }
    var R1 = {}, B1 = m.ReactDebugCurrentFrame;
    function ga(z) {
      if (z) {
        var K = z._owner, Z = ma(z.type, z._source, K ? K.type : null);
        B1.setExtraStackFrame(Z);
      } else
        B1.setExtraStackFrame(null);
    }
    function K3(z, K, Z, Q, ce) {
      {
        var ve = Function.call.bind(Object.prototype.hasOwnProperty);
        for (var me in z)
          if (ve(z, me)) {
            var pe = void 0;
            try {
              if (typeof z[me] != "function") {
                var Oe = Error((Q || "React class") + ": " + Z + " type `" + me + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof z[me] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw Oe.name = "Invariant Violation", Oe;
              }
              pe = z[me](K, me, Q, Z, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (_e) {
              pe = _e;
            }
            pe && !(pe instanceof Error) && (ga(ce), x("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", Q || "React class", Z, me, typeof pe), ga(null)), pe instanceof Error && !(pe.message in R1) && (R1[pe.message] = !0, ga(ce), x("Failed %s type: %s", Z, pe.message), ga(null));
          }
      }
    }
    function Kn(z) {
      if (z) {
        var K = z._owner, Z = ma(z.type, z._source, K ? K.type : null);
        p(Z);
      } else
        p(null);
    }
    var $o;
    $o = !1;
    function V1() {
      if (_.current) {
        var z = ee(_.current.type);
        if (z)
          return `

Check the render method of \`` + z + "`.";
      }
      return "";
    }
    function j3(z) {
      if (z !== void 0) {
        var K = z.fileName.replace(/^.*[\\\/]/, ""), Z = z.lineNumber;
        return `

Check your code at ` + K + ":" + Z + ".";
      }
      return "";
    }
    function U3(z) {
      return z != null ? j3(z.__source) : "";
    }
    var F1 = {};
    function W3(z) {
      var K = V1();
      if (!K) {
        var Z = typeof z == "string" ? z : z.displayName || z.name;
        Z && (K = `

Check the top-level render call using <` + Z + ">.");
      }
      return K;
    }
    function H1(z, K) {
      if (!(!z._store || z._store.validated || z.key != null)) {
        z._store.validated = !0;
        var Z = W3(K);
        if (!F1[Z]) {
          F1[Z] = !0;
          var Q = "";
          z && z._owner && z._owner !== _.current && (Q = " It was passed a child from " + ee(z._owner.type) + "."), Kn(z), x('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Z, Q), Kn(null);
        }
      }
    }
    function K1(z, K) {
      if (typeof z == "object") {
        if (Array.isArray(z))
          for (var Z = 0; Z < z.length; Z++) {
            var Q = z[Z];
            ln(Q) && H1(Q, K);
          }
        else if (ln(z))
          z._store && (z._store.validated = !0);
        else if (z) {
          var ce = A(z);
          if (typeof ce == "function" && ce !== z.entries)
            for (var ve = ce.call(z), me; !(me = ve.next()).done; )
              ln(me.value) && H1(me.value, K);
        }
      }
    }
    function j1(z) {
      {
        var K = z.type;
        if (K == null || typeof K == "string")
          return;
        var Z;
        if (typeof K == "function")
          Z = K.propTypes;
        else if (typeof K == "object" && (K.$$typeof === l || K.$$typeof === u))
          Z = K.propTypes;
        else
          return;
        if (Z) {
          var Q = ee(K);
          K3(Z, z.props, "prop", Q, z);
        } else if (K.PropTypes !== void 0 && !$o) {
          $o = !0;
          var ce = ee(K);
          x("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", ce || "Unknown");
        }
        typeof K.getDefaultProps == "function" && !K.getDefaultProps.isReactClassApproved && x("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function q3(z) {
      {
        for (var K = Object.keys(z.props), Z = 0; Z < K.length; Z++) {
          var Q = K[Z];
          if (Q !== "children" && Q !== "key") {
            Kn(z), x("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", Q), Kn(null);
            break;
          }
        }
        z.ref !== null && (Kn(z), x("Invalid attribute `ref` supplied to `React.Fragment`."), Kn(null));
      }
    }
    function U1(z, K, Z) {
      var Q = k1(z);
      if (!Q) {
        var ce = "";
        (z === void 0 || typeof z == "object" && z !== null && Object.keys(z).length === 0) && (ce += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
        var ve = U3(K);
        ve ? ce += ve : ce += V1();
        var me;
        z === null ? me = "null" : Array.isArray(z) ? me = "array" : z !== void 0 && z.$$typeof === r ? (me = "<" + (ee(z.type) || "Unknown") + " />", ce = " Did you accidentally export a JSX literal instead of a component?") : me = typeof z, x("React.createElement: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", me, ce);
      }
      var pe = Ve.apply(this, arguments);
      if (pe == null)
        return pe;
      if (Q)
        for (var Oe = 2; Oe < arguments.length; Oe++)
          K1(arguments[Oe], z);
      return z === e.Fragment ? q3(pe) : j1(pe), pe;
    }
    var W1 = !1;
    function Z3(z) {
      var K = U1.bind(null, z);
      return K.type = z, W1 || (W1 = !0, O("React.createFactory() is deprecated and will be removed in a future major release. Consider using JSX or use React.createElement() directly instead.")), Object.defineProperty(K, "type", { enumerable: !1, get: function() {
        return O("Factory.type is deprecated. Access the class directly before passing it to createFactory."), Object.defineProperty(this, "type", { value: z }), z;
      } }), K;
    }
    function G3(z, K, Z) {
      for (var Q = go.apply(this, arguments), ce = 2; ce < arguments.length; ce++)
        K1(arguments[ce], Q.type);
      return j1(Q), Q;
    }
    try {
      var UD = Object.freeze({});
    } catch {
    }
    var Y3 = U1, X3 = G3, J3 = Z3, Q3 = { map: pa, forEach: y3, count: g3, toArray: b3, only: w3 };
    e.Children = Q3, e.Component = L, e.PureComponent = U, e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = m, e.cloneElement = X3, e.createContext = x3, e.createElement = Y3, e.createFactory = J3, e.createRef = X, e.forwardRef = S3, e.isValidElement = ln, e.lazy = C3, e.memo = T3, e.useCallback = I3, e.useContext = A3, e.useDebugValue = R3, e.useEffect = _3, e.useImperativeHandle = N3, e.useLayoutEffect = L3, e.useMemo = D3, e.useReducer = z3, e.useRef = M3, e.useState = O3, e.version = n;
  }();
}), B = Ui((e, t) => {
  process.env.NODE_ENV === "production" ? t.exports = s4() : t.exports = c4();
}), qn = R(B()), u4 = (e) => qn.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, qn.createElement("path", { d: "m31.52 22.83-1.75-1.93-.12-2.59a1 1 0 0 0-1-1l-2.59-.12-1.93-1.75a1 1 0 0 0-1.34 0l-1.89 1.79-2.59.12a1 1 0 0 0-1 1l-.12 2.59-1.75 1.93a1 1 0 0 0 0 1.34l1.75 1.93.12 2.59a1 1 0 0 0 1 1l2.59.12 1.93 1.75a1 1 0 0 0 1.34 0l1.93-1.75 2.59-.12a1 1 0 0 0 1-1l.12-2.59 1.75-1.93a1 1 0 0 0-.04-1.38zm-7.18 4.48-.84.77-.84-.77a2 2 0 0 0-1.26-.52l-1.13-.06-.06-1.13a2 2 0 0 0-.52-1.26l-.77-.84.77-.84a2 2 0 0 0 .52-1.26l.06-1.14 1.13-.05a2 2 0 0 0 1.26-.52l.84-.77.84.77a2 2 0 0 0 1.26.52l1.13.05.06 1.14a2 2 0 0 0 .52 1.26l.77.84-.77.84a2 2 0 0 0-.52 1.26l-.06 1.13-1.13.06a2 2 0 0 0-1.26.52z" }), qn.createElement("rect", { height: 3, rx: 1, width: 12, x: 10, y: 5 }), qn.createElement("rect", { height: 3, rx: 1, width: 12, x: 10, y: 10 }), qn.createElement("rect", { height: 3, rx: 1, width: 6, x: 10, y: 15 }), qn.createElement("path", { d: "M15 29H8V3h16v9a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v30a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1z" })), d4 = u4, No = R(B()), f4 = (e) => No.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, No.createElement("path", { d: "M24 9h-8a1 1 0 0 0-1 1v8H4V9a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-5h24v5a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V16a7 7 0 0 0-7-7z" }), No.createElement("circle", { cx: 9.5, cy: 12.5, r: 4.5 })), p4 = f4, A0 = R(B()), h4 = (e) => A0.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, A0.createElement("path", { d: "M16 5.5A10.5 10.5 0 1 0 26.5 16 10.5 10.5 0 0 0 16 5.5Zm0 3a7.52 7.52 0 0 1 7.35 6H8.65a7.52 7.52 0 0 1 7.35-6Zm0 15a7.52 7.52 0 0 1-7.35-6h14.7a7.52 7.52 0 0 1-7.35 6Z" })), v4 = h4, O0 = R(B()), m4 = (e) => O0.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, O0.createElement("path", { d: "M27.41 4.59a2 2 0 0 0-2.82 0l-5.65 5.65L5.05 6.45a1 1 0 0 0-1 .26L2.67 8.12a1 1 0 0 0 .22 1.58l10.66 5.92-5.25 5.25-4-1a1 1 0 0 0-1 .26L2 21.56a1 1 0 0 0-.28.89 1 1 0 0 0 .59.73l4.58 2 2 4.58a1 1 0 0 0 .73.59h.19a1 1 0 0 0 .7-.29l1.42-1.41a1 1 0 0 0 .26-.95l-1-4 5.25-5.25 5.86 10.66a1 1 0 0 0 .73.51h.14a1 1 0 0 0 .71-.3l1.41-1.41a1 1 0 0 0 .26-1l-3.79-13.85 5.65-5.65a2 2 0 0 0 0-2.82z" })), g4 = m4, z0 = R(B()), y4 = (e) => z0.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, z0.createElement("path", { fillRule: "evenodd", d: "M16 32a16 16 0 1 1 0-32 16 16 0 0 1 0 32Zm0-3a13 13 0 1 0 0-26 13 13 0 0 0 0 26Zm0-10a1.5 1.5 0 0 1-1.5-1.5v-10a1.5 1.5 0 1 1 3 0v10A1.5 1.5 0 0 1 16 19Zm0 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z" })), b4 = y4, M0 = R(B()), w4 = (e) => M0.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, M0.createElement("path", { fillRule: "evenodd", d: "M16 32a16 16 0 1 1 0-32 16 16 0 0 1 0 32Zm0-3a13 13 0 1 0 0-26 13 13 0 0 0 0 26Zm0-10a1.5 1.5 0 0 1-1.5-1.5v-10a1.5 1.5 0 1 1 3 0v10A1.5 1.5 0 0 1 16 19Zm0 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z" })), x4 = w4, _0 = R(B()), E4 = (e) => _0.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, _0.createElement("path", { fillRule: "evenodd", d: "M16 32a16 16 0 1 0 0-32 16 16 0 0 0 0 32ZM14.5 7a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V7ZM16 22a2 2 0 1 1 0 4 2 2 0 0 1 0-4Z" })), $4 = E4, L0 = R(B()), P4 = (e) => L0.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, L0.createElement("path", { fillRule: "evenodd", d: "M16 19a1.5 1.5 0 0 1-1.5-1.5v-10a1.5 1.5 0 1 1 3 0v10A1.5 1.5 0 0 1 16 19Zm0 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z" })), C4 = P4, Ro = R(B()), S4 = (e) => Ro.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Ro.createElement("path", { d: "M18.06 17.41A2.46 2.46 0 0 0 18.5 16a2.5 2.5 0 0 0-5 0 2.46 2.46 0 0 0 .44 1.41L9.6 30.3a1 1 0 0 0 .63 1.26l.95.32a.86.86 0 0 0 .32.05 1 1 0 0 0 .44-.1 1 1 0 0 0 .51-.58L16 20.69l3.55 10.56a1 1 0 0 0 .51.58 1 1 0 0 0 .44.1.86.86 0 0 0 .32-.05l.95-.32a1 1 0 0 0 .63-1.26z" }), Ro.createElement("path", { d: "M30.68 12.9a1 1 0 0 0-1.15-.81l-1.53.28a12.43 12.43 0 0 0-2.84-4.9l1-1.23A1 1 0 0 0 26 4.83l-.76-.64a1 1 0 0 0-.71-.19 1 1 0 0 0-.68.35l-1 1.22A12.38 12.38 0 0 0 17.5 3.6V2a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v1.6a12.38 12.38 0 0 0-5.33 1.93l-1-1.22a1 1 0 0 0-.7-.31 1 1 0 0 0-.73.23l-.74.6a1 1 0 0 0-.13 1.41l1 1.23A12.43 12.43 0 0 0 4 12.37l-1.57-.28a1 1 0 0 0-1.15.81l-.18 1a.93.93 0 0 0 .17.74 1 1 0 0 0 .64.42l1.59.28a12.58 12.58 0 0 0 1 5.57l-1.38.8a1 1 0 0 0-.37 1.37l.5.86a1 1 0 0 0 1.37.37L6 23.5a11.89 11.89 0 0 0 1.14 1.34 1 1 0 0 0 .7.29 1 1 0 0 0 .71-.29l.71-.71a1 1 0 0 0 0-1.41 7.29 7.29 0 0 1-.63-.72l1.19-.69a1 1 0 0 0 .37-1.37l-.5-.86a1 1 0 0 0-1.37-.37l-1.19.69a9.58 9.58 0 0 1-.62-3.54l1.35.24H8a1 1 0 0 0 1-.82l.17-1a1 1 0 0 0-.81-1.16L7 12.9a9.47 9.47 0 0 1 1.8-3.11l.88 1.05a1 1 0 0 0 .68.35h.08a1 1 0 0 0 .65-.23l.76-.64A1 1 0 0 0 12 8.91l-.88-1a9.45 9.45 0 0 1 3.38-1.28V8a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V6.63a9.45 9.45 0 0 1 3.37 1.23l-.88 1a1 1 0 0 0 .13 1.41l.76.64a1 1 0 0 0 .65.23h.08a1 1 0 0 0 .68-.35l.88-1.05A9.47 9.47 0 0 1 25 12.9l-1.35.23a1 1 0 0 0-.81 1.16l.17 1a1 1 0 0 0 1 .82h.18l1.35-.24a9.58 9.58 0 0 1-.62 3.54l-1.19-.69a1 1 0 0 0-1.37.37l-.5.86a1 1 0 0 0 .37 1.37l1.19.69c-.2.25-.42.49-.65.73a1 1 0 0 0-.31.67 1 1 0 0 0 .29.74l.71.7a1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29A11.7 11.7 0 0 0 26 23.5l1.39.8a1 1 0 0 0 1.37-.37l.5-.86a1 1 0 0 0-.37-1.37l-1.38-.8a12.58 12.58 0 0 0 1-5.57l1.59-.28a1 1 0 0 0 .64-.42.93.93 0 0 0 .17-.74z" })), k4 = S4, I0 = R(B()), T4 = (e) => I0.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, I0.createElement("path", { d: "m26.71 18.29-.71-.71a1 1 0 0 0-.7-.29 1 1 0 0 0-.71.29l-7.09 7.1V3a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v21.68l-7.09-7.1a1 1 0 0 0-1.41 0l-.71.71a1 1 0 0 0 0 1.41l9.65 9.66.35.35a1.15 1.15 0 0 0 .33.21.94.94 0 0 0 .76 0 1.15 1.15 0 0 0 .33-.21l.35-.35 9.65-9.66a1 1 0 0 0 0-1.41z" })), A4 = T4, D0 = R(B()), O4 = (e) => D0.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, D0.createElement("path", { d: "M29 14.5H7.32l7.1-7.09a1 1 0 0 0 .29-.71 1 1 0 0 0-.29-.7l-.71-.71a1 1 0 0 0-1.41 0l-10 10a.87.87 0 0 0-.15.24.86.86 0 0 0 0 .94.87.87 0 0 0 .15.24l10 10a1 1 0 0 0 .7.29 1 1 0 0 0 .7-.29l.71-.71a1 1 0 0 0 .29-.7 1 1 0 0 0-.29-.71L7.32 17.5H29a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1z" })), z4 = O4, N0 = R(B()), M4 = (e) => N0.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, N0.createElement("path", { d: "M30 16.5a1 1 0 0 0-.14-.47.87.87 0 0 0-.15-.24l-10-10a1 1 0 0 0-1.41 0l-.71.71a1 1 0 0 0-.29.7 1 1 0 0 0 .29.71L24.68 15H3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h21.68l-7.1 7.09a1 1 0 0 0-.29.71 1 1 0 0 0 .29.7l.71.71a1 1 0 0 0 .7.29 1 1 0 0 0 .71-.29l10-10a.87.87 0 0 0 .15-.24 1 1 0 0 0 .15-.47z" })), _4 = M4, R0 = R(B()), L4 = (e) => R0.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, R0.createElement("path", { d: "m26.71 12.3-10-10A1 1 0 0 0 16 2a1 1 0 0 0-.71.29l-10 10a1 1 0 0 0 0 1.41l.71.71a1 1 0 0 0 .7.29 1 1 0 0 0 .71-.29l7.09-7.1V29a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V7.32l7.09 7.1a1 1 0 0 0 .71.29 1 1 0 0 0 .7-.29l.71-.71a1 1 0 0 0 0-1.41z" })), I4 = L4, B0 = R(B()), D4 = (e) => B0.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, B0.createElement("path", { d: "M16 8.5A7.5 7.5 0 1 1 8.5 16 7.5 7.5 0 0 1 16 8.5m0-3A10.5 10.5 0 1 0 26.5 16 10.5 10.5 0 0 0 16 5.5Z" })), N4 = D4, V0 = R(B()), R4 = (e) => V0.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, V0.createElement("path", { d: "M15.33 4a1 1 0 0 0-1.07.17L6.62 11H2a1 1 0 0 0-1 1v8a1 1 0 0 0 .3.71A1.09 1.09 0 0 0 2 21h4.61l7.72 6.83A1 1 0 0 0 15 28a1 1 0 0 0 .41-.08A1 1 0 0 0 16 27l-.07-22a1 1 0 0 0-.6-1zM4 18v-4h3a2 2 0 0 0 1.33-.51l4.61-4.09.06 13.19-4.67-4.13A2 2 0 0 0 7 18zm22.12-2 3.94-3.94a1 1 0 0 0 0-1.41l-.71-.71a1 1 0 0 0-1.41 0L24 13.88l-3.94-3.94a1 1 0 0 0-1.41 0l-.71.71a1 1 0 0 0 0 1.41L21.88 16l-3.94 3.94a1 1 0 0 0 0 1.41l.71.71a1 1 0 0 0 .7.29 1 1 0 0 0 .71-.29L24 18.12l3.94 3.94a1 1 0 0 0 .71.29 1 1 0 0 0 .7-.29l.71-.71a1 1 0 0 0 0-1.41z" })), B4 = R4, F0 = R(B()), V4 = (e) => F0.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, F0.createElement("path", { d: "M15.33 4a1 1 0 0 0-1.07.17L6.62 11H2a1 1 0 0 0-1 1v8a1 1 0 0 0 .3.71A1.11 1.11 0 0 0 2 21h4.61l7.72 6.83A1 1 0 0 0 15 28a1 1 0 0 0 .41-.08A1 1 0 0 0 16 27l-.07-22a1 1 0 0 0-.6-1zm10.79 12 3.94-3.94a1 1 0 0 0 0-1.41l-.71-.71a1 1 0 0 0-1.41 0L24 13.88l-3.94-3.94a1 1 0 0 0-1.41 0l-.71.71a1 1 0 0 0 0 1.41L21.88 16l-3.94 3.94a1 1 0 0 0 0 1.41l.71.71a1 1 0 0 0 .7.29 1 1 0 0 0 .71-.29L24 18.12l3.94 3.94a1 1 0 0 0 .71.29 1 1 0 0 0 .7-.29l.71-.71a1 1 0 0 0 0-1.41z" })), F4 = V4, Bo = R(B()), H4 = (e) => Bo.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Bo.createElement("path", { d: "M15.33 4a1 1 0 0 0-1.07.17L6.62 11H2a1 1 0 0 0-1 1v8a1 1 0 0 0 .3.71A1.13 1.13 0 0 0 2 21h4.61l7.72 6.83A1 1 0 0 0 15 28a1 1 0 0 0 .41-.08A1 1 0 0 0 16 27l-.07-22a1 1 0 0 0-.6-1zm-7 14.42A2 2 0 0 0 7 18H4v-4h3a2 2 0 0 0 1.33-.51l4.61-4.09.06 13.19zM23.46 3.31a1.49 1.49 0 0 0-.14-.12l-.59-.3a1 1 0 0 0-1.35.42l-.46.89a1 1 0 0 0-.07.76 1.06 1.06 0 0 0 .49.59l.25.13a1.07 1.07 0 0 0 .21.13 11.51 11.51 0 0 1 0 20.42l-.38.19a1.06 1.06 0 0 0-.49.59 1 1 0 0 0 .07.76l.09.17a1.36 1.36 0 0 0 .11.28c0 .07.09.13.13.19l.13.25a1 1 0 0 0 .89.54 1 1 0 0 0 .46-.12l.59-.3h.06a14.49 14.49 0 0 0 0-25.45z" }), Bo.createElement("path", { d: "M22 22.36a1.06 1.06 0 0 0 .27-.29A8 8 0 0 0 22 9.78v-.1l-.54-.39a1 1 0 0 0-.75-.17 1 1 0 0 0-.65.4l-.58.81a1 1 0 0 0-.18.75 1 1 0 0 0 .4.65l.3.27h.06a5 5 0 0 1 0 7.92 1.61 1.61 0 0 0-.23.22l-.2.14a1 1 0 0 0-.22 1.39l.58.82a1 1 0 0 0 .65.4h.16a1 1 0 0 0 .59-.19z" })), K4 = H4, Vo = R(B()), j4 = (e) => Vo.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Vo.createElement("path", { d: "M15.33 4a1 1 0 0 0-1.07.17L6.62 11H2a1 1 0 0 0-1 1v8a1 1 0 0 0 .3.71A1.18 1.18 0 0 0 2 21h4.61l7.72 6.83A1 1 0 0 0 15 28a1 1 0 0 0 .41-.08A1 1 0 0 0 16 27l-.07-22a1 1 0 0 0-.6-1zM31 16a14.46 14.46 0 0 0-7.54-12.69 1.49 1.49 0 0 0-.14-.12l-.59-.3a1 1 0 0 0-1.35.42l-.46.89a1 1 0 0 0-.07.76 1.06 1.06 0 0 0 .49.59l.25.13a1.07 1.07 0 0 0 .21.13 11.51 11.51 0 0 1 0 20.42l-.38.19a1.06 1.06 0 0 0-.49.59 1 1 0 0 0 .07.76l.09.17a1.36 1.36 0 0 0 .11.28c0 .07.09.13.13.19l.13.25a1 1 0 0 0 .89.54 1 1 0 0 0 .46-.12l.59-.3h.06A14.45 14.45 0 0 0 31 16z" }), Vo.createElement("path", { d: "M22 22.36a1.06 1.06 0 0 0 .27-.29A8 8 0 0 0 22 9.78v-.1l-.54-.39a1 1 0 0 0-.75-.17 1 1 0 0 0-.65.4l-.58.81a1 1 0 0 0-.18.75 1 1 0 0 0 .4.65l.3.27h.06a5 5 0 0 1 0 7.92 1.61 1.61 0 0 0-.23.22l-.2.14a1 1 0 0 0-.22 1.39l.58.82a1 1 0 0 0 .65.4h.16a1 1 0 0 0 .59-.19z" })), U4 = j4, H0 = R(B()), W4 = (e) => H0.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, H0.createElement("path", { d: "M20.44 5.06a3.55 3.55 0 0 0 .06-.56 4.5 4.5 0 0 0-9 0 3.55 3.55 0 0 0 .06.56A10 10 0 0 0 6 14v17a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V14a10 10 0 0 0-5.56-8.94zM16 2a2.49 2.49 0 0 1 2.48 2.32 9.77 9.77 0 0 0-5 0A2.49 2.49 0 0 1 16 2zm-2.83 9.79 2.12-2.12a1 1 0 0 1 1.42 0l2.12 2.12a1 1 0 0 1 0 1.42l-2.12 2.12a1 1 0 0 1-1.42 0l-2.12-2.12a1 1 0 0 1 0-1.42zM23 28a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1v-7a1 1 0 0 1 1-1h1v3a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-3h8a1 1 0 0 1 1 1z" })), q4 = W4, K0 = R(B()), Z4 = (e) => K0.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, K0.createElement("path", { d: "M16.21 21a6.13 6.13 0 0 0 2.31-1.85 12.41 12.41 0 0 0 6.23-10.4 8.75 8.75 0 0 0-17.5 0 12.38 12.38 0 0 0 6.24 10.39A3.27 3.27 0 0 0 12 21.83c0 2 1.68 2.89 2.79 3.49.39.21 1.21.66 1.21.85s-.82.63-1.21.84c-1.11.61-2.79 1.51-2.79 3.49v.5a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-.5c0-.19.82-.63 1.21-.85 1.11-.6 2.79-1.51 2.79-3.48s-1.68-2.89-2.79-3.49c-.39-.21-1.21-.68-1.21-.85s.82-.63 1.21-.83zm-6-12.24a5.75 5.75 0 0 1 11.5 0c0 3.19-2.48 7.3-5.75 8.18-3.23-.89-5.71-5-5.71-8.19z" })), G4 = Z4, j0 = R(B()), Y4 = (e) => j0.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, j0.createElement("path", { d: "M16.21 21a6.13 6.13 0 0 0 2.31-1.85 12.41 12.41 0 0 0 6.23-10.4 8.75 8.75 0 0 0-17.5 0 12.38 12.38 0 0 0 6.24 10.39A3.27 3.27 0 0 0 12 21.83c0 2 1.68 2.89 2.79 3.49.39.21 1.21.66 1.21.85s-.82.63-1.21.84c-1.11.61-2.79 1.51-2.79 3.49v.5a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-.5c0-.19.82-.63 1.21-.85 1.11-.6 2.79-1.51 2.79-3.48s-1.68-2.89-2.79-3.49c-.39-.21-1.21-.68-1.21-.85s.82-.63 1.21-.83z" })), X4 = Y4, U0 = R(B()), J4 = (e) => U0.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, U0.createElement("path", { d: "M27.2 4.59a25.45 25.45 0 0 0-2.65 9.91h7.37a15.88 15.88 0 0 0-4.72-9.91zm-2.38-1.94A16 16 0 0 0 17.5.08V14.5h4.05a28.5 28.5 0 0 1 3.27-11.85zM.08 17.5a15.88 15.88 0 0 0 4.72 9.91 25.45 25.45 0 0 0 2.65-9.91zm24.47 0a25.45 25.45 0 0 0 2.65 9.91 15.88 15.88 0 0 0 4.72-9.91zm-17.1-3A25.45 25.45 0 0 0 4.8 4.59 15.88 15.88 0 0 0 .08 14.5zm14.1 3H17.5v14.42a16 16 0 0 0 7.32-2.57 28.5 28.5 0 0 1-3.27-11.85zm-7.05-3V.08a16 16 0 0 0-7.32 2.57 28.5 28.5 0 0 1 3.27 11.85zm0 3h-4.05a28.5 28.5 0 0 1-3.27 11.85 16 16 0 0 0 7.32 2.57z" })), Q4 = J4, Fo = R(B()), ew = (e) => Fo.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Fo.createElement("path", { d: "m6.38 8.1 7.85 3.25-3.39 8.17a1 1 0 0 0 .55 1.31l.92.38a1 1 0 0 0 .38.08 1.09 1.09 0 0 0 .39-.08 1 1 0 0 0 .54-.54L17 12.5l7.85 3.25a1.09 1.09 0 0 0 .39.08 1 1 0 0 0 .92-.62A11 11 0 0 0 5.83 6.79a1 1 0 0 0 .55 1.31zM16 3a8 8 0 0 1 7.92 9.12L9.6 6.19A8 8 0 0 1 16 3zm13 26h-.5a4.08 4.08 0 0 1-3.13-1.58A6.81 6.81 0 0 0 15 27.4a4.08 4.08 0 0 1-3.17 1.6 4.08 4.08 0 0 1-3.13-1.6A7 7 0 0 0 3.86 25a.45.45 0 0 0-.11 0H3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h.5c1.48 0 2.17.67 3.13 1.59a6.83 6.83 0 0 0 10.41 0 3.87 3.87 0 0 1 6.25 0A7.06 7.06 0 0 0 28.14 32H29a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1z" }), Fo.createElement("path", { d: "M29 23h-.5a4.08 4.08 0 0 1-3.13-1.58A6.81 6.81 0 0 0 15 21.4a4.08 4.08 0 0 1-3.17 1.6 4.08 4.08 0 0 1-3.13-1.6A7 7 0 0 0 3.86 19a.45.45 0 0 0-.11 0H3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h.5c1.48 0 2.17.67 3.13 1.59a6.83 6.83 0 0 0 10.41 0 3.87 3.87 0 0 1 6.25 0A7.06 7.06 0 0 0 28.14 26H29a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1z" })), tw = ew, W0 = R(B()), nw = (e) => W0.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, W0.createElement("path", { d: "M29 25h-.5a4.08 4.08 0 0 1-3.13-1.58 6.81 6.81 0 0 0-10.41 0A4.08 4.08 0 0 1 11.83 25a4.08 4.08 0 0 1-3.13-1.58A7 7 0 0 0 3.86 21H3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h.5a4.08 4.08 0 0 1 3.13 1.58 6.81 6.81 0 0 0 10.41 0 3.88 3.88 0 0 1 6.25 0A7 7 0 0 0 28.14 28H29a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zm0-8.5h-.5a4.08 4.08 0 0 1-3.13-1.58 6.81 6.81 0 0 0-10.41 0 4.08 4.08 0 0 1-3.13 1.58 4.08 4.08 0 0 1-3.13-1.58 7 7 0 0 0-4.84-2.4H3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h.5a4.08 4.08 0 0 1 3.13 1.58 6.81 6.81 0 0 0 10.41 0 3.88 3.88 0 0 1 6.25 0 7 7 0 0 0 4.85 2.4H29a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zM29 8h-.5a4.08 4.08 0 0 1-3.13-1.58 6.81 6.81 0 0 0-10.37 0A4.08 4.08 0 0 1 11.83 8 4.08 4.08 0 0 1 8.7 6.42 7 7 0 0 0 3.86 4H3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h.5a4.08 4.08 0 0 1 3.13 1.58 6.89 6.89 0 0 0 5.2 2.42A6.93 6.93 0 0 0 17 8.58a3.88 3.88 0 0 1 6.25 0A7 7 0 0 0 28.14 11H29a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1z" })), rw = nw, q0 = R(B()), aw = (e) => q0.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, q0.createElement("path", { d: "M28.71 20.29 26 17.59V13a9.94 9.94 0 0 0-5-8.68 5 5 0 0 0-9.9 0A9.94 9.94 0 0 0 6 13v4.59l-2.71 2.7A1 1 0 0 0 3 21v2a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1v-2a1 1 0 0 0-.29-.71zM12.9 6.73l1.1-.54V5a2 2 0 0 1 4 0v1.22l1.09.54A7 7 0 0 1 23 13v5.83l.59.58L25.17 21H6.83l1.58-1.59.59-.58V13a7 7 0 0 1 3.9-6.27zM21 27h-2v1c0 .3 0 1-3 1s-3-.7-3-1v-1h-2a1 1 0 0 0-1 1c0 2.24 2.64 4 6 4s6-1.76 6-4a1 1 0 0 0-1-1z" })), iw = aw, Z0 = R(B()), ow = (e) => Z0.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Z0.createElement("path", { d: "M29.71 20.29 26 16.59V13a10 10 0 0 0-6-9.17 4 4 0 0 0-8 0A10 10 0 0 0 6 13v3.59l-3.71 3.7A1 1 0 0 0 2 21v2a1 1 0 0 0 .29.71A1 1 0 0 0 3 24h26a1 1 0 0 0 1-1v-2a1.05 1.05 0 0 0-.29-.71zM21 27H11a1 1 0 0 0-1 1c0 2.24 2.64 4 6 4s6-1.76 6-4a1 1 0 0 0-1-1z" })), lw = ow, Ho = R(B()), sw = (e) => Ho.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Ho.createElement("rect", { x: 17.51, width: 10.5, height: 3, rx: 1 }), Ho.createElement("path", { d: "M27 0h-1a1 1 0 0 0-1 1v.22a1 1 0 0 0-.37.23l-8.48 8.49a1.32 1.32 0 0 0-.19.29 7 7 0 1 0-5.43 12.61.9.9 0 0 0 0 .16v2H8a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2.5v3a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-3H16a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-2.5v-2a.9.9 0 0 0 0-.16 7 7 0 0 0 4.46-10.55 1 1 0 0 0 .34-.22L25 5.33v4.18a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1ZM12 20a4 4 0 1 1 4-4 4 4 0 0 1-4 4Z" })), cw = sw, Ko = R(B()), uw = (e) => Ko.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Ko.createElement("path", { d: "M30 26h-1a5.84 5.84 0 0 0-4.27 1.9A2.91 2.91 0 0 1 22.5 29a3 3 0 0 1-2.24-1.1 5.74 5.74 0 0 0-8.53 0A3 3 0 0 1 9.49 29a3 3 0 0 1-2.23-1.1A5.79 5.79 0 0 0 3 26H2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a2.91 2.91 0 0 1 2.23 1.1 5.74 5.74 0 0 0 8.53 0 2.82 2.82 0 0 1 4.47 0 5.75 5.75 0 0 0 8.54 0A2.91 2.91 0 0 1 29 29h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1z" }), Ko.createElement("path", { d: "M30 21h-1a6.19 6.19 0 0 0-1 .09V14a1 1 0 0 0-.66-.94L24 11.85V5a1 1 0 0 0-1-1h-2V2a1 1 0 0 0-1-1h-8a1 1 0 0 0-1 1v2H9a1 1 0 0 0-1 1v6.85l-3.34 1.21A1 1 0 0 0 4 14v7.09A6.19 6.19 0 0 0 3 21H2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a2.91 2.91 0 0 1 2.23 1.1 5.74 5.74 0 0 0 8.53 0 2.82 2.82 0 0 1 4.47 0 5.75 5.75 0 0 0 8.54 0A2.91 2.91 0 0 1 29 24h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zm-18.5-3a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5zm4.84-8.94a1 1 0 0 0-.68 0L11 10.75V7h10v3.75zM20.5 18a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5z" })), dw = uw, jo = R(B()), fw = (e) => jo.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, jo.createElement("path", { d: "M28 26v-1a1 1 0 0 0-.38-.78 1 1 0 0 0-.84-.2L16 26.47 5.22 24a1 1 0 0 0-.84.2A1 1 0 0 0 4 25v1a1 1 0 0 0 .78 1l4.51 1-4.51 1A1 1 0 0 0 4 30v1a1 1 0 0 0 1 1h.22L16 29.53 26.78 32H27a1 1 0 0 0 1-1v-1a1 1 0 0 0-.78-1l-4.51-1 4.51-1a1 1 0 0 0 .78-1z" }), jo.createElement("path", { d: "M12.5 24.86a.9.9 0 0 0 .5.14 1 1 0 0 0 .73-.31 1 1 0 0 0 .1-1.24c-2.68-4-.21-7.55 1.11-9 1.18 1.51 3.47 5.14 2.11 9.22a1 1 0 0 0 1.46 1.18C29.19 18.46 24 7.66 23.89 7.55A1 1 0 0 0 22 8a5.09 5.09 0 0 1-1.29 2.91C21.21 4.3 15.65.23 15.58.19a1 1 0 0 0-1-.11 1 1 0 0 0-.59.8 24.58 24.58 0 0 1-2.29 7.8 24.51 24.51 0 0 0-1.81-5.13A1 1 0 0 0 8 4a17.4 17.4 0 0 1-1.29 5.58c-1.61 4.64-3.43 9.91 5.79 15.28z" })), pw = fw, Uo = R(B()), hw = (e) => Uo.createElement("svg", { width: 32, height: 32, xmlns: "http://www.w3.org/2000/svg", className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Uo.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M27.516 3.579A1.55 1.55 0 0 1 29.5 5.067v18.895a1.55 1.55 0 0 1-1.116 1.489L16 29.062 3.616 25.451A1.55 1.55 0 0 1 2.5 23.962V5.067a1.55 1.55 0 0 1 1.984-1.488L16 6.937 27.516 3.58ZM14.5 9.625 5.5 7v15.875l9 2.625V9.625Zm3 15.875 9-2.625V7l-9 2.625V25.5Z" }), Uo.createElement("path", { d: "M22 7.72a1 1 0 0 1 .684-.948l1-.333A1 1 0 0 1 25 7.387v4.892a1 1 0 0 1-.684.949l-1 .333A1 1 0 0 1 22 12.613V7.72Z" })), vw = hw, G0 = R(B()), mw = (e) => G0.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, G0.createElement("path", { d: "M13.77 7 3.27 4a1 1 0 0 0-.87.16A1 1 0 0 0 2 5v19a1 1 0 0 0 .73 1l10.5 3a.84.84 0 0 0 .27 0 1 1 0 0 0 1-1V8a1 1 0 0 0-.73-1zM29.6 4.2a1 1 0 0 0-.87-.2L27 4.53v6a1 1 0 0 1-.6.92l-1 .43a.93.93 0 0 1-.4.09 1 1 0 0 1-.55-.17 1 1 0 0 1-.45-.83V5.39L18.23 7a1 1 0 0 0-.73 1v19a1 1 0 0 0 1 1 .84.84 0 0 0 .27 0l10.5-3a1 1 0 0 0 .73-1V5a1 1 0 0 0-.4-.8z" })), gw = mw, Y0 = R(B()), yw = (e) => Y0.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Y0.createElement("path", { d: "M25 2H7a1 1 0 0 0-1 1v26a1 1 0 0 0 .53.88 1 1 0 0 0 1-.05L16 24.2l8.45 5.63A1 1 0 0 0 26 29V3a1 1 0 0 0-1-1zM9 25.26V5h14v20.26l-5.89-3.92L16 20.6l-1.11.74z" })), bw = yw, X0 = R(B()), ww = (e) => X0.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, X0.createElement("path", { d: "M25 2H7a1 1 0 0 0-1 1v26a1 1 0 0 0 .53.88 1 1 0 0 0 1-.05L16 24.2l8.45 5.63A1 1 0 0 0 26 29V3a1 1 0 0 0-1-1z" })), xw = ww, Sr = R(B()), Ew = (e) => Sr.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Sr.createElement("rect", { x: 2, y: 8, width: 5, height: 22, rx: 1, ry: 1 }), Sr.createElement("rect", { x: 10, y: 2, width: 5, height: 28, rx: 1, ry: 1 }), Sr.createElement("rect", { x: 18, y: 4, width: 5, height: 26, rx: 1, ry: 1 }), Sr.createElement("path", { d: "M29.05 11.88a1 1 0 0 0-1.11-.88l-3 .35a1 1 0 0 0-.66.37 1 1 0 0 0-.21.74L26 29.12a1 1 0 0 0 1 .88h.12l3-.35a1 1 0 0 0 .66-.37 1 1 0 0 0 .21-.74z" })), $w = Ew, Wo = R(B()), Pw = (e) => Wo.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Wo.createElement("path", { d: "M12 17.57V17a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v.57l10-2.22V11a1 1 0 0 0-1-1h-6.08a7 7 0 0 0-13.84 0H3a1 1 0 0 0-1 1v4.35zm1.17-9.4a4.1 4.1 0 0 1 5.66 0 4 4 0 0 1 1 1.83h-7.69a4 4 0 0 1 1.03-1.83zM14 18h4v3h-4z" }), Wo.createElement("path", { d: "M20.33 20.57a1.24 1.24 0 0 1-.33 0V22a1 1 0 0 1-1 1h-6a1 1 0 0 1-1-1v-1.39a1.24 1.24 0 0 1-.33 0L2 18.42V27a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1v-8.58z" })), Cw = Pw, qo = R(B()), Sw = (e) => qo.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, qo.createElement("rect", { height: 7, rx: 1, width: 26, x: 3, y: 23 }), qo.createElement("path", { d: "m30.91 15.79-.7-.7a1 1 0 0 0-1.42 0l-.35.35-.35.35L27 16.88l-1.94-1.94a1.49 1.49 0 0 0-2.12 0L21 16.88l-1.94-1.94a1.49 1.49 0 0 0-2.12 0L15 16.88l-1.94-1.94a1.49 1.49 0 0 0-2.12 0L9 16.88l-1.94-1.94a1.49 1.49 0 0 0-2.12 0l-2.15 2.15-.35.35-.35.35a1 1 0 0 0 0 1.42l.7.7a1 1 0 0 0 1.42 0l.35-.35.35-.35L6 18.12l1.94 1.94a1.49 1.49 0 0 0 2.12 0L12 18.12l1.94 1.94a1.49 1.49 0 0 0 2.12 0L18 18.12l1.94 1.94a1.49 1.49 0 0 0 2.12 0L24 18.12l1.94 1.94a1.5 1.5 0 0 0 2.12 0l2.15-2.15.35-.35.35-.35a1 1 0 0 0 0-1.42zM23 2H9a6 6 0 0 0-6 6v3a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1V8a6 6 0 0 0-6-6zM7.5 7A1.5 1.5 0 1 1 9 5.5 1.5 1.5 0 0 1 7.5 7zm3 3A1.5 1.5 0 1 1 12 8.5a1.5 1.5 0 0 1-1.5 1.5zm3-3A1.5 1.5 0 1 1 15 5.5 1.5 1.5 0 0 1 13.5 7z" })), kw = Sw, J0 = R(B()), Tw = (e) => J0.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, J0.createElement("path", { d: "M27 3H5a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h1v3a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-3h14v3a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-3h1a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM8 8a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1zm.5 16a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 8.5 24zm15 0a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5z" })), Aw = Tw, Q0 = R(B()), Ow = (e) => Q0.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Q0.createElement("path", { d: "M29 5h-6V3a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v2h-8V3a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v2H3a1 1 0 0 0-1 1v23a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm-19 6h1a1 1 0 0 0 1-1V8h8v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V8h4v5H5V8h4v2a1 1 0 0 0 1 1zm-5 5h22v11H5z" })), zw = Ow, eu = R(B()), Mw = (e) => eu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, eu.createElement("path", { d: "M29 5h-6V3a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v2h-8V3a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v2H3a1 1 0 0 0-1 1v23a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zm-19 6h1a1 1 0 0 0 1-1V8h8v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V8h4v5H5V8h4v2a1 1 0 0 0 1 1z" })), _w = Mw, Zo = R(B()), Lw = (e) => Zo.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Zo.createElement("path", { d: "M29 8h-6V5a1 1 0 0 0-1-1H10a1 1 0 0 0-1 1v3H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1zm-17 3V7h8v4h7v14H5V11h7z" }), Zo.createElement("path", { d: "M16 23a5.5 5.5 0 1 0-5.5-5.5A5.51 5.51 0 0 0 16 23zm0-8a2.5 2.5 0 1 1-2.5 2.5A2.5 2.5 0 0 1 16 15z" })), Iw = Lw, Go = R(B()), Dw = (e) => Go.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Go.createElement("circle", { cx: 16, cy: 18, r: 4.25 }), Go.createElement("path", { d: "M29 8h-6V5a1 1 0 0 0-1-1H10a1 1 0 0 0-1 1v3H3a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1zM16 25.25A7.25 7.25 0 1 1 23.25 18 7.26 7.26 0 0 1 16 25.25z" })), Nw = Dw, tu = R(B()), Rw = (e) => tu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, tu.createElement("path", { d: "M27.75 10.84 25.6 8.38l.3-3.26a1 1 0 0 0-.78-1.06l-3.19-.72L20.26.53A1 1 0 0 0 19 .12l-3 1.29-3-1.29a1 1 0 0 0-1.26.41l-1.67 2.81-3.19.72a1 1 0 0 0-.78 1.06l.3 3.26-2.15 2.46a1 1 0 0 0 0 1.32l2.15 2.46-.3 3.26a1 1 0 0 0 .78 1.06l1.85.42V30.5a1 1 0 0 0 .51.87 1 1 0 0 0 1 0L16 27.83l5.47 3.51a1 1 0 0 0 .54.16 1 1 0 0 0 1-1V19.42l2.12-.48a1 1 0 0 0 .78-1.06l-.3-3.26 2.15-2.46a1 1 0 0 0-.01-1.32zM23.06 13l-.57.65.08.85.18 1.94-1.9.43L20 17l-.44.74-1 1.67-1.79-.77-.77-.32-.79.34-1.79.77-1-1.67L12 17l-.84-.19-1.9-.43.18-1.94.08-.85-.58-.59-1.28-1.5L8.94 10l.57-.65-.08-.85-.18-1.9 1.9-.43L12 6l.44-.74 1-1.67 1.79.77.79.34.79-.34 1.79-.77 1 1.67.4.74.84.19 1.9.43-.18 1.94-.08.85.57.65 1.28 1.46zm-6 12L16 24.29 15 25l-3.22 2v-4.54a1 1 0 0 0 1.26.41l3-1.29 3 1.29a1 1 0 0 0 .4.08.93.93 0 0 0 .6-.21v4.09z" })), Bw = Rw, nu = R(B()), Vw = (e) => nu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, nu.createElement("path", { d: "M27.75 10.84 25.6 8.38l.3-3.26a1 1 0 0 0-.78-1.06l-3.19-.72L20.26.53A1 1 0 0 0 19 .12l-3 1.29-3-1.29a1 1 0 0 0-1.26.41l-1.67 2.81-3.19.72a1 1 0 0 0-.78 1.06l.3 3.26-2.15 2.46a1 1 0 0 0 0 1.32l2.15 2.46-.3 3.26a1 1 0 0 0 .78 1.06l1.85.42V30.5a1 1 0 0 0 .51.87 1 1 0 0 0 1 0L16 27.83l5.47 3.51a1 1 0 0 0 .54.16 1 1 0 0 0 1-1V19.42l2.12-.48a1 1 0 0 0 .78-1.06l-.3-3.26 2.15-2.46a1 1 0 0 0-.01-1.32z" })), Fw = Vw, ru = R(B()), Hw = (e) => ru.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, ru.createElement("path", { d: "m31.48 23.52-6.36-6.36a11 11 0 1 0-18.24 0L.52 23.52a1 1 0 0 0-.25 1 1 1 0 0 0 .76.69l4.8 1 1 4.8a1 1 0 0 0 .69.76 1 1 0 0 0 .29 0 1 1 0 0 0 .71-.29L16 24l7.52 7.52a1 1 0 0 0 .71.29 1 1 0 0 0 .29 0 1 1 0 0 0 .69-.76l1-4.8 4.8-1a1 1 0 0 0 .76-.69 1 1 0 0 0-.29-1.04zM9 26.71l-.36-1.78-.26-1.31-1.31-.26L5.29 23l3.61-3.61a11 11 0 0 0 5 2.41zm-.7-13.55v-.18a6.41 6.41 0 0 1-.16-.76v-.24A7.93 7.93 0 0 1 8 11a7.38 7.38 0 0 1 0-.82 8 8 0 0 1 1.37-3.65c.14-.21.3-.42.46-.62a8 8 0 0 1 12.34 0c.16.2.32.41.46.62A8 8 0 0 1 24 10.18a7.38 7.38 0 0 1 0 .82 7.93 7.93 0 0 1-.07 1v.24a6.41 6.41 0 0 1-.16.76v.18a8 8 0 0 1-15.4 0zm16.63 10.2-1.31.26-.26 1.31-.36 1.78-4.92-4.91a11 11 0 0 0 5-2.41L26.71 23z" })), Kw = Hw, au = R(B()), jw = (e) => au.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, au.createElement("path", { d: "m31.48 23.52-6.36-6.36a11 11 0 1 0-18.24 0L.52 23.52a1 1 0 0 0-.25 1 1 1 0 0 0 .76.69l4.8 1 1 4.8a1 1 0 0 0 .69.76 1 1 0 0 0 .29 0 1 1 0 0 0 .71-.29L16 24l7.52 7.52a1 1 0 0 0 .71.29 1 1 0 0 0 .29 0 1 1 0 0 0 .69-.76l1-4.8 4.8-1a1 1 0 0 0 .76-.69 1 1 0 0 0-.29-1.04z" })), Uw = jw, iu = R(B()), Ww = (e) => iu.createElement("svg", { width: 32, height: 32, xmlns: "http://www.w3.org/2000/svg", className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, iu.createElement("path", { d: "M2.5 5.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v12.879l5.44-5.44a1.5 1.5 0 0 1 2.12 0L16 15.88l6.379-6.38H20.5a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1.879l-7.44 7.44a1.5 1.5 0 0 1-2.12 0L12 16.12l-6.5 6.5v1.88h23a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-25a1 1 0 0 1-1-1v-21Z" })), qw = Ww, ou = R(B()), Zw = (e) => ou.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, ou.createElement("path", { d: "M29 3H3a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h4v7a1 1 0 0 0 .65.94A1 1 0 0 0 8 30a1 1 0 0 0 .75-.34l6.7-7.66H29a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zM13.49 19.68l-3.49 4V19H5V6h22v13H14.09z" })), Gw = Zw, lu = R(B()), Yw = (e) => lu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, lu.createElement("path", { d: "M29 3H3a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h4v7a1 1 0 0 0 .65.94A1 1 0 0 0 8 30a1 1 0 0 0 .75-.34l6.7-7.66H29a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1z" })), Xw = Yw, su = R(B()), Jw = (e) => su.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, su.createElement("path", { d: "m24.71 11.17-.71-.71a1 1 0 0 0-1.41 0l-8.71 8.71-4.46-4.46a1 1 0 0 0-1.41 0l-.71.71a1 1 0 0 0 0 1.41L12.46 22l.71.71a1.15 1.15 0 0 0 .33.21.94.94 0 0 0 .76 0 1.15 1.15 0 0 0 .33-.21l.7-.71 9.42-9.42a1 1 0 0 0 0-1.41z" })), Qw = Jw, cu = R(B()), e6 = (e) => cu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, cu.createElement("path", { d: "m24.71 11.17-.71-.71a1 1 0 0 0-1.41 0l-8.71 8.71-4.46-4.46a1 1 0 0 0-1.41 0l-.71.71a1 1 0 0 0 0 1.41L12.46 22l.71.71a1.15 1.15 0 0 0 .33.21.94.94 0 0 0 .76 0 1.15 1.15 0 0 0 .33-.21l.7-.71 9.42-9.42a1 1 0 0 0 0-1.41z" })), t6 = e6, Yo = R(B()), n6 = (e) => Yo.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Yo.createElement("path", { d: "M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm0 29a13 13 0 1 1 13-13 13 13 0 0 1-13 13z" }), Yo.createElement("path", { d: "M24 10.46a1 1 0 0 0-1.41 0l-8.71 8.71-4.46-4.46a1 1 0 0 0-1.41 0l-.71.71a1 1 0 0 0 0 1.41L12.46 22l.71.71a1.15 1.15 0 0 0 .33.21.94.94 0 0 0 .76 0 1.15 1.15 0 0 0 .33-.21l.7-.71 9.42-9.42a1 1 0 0 0 0-1.41z" })), r6 = n6, uu = R(B()), a6 = (e) => uu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, uu.createElement("path", { d: "M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm8.71 12.58L15.29 22l-.7.71a1.15 1.15 0 0 1-.33.21.94.94 0 0 1-.76 0 1.15 1.15 0 0 1-.33-.21l-.71-.71-5.16-5.17a1 1 0 0 1 0-1.41l.7-.71a1 1 0 0 1 1.41 0l4.46 4.46 8.71-8.71a1 1 0 0 1 1.41 0l.71.71a1 1 0 0 1 .01 1.41z" })), i6 = a6, du = R(B()), o6 = (e) => du.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, du.createElement("path", { d: "m24.71 11.17-.71-.71a1 1 0 0 0-1.41 0l-8.71 8.71-4.46-4.46a1 1 0 0 0-1.41 0l-.71.71a1 1 0 0 0 0 1.41L12.46 22l.71.71a1.15 1.15 0 0 0 .33.21.94.94 0 0 0 .76 0 1.15 1.15 0 0 0 .33-.21l.7-.71 9.42-9.42a1 1 0 0 0 0-1.41z" })), l6 = o6, Xo = R(B()), s6 = (e) => Xo.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Xo.createElement("path", { d: "m18.82 16 6.88-6.87a1.05 1.05 0 0 0 .3-.71 1 1 0 0 0-.29-.71L25 7a1 1 0 0 0-1.41 0L16 14.59l-.71.7a1 1 0 0 0 0 1.42l.71.7L23.58 25a1 1 0 0 0 .7.3A1 1 0 0 0 25 25l.71-.7a1 1 0 0 0 .29-.71 1.05 1.05 0 0 0-.29-.71z" }), Xo.createElement("path", { d: "M15 8.42a1 1 0 0 0-.29-.71L14 7a1 1 0 0 0-1.41 0L5 14.59l-.71.7a1 1 0 0 0 0 1.42l.71.7L12.58 25a1 1 0 0 0 .7.3A1 1 0 0 0 14 25l.71-.7a1 1 0 0 0 .29-.71 1.05 1.05 0 0 0-.29-.71L7.82 16l6.88-6.87a1.05 1.05 0 0 0 .3-.71z" })), c6 = s6, Jo = R(B()), u6 = (e) => Jo.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Jo.createElement("path", { d: "M16 14.59 8.41 7A1 1 0 0 0 7 7l-.71.7a1 1 0 0 0-.29.72 1.05 1.05 0 0 0 .29.71L13.17 16l-6.88 6.87a1.05 1.05 0 0 0-.29.71 1 1 0 0 0 .29.71L7 25a1 1 0 0 0 .71.3 1 1 0 0 0 .7-.3L16 17.41l.7-.7a1 1 0 0 0 0-1.42z" }), Jo.createElement("path", { d: "m27.7 15.29-.7-.7L19.41 7A1 1 0 0 0 18 7l-.71.7a1 1 0 0 0-.29.71 1.05 1.05 0 0 0 .29.71L24.17 16l-6.88 6.87a1.05 1.05 0 0 0-.29.71 1 1 0 0 0 .29.71L18 25a1 1 0 0 0 .71.3 1 1 0 0 0 .7-.3L27 17.41l.7-.7a1 1 0 0 0 0-1.42z" })), d6 = u6, fu = R(B()), f6 = (e) => fu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, fu.createElement("path", { d: "M31.71 9.29 31 8.58a1 1 0 0 0-.71-.29 1 1 0 0 0-.7.29L16 22.17 2.41 8.59a1 1 0 0 0-1.41 0l-.71.71a1 1 0 0 0 0 1.41l15 15a1 1 0 0 0 .33.21.94.94 0 0 0 .76 0 .72.72 0 0 0 .24-.16l.08-.05.71-.71 14.3-14.3a1 1 0 0 0 0-1.41z" })), p6 = f6, pu = R(B()), h6 = (e) => pu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, pu.createElement("path", { d: "M23.42 29.59 9.83 16 23.41 2.41a1 1 0 0 0 0-1.41L22.7.29A1 1 0 0 0 22 0a1 1 0 0 0-.71.29L7 14.58l-.71.71a1.06 1.06 0 0 0-.22.33 1.1 1.1 0 0 0 0 .76 1.19 1.19 0 0 0 .22.33l.71.7 14.29 14.3A1 1 0 0 0 22 32a1 1 0 0 0 .71-.29l.71-.71a1 1 0 0 0 0-1.41z" })), v6 = h6, hu = R(B()), m6 = (e) => hu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, hu.createElement("path", { d: "M25.93 15.62a1.19 1.19 0 0 0-.22-.33l-.71-.7L10.71.29a1 1 0 0 0-1.42 0L8.58 1a1 1 0 0 0 0 1.41L22.17 16 8.59 29.59a1 1 0 0 0 0 1.41l.71.71a1 1 0 0 0 .7.29 1 1 0 0 0 .71-.29L25 17.42l.71-.71a1.06 1.06 0 0 0 .22-.33 1.1 1.1 0 0 0 0-.76z" })), g6 = m6, vu = R(B()), y6 = (e) => vu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, vu.createElement("path", { d: "M31.71 21.29 17.42 7l-.71-.71a1 1 0 0 0-1.4 0l-.7.71L.29 21.29a1 1 0 0 0 0 1.42l.71.71a1 1 0 0 0 .71.29 1 1 0 0 0 .7-.29L16 9.83l13.59 13.58a1 1 0 0 0 .7.29 1 1 0 0 0 .71-.29l.71-.71a1 1 0 0 0 0-1.41z" })), b6 = y6, Qo = R(B()), w6 = (e) => Qo.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Qo.createElement("path", { d: "M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm0 29a13 13 0 1 1 13-13 13 13 0 0 1-13 13z" }), Qo.createElement("path", { d: "M17.5 15.38V6a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v10.1a1 1 0 0 0 .27.81l5.8 5.8a1 1 0 0 0 .7.29 1 1 0 0 0 .71-.29l.71-.71a1 1 0 0 0 0-1.41z" })), x6 = w6, mu = R(B()), E6 = (e) => mu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, mu.createElement("path", { d: "M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm7.06 22.35-.71.71a1 1 0 0 1-1.41 0l-6.15-6.15a1 1 0 0 1-.27-.81V4a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v11.38l5.56 5.56a1 1 0 0 1-.02 1.41z" })), $6 = E6, el = R(B()), P6 = (e) => el.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, el.createElement("path", { d: "M25.29 27a1 1 0 0 1-.7-.29L5.29 7.41a1 1 0 0 1 0-1.41L6 5.29a1 1 0 0 1 1.41 0l19.3 19.3a1 1 0 0 1 0 1.41l-.71.71a1 1 0 0 1-.71.29z" }), el.createElement("path", { d: "M6.71 27a1 1 0 0 1-.71-.29L5.29 26a1 1 0 0 1 0-1.41l19.3-19.3a1 1 0 0 1 1.41 0l.71.71a1 1 0 0 1 0 1.41l-19.3 19.3a1 1 0 0 1-.7.29z" })), C6 = P6, tl = R(B()), S6 = (e) => tl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, tl.createElement("path", { d: "M22 22.59a1 1 0 0 0-1.41 0l-3.09 3.08V13a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v12.67l-3.09-3.08a1 1 0 0 0-1.41 0l-.71.7a1 1 0 0 0 0 1.42l5.3 5.29.7.71a1 1 0 0 0 1.42 0l.7-.71 5.3-5.29a1 1 0 0 0 0-1.42z" }), tl.createElement("path", { d: "M27.26 8.55a8.49 8.49 0 0 0-15.71-3.44A6.6 6.6 0 0 0 3.3 8.92 5.22 5.22 0 0 0 5.22 19h5.28a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H5.22a2.23 2.23 0 0 1-.6-4.37l1-.29.32-1a3.62 3.62 0 0 1 3.5-2.58 3.57 3.57 0 0 1 1.65.41l1.86 1 .87-1.91a5.49 5.49 0 0 1 10.49 2.21v2.35l2.24-.26h.25a2.24 2.24 0 0 1 0 4.47h-5.3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h5.28a5.24 5.24 0 0 0 .48-10.45z" })), k6 = S6, gu = R(B()), T6 = (e) => gu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, gu.createElement("path", { d: "M27.5 8a4 4 0 0 0-.5.05V8a8 8 0 0 0-15.26-3.34 6 6 0 0 0-8.46 3.53A4.49 4.49 0 0 0 4.5 17h23a4.5 4.5 0 0 0 0-9zM21 24.59a1 1 0 0 0-1.41 0l-2.09 2.08V21a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v5.67l-2.09-2.08a1 1 0 0 0-1.41 0l-.71.7a1 1 0 0 0 0 1.42l4.3 4.29.7.71a1 1 0 0 0 1.42 0l.7-.71 4.3-4.29a1 1 0 0 0 0-1.42z" })), A6 = T6, yu = R(B()), O6 = (e) => yu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, yu.createElement("path", { d: "M21.89 10a8 8 0 0 0-15.42 3 1.09 1.09 0 0 0 0 .18A6.5 6.5 0 0 0 8 26h13.5a8 8 0 0 0 .42-16Zm-.42 13H8a3.49 3.49 0 0 1-.26-7l2.14-.17-.32-2.12a5.34 5.34 0 0 1-.09-.71 5 5 0 0 1 9.8-1.42l.44 1.5 1.56-.08h.2a5 5 0 0 1 0 10Z", "data-name": "Layer 4" })), z6 = O6, bu = R(B()), M6 = (e) => bu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, bu.createElement("path", { d: "M22.42 10A8 8 0 0 0 7 13v.18A6.5 6.5 0 0 0 8.5 26H22a8 8 0 0 0 .42-16Z", "data-name": "Layer 4" })), _6 = M6, Kt = R(B()), L6 = (e) => Kt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Kt.createElement("g", { "data-name": "Layer 4" }, Kt.createElement("rect", { x: 11.34, y: 2.04, width: 3, height: 5, rx: 1 }), Kt.createElement("rect", { x: 1.06, y: 12.41, width: 5, height: 3, rx: 1 }), Kt.createElement("rect", { x: 4.37, y: 4.79, width: 3, height: 5, rx: 1, transform: "rotate(-45 5.878 7.285)" }), Kt.createElement("rect", { x: 3.48, y: 19.53, width: 5, height: 3, rx: 1, transform: "rotate(-45 5.982 21.032)" }), Kt.createElement("rect", { x: 17.26, y: 5.79, width: 5, height: 3, rx: 1, transform: "rotate(-45 19.761 7.295)" }), Kt.createElement("path", { d: "M25.72 16.18a5.92 5.92 0 0 0-5.51-3.88 5.9 5.9 0 0 0-.75 0c-5.2.49-5.09 6-5.09 6.08a4.2 4.2 0 0 0-3 2.11 4.26 4.26 0 0 0-.57 2.13 4.14 4.14 0 0 0 .09.87A4.24 4.24 0 0 0 15 27h10a5.36 5.36 0 0 0 5.31-5.42 5.66 5.66 0 0 0-.09-1 5.37 5.37 0 0 0-4.5-4.4ZM25.06 24H15a1.35 1.35 0 0 1-1.23-1.34A1.31 1.31 0 0 1 14 22a1.22 1.22 0 0 1 .85-.63l2.55-.4v-2.59a2.75 2.75 0 0 1 2.37-3.06h.47a2.94 2.94 0 0 1 2.73 1.94l.63 1.7 1.81.23a2.44 2.44 0 0 1-.35 4.81ZM7.05 15.06v-.22c-.05.08-.05.16 0 .22Zm6.67-6.98h.21Zm1.28.29c.1 0 .21.07.31.12ZM7.21 15.8l-.06-.23Zm.56 1.3a.41.41 0 0 1 0-.09.41.41 0 0 0 0 .09Zm-.32-.63-.07-.19Zm8.03-7.9a5.75 5.75 0 0 1 1.3.8 5.75 5.75 0 0 0-1.3-.8Zm-1.11-.37.28.07Zm2.43 1.18c.15.12.28.24.41.36-.13-.12-.21-.24-.41-.36ZM7 14.84a6 6 0 0 1 0-.74 6 6 0 0 0 0 .74Zm.15.73a4.59 4.59 0 0 1-.1-.51 4.59 4.59 0 0 0 .1.51ZM7.72 17a5.44 5.44 0 0 1-.27-.54 5.44 5.44 0 0 0 .27.54Zm-.34-.72c-.06-.16-.12-.32-.17-.48.05.2.11.32.17.48Zm.39.82A6 6 0 0 0 9 18.64a5.78 5.78 0 0 1-1.23-1.54Zm9.45-7.34-.01-.02.01.02zm-2.57-1.49.33.1Zm.64.22.19.08Zm-1.57-.41h-.7c.25-.08.47-.02.7 0Zm.21.03c.15 0 .3.05.44.09-.14-.04-.29-.06-.44-.09Zm2.85 1.26Z" }), Kt.createElement("path", { d: "M17.21 9.74c-.13-.12-.26-.24-.41-.36a5.75 5.75 0 0 0-1.3-.8l-.19-.08c-.1-.05-.21-.08-.31-.12l-.33-.1-.28-.07c-.14 0-.29-.06-.44-.09h-.9a6 6 0 0 0-6 6.8v.22a4.59 4.59 0 0 0 .1.51l.06.23c0 .16.11.32.17.48l.07.19a5.44 5.44 0 0 0 .27.54.41.41 0 0 0 0 .09A5.78 5.78 0 0 0 9 18.62a7.24 7.24 0 0 1 2.11-2.09 3.09 3.09 0 0 1-1-1.45 1.72 1.72 0 0 1-.07-.21c0-.08 0-.15-.05-.22a3.07 3.07 0 0 1 0-.53 3.22 3.22 0 0 1 .24-1.21A3.12 3.12 0 0 1 13.08 11a3 3 0 0 1 1.31.31 7.83 7.83 0 0 1 2.83-1.56Z" }))), I6 = L6, jt = R(B()), D6 = (e) => jt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, jt.createElement("g", { "data-name": "Layer 4" }, jt.createElement("rect", { x: 10.36, y: 3.01, width: 5, height: 3, rx: 1, transform: "rotate(-90 12.86 4.51)" }), jt.createElement("rect", { x: 1.08, y: 12.39, width: 5, height: 3, rx: 1, transform: "rotate(-180 3.58 13.885)" }), jt.createElement("path", { d: "M25.74 16.16a5.93 5.93 0 0 0-5.51-3.89c-.26 0-.51 0-.75.05-5.19.5-5.09 6.05-5.09 6.08a4.25 4.25 0 0 0-3 2.11 4.29 4.29 0 0 0-.56 2.14 4.94 4.94 0 0 0 .08.87A4.25 4.25 0 0 0 15 27h10a5.36 5.36 0 0 0 5.31-5.42 5.58 5.58 0 0 0-.09-1 5.36 5.36 0 0 0-4.48-4.42Zm-14.14.07a10.06 10.06 0 0 1 .59-1.88 8 8 0 0 1 5.06-4.62A6.05 6.05 0 1 0 9 18.62a7.14 7.14 0 0 1 2.6-2.39Z" }), jt.createElement("path", { d: "M15 27h10a5.36 5.36 0 0 0 5.31-5.42 5.58 5.58 0 0 0-.09-1 5.36 5.36 0 0 0-4.56-4.39 5.93 5.93 0 0 0-5.51-3.89c-.26 0-.51 0-.75.05-5.19.5-5.09 6.05-5.09 6.08a4.25 4.25 0 0 0-3 2.11 4.29 4.29 0 0 0-.56 2.14 4.94 4.94 0 0 0 .08.87A4.25 4.25 0 0 0 15 27Z" }), jt.createElement("rect", { x: 3.4, y: 5.77, width: 5, height: 3, rx: 1, transform: "rotate(-135 5.899 7.269)" }), jt.createElement("rect", { x: 3.51, y: 19.51, width: 5, height: 3, rx: 1, transform: "rotate(135 6.008 21.005)" }), jt.createElement("rect", { x: 17.28, y: 5.77, width: 5, height: 3, rx: 1, transform: "rotate(-45 19.771 7.27)" }))), N6 = D6, Ca = R(B()), R6 = (e) => Ca.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Ca.createElement("circle", { cx: 7, cy: 25, r: 3 }), Ca.createElement("path", { d: "M31 4H1a1 1 0 0 0-1 1v17a1 1 0 0 0 1 1h1.42a5 5 0 0 1 9.16 0h8.84a5 5 0 0 1 9.16 0H31a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zm-21 9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1zm9.5 0a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1zm9.5 0a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1z" }), Ca.createElement("circle", { cx: 25, cy: 25, r: 3 })), B6 = R6, wu = R(B()), V6 = (e) => wu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, wu.createElement("path", { d: "M27.79 3.62A1 1 0 0 0 27 2H5a1 1 0 0 0-.79 1.62L14.5 16.71V27H10a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-4.5V16.71zM22.89 5l-2.36 3h-9.06L9.11 5z", fillRule: "evenodd" })), F6 = V6, nl = R(B()), H6 = (e) => nl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, nl.createElement("path", { d: "M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm0 29a13 13 0 1 1 13-13 13 13 0 0 1-13 13z" }), nl.createElement("path", { d: "M6.33 14.12a2 2 0 1 0 2.55 1.21 2 2 0 0 0-2.55-1.21zm20.55 1.21a2 2 0 1 0-1.21 2.55 2 2 0 0 0 1.21-2.55zM19 20h-1V9a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v1h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2v7h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h5a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1z" })), K6 = H6, xu = R(B()), j6 = (e) => xu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, xu.createElement("path", { d: "M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zM7.67 17.88a2 2 0 1 1 1.21-2.55 2 2 0 0 1-1.21 2.55zM20 22a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1v-7h-2a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h2V9a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v11h1a1 1 0 0 1 1 1zm5.67-4.12a2 2 0 1 1 1.21-2.55 2 2 0 0 1-1.21 2.55z" })), U6 = j6, kr = R(B()), W6 = (e) => kr.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, kr.createElement("rect", { x: 2, y: 2, width: 12.5, height: 16, rx: 1, ry: 1 }), kr.createElement("rect", { x: 2, y: 21, width: 12.5, height: 9, rx: 1, ry: 1 }), kr.createElement("rect", { x: 17.5, y: 14, width: 12.5, height: 16, rx: 1, ry: 1 }), kr.createElement("rect", { x: 17.5, y: 2, width: 12.5, height: 9, rx: 1, ry: 1 })), q6 = W6, rl = R(B()), Z6 = (e) => rl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, rl.createElement("path", { d: "M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm0 29a13 13 0 1 1 13-13 13 13 0 0 1-13 13z" }), rl.createElement("path", { d: "M21.64 9.07 13 12.4a1 1 0 0 0-.57.57l-3.36 8.67a1 1 0 0 0 .22 1.07A1 1 0 0 0 10 23a.92.92 0 0 0 .36-.07L19 19.6a1 1 0 0 0 .6-.6l3.33-8.67a1 1 0 0 0-.22-1.07 1 1 0 0 0-1.07-.19z" })), G6 = Z6, Eu = R(B()), Y6 = (e) => Eu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Eu.createElement("path", { d: "M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm6.93 10.36L19.6 19a1 1 0 0 1-.57.57l-8.67 3.33a.92.92 0 0 1-.36.1 1 1 0 0 1-.71-.29 1 1 0 0 1-.22-1.07L12.4 13a1 1 0 0 1 .6-.6l8.67-3.33a1 1 0 0 1 1.07.22 1 1 0 0 1 .19 1.07z" })), X6 = Y6, al = R(B()), J6 = (e) => al.createElement("svg", { width: 32, height: 32, xmlns: "http://www.w3.org/2000/svg", className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, al.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.742 23.821c-.614.68-1.742.246-1.742-.67V18H1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h21a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H9l-5.258 5.821ZM5 15v2.953L7.667 15H20V5H3v10h2Z" }), al.createElement("path", { d: "M10 21v4a1 1 0 0 0 1 1h12l5.269 5.645c.62.664 1.731.226 1.731-.682V26h1a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1h-5v3h3v10h-2v2.889L24.304 23H13v-2h-3Z" })), Q6 = J6, il = R(B()), e7 = (e) => il.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, il.createElement("path", { d: "M31 10h-5v9.5a1.5 1.5 0 0 1-1.5 1.5H9v4a1 1 0 0 0 1 1h13.53l4.7 5.64a1 1 0 0 0 1.11.3A1 1 0 0 0 30 31v-5h1a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1z" }), il.createElement("path", { d: "M22 2H1a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h1v5a1 1 0 0 0 .66.94 1 1 0 0 0 1.11-.3L8.47 18H22a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z" })), t7 = e7, Sa = R(B()), n7 = (e) => Sa.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Sa.createElement("g", { "data-name": "Layer 4" }, Sa.createElement("path", { d: "M32 7.43a5.5 5.5 0 1 0-7 5.3V15a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2.29a5.49 5.49 0 0 0 4-5.28Zm-5.5 2.5a2.5 2.5 0 1 1 2.5-2.5 2.5 2.5 0 0 1-2.5 2.5ZM11 21.5a5.5 5.5 0 1 0-7 5.29v2.28A1 1 0 0 0 5 30h1a1 1 0 0 0 1-.93v-2.28a5.52 5.52 0 0 0 4-5.29ZM5.5 24A2.5 2.5 0 1 1 8 21.5 2.5 2.5 0 0 1 5.5 24Zm13.18-9.83A18.71 18.71 0 0 1 17.48 2h-5.93a15.81 15.81 0 0 0 .93 10.41c3.29 7.1 3.45 12.39 1.95 17.58h5.94c1.43-4.72 1.3-9.36-1.69-15.82Z" }), Sa.createElement("path", { d: "M13.48 12.41a15.6 15.6 0 0 1-1.17-9.25 1 1 0 0 0-1-1.16h-1.03a1 1 0 0 0-1 .82 18.55 18.55 0 0 0 1.45 10.85c2.84 6.12 3.1 10.61 1.91 15.08a1 1 0 0 0 1 1.24h1a1 1 0 0 0 1-.74c1.27-4.96.97-10.08-2.16-16.84Zm4.2 1.76c2.73 5.9 3.08 10.29 2 14.6a1 1 0 0 0 1 1.22h1a1 1 0 0 0 1-.76c1.12-4.8.74-9.79-2.29-16.32a15.78 15.78 0 0 1-1.08-9.72 1 1 0 0 0-1-1.19H17.3a1 1 0 0 0-1 .8 18.65 18.65 0 0 0 1.38 11.37Z" }))), r7 = n7, ka = R(B()), a7 = (e) => ka.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, ka.createElement("g", { "data-name": "Layer 4" }, ka.createElement("path", { d: "M32 7.43a5.5 5.5 0 1 0-7 5.3V15a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2.29a5.49 5.49 0 0 0 4-5.28ZM11 21.5a5.5 5.5 0 1 0-7 5.29v2.28A1 1 0 0 0 5 30h1a1 1 0 0 0 1-.93v-2.28a5.52 5.52 0 0 0 4-5.29Zm7.68-7.33A18.71 18.71 0 0 1 17.48 2h-5.93a15.81 15.81 0 0 0 .93 10.41c3.29 7.1 3.45 12.39 1.95 17.58h5.94c1.43-4.72 1.3-9.36-1.69-15.82Z" }), ka.createElement("path", { d: "M10.28 2a1 1 0 0 0-1 .82 18.55 18.55 0 0 0 1.45 10.85c2.84 6.12 3.1 10.61 1.91 15.08a1 1 0 0 0 1 1.24h8.08a1 1 0 0 0 1-.76c1.12-4.8.74-9.79-2.29-16.32a15.78 15.78 0 0 1-1.08-9.72 1 1 0 0 0-1-1.19Z" }))), i7 = a7, Zn = R(B()), o7 = (e) => Zn.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Zn.createElement("rect", { height: 3, rx: 1, width: 11, x: 5, y: 5 }), Zn.createElement("rect", { height: 3, rx: 1, width: 4, x: 5, y: 10 }), Zn.createElement("path", { d: "M5 21H3V3h15v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1z" }), Zn.createElement("path", { d: "M20 8a12 12 0 1 0 12 12A12 12 0 0 0 20 8zm0 21a9 9 0 1 1 9-9 9 9 0 0 1-9 9z" }), Zn.createElement("path", { d: "M21.5 20.38V14a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v7.1a1 1 0 0 0 .27.81l3.15 3.15a1 1 0 0 0 1.41 0l.71-.71a1 1 0 0 0 0-1.41z" })), l7 = o7, ol = R(B()), s7 = (e) => ol.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, ol.createElement("path", { d: "M20 8a12 12 0 1 0 12 12A12 12 0 0 0 20 8zm4.56 16.85-.71.71a1 1 0 0 1-1.41 0l-3.65-3.65a1 1 0 0 1-.27-.81V13a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v7.38l3.06 3.06a1 1 0 0 1-.02 1.41z" }), ol.createElement("path", { d: "M20 6h1V1a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h5.59A14 14 0 0 1 20 6zM3 4a1 1 0 0 1 1-1h9a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm0 6V9a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1z" })), c7 = s7, $u = R(B()), u7 = (e) => $u.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, $u.createElement("path", { d: "m28.71 10.15-6.86-6.86a1 1 0 0 0-1.41 0l-16 16a1 1 0 0 0-.29.57l-1.15 8a1 1 0 0 0 .28.85A1 1 0 0 0 4 29h.14l8-1.14a1 1 0 0 0 .57-.29l1.39-1.39 2.12-2.12 12.49-12.5a1 1 0 0 0 0-1.41zM23.05 13 19 9l2.12-2.12 4 4zM6.36 25.64l.64-4.7L8 20l4 4-.92.92zm3.71-7.74 6.83-6.83 4 4-6.8 6.86z" })), d7 = u7, Pu = R(B()), f7 = (e) => Pu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Pu.createElement("path", { d: "m7.945 15.776 6.83-6.83 8.274 8.272-6.83 6.831zM5.83 17.9l-1.39 1.39a1 1 0 0 0-.29.57l-1.15 8a1 1 0 0 0 .28.85A1 1 0 0 0 4 29h.14l8-1.14a1 1 0 0 0 .57-.29l1.39-1.39zm22.88-7.75-6.86-6.86a1 1 0 0 0-1.41 0L16.9 6.83l8.27 8.27 3.54-3.54a1 1 0 0 0 0-1.41z" })), p7 = f7, Cu = R(B()), h7 = (e) => Cu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Cu.createElement("path", { d: "M31 5H1a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zM3 17h26v7H3zm26-5H3V8h26z" })), v7 = h7, Su = R(B()), m7 = (e) => Su.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Su.createElement("path", { d: "M32 11V6a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v5zM0 16v10a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1V16z" })), g7 = m7, ku = R(B()), y7 = (e) => ku.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, ku.createElement("path", { d: "M29 22h-4V8a1 1 0 0 0-1-1H10V3a1 1 0 0 0-1-1H8a1 1 0 0 0-1 1v4H3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h4v14a1 1 0 0 0 1 1h14v4a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-4h4a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Zm-19 0V10h12v12Z", "data-name": "Layer 4" })), b7 = y7, ll = R(B()), w7 = (e) => ll.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, ll.createElement("path", { d: "m21.86 14.21-3.74-.55-1.67-3.38a.52.52 0 0 0-.9 0l-1.67 3.38-3.74.55a.5.5 0 0 0-.4.34.49.49 0 0 0 .13.51l2.7 2.63-.64 3.73a.5.5 0 0 0 .2.48.49.49 0 0 0 .53 0L16 20.19l3.34 1.75a.49.49 0 0 0 .23.06.47.47 0 0 0 .3-.1.5.5 0 0 0 .2-.48l-.64-3.73 2.7-2.63a.49.49 0 0 0 .13-.51.5.5 0 0 0-.4-.34z" }), ll.createElement("path", { d: "M31.2 12.08a1 1 0 0 0 .8-1V6a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v5.1a1 1 0 0 0 .8 1A4 4 0 0 1 4 16a4 4 0 0 1-3.2 3.92 1 1 0 0 0-.8 1V26a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1v-5.1a1 1 0 0 0-.8-1 4 4 0 0 1 0-7.84zM25 16a7 7 0 0 0 4 6.32V24H3v-1.68A7 7 0 0 0 7 16a7 7 0 0 0-4-6.32V8h26v1.68A7 7 0 0 0 25 16z" })), x7 = w7, Tu = R(B()), E7 = (e) => Tu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Tu.createElement("path", { d: "M31.2 12.08a1 1 0 0 0 .8-1V6a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v5.1a1 1 0 0 0 .8 1A4 4 0 0 1 4 16a4 4 0 0 1-3.2 3.92 1 1 0 0 0-.8 1V26a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1v-5.1a1 1 0 0 0-.8-1 4 4 0 0 1 0-7.84zm-9.07 2-2.7 2.63.64 3.73a.5.5 0 0 1-.2.48.47.47 0 0 1-.3.1.49.49 0 0 1-.23-.06L16 19.19l-3.34 1.75a.49.49 0 0 1-.53 0 .5.5 0 0 1-.2-.48l.64-3.73-2.7-2.63a.49.49 0 0 1-.13-.51.5.5 0 0 1 .4-.34l3.74-.55 1.67-3.38a.52.52 0 0 1 .9 0l1.67 3.38 3.74.55a.5.5 0 0 1 .4.34.49.49 0 0 1-.13.47z" })), $7 = E7, Ut = R(B()), P7 = (e) => Ut.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Ut.createElement("path", { d: "M31 0H12a1 1 0 0 0-1 1v19a1 1 0 0 0 1 1h19a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM14 18V3h15v15z" }), Ut.createElement("path", { d: "M20 23h-1a1 1 0 0 0-1 1v5H3V14h5a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v19a1 1 0 0 0 1 1h19a1 1 0 0 0 1-1v-7a1 1 0 0 0-1-1z" }), Ut.createElement("circle", { cx: 18, cy: 7, r: 2 }), Ut.createElement("circle", { cx: 18, cy: 14, r: 2 }), Ut.createElement("circle", { cx: 14, cy: 25, r: 2 }), Ut.createElement("circle", { cx: 7, cy: 18, r: 2 }), Ut.createElement("circle", { cx: 25, cy: 14, r: 2 }), Ut.createElement("circle", { cx: 25, cy: 7, r: 2 })), C7 = P7, sl = R(B()), S7 = (e) => sl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, sl.createElement("path", { d: "M31 0H13a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1zM18 16a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm0-8a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm8 8a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm0-8a2 2 0 1 1 2-2 2 2 0 0 1-2 2z" }), sl.createElement("path", { d: "M20 22H10V12a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v19a1 1 0 0 0 1 1h19a1 1 0 0 0 1-1v-8a1 1 0 0 0-1-1zM6 20a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm8 8a2 2 0 1 1 2-2 2 2 0 0 1-2 2z" })), k7 = S7, Tr = R(B()), T7 = (e) => Tr.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Tr.createElement("path", { d: "M31.1 16c0-1.54-1.91-2.75-2.36-4.14s.35-3.54-.52-4.74-3.14-1.08-4.35-2-1.76-3.06-3.2-3.53a2 2 0 0 0-.59-.09c-1.27.04-2.75 1.1-4.08 1.1s-2.81-1.06-4.08-1.06a2 2 0 0 0-.59.09c-1.44.47-2 2.66-3.2 3.53s-3.47.75-4.35 2-.06 3.3-.52 4.74S.9 14.46.9 16s1.91 2.75 2.36 4.14-.35 3.54.52 4.74 3.14 1.08 4.35 2 1.76 3.06 3.2 3.53a2 2 0 0 0 .59.09c1.27 0 2.75-1.07 4.08-1.07s2.81 1.07 4.08 1.07a2 2 0 0 0 .59-.09c1.44-.47 2-2.66 3.2-3.53s3.47-.75 4.35-2 .06-3.3.52-4.74 2.36-2.6 2.36-4.14zm-3.58.54a8.3 8.3 0 0 0-1.63 2.67 8.62 8.62 0 0 0-.27 3.19v.61l-.59.17a8.53 8.53 0 0 0-2.94 1.23 8.61 8.61 0 0 0-2.06 2.4c-.1.16-.23.36-.35.52l-.55-.2a8.69 8.69 0 0 0-3.13-.74 8.69 8.69 0 0 0-3.15.74l-.55.21c-.12-.17-.25-.37-.35-.53a8.61 8.61 0 0 0-2.06-2.4A8.53 8.53 0 0 0 7 23.18L6.35 23v-.61a8.62 8.62 0 0 0-.27-3.19 8.3 8.3 0 0 0-1.63-2.67l-.4-.53.43-.54a8.3 8.3 0 0 0 1.63-2.67 8.62 8.62 0 0 0 .27-3.19v-.61L7 8.82a8.53 8.53 0 0 0 2.89-1.23A8.61 8.61 0 0 0 12 5.19c.1-.16.23-.36.35-.52l.55.2a8.69 8.69 0 0 0 3.1.73 8.69 8.69 0 0 0 3.15-.73l.55-.21c.12.17.25.37.35.53a8.61 8.61 0 0 0 2.06 2.4 8.53 8.53 0 0 0 2.94 1.23l.6.17v.61a8.62 8.62 0 0 0 .27 3.19 8.3 8.3 0 0 0 1.63 2.67L28 16z" }), Tr.createElement("circle", { cx: 11.75, cy: 12.25, r: 2 }), Tr.createElement("circle", { cx: 19.75, cy: 20.25, r: 2 }), Tr.createElement("path", { d: "m21.45 11.25-.7-.7a1 1 0 0 0-1.42 0l-9.28 9.28a1 1 0 0 0 0 1.42l.7.7a1 1 0 0 0 .71.3 1 1 0 0 0 .71-.3l9.28-9.28a1 1 0 0 0 0-1.42z" })), A7 = T7, Au = R(B()), O7 = (e) => Au.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Au.createElement("path", { d: "M31.1 16c0-1.54-1.91-2.75-2.36-4.14s.35-3.54-.52-4.74-3.14-1.08-4.35-2-1.76-3.06-3.2-3.53a2 2 0 0 0-.59-.09c-1.27.04-2.75 1.1-4.08 1.1s-2.81-1.06-4.08-1.06a2 2 0 0 0-.59.09c-1.44.47-2 2.66-3.2 3.53s-3.47.75-4.35 2-.06 3.3-.52 4.74S.9 14.46.9 16s1.91 2.75 2.36 4.14-.35 3.54.52 4.74 3.14 1.08 4.35 2 1.76 3.06 3.2 3.53a2 2 0 0 0 .59.09c1.27 0 2.75-1.07 4.08-1.07s2.81 1.07 4.08 1.07a2 2 0 0 0 .59-.09c1.44-.47 2-2.66 3.2-3.53s3.47-.75 4.35-2 .06-3.3.52-4.74 2.36-2.6 2.36-4.14zM12 10a2 2 0 1 1-2 2 2 2 0 0 1 2-2zm.42 11.7a1 1 0 0 1-.71.3 1 1 0 0 1-.71-.3l-.7-.7a1 1 0 0 1 0-1.42l9.28-9.28a1 1 0 0 1 1.42 0l.7.7a1 1 0 0 1 0 1.42zM20 22a2 2 0 1 1 2-2 2 2 0 0 1-2 2z" })), z7 = O7, cl = R(B()), M7 = (e) => cl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, cl.createElement("path", { d: "M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm0 29a13 13 0 1 1 13-13 13 13 0 0 1-13 13z" }), cl.createElement("path", { d: "M22.71 10 22 9.29a1 1 0 0 0-1.41 0L16 13.88l-4.59-4.59a1 1 0 0 0-1.41 0l-.71.71a1 1 0 0 0 0 1.41L13.88 16l-4.59 4.59a1 1 0 0 0 0 1.41l.71.71a1 1 0 0 0 1.41 0L16 18.12l4.59 4.59a1 1 0 0 0 1.41 0l.71-.71a1 1 0 0 0 0-1.41L18.12 16l4.59-4.59a1 1 0 0 0 0-1.41z" })), _7 = M7, Ou = R(B()), L7 = (e) => Ou.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Ou.createElement("path", { d: "M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm6.71 20.59a1 1 0 0 1 0 1.41l-.71.71a1 1 0 0 1-1.41 0L16 18.12l-4.59 4.59a1 1 0 0 1-1.41 0L9.29 22a1 1 0 0 1 0-1.41L13.88 16l-4.59-4.59a1 1 0 0 1 0-1.41l.71-.71a1 1 0 0 1 1.41 0L16 13.88l4.59-4.59a1 1 0 0 1 1.41 0l.71.71a1 1 0 0 1 0 1.41L18.12 16z" })), I7 = L7, zu = R(B()), D7 = (e) => zu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, zu.createElement("path", { d: "m18.12 16 4.59-4.59a1 1 0 0 0 0-1.41L22 9.29a1 1 0 0 0-1.41 0L16 13.88l-4.59-4.59a1 1 0 0 0-1.41 0l-.71.71a1 1 0 0 0 0 1.41L13.88 16l-4.59 4.59a1 1 0 0 0 0 1.41l.71.71a1 1 0 0 0 1.41 0L16 18.12l4.59 4.59a1 1 0 0 0 1.41 0l.71-.71a1 1 0 0 0 0-1.41z" })), N7 = D7, ul = R(B()), R7 = (e) => ul.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, ul.createElement("path", { d: "M26 17h-1a1 1 0 0 0-1 1v7H7V8h7a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v21a1 1 0 0 0 1 1h21a1 1 0 0 0 1-1v-9a1 1 0 0 0-1-1z" }), ul.createElement("path", { d: "M29 2H19a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h5.88L14.29 15.58a1 1 0 0 0 0 1.42l.71.71a1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29L27 7.12V13a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z" })), B7 = R7, Mu = R(B()), V7 = (e) => Mu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlSpace: "preserve", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Mu.createElement("path", { d: "M29.4 17.8c.4.7.2 1.6-.6 2.1-.7.4-1.6.2-2.1-.6l-2.1-3.7c-1.2.7-2.5 1.3-3.8 1.7l.7 4c.1.8-.4 1.6-1.2 1.7H20c-.7 0-1.4-.5-1.5-1.3l-.6-3.9c-1.3.1-2.5.1-3.8 0l-.6 3.9c-.2.8-.8 1.3-1.5 1.3h-.3c-.8-.1-1.4-.9-1.2-1.7l.7-4c-1.3-.4-2.6-1-3.8-1.7l-2.1 3.7c-.4.7-1.3 1-2.1.6-.7-.4-1-1.3-.6-2.1l2.3-4c-.8-.7-1.5-1.5-2.2-2.3-.5-.8-.3-1.7.3-2.2.6-.5 1.5-.4 2 .2C7.1 12 10.6 15 16 15s8.9-3 10.9-5.5c.5-.6 1.5-.7 2.1-.2.6.5.7 1.5.2 2.1-.7.8-1.4 1.6-2.2 2.3l2.4 4.1z" })), F7 = V7, _u = R(B()), H7 = (e) => _u.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, _u.createElement("path", { d: "m29.39 15.29-.39-.42c-8.34-9.16-17.63-9.16-26 0l-.41.45a1 1 0 0 0 0 1.34l.41.45C7.16 21.68 11.51 24 16 24s8.81-2.35 13-7l.35-.36a1 1 0 0 0 .04-1.35ZM16 18.5a2.5 2.5 0 1 1 2.5-2.5 2.5 2.5 0 0 1-2.5 2.5Zm-3.32-6.88a5.48 5.48 0 0 0 0 8.73A16.93 16.93 0 0 1 6.14 16a17.27 17.27 0 0 1 6.54-4.38Zm6.74 8.68a5.47 5.47 0 0 0-.13-8.69A17 17 0 0 1 25.84 16a17.54 17.54 0 0 1-6.42 4.3Z", "data-name": "Layer 4" })), K7 = H7, Lu = R(B()), j7 = (e) => Lu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Lu.createElement("path", { d: "m29.39 15.29-.39-.42c-8.34-9.16-17.63-9.16-26 0l-.41.45a1 1 0 0 0 0 1.34l.41.45C7.16 21.68 11.51 24 16 24s8.81-2.35 13-7l.35-.36a1 1 0 0 0 .04-1.35Zm-16.71-3.67a5.48 5.48 0 0 0 0 8.73A16.93 16.93 0 0 1 6.14 16a17.27 17.27 0 0 1 6.54-4.38Zm6.74 8.68a5.47 5.47 0 0 0-.13-8.69A17 17 0 0 1 25.84 16a17.54 17.54 0 0 1-6.42 4.3Z", "data-name": "Layer 4" })), U7 = j7, Iu = R(B()), W7 = (e) => Iu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Iu.createElement("path", { d: "M26.49 11.5a10.49 10.49 0 1 0-12 10.37.53.53 0 0 0 0 .12v2H12a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2.5v3a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V27H20a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-2.5v-2.12a10.47 10.47 0 0 0 8.99-10.38zM16 19a7.5 7.5 0 1 1 7.49-7.49A7.5 7.5 0 0 1 16 19z" })), q7 = W7, Du = R(B()), Z7 = (e) => Du.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Du.createElement("path", { d: "M29 8h-3.25a5 5 0 0 0-9.5 0H3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h13.25a5 5 0 0 0 9.5 0H29a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1zm-8 3.5a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm8 9.5H15.75a5 5 0 0 0-9.5 0H3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h3.25a5 5 0 0 0 9.5 0H29a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zm-18 3.5a2 2 0 1 1 2-2 2 2 0 0 1-2 2z" })), G7 = Z7, dl = R(B()), Y7 = (e) => dl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, dl.createElement("path", { d: "M22 7a9.83 9.83 0 0 0-1.85.2l-8-4a1.5 1.5 0 0 0-2.11 1.75l1.66 5.83a17.79 17.79 0 0 0-3.1 2.39L2.29 9.23a1.48 1.48 0 0 0-1.52 0A1.51 1.51 0 0 0 0 10.5v11a1.51 1.51 0 0 0 .77 1.31 1.48 1.48 0 0 0 1.52 0l6.31-3.98a17.79 17.79 0 0 0 3.12 2.43l-1.66 5.83a1.47 1.47 0 0 0 .48 1.56 1.51 1.51 0 0 0 1 .35 1.44 1.44 0 0 0 .67-.16l8-4A9.83 9.83 0 0 0 22 25c5 0 10-5.5 10-9s-5-9-10-9zm-8.12.37 2.22 1.11c-.57.23-1.13.48-1.69.76zM3 18.79v-5.58l4 2.51v.56zm10.88 5.84.53-1.87c.56.28 1.12.53 1.69.76zM22 22c-3.72 0-10.75-4.07-11.91-6 1.16-1.93 8.19-6 11.91-6 3.34 0 7 4.21 7 6s-3.66 6-7 6z" }), dl.createElement("circle", { cx: 25, cy: 16, r: 1.5 })), X7 = Y7, Nu = R(B()), J7 = (e) => Nu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Nu.createElement("path", { d: "M22 7a9.83 9.83 0 0 0-1.85.2l-8-4a1.5 1.5 0 0 0-2.11 1.75l1.66 5.83a17.79 17.79 0 0 0-3.1 2.39L2.29 9.23a1.48 1.48 0 0 0-1.52 0A1.51 1.51 0 0 0 0 10.5v11a1.51 1.51 0 0 0 .77 1.31 1.48 1.48 0 0 0 1.52 0l6.31-3.98a17.79 17.79 0 0 0 3.12 2.43l-1.66 5.83a1.47 1.47 0 0 0 .48 1.56 1.51 1.51 0 0 0 1 .35 1.44 1.44 0 0 0 .67-.16l8-4A9.83 9.83 0 0 0 22 25c5 0 10-5.5 10-9s-5-9-10-9zm3.5 11a2 2 0 1 1 2-2 2 2 0 0 1-2 2z" })), Q7 = J7, Ru = R(B()), e8 = (e) => Ru.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Ru.createElement("path", { d: "m24.18 11 4.67-7.47A1 1 0 0 0 28 2H6a1 1 0 0 0-1 1v26a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-9h20a1 1 0 0 0 .85-1.53zm-2.88 1.06L24.39 17H8V5h16.39L21.3 9.94a2 2 0 0 0 0 2.12z" })), t8 = e8, Bu = R(B()), n8 = (e) => Bu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Bu.createElement("path", { d: "m24.18 11 4.67-7.47A1 1 0 0 0 28 2H6a1 1 0 0 0-1 1v26a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-9h20a1 1 0 0 0 .85-1.53z" })), r8 = n8, Ta = R(B()), a8 = (e) => Ta.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Ta.createElement("path", { d: "M21 6H3a1 1 0 0 0-1 1v23a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zM5 28V9h14v19z" }), Ta.createElement("rect", { height: 3, rx: 1, width: 10, x: 7, y: 22 }), Ta.createElement("path", { d: "M29 1H12a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h15v19h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM8.5 20h7a1.5 1.5 0 0 0 1.13-2.49l-3.5-4a1.55 1.55 0 0 0-2.26 0l-3.5 4A1.5 1.5 0 0 0 8.5 20z" })), i8 = a8, fl = R(B()), o8 = (e) => fl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, fl.createElement("path", { d: "M29 1H12a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h12v21a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z" }), fl.createElement("path", { d: "M21 6H3a1 1 0 0 0-1 1v23a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zM7.37 17.51l3.5-4a1.55 1.55 0 0 1 2.26 0l3.5 4A1.5 1.5 0 0 1 15.5 20h-7a1.5 1.5 0 0 1-1.13-2.49zM17 24a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1z" })), l8 = o8, pl = R(B()), s8 = (e) => pl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, pl.createElement("path", { d: "M30 2c-.94-.94-2.8-1.48-5.16-1.48a23.87 23.87 0 0 0-16.62 7.7C0 17-.83 27.17 2 30c.94.94 2.67 1.47 4.9 1.47 4.51 0 11-2.19 16.88-7.69C32 16 32.83 4.83 30 2zm-8.27 19.59c-5.42 5.07-11.21 6.88-14.83 6.88a4.76 4.76 0 0 1-2.78-.59c-1-1-1.55-9.24 6.29-17.61a21 21 0 0 1 14.43-6.75 5.51 5.51 0 0 1 3 .6c1.23 1.3 1.34 10.49-6.11 17.47z" }), pl.createElement("path", { d: "M18.83 9.64a1 1 0 0 0-1.42 0l-.7.7a1 1 0 0 0 0 1.42l3.53 3.53a1 1 0 0 0 1.42 0l.7-.7a1 1 0 0 0 0-1.42zm-3.54 3.53a1 1 0 0 0-1.41 0l-.71.71a1 1 0 0 0 0 1.41l3.54 3.54a1 1 0 0 0 1.41 0l.71-.71a1 1 0 0 0 0-1.41zm-3.53 3.54a1 1 0 0 0-1.42 0l-.7.7a1 1 0 0 0 0 1.42l3.53 3.53a1 1 0 0 0 .71.3 1 1 0 0 0 .71-.3l.7-.7a1 1 0 0 0 0-1.42z" })), c8 = s8, Vu = R(B()), u8 = (e) => Vu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Vu.createElement("path", { d: "M30 2C27.17-.83 16 0 8.22 8.22 0 17-.83 27.17 2 30s13 2 21.78-6.22C32 16 32.83 4.83 30 2zM14.59 22.36l-.71.71a1 1 0 0 1-.71.29 1 1 0 0 1-.71-.29l-3.53-3.53a1 1 0 0 1 0-1.42l.71-.71a1 1 0 0 1 1.41 0L14.59 21a1 1 0 0 1 0 1.36zm4.24-4.24-.71.71a1 1 0 0 1-1.41 0l-3.54-3.54a1 1 0 0 1 0-1.41l.71-.71a1 1 0 0 1 1.41 0l3.54 3.54a1 1 0 0 1 0 1.41zm4.24-4.24-.71.71a1 1 0 0 1-.7.29 1 1 0 0 1-.71-.29l-3.54-3.54a1 1 0 0 1 0-1.41l.71-.71a1 1 0 0 1 1.42 0l3.53 3.53a1 1 0 0 1 0 1.42z" })), d8 = u8, Fu = R(B()), f8 = (e) => Fu.createElement("svg", { width: 32, height: 32, xmlns: "http://www.w3.org/2000/svg", className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Fu.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.277 3.277a4.505 4.505 0 0 1 6.371 0l.005.004c.126.128.241.264.347.405.106-.141.221-.277.347-.405l.005-.004A4.505 4.505 0 0 1 23.556 8.5H28a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-1.5 1.5h-.5V26a1.5 1.5 0 0 1-1.5 1.5H6A1.5 1.5 0 0 1 4.5 26v-8.5H4A1.5 1.5 0 0 1 2.5 16v-6A1.5 1.5 0 0 1 4 8.5h4.444a4.505 4.505 0 0 1 .833-5.223ZM14.5 11.5h-9v3h9v-3Zm0 6h-7v7h7v-7Zm3 7v-7h7v7h-7Zm0-10v-3h9v3h-9Zm3.105-6.976a1.505 1.505 0 0 0-2.13-2.129c-.115.119-.288.397-.456.902a9.555 9.555 0 0 0-.357 1.618c-.024.165-.044.328-.061.484.156-.017.319-.037.484-.06a9.558 9.558 0 0 0 1.618-.358c.505-.168.783-.341.902-.457Zm-6.206.875a16.354 16.354 0 0 1-.484-.06 9.558 9.558 0 0 1-1.618-.358c-.505-.168-.783-.34-.902-.457a1.505 1.505 0 0 1 2.13-2.129c.115.119.288.397.456.902.16.482.276 1.05.357 1.618.024.165.044.328.062.484Z" })), p8 = f8, Aa = R(B()), h8 = (e) => Aa.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Aa.createElement("rect", { height: 13, rx: 1, width: 10.5, x: 17.5, y: 16 }), Aa.createElement("rect", { height: 13, rx: 1, width: 10.5, x: 4, y: 16 }), Aa.createElement("path", { d: "M28 8h-6.1a3.45 3.45 0 0 0 .35-1.5A3.49 3.49 0 0 0 16 4.36 3.49 3.49 0 0 0 9.75 6.5 3.45 3.45 0 0 0 10.1 8H4a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1zm-9.25-3a1.5 1.5 0 1 1-1.5 1.5 1.5 1.5 0 0 1 1.5-1.5zm-7 1.5a1.5 1.5 0 1 1 1.5 1.5 1.5 1.5 0 0 1-1.5-1.5z" })), v8 = h8, Hu = R(B()), m8 = (e) => Hu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Hu.createElement("path", { d: "M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm1.5 12.45a26.12 26.12 0 0 0 3.63-.45 21.15 21.15 0 0 1 .31 2.52H17.5zm0-3V3.21a22.37 22.37 0 0 1 2.91 5.85 21.87 21.87 0 0 1-2.91.39zm-3 0a21.87 21.87 0 0 1-2.91-.39 22.37 22.37 0 0 1 2.91-5.85zm0 3v2.05h-3.94a21.15 21.15 0 0 1 .31-2.5 26.12 26.12 0 0 0 3.63.45zM7.56 14.5H3.09a13 13 0 0 1 1.49-4.7A24.42 24.42 0 0 0 8 11.2a24.19 24.19 0 0 0-.44 3.3zm0 3a24.52 24.52 0 0 0 .37 3.1A25.07 25.07 0 0 0 4.5 22a12.89 12.89 0 0 1-1.41-4.5zm3 0h3.94v1.84a25.07 25.07 0 0 0-3.67.48 22.25 22.25 0 0 1-.27-2.32zm3.94 4.84v6.45a22.39 22.39 0 0 1-3-6.05 22.79 22.79 0 0 1 3-.4zm3 0a22.79 22.79 0 0 1 3 .4 22.39 22.39 0 0 1-3 6.05zm0-3V17.5h3.94a22.25 22.25 0 0 1-.27 2.32 25.07 25.07 0 0 0-3.67-.48zm6.94-1.84h4.47A12.89 12.89 0 0 1 27.5 22a25.07 25.07 0 0 0-3.43-1.43 24.52 24.52 0 0 0 .37-3.07zm0-3a24.19 24.19 0 0 0-.44-3.3 24.42 24.42 0 0 0 3.39-1.4 13 13 0 0 1 1.49 4.7zm1.21-7.18a21.68 21.68 0 0 1-2.34 1 24.85 24.85 0 0 0-1.64-4 13.18 13.18 0 0 1 3.98 3zm-15.32-3a24.85 24.85 0 0 0-1.64 4 21.68 21.68 0 0 1-2.34-1 13.18 13.18 0 0 1 3.98-3zM6.21 24.53a21.39 21.39 0 0 1 2.43-1 24.91 24.91 0 0 0 1.69 4.15 13.23 13.23 0 0 1-4.12-3.15zm15.46 3.15a24.91 24.91 0 0 0 1.69-4.15 21.39 21.39 0 0 1 2.43 1 13.23 13.23 0 0 1-4.12 3.15z" })), g8 = m8, hl = R(B()), y8 = (e) => hl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, hl.createElement("path", { d: "M31 10.77a1 1 0 0 0-.51-.87L16.55 2.13a1 1 0 0 0-1 0L1.52 9.9a1 1 0 0 0 0 1.74l14.05 8.22a1 1 0 0 0 .51.14 1.06 1.06 0 0 0 .51-.14L28 13.12V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V10.77z" }), hl.createElement("path", { d: "M24.48 19.12a1 1 0 0 0-1 0L16 23.82l-7.47-4.67A1 1 0 0 0 7 20v3a1 1 0 0 0 .47.85l8 5a1 1 0 0 0 1.06 0l8-5A1 1 0 0 0 25 23v-3a1 1 0 0 0-.52-.88z" })), b8 = y8, Ar = R(B()), w8 = (e) => Ar.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Ar.createElement("rect", { x: 3, y: 2, width: 12.5, height: 12.5, rx: 1, ry: 1 }), Ar.createElement("rect", { x: 18.5, y: 2, width: 12.5, height: 12.5, rx: 1, ry: 1 }), Ar.createElement("rect", { x: 3, y: 17.5, width: 12.5, height: 12.5, rx: 1, ry: 1 }), Ar.createElement("rect", { x: 18.5, y: 17.5, width: 12.5, height: 12.5, rx: 1, ry: 1 })), x8 = w8, Lt = R(B()), E8 = (e) => Lt.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Lt.createElement("rect", { x: 2, y: 2, width: 6, height: 6, rx: 1, ry: 1 }), Lt.createElement("rect", { x: 24, y: 2, width: 6, height: 6, rx: 1, ry: 1 }), Lt.createElement("rect", { x: 13, y: 2, width: 6, height: 6, rx: 1, ry: 1 }), Lt.createElement("rect", { x: 2, y: 24, width: 6, height: 6, rx: 1, ry: 1 }), Lt.createElement("rect", { x: 24, y: 24, width: 6, height: 6, rx: 1, ry: 1 }), Lt.createElement("rect", { x: 13, y: 24, width: 6, height: 6, rx: 1, ry: 1 }), Lt.createElement("rect", { x: 2, y: 13, width: 6, height: 6, rx: 1, ry: 1 }), Lt.createElement("rect", { x: 24, y: 13, width: 6, height: 6, rx: 1, ry: 1 }), Lt.createElement("rect", { x: 13, y: 13, width: 6, height: 6, rx: 1, ry: 1 })), $8 = E8, vl = R(B()), P8 = (e) => vl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, vl.createElement("path", { d: "m31.76 15.36-3.06-3.49.43-4.61a1 1 0 0 0-.76-1l-4.52-1-2.37-4a1 1 0 0 0-1.22-.4L16 2.65 11.74.81a1 1 0 0 0-1.22.4l-2.37 4-4.52 1a1 1 0 0 0-.76 1l.43 4.61-3.06 3.54a1 1 0 0 0 0 1.28l3.06 3.49-.43 4.61a1 1 0 0 0 .76 1l4.52 1 2.37 4a1 1 0 0 0 1.22.4L16 29.35l4.26 1.84a1 1 0 0 0 .38.08 1 1 0 0 0 .84-.48l2.37-4 4.52-1a1 1 0 0 0 .76-1l-.43-4.61 3.06-3.49a1 1 0 0 0 0-1.33zm-5.53 3.15-.56.63.08.84.31 3.33-3.27.69-.81.19-.43.72-1.71 2.87-3.07-1.28-.77-.33-.77.33-3.07 1.32L10.45 25l-.45-.77-.79-.23-3.27-.73.31-3.27.08-.84-.56-.63L3.57 16l2.2-2.51.56-.63-.08-.86-.31-3.31L9.21 8l.79-.23.43-.72 1.71-2.87 3.09 1.32.77.33.77-.33 3.07-1.32 1.71 2.87.43.72.81.19 3.27.73-.31 3.31-.08.84.56.63 2.2 2.53z" }), vl.createElement("path", { d: "M22.94 11.53a1 1 0 0 0-1.41 0l-6.65 6.64-3-3a1 1 0 0 0-1.41 0l-.71.7a1 1 0 0 0 0 1.42l3.7 3.71.71.71a1 1 0 0 0 .71.29 1 1 0 0 0 .71-.29l.7-.71 7.36-7.35a1 1 0 0 0 0-1.42z" })), C8 = P8, Ku = R(B()), S8 = (e) => Ku.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Ku.createElement("path", { d: "m31.76 15.36-3.06-3.49.43-4.61a1 1 0 0 0-.76-1l-4.52-1-2.37-4a1 1 0 0 0-1.22-.4L16 2.65 11.74.81a1 1 0 0 0-1.22.4l-2.37 4-4.52 1a1 1 0 0 0-.76 1l.43 4.61-3.06 3.54a1 1 0 0 0 0 1.28l3.06 3.49-.43 4.61a1 1 0 0 0 .76 1l4.52 1 2.37 4a1 1 0 0 0 1.22.4L16 29.35l4.26 1.84a1 1 0 0 0 .38.08 1 1 0 0 0 .84-.48l2.37-4 4.52-1a1 1 0 0 0 .76-1l-.43-4.61 3.06-3.49a1 1 0 0 0 0-1.33zm-8.11-1.71L16.29 21l-.7.71a1 1 0 0 1-.71.29 1 1 0 0 1-.71-.29l-.71-.71-3.73-3.73a1 1 0 0 1 0-1.42l.71-.7a1 1 0 0 1 1.41 0l3 3 6.65-6.64a1 1 0 0 1 1.41 0l.71.7a1 1 0 0 1 .03 1.44z" })), k8 = S8, ml = R(B()), T8 = (e) => ml.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, ml.createElement("path", { d: "M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm0 29a13 13 0 1 1 13-13 13 13 0 0 1-13 13z" }), ml.createElement("path", { d: "M21 10a4.51 4.51 0 0 0-4.5 4.5 1 1 0 0 0 1 1h1a1 1 0 0 0 1-1 1.5 1.5 0 0 1 3 0 1 1 0 0 0 1 1h1a1 1 0 0 0 1-1A4.51 4.51 0 0 0 21 10zm1.5 7.5h-1a1 1 0 0 0-1 1 4.5 4.5 0 0 1-9 0 1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1 7.5 7.5 0 0 0 15 0 1 1 0 0 0-1-1zm-13-3a1.5 1.5 0 0 1 3 0 1 1 0 0 0 1 1h1a1 1 0 0 0 1-1 4.5 4.5 0 0 0-9 0 1 1 0 0 0 1 1h1a1 1 0 0 0 1-1z" })), A8 = T8, ju = R(B()), O8 = (e) => ju.createElement("svg", { width: 32, height: 32, xmlns: "http://www.w3.org/2000/svg", className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, ju.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.993 3.5c1.768-.013 3.52.326 5.157.997a13.4 13.4 0 0 1 4.388 2.922 13.507 13.507 0 0 1 2.933 4.393A13.582 13.582 0 0 1 29.5 17v7c0 .924-.364 1.814-1.017 2.47a3.477 3.477 0 0 1-2.468 1.03h-1.984a3.477 3.477 0 0 1-2.468-1.03A3.508 3.508 0 0 1 20.547 24v-5c0-.924.364-1.813 1.016-2.47a3.477 3.477 0 0 1 2.468-1.03h2.362a10.572 10.572 0 0 0-.695-2.542 10.505 10.505 0 0 0-2.28-3.418 10.4 10.4 0 0 0-3.406-2.267 10.326 10.326 0 0 0-4.006-.773h-.023a10.326 10.326 0 0 0-4.002.776 10.4 10.4 0 0 0-3.402 2.268 10.505 10.505 0 0 0-2.278 3.416 10.56 10.56 0 0 0-.694 2.54h2.362c.928 0 1.815.372 2.468 1.03A3.508 3.508 0 0 1 11.454 19v5c0 .924-.365 1.814-1.017 2.47a3.477 3.477 0 0 1-2.468 1.03H5.984a3.477 3.477 0 0 1-2.468-1.03A3.508 3.508 0 0 1 2.5 24v-7c0-1.78.35-3.541 1.028-5.185a13.506 13.506 0 0 1 2.93-4.391A13.4 13.4 0 0 1 10.84 4.5a13.326 13.326 0 0 1 5.153-1ZM5.5 18.5V24a.51.51 0 0 0 .146.358.477.477 0 0 0 .338.142H7.97c.125 0 .247-.05.338-.142A.508.508 0 0 0 8.453 24v-5a.508.508 0 0 0-.146-.358.477.477 0 0 0-.338-.142H5.5Zm21 0h-2.469a.477.477 0 0 0-.338.142.508.508 0 0 0-.146.358v5a.51.51 0 0 0 .145.358.477.477 0 0 0 .339.142h1.985c.124 0 .246-.05.338-.142A.508.508 0 0 0 26.5 24v-5.5Z" })), z8 = O8, Uu = R(B()), M8 = (e) => Uu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Uu.createElement("path", { d: "M28 5.45A8.23 8.23 0 0 0 22.19 3a8.2 8.2 0 0 0-5.83 2.45l-.36.36-.35-.36A8.17 8.17 0 0 0 9.87 3H9.8a8.14 8.14 0 0 0-5.73 2.35l-.1.1A8.44 8.44 0 0 0 4 17.24L15.29 28.7a1 1 0 0 0 1.42 0L28 17.24a8.46 8.46 0 0 0 0-11.79zM6.11 7.55l.06-.06a5.18 5.18 0 0 1 7.34.07l1.07 1.07L16 10.07l1.42-1.44 1.07-1.08A5.23 5.23 0 0 1 22.18 6a5.25 5.25 0 0 1 3.7 1.55 5.44 5.44 0 0 1 0 7.58L16 25.15l-9.89-10a5.43 5.43 0 0 1 0-7.6z" })), _8 = M8, Wu = R(B()), L8 = (e) => Wu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Wu.createElement("path", { d: "M28 5.45A8.23 8.23 0 0 0 22.19 3a8.2 8.2 0 0 0-5.83 2.45L16 5.8l-.35-.35a8.18 8.18 0 0 0-11.58-.1l-.1.1A8.44 8.44 0 0 0 4 17.24L15.29 28.7a1 1 0 0 0 1.42 0L28 17.24a8.46 8.46 0 0 0 0-11.79zm-23.35.7z" })), I8 = L8, qu = R(B()), D8 = (e) => qu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, qu.createElement("path", { d: "m29.68 12.27-13-12a1 1 0 0 0-1.36 0l-13 12A1 1 0 0 0 2 13v18a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-9h6v9a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1V13a1 1 0 0 0-.32-.73zM10 19v10H5V13.88L16 3.72l11 10.16V29h-5V19H10z" })), N8 = D8, Zu = R(B()), R8 = (e) => Zu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Zu.createElement("path", { d: "m29.68 12.27-13-12a1 1 0 0 0-1.36 0l-13 12A1 1 0 0 0 2 13v18a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1v-9h8v9a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V13a1 1 0 0 0-.32-.73z" })), B8 = R8, Gu = R(B()), V8 = (e) => Gu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Gu.createElement("path", { d: "M28 8V3a1 1 0 0 0-1-1H5a1 1 0 0 0-1 1v5a1 1 0 0 0 .29.71l7.3 7.29-7.3 7.29A1 1 0 0 0 4 24v5a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1v-5a1 1 0 0 0-.29-.71L20.41 16l7.3-7.29A1 1 0 0 0 28 8zm-4.61 17.08A1 1 0 0 1 23 27H9a1 1 0 0 1-.39-1.92l7-3a1 1 0 0 1 .78 0zM20.6 11.8l-4 3a1 1 0 0 1-1.2 0l-4-3A1 1 0 0 1 12 10h8a1 1 0 0 1 .6 1.8z" })), F8 = V8, gl = R(B()), H8 = (e) => gl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, gl.createElement("circle", { cx: 21, cy: 11, r: 3 }), gl.createElement("path", { d: "M29 2H3a1 1 0 0 0-1 1v26a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-2 22.1-7-7a1 1 0 0 0-1.41 0L15 20.6l-4.95-5-.69-.6a.87.87 0 0 0-.36-.27 1 1 0 0 0-.76 0A.91.91 0 0 0 8 15l-.71.7L5 17.9V5h22zm-22-2 3.66-3.66 4.95 4.95.7.71a1.19 1.19 0 0 0 .33.22 1.07 1.07 0 0 0 .76 0 1.19 1.19 0 0 0 .33-.22l3.53-3.54 6.4 6.4H5z" })), K8 = H8, yl = R(B()), j8 = (e) => yl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, yl.createElement("path", { d: "m7.34 15.65.71-.7a1 1 0 0 1 1.41 0l.71.7 4.95 5 3.54-3.53a1 1 0 0 1 1.41 0l.71.7L30 27V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v18zM21 7a3 3 0 1 1-3 3 3 3 0 0 1 3-3z" }), yl.createElement("path", { d: "m19.36 20.6-2.82 2.83-.71.71a1 1 0 0 1-.71.29 1 1 0 0 1-.71-.29l-.7-.71-5-4.95L2 25.24V29a1 1 0 0 0 1 1h25.76z" })), U8 = j8, Oa = R(B()), W8 = (e) => Oa.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Oa.createElement("path", { d: "M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm0 29a13 13 0 1 1 13-13 13 13 0 0 1-13 13z" }), Oa.createElement("circle", { cx: 16, cy: 8, r: 2 }), Oa.createElement("rect", { x: 14.5, y: 13, width: 3, height: 13, rx: 1, ry: 1 })), q8 = W8, Yu = R(B()), Z8 = (e) => Yu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Yu.createElement("path", { d: "M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm1.5 25a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V14a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1zM16 10a2 2 0 1 1 2-2 2 2 0 0 1-2 2z" })), G8 = Z8, bl = R(B()), Y8 = (e) => bl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, bl.createElement("circle", { cx: 16, cy: 8, r: 2 }), bl.createElement("rect", { x: 14.5, y: 13, width: 3, height: 13, rx: 1, ry: 1 })), X8 = Y8, wl = R(B()), J8 = (e) => wl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, wl.createElement("rect", { x: 2, y: 3, width: 28, height: 3, rx: 1, ry: 1 }), wl.createElement("path", { d: "M29 9H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h6l-2.87 5a1 1 0 0 0 .37 1.37l.87.5a1 1 0 0 0 1.36-.37l3.75-6.5h7l3.75 6.5a1 1 0 0 0 1.36.37l.87-.5a1 1 0 0 0 .41-1.37L23 25h6a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1zm-2 13H5V12h22z" })), Q8 = J8, xl = R(B()), ex = (e) => xl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, xl.createElement("rect", { x: 2, y: 3, width: 28, height: 3, rx: 1, ry: 1 }), xl.createElement("path", { d: "M29 9H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h6l-2.87 5a1 1 0 0 0 .37 1.37l.87.5a1 1 0 0 0 1.36-.37l3.76-6.5h7l3.76 6.5a1 1 0 0 0 1.36.37l.87-.5a1 1 0 0 0 .39-1.37L23 25h6a1 1 0 0 0 1-1V10a1 1 0 0 0-1-1z" })), tx = ex, Xu = R(B()), nx = (e) => Xu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Xu.createElement("path", { d: "M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm6.71 20.59a1 1 0 0 1 0 1.41l-.71.71a1 1 0 0 1-1.41 0L16 18.12l-4.59 4.59a1 1 0 0 1-1.41 0L9.29 22a1 1 0 0 1 0-1.41L13.88 16l-4.59-4.59a1 1 0 0 1 0-1.41l.71-.71a1 1 0 0 1 1.41 0L16 13.88l4.59-4.59a1 1 0 0 1 1.41 0l.71.71a1 1 0 0 1 0 1.41L18.12 16z" })), rx = nx, Ju = R(B()), ax = (e) => Ju.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Ju.createElement("path", { d: "M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm8.71 12.58L15.29 22l-.7.71a1.15 1.15 0 0 1-.33.21.94.94 0 0 1-.76 0 1.15 1.15 0 0 1-.33-.21l-.71-.71-5.16-5.17a1 1 0 0 1 0-1.41l.7-.71a1 1 0 0 1 1.41 0l4.46 4.46 8.71-8.71a1 1 0 0 1 1.41 0l.71.71a1 1 0 0 1 .01 1.41z" })), ix = ax, Qu = R(B()), ox = (e) => Qu.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Qu.createElement("path", { d: "M9 18H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V19a1 1 0 0 0-1-1zm-4 9v-6h2v6zm14-17h-6a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1zm-4 17V13h2v14zM29 2h-6a1 1 0 0 0-1 1v26a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-4 25V5h2v22z" })), lx = ox, za = R(B()), sx = (e) => za.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, za.createElement("rect", { height: 12, rx: 1, width: 8, x: 2, y: 18 }), za.createElement("rect", { height: 20, rx: 1, width: 8, x: 12, y: 10 }), za.createElement("rect", { height: 28, rx: 1, width: 8, x: 22, y: 2 })), cx = sx, ed = R(B()), ux = (e) => ed.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, ed.createElement("path", { d: "M29 6.74a1 1 0 0 0-.73-.41 1 1 0 0 0-.79.29L23.17 11a1 1 0 0 0-.17 1.14 7.95 7.95 0 0 1 0 7.72 1 1 0 0 0 .17 1.19l4.34 4.33a1 1 0 0 0 .7.3h.09a1 1 0 0 0 .73-.41A15.92 15.92 0 0 0 29 6.74zm-7.95 16.43a1 1 0 0 0-1.19-.17 8.07 8.07 0 0 1-7.72 0 1 1 0 0 0-1.19.17l-4.33 4.34a1 1 0 0 0-.29.79 1 1 0 0 0 .41.73 15.92 15.92 0 0 0 18.52 0 1 1 0 0 0 .41-.73 1 1 0 0 0-.29-.79zM11 8.83a1 1 0 0 0 1.14.17 8.07 8.07 0 0 1 7.72 0 1 1 0 0 0 .48.12 1 1 0 0 0 .71-.29l4.33-4.34a1 1 0 0 0 .29-.79 1 1 0 0 0-.41-.7A15.92 15.92 0 0 0 6.74 3a1 1 0 0 0-.41.73 1 1 0 0 0 .29.79zM9 19.86a7.95 7.95 0 0 1 0-7.72A1 1 0 0 0 8.83 11L4.49 6.62a.93.93 0 0 0-.79-.29 1 1 0 0 0-.7.41 15.92 15.92 0 0 0 0 18.52 1 1 0 0 0 .73.41h.09a1 1 0 0 0 .7-.3l4.34-4.33A1 1 0 0 0 9 19.86z" })), dx = ux, xn = R(B()), fx = (e) => xn.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, xn.createElement("rect", { x: 2, y: 2, width: 6, height: 6, rx: 1, ry: 1 }), xn.createElement("rect", { x: 2, y: 24, width: 6, height: 6, rx: 1, ry: 1 }), xn.createElement("rect", { x: 2, y: 13, width: 6, height: 6, rx: 1, ry: 1 }), xn.createElement("rect", { x: 11, y: 2, width: 19, height: 6, rx: 1, ry: 1 }), xn.createElement("rect", { x: 11, y: 24, width: 19, height: 6, rx: 1, ry: 1 }), xn.createElement("rect", { x: 11, y: 13, width: 19, height: 6, rx: 1, ry: 1 })), px = fx, El = R(B()), hx = (e) => El.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, El.createElement("path", { d: "M16 0A12 12 0 0 0 4 12c0 9.33 10.87 19.32 11.33 19.74a1 1 0 0 0 1.34 0C17.13 31.32 28 21.33 28 12A12 12 0 0 0 16 0zm0 3a9 9 0 0 1 9 9c0 6.22-6.2 13.31-9 16.19-2.8-2.88-9-10-9-16.19a9 9 0 0 1 9-9z" }), El.createElement("path", { d: "M16 18a6 6 0 1 0-6-6 6 6 0 0 0 6 6zm0-9a3 3 0 1 1-3 3 3 3 0 0 1 3-3z" })), vx = hx, td = R(B()), mx = (e) => td.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, td.createElement("path", { d: "M16 0A12 12 0 0 0 4 12c0 9.33 10.87 19.32 11.33 19.74a1 1 0 0 0 1.34 0C17.13 31.32 28 21.33 28 12A12 12 0 0 0 16 0zm0 17a5 5 0 1 1 5-5 5 5 0 0 1-5 5z" })), gx = mx, $l = R(B()), yx = (e) => $l.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, $l.createElement("path", { d: "M27 12h-3.5V9.5a7.5 7.5 0 0 0-15 0V12H5a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V13a1 1 0 0 0-1-1zM11.5 9.5a4.5 4.5 0 0 1 9 0V12h-9zM25 27H7V15h18z" }), $l.createElement("path", { d: "M14.5 22.05V25a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2.95a2.75 2.75 0 1 0-3 0z" })), bx = yx, nd = R(B()), wx = (e) => nd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, nd.createElement("path", { d: "M27 12h-3.5V9.5a7.5 7.5 0 0 0-15 0V12H5a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V13a1 1 0 0 0-1-1zM11.5 9.5a4.5 4.5 0 0 1 9 0V12h-9zm6 12.55V25a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-2.95a2.75 2.75 0 1 1 3 0z" })), xx = wx, Pl = R(B()), Ex = (e) => Pl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Pl.createElement("path", { d: "M0 7.41V24.5l8.12-8.97L0 7.41zM30.59 5H1.41L16 19.59 30.59 5z" }), Pl.createElement("path", { d: "m21.76 17.65-5.05 5.06a1 1 0 0 1-1.42 0l-5-5.06L1.79 27h28.42zm2.12-2.12L32 24.5V7.41l-8.12 8.12z" })), $x = Ex, rd = R(B()), Px = (e) => rd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, rd.createElement("path", { d: "M29 2h-8.49a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h4.37l-5.24 5.24a11.05 11.05 0 1 0 2.12 2.12L27 7.13v4.36a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zM13 27a8 8 0 1 1 8-8 8 8 0 0 1-8 8z" })), Cx = Px, ad = R(B()), Sx = (e) => ad.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, ad.createElement("path", { d: "M29.58 1.19a1 1 0 0 0-.9-.14L20 4l-8.68-2.9h-.09L11 1h-.32l-9 3A1 1 0 0 0 1 5v24a1 1 0 0 0 .42.81A.94.94 0 0 0 2 30a1.19 1.19 0 0 0 .32 0L11 27.05 19.68 30a1 1 0 0 0 .62 0l9-3a1 1 0 0 0 .7-1V2a1 1 0 0 0-.42-.81zM9.5 24.92l-6 2V6.08l6-2zm9 2-6-2V4.08l6 2zm9-2-6 2V6.08l6-2z" })), kx = Sx, Cl = R(B()), Tx = (e) => Cl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Cl.createElement("path", { d: "M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm0 29a13 13 0 1 1 13-13 13 13 0 0 1-13 13z" }), Cl.createElement("path", { d: "M20.06 7.32a1 1 0 0 0-1 .87l-1 7.74a.53.53 0 0 0 0 .13V25a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V8.32a1 1 0 0 0-1-1zM12.5 7C10.57 7 9 9.24 9 12a5.43 5.43 0 0 0 2 4.5V25a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-8.5a5.43 5.43 0 0 0 2-4.5c0-2.76-1.57-5-3.5-5z" })), Ax = Tx, Sl = R(B()), Ox = (e) => Sl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Sl.createElement("path", { d: "M10.2 17.92a1 1 0 0 1-.92-.62L3.1 2.38a1 1 0 0 1 .54-1.31l.92-.38a.94.94 0 0 1 .77 0 1 1 0 0 1 .54.54l6.18 14.92a1 1 0 0 1-.54 1.31l-.93.38a1 1 0 0 1-.38.08zm11.6 0a1 1 0 0 1-.38-.08l-.93-.38a1 1 0 0 1-.49-1.31l6.13-14.92a1 1 0 0 1 .54-.54.94.94 0 0 1 .77 0l.92.38a1 1 0 0 1 .54 1.31L22.72 17.3a1 1 0 0 1-.92.62z" }), Sl.createElement("circle", { cx: 16, cy: 24.5, r: 6.5 })), zx = Ox, Or = R(B()), Mx = (e) => Or.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Or.createElement("path", { d: "M30 11H2a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h28a1 1 0 0 0 1-1V12a1 1 0 0 0-1-1zM4 28V14h24v14z" }), Or.createElement("rect", { height: 3, rx: 1, width: 24, x: 4, y: 6 }), Or.createElement("rect", { height: 3, rx: 1, width: 18, x: 7, y: 1 }), Or.createElement("path", { d: "m19.55 20.17-6-4a1 1 0 0 0-1-.05A1 1 0 0 0 12 17v8a1 1 0 0 0 .53.88 1 1 0 0 0 1-.05l6-4a1 1 0 0 0 0-1.66z" })), _x = Mx, Ma = R(B()), Lx = (e) => Ma.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Ma.createElement("rect", { height: 3, rx: 1, width: 24, x: 4, y: 6 }), Ma.createElement("rect", { height: 3, rx: 1, width: 18, x: 7, y: 1 }), Ma.createElement("path", { d: "M30 11H2a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h28a1 1 0 0 0 1-1V12a1 1 0 0 0-1-1zM19.55 21.83l-6 4A1 1 0 0 1 12 25v-8a1 1 0 0 1 .53-.88 1 1 0 0 1 1 .05l6 4a1 1 0 0 1 0 1.66z" })), Ix = Lx, id = R(B()), Dx = (e) => id.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, id.createElement("path", { d: "M29 10h-6V5a1 1 0 0 0-1-1H10a1 1 0 0 0-1 1v5H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1zM12 7h8v3h-8zm9 12.5a1 1 0 0 1-1 1h-2.5V23a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-2.5H12a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h2.5V15a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v2.5H20a1 1 0 0 1 1 1z" })), Nx = Dx, _a = R(B()), Rx = (e) => _a.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", className: "ef-svg ef-icon", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, _a.createElement("path", { d: "M18.5 6.5C18.5 7.88071 17.3807 9 16 9C14.6193 9 13.5 7.88071 13.5 6.5C13.5 5.11929 14.6193 4 16 4C17.3807 4 18.5 5.11929 18.5 6.5Z" }), _a.createElement("path", { d: "M18.5 25.5C18.5 26.8807 17.3807 28 16 28C14.6193 28 13.5 26.8807 13.5 25.5C13.5 24.1193 14.6193 23 16 23C17.3807 23 18.5 24.1193 18.5 25.5Z" }), _a.createElement("path", { d: "M18.5 16C18.5 17.3807 17.3807 18.5 16 18.5C14.6193 18.5 13.5 17.3807 13.5 16C13.5 14.6193 14.6193 13.5 16 13.5C17.3807 13.5 18.5 14.6193 18.5 16Z" })), Bx = Rx, kl = R(B()), Vx = (e) => kl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, kl.createElement("rect", { y: 9, width: 32, height: 3, rx: 1, ry: 1 }), kl.createElement("rect", { y: 20, width: 32, height: 3, rx: 1, ry: 1 })), Fx = Vx, Tl = R(B()), Hx = (e) => Tl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Tl.createElement("path", { d: "M20.5 10h-1a1 1 0 0 0-.89.55L16 15.76l-2.61-5.21a1 1 0 0 0-.89-.55h-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-4.3l1.64 2.8a1 1 0 0 0 1.72 0l1.64-2.8V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1z" }), Tl.createElement("path", { d: "M31.2 12.08a1 1 0 0 0 .8-1V6a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v5.1a1 1 0 0 0 .8 1A4 4 0 0 1 4 16a4 4 0 0 1-3.2 3.92 1 1 0 0 0-.8 1V26a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1v-5.1a1 1 0 0 0-.8-1 4 4 0 0 1 0-7.84zM25 16a7 7 0 0 0 4 6.32V24H3v-1.68A7 7 0 0 0 7 16a7 7 0 0 0-4-6.32V8h26v1.68A7 7 0 0 0 25 16z" })), Kx = Hx, od = R(B()), jx = (e) => od.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, od.createElement("path", { d: "M31.2 12.08a1 1 0 0 0 .8-1V6a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v5.1a1 1 0 0 0 .8 1A4 4 0 0 1 4 16a4 4 0 0 1-3.2 3.92 1 1 0 0 0-.8 1V26a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1v-5.1a1 1 0 0 0-.8-1 4 4 0 0 1 0-7.84zM21.5 21a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-4.3l-1.64 2.8a1 1 0 0 1-1.72 0l-1.64-2.8V21a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V11a1 1 0 0 1 1-1h1a1 1 0 0 1 .89.55L16 15.76l2.61-5.21a1 1 0 0 1 .89-.55h1a1 1 0 0 1 1 1z" })), Ux = jx, Al = R(B()), Wx = (e) => Al.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Al.createElement("path", { d: "m23.42 18.6-.7-.71a1 1 0 0 0-1.42 0l-.7.71a6.52 6.52 0 0 1-9.2 0l-.7-.71a1 1 0 0 0-1.42 0l-.7.71a1 1 0 0 0 0 1.41l.7.71a9.42 9.42 0 0 0 5.22 2.65V27h-3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-3v-3.63a9.42 9.42 0 0 0 5.22-2.65l.7-.71a1 1 0 0 0 0-1.41zM16 2a5 5 0 0 0-5 5v2.05l6.73-6.72A5 5 0 0 0 16 2z" }), Al.createElement("path", { d: "M16 18a5 5 0 0 0 5-5V9l-8 8a4.94 4.94 0 0 0 3 1zm-6.35-1.94a1 1 0 0 0 .7.29 1 1 0 0 0 .71-.29l.71-.71 9.15-9.15 1.64-1.64a1 1 0 0 0 0-1.41l-.71-.71a1 1 0 0 0-1.41 0l-1 1L11 11.88l-2.06 2.06a1 1 0 0 0 0 1.41z" })), qx = Wx, Ol = R(B()), Zx = (e) => Ol.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Ol.createElement("path", { d: "m23.42 18.54-.7-.7a1 1 0 0 0-1.42 0l-.7.7a6.51 6.51 0 0 1-9.2 0l-.7-.7a1 1 0 0 0-1.42 0l-.7.7a1 1 0 0 0 0 1.42l.7.7a9.42 9.42 0 0 0 5.22 2.65V27h-3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-3v-3.69a9.42 9.42 0 0 0 5.22-2.65l.7-.7a1 1 0 0 0 0-1.42z" }), Ol.createElement("path", { d: "M16 18a5 5 0 0 0 5-5V7a5 5 0 0 0-10 0v6a5 5 0 0 0 5 5zM14 7a2 2 0 0 1 4 0v6a2 2 0 0 1-4 0z" })), Gx = Zx, zl = R(B()), Yx = (e) => zl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, zl.createElement("path", { d: "M16 18a5 5 0 0 0 5-5V7a5 5 0 0 0-10 0v6a5 5 0 0 0 5 5z" }), zl.createElement("path", { d: "m23.42 18.54-.7-.7a1 1 0 0 0-1.42 0l-.7.7a6.51 6.51 0 0 1-9.2 0l-.7-.7a1 1 0 0 0-1.42 0l-.7.7a1 1 0 0 0 0 1.42l.7.7a9.42 9.42 0 0 0 5.22 2.65V27h-3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h9a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-3v-3.69a9.42 9.42 0 0 0 5.22-2.65l.7-.7a1 1 0 0 0 0-1.42z" })), Xx = Yx, En = R(B()), Jx = (e) => En.createElement("svg", { width: 32, height: 32, xmlns: "http://www.w3.org/2000/svg", className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, En.createElement("g", { clipPath: "url(#a)" }, En.createElement("path", { d: "M16 0a16 16 0 1 0 0 32 16 16 0 0 0 0-32Zm0 29a13 13 0 1 1 0-26 13 13 0 0 1 0 26Z" }), En.createElement("path", { d: "M23 14.5H9a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Z" })), En.createElement("defs", null, En.createElement("clipPath", { id: "a" }, En.createElement("path", { d: "M0 0h32v32H0z" })))), Qx = Jx, Gn = R(B()), e9 = (e) => Gn.createElement("svg", { width: 32, height: 32, xmlns: "http://www.w3.org/2000/svg", className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Gn.createElement("g", { clipPath: "url(#a)" }, Gn.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.11 2.696a16 16 0 1 1 17.78 26.607A16 16 0 0 1 7.11 2.696Zm16.597 14.511A1 1 0 0 0 24 16.5v-1a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h14a1 1 0 0 0 .707-.293Z" })), Gn.createElement("defs", null, Gn.createElement("clipPath", { id: "a" }, Gn.createElement("path", { d: "M0 0h32v32H0z" })))), t9 = e9, ld = R(B()), n9 = (e) => ld.createElement("svg", { width: 32, height: 32, xmlns: "http://www.w3.org/2000/svg", className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, ld.createElement("path", { d: "M17.5 14.5H23a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h8.5Z" })), r9 = n9, sd = R(B()), a9 = (e) => sd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, sd.createElement("path", { d: "M27 29h-2v-7a1 1 0 0 0-1-1h-3.17L19.11 8.89a5 5 0 1 0-6.22 0L11.17 21H8a1 1 0 0 0-1 1v7H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1zm-17-5h12v5H10zm6-21a2 2 0 1 1-2 2 2 2 0 0 1 2-2zm-.24 7h.48l1.56 11h-3.6z" })), i9 = a9, cd = R(B()), o9 = (e) => cd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, cd.createElement("path", { d: "M27.33 17.46a1 1 0 0 0-1.11 0c-3.67 2.34-8.17 2-10.94-.72s-3.06-7.27-.72-10.94a1 1 0 0 0-1.05-1.52 12 12 0 1 0 14.23 14.21 1 1 0 0 0-.41-1.03ZM16 25a9 9 0 0 1-5.88-15.8 11.12 11.12 0 0 0 3 9.64A11 11 0 0 0 21 22a12.32 12.32 0 0 0 1.83-.14A9 9 0 0 1 16 25Z", "data-name": "Layer 4" })), l9 = o9, ud = R(B()), s9 = (e) => ud.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, ud.createElement("path", { d: "M27.33 17.46a1 1 0 0 0-1.11 0c-3.67 2.34-8.17 2-10.94-.72s-3.06-7.27-.72-10.94a1 1 0 0 0-1.05-1.52 12 12 0 1 0 14.23 14.21 1 1 0 0 0-.41-1.03Z", "data-name": "Layer 4" })), c9 = s9, dd = R(B()), u9 = (e) => dd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, dd.createElement("path", { d: "M26.64 4.23a1 1 0 0 0-.82-.23l-16 3A1 1 0 0 0 9 8v11.78a4.39 4.39 0 0 0-1.5-.28A4.5 4.5 0 1 0 12 24V9.81l12-2.57v8.54a4.39 4.39 0 0 0-1.5-.28A4.5 4.5 0 1 0 27 20V5a1 1 0 0 0-.36-.77zM7.5 25.5A1.5 1.5 0 1 1 9 24a1.5 1.5 0 0 1-1.5 1.5zm15-4A1.5 1.5 0 1 1 24 20a1.5 1.5 0 0 1-1.5 1.5z" })), d9 = u9, fd = R(B()), f9 = (e) => fd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, fd.createElement("path", { d: "M26.64 4.23a1 1 0 0 0-.82-.23l-16 3A1 1 0 0 0 9 8v11.78a4.39 4.39 0 0 0-1.5-.28A4.5 4.5 0 1 0 12 24V9.81l12-2.57v8.54a4.39 4.39 0 0 0-1.5-.28A4.5 4.5 0 1 0 27 20V5a1 1 0 0 0-.36-.77z" })), p9 = f9, zr = R(B()), h9 = (e) => zr.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, zr.createElement("path", { d: "M28 1H4a1 1 0 0 0-1 1v28a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM6 28V4h20v24z" }), zr.createElement("rect", { height: 3, rx: 1, width: 14, x: 9, y: 8 }), zr.createElement("rect", { height: 3, rx: 1, width: 14, x: 9, y: 14.5 }), zr.createElement("rect", { height: 3, rx: 1, width: 14, x: 9, y: 21 })), v9 = h9, pd = R(B()), m9 = (e) => pd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, pd.createElement("path", { d: "M28 1H4a1 1 0 0 0-1 1v28a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zm-5 23a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1zm0-7.5a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1zM23 9a1 1 0 0 1-1 1H10a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1z" })), g9 = m9, Mr = R(B()), y9 = (e) => Mr.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Mr.createElement("path", { d: "M29 2H3a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h11.5v3H10a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-4.5v-3H29a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zM5 21V5h22v16z" }), Mr.createElement("circle", { cx: 10, cy: 9.5, r: 2 }), Mr.createElement("circle", { cx: 10, cy: 16.5, r: 2 }), Mr.createElement("path", { d: "M24.71 9.73 24 9a1 1 0 0 0-1.41 0l-4.15 4.14-2-2a1 1 0 0 0-1.41 0l-.71.7a1 1 0 0 0 0 1.42L17 16l.7.71a1 1 0 0 0 1.42 0l.7-.71 4.86-4.85a1 1 0 0 0 .03-1.42z" })), b9 = y9, hd = R(B()), w9 = (e) => hd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, hd.createElement("path", { d: "M29 2H3a1 1 0 0 0-1 1v20a1 1 0 0 0 1 1h11.5v3H10a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-4.5v-3H29a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zM9 18.5a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm0-7a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm16.71-.35L20.85 16l-.7.71a1 1 0 0 1-1.42 0L18 16l-2.74-2.73a1 1 0 0 1 0-1.42l.71-.7a1 1 0 0 1 1.41 0l2 2L23.59 9A1 1 0 0 1 25 9l.71.7a1 1 0 0 1 0 1.45z" })), x9 = w9, La = R(B()), E9 = (e) => La.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, La.createElement("g", { "data-name": "Layer 4" }, La.createElement("path", { d: "M9.5 5a5.5 5.5 0 0 1 1 10.91l-1 .17-1-.17A5.5 5.5 0 0 1 9.5 5m0-3A8.5 8.5 0 0 0 8 18.86V27H3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-1v-2h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H16a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a.24.24 0 0 0 0 .08V27h-6v-8.14A8.5 8.5 0 0 0 9.5 2ZM20 27v-1.92a.24.24 0 0 0 0-.08h5v2Z" }), La.createElement("path", { d: "M29 18H16a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Z" }))), $9 = E9, vd = R(B()), P9 = (e) => vd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, vd.createElement("path", { d: "M12 4a1 1 0 0 1 1 1v22a1 1 0 0 1-1 1H8a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h4Zm12 0a1 1 0 0 1 1 1v22a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h4Z" })), C9 = P9, md = R(B()), S9 = (e) => md.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, md.createElement("path", { d: "m28.71 10.15-6.86-6.86a1 1 0 0 0-1.41 0l-16 16a1 1 0 0 0-.29.57l-1.15 8a1 1 0 0 0 .28.85A1 1 0 0 0 4 29h.14l8-1.14a1 1 0 0 0 .57-.29l16-16a1 1 0 0 0 0-1.42zm-7 4.15-4-4 3.44-3.45 4 4zM6.36 25.64l.64-4.7 8.54-8.54 4 4-8.48 8.6z" })), k9 = S9, gd = R(B()), T9 = (e) => gd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, gd.createElement("path", { d: "m28.71 10.15-6.86-6.86a1 1 0 0 0-1.41 0l-4.87 4.86 8.28 8.28 4.86-4.87a1 1 0 0 0 0-1.41zm-15.26.13-9 9a1 1 0 0 0-.29.57L3 27.86a1 1 0 0 0 .28.85A1 1 0 0 0 4 29h.14l8-1.14a1 1 0 0 0 .57-.29l9-9z" })), A9 = T9, Ia = R(B()), O9 = (e) => Ia.createElement("svg", { width: 32, height: 32, xmlns: "http://www.w3.org/2000/svg", className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Ia.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M24.675 11.225a5 5 0 1 0-5.35-8.45 5 5 0 0 0 5.35 8.45ZM22 9a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z" }), Ia.createElement("path", { d: "M18.894 14.375c-1.852.45-3.467 1.262-4.668 2.19 1.265.343 2.435.823 3.476 1.389A10.281 10.281 0 0 1 22 17c2.135 0 4.072.694 5.433 1.58.68.443 1.14.885 1.4 1.223.062.082.106.148.136.197h-8.417c.384.366.734.751 1.043 1.153.395.516.781 1.14 1.049 1.847H31a1 1 0 0 0 1-1v-2.12c0-1.872-2.893-4.533-6.894-5.505A13.154 13.154 0 0 0 22 14c-1.084 0-2.128.137-3.106.375Z" }), Ia.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15 12a4.996 4.996 0 0 1-5 5 4.996 4.996 0 0 1-5-5 5 5 0 0 1 10 0Zm-3 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM0 24.88c0-1.872 2.893-4.533 6.894-5.505A13.155 13.155 0 0 1 10 19c1.084 0 2.128.137 3.106.375C17.107 20.347 20 23.008 20 24.88V27a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-2.12Zm16.833-.077c.062.082.106.148.136.197H3.03c.03-.05.074-.115.136-.197.26-.338.72-.78 1.4-1.223C5.928 22.694 7.865 22 10 22s4.072.694 5.433 1.58c.68.443 1.14.885 1.4 1.223Z" })), z9 = O9, Da = R(B()), M9 = (e) => Da.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Da.createElement("circle", { cx: 22, cy: 9, r: 5 }), Da.createElement("path", { d: "M22 16a13.27 13.27 0 0 0-5.72 1.31C20.13 19 23 21.89 23 24.88V25h8a1 1 0 0 0 1-1v-2.12C32 19.55 27.52 16 22 16zm-12 3c-5.52 0-10 3.55-10 5.88V27a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-2.12C20 22.55 15.52 19 10 19z" }), Da.createElement("circle", { cx: 10, cy: 12, r: 5 })), _9 = M9, yd = R(B()), L9 = (e) => yd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, yd.createElement("path", { d: "M16 16a7 7 0 1 0-7-7 7 7 0 0 0 7 7zm0-11a4 4 0 1 1-4 4 4 4 0 0 1 4-4zm0 13c-7 0-13 4.61-13 7.5V29a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1v-3.5c0-2.89-5.95-7.5-13-7.5zm0 3c5.63 0 9.63 3.39 10 4.58V27H6v-1.42C6.37 24.39 10.37 21 16 21z" })), I9 = L9, Ml = R(B()), D9 = (e) => Ml.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Ml.createElement("circle", { cx: 16, cy: 9, r: 7 }), Ml.createElement("path", { d: "M16 18c-7 0-13 4.61-13 7.5V29a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1v-3.5c0-2.89-5.95-7.5-13-7.5z" })), N9 = D9, bd = R(B()), R9 = (e) => bd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, bd.createElement("path", { d: "m28.32 21.05-6-2a1 1 0 0 0-1.21.5L19.39 23c-5-.38-10-5.33-10.37-10.37l3.43-1.72A1 1 0 0 0 13 9.68l-2-6A1 1 0 0 0 10 3H6a1 1 0 0 0-.71.29l-2 2A1 1 0 0 0 3 6c0 13.76 9.24 23 23 23a1 1 0 0 0 .71-.29l2-2A1 1 0 0 0 29 26v-4a1 1 0 0 0-.68-.95z" })), B9 = R9, wd = R(B()), V9 = (e) => wd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, wd.createElement("path", { d: "M26.73 2.32A1 1 0 0 0 26 2H6a1 1 0 0 0-.73.32 1 1 0 0 0-.27.76l2 26A1 1 0 0 0 8 30h16a1 1 0 0 0 1-.92l2-26a1 1 0 0 0-.27-.76zM8.62 11l-.46-6h15.68l-.46 6z" })), F9 = V9, _l = R(B()), H9 = (e) => _l.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, _l.createElement("path", { d: "M28.07 5.34a19 19 0 0 0-24.15 0 1 1 0 0 0-.26 1.2l.44.94a1 1 0 0 0 .69.52H5a1 1 0 0 0 .65-.24 15.92 15.92 0 0 1 20.69 0 1 1 0 0 0 .87.21 1 1 0 0 0 .69-.55l.44-.94a1 1 0 0 0-.27-1.14z" }), _l.createElement("path", { d: "M25.93 10.12a14 14 0 0 0-19.86 0 1 1 0 0 0-.2 1.13l9.22 19.67a1 1 0 0 0 1.82 0l9.22-19.67a1 1 0 0 0-.2-1.13zM10 12a2 2 0 1 1 2 2 2 2 0 0 1-2-2zm5 11a2 2 0 1 1 2-2 2 2 0 0 1-2 2zm4-6a2 2 0 1 1 2-2 2 2 0 0 1-2 2z" })), K9 = H9, xd = R(B()), j9 = (e) => xd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, xd.createElement("path", { d: "m26.55 15.17-18-12a1 1 0 0 0-1 0A1 1 0 0 0 7 4v24a1 1 0 0 0 .53.88 1 1 0 0 0 1-.05l18-12a1 1 0 0 0 0-1.66zM10 24.26V7.74L22.39 16z" })), U9 = j9, Ed = R(B()), W9 = (e) => Ed.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Ed.createElement("path", { d: "m26.55 15.17-18-12a1 1 0 0 0-1 0A1 1 0 0 0 7 4v24a1 1 0 0 0 .53.88 1 1 0 0 0 1-.05l18-12a1 1 0 0 0 0-1.66z" })), q9 = W9, Ll = R(B()), Z9 = (e) => Ll.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Ll.createElement("path", { d: "M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm0 29a13 13 0 1 1 13-13 13 13 0 0 1-13 13z" }), Ll.createElement("path", { d: "M23 14.5h-5.5V9a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v5.5H9a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h5.5V23a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-5.5H23a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1z" })), G9 = Z9, $d = R(B()), Y9 = (e) => $d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, $d.createElement("path", { d: "M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm8 16.5a1 1 0 0 1-1 1h-5.5V23a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-5.5H9a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h5.5V9a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v5.5H23a1 1 0 0 1 1 1z" })), X9 = Y9, Pd = R(B()), J9 = (e) => Pd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Pd.createElement("path", { d: "M23 14.5h-5.5V9a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v5.5H9a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h5.5V23a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-5.5H23a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1z" })), Q9 = J9, Cd = R(B()), eE = (e) => Cd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Cd.createElement("path", { d: "m25.86 23.46-7.14-7.14 6.62-2.38a1 1 0 0 0 0-1.87l-20-8a1 1 0 0 0-1.3 1.3l8 20A1 1 0 0 0 13 26a1 1 0 0 0 .92-.66l2.38-6.62 7.14 7.14a1 1 0 0 0 .71.3 1 1 0 0 0 .71-.3l1-1a1 1 0 0 0 0-1.4zM8.59 8.59l10.78 4.31-3.87 1.4a2 2 0 0 0-1.21 1.2l-1.39 3.87z" })), tE = eE, Sd = R(B()), nE = (e) => Sd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Sd.createElement("path", { d: "m25.86 23.46-7.14-7.14 6.62-2.38a1 1 0 0 0 0-1.87l-20-8a1 1 0 0 0-1.3 1.3l8 20A1 1 0 0 0 13 26a1 1 0 0 0 .92-.66l2.38-6.62 7.14 7.14a1 1 0 0 0 .71.3 1 1 0 0 0 .71-.3l1-1a1 1 0 0 0 0-1.4z" })), rE = nE, Il = R(B()), aE = (e) => Il.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Il.createElement("path", { d: "M28 3H16.67a1 1 0 0 0-.7.29L1.12 18.14a1 1 0 0 0 0 1.42l11.31 11.31a1 1 0 0 0 .71.29 1 1 0 0 0 .7-.29L28.69 16a1 1 0 0 0 .3-.71V4A1 1 0 0 0 28 3zm-2 3v8.49L13.15 27.33l-8.48-8.48L17.51 6z" }), Il.createElement("circle", { cx: 22, cy: 10, r: 2 })), iE = aE, kd = R(B()), oE = (e) => kd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, kd.createElement("path", { d: "M28 3H16.67a1 1 0 0 0-.7.29L1.12 18.14a1 1 0 0 0 0 1.42l11.31 11.31a1 1 0 0 0 .71.29 1 1 0 0 0 .7-.29L28.69 16a1 1 0 0 0 .3-.71V4A1 1 0 0 0 28 3zm-3.54 7.36a2 2 0 1 1 0-2.82 2 2 0 0 1-.01 2.82z" })), lE = oE, Dl = R(B()), sE = (e) => Dl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Dl.createElement("path", { d: "M29 8h-5V2a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1v6H3a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h5v6a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1v-6h5a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1zM11 4h10v4H11zm10 17v7H11v-7zm2-3H9a1 1 0 0 0-1 1v2H5V11h22v10h-3v-2a1 1 0 0 0-1-1z" }), Dl.createElement("rect", { height: 2.99, rx: 1, width: 3, x: 21, y: 13.01 })), cE = sE, $n = R(B()), uE = (e) => $n.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, $n.createElement("rect", { height: 3, rx: 1, width: 3, x: 6.5, y: 22.5 }), $n.createElement("rect", { height: 3, rx: 1, width: 3, x: 6.5, y: 6.5 }), $n.createElement("rect", { height: 3, rx: 1, width: 3, x: 22.5, y: 6.5 }), $n.createElement("rect", { height: 5, rx: 1, width: 3, x: 18, y: 25 }), $n.createElement("rect", { height: 3, rx: 1, width: 3, x: 26, y: 18 }), $n.createElement("path", { d: "M23 21a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1zm5 2h-1a1 1 0 0 0-1 1v3h-2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1zm-15-5H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V19a1 1 0 0 0-1-1zm-8 9v-6h6v6zm8-25H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-8 9V5h6v6zm24-9H19a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-8 9V5h6v6z" })), dE = uE, Na = R(B()), fE = (e) => Na.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Na.createElement("path", { d: "m31.76 15.31-3.06-3.48.43-4.62a1 1 0 0 0-.76-1l-4.52-1-2.37-4a1 1 0 0 0-1.22-.44L16 2.6 11.74.77a1 1 0 0 0-1.22.39l-2.37 4-4.52 1a1 1 0 0 0-.76 1l.43 4.62-3.06 3.53a1 1 0 0 0 0 1.29l3.06 3.48-.43 4.62a1 1 0 0 0 .76 1l4.52 1 2.37 4a1 1 0 0 0 1.22.4L16 29.31l4.26 1.83a.84.84 0 0 0 .38.08 1 1 0 0 0 .84-.48l2.37-4 4.52-1a1 1 0 0 0 .76-1l-.43-4.62 3.06-3.48a1 1 0 0 0 0-1.33zm-5.53 3.16-.56.63.08.83.31 3.33-3.27.74-.81.18-.43.72-1.71 2.88-3.07-1.32-.77-.34-.77.34-3.07 1.32-1.71-2.88-.45-.72-.79-.18-3.27-.74.31-3.33.08-.83-.56-.63L3.57 16l2.2-2.51.56-.63-.08-.86-.31-3.35 3.27-.74.79-.18.45-.73 1.71-2.88 3.07 1.32.77.34.77-.34 3.07-1.32L21.55 7l.43.72.81.18 3.27.74-.31 3.36-.08.83.56.63 2.2 2.54z" }), Na.createElement("path", { d: "M16 7.46A5.5 5.5 0 0 0 10.5 13a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1 2.5 2.5 0 1 1 2.5 2.5h-1a1 1 0 0 0-1 1V19a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-.64a5.5 5.5 0 0 0-1-10.9z" }), Na.createElement("rect", { height: 3, rx: 1, width: 3, x: 14, y: 20.96 })), pE = fE, Td = R(B()), hE = (e) => Td.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Td.createElement("path", { d: "m31.76 15.31-3.06-3.48.43-4.62a1 1 0 0 0-.76-1l-4.52-1-2.37-4a1 1 0 0 0-1.22-.44L16 2.6 11.74.77a1 1 0 0 0-1.22.39l-2.37 4-4.52 1a1 1 0 0 0-.76 1l.43 4.62-3.06 3.53a1 1 0 0 0 0 1.29l3.06 3.48-.43 4.62a1 1 0 0 0 .76 1l4.52 1 2.37 4a1 1 0 0 0 1.22.4L16 29.31l4.26 1.83a.84.84 0 0 0 .38.08 1 1 0 0 0 .84-.48l2.37-4 4.52-1a1 1 0 0 0 .76-1l-.43-4.62 3.06-3.48a1 1 0 0 0 0-1.33zM17 24a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1zm0-5.6v.6a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-2.5a1 1 0 0 1 1-1h1a2.5 2.5 0 1 0-2.5-2.5 1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1 5.5 5.5 0 1 1 6.5 5.4z" })), vE = hE, Pn = R(B()), mE = (e) => Pn.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Pn.createElement("g", { "data-name": "Layer 4" }, Pn.createElement("rect", { x: 5.01, y: 25.01, width: 5, height: 3, rx: 1, transform: "rotate(-90 7.505 26.505)" }), Pn.createElement("rect", { x: 10, y: 26, width: 5, height: 3, rx: 1, transform: "rotate(-90 12.505 27.495)" }), Pn.createElement("rect", { x: 15.01, y: 25, width: 5, height: 3, rx: 1, transform: "rotate(-90 17.505 26.495)" }), Pn.createElement("rect", { x: 19.98, y: 26, width: 5, height: 3, rx: 1, transform: "rotate(-90 22.48 27.5)" }), Pn.createElement("path", { d: "M21.89 7a8 8 0 0 0-15.42 3 1.09 1.09 0 0 0 0 .18A6.5 6.5 0 0 0 8 23h13.5a8 8 0 0 0 .42-16Zm-.42 13H8a3.49 3.49 0 0 1-.26-7l2.14-.17-.32-2.12a5.34 5.34 0 0 1-.09-.71 5 5 0 0 1 9.8-1.42l.44 1.5 1.56-.08h.2a5 5 0 0 1 0 10Z" }))), gE = mE, Cn = R(B()), yE = (e) => Cn.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Cn.createElement("g", { "data-name": "Layer 4" }, Cn.createElement("rect", { x: 5.01, y: 25.01, width: 5, height: 3, rx: 1, transform: "rotate(-90 7.505 26.505)" }), Cn.createElement("rect", { x: 10, y: 26, width: 5, height: 3, rx: 1, transform: "rotate(-90 12.505 27.495)" }), Cn.createElement("rect", { x: 15.01, y: 25, width: 5, height: 3, rx: 1, transform: "rotate(-90 17.505 26.495)" }), Cn.createElement("rect", { x: 19.98, y: 26, width: 5, height: 3, rx: 1, transform: "rotate(-90 22.48 27.5)" }), Cn.createElement("path", { d: "M21.42 7A8 8 0 0 0 6 10v.18A6.5 6.5 0 0 0 7.5 23H21a8 8 0 0 0 .42-16Z" }))), bE = yE, Ad = R(B()), wE = (e) => Ad.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Ad.createElement("path", { d: "M16 4a12 12 0 0 0-8.49 3.52A1 1 0 0 0 7.57 9l.77.64a1 1 0 0 0 1.31 0A9 9 0 0 1 25 16.26a9 9 0 0 1-17.86 1.35l1.33 1.32a1 1 0 0 0 1.41 0l.71-.71a1 1 0 0 0 0-1.41l-4.25-4.25a1 1 0 0 0-1.42 0L.67 16.81a1 1 0 0 0 0 1.41l.71.71a1 1 0 0 0 1.41 0l1.33-1.33A12 12 0 1 0 16 4Z", "data-name": "Layer 4" })), xE = wE, Sn = R(B()), EE = (e) => Sn.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Sn.createElement("g", { "data-name": "Layer 4" }, Sn.createElement("path", { d: "M4 30H3a1 1 0 0 1-1-1.15l4-26A1 1 0 0 1 7 2h1a1 1 0 0 1 1 1.15l-4 26A1 1 0 0 1 4 30Zm25 0h-1a1 1 0 0 1-1-.85l-4-26A1 1 0 0 1 24 2h1a1 1 0 0 1 1 .85l4 26A1 1 0 0 1 29 30Z" }), Sn.createElement("rect", { x: 14.5, y: 8.5, width: 3, height: 6, rx: 1 }), Sn.createElement("rect", { x: 14.5, y: 17.5, width: 3, height: 6, rx: 1 }), Sn.createElement("rect", { x: 14.5, y: 26.5, width: 3, height: 3.5, rx: 1 }), Sn.createElement("rect", { x: 14.5, y: 2, width: 3, height: 3.5, rx: 1 }))), $E = EE, Od = R(B()), PE = (e) => Od.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Od.createElement("path", { d: "M26 2.85A1 1 0 0 0 25 2h-7.5v2.5a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V2H7a1 1 0 0 0-1 .85l-4 26A1 1 0 0 0 3 30h11.5v-2.5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1V30H29a1 1 0 0 0 1-1.15ZM17.5 22.5a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1Zm0-9a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1Z", "data-name": "Layer 4" })), CE = PE, zd = R(B()), SE = (e) => zd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, zd.createElement("path", { d: "m31.71 29.59-6.81-6.81a14 14 0 1 0-2.12 2.12l6.81 6.81a1 1 0 0 0 1.41 0l.71-.71a1 1 0 0 0 0-1.41zM3 14a11 11 0 1 1 11 11A11 11 0 0 1 3 14z" })), kE = SE, Md = R(B()), TE = (e) => Md.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Md.createElement("path", { d: "M27 16.91a8.31 8.31 0 0 0 0-1.82l3.31-2.72a1 1 0 0 0 .23-1.27l-3-5.2a1 1 0 0 0-1.22-.43l-4 1.5a10.78 10.78 0 0 0-1.58-.91L20 1.84A1 1 0 0 0 19 1h-6a1 1 0 0 0-1 .84l-.7 4.22A10.78 10.78 0 0 0 9.73 7l-4-1.5a1 1 0 0 0-1.22.43l-3 5.2a1 1 0 0 0 .23 1.27l3.31 2.72a8.31 8.31 0 0 0 0 1.82l-3.31 2.69a1 1 0 0 0-.23 1.27l3 5.2a1 1 0 0 0 .87.5.91.91 0 0 0 .35-.07l4-1.5a10.78 10.78 0 0 0 1.58.91l.7 4.22A1 1 0 0 0 13 31h6a1 1 0 0 0 1-.84l.7-4.22a10.78 10.78 0 0 0 1.57-.94l4 1.5a.91.91 0 0 0 .35.07 1 1 0 0 0 .87-.5l3-5.2a1 1 0 0 0-.23-1.27zM21 16a5 5 0 1 1-5-5 5 5 0 0 1 5 5z" })), AE = TE, _d = R(B()), OE = (e) => _d.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, _d.createElement("path", { d: "M25 19a5 5 0 0 0-3.73 1.7l-9.33-4.14A5.32 5.32 0 0 0 12 16a5.32 5.32 0 0 0-.06-.56l9.33-4.14A5 5 0 1 0 20 8a5.32 5.32 0 0 0 .06.56l-9.33 4.14a5 5 0 1 0 0 6.6l9.33 4.14A5.32 5.32 0 0 0 20 24a5 5 0 1 0 5-5Zm0-13a2 2 0 1 1-2 2 2 2 0 0 1 2-2ZM7 18a2 2 0 1 1 2-2 2 2 0 0 1-2 2Zm18 8a2 2 0 1 1 2-2 2 2 0 0 1-2 2Z", "data-name": "Layer 4" })), zE = OE, Ld = R(B()), ME = (e) => Ld.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Ld.createElement("path", { d: "M25 19a5 5 0 0 0-3.73 1.7l-9.33-4.14A5.32 5.32 0 0 0 12 16a5.32 5.32 0 0 0-.06-.56l9.33-4.14A5 5 0 1 0 20 8a5.32 5.32 0 0 0 .06.56l-9.33 4.14a5 5 0 1 0 0 6.6l9.33 4.14A5.32 5.32 0 0 0 20 24a5 5 0 1 0 5-5Z", "data-name": "Layer 4" })), _E = ME, Nl = R(B()), LE = (e) => Nl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Nl.createElement("path", { d: "M31.18 6.11c-.1 0-10.12-1.88-14.56-5.42a1 1 0 0 0-1.24 0C10.94 4.23.92 6.09.82 6.11a1 1 0 0 0-.82 1C0 19 5.1 27 15.61 31.45a1 1 0 0 0 .78 0C26.9 27 32 19 32 7.09a1 1 0 0 0-.82-.98zM3 8.71c3-.65 9-2.22 13-4.79 4 2.57 10.06 4.15 13 4.8-.25 6.42-2.26 14.69-13 19.62C10.43 25.81 3.59 21 3 8.71z" }), Nl.createElement("path", { d: "M26 10.06a47.09 47.09 0 0 1-9.54-3.55 1 1 0 0 0-.94 0A47.09 47.09 0 0 1 6 10.06a1 1 0 0 0-.74 1.1 18.06 18.06 0 0 0 10.28 14.73 1 1 0 0 0 .92 0 18.06 18.06 0 0 0 10.29-14.73 1 1 0 0 0-.75-1.1zm-10-.42a49.34 49.34 0 0 0 7.49 2.83A14.66 14.66 0 0 1 16 22.72a14.66 14.66 0 0 1-7.49-10.25A49.34 49.34 0 0 0 16 9.64z" })), IE = LE, Rl = R(B()), DE = (e) => Rl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Rl.createElement("path", { d: "M8.51 12.47A14.66 14.66 0 0 0 16 22.72a14.66 14.66 0 0 0 7.49-10.25A49.34 49.34 0 0 1 16 9.64a49.34 49.34 0 0 1-7.49 2.83z" }), Rl.createElement("path", { d: "M31.18 6.11c-.1 0-10.12-1.88-14.56-5.42a1 1 0 0 0-1.24 0C10.94 4.23.92 6.09.82 6.11a1 1 0 0 0-.82 1C0 19 5.1 27 15.61 31.45a1 1 0 0 0 .78 0C26.9 27 32 19 32 7.09a1 1 0 0 0-.82-.98zM16.46 25.89a1 1 0 0 1-.92 0A18.06 18.06 0 0 1 5.25 11.16a1 1 0 0 1 .75-1.1 47.09 47.09 0 0 0 9.54-3.55 1 1 0 0 1 .94 0A47.09 47.09 0 0 0 26 10.06a1 1 0 0 1 .74 1.1 18.06 18.06 0 0 1-10.28 14.73z" })), NE = DE, Bl = R(B()), RE = (e) => Bl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Bl.createElement("path", { d: "M31.18 6.11c-.1 0-10.12-1.87-14.56-5.42a1 1 0 0 0-1.24 0C10.94 4.24.92 6.09.82 6.11a1 1 0 0 0-.82 1C0 19 5.1 27 15.61 31.45a1 1 0 0 0 .78 0C26.9 27 32 19 32 7.09a1 1 0 0 0-.82-.98zM3 8.71c3-.65 9-2.22 13-4.79 4 2.57 10.06 4.15 13 4.8-.25 6.42-2.26 14.69-13 19.62C10.43 25.81 3.59 21 3 8.71z" }), Bl.createElement("path", { d: "M21 14.5h-3.5V11a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v3.5H11a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h3.5V21a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-3.5H21a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1z" })), BE = RE, Id = R(B()), VE = (e) => Id.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Id.createElement("path", { d: "M31.18 6.11c-.1 0-10.12-1.87-14.56-5.42a1 1 0 0 0-1.24 0C10.94 4.24.92 6.09.82 6.11a1 1 0 0 0-.82 1C0 19 5.1 27 15.61 31.45a1 1 0 0 0 .78 0C26.9 27 32 19 32 7.09a1 1 0 0 0-.82-.98zM22 16.5a1 1 0 0 1-1 1h-3.5V21a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-3.5H11a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h3.5V11a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v3.5H21a1 1 0 0 1 1 1z" })), FE = VE, Ra = R(B()), HE = (e) => Ra.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Ra.createElement("circle", { cx: 14, cy: 27, r: 3 }), Ra.createElement("circle", { cx: 24, cy: 27, r: 3 }), Ra.createElement("path", { d: "m28 16.24 2-8a1 1 0 0 0-.18-.86A1 1 0 0 0 29 7H9.78L9 3.88V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h3.22L10 20.12V21a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H12.78l-.5-2H27a1 1 0 0 0 1-.76zM10.56 10h15.88l-1 4H11.56z" })), KE = HE, Ba = R(B()), jE = (e) => Ba.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Ba.createElement("circle", { cx: 14, cy: 27, r: 3 }), Ba.createElement("circle", { cx: 24, cy: 27, r: 3 }), Ba.createElement("path", { d: "m28 16.24 2-8a1 1 0 0 0-.18-.86A1 1 0 0 0 29 7H9.78L9 3.88V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h3.22L10 20.12V21a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H12.78l-.5-2H27a1 1 0 0 0 1-.76z" })), UE = jE, Vl = R(B()), WE = (e) => Vl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Vl.createElement("path", { d: "M29 2H9a1 1 0 0 0-1 1v7.5a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V5h16v22H11v-5.5a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1V29a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1z" }), Vl.createElement("path", { d: "M14.58 20.59a1 1 0 0 0 0 1.42l.71.7a1 1 0 0 0 1.41 0l5.3-5.3.71-.7a1 1 0 0 0 0-1.42l-6-6A1 1 0 0 0 16 9a1 1 0 0 0-.71.29l-.7.71a1 1 0 0 0 0 1.41l3.08 3.09H3a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h14.67z" })), qE = WE, Fl = R(B()), ZE = (e) => Fl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Fl.createElement("path", { d: "M29 2H15a1 1 0 0 0-1 1v7.5a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V5h10v22H17v-5.5a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1V29a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1Z" }), Fl.createElement("path", { d: "M22 14.5H7.33l3.09-3.09a1 1 0 0 0 0-1.41l-.71-.71a1 1 0 0 0-1.42 0L3 14.58l-.71.71a1 1 0 0 0 0 1.41l.71.71 5.3 5.3a1 1 0 0 0 1.41 0l.71-.71a1 1 0 0 0 0-1.41L7.33 17.5H22a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1Z" })), GE = ZE, Dd = R(B()), YE = (e) => Dd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Dd.createElement("path", { d: "M24 2H8a1 1 0 0 0-1 1v27a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-8 27a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 16 29zm7-5H9V4h14z" })), XE = YE, Hl = R(B()), JE = (e) => Hl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Hl.createElement("g", { "data-name": "Layer 4" }, Hl.createElement("path", { d: "M28.1 21.55a1.74 1.74 0 0 0-.86-.91l-.19-.1-.33-.17a7.15 7.15 0 0 1-2.66-2.28 4.59 4.59 0 0 1-.46-.81.37.37 0 0 1 0-.31.54.54 0 0 1 .15-.15l.53-.35.57-.38a3 3 0 0 0 1-1.07 2.12 2.12 0 0 0 .15-1.76 2.1 2.1 0 0 0-2-1.33 2.86 2.86 0 0 0-.58.06h-.16a17.09 17.09 0 0 0-.05-1.74A6.49 6.49 0 0 0 19.82 5 7.57 7.57 0 0 0 16 4a7.6 7.6 0 0 0-3.82 1 6.52 6.52 0 0 0-1.67 1.34 6.4 6.4 0 0 0-1.64 4 16.82 16.82 0 0 0 0 1.73h-.15a3 3 0 0 0-.59-.06 2.1 2.1 0 0 0-2 1.33A2.15 2.15 0 0 0 6.16 15a3 3 0 0 0 1 1.07l.57.37.51.34a.65.65 0 0 1 .17.16.39.39 0 0 1 0 .33 5.67 5.67 0 0 1-.45.8 7.3 7.3 0 0 1-2.58 2.24c-.59.31-1.2.52-1.46 1.22a1.54 1.54 0 0 0 .43 1.63 2.64 2.64 0 0 0 .62.48 6.79 6.79 0 0 0 1.53.61.81.81 0 0 1 .3.13c.18.16.16.4.4.75a1.75 1.75 0 0 0 .45.45A3 3 0 0 0 9.3 26a6.31 6.31 0 0 1 1.85.27 4.84 4.84 0 0 1 .94.5 6.87 6.87 0 0 0 7.83 0 5.67 5.67 0 0 1 .93-.49A6.31 6.31 0 0 1 22.7 26a3 3 0 0 0 1.67-.39 1.7 1.7 0 0 0 .51-.56c.18-.3.17-.5.33-.65a1.08 1.08 0 0 1 .29-.13 6.67 6.67 0 0 0 1.55-.61 2.66 2.66 0 0 0 .65-.51 1.54 1.54 0 0 0 .4-1.6Z", "data-name": "PRIMARY - GHOST" }))), QE = JE, Kl = R(B()), e$ = (e) => Kl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Kl.createElement("path", { d: "M29 30H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h26a1 1 0 0 1 1 1v26a1 1 0 0 1-1 1Z" }), Kl.createElement("path", { d: "M25.93 20.56a1.41 1.41 0 0 0-.71-.75l-.15-.08-.27-.14a6.06 6.06 0 0 1-2.19-1.87 4 4 0 0 1-.37-.67.31.31 0 0 1 0-.25.37.37 0 0 1 .12-.13l.44-.29.46-.3a2.53 2.53 0 0 0 .83-.88 1.73 1.73 0 0 0-1.58-2.54 2.61 2.61 0 0 0-.48.05h-.12v-1.42a5.17 5.17 0 0 0-1.41-3.24A5.35 5.35 0 0 0 19.14 7a6.54 6.54 0 0 0-6.27 0 5.07 5.07 0 0 0-1.37 1.06 5.17 5.17 0 0 0-1.35 3.26 13.62 13.62 0 0 0 0 1.42h-.13a2.61 2.61 0 0 0-.48-.05 1.73 1.73 0 0 0-1.62 2.51 2.53 2.53 0 0 0 .83.88l.46.31.42.27a.47.47 0 0 1 .14.14.33.33 0 0 1 0 .27 3.72 3.72 0 0 1-.36.65 5.91 5.91 0 0 1-2.12 1.84c-.49.26-1 .43-1.2 1a1.28 1.28 0 0 0 .35 1.35 2.12 2.12 0 0 0 .51.38 5.35 5.35 0 0 0 1.25.5.88.88 0 0 1 .26.12c.14.12.12.32.32.6a1.34 1.34 0 0 0 .37.38 2.4 2.4 0 0 0 1.37.32 5.35 5.35 0 0 1 1.52.23 3.9 3.9 0 0 1 .77.41 5.64 5.64 0 0 0 6.43 0 4.35 4.35 0 0 1 .76-.4 5.3 5.3 0 0 1 1.52-.23 2.32 2.32 0 0 0 1.37-.32 1.33 1.33 0 0 0 .42-.46c.14-.24.14-.41.27-.52a.86.86 0 0 1 .24-.11 5.82 5.82 0 0 0 1.27-.51 2 2 0 0 0 .53-.42 1.26 1.26 0 0 0 .31-1.32Zm-1.4.75c-.86.47-1.43.42-1.87.71s-.15.76-.42.95-1.33 0-2.61.4c-1.06.35-1.73 1.36-3.63 1.36s-2.56-1-3.63-1.36c-1.28-.42-2.27-.17-2.6-.4s-.06-.71-.43-1-1-.23-1.87-.7c-.54-.3-.23-.49 0-.57 3.1-1.5 3.59-3.82 3.61-4a.53.53 0 0 0-.17-.58c-.22-.21-1.2-.81-1.47-1-.46-.32-.65-.63-.51-1a.6.6 0 0 1 .62-.37 1 1 0 0 1 .24 0c.5.11 1 .36 1.25.42h.11c.14 0 .2-.08.19-.25a17.44 17.44 0 0 1 0-2.58 4.08 4.08 0 0 1 1-2.54A4.77 4.77 0 0 1 16 7.27a4.81 4.81 0 0 1 3.66 1.52 4.13 4.13 0 0 1 1.08 2.62 17.61 17.61 0 0 1 0 2.59c0 .17 0 .24.19.24H21c.27-.07.75-.32 1.25-.43h.24a.62.62 0 0 1 .62.36c.14.39-.05.7-.51 1-.27.19-1.25.8-1.47 1a.54.54 0 0 0-.17.58c0 .18.51 2.49 3.61 4 .19.07.5.25-.04.56Z", "data-name": "PRIMARY - GHOST" })), t$ = e$, jl = R(B()), n$ = (e) => jl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, jl.createElement("g", { "data-name": "Layer 4" }, jl.createElement("path", { d: "M28.1 21.55a1.74 1.74 0 0 0-.86-.91l-.19-.1-.33-.17a7.15 7.15 0 0 1-2.66-2.28 4.59 4.59 0 0 1-.46-.81.37.37 0 0 1 0-.31.54.54 0 0 1 .15-.15l.53-.35.57-.38a3 3 0 0 0 1-1.07 2.12 2.12 0 0 0 .15-1.76 2.1 2.1 0 0 0-2-1.33 2.86 2.86 0 0 0-.58.06h-.16a17.09 17.09 0 0 0-.05-1.74A6.49 6.49 0 0 0 19.82 5 7.57 7.57 0 0 0 16 4a7.6 7.6 0 0 0-3.82 1 6.52 6.52 0 0 0-1.67 1.34 6.4 6.4 0 0 0-1.64 4 16.82 16.82 0 0 0 0 1.73h-.15a3 3 0 0 0-.59-.06 2.1 2.1 0 0 0-2 1.33A2.15 2.15 0 0 0 6.16 15a3 3 0 0 0 1 1.07l.57.37.51.34a.65.65 0 0 1 .17.16.39.39 0 0 1 0 .33 5.67 5.67 0 0 1-.45.8 7.3 7.3 0 0 1-2.58 2.24c-.59.31-1.2.52-1.46 1.22a1.54 1.54 0 0 0 .43 1.63 2.64 2.64 0 0 0 .62.48 6.79 6.79 0 0 0 1.53.61.81.81 0 0 1 .3.13c.18.16.16.4.4.75a1.75 1.75 0 0 0 .45.45A3 3 0 0 0 9.3 26a6.31 6.31 0 0 1 1.85.27 4.84 4.84 0 0 1 .94.5 6.87 6.87 0 0 0 7.83 0 5.67 5.67 0 0 1 .93-.49A6.31 6.31 0 0 1 22.7 26a3 3 0 0 0 1.67-.39 1.7 1.7 0 0 0 .51-.56c.18-.3.17-.5.33-.65a1.08 1.08 0 0 1 .29-.13 6.67 6.67 0 0 0 1.55-.61 2.66 2.66 0 0 0 .65-.51 1.54 1.54 0 0 0 .4-1.6Zm-1.71.92c-1 .58-1.73.51-2.27.86s-.19.93-.52 1.16-1.62 0-3.18.49c-1.28.43-2.1 1.65-4.42 1.65s-3.11-1.22-4.42-1.63c-1.56-.51-2.77-.21-3.18-.49s-.06-.87-.51-1.16-1.24-.35-2.28-.88c-.66-.37-.28-.59-.06-.7 3.77-1.83 4.37-4.65 4.4-4.86a.67.67 0 0 0-.21-.71c-.27-.24-1.47-1-1.8-1.22-.55-.38-.79-.76-.61-1.23a.73.73 0 0 1 .75-.45 1.36 1.36 0 0 1 .29 0c.61.13 1.19.43 1.53.52h.1c.19 0 .25-.09.24-.29a21 21 0 0 1 0-3.15 5 5 0 0 1 1.31-3.2A5.86 5.86 0 0 1 16 5.37a5.82 5.82 0 0 1 4.46 1.85 4.92 4.92 0 0 1 1.31 3.19 22.44 22.44 0 0 1 0 3.15c0 .22.05.3.23.3h.13c.34-.08.92-.38 1.52-.52h.3a.75.75 0 0 1 .75.45c.18.47-.06.85-.61 1.24-.33.23-1.53 1-1.8 1.22a.66.66 0 0 0-.21.71c0 .21.63 3 4.4 4.85.2.07.57.29-.09.66Z", "data-name": "PRIMARY - GHOST" }))), r$ = n$, Nd = R(B()), a$ = (e) => Nd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Nd.createElement("path", { d: "M31 14.5a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1 4.49 4.49 0 0 0-4.22 3h-.28V11a1.49 1.49 0 0 0-.77-1.31l-3.3-1.83.25-.43a4.45 4.45 0 0 0 .81.08 4.64 4.64 0 0 0 1.17-.15 4.46 4.46 0 0 0 2.72-2.08A1 1 0 0 0 27 3.89l-.86-.5a1 1 0 0 0-1.37.37 1.49 1.49 0 0 1-.91.7 1.51 1.51 0 0 1-1.14-.15 1.49 1.49 0 0 1-.7-.91 1.51 1.51 0 0 1 .15-1.14 1 1 0 0 0 .13-.5 1 1 0 0 0-.5-.87l-.8-.5a1 1 0 0 0-1.4.37 4.45 4.45 0 0 0-.45 3.4 4.5 4.5 0 0 0 .94 1.75l-.28.48-3.08-1.7a1.51 1.51 0 0 0-1.46 0L12.19 6.4l-.28-.48a4.5 4.5 0 0 0 .94-1.75 4.45 4.45 0 0 0-.45-3.4A1 1 0 0 0 11 .39l-.86.5a1 1 0 0 0-.5.87 1 1 0 0 0 .13.5A1.51 1.51 0 0 1 10 3.4a1.49 1.49 0 0 1-.7.91 1.51 1.51 0 0 1-1.14.15 1.49 1.49 0 0 1-.91-.7 1 1 0 0 0-1.37-.37l-.88.5a1 1 0 0 0-.4 1.37 4.46 4.46 0 0 0 2.74 2.1 4.64 4.64 0 0 0 1.17.15 4.45 4.45 0 0 0 .81-.08l.25.43-3.3 1.83A1.49 1.49 0 0 0 5.5 11v3.5h-.28a4.49 4.49 0 0 0-4.22-3 1 1 0 0 0-1 1v1a1 1 0 0 0 1 1 1.5 1.5 0 0 1 0 3 1 1 0 0 0-1 1v1a1 1 0 0 0 1 1 4.49 4.49 0 0 0 4.22-3h.28V21a1.49 1.49 0 0 0 .77 1.31l3.3 1.83-.26.44a4.43 4.43 0 0 0-4.7 2.15A1 1 0 0 0 5 28.11l.86.5a1 1 0 0 0 .5.13 1 1 0 0 0 .87-.5 1.49 1.49 0 0 1 .91-.7 1.51 1.51 0 0 1 1.14.15 1.49 1.49 0 0 1 .7.91 1.51 1.51 0 0 1-.15 1.14 1 1 0 0 0-.13.5 1 1 0 0 0 .5.87l.86.5a1 1 0 0 0 1.37-.37 4.45 4.45 0 0 0 .45-3.4 4.5 4.5 0 0 0-.94-1.75l.28-.48 3.08 1.71a1.5 1.5 0 0 0 1.46 0l3.08-1.71.28.48a4.5 4.5 0 0 0-.94 1.75 4.45 4.45 0 0 0 .45 3.4 1 1 0 0 0 1.37.37l.86-.5a1 1 0 0 0 .5-.87 1 1 0 0 0-.13-.5 1.51 1.51 0 0 1-.15-1.14 1.49 1.49 0 0 1 .7-.91 1.51 1.51 0 0 1 1.14-.15 1.49 1.49 0 0 1 .91.7 1 1 0 0 0 .87.5 1 1 0 0 0 .5-.13l.86-.5a1 1 0 0 0 .37-1.37 4.43 4.43 0 0 0-4.7-2.15l-.26-.44 3.3-1.83A1.49 1.49 0 0 0 26.5 21v-3.5h.28a4.49 4.49 0 0 0 4.22 3 1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1 1.5 1.5 0 0 1 0-3zm-7.5-2.62v2.62h-4.9l2.33-4zM16 7.72 18.31 9 16 13l-2.31-4zm-7.5 4.16 2.57-1.42 2.33 4H8.5zm0 8.24V17.5h4.9l-2.33 4zm7.5 4.16L13.69 23 16 19l2.31 4zm7.5-4.16-2.57 1.42-2.33-4h4.9z" })), i$ = a$, Ul = R(B()), o$ = (e) => Ul.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Ul.createElement("path", { d: "M11.65 16.55H8.71v3.39h2.89a3.11 3.11 0 0 0 .76-.08 1.66 1.66 0 0 0 .64-.26 1.31 1.31 0 0 0 .44-.49 1.67 1.67 0 0 0 .16-.8 1.6 1.6 0 0 0-.53-1.31 2.3 2.3 0 0 0-1.42-.45zm.99-2.19a1.3 1.3 0 0 0 .46-1.12 1.49 1.49 0 0 0-.15-.71 1.1 1.1 0 0 0-.41-.42 1.66 1.66 0 0 0-.6-.22 4 4 0 0 0-.7-.06H8.71v2.87h2.74a2 2 0 0 0 1.19-.34zm8.95.36a2.12 2.12 0 0 0-1 .2 2 2 0 0 0-.62.49 1.74 1.74 0 0 0-.33.63 3 3 0 0 0-.11.59h4a2.32 2.32 0 0 0-.53-1.41 1.83 1.83 0 0 0-1.41-.5z" }), Ul.createElement("path", { d: "M29 2H3a1 1 0 0 0-1 1v26a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-9.94 8.56h5v1.21h-5zm-3.12 9.52a3.25 3.25 0 0 1-1 1.11 4.37 4.37 0 0 1-1.4.64A6.18 6.18 0 0 1 12 22H6V9.73h5.8a7.17 7.17 0 0 1 1.6.16 3.36 3.36 0 0 1 1.25.51 2.3 2.3 0 0 1 .8.94 3.24 3.24 0 0 1 .28 1.44 2.7 2.7 0 0 1-.42 1.55 3 3 0 0 1-1.26 1 2.92 2.92 0 0 1 1.69 1.15 3.36 3.36 0 0 1 .56 2 3.43 3.43 0 0 1-.36 1.6zm4.22-.18a2.47 2.47 0 0 0 2.86.16 1.55 1.55 0 0 0 .66-.79h2.15a4.07 4.07 0 0 1-1.59 2.3 4.57 4.57 0 0 1-2.58.7 5.22 5.22 0 0 1-1.9-.34 4.23 4.23 0 0 1-1.44-1 4.42 4.42 0 0 1-.9-1.48 5.53 5.53 0 0 1-.32-1.9 5.22 5.22 0 0 1 .33-1.87 4.27 4.27 0 0 1 2.38-2.48 4.59 4.59 0 0 1 1.85-.36 4.13 4.13 0 0 1 2 .44A3.8 3.8 0 0 1 25 14.5a4.85 4.85 0 0 1 .78 1.69 6.18 6.18 0 0 1 .17 2h-6.39a2.48 2.48 0 0 0 .6 1.71z" })), l$ = o$, Rd = R(B()), s$ = (e) => Rd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Rd.createElement("path", { d: "M13.28 15.08A4.21 4.21 0 0 0 15 13.66a3.72 3.72 0 0 0 .59-2.17 4.66 4.66 0 0 0-.39-2 3.26 3.26 0 0 0-1.12-1.31 4.87 4.87 0 0 0-1.74-.71 10.47 10.47 0 0 0-2.25-.22H2v17.2h8.35a8.9 8.9 0 0 0 2.25-.29 6 6 0 0 0 2-.89 4.47 4.47 0 0 0 1.36-1.56 4.86 4.86 0 0 0 .5-2.26 4.7 4.7 0 0 0-.78-2.76 4.09 4.09 0 0 0-2.4-1.61zm-7.49-4.92h3.55a4.38 4.38 0 0 1 1 .09 2.21 2.21 0 0 1 .84.3 1.52 1.52 0 0 1 .58.6 1.94 1.94 0 0 1 .22 1 1.82 1.82 0 0 1-.65 1.56 2.71 2.71 0 0 1-1.67.49H5.79zm6.62 10.2a1.75 1.75 0 0 1-.61.68 2.59 2.59 0 0 1-.9.37 5.14 5.14 0 0 1-1.06.11h-4v-4.75h4.07a3.19 3.19 0 0 1 2 .57 2.23 2.23 0 0 1 .75 1.9 2.33 2.33 0 0 1-.25 1.12zm13.42 1.33a3 3 0 0 1-1.79.52 3 3 0 0 1-2.21-.75A3.46 3.46 0 0 1 21 19h9a9.13 9.13 0 0 0-.24-2.78 6.83 6.83 0 0 0-1.1-2.36 5.39 5.39 0 0 0-1.94-1.66 6 6 0 0 0-2.77-.61 6.59 6.59 0 0 0-2.6.5A6.07 6.07 0 0 0 18 15.61a7.46 7.46 0 0 0-.46 2.61 7.54 7.54 0 0 0 .46 2.66A6.13 6.13 0 0 0 19.25 23a5.67 5.67 0 0 0 2 1.34 7.24 7.24 0 0 0 2.66.47 6.45 6.45 0 0 0 3.61-1 5.67 5.67 0 0 0 2.22-3.22h-3a2.21 2.21 0 0 1-.91 1.1zm-4.69-5.63a2.26 2.26 0 0 1 .46-.88 2.84 2.84 0 0 1 .86-.69 3.06 3.06 0 0 1 1.37-.28 2.54 2.54 0 0 1 1.93.7 3.31 3.31 0 0 1 .79 2H21a4.06 4.06 0 0 1 .14-.85zm-.86-7.68h6.98v1.7h-6.98z" })), c$ = s$, Bd = R(B()), u$ = (e) => Bd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Bd.createElement("path", { d: "M20.31 6.32h2.43V2.18A34.52 34.52 0 0 0 19.18 2c-3.53 0-5.95 2.15-5.95 6.11v3.41h-4v4.64h4V28H18V16.16h4l.6-4.64H18V8.57c0-1.34.39-2.25 2.31-2.25z" })), d$ = u$, Vd = R(B()), f$ = (e) => Vd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Vd.createElement("path", { d: "M29 2H3a1 1 0 0 0-1 1v26a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-7.55 7h-2c-1.55 0-1.85.73-1.85 1.82v2.38h3.71l-.48 3.74h-3.2v9.56h-3.86v-9.57h-3.22v-3.74h3.22v-2.76c0-3.19 2-4.93 4.8-4.93a25.06 25.06 0 0 1 2.88.15z" })), p$ = f$, Fd = R(B()), h$ = (e) => Fd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Fd.createElement("path", { d: "M27.57 3H4.43A1.43 1.43 0 0 0 3 4.43v23.14A1.43 1.43 0 0 0 4.43 29h12.46V19h-3.38v-4h3.38v-2.9c0-3.35 2.05-5.18 5.05-5.18a27.54 27.54 0 0 1 3 .15v3.51H22.9c-1.63 0-1.95.78-1.95 1.91V15h3.9l-.51 4H21v10h6.62A1.43 1.43 0 0 0 29 27.57V4.43A1.43 1.43 0 0 0 27.57 3z" })), v$ = h$, Wl = R(B()), m$ = (e) => Wl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Wl.createElement("circle", { cx: 16, cy: 16, r: 4.67 }), Wl.createElement("path", { d: "M29.92 10.23a10.5 10.5 0 0 0-.65-3.4 7.21 7.21 0 0 0-4.1-4.1 10.5 10.5 0 0 0-3.4-.65C20.28 2 19.8 2 16 2s-4.28 0-5.77.08a10.5 10.5 0 0 0-3.4.65 7.21 7.21 0 0 0-4.1 4.1 10.5 10.5 0 0 0-.65 3.4C2 11.72 2 12.2 2 16s0 4.28.08 5.77a10.5 10.5 0 0 0 .65 3.4 7.21 7.21 0 0 0 4.1 4.1 10.5 10.5 0 0 0 3.4.65c1.49.06 2 .08 5.77.08s4.28 0 5.77-.08a10.5 10.5 0 0 0 3.4-.65 7.21 7.21 0 0 0 4.1-4.1 10.5 10.5 0 0 0 .65-3.4C30 20.28 30 19.8 30 16s0-4.28-.08-5.77zM16 23.19A7.19 7.19 0 1 1 23.19 16 7.19 7.19 0 0 1 16 23.19zm7.47-13a1.68 1.68 0 1 1 1.68-1.68 1.69 1.69 0 0 1-1.68 1.7z" })), g$ = m$, Va = R(B()), y$ = (e) => Va.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Va.createElement("path", { d: "M29 2H3a1 1 0 0 0-1 1v26a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-3.06 18.12a7.59 7.59 0 0 1-.46 2.43 4.85 4.85 0 0 1-1.16 1.77 4.7 4.7 0 0 1-1.77 1.15 7.3 7.3 0 0 1-2.43.47c-1.06 0-1.4.06-4.12.06s-3.06 0-4.12-.06a7.3 7.3 0 0 1-2.43-.47 4.7 4.7 0 0 1-1.77-1.15 4.85 4.85 0 0 1-1.16-1.77 7.59 7.59 0 0 1-.46-2.43C6 19.06 6 18.72 6 16s0-3.06.06-4.12a7.59 7.59 0 0 1 .46-2.43 5.19 5.19 0 0 1 2.93-2.93 7.59 7.59 0 0 1 2.43-.46C12.94 6 13.28 6 16 6s3.06 0 4.12.06a7.59 7.59 0 0 1 2.43.46 5.19 5.19 0 0 1 2.93 2.93 7.59 7.59 0 0 1 .46 2.43c0 1.06.06 1.4.06 4.12s0 3.06-.06 4.12z" }), Va.createElement("path", { d: "M16 12.67A3.33 3.33 0 1 0 19.33 16 3.33 3.33 0 0 0 16 12.67z" }), Va.createElement("path", { d: "M23.8 10.1a3.33 3.33 0 0 0-1.9-1.9 5.61 5.61 0 0 0-1.9-.34c-1-.05-1.33-.06-4-.06s-3 0-4 .06a5.61 5.61 0 0 0-1.86.34 3.33 3.33 0 0 0-1.9 1.9 5.61 5.61 0 0 0-.38 1.9c-.05 1-.06 1.37-.06 4s0 3 .06 4a5.61 5.61 0 0 0 .34 1.9 3.33 3.33 0 0 0 1.9 1.9 5.61 5.61 0 0 0 1.86.34c1 .05 1.37.06 4 .06s3 0 4-.06a5.61 5.61 0 0 0 1.86-.34 3.33 3.33 0 0 0 1.9-1.9 5.61 5.61 0 0 0 .42-1.9c.05-1.05.06-1.37.06-4s0-3-.06-4a5.61 5.61 0 0 0-.34-1.9zm-7.8 11a5.14 5.14 0 1 1 5.14-5.1A5.14 5.14 0 0 1 16 21.14zm5.34-9.28a1.2 1.2 0 1 1 1.2-1.2 1.2 1.2 0 0 1-1.2 1.24z" })), b$ = y$, ql = R(B()), w$ = (e) => ql.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, ql.createElement("path", { d: "M29.92 10.23a10.5 10.5 0 0 0-.65-3.4 7.21 7.21 0 0 0-4.1-4.1 10.5 10.5 0 0 0-3.4-.65C20.28 2 19.8 2 16 2s-4.28 0-5.77.08a10.5 10.5 0 0 0-3.4.65 7.21 7.21 0 0 0-4.1 4.1 10.5 10.5 0 0 0-.65 3.4C2 11.72 2 12.2 2 16s0 4.28.08 5.77a10.5 10.5 0 0 0 .65 3.4 7.21 7.21 0 0 0 4.1 4.1 10.5 10.5 0 0 0 3.4.65c1.49.06 2 .08 5.77.08s4.28 0 5.77-.08a10.5 10.5 0 0 0 3.4-.65 7.21 7.21 0 0 0 4.1-4.1 10.5 10.5 0 0 0 .65-3.4C30 20.28 30 19.8 30 16s0-4.28-.08-5.77zM27.4 21.66a7.75 7.75 0 0 1-.49 2.6 4.56 4.56 0 0 1-2.65 2.65 7.75 7.75 0 0 1-2.6.49c-1.48.06-1.92.08-5.66.08s-4.18 0-5.66-.08a7.75 7.75 0 0 1-2.6-.49 4.56 4.56 0 0 1-2.65-2.65 7.75 7.75 0 0 1-.49-2.6c-.06-1.48-.08-1.92-.08-5.66s0-4.18.08-5.66a7.75 7.75 0 0 1 .49-2.6 4.56 4.56 0 0 1 2.65-2.65 7.75 7.75 0 0 1 2.6-.49c1.48-.06 1.92-.08 5.66-.08s4.18 0 5.66.08a7.75 7.75 0 0 1 2.6.49 4.56 4.56 0 0 1 2.65 2.65 7.75 7.75 0 0 1 .49 2.6c.06 1.48.08 1.92.08 5.66s-.02 4.18-.08 5.66z" }), ql.createElement("path", { d: "M16 8.81A7.19 7.19 0 1 0 23.19 16 7.19 7.19 0 0 0 16 8.81zm0 11.86A4.67 4.67 0 1 1 20.67 16 4.67 4.67 0 0 1 16 20.67zm7.47-13.82a1.68 1.68 0 1 0 1.68 1.68 1.68 1.68 0 0 0-1.68-1.68z" })), x$ = w$, Hd = R(B()), E$ = (e) => Hd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Hd.createElement("path", { d: "M27 26v-8c0-4-.85-7-5.47-7a4.77 4.77 0 0 0-4.31 2.37h-.06v-2h-4.37V26h4.55v-7.28c0-1.91.36-3.76 2.73-3.76s2.37 2.19 2.37 3.89V26zM7.64 4a2.65 2.65 0 1 0 2.65 2.64A2.64 2.64 0 0 0 7.64 4zm-2.28 7.31h4.56v14.67H5.36z" })), $$ = E$, Kd = R(B()), P$ = (e) => Kd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Kd.createElement("path", { d: "M29 2H3a1 1 0 0 0-1 1v26a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zM11.31 24.48H7.78V13.15h3.53zM9.54 11.6a2 2 0 1 1 2.05-2 2 2 0 0 1-2.05 2zm15 12.88H21V19c0-1.31 0-3-1.83-3S17 17.4 17 18.88v5.6h-3.48V13.15h3.37v1.55h.05a3.7 3.7 0 0 1 3.33-1.83c3.57 0 4.23 2.35 4.23 5.4z" })), C$ = P$, jd = R(B()), S$ = (e) => jd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, jd.createElement("path", { d: "M27.08 3H4.92A1.9 1.9 0 0 0 3 4.87v22.25A1.9 1.9 0 0 0 4.92 29h22.16A1.9 1.9 0 0 0 29 27.12V4.87A1.9 1.9 0 0 0 27.08 3zM10.71 25.15H6.85v-12.4h3.86zm-1.93-14.1A2.24 2.24 0 1 1 11 8.82a2.23 2.23 0 0 1-2.22 2.23zm16.38 14.1H21.3v-6c0-1.44 0-3.29-2-3.29S17 17.4 17 19v6.13h-3.87V12.75h3.7v1.69h.05a4.06 4.06 0 0 1 3.65-2c3.9 0 4.63 2.57 4.63 5.91z" })), k$ = S$, Ud = R(B()), T$ = (e) => Ud.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Ud.createElement("path", { d: "M11.61 27.56a15.72 15.72 0 0 0 1.84-3.9c.19-.69.93-3.53.93-3.53a4 4 0 0 0 3.41 1.71c4.47 0 7.71-4.12 7.71-9.25 0-4.92-4-8.59-9.17-8.59C9.91 4 6.5 8.31 6.5 13c0 2.19 1.17 4.9 3 5.77.28.13.44.07.5-.2s.3-1.22.41-1.69a.44.44 0 0 0-.09-.43 5.78 5.78 0 0 1-1.1-3.39A6.43 6.43 0 0 1 16 6.61a5.87 5.87 0 0 1 6.22 6c0 4-2 6.8-4.67 6.8a2.17 2.17 0 0 1-2.21-2.69c.43-1.77 1.24-3.68 1.24-5a1.87 1.87 0 0 0-1.89-2.1c-1.49 0-2.69 1.55-2.69 3.61a5.48 5.48 0 0 0 .44 2.21s-1.47 6.22-1.73 7.39a14.64 14.64 0 0 0-.05 4.27c.08.84.43 1.28.95.46z" })), A$ = T$, Wd = R(B()), O$ = (e) => Wd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Wd.createElement("path", { d: "M29 2H3a1 1 0 0 0-1 1v26a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zM17.44 20.72a3.18 3.18 0 0 1-2.74-1.39l-.76 2.86a13.38 13.38 0 0 1-1.48 3.15c-.43.66-.71.3-.81-.3a11.8 11.8 0 0 1 0-3.45l1.4-6a4.43 4.43 0 0 1-.35-1.78c0-1.67 1-2.92 2.17-2.92a1.51 1.51 0 0 1 1.52 1.69 24.39 24.39 0 0 1-1 4 1.74 1.74 0 0 0 1.78 2.17c2.13 0 3.77-2.25 3.77-5.49a4.74 4.74 0 0 0-5-4.89 5.2 5.2 0 0 0-5.43 5.21 4.71 4.71 0 0 0 .89 2.74.35.35 0 0 1 .08.34l-.33 1.37c0 .22-.18.27-.41.16-1.5-.71-2.44-2.89-2.44-4.66 0-3.78 2.75-7.26 7.94-7.26 4.16 0 7.4 3 7.4 6.94.03 4.18-2.58 7.51-6.2 7.51z" })), z$ = O$, qd = R(B()), M$ = (e) => qd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, qd.createElement("path", { d: "M16 1a15 15 0 0 0-5.47 29 14.19 14.19 0 0 1 .05-4.31c.27-1.18 1.75-7.47 1.75-7.47A5.5 5.5 0 0 1 11.9 16c0-2.09 1.21-3.65 2.72-3.65a1.89 1.89 0 0 1 1.9 2.12c0 1.28-.82 3.21-1.25 5a2.18 2.18 0 0 0 2.23 2.72c2.66 0 4.71-2.82 4.71-6.87a5.92 5.92 0 0 0-6.27-6.1 6.5 6.5 0 0 0-6.79 6.51 5.84 5.84 0 0 0 1.12 3.42.47.47 0 0 1 .1.43c-.12.47-.37 1.5-.42 1.71s-.23.33-.51.2c-1.88-.88-3-3.61-3-5.82 0-4.74 3.43-9.09 9.92-9.09 5.2 0 9.25 3.71 9.25 8.68 0 5.18-3.26 9.34-7.78 9.34a4 4 0 0 1-3.44-1.73l-.93 3.57a16.49 16.49 0 0 1-1.87 3.94 15.16 15.16 0 0 0 4.45.67A15 15 0 0 0 16 1z" })), _$ = M$, Zd = R(B()), L$ = (e) => Zd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Zd.createElement("path", { d: "M29 2H3a1 1 0 0 0-1 1v26a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-4.25 9.51v.59A12.83 12.83 0 0 1 5 22.91a9.51 9.51 0 0 0 1.08.09 9 9 0 0 0 5.6-2 4.5 4.5 0 0 1-4.21-3.13 4.48 4.48 0 0 0 2-.08 4.52 4.52 0 0 1-3.62-4.42v-.06a4.45 4.45 0 0 0 2.05.56 4.51 4.51 0 0 1-2-3.75 4.45 4.45 0 0 1 .61-2.27 12.82 12.82 0 0 0 9.3 4.71 4.93 4.93 0 0 1-.11-1 4.51 4.51 0 0 1 7.81-3.08 9.18 9.18 0 0 0 2.86-1.1 4.52 4.52 0 0 1-2 2.5 9 9 0 0 0 2.63-.7 9.06 9.06 0 0 1-2.25 2.33z" })), I$ = L$, Gd = R(B()), D$ = (e) => Gd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Gd.createElement("path", { d: "M30 7.32a11.76 11.76 0 0 1-3.3.9A5.76 5.76 0 0 0 29.23 5a11.53 11.53 0 0 1-3.65 1.4 5.74 5.74 0 0 0-9.94 3.93 5.66 5.66 0 0 0 .15 1.31A16.3 16.3 0 0 1 4 5.67a5.74 5.74 0 0 0 1.78 7.67 5.56 5.56 0 0 1-2.6-.72.22.22 0 0 0 0 .08 5.75 5.75 0 0 0 4.61 5.63 5.79 5.79 0 0 1-1.51.2 5.49 5.49 0 0 1-1.08-.1 5.76 5.76 0 0 0 5.37 4 11.56 11.56 0 0 1-7.14 2.46A12.44 12.44 0 0 1 2 24.8a16.25 16.25 0 0 0 8.81 2.58c10.56 0 16.34-8.76 16.34-16.35v-.74A11.58 11.58 0 0 0 30 7.32z" })), N$ = D$, Zl = R(B()), R$ = (e) => Zl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Zl.createElement("path", { d: "M29 2H3a1 1 0 0 0-1 1v26a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm-3.42 18.81a2.51 2.51 0 0 1-1.77 1.77C22.25 23 16 23 16 23s-6.25 0-7.81-.42a2.51 2.51 0 0 1-1.77-1.77A25.87 25.87 0 0 1 6 16a25.87 25.87 0 0 1 .42-4.81 2.51 2.51 0 0 1 1.77-1.77C9.75 9 16 9 16 9s6.25 0 7.81.42a2.51 2.51 0 0 1 1.77 1.77A25.87 25.87 0 0 1 26 16a25.87 25.87 0 0 1-.42 4.81z" }), Zl.createElement("path", { d: "m14 19 5.2-3-5.2-3v6z" })), B$ = R$, Yd = R(B()), V$ = (e) => Yd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Yd.createElement("path", { d: "M30.37 8.78a3.74 3.74 0 0 0-2.65-2.65C25.38 5.5 16 5.5 16 5.5s-9.38 0-11.72.63a3.74 3.74 0 0 0-2.65 2.65A38.85 38.85 0 0 0 1 16a38.85 38.85 0 0 0 .63 7.22 3.74 3.74 0 0 0 2.65 2.65c2.34.63 11.72.63 11.72.63s9.38 0 11.72-.63a3.74 3.74 0 0 0 2.65-2.65A38.85 38.85 0 0 0 31 16a38.85 38.85 0 0 0-.63-7.22zM13 20.5v-9l7.79 4.5z" })), F$ = V$, Xd = R(B()), H$ = (e) => Xd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Xd.createElement("path", { d: "M31 11.55a1 1 0 0 0-.81-.68L21 9.54l-4.1-8.3a1 1 0 0 0-1.8 0L11 9.54l-9.14 1.33a1 1 0 0 0-.56 1.7L7.93 19l-1.57 9.15a1 1 0 0 0 .4 1 1 1 0 0 0 1 .08L16 24.9l8.19 4.3a.92.92 0 0 0 .46.11 1 1 0 0 0 .59-.19 1 1 0 0 0 .4-1L24.07 19l6.63-6.46a1 1 0 0 0 .3-.99zm-9.35 5.7-.75.73L21 19l1 5.64L16.93 22l-.93-.49-.93.49L10 24.66 11 19l.18-1-.75-.73-4.1-4 5.67-.84 1-.15.47-.94L16 6.2l2.53 5.14.47.94 1 .15 5.66.82z" })), K$ = H$, Jd = R(B()), j$ = (e) => Jd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Jd.createElement("path", { d: "M31 11.55a1 1 0 0 0-.81-.68L21 9.54l-4.1-8.3a1 1 0 0 0-1.8 0L11 9.54l-9.14 1.33a1 1 0 0 0-.56 1.7L7.93 19l-1.57 9.15a1 1 0 0 0 .4 1 1 1 0 0 0 1 .08L16 24.9l8.19 4.3a.92.92 0 0 0 .46.11 1 1 0 0 0 .59-.19 1 1 0 0 0 .4-1L24.07 19l6.63-6.46a1 1 0 0 0 .3-.99z" })), U$ = j$, _r = R(B()), W$ = (e) => _r.createElement("svg", { width: 32, height: 32, xmlns: "http://www.w3.org/2000/svg", className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, _r.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M16 24.502a9.512 9.512 0 0 0-7.968 4.317 1.5 1.5 0 1 1-2.514-1.638 12.513 12.513 0 0 1 20.964 0 1.5 1.5 0 1 1-2.514 1.638A9.513 9.513 0 0 0 16 24.502Z" }), _r.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.85 10.169a1.5 1.5 0 0 1 .094 2.119 5.5 5.5 0 1 0 8.112 0 1.5 1.5 0 0 1 2.213-2.026 8.5 8.5 0 1 1-12.538 0 1.5 1.5 0 0 1 2.12-.093Z" }), _r.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m16 4.942-7.8 3.22 7.8 3.22 7.8-3.22-7.8-3.22Zm.382-3.088a1 1 0 0 0-.764 0L2.577 7.238c-.825.34-.825 1.508 0 1.849l13.041 5.384a1 1 0 0 0 .764 0l13.041-5.384c.825-.34.825-1.509 0-1.849L16.382 1.854Z" }), _r.createElement("path", { d: "M2 8h2a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V8Z" })), q$ = W$, Qd = R(B()), Z$ = (e) => Qd.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Qd.createElement("path", { d: "M29 10h-6V5a1 1 0 0 0-1-1H10a1 1 0 0 0-1 1v5H3a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V14a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v13a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V14a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v13a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1V11a1 1 0 0 0-1-1zM12 7h8v3h-8z" })), G$ = Z$, Fa = R(B()), Y$ = (e) => Fa.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Fa.createElement("g", { "data-name": "Layer 4" }, Fa.createElement("rect", { x: 14.5, width: 3, height: 5, rx: 1 }), Fa.createElement("path", { d: "M6.3 9.91a1 1 0 0 1-.62-.22L3.34 7.82a1 1 0 0 1-.16-1.4l.62-.79a1.05 1.05 0 0 1 .67-.37 1.08 1.08 0 0 1 .74.21l2.34 1.87a1 1 0 0 1 .37.66 1 1 0 0 1-.21.74l-.62.78a1 1 0 0 1-.79.39ZM1.49 20.83a1 1 0 0 1-1-.78l-.22-1a1 1 0 0 1 .13-.75 1 1 0 0 1 .6-.42l3-.67a1 1 0 0 1 1.16.79l.23 1a1 1 0 0 1-.76 1.19l-2.92.67Zm8.45 9.9a1 1 0 0 1-.43-.1l-.9-.43a1 1 0 0 1-.47-1.34l1.3-2.7a1 1 0 0 1 1.34-.47l.9.44a1 1 0 0 1 .47 1.33l-1.31 2.71a1 1 0 0 1-.9.56Zm12.12 0a1 1 0 0 1-.9-.56l-1.3-2.71a1 1 0 0 1 .46-1.33l.9-.44a1 1 0 0 1 1.34.47l1.3 2.7a1 1 0 0 1-.47 1.34l-.9.43a.94.94 0 0 1-.43.1Zm8.45-9.91a.86.86 0 0 1-.22 0l-2.92-.67a1 1 0 0 1-.76-1.2l.23-1a1 1 0 0 1 1.16-.74l2.93.66a1 1 0 0 1 .75 1.2l-.22 1a1 1 0 0 1-.95.75ZM25.69 9.91a1 1 0 0 1-.78-.38l-.62-.78a1 1 0 0 1 .16-1.41l2.34-1.87a1 1 0 0 1 .74-.21 1 1 0 0 1 .67.37l.62.78a1 1 0 0 1 .21.74 1 1 0 0 1-.37.67l-2.34 1.87a1 1 0 0 1-.63.22ZM16 10a6 6 0 1 1-6 6 6 6 0 0 1 6-6m0-3a9 9 0 1 0 9 9 9 9 0 0 0-9-9Z" }))), X$ = Y$, Ha = R(B()), J$ = (e) => Ha.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Ha.createElement("rect", { x: 14.5, width: 3, height: 5, rx: 1, ry: 1 }), Ha.createElement("path", { d: "M7.71 8.75A1 1 0 0 0 7.92 8a1 1 0 0 0-.37-.67L5.21 5.47a1.08 1.08 0 0 0-.74-.21 1.05 1.05 0 0 0-.67.37l-.62.79a1 1 0 0 0 .16 1.4l2.34 1.87a1 1 0 0 0 1.41-.16zM5.16 18A1 1 0 0 0 4 17.21l-3 .67a1 1 0 0 0-.62.44 1 1 0 0 0-.13.75l.22 1a1 1 0 0 0 1 .78h.22l2.92-.67a1 1 0 0 0 .76-1.19zm6.52 8.13-.9-.44a1 1 0 0 0-1.34.47l-1.3 2.7a1 1 0 0 0 .47 1.34l.9.43a1 1 0 0 0 .43.1 1 1 0 0 0 .9-.56l1.31-2.71a1 1 0 0 0-.47-1.33zm10.88.03a1 1 0 0 0-1.34-.47l-.9.44a1 1 0 0 0-.46 1.33l1.3 2.71a1 1 0 0 0 .9.56.94.94 0 0 0 .43-.1l.9-.43a1 1 0 0 0 .47-1.34zm9.02-7.84a1 1 0 0 0-.62-.45L28 17.21a1 1 0 0 0-1.19.75l-.23 1a1 1 0 0 0 .76 1.2l2.92.67a.86.86 0 0 0 .22 0 1 1 0 0 0 1-.77l.22-1a1 1 0 0 0-.12-.74zM29 7.15a1 1 0 0 0-.21-.74l-.62-.78a1 1 0 0 0-.67-.37 1 1 0 0 0-.74.21l-2.31 1.87a1 1 0 0 0-.16 1.41l.62.78a1 1 0 0 0 1.41.16l2.34-1.87a1 1 0 0 0 .34-.67z" }), Ha.createElement("circle", { cx: 16, cy: 16, r: 9 })), Q$ = J$, ef = R(B()), eP = (e) => ef.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, ef.createElement("path", { d: "M30 11H2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1v2a6 6 0 0 0 12 0v-2h2v2a6 6 0 0 0 12 0v-2h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1z" })), tP = eP, Yn = R(B()), nP = (e) => Yn.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Yn.createElement("g", { "data-name": "Layer 4" }, Yn.createElement("rect", { x: 4, y: 26, width: 24, height: 3, rx: 1 }), Yn.createElement("path", { d: "M30 23a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-5.06a8.26 8.26 0 0 0 .06-1 9 9 0 0 0-18 0 8.26 8.26 0 0 0 .06 1H2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1Zm-20-4a6 6 0 0 1 12 0 6.64 6.64 0 0 1-.09 1H10.09a6.64 6.64 0 0 1-.09-1Z" }), Yn.createElement("rect", { x: 14.5, y: 3, width: 3, height: 5, rx: 1 }), Yn.createElement("path", { d: "M6.3 12.91a1 1 0 0 1-.62-.22l-2.34-1.87a1 1 0 0 1-.16-1.4l.62-.79a1.05 1.05 0 0 1 .67-.37 1.09 1.09 0 0 1 .74.21l2.34 1.87a1 1 0 0 1 .37.67 1 1 0 0 1-.21.74l-.62.78a1 1 0 0 1-.79.38Zm19.39 0a1 1 0 0 1-.78-.38l-.62-.78a1 1 0 0 1 .16-1.41l2.34-1.87a1 1 0 0 1 .74-.21 1 1 0 0 1 .67.37l.62.78a1 1 0 0 1 .21.74 1 1 0 0 1-.37.67l-2.34 1.87a1 1 0 0 1-.63.22Z" }))), rP = nP, Xn = R(B()), aP = (e) => Xn.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Xn.createElement("g", { "data-name": "Layer 4" }, Xn.createElement("rect", { x: 14.5, y: 3, width: 3, height: 5, rx: 1 }), Xn.createElement("path", { d: "M6.3 12.91a1 1 0 0 1-.62-.22l-2.34-1.87a1 1 0 0 1-.16-1.4l.62-.79a1.05 1.05 0 0 1 .67-.37 1.09 1.09 0 0 1 .74.21l2.34 1.87a1 1 0 0 1 .37.67 1 1 0 0 1-.21.74l-.62.78a1 1 0 0 1-.79.38Zm19.39 0a1 1 0 0 1-.78-.38l-.62-.78a1 1 0 0 1 .16-1.41l2.34-1.87a1 1 0 0 1 .74-.21 1 1 0 0 1 .67.37l.62.78a1 1 0 0 1 .21.74 1 1 0 0 1-.37.67l-2.34 1.87a1 1 0 0 1-.63.22Z" }), Xn.createElement("rect", { x: 4, y: 26, width: 24, height: 3, rx: 1 }), Xn.createElement("path", { d: "M30 23a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-5.06a8.26 8.26 0 0 0 .06-1 9 9 0 0 0-18 0 8.26 8.26 0 0 0 .06 1H2a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1Z" }))), iP = aP, Ka = R(B()), oP = (e) => Ka.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Ka.createElement("path", { d: "M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm0 29a13 13 0 1 1 13-13 13 13 0 0 1-13 13z" }), Ka.createElement("path", { d: "M16 6a6 6 0 0 0-6 6v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1a3 3 0 1 1 3 3h-1a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1.09A6 6 0 0 0 16 6z" }), Ka.createElement("rect", { height: 3, rx: 1, width: 3, x: 14, y: 22 })), lP = oP, tf = R(B()), sP = (e) => tf.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, tf.createElement("path", { d: "M16 0a16 16 0 1 0 16 16A16 16 0 0 0 16 0zm1 24a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1zm0-6.09V19a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h1a3 3 0 1 0-3-3v1a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1a6 6 0 1 1 7 5.91z" })), cP = sP, nf = R(B()), uP = (e) => nf.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, nf.createElement("path", { d: "M23.7 22.48a1 1 0 0 0-1.32 0 9.13 9.13 0 0 1-15.28-5.1l1.37 1.37a1 1 0 0 0 1.41 0l.71-.71a1 1 0 0 0 0-1.41L7 13.08l-.7-.7a1 1 0 0 0-1.42 0l-.71.7-3.5 3.55a1 1 0 0 0 0 1.37l.71.71a1 1 0 0 0 1.41 0l1.29-1.29a12.13 12.13 0 0 0 20.39 7.17 1 1 0 0 0 0-1.5Zm7.68-8.55-.71-.7a1 1 0 0 0-1.41 0L28 14.51A12.14 12.14 0 0 0 7.57 7.35a1 1 0 0 0 0 1.49l.75.66a1 1 0 0 0 1.32 0A9.14 9.14 0 0 1 25 14.59l-1.37-1.36a1 1 0 0 0-1.41 0l-.71.7a1 1 0 0 0 0 1.42l4.25 4.25a1 1 0 0 0 1.42 0l4.25-4.25a1 1 0 0 0-.05-1.42Z", "data-name": "Layer 4" })), dP = uP, rf = R(B()), fP = (e) => rf.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, rf.createElement("path", { d: "M27 1H5a1 1 0 0 0-1 1v28a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM16 29a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 16 29zm9-5H7V4h18z" })), pP = fP, af = R(B()), hP = (e) => af.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, af.createElement("path", { d: "M29.87 28.51 17.74 7.05l2.69-4.66a1 1 0 0 0 .1-.76 1 1 0 0 0-.47-.63L19.2.52a1 1 0 0 0-1.37.37L16 4.06 14.17.89A1 1 0 0 0 12.8.52l-.86.5a1 1 0 0 0-.47.61 1 1 0 0 0 .1.76l2.69 4.66L2.13 28.51a1 1 0 0 0 0 1A1 1 0 0 0 3 30h26a1 1 0 0 0 .86-.5 1 1 0 0 0 .01-.99zM16 22.65 18.86 27h-5.72zM22.45 27l-5.61-8.55a1.05 1.05 0 0 0-1.68 0L9.55 27H6.43L16 10.06 25.57 27z" })), vP = hP, of = R(B()), mP = (e) => of.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, of.createElement("path", { d: "M29.87 28.51 17.74 7.05l2.69-4.66a1 1 0 0 0 .1-.76 1 1 0 0 0-.47-.63L19.2.52a1 1 0 0 0-1.37.37L16 4.06 14.17.89A1 1 0 0 0 12.8.52l-.86.5a1 1 0 0 0-.47.61 1 1 0 0 0 .1.76l2.69 4.66L2.13 28.51a1 1 0 0 0 0 1A1 1 0 0 0 3 30h26a1 1 0 0 0 .86-.5 1 1 0 0 0 .01-.99zM16 19.82 20.71 27h-9.42z" })), gP = mP, Jn = R(B()), yP = (e) => Jn.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Jn.createElement("path", { d: "M28 1H4a1 1 0 0 0-1 1v28a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM6 28V4h20v24z" }), Jn.createElement("rect", { height: 3, rx: 1, width: 3, x: 8, y: 19 }), Jn.createElement("path", { d: "M23 17a1 1 0 0 0-1.41 0l-4.15 4.14-2-2a1 1 0 0 0-1.41 0l-.71.7a1 1 0 0 0 0 1.42L16 24l.7.71a1 1 0 0 0 1.42 0l.7-.71 4.86-4.85a1 1 0 0 0 0-1.42z" }), Jn.createElement("rect", { height: 3, rx: 1, width: 3, x: 8, y: 9 }), Jn.createElement("path", { d: "M23 7a1 1 0 0 0-1.41 0l-4.15 4.14-2-2a1 1 0 0 0-1.41 0l-.71.7a1 1 0 0 0 0 1.42L16 14l.7.71a1 1 0 0 0 1.42 0l.7-.71 4.86-4.85a1 1 0 0 0 0-1.42z" })), bP = yP, lf = R(B()), wP = (e) => lf.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, lf.createElement("path", { d: "M28 1H4a1 1 0 0 0-1 1v28a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM11 21a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1zm0-10a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1zm12.71 8.15L18.85 24l-.7.71a1 1 0 0 1-1.42 0L16 24l-2.74-2.73a1 1 0 0 1 0-1.42l.71-.7a1 1 0 0 1 1.41 0l2 2L21.59 17A1 1 0 0 1 23 17l.71.7a1 1 0 0 1 0 1.45zm0-10L18.85 14l-.7.71a1 1 0 0 1-1.42 0L16 14l-2.74-2.73a1 1 0 0 1 0-1.42l.71-.7a1 1 0 0 1 1.41 0l2 2L21.59 7A1 1 0 0 1 23 7l.71.7a1 1 0 0 1 0 1.45z" })), xP = wP, Gl = R(B()), EP = (e) => Gl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Gl.createElement("path", { d: "M30 1H2a1 1 0 0 0-1 1v28a1 1 0 0 0 1 1h28a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM4 28V4h24v24z" }), Gl.createElement("path", { d: "M23 7.5H9a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-1h3.5v11H14a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h4a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-.5v-11H21v1a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z" })), $P = EP, sf = R(B()), PP = (e) => sf.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, sf.createElement("path", { d: "M30 1H2a1 1 0 0 0-1 1v28a1 1 0 0 0 1 1h28a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zm-6 8.5v2a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-1h-3.5v11h.5a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-1a1 1 0 0 1 1-1h.5v-11H11v1a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1z" })), CP = PP, cf = R(B()), SP = (e) => cf.createElement("svg", { width: 32, height: 32, xmlns: "http://www.w3.org/2000/svg", className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, cf.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m5.64 19.27-1.91-1.91v-.01c-.47-.47-.73-1.11-.73-1.77v-2.3c0-.46.13-.92.37-1.31l3.56-5.78C7.39 5.45 8.19 5 9.06 5H28.5c.55 0 1 .45 1 1v12c0 .55-.45 1-1 1h-5.66c-.09.26-.22.5-.39.71l-5.48 6.9c-.48.59-1.2.94-1.96.94h-1.35c-1.51 0-2.67-1.32-2.48-2.82l.61-4.73H7.41c-.67 0-1.3-.26-1.77-.73ZM23 16.01h3.5v-8H23v8Zm-13.66-8L6 13.43v1.95L7.62 17h7.58l-.97 7.55h.54l4.73-6.05V8.01H9.34Z" })), kP = SP, Yl = R(B()), TP = (e) => Yl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Yl.createElement("rect", { height: 14, rx: 1, width: 5, x: 23, y: 6 }), Yl.createElement("path", { d: "M20 6H7a1 1 0 0 0-.83.45l-4 6A1 1 0 0 0 2 13v5a1 1 0 0 0 .29.71l2 2A1 1 0 0 0 5 21h7.85L12 26.86a.66.66 0 0 0 0 .14v1a1 1 0 0 0 1 1h1a1 1 0 0 0 .8-.4l6-8a1 1 0 0 0 .2-.6V7a1 1 0 0 0-1-1z" })), AP = TP, uf = R(B()), OP = (e) => uf.createElement("svg", { width: 32, height: 32, xmlns: "http://www.w3.org/2000/svg", className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, uf.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "m26.86 13.28 1.91 1.91v.01c.47.47.73 1.11.73 1.77v2.3c0 .46-.13.92-.37 1.31l-3.56 5.78c-.46.74-1.26 1.19-2.13 1.19H4c-.55 0-1-.45-1-1v-12c0-.55.45-1 1-1h5.66c.09-.26.22-.5.39-.71l5.48-6.9c.48-.59 1.2-.94 1.96-.94h1.35c1.51 0 2.67 1.32 2.48 2.82l-.61 4.73h4.38c.67 0 1.3.26 1.77.73ZM9.5 16.54H6v8h3.5v-8Zm13.66 8 3.34-5.42v-1.95l-1.62-1.62H17.3L18.27 8h-.54L13 14v10.54h10.16Z" })), zP = OP, Xl = R(B()), MP = (e) => Xl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Xl.createElement("rect", { height: 14, rx: 1, width: 5, x: 3, y: 12 }), Xl.createElement("path", { d: "m28.71 13.29-2-2A1 1 0 0 0 26 11h-7.85L19 5.14A.66.66 0 0 0 19 5V4a1 1 0 0 0-1-1h-1a1 1 0 0 0-.8.4l-6 8a1 1 0 0 0-.2.6v13a1 1 0 0 0 1 1h13a1 1 0 0 0 .83-.45l4-6A1 1 0 0 0 29 19v-5a1 1 0 0 0-.29-.71z" })), _P = MP, df = R(B()), LP = (e) => df.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, df.createElement("path", { d: "M31.2 13.08a1 1 0 0 0 .8-1V7a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v5.1a1 1 0 0 0 .8 1A4 4 0 0 1 4 17a4 4 0 0 1-3.2 3.92 1 1 0 0 0-.8 1V27a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1v-5.1a1 1 0 0 0-.8-1 4 4 0 0 1 0-7.84zM25 17a7 7 0 0 0 4 6.32V25H3v-1.68A7 7 0 0 0 7 17a7 7 0 0 0-4-6.32V9h26v1.68A7 7 0 0 0 25 17z" })), IP = LP, ff = R(B()), DP = (e) => ff.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, ff.createElement("path", { d: "M31.2 13.08a1 1 0 0 0 .8-1V7a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v5.1a1 1 0 0 0 .8 1A4 4 0 0 1 4 17a4 4 0 0 1-3.2 3.92 1 1 0 0 0-.8 1V27a1 1 0 0 0 1 1h30a1 1 0 0 0 1-1v-5.1a1 1 0 0 0-.8-1 4 4 0 0 1 0-7.84z" })), NP = DP, pf = R(B()), RP = (e) => pf.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, pf.createElement("path", { d: "M29 2H3a1 1 0 0 0-1 1v26a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1Zm-4.44 12.09a3.91 3.91 0 0 1-.49 0 5.32 5.32 0 0 1-4.47-2.39v8.22a6.08 6.08 0 1 1-6.08-6.07h.37v3h-.37a3.11 3.11 0 0 0 0 6.21A3.18 3.18 0 0 0 16.75 20V6h2.87a5.32 5.32 0 0 0 4.92 4.76Z" })), BP = RP, hf = R(B()), VP = (e) => hf.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, hf.createElement("path", { d: "M5.73 20.71a7.29 7.29 0 0 0 14.58 0v-9.87a6.42 6.42 0 0 0 5.37 2.9h.59v-4A6.41 6.41 0 0 1 20.37 4h-3.44v16.76A3.81 3.81 0 0 1 13 24.43 3.72 3.72 0 0 1 13 17h.45v-3.56H13a7.29 7.29 0 0 0-7.27 7.27Z", "data-name": "Layer 4" })), FP = VP, Jl = R(B()), HP = (e) => Jl.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Jl.createElement("path", { d: "m22.64 5.67 1.2-2.91a1 1 0 0 0-.54-1.3l-.92-.38a1 1 0 0 0-1.31.54l-1.21 2.93a14.29 14.29 0 0 0-2.36-.47V1a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v3.08a14 14 0 1 0 8.14 1.59zM16 29a11 11 0 1 1 11-11 11 11 0 0 1-11 11z" }), Jl.createElement("path", { d: "M16 14.5a3.51 3.51 0 0 0-1.17.21l-2.77-2.77a1 1 0 0 0-1.41 0l-.71.71a1 1 0 0 0 0 1.41l2.77 2.77A3.49 3.49 0 1 0 16 14.5z" })), KP = HP, vf = R(B()), jP = (e) => vf.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, vf.createElement("path", { d: "m22.65 5.68 1.19-2.87a1 1 0 0 0-.54-1.31l-.92-.38a1 1 0 0 0-1.31.54l-1.2 2.89a14.2 14.2 0 0 0-2.37-.47V1a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v3.08a14 14 0 1 0 8.15 1.6zM16 21a3 3 0 0 1-3-3 3.25 3.25 0 0 1 .11-.77L8 12.08a1 1 0 0 1 0-1.41l.67-.67a1 1 0 0 1 1.41 0l5.15 5.15A3.25 3.25 0 0 1 16 15a3 3 0 0 1 0 6z" })), UP = jP, mf = R(B()), WP = (e) => mf.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, mf.createElement("path", { d: "M27 24h-2v-4a1 1 0 0 0-1-1h-3V4a1 1 0 0 0-.4-.8l-4-3a1 1 0 0 0-1.2 0l-4 3a1 1 0 0 0-.4.8v15H8a1 1 0 0 0-1 1v4H5a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm-13-5V5l2-1.5L18 5v14zm-7 8h18v2H7zm3-5h12v2H10z" })), qP = WP, Qn = R(B()), ZP = (e) => Qn.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Qn.createElement("g", { "data-name": "Layer 4" }, Qn.createElement("circle", { cx: 16, cy: 7, r: 2.5 }), Qn.createElement("path", { d: "M21 0H11a2.5 2.5 0 0 0-2.5 2.5v22A2.5 2.5 0 0 0 11 27h3.5v4a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-4H21a2.5 2.5 0 0 0 2.5-2.5v-22A2.5 2.5 0 0 0 21 0Zm-.5 24h-9V3h9Z" }), Qn.createElement("circle", { cx: 16, cy: 13.5, r: 2.5 }), Qn.createElement("circle", { cx: 16, cy: 20, r: 2.5 }))), GP = ZP, gf = R(B()), YP = (e) => gf.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, gf.createElement("path", { d: "M21 0H11a2.5 2.5 0 0 0-2.5 2.5v22A2.5 2.5 0 0 0 11 27h3.5v4a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-4H21a2.5 2.5 0 0 0 2.5-2.5v-22A2.5 2.5 0 0 0 21 0Zm-5 23a2.5 2.5 0 1 1 2.5-2.5A2.5 2.5 0 0 1 16 23Zm0-7a2.5 2.5 0 1 1 2.5-2.5A2.5 2.5 0 0 1 16 16Zm0-7a2.5 2.5 0 1 1 2.5-2.5A2.5 2.5 0 0 1 16 9Z", "data-name": "Layer 4" })), XP = YP, yf = R(B()), JP = (e) => yf.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, yf.createElement("path", { d: "m27.45 3.11-4-2A1 1 0 0 0 23 1H9a1 1 0 0 0-.45.11l-4 2A1 1 0 0 0 4 4v20a1 1 0 0 0 1 1h3.13l-3 4.45a1 1 0 0 0 0 1A1 1 0 0 0 6 31h1a1 1 0 0 0 .83-.45L11.54 25h8.92l3.71 5.55A1 1 0 0 0 25 31h1a1 1 0 0 0 .88-.53 1 1 0 0 0-.05-1l-3-4.45H27a1 1 0 0 0 1-1V4a1 1 0 0 0-.55-.89zM8.5 22a1.5 1.5 0 1 1 1.5-1.5A1.5 1.5 0 0 1 8.5 22zM8 16a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h6.5v9zm15.5 6a1.5 1.5 0 1 1 1.5-1.5 1.5 1.5 0 0 1-1.5 1.5zm1.5-7a1 1 0 0 1-1 1h-6.5V7H24a1 1 0 0 1 1 1z" })), QP = JP, bf = R(B()), eC = (e) => bf.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, bf.createElement("path", { d: "M32 1a1 1 0 0 0-1-1h-8.5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h4.6l-7 6.94a1.32 1.32 0 0 0-.19.29 7 7 0 0 0-7.73-.12l-2-2L12 6.3a1 1 0 0 0 0-1.41l-.71-.71a1 1 0 0 0-1.41 0L8.07 6 5.12 3H8a1 1 0 0 0 1-1V1a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V5.12l3 3-1.82 1.72a1 1 0 0 0 0 1.41l.71.71A1 1 0 0 0 6.3 12l1.77-1.77 2 2a7 7 0 0 0 4.42 10.61.9.9 0 0 0 0 .16v2H12a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h2.5v3a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-3H20a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-2.5v-2a.9.9 0 0 0 0-.16 7 7 0 0 0 4.46-10.55 1 1 0 0 0 .34-.22L29 5.33v4.18a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V1ZM16 20a4 4 0 1 1 4-4 4 4 0 0 1-4 4Z" })), tC = eC, Lr = R(B()), nC = (e) => Lr.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Lr.createElement("path", { d: "M25 12H7a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V13a1 1 0 0 0-1-1zM9 29V15h14v14z" }), Lr.createElement("rect", { x: 12, y: 17, width: 3, height: 10, rx: 1, ry: 1 }), Lr.createElement("rect", { x: 17, y: 17, width: 3, height: 10, rx: 1, ry: 1 }), Lr.createElement("path", { d: "M27 6h-4V1a1 1 0 0 0-1-1H10a1 1 0 0 0-1 1v5H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1zm-7 0h-8V3h8z" })), rC = nC, wf = R(B()), aC = (e) => wf.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, wf.createElement("path", { d: "M25 12H7a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V13a1 1 0 0 0-1-1zM13.5 28a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V16a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1zm8 0a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1V16a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1zM27 6h-4V1a1 1 0 0 0-1-1H10a1 1 0 0 0-1 1v5H5a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1z" })), iC = aC, xf = R(B()), oC = (e) => xf.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, xf.createElement("path", { d: "m31.8 12.4-3-4A1 1 0 0 0 28 8H17.5V3a1 1 0 0 0-1-1H4a1 1 0 0 0-.8.4l-3 4a1 1 0 0 0 0 1.2l3 4a1 1 0 0 0 .8.4h10.5v2H4a1 1 0 0 0-.8.4l-3 4a1 1 0 0 0 0 1.2l3 4a1 1 0 0 0 .8.4h10.5v5a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V18H28a1 1 0 0 0 .8-.4l3-4a1 1 0 0 0 0-1.2zM14 5v4H5L3.5 7 5 5zm14.5 8L27 15h-9v-4h9zM14 17v4H5l-1.5-2L5 17z" })), lC = oC, Ef = R(B()), sC = (e) => Ef.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Ef.createElement("path", { d: "m31.8 12.4-3-4A1 1 0 0 0 28 8H17.5V3a1 1 0 0 0-1-1H4a1 1 0 0 0-.8.4l-3 4a1 1 0 0 0 0 1.2l3 4a1 1 0 0 0 .8.4h10.5v2H4a1 1 0 0 0-.8.4l-3 4a1 1 0 0 0 0 1.2l3 4a1 1 0 0 0 .8.4h10.5v5a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V18H28a1 1 0 0 0 .8-.4l3-4a1 1 0 0 0 0-1.2z" })), cC = sC, $f = R(B()), uC = (e) => $f.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, $f.createElement("path", { d: "M25.9 11.57A1 1 0 0 0 25 11H7a1 1 0 0 0-.77 1.63l9 11a1 1 0 0 0 1.54 0l9-11a1 1 0 0 0 .13-1.06z" })), dC = uC, Pf = R(B()), fC = (e) => Pf.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Pf.createElement("path", { d: "M6.1 21.43A1 1 0 0 0 7 22h18a1 1 0 0 0 .77-1.63l-9-11a1 1 0 0 0-1.54 0l-9 11a1 1 0 0 0-.13 1.06z" })), pC = fC, Cf = R(B()), hC = (e) => Cf.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Cf.createElement("path", { d: "M32 10a6 6 0 0 0-5.38-6V3a1 1 0 0 0-1-1h-19a1 1 0 0 0-1 1v1A6 6 0 0 0 6 16h.23A10.52 10.52 0 0 0 14 22.78V27h-3.88a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H18v-4.18A10.49 10.49 0 0 0 26 16a6 6 0 0 0 6-6zM3 10a3 3 0 0 1 2.62-3v6A3 3 0 0 1 3 10zm23.62 2.93V7.07a3 3 0 0 1 0 5.86z" })), vC = hC, Ql = R(B()), mC = (e) => Ql.createElement("svg", { width: 32, height: 32, xmlns: "http://www.w3.org/2000/svg", className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Ql.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M6.5 6.5v17H9a1.5 1.5 0 0 1 1.5 1.5v1.801l3.257-2.71a2.475 2.475 0 0 1 1.605-.591h5.085l5.053-4.205V6.5h-19ZM4.232 4.232A2.5 2.5 0 0 1 6 3.5h20A2.5 2.5 0 0 1 28.5 6v13.558a2.513 2.513 0 0 1-.9 1.892l-.003.003-5.354 4.456a2.475 2.475 0 0 1-1.605.591h-5.085l-5.594 4.653A1.5 1.5 0 0 1 7.5 30v-3.5H6A2.5 2.5 0 0 1 3.5 24V6a2.5 2.5 0 0 1 .732-1.768Z" }), Ql.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M21 9.5a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-3 0v-6A1.5 1.5 0 0 1 21 9.5Zm-6 0a1.5 1.5 0 0 1 1.5 1.5v6a1.5 1.5 0 0 1-3 0v-6A1.5 1.5 0 0 1 15 9.5Z" })), gC = mC, Sf = R(B()), yC = (e) => Sf.createElement("svg", { width: 32, height: 32, xmlns: "http://www.w3.org/2000/svg", className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Sf.createElement("path", { d: "M26 4H6a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h2v4a.987.987 0 0 0 .575.9A.85.85 0 0 0 9 31a.938.938 0 0 0 .637-.238L15.363 26h5.274c.467.001.918-.163 1.276-.462l5.362-4.476A1.963 1.963 0 0 0 28 19.538V6a2 2 0 0 0-2-2ZM16 17a1 1 0 0 1-2 0v-6a1 1 0 0 1 2 0v6Zm6 0a1 1 0 0 1-2 0v-6a1 1 0 0 1 2 0v6Z" })), bC = yC, kf = R(B()), wC = (e) => kf.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, kf.createElement("path", { d: "M31.93 14.66a16 16 0 0 0-31.86 0A1 1 0 0 0 0 15v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-.5c0-1.08 1.37-2 3-2s3 .92 3 2v.5a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1c0-1 1.06-1.91 2.5-2.3v12.05a1.25 1.25 0 0 1-2.5 0V26a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 .05.25 4.23 4.23 0 0 0 8.44-.4V14.7C18.94 15.09 20 16 20 17a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-.5c0-1.08 1.37-2 3-2s3 .92 3 2v.5a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2a1 1 0 0 0-.07-.34zm-10.62-1.27A7.87 7.87 0 0 0 16 11.5a7.87 7.87 0 0 0-5.31 1.89A6.48 6.48 0 0 0 6 11.5a7 7 0 0 0-2.32.39 13 13 0 0 1 24.64 0A7 7 0 0 0 26 11.5a6.48 6.48 0 0 0-4.69 1.89z" })), xC = wC, Tf = R(B()), EC = (e) => Tf.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Tf.createElement("path", { d: "M31.93 14.66a16 16 0 0 0-31.86 0A1 1 0 0 0 0 15v2a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-.5c0-1.08 1.37-2 3-2s3 .92 3 2v.5a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1c0-1 1.06-1.91 2.5-2.3v12.05a1.25 1.25 0 0 1-2.5 0V26a1 1 0 0 0-1-1h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 .05.25 4.23 4.23 0 0 0 8.44-.4V14.7C18.94 15.09 20 16 20 17a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-.5c0-1.08 1.37-2 3-2s3 .92 3 2v.5a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2a1 1 0 0 0-.07-.34z" })), $C = EC, es = R(B()), PC = (e) => es.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, es.createElement("path", { d: "M27 12h-2.81a7.5 7.5 0 0 0-11.94-8.8l-.35.35-.13.13a1 1 0 0 0-.3.71 1 1 0 0 0 .3.71l.7.71a1 1 0 0 0 1.42 0l.45-.46a4.5 4.5 0 1 1 6.37 6.36l-.32.32H5a1 1 0 0 0-1 1V29a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V13a1 1 0 0 0-1-1zm-2 3v12H7V15z" }), es.createElement("path", { d: "M14.5 22.05V25a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-2.95a2.75 2.75 0 1 0-3 0z" })), CC = PC, Af = R(B()), SC = (e) => Af.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Af.createElement("path", { d: "M26 12h-2.81a7.5 7.5 0 0 0-11.94-8.8l-.35.35-.13.13a1 1 0 0 0-.3.71 1 1 0 0 0 .3.71l.7.71a1 1 0 0 0 1.42 0l.45-.46a4.5 4.5 0 0 1 6.37 6.36l-.32.32H4a1 1 0 0 0-1 1V29a1 1 0 0 0 1 1h22a1 1 0 0 0 1-1V13a1 1 0 0 0-1-1zm-9.5 10.05V25a1 1 0 0 1-1 1h-1a1 1 0 0 1-1-1v-2.95a2.75 2.75 0 1 1 3 0z" })), kC = SC, ts = R(B()), TC = (e) => ts.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, ts.createElement("path", { d: "m9.29 19.71.71.7a1 1 0 0 0 1.41 0l3.09-3.08V30a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1V17.33l3.09 3.08a1 1 0 0 0 1.41 0l.71-.7a1 1 0 0 0 0-1.42L17.41 13l-.7-.71a1 1 0 0 0-1.42 0l-.7.71-5.3 5.29a1 1 0 0 0 0 1.42Z" }), ts.createElement("path", { d: "M32 13.76a5.24 5.24 0 0 0-4.74-5.21 8.49 8.49 0 0 0-15.71-3.44A6.6 6.6 0 0 0 3.3 8.92a5.2 5.2 0 0 0 1.33 10A1.16 1.16 0 0 0 5 19h1a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1H5a2.22 2.22 0 0 1-.38-4.35l1-.29.32-1a3.62 3.62 0 0 1 3.5-2.6 3.57 3.57 0 0 1 1.65.41l1.86 1 .87-1.91a5.49 5.49 0 0 1 10.49 2.21v2.35l2.23-.26h.25A2.23 2.23 0 0 1 27 16h-1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h1a1.16 1.16 0 0 0 .37-.07A5.22 5.22 0 0 0 32 13.76Z" })), AC = TC, Of = R(B()), OC = (e) => Of.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Of.createElement("path", { d: "M27.5 8a4 4 0 0 0-.5.05V8a8 8 0 0 0-15.26-3.34 6 6 0 0 0-8.46 3.53A4.49 4.49 0 0 0 4.5 17h23a4.5 4.5 0 0 0 0-9ZM10.29 26.71l.71.7a1 1 0 0 0 1.41 0l2.09-2.08V31a1 1 0 0 0 1 1h1a1 1 0 0 0 1-1v-5.67l2.09 2.08a1 1 0 0 0 1.41 0l.71-.7a1 1 0 0 0 0-1.42L17.41 21l-.7-.71a1 1 0 0 0-1.42 0l-.7.71-4.3 4.29a1 1 0 0 0 0 1.42Z" })), zC = OC, ns = R(B()), MC = (e) => ns.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, ns.createElement("path", { d: "M29 12h-3V3a1 1 0 0 0-.46-.84 1 1 0 0 0-.95-.07l-22 10a1 1 0 0 0-.29.2.1.1 0 0 0 0 .05.82.82 0 0 0-.16.25.36.36 0 0 0 0 .11 2 2 0 0 0-.05.24L2 13v16a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V13a1 1 0 0 0-1-1zM5 15h22v12H5zm18-3H10l13-5.89z" }), ns.createElement("circle", { cx: 22, cy: 21, r: 2 })), _C = MC, rs = R(B()), LC = (e) => rs.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, rs.createElement("path", { d: "M10.5 13a5.38 5.38 0 0 0 .12 1.14l6.52-6.52A5.38 5.38 0 0 0 16 7.5a5.51 5.51 0 0 0-5.5 5.5zm11 0a5.38 5.38 0 0 0-.12-1.14l-6.52 6.52a5.38 5.38 0 0 0 1.14.12 5.51 5.51 0 0 0 5.5-5.5z" }), rs.createElement("path", { d: "M23.74 9.5A8.49 8.49 0 0 1 12.5 20.74l-1.85 1.85a10.84 10.84 0 0 0 3.85 1.3V27H10a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-4.5v-3.11a11 11 0 0 0 8.1-16.25zm-15.48 7A8.49 8.49 0 0 1 19.5 5.26l1.86-1.86a11 11 0 0 0-15 15zm18.8-13.85-.71-.71a1 1 0 0 0-1.41 0l-20 20a1 1 0 0 0 0 1.41l.71.71a1 1 0 0 0 1.41 0l20-20a1 1 0 0 0 0-1.41z" })), IC = LC, as = R(B()), DC = (e) => as.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, as.createElement("path", { d: "M16 7.5a5.5 5.5 0 1 0 5.5 5.5A5.51 5.51 0 0 0 16 7.5zm0 8a2.5 2.5 0 1 1 2.5-2.5 2.5 2.5 0 0 1-2.5 2.5z" }), as.createElement("path", { d: "M27 13a11 11 0 1 0-12.5 10.89V27H10a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-1a1 1 0 0 0-1-1h-4.5v-3.11A11 11 0 0 0 27 13zm-11 8.5a8.5 8.5 0 1 1 8.5-8.5 8.51 8.51 0 0 1-8.5 8.5z" })), NC = DC, ja = R(B()), RC = (e) => ja.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, ja.createElement("g", { "data-name": "Layer 4" }, ja.createElement("path", { d: "M29 2H3a1 1 0 0 0-1 1v26a1 1 0 0 0 1 1h26a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1Zm-4.72 18.25a9.26 9.26 0 0 1-12.59 3.61L6.56 25.5l1.67-5a9.27 9.27 0 0 1 7.93-14 9.26 9.26 0 0 1 8.12 13.75Z" }), ja.createElement("path", { d: "M11.65 9.54a7.71 7.71 0 0 0-1.73 10.77l-1 2.86 3-.94a7.71 7.71 0 1 0-.27-12.69Zm9.14 9.76a2.4 2.4 0 0 1-1.63 1.06c-.44 0-.45.31-2.82-.69a9.83 9.83 0 0 1-3.9-3.67 4.54 4.54 0 0 1-.87-2.48 2.64 2.64 0 0 1 .9-1.94.82.82 0 0 1 .64-.27h.45c.14 0 .34-.06.52.42s.61 1.66.66 1.78a.43.43 0 0 1 0 .41 1.66 1.66 0 0 1-.26.39c-.12.13-.26.3-.37.4a.35.35 0 0 0-.1.47 7.3 7.3 0 0 0 1.24 1.68 6.63 6.63 0 0 0 1.85 1.25c.23.16.38.16.52 0s.62-.67.78-.9.31-.19.53-.1 1.36.7 1.59.83a3.3 3.3 0 0 1 .49.29 2 2 0 0 1-.22 1.07Z" }))), BC = RC, is = R(B()), VC = (e) => is.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, is.createElement("g", { "data-name": "Layer 4" }, is.createElement("path", { d: "M16.2 4A11.69 11.69 0 0 0 4.54 15.73a11.55 11.55 0 0 0 1.65 5.95L4.08 28l6.48-2.07A11.69 11.69 0 1 0 16.2 4Zm0 21.47a9.7 9.7 0 0 1-5.35-1.6l-3.79 1.19 1.26-3.62a9.74 9.74 0 1 1 13.6 2.18 9.62 9.62 0 0 1-5.72 1.85Zm5.48-7.07c-.29-.16-1.73-.93-2-1s-.47-.16-.67.13-.81.93-1 1.13-.36.21-.66 0A8.17 8.17 0 0 1 15 17a9.38 9.38 0 0 1-1.57-2.13.42.42 0 0 1 .13-.59c.14-.13.32-.34.47-.51a2.34 2.34 0 0 0 .33-.49.53.53 0 0 0 0-.52c-.06-.15-.61-1.64-.83-2.25s-.43-.51-.61-.51h-.57a1.07 1.07 0 0 0-.81.34 3.34 3.34 0 0 0-1.14 2.46 5.92 5.92 0 0 0 1.1 3.14 12.45 12.45 0 0 0 4.93 4.7c3 1.26 3 .91 3.56.87a3 3 0 0 0 2.06-1.34 2.44 2.44 0 0 0 .25-1.45 3.41 3.41 0 0 0-.62-.37Z", "data-name": "Layer 1" }))), FC = VC, Ua = R(B()), HC = (e) => Ua.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 32, height: 32, className: "ef-svg ef-icon", viewBox: "0 0 32 32", ...e, style: { fill: "currentColor", width: "var(--icon-size, 1em)", height: "var(--icon-size, 1em)", display: "inline-block", ...e.style } }, Ua.createElement("circle", { cx: 16.04, cy: 26.5, r: 2.5 }), Ua.createElement("path", { d: "M16 17.5a8.47 8.47 0 0 0-6.7 3.28 1 1 0 0 0 0 1.19l.61.86a1 1 0 0 0 .81.43 1 1 0 0 0 .81-.42 5.47 5.47 0 0 1 8.92-.08.93.93 0 0 0 .82.4 1 1 0 0 0 .81-.42l.6-.86a1 1 0 0 0 0-1.21A8.49 8.49 0 0 0 16 17.5zm14.09-7.74a21.38 21.38 0 0 0-28.18.08 1 1 0 0 0-.16 1.33l.57.82a1 1 0 0 0 .7.42h.12a1 1 0 0 0 .66-.25 18.39 18.39 0 0 1 24.4-.08 1 1 0 0 0 .78.24 1 1 0 0 0 .7-.42l.57-.82a1 1 0 0 0-.16-1.32z" }), Ua.createElement("path", { d: "M16 11a14.91 14.91 0 0 0-10.38 4.23 1 1 0 0 0-.12 1.29l.58.83a1 1 0 0 0 .72.42h.09a1 1 0 0 0 .71-.29 12 12 0 0 1 16.81-.08 1 1 0 0 0 .79.28 1 1 0 0 0 .72-.42l.58-.82a1 1 0 0 0-.13-1.3A14.89 14.89 0 0 0 16 11z" })), KC = HC;
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/** @license React v17.0.2
 * react.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/** @license React v17.0.2
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
const jC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  IconAcademicMaterial: d4,
  IconAccommodation: p4,
  IconAgender: v4,
  IconAirplane: g4,
  IconAlert: C4,
  IconAlertCircle: $4,
  IconAlertCircleOutlined: x4,
  IconAlertCircleOutlined2: b4,
  IconAmusement: k4,
  IconArrowDown: A4,
  IconArrowLeft: z4,
  IconArrowRight: _4,
  IconArrowUp: I4,
  IconAsexual: N4,
  IconAudio: U4,
  IconAudioOff: F4,
  IconAudioOffOutlined: B4,
  IconAudioOutlined: K4,
  IconBackpack: q4,
  IconBalloon: X4,
  IconBalloonOutlined: G4,
  IconBasketball: Q4,
  IconBeach: rw,
  IconBeachClub: tw,
  IconBell: lw,
  IconBellOutlined: iw,
  IconBigender: cw,
  IconBoat: dw,
  IconBonfire: pw,
  IconBook: gw,
  IconBookOutlined: vw,
  IconBookmark: xw,
  IconBookmarkOutlined: bw,
  IconBookshelf: $w,
  IconBriefcase: Cw,
  IconBurger: kw,
  IconBus: Aw,
  IconCalendar: _w,
  IconCalendarOutlined: zw,
  IconCamera: Nw,
  IconCameraOutlined: Iw,
  IconCertificate: Uw,
  IconCertificateAlt: Fw,
  IconCertificateAltOutlined: Bw,
  IconCertificateOutlined: Kw,
  IconChartLineUp: qw,
  IconChat: Xw,
  IconChatOutlined: Gw,
  IconCheck: l6,
  IconCheckActive: Qw,
  IconCheckCircle: i6,
  IconCheckCircleOutlined: r6,
  IconCheckDisabled: t6,
  IconChevronDoubleLeft: c6,
  IconChevronDoubleRight: d6,
  IconChevronDown: p6,
  IconChevronLeft: v6,
  IconChevronRight: g6,
  IconChevronUp: b6,
  IconClock: $6,
  IconClockOutlined: x6,
  IconClose: C6,
  IconCloud: _6,
  IconCloudDownload: A6,
  IconCloudDownloadOutlined: k6,
  IconCloudOutlined: z6,
  IconCloudy: N6,
  IconCloudyOutlined: I6,
  IconCoach: B6,
  IconCocktail: F6,
  IconCoin: U6,
  IconCoinOutlined: K6,
  IconColumns: q6,
  IconCompass: X6,
  IconCompassOutlined: G6,
  IconConversation: t7,
  IconConversationOutlined: Q6,
  IconCountryRoad: i7,
  IconCountryRoadOutlined: r7,
  IconCourseDuration: c7,
  IconCourseDurationOutlined: l7,
  IconCrayon: p7,
  IconCrayonOutlined: d7,
  IconCreditCard: g7,
  IconCreditCardOutlined: v7,
  IconCrop: b7,
  IconDeal: $7,
  IconDealOutlined: x7,
  IconDice: k7,
  IconDiceOutlined: C7,
  IconDiscount: z7,
  IconDiscountOutlined: A7,
  IconError: N7,
  IconErrorCircle: I7,
  IconErrorCircleOutlined: _7,
  IconExternalLink: B7,
  IconEye: U7,
  IconEyeClosed: F7,
  IconEyeOutlined: K7,
  IconFemale: q7,
  IconFilter: G7,
  IconFish: Q7,
  IconFishOutlined: X7,
  IconFlag: r8,
  IconFlagOutlined: t8,
  IconFlashcard: l8,
  IconFlashcardOutlined: i8,
  IconFootball: d8,
  IconFootballOutlined: c8,
  IconGift: v8,
  IconGiftOutlined: p8,
  IconGlobe: g8,
  IconGraduationCap: b8,
  IconGrid: $8,
  IconGrid2: x8,
  IconGuarantee: k8,
  IconGuaranteeOutlined: C8,
  IconHappy: A8,
  IconHeadphones: z8,
  IconHeart: I8,
  IconHeartOutlined: _8,
  IconHome: B8,
  IconHomeOutlined: N8,
  IconHourglass: F8,
  IconImage: U8,
  IconImageOutlined: K8,
  IconInfo: X8,
  IconInfoCircle: G8,
  IconInfoCircleOutlined: q8,
  IconInfomeeting: tx,
  IconInfomeetingOutlined: Q8,
  IconIsInvalid: rx,
  IconIsValid: ix,
  IconLevel: cx,
  IconLevelOutlined: lx,
  IconLifesaver: dx,
  IconList: px,
  IconLocation: gx,
  IconLocationOutlined: vx,
  IconLocked: xx,
  IconLockedOutlined: bx,
  IconMail: $x,
  IconMale: Cx,
  IconMap: kx,
  IconMeal: Ax,
  IconMedal: zx,
  IconMediaLibrary: Ix,
  IconMediaLibraryOutlined: _x,
  IconMedicalKit: Nx,
  IconMenu: Fx,
  IconMenuDots: Bx,
  IconMetroPass: Ux,
  IconMetroPassOutlined: Kx,
  IconMicrophone: Xx,
  IconMicrophoneOff: qx,
  IconMicrophoneOutlined: Gx,
  IconMinus: r9,
  IconMinusCircle: t9,
  IconMinusCircleOutlined: Qx,
  IconMonument: i9,
  IconMoon: c9,
  IconMoonOutlined: l9,
  IconMusic: p9,
  IconMusicOutlined: d9,
  IconNote: g9,
  IconNoteOutlined: v9,
  IconOnlineCourse: x9,
  IconOnlineCourseOutlined: b9,
  IconPark: $9,
  IconPause: C9,
  IconPen: A9,
  IconPenOutlined: k9,
  IconPeople: _9,
  IconPeopleOutlined: z9,
  IconPerson: N9,
  IconPersonOutlined: I9,
  IconPhone: B9,
  IconPint: F9,
  IconPizza: K9,
  IconPlay: q9,
  IconPlayOutlined: U9,
  IconPlus: Q9,
  IconPlusCircle: X9,
  IconPlusCircleOutlined: G9,
  IconPointer: rE,
  IconPointerOutlined: tE,
  IconPrice: lE,
  IconPriceOutlined: iE,
  IconPrinter: cE,
  IconQr: dE,
  IconQuiz: vE,
  IconQuizOutlined: pE,
  IconRain: bE,
  IconRainOutlined: gE,
  IconRefresh: xE,
  IconRoad: CE,
  IconRoadOutlined: $E,
  IconSearch: kE,
  IconSettings: AE,
  IconShare: _E,
  IconShareOutlined: zE,
  IconShield: FE,
  IconShieldAlt: NE,
  IconShieldAltOutlined: IE,
  IconShieldOutlined: BE,
  IconShoppingCart: UE,
  IconShoppingCartOutlined: KE,
  IconSignIn: qE,
  IconSignOut: GE,
  IconSmartphone: XE,
  IconSnapchat: r$,
  IconSnapchatAlt: QE,
  IconSnapchatSquare: t$,
  IconSnow: i$,
  IconSocialBe: c$,
  IconSocialBeSq: l$,
  IconSocialFb: v$,
  IconSocialFbAlt: d$,
  IconSocialFbSquare: p$,
  IconSocialIn: x$,
  IconSocialInAlt: g$,
  IconSocialInSquare: b$,
  IconSocialLi: k$,
  IconSocialLiAlt: $$,
  IconSocialLiSquare: C$,
  IconSocialPi: _$,
  IconSocialPiAlt: A$,
  IconSocialPiSquare: z$,
  IconSocialTw: N$,
  IconSocialTwSquare: I$,
  IconSocialYt: F$,
  IconSocialYtSquare: B$,
  IconStar: U$,
  IconStarOutlined: K$,
  IconStudentOutlined: q$,
  IconSuitcase: G$,
  IconSun: Q$,
  IconSunOutlined: X$,
  IconSunglasses: tP,
  IconSunset: iP,
  IconSunsetOutlined: rP,
  IconSupport: cP,
  IconSupportOutlined: lP,
  IconSync: dP,
  IconTablet: pP,
  IconTent: gP,
  IconTentOutlined: vP,
  IconTest: xP,
  IconTestOutlined: bP,
  IconText: CP,
  IconTextOutlined: $P,
  IconThumbsDown: AP,
  IconThumbsDownOutlined: kP,
  IconThumbsUp: _P,
  IconThumbsUpOutlined: zP,
  IconTicket: NP,
  IconTicketOutlined: IP,
  IconTiktok: FP,
  IconTiktokSquare: BP,
  IconTimer: UP,
  IconTimerOutlined: KP,
  IconTower: qP,
  IconTrafficLight: XP,
  IconTrafficLightOutlined: GP,
  IconTrain: QP,
  IconTransgender: tC,
  IconTrash: iC,
  IconTrashOutlined: rC,
  IconTravelDirections: cC,
  IconTravelDirectionsOutlined: lC,
  IconTriangleDown: dC,
  IconTriangleUp: pC,
  IconTrophy: vC,
  IconTwitch: bC,
  IconTwitchOutlined: gC,
  IconUmbrella: $C,
  IconUmbrellaOutlined: xC,
  IconUnlocked: kC,
  IconUnlockedOutlined: CC,
  IconUpload: zC,
  IconUploadOutlined: AC,
  IconWallet: _C,
  IconWebcam: NC,
  IconWebcamOff: IC,
  IconWhatsapp: FC,
  IconWhatsappSquare: BC,
  IconWifi: KC
}, Symbol.toStringTag, { value: "Module" })), UC = de("gudl-icon", {
  variants: {
    /**
     * The size of the icon. `xs` is 12px, `sm` is 16px, `base` is 24px, and `lg` is 32px.
     */
    size: {
      xs: "text-xs/[0]",
      sm: "text-base/[0]",
      base: "text-2xl/[0]",
      lg: "text-[32px]/[0]"
    }
  },
  defaultVariants: {
    size: "base"
  }
}), WC = (e) => {
  const t = (n) => n[0].toUpperCase() + n.substring(1);
  return e.split("-").map(t).join("");
}, qC = jC, Le = ({
  "aria-hidden": e = !0,
  iconName: t,
  size: n = "base",
  color: r,
  flipIconOnRtl: a = !1,
  className: i
}) => {
  if (!t || !t.length)
    throw Error("Please provide an iconName!");
  const o = `Icon${WC(t)}`, l = qC[o];
  if (!l)
    throw Error("The icon you are looking for does not exist!");
  return /* @__PURE__ */ H(
    "i",
    {
      style: { color: r },
      className: ae(
        !r && "text-inherit",
        a && "rtl:-scale-x-100",
        UC({ size: n }),
        i
      ),
      "aria-hidden": e,
      "data-cy": "gudl-icon",
      children: l({})
    }
  );
}, ZC = de("luik-breadcrumbs flex", {
  variants: {
    color: {
      white: "text-white",
      black: "text-black"
    }
  }
}), GC = ({
  isCurrent: e,
  children: t,
  renderWithoutTrailingChevron: n = !1,
  className: r
}) => {
  var l;
  const a = J(null), i = ((l = a.current) == null ? void 0 : l.tagName.toLowerCase()) || "a", { itemProps: o } = v5(
    { children: t, isCurrent: e, elementType: i },
    a
  );
  if (!t)
    throw new Error("You must provide child element to <BreadcrumbItem>");
  return /* @__PURE__ */ ie(
    "li",
    {
      className: ae(
        "luik-breadcrumb-item inline-flex items-center ",
        e ? "pointer-events-none" : "hover:underline",
        r
      ),
      children: [
        en(t, { ref: a, ...o }),
        !n && /* @__PURE__ */ H(
          Le,
          {
            className: "mx-1 rtl:-scale-x-100",
            size: "xs",
            iconName: "chevron-right",
            flipIconOnRtl: !0
          }
        )
      ]
    }
  );
}, YC = ({
  color: e = "black",
  children: t,
  maxItems: n = 4,
  enableLinkOnLastItem: r = !1,
  className: a,
  ...i
}) => {
  const { navProps: o } = m5(i);
  return /* @__PURE__ */ H(
    "nav",
    {
      className: ae(ZC({ color: e }), a),
      ...o,
      children: /* @__PURE__ */ H("ol", { children: t.slice(0, n).map(
        (l, s, u) => en(l, {
          isCurrent: !r && s === u.length - 1,
          renderWithoutTrailingChevron: s === u.length - 1,
          key: s
        })
      ) })
    }
  );
};
YC.Item = GC;
const XC = de(
  "gudl-loading-indicator flex relative leading-none rounded-full border-2 border-x-transparent border-b-transparent after:border-2 after:rounded-full after:absolute after:opacity-20 after:-top-0.5 after:-bottom-0.5 after:-start-0.5 after:-end-0.5 animate-spin",
  {
    variants: {
      /**
       * Intent of the loading indicator.
       */
      intent: {
        inherit: "border-t-inherit after:border-inherit",
        "accessible-blue": "border-t-brand-accessible-blue after:border-brand-accessible-blue",
        white: "border-t-white after:border-white",
        black: "border-t-black after:border-black"
      },
      /**
       * Size of the loading indicator.
       */
      size: {
        sm: "w-5 h-5",
        base: "w-6 h-6",
        lg: "w-6 h-6"
      }
    },
    defaultVariants: {
      intent: "inherit",
      size: "base"
    }
  }
), JC = ({
  intent: e = "inherit",
  size: t = "lg",
  ariaLive: n = "assertive",
  className: r,
  ...a
}) => /* @__PURE__ */ H(
  "span",
  {
    "data-cy": "gudl-loading",
    className: ae(XC({ intent: e, size: t }), r),
    "aria-busy": "true",
    "aria-live": n,
    ...a
  }
), QC = de(
  "gudl-button relative group inline-flex items-center justify-center gap-2.5 rounded-full disabled:pointer-events-none outline-none md:max-w-[327px]",
  {
    variants: {
      /**
       * Whether the button is loading.
       */
      isLoading: {
        true: "cursor-default pointer-events-none"
      },
      inert: {
        true: "cursor-default pointer-events-none"
      }
    },
    defaultVariants: {
      isLoading: !1
    }
  }
), eS = de(
  "inline-flex flex-row items-center gap-2.5 relative z-auto transition-colors ease-expressive duration-300",
  {
    variants: {
      /**
       * The intent of the button.
       */
      intent: {
        "primary-accessible-blue": "text-white group-disabled:text-white",
        "primary-black": "text-white group-disabled:text-white",
        "primary-white": "text-black group-disabled:text-neutral-500",
        "secondary-accessible-blue": "text-brand-accessible-blue group-disabled:text-neutral-400",
        "secondary-filled-accessible-blue-60": "text-brand-accessible-blue group-disabled:text-neutral-400",
        "secondary-filled-accessible-blue-80": "text-brand-accessible-blue group-disabled:text-neutral-400",
        "secondary-filled-accessible-blue-100": "text-brand-accessible-blue group-disabled:text-neutral-400",
        "secondary-black": "text-black group-disabled:text-neutral-500",
        "secondary-filled-black-60": "text-black group-disabled:text-neutral-500",
        "secondary-filled-black-80": "text-black group-disabled:text-neutral-500",
        "secondary-filled-black-100": "text-black group-disabled:text-neutral-500",
        "secondary-white": "text-white group-disabled:text-neutral-500",
        "secondary-filled-white-60": "text-white group-disabled:text-neutral-500",
        "secondary-filled-white-80": "text-white group-disabled:text-neutral-500",
        "secondary-filled-white-100": "text-white group-disabled:text-neutral-500",
        "tertiary-accessible-blue": "text-brand-accessible-blue group-disabled:text-neutral-500",
        "tertiary-black": "text-black group-disabled:text-neutral-500",
        "tertiary-white": "text-white group-disabled:text-neutral-500"
      },
      /**
       * The size of the button.
       */
      size: {
        sm: "text-sm py-2 px-4",
        base: "text-label-lg py-[14px] px-6",
        lg: "text-label-lg py-[18px] px-10"
      },
      isPressed: {
        true: []
      }
    },
    compoundVariants: [
      {
        isPressed: !0,
        intent: "primary-black",
        className: "text-neutral-400"
      }
    ],
    defaultVariants: {
      intent: "primary-accessible-blue",
      size: "base"
    }
  }
), tS = de(
  "absolute inset-0 z-auto rounded-full ease-expressive duration-300 transition-all border border-transparent ring-2 ring-offset-2 ring-transparent ring-offset-transparent",
  {
    variants: {
      intent: {
        "primary-accessible-blue": "bg-brand-accessible-blue",
        "primary-black": "bg-black",
        "primary-white": "bg-white",
        "secondary-accessible-blue": "border-brand-accessible-blue",
        "secondary-filled-accessible-blue-60": "border-brand-accessible-blue bg-white/60",
        "secondary-filled-accessible-blue-80": "border-brand-accessible-blue bg-white/80",
        "secondary-filled-accessible-blue-100": "border-brand-accessible-blue bg-white",
        "secondary-black": "border-black",
        "secondary-filled-black-60": "border-black bg-white/60",
        "secondary-filled-black-80": "border-black bg-white/80",
        "secondary-filled-black-100": "border-black bg-white",
        "secondary-white": "border-white",
        "secondary-filled-white-60": "border-white bg-black/60",
        "secondary-filled-white-80": "border-white bg-black/80",
        "secondary-filled-white-100": "border-white bg-black",
        "tertiary-accessible-blue": "group-hover:bg-info-lighter ring-offset-0",
        "tertiary-black": "group-hover:bg-neutral-50 ring-offset-0",
        "tertiary-white": "group-hover:bg-neutral-700 ring-offset-0"
      },
      /* Added to satisfy CVA only used in a compound variant */
      hasActiveStateBackground: {
        true: []
      },
      isDisabled: {
        true: []
      },
      size: {
        sm: "motion-safe:group-hover:scale-[1.06] ",
        base: "motion-safe:group-hover:scale-[1.04]",
        lg: "motion-safe:group-hover:scale-[1.04]"
      },
      touchActivated: {
        true: "motion-safe:group-active:scale-[0.95]"
      },
      pointerActivated: {
        true: "motion-safe:group-active:scale-[1]"
      },
      isFocusVisible: {
        true: "ring-offset-white ring-brand-accessible-blue"
      }
    },
    compoundVariants: [
      {
        isDisabled: !0,
        intent: "primary-accessible-blue",
        className: "bg-neutral-400"
      },
      {
        hasActiveStateBackground: !0,
        intent: "primary-accessible-blue",
        className: "bg-info-dark"
      },
      {
        isDisabled: !0,
        intent: "primary-black",
        className: "bg-neutral-500"
      },
      {
        isDisabled: !0,
        intent: "primary-white",
        className: "bg-neutral-200"
      },
      {
        hasActiveStateBackground: !0,
        intent: "primary-white",
        className: "bg-neutral-200"
      },
      {
        isDisabled: !0,
        intent: "secondary-accessible-blue",
        className: "border-neutral-400"
      },
      {
        hasActiveStateBackground: !0,
        intent: "secondary-accessible-blue",
        className: "bg-info-lighter"
      },
      {
        isDisabled: !0,
        intent: "secondary-black",
        className: "border-neutral-500"
      },
      {
        hasActiveStateBackground: !0,
        intent: "secondary-black",
        className: "bg-neutral-100"
      },
      {
        isDisabled: !0,
        intent: "secondary-white",
        className: "border-neutral-500"
      },
      {
        hasActiveStateBackground: !0,
        intent: "secondary-white",
        className: "bg-neutral-600"
      },
      {
        hasActiveStateBackground: !0,
        intent: "tertiary-accessible-blue",
        className: "bg-info-lighter"
      },
      {
        hasActiveStateBackground: !0,
        intent: "tertiary-black",
        className: "bg-neutral-100"
      },
      {
        hasActiveStateBackground: !0,
        intent: "tertiary-white",
        className: "bg-neutral-600"
      }
    ],
    defaultVariants: {
      intent: "primary-accessible-blue",
      size: "base",
      touchActivated: !1,
      pointerActivated: !1
    }
  }
), Xv = ({
  intent: e = "primary-accessible-blue",
  size: t = "base",
  "aria-label": n,
  as: r,
  buttonRef: a,
  children: i,
  isDisabled: o = !1,
  isLoading: l = !1,
  onPress: s,
  href: u,
  target: f,
  iconName: h,
  iconPosition: g = "start",
  className: v,
  contentClassName: E,
  backgroundClassName: b,
  inert: w,
  flipIconOnRtl: S = !0,
  ...T
}) => {
  const [A, V] = ne(!1), [$, _] = ne(!1), y = (k) => {
    k.pointerType === "mouse" ? (_(!0), V(!1)) : (_(!1), V(!0));
  }, c = J(null), { buttonProps: p, isPressed: d } = Fi(
    {
      elementType: u ? "a" : "button",
      isDisabled: o || !!l,
      onPress: s,
      href: u,
      target: f,
      onPressStart: y,
      ...T
    },
    c
  ), { focusProps: m, isFocusVisible: O } = vr(), x = (k) => r || k(), P = (k) => u ? "a" : k(), N = (k) => w ? "span" : k(), D = () => "button", I = x(() => P(() => N(D))), C = u ? { role: "link" } : w ? {} : { role: "button" }, L = w ? T : Pe(p, T);
  return /* @__PURE__ */ ie(
    I,
    {
      className: ae(
        "highlight-none",
        QC({
          isLoading: l,
          inert: w
        }),
        v
      ),
      ref: a || (u ? null : c),
      "data-cy": "gudl-button",
      ...C,
      "aria-label": n,
      ...L,
      onTouchEnd: (k) => !u && k.preventDefault(),
      ...m,
      children: [
        /* @__PURE__ */ H(
          "div",
          {
            className: ae(
              tS({
                intent: e,
                size: t,
                touchActivated: A,
                pointerActivated: $,
                isFocusVisible: O,
                hasActiveStateBackground: l || d,
                isDisabled: o
              }),
              b
            ),
            "data-cy": "gudl-button-background"
          }
        ),
        /* @__PURE__ */ H(
          "span",
          {
            className: ae(
              eS({
                intent: e,
                size: t,
                isPressed: d
              }),
              E
            ),
            "data-cy": "gudl-button-content",
            children: l ? /* @__PURE__ */ H(JC, { size: t }) : /* @__PURE__ */ ie(De, { children: [
              h && /* @__PURE__ */ H(
                Le,
                {
                  className: _n(
                    g === "start" ? "order-first" : "order-last"
                  ),
                  flipIconOnRtl: S,
                  iconName: h,
                  size: "sm"
                }
              ),
              /* @__PURE__ */ H("span", { className: "line-clamp-2 text-center leading-5", children: i })
            ] })
          }
        )
      ]
    }
  );
}, nS = de(
  "gudl-banner p-4 md:p-6 transition-colors block focus:border-0 focus:outline-0 focus:ring-brand-accessible-blue focus:ring-offset-4 focus:ring-2",
  {
    variants: {
      /**
       * The style of the banner.
       */
      style: {
        "accessible-blue": "bg-brand-accessible-blue",
        "light-blue": "bg-info-light",
        neutral: "bg-neutral-100"
      },
      /**
       * The position of the banner.
       */
      position: {
        top: "rounded-t-3xl",
        inline: "rounded lg:p-8"
      }
    },
    defaultVariants: {
      style: "accessible-blue",
      position: "inline"
    }
  }
), rS = de("", {
  variants: {
    // Just here to satisfy cva
    style: {
      "accessible-blue": "",
      "light-blue": "",
      neutral: ""
    },
    isClickable: {
      true: "cursor-pointer",
      false: "cursor-default"
    }
  },
  compoundVariants: [
    {
      style: "accessible-blue",
      isClickable: !0,
      className: "hover:bg-info-dark"
    },
    {
      style: "light-blue",
      isClickable: !0,
      className: "hover:bg-info-lighter"
    },
    {
      style: "neutral",
      isClickable: !0,
      className: "hover:bg-neutral-200"
    }
  ]
}), aS = de(
  "gudl-banner-content w-full flex gap-4 items-top md:items-center mx-auto",
  {
    variants: {
      style: {
        "accessible-blue": "text-white",
        "light-blue": "text-black",
        neutral: "text-black"
      },
      position: {
        top: "flex justify-center items-center w-fit",
        inline: ""
      }
    }
  }
), YD = ({
  className: e,
  iconName: t,
  style: n = "accessible-blue",
  position: r = "inline",
  href: a,
  hrefTarget: i = "_self",
  onBannerPress: o,
  buttonLabel: l,
  children: s,
  dataInfo: u,
  ...f
}) => {
  const h = !!a || !!o;
  let g = o ? "button" : "div";
  a && (g = "a");
  const v = a && {
    href: a,
    target: i
  }, E = o && { onPress: o }, b = u && { "data-info": u };
  return /* @__PURE__ */ H(
    g,
    {
      className: ae(
        nS({ style: n, position: r }),
        rS({ style: n, isClickable: h }),
        e
      ),
      ...v,
      ...E,
      ...b,
      ...f,
      "data-cy": "gudl-banner",
      children: /* @__PURE__ */ ie(
        "div",
        {
          className: ae(aS({ style: n, position: r })),
          "data-cy": "gudl-banner-content",
          children: [
            t && /* @__PURE__ */ H(iS, { iconName: t, position: r }),
            /* @__PURE__ */ ie("div", { className: "flex w-full flex-col items-start justify-between gap-4 md:flex-row md:items-center", children: [
              /* @__PURE__ */ H(Ye, { className: "line-clamp-2 lg:line-clamp-1", variant: "heading-5", children: s }),
              r === "inline" && h && /* @__PURE__ */ H(
                Xv,
                {
                  className: "shrink-0",
                  intent: n === "accessible-blue" ? "secondary-white" : "secondary-black",
                  iconName: "arrow-right",
                  iconPosition: "end",
                  size: "base",
                  flipIconOnRtl: !0,
                  inert: !0,
                  children: l
                }
              )
            ] })
          ]
        }
      )
    }
  );
}, iS = ({ iconName: e, position: t }) => /* @__PURE__ */ ie(De, { children: [
  t === "inline" && /* @__PURE__ */ ie(De, { children: [
    /* @__PURE__ */ H(Le, { className: "lg:hidden", iconName: e, size: "base" }),
    /* @__PURE__ */ H(Le, { className: "hidden lg:block", iconName: e, size: "lg" })
  ] }),
  t === "top" && /* @__PURE__ */ ie(De, { children: [
    /* @__PURE__ */ H(Le, { className: "md:hidden", iconName: e, size: "base" }),
    /* @__PURE__ */ H(Le, { className: "hidden md:block", iconName: e, size: "lg" })
  ] })
] }), oS = de("flex flex-col gap-4 lg:flex-row flex-wrap", {
  variants: {
    stack: {
      true: "lg:flex-col"
    },
    horizontal: {
      true: "flex-row"
    }
  }
}), XD = ({
  children: e,
  stack: t,
  horizontal: n,
  onlyButtons: r = !0,
  className: a,
  equalWidth: i = !0
}) => {
  if (He.count(e) === 0)
    throw Error("Usage without children is not allowed!");
  if (He.count(e) < 2)
    throw Error("Number of children needs to be at least 2!");
  if (He.count(e) > 3)
    throw Error("Number of children needs to be at most 3!");
  if (t && n)
    throw Error("Stack and horizontal flags cannot be used together!");
  return r && He.forEach(e, (o) => {
    if (o && o.type !== Xv)
      throw new Error("This component type is not allowed!");
  }), /* @__PURE__ */ H(
    "div",
    {
      className: ae(oS({ stack: t, horizontal: n }), a),
      "data-cy": "gudl-button-group",
      children: He.map(
        e,
        (o) => o ? en(o, {
          className: ae(
            o == null ? void 0 : o.props.className,
            i ? "flex-1" : "max-md:flex-1"
          )
        }) : null
      )
    }
  );
}, lS = de(
  "group/card relative w-full overflow-hidden rounded-lg bg-white shadow",
  {
    variants: {
      /**
       * The style of the card.
       */
      style: {
        default: "",
        retro: "",
        "no-background": "rounded-none bg-transparent shadow-none",
        bordered: "border border-neutral-300 shadow-none"
      }
    }
  }
), sS = de("w-full overflow-hidden", {
  variants: {
    /**
     * The aspect ratio of the card image.
     */
    aspectRatio: {
      "2/3": "aspect-2/3",
      "3/2": "aspect-3/2",
      "4/3": "aspect-4/3",
      "3/4": "aspect-3/4",
      "5/3": "aspect-5/3",
      "7/5": "aspect-7/5",
      "5/7": "aspect-5/7",
      "16/9": "aspect-16/9",
      "9/16": "aspect-9/16",
      "21/9": "aspect-21/9",
      "1/1": "aspect-1/1"
    }
  }
}), cS = ({ tags: e }) => /* @__PURE__ */ H("div", { className: "flex flex-wrap gap-2", "data-cy": "gudl-card-tags", children: e.slice(0, 2).map(
  (t, n) => t && /* @__PURE__ */ H(
    $1,
    {
      size: "sm",
      iconName: t.iconName,
      intent: t.variant,
      "data-cy": "gudl-card-tag",
      contentClassName: "line-clamp-1",
      className: "max-w-none",
      children: t.text
    },
    n
  )
) }), JD = ({
  title: e,
  className: t,
  contentClassName: n,
  href: r,
  hrefTarget: a = "_self",
  "aria-label": i,
  tags: o,
  image: l,
  description: s,
  eyebrow: u,
  aspectRatio: f = "16/9",
  dataInfo: h,
  onCardPress: g,
  style: v = "default",
  children: E
}) => {
  const b = r ? "a" : "article", w = h && { "data-info": h }, S = r && { role: "link", target: a, href: r }, T = g && { role: "button", onClick: g }, A = !!r || !!g;
  return /* @__PURE__ */ ie(
    b,
    {
      className: ae(
        lS({ style: v }),
        b === "a" && "block",
        t
      ),
      "aria-label": i,
      "data-cy": "gudl-card",
      ...w,
      ...S,
      ...T,
      children: [
        o && /* @__PURE__ */ H(
          "div",
          {
            className: ae(
              l && "absolute end-4 start-4 top-4 z-10",
              v === "retro" && "end-6 start-6 top-6",
              !l && "hidden"
            ),
            children: /* @__PURE__ */ H(cS, { tags: o })
          }
        ),
        oe.isValidElement(l) && /* @__PURE__ */ H(
          "figure",
          {
            className: ae(
              "overflow-hidden",
              v === "retro" && "mx-4 mt-4",
              v === "no-background" && "rounded-md"
            ),
            children: oe.cloneElement(l, {
              className: ae(
                "w-auto object-cover object-center",
                A && "ease-expressive transition-all duration-300  md:group-hover/card:scale-105",
                sS({ aspectRatio: f })
              ),
              "data-cy": "gudl-card-image"
            })
          }
        ),
        /* @__PURE__ */ ie(
          "div",
          {
            className: ae(
              "space-y-2 hyphens-auto p-6",
              v === "retro" && "p-4",
              v === "no-background" && "px-0 pb-0 pt-6",
              n
            ),
            "data-cy": "gudl-card-content",
            children: [
              u && /* @__PURE__ */ H(Ye, { variant: "special-eyebrow", "data-cy": "gudl-card-eyebrow", children: u }),
              e && /* @__PURE__ */ H(Ye, { variant: "heading-5-bold", "data-cy": "gudl-card-title", children: e }),
              s && /* @__PURE__ */ H(Ye, { variant: "paragraph-body", "data-cy": "gudl-card-description", children: s }),
              E
            ]
          }
        )
      ]
    }
  );
}, uS = de(
  "gudl-card rounded-lg relative w-full overflow-hidden flex flex-col self-start group/card",
  {
    variants: {
      /**
       * Whether the card should use the retro style.
       */
      isRetro: {
        true: "p-4 gap-6"
      },
      /**
       * Whether the card should have a background.
       */
      hasBackground: {
        true: "bg-white shadow-[0_1px_10px_-1px_rgba(25,25,25,0.1)]"
      },
      highlight: {
        true: "relative"
      },
      /**
       * Whether the card should have a border.
       */
      hasBorder: {
        true: "border border-neutral-300"
      },
      /**
       * Whether the card should have a full background image, where content is
       * laid out on top of the image.
       */
      fullImage: {
        true: "rounded-2"
      },
      /**
       * Whether the entire card should be clickable.
       */
      isClickable: {
        true: "cursor-pointer hover:shadow-[0px_4px_20px_-1px_rgba(0,0,0,0.2)] focus:border-[2px] border-[#1a73e8] transition-shadow duration-700"
      }
    },
    compoundVariants: [
      {
        hasBackground: !0,
        hasBorder: !0,
        class: "shadow-none"
      },
      {
        hasBackground: !0,
        hasBorder: !1,
        class: "shadow"
      }
    ]
  }
), dS = de("gudl-card-image w-full overflow-hidden", {
  variants: {
    retro: {
      false: ["rounded-t-lg"]
    },
    highlight: {
      true: ""
    },
    fullImage: {
      true: ["col-start-1", "row-span-full"],
      false: ["row-start-1", "col-start-1"]
    },
    /**
     * The aspect ratio of the card image.
     */
    aspectRatio: {
      "2/3": "aspect-2/3",
      "3/2": "aspect-3/2",
      "4/3": "aspect-4/3",
      "3/4": "aspect-3/4",
      "5/3": "aspect-5/3",
      "7/5": "aspect-7/5",
      "5/7": "aspect-5/7",
      "16/9": "aspect-16/9",
      "9/16": "aspect-9/16",
      "21/9": "aspect-21/9",
      "1/1": "aspect-1/1"
    }
  }
}), fS = de(
  "gudl-card-content px-6 py-8 flex flex-col gap-4",
  {
    variants: {
      fullImage: {
        true: " [&>*]:text-white absolute bottom-0 start-0 end-0 z-50"
      },
      isRetro: {
        true: "p-0"
      },
      highlight: {
        true: "flex flex-col text-center align-center justify-center font-bold bg-gradient-to-t from-black/20 h-full"
      },
      aspectRatio: {
        "2/3": "",
        "3/2": "",
        "4/3": "",
        "3/4": "",
        "5/3": "",
        "7/5": "",
        "5/7": "",
        "16/9": "",
        "9/16": "",
        "21/9": "",
        "1/1": ""
      }
    },
    compoundVariants: [
      {
        fullImage: !0,
        aspectRatio: "21/9",
        class: "md:start-auto md:right-0 md:bg-gradient-to-l md:rtl:bg-gradient-to-r md:h-full md:max-w-[290px] md:justify-center"
      },
      {
        fullImage: !0,
        highlight: !1,
        class: "bg-gradient-to-t from-black/20"
      }
    ]
  }
), pS = de(
  "gudl-card-tags absolute start-0 flex gap-2 z-50 p-4",
  {
    variants: {
      isRetro: {
        true: "start-4 p-2"
      }
    }
  }
), hS = ({
  title: e,
  hasBackground: t = !0,
  hasBorder: n = !1,
  className: r,
  contentClassName: a,
  href: i,
  "aria-label": o,
  tags: l = [],
  image: s,
  video: u,
  description: f,
  eyebrow: h,
  fullImage: g = !1,
  highlight: v = !1,
  zoomImageOnHover: E = !0,
  isRetro: b = !1,
  aspectRatio: w,
  dataInfo: S,
  onCardPress: T,
  children: A
}) => {
  const V = (l == null ? void 0 : l.length) > 0, [$, _] = ne(!1), y = e || f || h || A, c = i ? "a" : "article", p = S ? { "data-info": S } : {};
  let d = {};
  i && (d = { target: "_blank", role: "link" }), u && (g = !0);
  const m = i ? { role: "link" } : T ? { role: "button" } : {};
  return /* @__PURE__ */ ie(
    c,
    {
      href: i,
      onClick: T && !i ? T : void 0,
      className: ae(
        uS({
          highlight: v,
          isRetro: b,
          fullImage: g,
          isClickable: !!i || !!T,
          hasBackground: t,
          hasBorder: n
        }),
        r
      ),
      "aria-label": o,
      ...m,
      ...d,
      ...p,
      children: [
        V && s && /* @__PURE__ */ H("div", { className: ae(pS({ isRetro: b })), children: l.slice(0, 2).map(
          (O, x) => O && /* @__PURE__ */ H(
            $1,
            {
              size: "sm",
              iconName: O.iconName,
              intent: O.variant,
              "data-cy": "gudl-card-tag",
              children: O.text
            },
            x
          )
        ) }),
        (s || u) && /* @__PURE__ */ ie("figure", { className: "relative overflow-hidden", children: [
          /* @__PURE__ */ H(
            "img",
            {
              className: ae(
                dS({ aspectRatio: w, highlight: v, fullImage: g }),
                "relative z-30 h-full w-full object-cover object-center",
                E ? "ease-expressive transition-[transform,opacity] duration-700 md:group-hover/card:scale-[1.05]" : "transition-opacity",
                $ ? "opacity-0" : "opacity-100"
              ),
              decoding: "async",
              loading: "lazy",
              src: (s == null ? void 0 : s.url) || (u == null ? void 0 : u.thumbnailImageUrl),
              alt: (s == null ? void 0 : s.alt) || (u == null ? void 0 : u.thumbnailImageAlt)
            }
          ),
          u && /* @__PURE__ */ H("div", { className: "absolute top-0 z-20 flex h-full w-full", children: /* @__PURE__ */ H(
            ag,
            {
              "aria-label": u["aria-label"],
              url: u.url,
              aspectRatio: w,
              loop: !0,
              playing: $,
              className: "h-full w-full",
              showControls: !1
            }
          ) })
        ] }),
        u && /* @__PURE__ */ H(
          "div",
          {
            className: ae(
              "gudl-card-video-button group group absolute bottom-0 end-0 start-0 top-0 z-50 flex items-center justify-center"
            ),
            children: /* @__PURE__ */ H(
              dr,
              {
                iconName: $ ? "pause" : "play",
                onPress: () => _(!$),
                intent: "primary-white",
                "aria-label": "Play video",
                className: ae(
                  "transition-opacity",
                  $ ? "opacity-0" : "opacity-100",
                  "focus:opacity-100 group-hover:opacity-100"
                )
              }
            )
          }
        ),
        y && /* @__PURE__ */ ie(
          "div",
          {
            className: ae(
              fS({
                fullImage: g,
                isRetro: b,
                aspectRatio: w,
                highlight: v
              }),
              a
            ),
            children: [
              h && /* @__PURE__ */ H(Ye, { className: "gudl-card-eyebrow", variant: "special-eyebrow", children: h }),
              e && /* @__PURE__ */ H(
                Ye,
                {
                  className: `gudl-card-title  ${v && "!text-[40px]/[46px] uppercase"}`,
                  variant: "heading-5-bold",
                  children: e
                }
              ),
              f && /* @__PURE__ */ H(Ye, { className: "gudl-card-description", variant: "paragraph-body", children: f }),
              A
            ]
          }
        )
      ]
    }
  );
}, QD = hS;
var vt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Jv(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function vS(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      return this instanceof r ? Reflect.construct(t, arguments, this.constructor) : t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var a = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, a.get ? a : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var Qv = {};
Object.defineProperty(Qv, "__esModule", { value: !0 });
var Ir = oe;
function zf(e) {
  return Array.prototype.slice.call(e);
}
function Mf(e, t) {
  var n = Math.floor(e);
  return n === t || n + 1 === t ? e : t;
}
function _f() {
  return Date.now();
}
function os(e, t, n) {
  if (t = "data-keen-slider-" + t, n === null)
    return e.removeAttribute(t);
  e.setAttribute(t, n || "");
}
function wi(e, t) {
  return t = t || document, typeof e == "function" && (e = e(t)), Array.isArray(e) ? e : typeof e == "string" ? zf(t.querySelectorAll(e)) : e instanceof HTMLElement ? [e] : e instanceof NodeList ? zf(e) : [];
}
function Dr(e) {
  e.raw && (e = e.raw), e.cancelable && !e.defaultPrevented && e.preventDefault();
}
function Nr(e) {
  e.raw && (e = e.raw), e.stopPropagation && e.stopPropagation();
}
function em() {
  var e = [];
  return { add: function(t, n, r, a) {
    t.addListener ? t.addListener(r) : t.addEventListener(n, r, a), e.push([t, n, r, a]);
  }, input: function(t, n, r, a) {
    this.add(t, n, function(i) {
      return function(o) {
        o.nativeEvent && (o = o.nativeEvent);
        var l = o.changedTouches || [], s = o.targetTouches || [], u = o.detail && o.detail.x ? o.detail : null;
        return i({ id: u ? u.identifier ? u.identifier : "i" : s[0] ? s[0] ? s[0].identifier : "e" : "d", idChanged: u ? u.identifier ? u.identifier : "i" : l[0] ? l[0] ? l[0].identifier : "e" : "d", raw: o, x: u && u.x ? u.x : s[0] ? s[0].screenX : u ? u.x : o.pageX, y: u && u.y ? u.y : s[0] ? s[0].screenY : u ? u.y : o.pageY });
      };
    }(r), a);
  }, purge: function() {
    e.forEach(function(t) {
      t[0].removeListener ? t[0].removeListener(t[2]) : t[0].removeEventListener(t[1], t[2], t[3]);
    }), e = [];
  } };
}
function Wc(e, t, n) {
  return Math.min(Math.max(e, t), n);
}
function Ot(e) {
  return (e > 0 ? 1 : 0) - (e < 0 ? 1 : 0) || +e;
}
function Lf(e) {
  var t = e.getBoundingClientRect();
  return { height: Mf(t.height, e.offsetHeight), width: Mf(t.width, e.offsetWidth) };
}
function ot(e, t, n, r) {
  var a = e && e[t];
  return a == null ? n : r && typeof a == "function" ? a() : a;
}
function xt(e) {
  return Math.round(1e6 * e) / 1e6;
}
function tm(e, t) {
  if (e === t)
    return !0;
  var n = typeof e;
  if (n !== typeof t)
    return !1;
  if (n !== "object" || e === null || t === null)
    return n === "function" && e.toString() === t.toString();
  if (e.length !== t.length || Object.getOwnPropertyNames(e).length !== Object.getOwnPropertyNames(t).length)
    return !1;
  for (var r in e)
    if (!tm(e[r], t[r]))
      return !1;
  return !0;
}
var sr = function() {
  return sr = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++)
      for (var a in t = arguments[n])
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    return e;
  }, sr.apply(this, arguments);
};
function nm(e, t, n) {
  if (n || arguments.length === 2)
    for (var r, a = 0, i = t.length; a < i; a++)
      !r && a in t || (r || (r = Array.prototype.slice.call(t, 0, a)), r[a] = t[a]);
  return e.concat(r || Array.prototype.slice.call(t));
}
function mS(e) {
  var t, n, r, a, i, o;
  function l(g) {
    o || (o = g), s(!0);
    var v = g - o;
    v > r && (v = r);
    var E = a[n];
    if (E[3] < v)
      return n++, l(g);
    var b = E[2], w = E[4], S = E[0], T = E[1] * (0, E[5])(w === 0 ? 1 : (v - b) / w);
    if (T && e.track.to(S + T), v < r)
      return f();
    o = null, s(!1), u(null), e.emit("animationEnded");
  }
  function s(g) {
    t.active = g;
  }
  function u(g) {
    t.targetIdx = g;
  }
  function f() {
    var g;
    g = l, i = window.requestAnimationFrame(g);
  }
  function h() {
    var g;
    g = i, window.cancelAnimationFrame(g), s(!1), u(null), o && e.emit("animationStopped"), o = null;
  }
  return t = { active: !1, start: function(g) {
    if (h(), e.track.details) {
      var v = 0, E = e.track.details.position;
      n = 0, r = 0, a = g.map(function(b) {
        var w, S = Number(E), T = (w = b.earlyExit) !== null && w !== void 0 ? w : b.duration, A = b.easing, V = b.distance * A(T / b.duration) || 0;
        E += V;
        var $ = r;
        return r += T, v += V, [S, b.distance, $, r, b.duration, A];
      }), u(e.track.distToIdx(v)), f(), e.emit("animationStarted");
    }
  }, stop: h, targetIdx: null };
}
function gS(e) {
  var t, n, r, a, i, o, l, s, u, f, h, g, v, E, b = 1 / 0, w = [], S = null, T = 0;
  function A(P) {
    O(T + P);
  }
  function V(P) {
    var N = $(T + P).abs;
    return c(N) ? N : null;
  }
  function $(P) {
    var N = Math.floor(Math.abs(xt(P / n))), D = xt((P % n + n) % n);
    D === n && (D = 0);
    var I = Ot(P), C = l.indexOf(nm([], l, !0).reduce(function(k, M) {
      return Math.abs(M - D) < Math.abs(k - D) ? M : k;
    })), L = C;
    return I < 0 && N++, C === o && (L = 0, N += I > 0 ? 1 : -1), { abs: L + N * o * I, origin: C, rel: L };
  }
  function _(P, N, D) {
    var I;
    if (N || !d())
      return y(P, D);
    if (!c(P))
      return null;
    var C = $(D ?? T), L = C.abs, k = P - C.rel, M = L + k;
    I = y(M);
    var F = y(M - o * Ot(k));
    return (F !== null && Math.abs(F) < Math.abs(I) || I === null) && (I = F), xt(I);
  }
  function y(P, N) {
    if (N == null && (N = xt(T)), !c(P) || P === null)
      return null;
    P = Math.round(P);
    var D = $(N), I = D.abs, C = D.rel, L = D.origin, k = m(P), M = (N % n + n) % n, F = l[L], j = Math.floor((P - (I - C)) / o) * n;
    return xt(F - M - F + l[k] + j + (L === o ? n : 0));
  }
  function c(P) {
    return p(P) === P;
  }
  function p(P) {
    return Wc(P, u, f);
  }
  function d() {
    return a.loop;
  }
  function m(P) {
    return (P % o + o) % o;
  }
  function O(P) {
    var N;
    N = P - T, w.push({ distance: N, timestamp: _f() }), w.length > 6 && (w = w.slice(-6)), T = xt(P);
    var D = x().abs;
    if (D !== S) {
      var I = S !== null;
      S = D, I && e.emit("slideChanged");
    }
  }
  function x(P) {
    var N = P ? null : function() {
      if (o) {
        var D = d(), I = D ? (T % n + n) % n : T, C = (D ? T % n : T) - i[0][2], L = 0 - (C < 0 && D ? n - Math.abs(C) : C), k = 0, M = $(T), F = M.abs, j = M.rel, U = i[j][2], G = i.map(function(X, W) {
          var q = L + k;
          (q < 0 - X[0] || q > 1) && (q += (Math.abs(q) > n - 1 && D ? n : 0) * Ot(-q));
          var ee = W - j, te = Ot(ee), le = ee + F;
          D && (te === -1 && q > U && (le += o), te === 1 && q < U && (le -= o), h !== null && le < h && (q += n), g !== null && le > g && (q -= n));
          var Y = q + X[0] + X[1], ye = Math.max(q >= 0 && Y <= 1 ? 1 : Y < 0 || q > 1 ? 0 : q < 0 ? Math.min(1, (X[0] + q) / X[0]) : (1 - q) / X[0], 0);
          return k += X[0] + X[1], { abs: le, distance: a.rtl ? -1 * q + 1 - X[0] : q, portion: ye, size: X[0] };
        });
        return F = p(F), j = m(F), { abs: p(F), length: r, max: E, maxIdx: f, min: v, minIdx: u, position: T, progress: D ? I / n : T / r, rel: j, slides: G, slidesLength: n };
      }
    }();
    return t.details = N, e.emit("detailsChanged"), N;
  }
  return t = { absToRel: m, add: A, details: null, distToIdx: V, idxToDist: _, init: function(P) {
    if (function() {
      if (a = e.options, i = (a.trackConfig || []).map(function(C) {
        return [ot(C, "size", 1), ot(C, "spacing", 0), ot(C, "origin", 0)];
      }), o = i.length) {
        n = xt(i.reduce(function(C, L) {
          return C + L[0] + L[1];
        }, 0));
        var D, I = o - 1;
        r = xt(n + i[0][2] - i[I][0] - i[I][2] - i[I][1]), l = i.reduce(function(C, L) {
          if (!C)
            return [0];
          var k = i[C.length - 1], M = C[C.length - 1] + (k[0] + k[2]) + k[1];
          return M -= L[2], C[C.length - 1] > M && (M = C[C.length - 1]), M = xt(M), C.push(M), (!D || D < M) && (s = C.length - 1), D = M, C;
        }, null), r === 0 && (s = 0), l.push(xt(n));
      }
    }(), !o)
      return x(!0);
    var N;
    (function() {
      var D = e.options.range, I = e.options.loop;
      h = u = I ? ot(I, "min", -1 / 0) : 0, g = f = I ? ot(I, "max", b) : s;
      var C = ot(D, "min", null), L = ot(D, "max", null);
      C !== null && (u = C), L !== null && (f = L), v = u === -1 / 0 ? u : e.track.idxToDist(u || 0, !0, 0), E = f === b ? f : _(f, !0, 0), L === null && (g = f), ot(D, "align", !1) && f !== b && i[m(f)][2] === 0 && (E -= 1 - i[m(f)][0], f = V(E - T)), v = xt(v), E = xt(E);
    })(), N = P, Number(N) === N ? A(y(p(P))) : x();
  }, to: O, velocity: function() {
    var P = _f(), N = w.reduce(function(D, I) {
      var C = I.distance, L = I.timestamp;
      return P - L > 200 || (Ot(C) !== Ot(D.distance) && D.distance && (D = { distance: 0, lastTimestamp: 0, time: 0 }), D.time && (D.distance += C), D.lastTimestamp && (D.time += L - D.lastTimestamp), D.lastTimestamp = L), D;
    }, { distance: 0, lastTimestamp: 0, time: 0 });
    return N.distance / N.time || 0;
  } };
}
function yS(e) {
  var t, n, r, a, i, o, l, s;
  function u(S) {
    return 2 * S;
  }
  function f(S) {
    return Wc(S, l, s);
  }
  function h(S) {
    return 1 - Math.pow(1 - S, 3);
  }
  function g() {
    return r ? e.track.velocity() : 0;
  }
  function v() {
    w();
    var S = e.options.mode === "free-snap", T = e.track, A = g();
    a = Ot(A);
    var V = e.track.details, $ = [];
    if (A || !S) {
      var _ = E(A), y = _.dist, c = _.dur;
      if (c = u(c), y *= a, S) {
        var p = T.idxToDist(T.distToIdx(y), !0);
        p && (y = p);
      }
      $.push({ distance: y, duration: c, easing: h });
      var d = V.position, m = d + y;
      if (m < i || m > o) {
        var O = m < i ? i - d : o - d, x = 0, P = A;
        if (Ot(O) === a) {
          var N = Math.min(Math.abs(O) / Math.abs(y), 1), D = function(L) {
            return 1 - Math.pow(1 - L, 1 / 3);
          }(N) * c;
          $[0].earlyExit = D, P = A * (1 - N);
        } else
          $[0].earlyExit = 0, x += O;
        var I = E(P, 100), C = I.dist * a;
        e.options.rubberband && ($.push({ distance: C, duration: u(I.dur), easing: h }), $.push({ distance: -C + x, duration: 500, easing: h }));
      }
      e.animator.start($);
    } else
      e.moveToIdx(f(V.abs), !0, { duration: 500, easing: function(L) {
        return 1 + --L * L * L * L * L;
      } });
  }
  function E(S, T) {
    T === void 0 && (T = 1e3);
    var A = 147e-9 + (S = Math.abs(S)) / T;
    return { dist: Math.pow(S, 2) / A, dur: S / A };
  }
  function b() {
    var S = e.track.details;
    S && (i = S.min, o = S.max, l = S.minIdx, s = S.maxIdx);
  }
  function w() {
    e.animator.stop();
  }
  e.on("updated", b), e.on("optionsChanged", b), e.on("created", b), e.on("dragStarted", function() {
    r = !1, w(), t = n = e.track.details.abs;
  }), e.on("dragChecked", function() {
    r = !0;
  }), e.on("dragEnded", function() {
    var S = e.options.mode;
    S === "snap" && function() {
      var T = e.track, A = e.track.details, V = A.position, $ = Ot(g());
      (V > o || V < i) && ($ = 0);
      var _ = t + $;
      A.slides[T.absToRel(_)].portion === 0 && (_ -= $), t !== n && (_ = n), Ot(T.idxToDist(_, !0)) !== $ && (_ += $), _ = f(_);
      var y = T.idxToDist(_, !0);
      e.animator.start([{ distance: y, duration: 500, easing: function(c) {
        return 1 + --c * c * c * c * c;
      } }]);
    }(), S !== "free" && S !== "free-snap" || v();
  }), e.on("dragged", function() {
    n = e.track.details.abs;
  });
}
function bS(e) {
  var t, n, r, a, i, o, l, s, u, f, h, g, v, E, b, w, S, T, A = em();
  function V(x) {
    if (o && s === x.id) {
      var P = c(x);
      if (u) {
        if (!y(x))
          return _(x);
        f = P, u = !1, e.emit("dragChecked");
      }
      if (w)
        return f = P;
      Dr(x);
      var N = function(I) {
        if (S === -1 / 0 && T === 1 / 0)
          return I;
        var C = e.track.details, L = C.length, k = C.position, M = Wc(I, S - k, T - k);
        if (L === 0)
          return 0;
        if (!e.options.rubberband)
          return M;
        if (k <= T && k >= S || k < S && n > 0 || k > T && n < 0)
          return I;
        var F = (k < S ? k - S : k - T) / L, j = a * L, U = Math.abs(F * j), G = Math.max(0, 1 - U / i * 2);
        return G * G * I;
      }(l(f - P) / a * r);
      n = Ot(N);
      var D = e.track.details.position;
      (D > S && D < T || D === S && n > 0 || D === T && n < 0) && Nr(x), h += N, !g && Math.abs(h * a) > 5 && (g = !0), e.track.add(N), f = P, e.emit("dragged");
    }
  }
  function $(x) {
    !o && e.track.details && e.track.details.length && (h = 0, o = !0, g = !1, u = !0, s = x.id, y(x), f = c(x), e.emit("dragStarted"));
  }
  function _(x) {
    o && s === x.idChanged && (o = !1, e.emit("dragEnded"));
  }
  function y(x) {
    var P = p(), N = P ? x.y : x.x, D = P ? x.x : x.y, I = v !== void 0 && E !== void 0 && Math.abs(E - D) <= Math.abs(v - N);
    return v = N, E = D, I;
  }
  function c(x) {
    return p() ? x.y : x.x;
  }
  function p() {
    return e.options.vertical;
  }
  function d() {
    a = e.size, i = p() ? window.innerHeight : window.innerWidth;
    var x = e.track.details;
    x && (S = x.min, T = x.max);
  }
  function m(x) {
    g && (Nr(x), Dr(x));
  }
  function O() {
    if (A.purge(), e.options.drag && !e.options.disabled) {
      var x;
      x = e.options.dragSpeed || 1, l = typeof x == "function" ? x : function(N) {
        return N * x;
      }, r = e.options.rtl ? -1 : 1, d(), t = e.container, function() {
        var N = "data-keen-slider-clickable";
        wi("[".concat(N, "]:not([").concat(N, "=false])"), t).map(function(D) {
          A.add(D, "dragstart", Nr), A.add(D, "mousedown", Nr), A.add(D, "touchstart", Nr);
        });
      }(), A.add(t, "dragstart", function(N) {
        Dr(N);
      }), A.add(t, "click", m, { capture: !0 }), A.input(t, "ksDragStart", $), A.input(t, "ksDrag", V), A.input(t, "ksDragEnd", _), A.input(t, "mousedown", $), A.input(t, "mousemove", V), A.input(t, "mouseleave", _), A.input(t, "mouseup", _), A.input(t, "touchstart", $, { passive: !0 }), A.input(t, "touchmove", V, { passive: !1 }), A.input(t, "touchend", _), A.input(t, "touchcancel", _), A.add(window, "wheel", function(N) {
        o && Dr(N);
      });
      var P = "data-keen-slider-scrollable";
      wi("[".concat(P, "]:not([").concat(P, "=false])"), e.container).map(function(N) {
        return function(D) {
          var I;
          A.input(D, "touchstart", function(C) {
            I = c(C), w = !0, b = !0;
          }, { passive: !0 }), A.input(D, "touchmove", function(C) {
            var L = p(), k = L ? D.scrollHeight - D.clientHeight : D.scrollWidth - D.clientWidth, M = I - c(C), F = L ? D.scrollTop : D.scrollLeft, j = L && D.style.overflowY === "scroll" || !L && D.style.overflowX === "scroll";
            if (I = c(C), (M < 0 && F > 0 || M > 0 && F < k) && b && j)
              return w = !0;
            b = !1, Dr(C), w = !1;
          }), A.input(D, "touchend", function() {
            w = !1;
          });
        }(N);
      });
    }
  }
  e.on("updated", d), e.on("optionsChanged", O), e.on("created", O), e.on("destroyed", A.purge);
}
function wS(e) {
  var t, n, r = null;
  function a(v, E, b) {
    e.animator.active ? o(v, E, b) : requestAnimationFrame(function() {
      return o(v, E, b);
    });
  }
  function i() {
    a(!1, !1, n);
  }
  function o(v, E, b) {
    var w = 0, S = e.size, T = e.track.details;
    if (T && t) {
      var A = T.slides;
      t.forEach(function(V, $) {
        if (v)
          !r && E && s(V, null, b), u(V, null, b);
        else {
          if (!A[$])
            return;
          var _ = A[$].size * S;
          !r && E && s(V, _, b), u(V, A[$].distance * S - w, b), w += _;
        }
      });
    }
  }
  function l(v) {
    return e.options.renderMode === "performance" ? Math.round(v) : v;
  }
  function s(v, E, b) {
    var w = b ? "height" : "width";
    E !== null && (E = l(E) + "px"), v.style["min-" + w] = E, v.style["max-" + w] = E;
  }
  function u(v, E, b) {
    if (E !== null) {
      E = l(E);
      var w = b ? E : 0;
      E = "translate3d(".concat(b ? 0 : E, "px, ").concat(w, "px, 0)");
    }
    v.style.transform = E, v.style["-webkit-transform"] = E;
  }
  function f() {
    t && (o(!0, !0, n), t = null), e.on("detailsChanged", i, !0);
  }
  function h() {
    a(!1, !0, n);
  }
  function g() {
    f(), n = e.options.vertical, e.options.disabled || e.options.renderMode === "custom" || (r = ot(e.options.slides, "perView", null) === "auto", e.on("detailsChanged", i), (t = e.slides).length && h());
  }
  e.on("created", g), e.on("optionsChanged", g), e.on("beforeOptionsChanged", function() {
    f();
  }), e.on("updated", h), e.on("destroyed", f);
}
function xS(e, t) {
  return function(n) {
    var r, a, i, o, l, s = em();
    function u(y) {
      var c;
      os(n.container, "reverse", (c = n.container, window.getComputedStyle(c, null).getPropertyValue("direction") !== "rtl" || y ? null : "")), os(n.container, "v", n.options.vertical && !y ? "" : null), os(n.container, "disabled", n.options.disabled && !y ? "" : null);
    }
    function f() {
      h() && w();
    }
    function h() {
      var y = null;
      if (o.forEach(function(p) {
        p.matches && (y = p.__media);
      }), y === r)
        return !1;
      r || n.emit("beforeOptionsChanged"), r = y;
      var c = y ? i.breakpoints[y] : i;
      return n.options = sr(sr({}, i), c), u(), $(), _(), T(), !0;
    }
    function g(y) {
      var c = Lf(y);
      return (n.options.vertical ? c.height : c.width) / n.size || 1;
    }
    function v() {
      return n.options.trackConfig.length;
    }
    function E(y) {
      for (var c in r = !1, i = sr(sr({}, t), y), s.purge(), a = n.size, o = [], i.breakpoints || []) {
        var p = window.matchMedia(c);
        p.__media = c, o.push(p), s.add(p, "change", f);
      }
      s.add(window, "orientationchange", V), s.add(window, "resize", A), h();
    }
    function b(y) {
      n.animator.stop();
      var c = n.track.details;
      n.track.init(y ?? (c ? c.abs : 0));
    }
    function w(y) {
      b(y), n.emit("optionsChanged");
    }
    function S(y, c) {
      if (y)
        return E(y), void w(c);
      $(), _();
      var p = v();
      T(), v() !== p ? w(c) : b(c), n.emit("updated");
    }
    function T() {
      var y = n.options.slides;
      if (typeof y == "function")
        return n.options.trackConfig = y(n.size, n.slides);
      for (var c = n.slides, p = c.length, d = typeof y == "number" ? y : ot(y, "number", p, !0), m = [], O = ot(y, "perView", 1, !0), x = ot(y, "spacing", 0, !0) / n.size || 0, P = O === "auto" ? x : x / O, N = ot(y, "origin", "auto"), D = 0, I = 0; I < d; I++) {
        var C = O === "auto" ? g(c[I]) : 1 / O - x + P, L = N === "center" ? 0.5 - C / 2 : N === "auto" ? 0 : N;
        m.push({ origin: L, size: C, spacing: x }), D += C;
      }
      if (D += x * (d - 1), N === "auto" && !n.options.loop && O !== 1) {
        var k = 0;
        m.map(function(M) {
          var F = D - k;
          return k += M.size + x, F >= 1 || (M.origin = 1 - F - (D > 1 ? 0 : 1 - D)), M;
        });
      }
      n.options.trackConfig = m;
    }
    function A() {
      $();
      var y = n.size;
      n.options.disabled || y === a || (a = y, S());
    }
    function V() {
      A(), setTimeout(A, 500), setTimeout(A, 2e3);
    }
    function $() {
      var y = Lf(n.container);
      n.size = (n.options.vertical ? y.height : y.width) || 1;
    }
    function _() {
      n.slides = wi(n.options.selector, n.container);
    }
    n.container = (l = wi(e, document)).length ? l[0] : null, n.destroy = function() {
      s.purge(), n.emit("destroyed"), u(!0);
    }, n.prev = function() {
      n.moveToIdx(n.track.details.abs - 1, !0);
    }, n.next = function() {
      n.moveToIdx(n.track.details.abs + 1, !0);
    }, n.update = S, E(n.options);
  };
}
var ES = function(e, t, n) {
  try {
    return function(r, a) {
      var i, o = {};
      return i = { emit: function(l) {
        o[l] && o[l].forEach(function(u) {
          u(i);
        });
        var s = i.options && i.options[l];
        s && s(i);
      }, moveToIdx: function(l, s, u) {
        var f = i.track.idxToDist(l, s);
        if (f) {
          var h = i.options.defaultAnimation;
          i.animator.start([{ distance: f, duration: ot(u || h, "duration", 500), easing: ot(u || h, "easing", function(g) {
            return 1 + --g * g * g * g * g;
          }) }]);
        }
      }, on: function(l, s, u) {
        u === void 0 && (u = !1), o[l] || (o[l] = []);
        var f = o[l].indexOf(s);
        f > -1 ? u && delete o[l][f] : u || o[l].push(s);
      }, options: r }, function() {
        if (i.track = gS(i), i.animator = mS(i), a)
          for (var l = 0, s = a; l < s.length; l++)
            (0, s[l])(i);
        i.track.init(i.options.initial || 0), i.emit("created");
      }(), i;
    }(t, nm([xS(e, { drag: !0, mode: "snap", renderMode: "precision", rubberband: !0, selector: ".keen-slider__slide" }), wS, bS, yS], n || [], !0));
  } catch (r) {
    console.error(r);
  }
}, $S = Qv.useKeenSlider = function(e, t) {
  var n = Ir.useRef(null), r = Ir.useRef(!1), a = Ir.useRef(e), i = Ir.useCallback(function(o) {
    o ? (a.current = e, n.current = new ES(o, e, t), r.current = !1) : (n.current && n.current.destroy && n.current.destroy(), n.current = null);
  }, []);
  return Ir.useEffect(function() {
    tm(a.current, e) || (a.current = e, n.current && n.current.update(a.current));
  }, [e]), [i, n];
};
const PS = {
  md: "768px",
  lg: "1024px",
  xl: "1264px"
}, CS = typeof window > "u" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent), rm = !CS, SS = rm ? na : re;
function kS(e) {
  if (!e)
    throw new Error(
      "Failed to create breakpoint hooks, given `screens` value is invalid."
    );
  function t(a, i = !1) {
    const [o, l] = ue.useState(() => i), s = ue.useRef(i);
    return SS(() => {
      if (!(rm && "matchMedia" in window))
        return;
      function u() {
        const f = (e == null ? void 0 : e[a]) ?? "999999px", h = window.matchMedia(`(min-width: ${f})`);
        s.current = h.matches, s.current !== o && l(s.current);
      }
      return window.addEventListener("resize", u), () => window.removeEventListener("resize", u);
    }), o;
  }
  function n(a, i) {
    const o = t(a);
    return ue.useEffect(() => i(o)), null;
  }
  function r(a, i, o) {
    const l = t(a);
    return ue.useMemo(
      () => l ? i : o,
      [o, l, i]
    );
  }
  return {
    useBreakpoint: t,
    useBreakpointEffect: n,
    useBreakpointValue: r
  };
}
const { useBreakpoint: ls } = kS(PS), TS = () => {
  const e = ls("md"), t = ls("lg"), n = ls("xl"), [r, a] = ue.useState("base");
  return re(() => {
    !e && !t && !n && a("base"), e && !t && !n && a("md"), e && t && !n && a("lg"), e && t && n && a("xl");
  }, [e, t, n]), re(() => {
    window.dispatchEvent(new Event("resize"));
  }, []), {
    current: r,
    md: e,
    lg: t,
    xl: n
  };
}, AS = () => {
  const [e, t] = ne("ltr"), [n, r] = ne(!1);
  return re(() => {
    const a = () => {
      const o = document.dir !== "" ? document.dir : "ltr";
      t(o), r(o === "rtl");
    };
    a();
    const i = new MutationObserver((o) => {
      o.forEach((l) => {
        l.type === "attributes" && l.attributeName === "dir" && a();
      });
    });
    return i.observe(document.documentElement, { attributes: !0 }), () => i.disconnect();
  }, []), { isRTL: n, direction: e };
};
function OS(e, t) {
  const [n, r] = ne(e);
  return re(() => {
    const a = setTimeout(() => r(e), t || 500);
    return () => {
      clearTimeout(a);
    };
  }, [e, t]), n;
}
const zS = de(
  "gudl-icon-button group relative flex items-center outline-none justify-center rounded-full disabled:pointer-events-none",
  {
    variants: {
      /**
       * The size of the icon button.
       */
      size: {
        xs: "w-8 h-8",
        sm: "w-12 h-12",
        md: "w-14 h-14",
        lg: "w-[72px] h-[72px]"
      }
    },
    defaultVariants: {
      size: "md"
    }
  }
), MS = de(
  "inline-flex items-center relative z-auto transition-colors duration-300 ease-expressive",
  {
    variants: {
      /**
       * The intent of the icon button.
       */
      intent: {
        "primary-accessible-blue": "text-white group-disabled:text-white",
        "primary-black": "text-white group-disabled:text-white",
        "primary-white": "text-black group-disabled:text-neutral-500",
        "secondary-accessible-blue": "text-brand-accessible-blue group-disabled:text-neutral-400",
        "secondary-black": "text-black group-disabled:text-neutral-500",
        "secondary-white": "text-white group-disabled:text-neutral-500",
        "tertiary-accessible-blue": "text-brand-accessible-blue group-disabled:text-neutral-500",
        "tertiary-black": "text-black group-disabled:text-neutral-500",
        "tertiary-white": "text-white group-disabled:text-neutral-500"
      },
      // CVA Typing
      isPressed: {
        true: []
      }
    },
    compoundVariants: [
      {
        isPressed: !0,
        intent: "primary-black",
        className: "text-neutral-400"
      }
    ],
    defaultVariants: {
      intent: "primary-accessible-blue"
    }
  }
), _S = de(
  "absolute inset-0 z-auto rounded-full ease-expressive duration-300 transition-all border border-transparent ring-2 ring-offset-2 ring-transparent ring-offset-transparent",
  {
    variants: {
      intent: {
        "primary-accessible-blue": "bg-brand-accessible-blue group-disabled:bg-neutral-400",
        "primary-black": "bg-black group-disabled:bg-neutral-500",
        "primary-white": "bg-white group-disabled:bg-neutral-200",
        "secondary-accessible-blue": "border-brand-accessible-blue group-disabled:border-neutral-400",
        "secondary-black": "border-black group-disabled:border-neutral-500",
        "secondary-white": "border-white group-disabled:border-neutral-500",
        "tertiary-accessible-blue": "group-hover:bg-info-lighter ring-offset-0",
        "tertiary-black": "group-hover:bg-neutral-50 ring-offset-0",
        "tertiary-white": "group-hover:bg-neutral-700 ring-offset-0"
      },
      size: {
        xs: "motion-safe:group-hover:scale-[1.11]",
        sm: "motion-safe:group-hover:scale-[1.09]",
        md: "motion-safe:group-hover:scale-[1.10]",
        lg: "motion-safe:group-hover:scale-[1.10]"
      },
      touchActivated: {
        true: "motion-safe:group-active:scale-[0.95]"
      },
      pointerActivated: {
        true: "motion-safe:group-active:scale-[1]"
      },
      isFocusVisible: {
        true: "ring-offset-white ring-brand-accessible-blue"
      },
      // CVA Typing
      isPressed: {
        true: []
      }
    },
    compoundVariants: [
      {
        isPressed: !0,
        intent: "primary-accessible-blue",
        className: "bg-info-dark"
      },
      {
        isPressed: !0,
        intent: "primary-white",
        className: "bg-neutral-200"
      },
      {
        isPressed: !0,
        intent: "secondary-accessible-blue",
        className: "bg-info-lighter"
      },
      {
        isPressed: !0,
        intent: "secondary-black",
        className: "bg-neutral-100"
      },
      {
        isPressed: !0,
        intent: "secondary-white",
        className: "bg-neutral-600"
      },
      {
        isPressed: !0,
        intent: "tertiary-accessible-blue",
        className: "bg-info-light"
      },
      {
        isPressed: !0,
        intent: "tertiary-black",
        className: "bg-neutral-100"
      },
      {
        isPressed: !0,
        intent: "tertiary-white",
        className: "bg-neutral-600"
      }
    ],
    defaultVariants: {
      intent: "primary-accessible-blue",
      size: "md",
      touchActivated: !1,
      pointerActivated: !1
    }
  }
), dr = ({
  "aria-label": e,
  intent: t = "primary-black",
  size: n = "md",
  isDisabled: r = !1,
  onPress: a,
  href: i,
  target: o,
  iconName: l,
  flipIconOnRtl: s = !0,
  className: u,
  backgroundClassName: f,
  contentClassName: h,
  ...g
}) => {
  const [v, E] = ne(!1), [b, w] = ne(!1), S = (c) => {
    c.pointerType === "mouse" ? (w(!0), E(!1)) : (w(!1), E(!0));
  }, T = J(null), { buttonProps: A, isPressed: V } = Fi(
    {
      elementType: i ? "a" : "button",
      isDisabled: r,
      onPress: a,
      href: i,
      target: o,
      onPressStart: S,
      ...g
    },
    T
  ), { focusProps: $, isFocusVisible: _ } = vr();
  return /* @__PURE__ */ ie(
    i ? "a" : "button",
    {
      className: ae(
        zS({
          size: n
        }),
        u
      ),
      ...A,
      ref: i ? null : T,
      "data-cy": "gudl-icon-button",
      role: "button",
      "aria-label": e,
      "aria-disabled": r,
      ...$,
      children: [
        /* @__PURE__ */ H(
          "div",
          {
            className: ae(
              _S({
                intent: t,
                size: n,
                touchActivated: v,
                pointerActivated: b,
                isFocusVisible: _,
                isPressed: V
              }),
              f
            ),
            "data-cy": "gudl-icon-button-background"
          }
        ),
        /* @__PURE__ */ H(
          "span",
          {
            className: ae(
              MS({
                intent: t
              }),
              h
            ),
            "data-cy": "gudl-icon-button-content",
            children: /* @__PURE__ */ H(Le, { iconName: l, size: "sm", flipIconOnRtl: s })
          }
        )
      ]
    }
  );
};
function LS(e) {
  let t = 0;
  for (let n = 0; n < e.length; n++)
    typeof e[n] == "number" ? t = e[n] : e[n] = t;
  return {
    base: e[0] ? e[0] : 0,
    md: e[1] ? e[1] : 0,
    lg: e[2] ? e[2] : 0,
    xl: e[3] ? e[3] : 0
  };
}
const eN = ({
  children: e,
  "aria-label": t = "Carousel",
  withOverhang: n = !1,
  slidesPerPageBase: r,
  slidesPerPageMd: a,
  slidesPerPageLg: i,
  slidesPerPageXl: o,
  gap: l = 4,
  initialSlide: s = 0,
  overflow: u = !1,
  className: f,
  overlayControls: h = !1,
  paginate: g = "false"
}) => {
  const v = TS(), { isRTL: E } = AS();
  if (re(() => {
    var x;
    (x = window.EFClickMapActivator) == null || x.init();
  }, []), typeof e != "object")
    throw new Error("Incorrect children type for Carousel");
  const w = (Array.isArray(e) ? e : [e]).filter(pn), S = LS([
    r,
    a,
    i,
    o
  ]), [T, A] = ne(!1), [V, $] = ne(s), _ = n ? 0.15 : 0, [y, c] = $S(
    {
      selector: ".gudl-carousel-item",
      initial: s,
      slideChanged(x) {
        $(x.track.details.rel);
      },
      slides: {
        spacing: l * 4,
        perView: S[v.current] !== 0 ? S[v.current] + _ : "auto"
      },
      rtl: E,
      created() {
        setTimeout(() => {
          A(!0);
        }, 200);
      }
    },
    []
  );
  function p(x) {
    switch (x.key) {
      default:
        break;
      case "Left":
      case "ArrowLeft":
        c.current && c.current.prev();
        break;
      case "Right":
      case "ArrowRight":
        c.current && c.current.next();
        break;
    }
  }
  re(() => {
    c.current && (c.current.container.setAttribute("tabindex", "0"), c.current.container.addEventListener("keydown", p));
  }), re(() => {
    var x;
    (x = c.current) == null || x.update();
  }, [e]);
  const d = () => {
    var x, P;
    if (!g)
      (x = c.current) == null || x.next();
    else {
      const N = He.count(w) - S[v.current];
      let D = V + S[v.current];
      D > N && (D = N), (P = c.current) == null || P.moveToIdx(D);
    }
  }, m = () => {
    var x, P;
    if (!g)
      (x = c.current) == null || x.prev();
    else {
      let N = V - S[v.current];
      N < 0 && (N = 0), (P = c.current) == null || P.moveToIdx(N);
    }
  }, O = (x, P, N) => x === Math.ceil(P / N - 1) && P % N !== 0 ? Math.floor(x * N) + Math.floor(P % N) - N : Math.floor(x * N);
  return /* @__PURE__ */ ie(De, { children: [
    /* @__PURE__ */ ie(
      "div",
      {
        className: ae(
          "ring-brand-accessible-blue relative ring-offset-1 transition-opacity focus:ring-2",
          !T && "max-h-0 overflow-hidden",
          // Save ourselves from a fouc if content takes too long to be styled
          f
        ),
        role: "region",
        "aria-label": t,
        "data-cy": "gudl-carousel",
        children: [
          /* @__PURE__ */ H(
            "div",
            {
              ref: y,
              className: ae(
                "keen-slider outline-none !ring-0",
                u && "!overflow-visible"
              ),
              "data-cy": "gudl-carousel-content",
              children: He.map(
                w,
                (x, P) => pn(x) && /* @__PURE__ */ H("div", { className: "gudl-carousel-item [&>*]:h-full [&>*]:max-h-full [&>*]:w-full [&>*]:max-w-full", children: en(x) })
              )
            }
          ),
          T && c.current && He.count(w) > S[v.current] && /* @__PURE__ */ ie(
            "div",
            {
              className: ae(
                "mt-4 flex flex-row-reverse items-center justify-between gap-4 md:mt-6 lg:mt-8",
                h && "absolute bottom-4 end-4 start-4"
              ),
              "aria-hidden": !0,
              children: [
                /* @__PURE__ */ ie("div", { className: "flex gap-2 place-self-end", children: [
                  /* @__PURE__ */ H(
                    dr,
                    {
                      iconName: "ArrowLeft",
                      size: "sm",
                      "aria-label": "Previous",
                      intent: h ? "primary-white" : "tertiary-black",
                      isDisabled: V === 0,
                      "data-info": "previous",
                      "data-clicklabel": "",
                      onPress: m
                    }
                  ),
                  /* @__PURE__ */ H(
                    dr,
                    {
                      iconName: "ArrowRight",
                      size: "sm",
                      "aria-label": "Next",
                      intent: h ? "primary-white" : "tertiary-black",
                      isDisabled: V === He.count(w) - S[v.current],
                      "data-info": "next",
                      "data-clicklabel": "",
                      onPress: d
                    }
                  )
                ] }),
                S[v.current] !== 0 && /* @__PURE__ */ H(
                  "div",
                  {
                    className: ae(
                      "flex gap-1.5",
                      h && "h-12 items-center rounded-full bg-white px-[22px] shadow"
                    ),
                    children: [
                      ...Array(
                        g ? Math.ceil(
                          He.count(w) / S[v.current]
                        ) : He.count(w) - Math.floor(S[v.current]) + 1
                      ).keys()
                    ].map((x) => /* @__PURE__ */ H(
                      "button",
                      {
                        onClick: () => {
                          var P;
                          (P = c.current) == null || P.moveToIdx(
                            g ? O(
                              x,
                              He.count(w),
                              S[v.current]
                            ) : x
                          );
                        },
                        className: ae(
                          "h-1 w-1 rounded-full bg-black transition-all delay-100",
                          !g && x === V && "w-4",
                          g && x === Math.ceil(
                            V / S[v.current]
                          ) && "w-4"
                        ),
                        "data-cy": "gudl-carousel-indicator"
                      },
                      x
                    ))
                  }
                )
              ]
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ H("noscript", { children: /* @__PURE__ */ H("div", { className: "grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3", children: w }) })
  ] });
};
class At extends Set {
  constructor(t, n, r) {
    super(t), t instanceof At ? (this.anchorKey = n || t.anchorKey, this.currentKey = r || t.currentKey) : (this.anchorKey = n, this.currentKey = r);
  }
}
function IS(e, t) {
  if (e.size !== t.size)
    return !1;
  for (let n of e)
    if (!t.has(n))
      return !1;
  return !0;
}
function DS(e) {
  let { selectionMode: t = "none", disallowEmptySelection: n, allowDuplicateSelectionEvents: r, selectionBehavior: a = "toggle", disabledBehavior: i = "all" } = e, o = J(!1), [, l] = ne(!1), s = J(null), u = J(null), [, f] = ne(null), h = ge(() => If(e.selectedKeys), [
    e.selectedKeys
  ]), g = ge(() => If(e.defaultSelectedKeys, new At()), [
    e.defaultSelectedKeys
  ]), [v, E] = Bn(h, g, e.onSelectionChange), b = ge(() => e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set(), [
    e.disabledKeys
  ]), [w, S] = ne(a);
  a === "replace" && w === "toggle" && typeof v == "object" && v.size === 0 && S("replace");
  let T = J(a);
  return re(() => {
    a !== T.current && (S(a), T.current = a);
  }, [
    a
  ]), {
    selectionMode: t,
    disallowEmptySelection: n,
    selectionBehavior: w,
    setSelectionBehavior: S,
    get isFocused() {
      return o.current;
    },
    setFocused(A) {
      o.current = A, l(A);
    },
    get focusedKey() {
      return s.current;
    },
    get childFocusStrategy() {
      return u.current;
    },
    setFocusedKey(A, V = "first") {
      s.current = A, u.current = V, f(A);
    },
    selectedKeys: v,
    setSelectedKeys(A) {
      (r || !IS(A, v)) && E(A);
    },
    disabledKeys: b,
    disabledBehavior: i
  };
}
function If(e, t) {
  return e ? e === "all" ? "all" : new At(e) : t;
}
class NS {
  /**
  * The type of selection that is allowed in the collection.
  */
  get selectionMode() {
    return this.state.selectionMode;
  }
  /**
  * Whether the collection allows empty selection.
  */
  get disallowEmptySelection() {
    return this.state.disallowEmptySelection;
  }
  /**
  * The selection behavior for the collection.
  */
  get selectionBehavior() {
    return this.state.selectionBehavior;
  }
  /**
  * Sets the selection behavior for the collection.
  */
  setSelectionBehavior(t) {
    this.state.setSelectionBehavior(t);
  }
  /**
  * Whether the collection is currently focused.
  */
  get isFocused() {
    return this.state.isFocused;
  }
  /**
  * Sets whether the collection is focused.
  */
  setFocused(t) {
    this.state.setFocused(t);
  }
  /**
  * The current focused key in the collection.
  */
  get focusedKey() {
    return this.state.focusedKey;
  }
  /** Whether the first or last child of the focused key should receive focus. */
  get childFocusStrategy() {
    return this.state.childFocusStrategy;
  }
  /**
  * Sets the focused key.
  */
  setFocusedKey(t, n) {
    (t == null || this.collection.getItem(t)) && this.state.setFocusedKey(t, n);
  }
  /**
  * The currently selected keys in the collection.
  */
  get selectedKeys() {
    return this.state.selectedKeys === "all" ? new Set(this.getSelectAllKeys()) : this.state.selectedKeys;
  }
  /**
  * The raw selection value for the collection.
  * Either 'all' for select all, or a set of keys.
  */
  get rawSelection() {
    return this.state.selectedKeys;
  }
  /**
  * Returns whether a key is selected.
  */
  isSelected(t) {
    return this.state.selectionMode === "none" ? !1 : (t = this.getKey(t), this.state.selectedKeys === "all" ? this.canSelectItem(t) : this.state.selectedKeys.has(t));
  }
  /**
  * Whether the selection is empty.
  */
  get isEmpty() {
    return this.state.selectedKeys !== "all" && this.state.selectedKeys.size === 0;
  }
  /**
  * Whether all items in the collection are selected.
  */
  get isSelectAll() {
    if (this.isEmpty)
      return !1;
    if (this.state.selectedKeys === "all")
      return !0;
    if (this._isSelectAll != null)
      return this._isSelectAll;
    let t = this.getSelectAllKeys(), n = this.state.selectedKeys;
    return this._isSelectAll = t.every((r) => n.has(r)), this._isSelectAll;
  }
  get firstSelectedKey() {
    let t = null;
    for (let n of this.state.selectedKeys) {
      let r = this.collection.getItem(n);
      (!t || r && Do(this.collection, r, t) < 0) && (t = r);
    }
    return t == null ? void 0 : t.key;
  }
  get lastSelectedKey() {
    let t = null;
    for (let n of this.state.selectedKeys) {
      let r = this.collection.getItem(n);
      (!t || r && Do(this.collection, r, t) > 0) && (t = r);
    }
    return t == null ? void 0 : t.key;
  }
  get disabledKeys() {
    return this.state.disabledKeys;
  }
  get disabledBehavior() {
    return this.state.disabledBehavior;
  }
  /**
  * Extends the selection to the given key.
  */
  extendSelection(t) {
    if (this.selectionMode === "none")
      return;
    if (this.selectionMode === "single") {
      this.replaceSelection(t);
      return;
    }
    t = this.getKey(t);
    let n;
    if (this.state.selectedKeys === "all")
      n = new At([
        t
      ], t, t);
    else {
      let r = this.state.selectedKeys, a = r.anchorKey || t;
      n = new At(r, a, t);
      for (let i of this.getKeyRange(a, r.currentKey || t))
        n.delete(i);
      for (let i of this.getKeyRange(t, a))
        this.canSelectItem(i) && n.add(i);
    }
    this.state.setSelectedKeys(n);
  }
  getKeyRange(t, n) {
    let r = this.collection.getItem(t), a = this.collection.getItem(n);
    return r && a ? Do(this.collection, r, a) <= 0 ? this.getKeyRangeInternal(t, n) : this.getKeyRangeInternal(n, t) : [];
  }
  getKeyRangeInternal(t, n) {
    let r = [], a = t;
    for (; a; ) {
      let i = this.collection.getItem(a);
      if ((i && i.type === "item" || i.type === "cell" && this.allowsCellSelection) && r.push(a), a === n)
        return r;
      a = this.collection.getKeyAfter(a);
    }
    return [];
  }
  getKey(t) {
    let n = this.collection.getItem(t);
    if (!n || n.type === "cell" && this.allowsCellSelection)
      return t;
    for (; n.type !== "item" && n.parentKey != null; )
      n = this.collection.getItem(n.parentKey);
    return !n || n.type !== "item" ? null : n.key;
  }
  /**
  * Toggles whether the given key is selected.
  */
  toggleSelection(t) {
    if (this.selectionMode === "none")
      return;
    if (this.selectionMode === "single" && !this.isSelected(t)) {
      this.replaceSelection(t);
      return;
    }
    if (t = this.getKey(t), t == null)
      return;
    let n = new At(this.state.selectedKeys === "all" ? this.getSelectAllKeys() : this.state.selectedKeys);
    n.has(t) ? n.delete(t) : this.canSelectItem(t) && (n.add(t), n.anchorKey = t, n.currentKey = t), !(this.disallowEmptySelection && n.size === 0) && this.state.setSelectedKeys(n);
  }
  /**
  * Replaces the selection with only the given key.
  */
  replaceSelection(t) {
    if (this.selectionMode === "none" || (t = this.getKey(t), t == null))
      return;
    let n = this.canSelectItem(t) ? new At([
      t
    ], t, t) : new At();
    this.state.setSelectedKeys(n);
  }
  /**
  * Replaces the selection with the given keys.
  */
  setSelectedKeys(t) {
    if (this.selectionMode === "none")
      return;
    let n = new At();
    for (let r of t)
      if (r = this.getKey(r), r != null && (n.add(r), this.selectionMode === "single"))
        break;
    this.state.setSelectedKeys(n);
  }
  getSelectAllKeys() {
    let t = [], n = (r) => {
      for (; r; ) {
        if (this.canSelectItem(r)) {
          let a = this.collection.getItem(r);
          a.type === "item" && t.push(r), a.hasChildNodes && (this.allowsCellSelection || a.type !== "item") && n(F5(Ki(a, this.collection)).key);
        }
        r = this.collection.getKeyAfter(r);
      }
    };
    return n(this.collection.getFirstKey()), t;
  }
  /**
  * Selects all items in the collection.
  */
  selectAll() {
    !this.isSelectAll && this.selectionMode === "multiple" && this.state.setSelectedKeys("all");
  }
  /**
  * Removes all keys from the selection.
  */
  clearSelection() {
    !this.disallowEmptySelection && (this.state.selectedKeys === "all" || this.state.selectedKeys.size > 0) && this.state.setSelectedKeys(new At());
  }
  /**
  * Toggles between select all and an empty selection.
  */
  toggleSelectAll() {
    this.isSelectAll ? this.clearSelection() : this.selectAll();
  }
  select(t, n) {
    this.selectionMode !== "none" && (this.selectionMode === "single" ? this.isSelected(t) && !this.disallowEmptySelection ? this.toggleSelection(t) : this.replaceSelection(t) : this.selectionBehavior === "toggle" || n && (n.pointerType === "touch" || n.pointerType === "virtual") ? this.toggleSelection(t) : this.replaceSelection(t));
  }
  /**
  * Returns whether the current selection is equal to the given selection.
  */
  isSelectionEqual(t) {
    if (t === this.state.selectedKeys)
      return !0;
    let n = this.selectedKeys;
    if (t.size !== n.size)
      return !1;
    for (let r of t)
      if (!n.has(r))
        return !1;
    for (let r of n)
      if (!t.has(r))
        return !1;
    return !0;
  }
  canSelectItem(t) {
    if (this.state.selectionMode === "none" || this.state.disabledKeys.has(t))
      return !1;
    let n = this.collection.getItem(t);
    return !(!n || n.type === "cell" && !this.allowsCellSelection);
  }
  isDisabled(t) {
    return this.state.disabledKeys.has(t) && this.state.disabledBehavior === "all";
  }
  isLink(t) {
    var n, r;
    return !!(!((r = this.collection.getItem(t)) === null || r === void 0 || (n = r.props) === null || n === void 0) && n.href);
  }
  constructor(t, n, r) {
    this.collection = t, this.state = n;
    var a;
    this.allowsCellSelection = (a = r == null ? void 0 : r.allowsCellSelection) !== null && a !== void 0 ? a : !1, this._isSelectAll = null;
  }
}
class lc {
  *[Symbol.iterator]() {
    yield* this.iterable;
  }
  get size() {
    return this.keyMap.size;
  }
  getKeys() {
    return this.keyMap.keys();
  }
  getKeyBefore(t) {
    let n = this.keyMap.get(t);
    return n ? n.prevKey : null;
  }
  getKeyAfter(t) {
    let n = this.keyMap.get(t);
    return n ? n.nextKey : null;
  }
  getFirstKey() {
    return this.firstKey;
  }
  getLastKey() {
    return this.lastKey;
  }
  getItem(t) {
    return this.keyMap.get(t);
  }
  at(t) {
    const n = [
      ...this.getKeys()
    ];
    return this.getItem(n[t]);
  }
  getChildren(t) {
    let n = this.keyMap.get(t);
    return (n == null ? void 0 : n.childNodes) || [];
  }
  constructor(t) {
    this.keyMap = /* @__PURE__ */ new Map(), this.iterable = t;
    let n = (i) => {
      if (this.keyMap.set(i.key, i), i.childNodes && i.type === "section")
        for (let o of i.childNodes)
          n(o);
    };
    for (let i of t)
      n(i);
    let r, a = 0;
    for (let [i, o] of this.keyMap)
      r ? (r.nextKey = i, o.prevKey = r.key) : (this.firstKey = i, o.prevKey = void 0), o.type === "item" && (o.index = a++), r = o, r.nextKey = void 0;
    this.lastKey = r == null ? void 0 : r.key;
  }
}
function RS(e) {
  let { filter: t } = e, n = DS(e), r = ge(() => e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set(), [
    e.disabledKeys
  ]), a = he((u) => t ? new lc(t(u)) : new lc(u), [
    t
  ]), i = ge(() => ({
    suppressTextValueWarning: e.suppressTextValueWarning
  }), [
    e.suppressTextValueWarning
  ]), o = V5(e, a, i), l = ge(() => new NS(o, n), [
    o,
    n
  ]);
  const s = J(null);
  return re(() => {
    if (n.focusedKey != null && !o.getItem(n.focusedKey)) {
      const u = s.current.getItem(n.focusedKey), f = [
        ...s.current.getKeys()
      ].map((b) => {
        const w = s.current.getItem(b);
        return w.type === "item" ? w : null;
      }).filter((b) => b !== null), h = [
        ...o.getKeys()
      ].map((b) => {
        const w = o.getItem(b);
        return w.type === "item" ? w : null;
      }).filter((b) => b !== null), g = f.length - h.length;
      let v = Math.min(g > 1 ? Math.max(u.index - g + 1, 0) : u.index, h.length - 1), E;
      for (; v >= 0; ) {
        if (!l.isDisabled(h[v].key)) {
          E = h[v];
          break;
        }
        v < h.length - 1 ? v++ : (v > u.index && (v = u.index), v--);
      }
      n.setFocusedKey(E ? E.key : null);
    }
    s.current = o;
  }, [
    o,
    l,
    n,
    n.focusedKey
  ]), {
    collection: o,
    disabledKeys: r,
    selectionManager: l
  };
}
function am(e) {
  var t;
  let [n, r] = Bn(e.selectedKey, (t = e.defaultSelectedKey) !== null && t !== void 0 ? t : null, e.onSelectionChange), a = ge(() => n != null ? [
    n
  ] : [], [
    n
  ]), { collection: i, disabledKeys: o, selectionManager: l } = RS({
    ...e,
    selectionMode: "single",
    disallowEmptySelection: !0,
    allowDuplicateSelectionEvents: !0,
    selectedKeys: a,
    onSelectionChange: (u) => {
      var f;
      let h = (f = u.values().next().value) !== null && f !== void 0 ? f : null;
      h === n && e.onSelectionChange && e.onSelectionChange(h), r(h);
    }
  }), s = n != null ? i.getItem(n) : null;
  return {
    collection: i,
    disabledKeys: o,
    selectionManager: l,
    selectedKey: n,
    setSelectedKey: r,
    selectedItem: s
  };
}
function BS(e) {
  let [t, n] = Bn(e.isOpen, e.defaultOpen || !1, e.onOpenChange);
  const r = he(() => {
    n(!0);
  }, [
    n
  ]), a = he(() => {
    n(!1);
  }, [
    n
  ]), i = he(() => {
    n(!t);
  }, [
    n,
    t
  ]);
  return {
    isOpen: t,
    setOpen: n,
    open: r,
    close: a,
    toggle: i
  };
}
function VS(e) {
  var t, n;
  let { defaultFilter: r, menuTrigger: a = "input", allowsEmptyCollection: i = !1, allowsCustomValue: o, shouldCloseOnBlur: l = !0 } = e, [s, u] = ne(!1), [f, h] = ne(!1), [g, v] = ne(null), E = (we) => {
    e.onSelectionChange && e.onSelectionChange(we), we === T && (U(), M());
  };
  var b;
  let { collection: w, selectionManager: S, selectedKey: T, setSelectedKey: A, selectedItem: V, disabledKeys: $ } = am({
    ...e,
    onSelectionChange: E,
    items: (b = e.items) !== null && b !== void 0 ? b : e.defaultItems
  });
  var _, y;
  let [c, p] = Bn(e.inputValue, (y = (_ = e.defaultInputValue) !== null && _ !== void 0 ? _ : (t = w.getItem(T)) === null || t === void 0 ? void 0 : t.textValue) !== null && y !== void 0 ? y : "", e.onInputChange), d = w, m = ge(() => (
    // No default filter if items are controlled.
    e.items != null || !r ? w : FS(w, c, r)
  ), [
    w,
    c,
    r,
    e.items
  ]), [O, x] = ne(m), P = J("focus"), D = BS({
    ...e,
    onOpenChange: (we) => {
      e.onOpenChange && e.onOpenChange(we, we ? P.current : void 0), S.setFocused(we), we || S.setFocusedKey(null);
    },
    isOpen: void 0,
    defaultOpen: void 0
  }), I = (we = null, $e) => {
    let Ve = $e === "manual" || $e === "focus" && a === "focus";
    (i || m.size > 0 || Ve && d.size > 0 || e.items) && (Ve && !D.isOpen && e.items === void 0 && u(!0), P.current = $e, v(we), D.open());
  }, C = (we = null, $e) => {
    let Ve = $e === "manual" || $e === "focus" && a === "focus";
    !(i || m.size > 0 || Ve && d.size > 0 || e.items) && !D.isOpen || (Ve && !D.isOpen && e.items === void 0 && u(!0), D.isOpen || (P.current = $e), k(we));
  }, L = he(() => {
    x(s ? d : m);
  }, [
    s,
    d,
    m
  ]), k = he((we = null) => {
    D.isOpen && L(), v(we), D.toggle();
  }, [
    D,
    L
  ]), M = he(() => {
    D.isOpen && (L(), D.close());
  }, [
    D,
    L
  ]), [F, j] = ne(c), U = () => {
    var we, $e;
    let Ve = ($e = (we = w.getItem(T)) === null || we === void 0 ? void 0 : we.textValue) !== null && $e !== void 0 ? $e : "";
    j(Ve), p(Ve);
  };
  var G, X;
  let W = J((X = (G = e.selectedKey) !== null && G !== void 0 ? G : e.defaultSelectedKey) !== null && X !== void 0 ? X : null);
  var q;
  let ee = J((q = (n = w.getItem(T)) === null || n === void 0 ? void 0 : n.textValue) !== null && q !== void 0 ? q : "");
  re(() => {
    var we;
    f && (m.size > 0 || i) && !D.isOpen && c !== F && a !== "manual" && I(null, "input"), !s && !i && D.isOpen && m.size === 0 && M(), T != null && T !== W.current && M(), c !== F && (S.setFocusedKey(null), u(!1), c === "" && (e.inputValue === void 0 || e.selectedKey === void 0) && A(null)), T !== W.current && (e.inputValue === void 0 || e.selectedKey === void 0) ? U() : F !== c && j(c);
    var $e;
    let Ve = ($e = (we = w.getItem(T)) === null || we === void 0 ? void 0 : we.textValue) !== null && $e !== void 0 ? $e : "";
    !f && T != null && e.inputValue === void 0 && T === W.current && ee.current !== Ve && (j(Ve), p(Ve)), W.current = T, ee.current = Ve;
  });
  let te = Hi({
    ...e,
    value: ge(() => ({
      inputValue: c,
      selectedKey: T
    }), [
      c,
      T
    ])
  }), le = () => {
    o && T == null ? Y() : ye();
  }, Y = () => {
    W.current = null, A(null), M();
  }, ye = () => {
    if (e.selectedKey !== void 0 && e.inputValue !== void 0) {
      var we;
      e.onSelectionChange(T);
      var $e;
      let Ve = ($e = (we = w.getItem(T)) === null || we === void 0 ? void 0 : we.textValue) !== null && $e !== void 0 ? $e : "";
      j(Ve), M();
    } else
      U(), M();
  };
  const Ce = () => {
    if (o) {
      var we, $e;
      const Ve = ($e = (we = w.getItem(T)) === null || we === void 0 ? void 0 : we.textValue) !== null && $e !== void 0 ? $e : "";
      c === Ve ? ye() : Y();
    } else
      ye();
  };
  let Ke = () => {
    D.isOpen && S.focusedKey != null ? T === S.focusedKey ? ye() : A(S.focusedKey) : Ce();
  }, We = J(c), nt = (we) => {
    we ? (We.current = c, a === "focus" && I(null, "focus")) : (l && Ce(), c !== We.current && te.commitValidation()), h(we);
  }, qe = ge(() => D.isOpen ? s ? d : m : O, [
    D.isOpen,
    d,
    m,
    s,
    O
  ]);
  return {
    ...te,
    ...D,
    focusStrategy: g,
    toggle: C,
    open: I,
    close: Ce,
    selectionManager: S,
    selectedKey: T,
    setSelectedKey: A,
    disabledKeys: $,
    isFocused: f,
    setFocused: nt,
    selectedItem: V,
    collection: qe,
    inputValue: c,
    setInputValue: p,
    commit: Ke,
    revert: le
  };
}
function FS(e, t, n) {
  return new lc(im(e, e, t, n));
}
function im(e, t, n, r) {
  let a = [];
  for (let i of t)
    if (i.type === "section" && i.hasChildNodes) {
      let o = im(e, Ki(i, e), n, r);
      [
        ...o
      ].some((l) => l.type === "item") && a.push({
        ...i,
        childNodes: o
      });
    } else
      i.type === "item" && r(i.textValue, n) ? a.push({
        ...i
      }) : i.type !== "item" && a.push({
        ...i
      });
  return a;
}
function HS(e, t) {
  let { cursor: n, getKey: r } = e;
  return {
    setSelectedKeys(a) {
      t((i) => ({
        ...i,
        selectedKeys: a
      }));
    },
    setFilterText(a) {
      t((i) => ({
        ...i,
        filterText: a
      }));
    },
    insert(a, ...i) {
      t((o) => Rr(o, a, ...i));
    },
    insertBefore(a, ...i) {
      t((o) => {
        let l = o.items.findIndex((s) => r(s) === a);
        if (l === -1)
          if (o.items.length === 0)
            l = 0;
          else
            return o;
        return Rr(o, l, ...i);
      });
    },
    insertAfter(a, ...i) {
      t((o) => {
        let l = o.items.findIndex((s) => r(s) === a);
        if (l === -1)
          if (o.items.length === 0)
            l = 0;
          else
            return o;
        return Rr(o, l + 1, ...i);
      });
    },
    prepend(...a) {
      t((i) => Rr(i, 0, ...a));
    },
    append(...a) {
      t((i) => Rr(i, i.items.length, ...a));
    },
    remove(...a) {
      t((i) => {
        let o = new Set(a), l = i.items.filter((u) => !o.has(r(u))), s = "all";
        if (i.selectedKeys !== "all") {
          s = new Set(i.selectedKeys);
          for (let u of a)
            s.delete(u);
        }
        return n == null && l.length === 0 && (s = /* @__PURE__ */ new Set()), {
          ...i,
          items: l,
          selectedKeys: s
        };
      });
    },
    removeSelectedItems() {
      t((a) => {
        if (a.selectedKeys === "all")
          return {
            ...a,
            items: [],
            selectedKeys: /* @__PURE__ */ new Set()
          };
        let i = a.selectedKeys, o = a.items.filter((l) => !i.has(r(l)));
        return {
          ...a,
          items: o,
          selectedKeys: /* @__PURE__ */ new Set()
        };
      });
    },
    move(a, i) {
      t((o) => {
        let l = o.items.findIndex((f) => r(f) === a);
        if (l === -1)
          return o;
        let s = o.items.slice(), [u] = s.splice(l, 1);
        return s.splice(i, 0, u), {
          ...o,
          items: s
        };
      });
    },
    moveBefore(a, i) {
      t((o) => {
        let l = o.items.findIndex((f) => r(f) === a);
        if (l === -1)
          return o;
        let u = (Array.isArray(i) ? i : [
          ...i
        ]).map((f) => o.items.findIndex((h) => r(h) === f)).sort();
        return Df(o, u, l);
      });
    },
    moveAfter(a, i) {
      t((o) => {
        let l = o.items.findIndex((f) => r(f) === a);
        if (l === -1)
          return o;
        let u = (Array.isArray(i) ? i : [
          ...i
        ]).map((f) => o.items.findIndex((h) => r(h) === f)).sort();
        return Df(o, u, l + 1);
      });
    },
    update(a, i) {
      t((o) => {
        let l = o.items.findIndex((s) => r(s) === a);
        return l === -1 ? o : {
          ...o,
          items: [
            ...o.items.slice(0, l),
            i,
            ...o.items.slice(l + 1)
          ]
        };
      });
    }
  };
}
function Rr(e, t, ...n) {
  return {
    ...e,
    items: [
      ...e.items.slice(0, t),
      ...n,
      ...e.items.slice(t)
    ]
  };
}
function Df(e, t, n) {
  n -= t.filter((i) => i < n).length;
  let r = t.map((i) => ({
    from: i,
    to: n++
  }));
  for (let i = 0; i < r.length; i++) {
    let o = r[i].from;
    for (let l = i; l < r.length; l++)
      r[l].from > o && r[l].from--;
  }
  for (let i = 0; i < r.length; i++) {
    let o = r[i];
    for (let l = r.length - 1; l > i; l--) {
      let s = r[l];
      s.from < o.to ? o.to++ : s.from++;
    }
  }
  let a = e.items.slice();
  for (let i of r) {
    let [o] = a.splice(i.from, 1);
    a.splice(i.to, 0, o);
  }
  return {
    ...e,
    items: a
  };
}
function KS(e, t) {
  let n;
  switch (e.state) {
    case "idle":
    case "error":
      switch (t.type) {
        case "loading":
        case "loadingMore":
        case "sorting":
        case "filtering":
          var r, a;
          return {
            ...e,
            filterText: (r = t.filterText) !== null && r !== void 0 ? r : e.filterText,
            state: t.type,
            // Reset items to an empty list if loading, but not when sorting.
            items: t.type === "loading" ? [] : e.items,
            sortDescriptor: (a = t.sortDescriptor) !== null && a !== void 0 ? a : e.sortDescriptor,
            abortController: t.abortController
          };
        case "update":
          return {
            ...e,
            ...t.updater(e)
          };
        case "success":
        case "error":
          return e;
        default:
          throw new Error(`Invalid action "${t.type}" in state "${e.state}"`);
      }
    case "loading":
    case "sorting":
    case "filtering":
      switch (t.type) {
        case "success":
          if (t.abortController !== e.abortController)
            return e;
          var i;
          n = (i = t.selectedKeys) !== null && i !== void 0 ? i : e.selectedKeys;
          var o, l;
          return {
            ...e,
            filterText: (o = t.filterText) !== null && o !== void 0 ? o : e.filterText,
            state: "idle",
            items: [
              ...t.items
            ],
            selectedKeys: n === "all" ? "all" : new Set(n),
            sortDescriptor: (l = t.sortDescriptor) !== null && l !== void 0 ? l : e.sortDescriptor,
            abortController: null,
            cursor: t.cursor
          };
        case "error":
          return t.abortController !== e.abortController ? e : {
            ...e,
            state: "error",
            error: t.error,
            abortController: null
          };
        case "loading":
        case "loadingMore":
        case "sorting":
        case "filtering":
          e.abortController.abort();
          var s;
          return {
            ...e,
            filterText: (s = t.filterText) !== null && s !== void 0 ? s : e.filterText,
            state: t.type,
            // Reset items to an empty list if loading, but not when sorting.
            items: t.type === "loading" ? [] : e.items,
            abortController: t.abortController
          };
        case "update":
          return {
            ...e,
            ...t.updater(e)
          };
        default:
          throw new Error(`Invalid action "${t.type}" in state "${e.state}"`);
      }
    case "loadingMore":
      switch (t.type) {
        case "success":
          var u;
          n = e.selectedKeys === "all" || t.selectedKeys === "all" ? "all" : /* @__PURE__ */ new Set([
            ...e.selectedKeys,
            ...(u = t.selectedKeys) !== null && u !== void 0 ? u : []
          ]);
          var f;
          return {
            ...e,
            state: "idle",
            items: [
              ...e.items,
              ...t.items
            ],
            selectedKeys: n,
            sortDescriptor: (f = t.sortDescriptor) !== null && f !== void 0 ? f : e.sortDescriptor,
            abortController: null,
            cursor: t.cursor
          };
        case "error":
          return t.abortController !== e.abortController ? e : {
            ...e,
            state: "error",
            error: t.error
          };
        case "loading":
        case "sorting":
        case "filtering":
          e.abortController.abort();
          var h;
          return {
            ...e,
            filterText: (h = t.filterText) !== null && h !== void 0 ? h : e.filterText,
            state: t.type,
            // Reset items to an empty list if loading, but not when sorting.
            items: t.type === "loading" ? [] : e.items,
            abortController: t.abortController
          };
        case "loadingMore":
          return t.abortController.abort(), e;
        case "update":
          return {
            ...e,
            ...t.updater(e)
          };
        default:
          throw new Error(`Invalid action "${t.type}" in state "${e.state}"`);
      }
    default:
      throw new Error(`Invalid state "${e.state}"`);
  }
}
function jS(e) {
  const { load: t, sort: n, initialSelectedKeys: r, initialSortDescriptor: a, getKey: i = (h) => h.id || h.key, initialFilterText: o = "" } = e;
  let [l, s] = Ii(KS, {
    state: "idle",
    error: null,
    items: [],
    selectedKeys: r === "all" ? "all" : new Set(r),
    sortDescriptor: a,
    filterText: o
  });
  const u = async (h, g) => {
    let v = new AbortController();
    try {
      s({
        ...h,
        abortController: v
      });
      var E;
      let S = (E = h.filterText) !== null && E !== void 0 ? E : l.filterText;
      var b;
      let T = await g({
        items: l.items.slice(),
        selectedKeys: l.selectedKeys,
        sortDescriptor: (b = h.sortDescriptor) !== null && b !== void 0 ? b : l.sortDescriptor,
        signal: v.signal,
        cursor: h.type === "loadingMore" ? l.cursor : null,
        filterText: S
      });
      var w;
      let A = (w = T.filterText) !== null && w !== void 0 ? w : S;
      s({
        type: "success",
        ...T,
        abortController: v
      }), A && A !== S && !v.signal.aborted && u({
        type: "filtering",
        filterText: A
      }, t);
    } catch (S) {
      s({
        type: "error",
        error: S,
        abortController: v
      });
    }
  };
  let f = J(!1);
  return re(() => {
    f.current || (u({
      type: "loading"
    }, t), f.current = !0);
  }, []), {
    items: l.items,
    selectedKeys: l.selectedKeys,
    sortDescriptor: l.sortDescriptor,
    isLoading: l.state === "loading" || l.state === "loadingMore" || l.state === "sorting" || l.state === "filtering",
    loadingState: l.state,
    error: l.error,
    filterText: l.filterText,
    getItem(h) {
      return l.items.find((g) => i(g) === h);
    },
    reload() {
      u({
        type: "loading"
      }, t);
    },
    loadMore() {
      l.state === "loadingMore" || l.state === "filtering" || l.cursor == null || u({
        type: "loadingMore"
      }, t);
    },
    sort(h) {
      u({
        type: "sorting",
        sortDescriptor: h
      }, n || t);
    },
    ...HS({
      ...e,
      getKey: i,
      cursor: l.cursor
    }, (h) => {
      s({
        type: "update",
        updater: h
      });
    }),
    setFilterText(h) {
      u({
        type: "filtering",
        filterText: h
      }, t);
    }
  };
}
let US = Math.round(Math.random() * 1e10), WS = 0;
function qS(e) {
  let t = ge(() => e.name || `radio-group-${US}-${++WS}`, [
    e.name
  ]);
  var n;
  let [r, a] = Bn(e.value, (n = e.defaultValue) !== null && n !== void 0 ? n : null, e.onChange), [i, o] = ne(null), l = Hi({
    ...e,
    value: r
  }), s = (f) => {
    !e.isReadOnly && !e.isDisabled && (a(f), l.commitValidation());
  }, u = l.displayValidation.isInvalid;
  return {
    ...l,
    name: t,
    selectedValue: r,
    setSelectedValue: s,
    lastFocusedValue: i,
    setLastFocusedValue: o,
    isDisabled: e.isDisabled || !1,
    isReadOnly: e.isReadOnly || !1,
    isRequired: e.isRequired || !1,
    validationState: e.validationState || (u ? "invalid" : null),
    isInvalid: u
  };
}
function ZS(e) {
  var t;
  let n = am({
    ...e,
    suppressTextValueWarning: !0,
    defaultSelectedKey: (t = e.defaultSelectedKey) !== null && t !== void 0 ? t : Nf(e.collection, e.disabledKeys ? new Set(e.disabledKeys) : /* @__PURE__ */ new Set())
  }), { selectionManager: r, collection: a, selectedKey: i } = n, o = J(i);
  return re(() => {
    let l = i;
    (r.isEmpty || !a.getItem(l)) && (l = Nf(a, n.disabledKeys), l != null && r.setSelectedKeys([
      l
    ])), (l != null && r.focusedKey == null || !r.isFocused && l !== o.current) && r.setFocusedKey(l), o.current = l;
  }), {
    ...n,
    isDisabled: e.isDisabled || !1
  };
}
function Nf(e, t) {
  let n = null;
  if (e) {
    for (n = e.getFirstKey(); t.has(n) && n !== e.getLastKey(); )
      n = e.getKeyAfter(n);
    t.has(n) && n === e.getLastKey() && (n = e.getFirstKey());
  }
  return n;
}
var qc = {}, Zc = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Doctype = e.CDATA = e.Tag = e.Style = e.Script = e.Comment = e.Directive = e.Text = e.Root = e.isTag = e.ElementType = void 0;
  var t;
  (function(r) {
    r.Root = "root", r.Text = "text", r.Directive = "directive", r.Comment = "comment", r.Script = "script", r.Style = "style", r.Tag = "tag", r.CDATA = "cdata", r.Doctype = "doctype";
  })(t = e.ElementType || (e.ElementType = {}));
  function n(r) {
    return r.type === t.Tag || r.type === t.Script || r.type === t.Style;
  }
  e.isTag = n, e.Root = t.Root, e.Text = t.Text, e.Directive = t.Directive, e.Comment = t.Comment, e.Script = t.Script, e.Style = t.Style, e.Tag = t.Tag, e.CDATA = t.CDATA, e.Doctype = t.Doctype;
})(Zc);
var xe = {}, bn = vt && vt.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, a) {
      r.__proto__ = a;
    } || function(r, a) {
      for (var i in a)
        Object.prototype.hasOwnProperty.call(a, i) && (r[i] = a[i]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), Zr = vt && vt.__assign || function() {
  return Zr = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var a in t)
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, Zr.apply(this, arguments);
};
Object.defineProperty(xe, "__esModule", { value: !0 });
xe.cloneNode = xe.hasChildren = xe.isDocument = xe.isDirective = xe.isComment = xe.isText = xe.isCDATA = xe.isTag = xe.Element = xe.Document = xe.CDATA = xe.NodeWithChildren = xe.ProcessingInstruction = xe.Comment = xe.Text = xe.DataNode = xe.Node = void 0;
var dt = Zc, Gc = (
  /** @class */
  function() {
    function e() {
      this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
    }
    return Object.defineProperty(e.prototype, "parentNode", {
      // Read-write aliases for properties
      /**
       * Same as {@link parent}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.parent;
      },
      set: function(t) {
        this.parent = t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "previousSibling", {
      /**
       * Same as {@link prev}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.prev;
      },
      set: function(t) {
        this.prev = t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "nextSibling", {
      /**
       * Same as {@link next}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.next;
      },
      set: function(t) {
        this.next = t;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.cloneNode = function(t) {
      return t === void 0 && (t = !1), Yc(this, t);
    }, e;
  }()
);
xe.Node = Gc;
var Wi = (
  /** @class */
  function(e) {
    bn(t, e);
    function t(n) {
      var r = e.call(this) || this;
      return r.data = n, r;
    }
    return Object.defineProperty(t.prototype, "nodeValue", {
      /**
       * Same as {@link data}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.data;
      },
      set: function(n) {
        this.data = n;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Gc)
);
xe.DataNode = Wi;
var om = (
  /** @class */
  function(e) {
    bn(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = dt.ElementType.Text, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 3;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Wi)
);
xe.Text = om;
var lm = (
  /** @class */
  function(e) {
    bn(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = dt.ElementType.Comment, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 8;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Wi)
);
xe.Comment = lm;
var sm = (
  /** @class */
  function(e) {
    bn(t, e);
    function t(n, r) {
      var a = e.call(this, r) || this;
      return a.name = n, a.type = dt.ElementType.Directive, a;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Wi)
);
xe.ProcessingInstruction = sm;
var qi = (
  /** @class */
  function(e) {
    bn(t, e);
    function t(n) {
      var r = e.call(this) || this;
      return r.children = n, r;
    }
    return Object.defineProperty(t.prototype, "firstChild", {
      // Aliases
      /** First child of the node. */
      get: function() {
        var n;
        return (n = this.children[0]) !== null && n !== void 0 ? n : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "lastChild", {
      /** Last child of the node. */
      get: function() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "childNodes", {
      /**
       * Same as {@link children}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.children;
      },
      set: function(n) {
        this.children = n;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Gc)
);
xe.NodeWithChildren = qi;
var cm = (
  /** @class */
  function(e) {
    bn(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = dt.ElementType.CDATA, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 4;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(qi)
);
xe.CDATA = cm;
var um = (
  /** @class */
  function(e) {
    bn(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = dt.ElementType.Root, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 9;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(qi)
);
xe.Document = um;
var dm = (
  /** @class */
  function(e) {
    bn(t, e);
    function t(n, r, a, i) {
      a === void 0 && (a = []), i === void 0 && (i = n === "script" ? dt.ElementType.Script : n === "style" ? dt.ElementType.Style : dt.ElementType.Tag);
      var o = e.call(this, a) || this;
      return o.name = n, o.attribs = r, o.type = i, o;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "tagName", {
      // DOM Level 1 aliases
      /**
       * Same as {@link name}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.name;
      },
      set: function(n) {
        this.name = n;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "attributes", {
      get: function() {
        var n = this;
        return Object.keys(this.attribs).map(function(r) {
          var a, i;
          return {
            name: r,
            value: n.attribs[r],
            namespace: (a = n["x-attribsNamespace"]) === null || a === void 0 ? void 0 : a[r],
            prefix: (i = n["x-attribsPrefix"]) === null || i === void 0 ? void 0 : i[r]
          };
        });
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(qi)
);
xe.Element = dm;
function fm(e) {
  return (0, dt.isTag)(e);
}
xe.isTag = fm;
function pm(e) {
  return e.type === dt.ElementType.CDATA;
}
xe.isCDATA = pm;
function hm(e) {
  return e.type === dt.ElementType.Text;
}
xe.isText = hm;
function vm(e) {
  return e.type === dt.ElementType.Comment;
}
xe.isComment = vm;
function mm(e) {
  return e.type === dt.ElementType.Directive;
}
xe.isDirective = mm;
function gm(e) {
  return e.type === dt.ElementType.Root;
}
xe.isDocument = gm;
function GS(e) {
  return Object.prototype.hasOwnProperty.call(e, "children");
}
xe.hasChildren = GS;
function Yc(e, t) {
  t === void 0 && (t = !1);
  var n;
  if (hm(e))
    n = new om(e.data);
  else if (vm(e))
    n = new lm(e.data);
  else if (fm(e)) {
    var r = t ? ss(e.children) : [], a = new dm(e.name, Zr({}, e.attribs), r);
    r.forEach(function(s) {
      return s.parent = a;
    }), e.namespace != null && (a.namespace = e.namespace), e["x-attribsNamespace"] && (a["x-attribsNamespace"] = Zr({}, e["x-attribsNamespace"])), e["x-attribsPrefix"] && (a["x-attribsPrefix"] = Zr({}, e["x-attribsPrefix"])), n = a;
  } else if (pm(e)) {
    var r = t ? ss(e.children) : [], i = new cm(r);
    r.forEach(function(u) {
      return u.parent = i;
    }), n = i;
  } else if (gm(e)) {
    var r = t ? ss(e.children) : [], o = new um(r);
    r.forEach(function(u) {
      return u.parent = o;
    }), e["x-mode"] && (o["x-mode"] = e["x-mode"]), n = o;
  } else if (mm(e)) {
    var l = new sm(e.name, e.data);
    e["x-name"] != null && (l["x-name"] = e["x-name"], l["x-publicId"] = e["x-publicId"], l["x-systemId"] = e["x-systemId"]), n = l;
  } else
    throw new Error("Not implemented yet: ".concat(e.type));
  return n.startIndex = e.startIndex, n.endIndex = e.endIndex, e.sourceCodeLocation != null && (n.sourceCodeLocation = e.sourceCodeLocation), n;
}
xe.cloneNode = Yc;
function ss(e) {
  for (var t = e.map(function(r) {
    return Yc(r, !0);
  }), n = 1; n < t.length; n++)
    t[n].prev = t[n - 1], t[n - 1].next = t[n];
  return t;
}
(function(e) {
  var t = vt && vt.__createBinding || (Object.create ? function(l, s, u, f) {
    f === void 0 && (f = u);
    var h = Object.getOwnPropertyDescriptor(s, u);
    (!h || ("get" in h ? !s.__esModule : h.writable || h.configurable)) && (h = { enumerable: !0, get: function() {
      return s[u];
    } }), Object.defineProperty(l, f, h);
  } : function(l, s, u, f) {
    f === void 0 && (f = u), l[f] = s[u];
  }), n = vt && vt.__exportStar || function(l, s) {
    for (var u in l)
      u !== "default" && !Object.prototype.hasOwnProperty.call(s, u) && t(s, l, u);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.DomHandler = void 0;
  var r = Zc, a = xe;
  n(xe, e);
  var i = {
    withStartIndices: !1,
    withEndIndices: !1,
    xmlMode: !1
  }, o = (
    /** @class */
    function() {
      function l(s, u, f) {
        this.dom = [], this.root = new a.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof u == "function" && (f = u, u = i), typeof s == "object" && (u = s, s = void 0), this.callback = s ?? null, this.options = u ?? i, this.elementCB = f ?? null;
      }
      return l.prototype.onparserinit = function(s) {
        this.parser = s;
      }, l.prototype.onreset = function() {
        this.dom = [], this.root = new a.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
      }, l.prototype.onend = function() {
        this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
      }, l.prototype.onerror = function(s) {
        this.handleCallback(s);
      }, l.prototype.onclosetag = function() {
        this.lastNode = null;
        var s = this.tagStack.pop();
        this.options.withEndIndices && (s.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(s);
      }, l.prototype.onopentag = function(s, u) {
        var f = this.options.xmlMode ? r.ElementType.Tag : void 0, h = new a.Element(s, u, void 0, f);
        this.addNode(h), this.tagStack.push(h);
      }, l.prototype.ontext = function(s) {
        var u = this.lastNode;
        if (u && u.type === r.ElementType.Text)
          u.data += s, this.options.withEndIndices && (u.endIndex = this.parser.endIndex);
        else {
          var f = new a.Text(s);
          this.addNode(f), this.lastNode = f;
        }
      }, l.prototype.oncomment = function(s) {
        if (this.lastNode && this.lastNode.type === r.ElementType.Comment) {
          this.lastNode.data += s;
          return;
        }
        var u = new a.Comment(s);
        this.addNode(u), this.lastNode = u;
      }, l.prototype.oncommentend = function() {
        this.lastNode = null;
      }, l.prototype.oncdatastart = function() {
        var s = new a.Text(""), u = new a.CDATA([s]);
        this.addNode(u), s.parent = u, this.lastNode = s;
      }, l.prototype.oncdataend = function() {
        this.lastNode = null;
      }, l.prototype.onprocessinginstruction = function(s, u) {
        var f = new a.ProcessingInstruction(s, u);
        this.addNode(f);
      }, l.prototype.handleCallback = function(s) {
        if (typeof this.callback == "function")
          this.callback(s, this.dom);
        else if (s)
          throw s;
      }, l.prototype.addNode = function(s) {
        var u = this.tagStack[this.tagStack.length - 1], f = u.children[u.children.length - 1];
        this.options.withStartIndices && (s.startIndex = this.parser.startIndex), this.options.withEndIndices && (s.endIndex = this.parser.endIndex), u.children.push(s), f && (s.prev = f, f.next = s), s.parent = u, this.lastNode = null;
      }, l;
    }()
  );
  e.DomHandler = o, e.default = o;
})(qc);
var Rf = "html", Bf = "head", Wa = "body", YS = /<([a-zA-Z]+[0-9]?)/, Vf = /<head[^]*>/i, Ff = /<body[^]*>/i, xi = function() {
  throw new Error(
    "This browser does not support `document.implementation.createHTMLDocument`"
  );
}, sc = function() {
  throw new Error(
    "This browser does not support `DOMParser.prototype.parseFromString`"
  );
}, Hf = typeof window == "object" && window.DOMParser;
if (typeof Hf == "function") {
  var XS = new Hf(), JS = "text/html";
  sc = function(e, t) {
    return t && (e = "<" + t + ">" + e + "</" + t + ">"), XS.parseFromString(e, JS);
  }, xi = sc;
}
if (typeof document == "object" && document.implementation) {
  var qa = document.implementation.createHTMLDocument();
  xi = function(e, t) {
    if (t) {
      var n = qa.documentElement.querySelector(t);
      return n.innerHTML = e, qa;
    }
    return qa.documentElement.innerHTML = e, qa;
  };
}
var cs = typeof document == "object" ? document.createElement("template") : {}, cc;
cs.content && (cc = function(e) {
  return cs.innerHTML = e, cs.content.childNodes;
});
function QS(e) {
  var t, n = e.match(YS);
  n && n[1] && (t = n[1].toLowerCase());
  var r, a, i;
  switch (t) {
    case Rf:
      return r = sc(e), Vf.test(e) || (a = r.querySelector(Bf), a && a.parentNode.removeChild(a)), Ff.test(e) || (a = r.querySelector(Wa), a && a.parentNode.removeChild(a)), r.querySelectorAll(Rf);
    case Bf:
    case Wa:
      return r = xi(e), i = r.querySelectorAll(t), Ff.test(e) && Vf.test(e) ? i[0].parentNode.childNodes : i;
    default:
      return cc ? cc(e) : (a = xi(e, Wa).querySelector(Wa), a.childNodes);
  }
}
var ek = QS, Xc = {}, ym = {};
ym.CASE_SENSITIVE_TAG_NAMES = [
  "animateMotion",
  "animateTransform",
  "clipPath",
  "feBlend",
  "feColorMatrix",
  "feComponentTransfer",
  "feComposite",
  "feConvolveMatrix",
  "feDiffuseLighting",
  "feDisplacementMap",
  "feDropShadow",
  "feFlood",
  "feFuncA",
  "feFuncB",
  "feFuncG",
  "feFuncR",
  "feGaussianBlur",
  "feImage",
  "feMerge",
  "feMergeNode",
  "feMorphology",
  "feOffset",
  "fePointLight",
  "feSpecularLighting",
  "feSpotLight",
  "feTile",
  "feTurbulence",
  "foreignObject",
  "linearGradient",
  "radialGradient",
  "textPath"
];
var Zi = qc, tk = ym, Kf = tk.CASE_SENSITIVE_TAG_NAMES, nk = Zi.Comment, rk = Zi.Element, ak = Zi.ProcessingInstruction, ik = Zi.Text, bm = {}, us;
for (var ds = 0, ok = Kf.length; ds < ok; ds++)
  us = Kf[ds], bm[us.toLowerCase()] = us;
function lk(e) {
  return bm[e];
}
function wm(e) {
  for (var t = {}, n, r = 0, a = e.length; r < a; r++)
    n = e[r], t[n.name] = n.value;
  return t;
}
function sk(e) {
  e = e.toLowerCase();
  var t = lk(e);
  return t || e;
}
function xm(e, t, n) {
  t = t || null;
  for (var r = [], a, i = 0, o = e.length; i < o; i++) {
    var l = e[i], s;
    switch (l.nodeType) {
      case 1:
        a = sk(l.nodeName), s = new rk(a, wm(l.attributes)), s.children = xm(
          // template children are on content
          a === "template" ? l.content.childNodes : l.childNodes,
          s
        );
        break;
      case 3:
        s = new ik(l.nodeValue);
        break;
      case 8:
        s = new nk(l.nodeValue);
        break;
      default:
        continue;
    }
    var u = r[i - 1] || null;
    u && (u.next = s), s.parent = t, s.prev = u, s.next = null, r.push(s);
  }
  return n && (s = new ak(
    n.substring(0, n.indexOf(" ")).toLowerCase(),
    n
  ), s.next = r[0] || null, s.parent = t, r.unshift(s), r[1] && (r[1].prev = r[0])), r;
}
Xc.formatAttributes = wm;
Xc.formatDOM = xm;
var ck = ek, uk = Xc, dk = uk.formatDOM, fk = /<(![a-zA-Z\s]+)>/;
function pk(e) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (e === "")
    return [];
  var t = e.match(fk), n;
  return t && t[1] && (n = t[1]), dk(ck(e), null, n);
}
var hk = pk, St = {}, Gi = {}, vk = 0;
Gi.SAME = vk;
var mk = 1;
Gi.CAMELCASE = mk;
Gi.possibleStandardNames = {
  accept: 0,
  acceptCharset: 1,
  "accept-charset": "acceptCharset",
  accessKey: 1,
  action: 0,
  allowFullScreen: 1,
  alt: 0,
  as: 0,
  async: 0,
  autoCapitalize: 1,
  autoComplete: 1,
  autoCorrect: 1,
  autoFocus: 1,
  autoPlay: 1,
  autoSave: 1,
  capture: 0,
  cellPadding: 1,
  cellSpacing: 1,
  challenge: 0,
  charSet: 1,
  checked: 0,
  children: 0,
  cite: 0,
  class: "className",
  classID: 1,
  className: 1,
  cols: 0,
  colSpan: 1,
  content: 0,
  contentEditable: 1,
  contextMenu: 1,
  controls: 0,
  controlsList: 1,
  coords: 0,
  crossOrigin: 1,
  dangerouslySetInnerHTML: 1,
  data: 0,
  dateTime: 1,
  default: 0,
  defaultChecked: 1,
  defaultValue: 1,
  defer: 0,
  dir: 0,
  disabled: 0,
  disablePictureInPicture: 1,
  disableRemotePlayback: 1,
  download: 0,
  draggable: 0,
  encType: 1,
  enterKeyHint: 1,
  for: "htmlFor",
  form: 0,
  formMethod: 1,
  formAction: 1,
  formEncType: 1,
  formNoValidate: 1,
  formTarget: 1,
  frameBorder: 1,
  headers: 0,
  height: 0,
  hidden: 0,
  high: 0,
  href: 0,
  hrefLang: 1,
  htmlFor: 1,
  httpEquiv: 1,
  "http-equiv": "httpEquiv",
  icon: 0,
  id: 0,
  innerHTML: 1,
  inputMode: 1,
  integrity: 0,
  is: 0,
  itemID: 1,
  itemProp: 1,
  itemRef: 1,
  itemScope: 1,
  itemType: 1,
  keyParams: 1,
  keyType: 1,
  kind: 0,
  label: 0,
  lang: 0,
  list: 0,
  loop: 0,
  low: 0,
  manifest: 0,
  marginWidth: 1,
  marginHeight: 1,
  max: 0,
  maxLength: 1,
  media: 0,
  mediaGroup: 1,
  method: 0,
  min: 0,
  minLength: 1,
  multiple: 0,
  muted: 0,
  name: 0,
  noModule: 1,
  nonce: 0,
  noValidate: 1,
  open: 0,
  optimum: 0,
  pattern: 0,
  placeholder: 0,
  playsInline: 1,
  poster: 0,
  preload: 0,
  profile: 0,
  radioGroup: 1,
  readOnly: 1,
  referrerPolicy: 1,
  rel: 0,
  required: 0,
  reversed: 0,
  role: 0,
  rows: 0,
  rowSpan: 1,
  sandbox: 0,
  scope: 0,
  scoped: 0,
  scrolling: 0,
  seamless: 0,
  selected: 0,
  shape: 0,
  size: 0,
  sizes: 0,
  span: 0,
  spellCheck: 1,
  src: 0,
  srcDoc: 1,
  srcLang: 1,
  srcSet: 1,
  start: 0,
  step: 0,
  style: 0,
  summary: 0,
  tabIndex: 1,
  target: 0,
  title: 0,
  type: 0,
  useMap: 1,
  value: 0,
  width: 0,
  wmode: 0,
  wrap: 0,
  about: 0,
  accentHeight: 1,
  "accent-height": "accentHeight",
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 1,
  "alignment-baseline": "alignmentBaseline",
  allowReorder: 1,
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 1,
  "arabic-form": "arabicForm",
  ascent: 0,
  attributeName: 1,
  attributeType: 1,
  autoReverse: 1,
  azimuth: 0,
  baseFrequency: 1,
  baselineShift: 1,
  "baseline-shift": "baselineShift",
  baseProfile: 1,
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 1,
  capHeight: 1,
  "cap-height": "capHeight",
  clip: 0,
  clipPath: 1,
  "clip-path": "clipPath",
  clipPathUnits: 1,
  clipRule: 1,
  "clip-rule": "clipRule",
  color: 0,
  colorInterpolation: 1,
  "color-interpolation": "colorInterpolation",
  colorInterpolationFilters: 1,
  "color-interpolation-filters": "colorInterpolationFilters",
  colorProfile: 1,
  "color-profile": "colorProfile",
  colorRendering: 1,
  "color-rendering": "colorRendering",
  contentScriptType: 1,
  contentStyleType: 1,
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  datatype: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 1,
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 1,
  "dominant-baseline": "dominantBaseline",
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 1,
  elevation: 0,
  enableBackground: 1,
  "enable-background": "enableBackground",
  end: 0,
  exponent: 0,
  externalResourcesRequired: 1,
  fill: 0,
  fillOpacity: 1,
  "fill-opacity": "fillOpacity",
  fillRule: 1,
  "fill-rule": "fillRule",
  filter: 0,
  filterRes: 1,
  filterUnits: 1,
  floodOpacity: 1,
  "flood-opacity": "floodOpacity",
  floodColor: 1,
  "flood-color": "floodColor",
  focusable: 0,
  fontFamily: 1,
  "font-family": "fontFamily",
  fontSize: 1,
  "font-size": "fontSize",
  fontSizeAdjust: 1,
  "font-size-adjust": "fontSizeAdjust",
  fontStretch: 1,
  "font-stretch": "fontStretch",
  fontStyle: 1,
  "font-style": "fontStyle",
  fontVariant: 1,
  "font-variant": "fontVariant",
  fontWeight: 1,
  "font-weight": "fontWeight",
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 1,
  "glyph-name": "glyphName",
  glyphOrientationHorizontal: 1,
  "glyph-orientation-horizontal": "glyphOrientationHorizontal",
  glyphOrientationVertical: 1,
  "glyph-orientation-vertical": "glyphOrientationVertical",
  glyphRef: 1,
  gradientTransform: 1,
  gradientUnits: 1,
  hanging: 0,
  horizAdvX: 1,
  "horiz-adv-x": "horizAdvX",
  horizOriginX: 1,
  "horiz-origin-x": "horizOriginX",
  ideographic: 0,
  imageRendering: 1,
  "image-rendering": "imageRendering",
  in2: 0,
  in: 0,
  inlist: 0,
  intercept: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  k: 0,
  kernelMatrix: 1,
  kernelUnitLength: 1,
  kerning: 0,
  keyPoints: 1,
  keySplines: 1,
  keyTimes: 1,
  lengthAdjust: 1,
  letterSpacing: 1,
  "letter-spacing": "letterSpacing",
  lightingColor: 1,
  "lighting-color": "lightingColor",
  limitingConeAngle: 1,
  local: 0,
  markerEnd: 1,
  "marker-end": "markerEnd",
  markerHeight: 1,
  markerMid: 1,
  "marker-mid": "markerMid",
  markerStart: 1,
  "marker-start": "markerStart",
  markerUnits: 1,
  markerWidth: 1,
  mask: 0,
  maskContentUnits: 1,
  maskUnits: 1,
  mathematical: 0,
  mode: 0,
  numOctaves: 1,
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 1,
  "overline-position": "overlinePosition",
  overlineThickness: 1,
  "overline-thickness": "overlineThickness",
  paintOrder: 1,
  "paint-order": "paintOrder",
  panose1: 0,
  "panose-1": "panose1",
  pathLength: 1,
  patternContentUnits: 1,
  patternTransform: 1,
  patternUnits: 1,
  pointerEvents: 1,
  "pointer-events": "pointerEvents",
  points: 0,
  pointsAtX: 1,
  pointsAtY: 1,
  pointsAtZ: 1,
  prefix: 0,
  preserveAlpha: 1,
  preserveAspectRatio: 1,
  primitiveUnits: 1,
  property: 0,
  r: 0,
  radius: 0,
  refX: 1,
  refY: 1,
  renderingIntent: 1,
  "rendering-intent": "renderingIntent",
  repeatCount: 1,
  repeatDur: 1,
  requiredExtensions: 1,
  requiredFeatures: 1,
  resource: 0,
  restart: 0,
  result: 0,
  results: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  security: 0,
  seed: 0,
  shapeRendering: 1,
  "shape-rendering": "shapeRendering",
  slope: 0,
  spacing: 0,
  specularConstant: 1,
  specularExponent: 1,
  speed: 0,
  spreadMethod: 1,
  startOffset: 1,
  stdDeviation: 1,
  stemh: 0,
  stemv: 0,
  stitchTiles: 1,
  stopColor: 1,
  "stop-color": "stopColor",
  stopOpacity: 1,
  "stop-opacity": "stopOpacity",
  strikethroughPosition: 1,
  "strikethrough-position": "strikethroughPosition",
  strikethroughThickness: 1,
  "strikethrough-thickness": "strikethroughThickness",
  string: 0,
  stroke: 0,
  strokeDasharray: 1,
  "stroke-dasharray": "strokeDasharray",
  strokeDashoffset: 1,
  "stroke-dashoffset": "strokeDashoffset",
  strokeLinecap: 1,
  "stroke-linecap": "strokeLinecap",
  strokeLinejoin: 1,
  "stroke-linejoin": "strokeLinejoin",
  strokeMiterlimit: 1,
  "stroke-miterlimit": "strokeMiterlimit",
  strokeWidth: 1,
  "stroke-width": "strokeWidth",
  strokeOpacity: 1,
  "stroke-opacity": "strokeOpacity",
  suppressContentEditableWarning: 1,
  suppressHydrationWarning: 1,
  surfaceScale: 1,
  systemLanguage: 1,
  tableValues: 1,
  targetX: 1,
  targetY: 1,
  textAnchor: 1,
  "text-anchor": "textAnchor",
  textDecoration: 1,
  "text-decoration": "textDecoration",
  textLength: 1,
  textRendering: 1,
  "text-rendering": "textRendering",
  to: 0,
  transform: 0,
  typeof: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 1,
  "underline-position": "underlinePosition",
  underlineThickness: 1,
  "underline-thickness": "underlineThickness",
  unicode: 0,
  unicodeBidi: 1,
  "unicode-bidi": "unicodeBidi",
  unicodeRange: 1,
  "unicode-range": "unicodeRange",
  unitsPerEm: 1,
  "units-per-em": "unitsPerEm",
  unselectable: 0,
  vAlphabetic: 1,
  "v-alphabetic": "vAlphabetic",
  values: 0,
  vectorEffect: 1,
  "vector-effect": "vectorEffect",
  version: 0,
  vertAdvY: 1,
  "vert-adv-y": "vertAdvY",
  vertOriginX: 1,
  "vert-origin-x": "vertOriginX",
  vertOriginY: 1,
  "vert-origin-y": "vertOriginY",
  vHanging: 1,
  "v-hanging": "vHanging",
  vIdeographic: 1,
  "v-ideographic": "vIdeographic",
  viewBox: 1,
  viewTarget: 1,
  visibility: 0,
  vMathematical: 1,
  "v-mathematical": "vMathematical",
  vocab: 0,
  widths: 0,
  wordSpacing: 1,
  "word-spacing": "wordSpacing",
  writingMode: 1,
  "writing-mode": "writingMode",
  x1: 0,
  x2: 0,
  x: 0,
  xChannelSelector: 1,
  xHeight: 1,
  "x-height": "xHeight",
  xlinkActuate: 1,
  "xlink:actuate": "xlinkActuate",
  xlinkArcrole: 1,
  "xlink:arcrole": "xlinkArcrole",
  xlinkHref: 1,
  "xlink:href": "xlinkHref",
  xlinkRole: 1,
  "xlink:role": "xlinkRole",
  xlinkShow: 1,
  "xlink:show": "xlinkShow",
  xlinkTitle: 1,
  "xlink:title": "xlinkTitle",
  xlinkType: 1,
  "xlink:type": "xlinkType",
  xmlBase: 1,
  "xml:base": "xmlBase",
  xmlLang: 1,
  "xml:lang": "xmlLang",
  xmlns: 0,
  "xml:space": "xmlSpace",
  xmlnsXlink: 1,
  "xmlns:xlink": "xmlnsXlink",
  xmlSpace: 1,
  y1: 0,
  y2: 0,
  y: 0,
  yChannelSelector: 1,
  z: 0,
  zoomAndPan: 1
};
Object.defineProperty(St, "__esModule", { value: !0 });
function gk(e, t) {
  return yk(e) || bk(e, t) || wk(e, t) || xk();
}
function yk(e) {
  if (Array.isArray(e))
    return e;
}
function bk(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], a = !0, i = !1, o, l;
    try {
      for (n = n.call(e); !(a = (o = n.next()).done) && (r.push(o.value), !(t && r.length === t)); a = !0)
        ;
    } catch (s) {
      i = !0, l = s;
    } finally {
      try {
        !a && n.return != null && n.return();
      } finally {
        if (i)
          throw l;
      }
    }
    return r;
  }
}
function wk(e, t) {
  if (e) {
    if (typeof e == "string")
      return jf(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return jf(e, t);
  }
}
function jf(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function xk() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var Em = 0, wn = 1, Yi = 2, Xi = 3, Jc = 4, $m = 5, Pm = 6;
function Ek(e) {
  return Xe.hasOwnProperty(e) ? Xe[e] : null;
}
function ct(e, t, n, r, a, i, o) {
  this.acceptsBooleans = t === Yi || t === Xi || t === Jc, this.attributeName = r, this.attributeNamespace = a, this.mustUseProperty = n, this.propertyName = e, this.type = t, this.sanitizeURL = i, this.removeEmptyString = o;
}
var Xe = {}, $k = [
  "children",
  "dangerouslySetInnerHTML",
  // TODO: This prevents the assignment of defaultValue to regular
  // elements (not just inputs). Now that ReactDOMInput assigns to the
  // defaultValue property -- do we need this?
  "defaultValue",
  "defaultChecked",
  "innerHTML",
  "suppressContentEditableWarning",
  "suppressHydrationWarning",
  "style"
];
$k.forEach(function(e) {
  Xe[e] = new ct(
    e,
    Em,
    !1,
    // mustUseProperty
    e,
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
  );
});
[["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(e) {
  var t = gk(e, 2), n = t[0], r = t[1];
  Xe[n] = new ct(
    n,
    wn,
    !1,
    // mustUseProperty
    r,
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
  );
});
["contentEditable", "draggable", "spellCheck", "value"].forEach(function(e) {
  Xe[e] = new ct(
    e,
    Yi,
    !1,
    // mustUseProperty
    e.toLowerCase(),
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
  );
});
["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(e) {
  Xe[e] = new ct(
    e,
    Yi,
    !1,
    // mustUseProperty
    e,
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
  );
});
[
  "allowFullScreen",
  "async",
  // Note: there is a special case that prevents it from being written to the DOM
  // on the client side because the browsers are inconsistent. Instead we call focus().
  "autoFocus",
  "autoPlay",
  "controls",
  "default",
  "defer",
  "disabled",
  "disablePictureInPicture",
  "disableRemotePlayback",
  "formNoValidate",
  "hidden",
  "loop",
  "noModule",
  "noValidate",
  "open",
  "playsInline",
  "readOnly",
  "required",
  "reversed",
  "scoped",
  "seamless",
  // Microdata
  "itemScope"
].forEach(function(e) {
  Xe[e] = new ct(
    e,
    Xi,
    !1,
    // mustUseProperty
    e.toLowerCase(),
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
  );
});
[
  "checked",
  // Note: `option.selected` is not updated if `select.multiple` is
  // disabled with `removeAttribute`. We have special logic for handling this.
  "multiple",
  "muted",
  "selected"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach(function(e) {
  Xe[e] = new ct(
    e,
    Xi,
    !0,
    // mustUseProperty
    e,
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
  );
});
[
  "capture",
  "download"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach(function(e) {
  Xe[e] = new ct(
    e,
    Jc,
    !1,
    // mustUseProperty
    e,
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
  );
});
[
  "cols",
  "rows",
  "size",
  "span"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach(function(e) {
  Xe[e] = new ct(
    e,
    Pm,
    !1,
    // mustUseProperty
    e,
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
  );
});
["rowSpan", "start"].forEach(function(e) {
  Xe[e] = new ct(
    e,
    $m,
    !1,
    // mustUseProperty
    e.toLowerCase(),
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
  );
});
var Qc = /[\-\:]([a-z])/g, e1 = function(t) {
  return t[1].toUpperCase();
};
[
  "accent-height",
  "alignment-baseline",
  "arabic-form",
  "baseline-shift",
  "cap-height",
  "clip-path",
  "clip-rule",
  "color-interpolation",
  "color-interpolation-filters",
  "color-profile",
  "color-rendering",
  "dominant-baseline",
  "enable-background",
  "fill-opacity",
  "fill-rule",
  "flood-color",
  "flood-opacity",
  "font-family",
  "font-size",
  "font-size-adjust",
  "font-stretch",
  "font-style",
  "font-variant",
  "font-weight",
  "glyph-name",
  "glyph-orientation-horizontal",
  "glyph-orientation-vertical",
  "horiz-adv-x",
  "horiz-origin-x",
  "image-rendering",
  "letter-spacing",
  "lighting-color",
  "marker-end",
  "marker-mid",
  "marker-start",
  "overline-position",
  "overline-thickness",
  "paint-order",
  "panose-1",
  "pointer-events",
  "rendering-intent",
  "shape-rendering",
  "stop-color",
  "stop-opacity",
  "strikethrough-position",
  "strikethrough-thickness",
  "stroke-dasharray",
  "stroke-dashoffset",
  "stroke-linecap",
  "stroke-linejoin",
  "stroke-miterlimit",
  "stroke-opacity",
  "stroke-width",
  "text-anchor",
  "text-decoration",
  "text-rendering",
  "underline-position",
  "underline-thickness",
  "unicode-bidi",
  "unicode-range",
  "units-per-em",
  "v-alphabetic",
  "v-hanging",
  "v-ideographic",
  "v-mathematical",
  "vector-effect",
  "vert-adv-y",
  "vert-origin-x",
  "vert-origin-y",
  "word-spacing",
  "writing-mode",
  "xmlns:xlink",
  "x-height"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach(function(e) {
  var t = e.replace(Qc, e1);
  Xe[t] = new ct(
    t,
    wn,
    !1,
    // mustUseProperty
    e,
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
  );
});
[
  "xlink:actuate",
  "xlink:arcrole",
  "xlink:role",
  "xlink:show",
  "xlink:title",
  "xlink:type"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach(function(e) {
  var t = e.replace(Qc, e1);
  Xe[t] = new ct(
    t,
    wn,
    !1,
    // mustUseProperty
    e,
    "http://www.w3.org/1999/xlink",
    !1,
    // sanitizeURL
    !1
  );
});
[
  "xml:base",
  "xml:lang",
  "xml:space"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach(function(e) {
  var t = e.replace(Qc, e1);
  Xe[t] = new ct(
    t,
    wn,
    !1,
    // mustUseProperty
    e,
    "http://www.w3.org/XML/1998/namespace",
    !1,
    // sanitizeURL
    !1
  );
});
["tabIndex", "crossOrigin"].forEach(function(e) {
  Xe[e] = new ct(
    e,
    wn,
    !1,
    // mustUseProperty
    e.toLowerCase(),
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
  );
});
var Pk = "xlinkHref";
Xe[Pk] = new ct(
  "xlinkHref",
  wn,
  !1,
  // mustUseProperty
  "xlink:href",
  "http://www.w3.org/1999/xlink",
  !0,
  // sanitizeURL
  !1
);
["src", "href", "action", "formAction"].forEach(function(e) {
  Xe[e] = new ct(
    e,
    wn,
    !1,
    // mustUseProperty
    e.toLowerCase(),
    // attributeName
    null,
    // attributeNamespace
    !0,
    // sanitizeURL
    !0
  );
});
var t1 = Gi, Ck = t1.CAMELCASE, Sk = t1.SAME, Uf = t1.possibleStandardNames, kk = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", Tk = kk + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", Ak = RegExp.prototype.test.bind(
  // eslint-disable-next-line no-misleading-character-class
  new RegExp("^(data|aria)-[" + Tk + "]*$")
), Ok = Object.keys(Uf).reduce(function(e, t) {
  var n = Uf[t];
  return n === Sk ? e[t] = t : n === Ck ? e[t.toLowerCase()] = t : e[t] = n, e;
}, {});
St.BOOLEAN = Xi;
St.BOOLEANISH_STRING = Yi;
St.NUMERIC = $m;
St.OVERLOADED_BOOLEAN = Jc;
St.POSITIVE_NUMERIC = Pm;
St.RESERVED = Em;
St.STRING = wn;
St.getPropertyInfo = Ek;
St.isCustomAttribute = Ak;
St.possibleStandardNames = Ok;
var n1 = {}, r1 = { exports: {} }, Wf = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, zk = /\n/g, Mk = /^\s*/, _k = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, Lk = /^:\s*/, Ik = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, Dk = /^[;\s]*/, Nk = /^\s+|\s+$/g, Rk = `
`, qf = "/", Zf = "*", kn = "", Bk = "comment", Vk = "declaration", Fk = function(e, t) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e)
    return [];
  t = t || {};
  var n = 1, r = 1;
  function a(E) {
    var b = E.match(zk);
    b && (n += b.length);
    var w = E.lastIndexOf(Rk);
    r = ~w ? E.length - w : r + E.length;
  }
  function i() {
    var E = { line: n, column: r };
    return function(b) {
      return b.position = new o(E), u(), b;
    };
  }
  function o(E) {
    this.start = E, this.end = { line: n, column: r }, this.source = t.source;
  }
  o.prototype.content = e;
  function l(E) {
    var b = new Error(
      t.source + ":" + n + ":" + r + ": " + E
    );
    if (b.reason = E, b.filename = t.source, b.line = n, b.column = r, b.source = e, !t.silent)
      throw b;
  }
  function s(E) {
    var b = E.exec(e);
    if (b) {
      var w = b[0];
      return a(w), e = e.slice(w.length), b;
    }
  }
  function u() {
    s(Mk);
  }
  function f(E) {
    var b;
    for (E = E || []; b = h(); )
      b !== !1 && E.push(b);
    return E;
  }
  function h() {
    var E = i();
    if (!(qf != e.charAt(0) || Zf != e.charAt(1))) {
      for (var b = 2; kn != e.charAt(b) && (Zf != e.charAt(b) || qf != e.charAt(b + 1)); )
        ++b;
      if (b += 2, kn === e.charAt(b - 1))
        return l("End of comment missing");
      var w = e.slice(2, b - 2);
      return r += 2, a(w), e = e.slice(b), r += 2, E({
        type: Bk,
        comment: w
      });
    }
  }
  function g() {
    var E = i(), b = s(_k);
    if (b) {
      if (h(), !s(Lk))
        return l("property missing ':'");
      var w = s(Ik), S = E({
        type: Vk,
        property: Gf(b[0].replace(Wf, kn)),
        value: w ? Gf(w[0].replace(Wf, kn)) : kn
      });
      return s(Dk), S;
    }
  }
  function v() {
    var E = [];
    f(E);
    for (var b; b = g(); )
      b !== !1 && (E.push(b), f(E));
    return E;
  }
  return u(), v();
};
function Gf(e) {
  return e ? e.replace(Nk, kn) : kn;
}
var Hk = Fk;
function Cm(e, t) {
  var n = null;
  if (!e || typeof e != "string")
    return n;
  for (var r, a = Hk(e), i = typeof t == "function", o, l, s = 0, u = a.length; s < u; s++)
    r = a[s], o = r.property, l = r.value, i ? t(o, l, r) : l && (n || (n = {}), n[o] = l);
  return n;
}
r1.exports = Cm;
r1.exports.default = Cm;
var Kk = r1.exports, Ji = {};
Object.defineProperty(Ji, "__esModule", { value: !0 });
Ji.camelCase = void 0;
var jk = /^--[a-zA-Z0-9-]+$/, Uk = /-([a-z])/g, Wk = /^[^-]+$/, qk = /^-(webkit|moz|ms|o|khtml)-/, Zk = /^-(ms)-/, Gk = function(e) {
  return !e || Wk.test(e) || jk.test(e);
}, Yk = function(e, t) {
  return t.toUpperCase();
}, Yf = function(e, t) {
  return "".concat(t, "-");
}, Xk = function(e, t) {
  return t === void 0 && (t = {}), Gk(e) ? e : (e = e.toLowerCase(), t.reactCompat ? e = e.replace(Zk, Yf) : e = e.replace(qk, Yf), e.replace(Uk, Yk));
};
Ji.camelCase = Xk;
var Jk = vt && vt.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(n1, "__esModule", { value: !0 });
var Qk = Jk(Kk), eT = Ji;
function tT(e, t) {
  var n = {};
  return !e || typeof e != "string" || (0, Qk.default)(e, function(r, a) {
    r && a && (n[(0, eT.camelCase)(r, t)] = a);
  }), n;
}
n1.default = tT;
var nT = oe, rT = n1.default;
function aT(e, t) {
  if (!e || typeof e != "object")
    throw new TypeError("First argument must be an object");
  var n = typeof t == "function", r = {}, a = {};
  for (var i in e) {
    var o = e[i];
    if (n && (r = t(i, o), r && r.length === 2)) {
      a[r[0]] = r[1];
      continue;
    }
    typeof o == "string" && (a[o] = i);
  }
  return a;
}
var iT = /* @__PURE__ */ new Set([
  "annotation-xml",
  "color-profile",
  "font-face",
  "font-face-src",
  "font-face-uri",
  "font-face-format",
  "font-face-name",
  "missing-glyph"
]);
function oT(e, t) {
  return e.indexOf("-") === -1 ? t && typeof t.is == "string" : !iT.has(e);
}
var lT = { reactCompat: !0 };
function sT(e, t) {
  if (e != null)
    try {
      t.style = rT(e, lT);
    } catch {
      t.style = {};
    }
}
var cT = nT.version.split(".")[0] >= 16, Sm = /* @__PURE__ */ new Set([
  "tr",
  "tbody",
  "thead",
  "tfoot",
  "colgroup",
  "table",
  "head",
  "html",
  "frameset"
]);
function uT(e) {
  return !Sm.has(e.name);
}
function dT(e) {
  return e;
}
var km = {
  PRESERVE_CUSTOM_ATTRIBUTES: cT,
  ELEMENTS_WITH_NO_TEXT_CHILDREN: Sm,
  invertObject: aT,
  isCustomComponent: oT,
  setStyleProp: sT,
  canTextBeChildOfNode: uT,
  returnFirstArg: dT
}, jr = St, Xf = km, fT = ["checked", "value"], pT = ["input", "select", "textarea"], hT = {
  reset: !0,
  submit: !0
}, Tm = function(t, n) {
  t = t || {};
  var r, a, i, o, l, s = {}, u = t.type && hT[t.type];
  for (r in t) {
    if (i = t[r], jr.isCustomAttribute(r)) {
      s[r] = i;
      continue;
    }
    if (a = r.toLowerCase(), o = Jf(a), o) {
      switch (l = jr.getPropertyInfo(o), fT.indexOf(o) !== -1 && pT.indexOf(n) !== -1 && !u && (o = Jf("default" + a)), s[o] = i, l && l.type) {
        case jr.BOOLEAN:
          s[o] = !0;
          break;
        case jr.OVERLOADED_BOOLEAN:
          i === "" && (s[o] = !0);
          break;
      }
      continue;
    }
    Xf.PRESERVE_CUSTOM_ATTRIBUTES && (s[r] = i);
  }
  return Xf.setStyleProp(t.style, s), s;
};
function Jf(e) {
  return jr.possibleStandardNames[e];
}
var vT = oe, mT = Tm, Jr = km, gT = Jr.setStyleProp, yT = Jr.canTextBeChildOfNode;
function Am(e, t) {
  t = t || {};
  for (var n = t.library || vT, r = n.cloneElement, a = n.createElement, i = n.isValidElement, o = [], l, s, u = typeof t.replace == "function", f = t.transform || Jr.returnFirstArg, h, g, v, E = t.trim, b = 0, w = e.length; b < w; b++) {
    if (l = e[b], u && (h = t.replace(l), i(h))) {
      w > 1 && (h = r(h, {
        key: h.key || b
      })), o.push(f(h, l, b));
      continue;
    }
    if (l.type === "text") {
      if (s = !l.data.trim().length, s && l.parent && !yT(l.parent) || E && s)
        continue;
      o.push(f(l.data, l, b));
      continue;
    }
    switch (g = l.attribs, bT(l) ? gT(g.style, g) : g && (g = mT(g, l.name)), v = null, l.type) {
      case "script":
      case "style":
        l.children[0] && (g.dangerouslySetInnerHTML = {
          __html: l.children[0].data
        });
        break;
      case "tag":
        l.name === "textarea" && l.children[0] ? g.defaultValue = l.children[0].data : l.children && l.children.length && (v = Am(l.children, t));
        break;
      default:
        continue;
    }
    w > 1 && (g.key = b), o.push(f(a(l.name, g, v), l, b));
  }
  return o.length === 1 ? o[0] : o;
}
function bT(e) {
  return Jr.PRESERVE_CUSTOM_ATTRIBUTES && e.type === "tag" && Jr.isCustomComponent(e.name, e.attribs);
}
var wT = Am, Qi = qc, cr = hk, xT = Tm, Om = wT;
cr = /* istanbul ignore next */
typeof cr.default == "function" ? cr.default : cr;
var ET = { lowerCaseAttributeNames: !1 };
function Nt(e, t) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  return e === "" ? [] : (t = t || {}, Om(
    cr(e, t.htmlparser2 || ET),
    t
  ));
}
Nt.domToReact = Om;
Nt.htmlToDOM = cr;
Nt.attributesToProps = xT;
Nt.Comment = Qi.Comment;
Nt.Element = Qi.Element;
Nt.ProcessingInstruction = Qi.ProcessingInstruction;
Nt.Text = Qi.Text;
var $T = Nt;
Nt.default = Nt;
const nn = /* @__PURE__ */ Jv($T);
var PT = nn.domToReact;
nn.htmlToDOM;
var CT = nn.attributesToProps;
nn.Comment;
nn.Element;
nn.ProcessingInstruction;
nn.Text;
function ST(e, t = ["a", "strong"]) {
  return nn(e, {
    replace: (r) => {
      if (r.name && !t.includes(r.name))
        return /* @__PURE__ */ H(De, {});
    }
  });
}
const zm = ({
  children: e,
  hint: t,
  imageUrl: n,
  imagePosition: r = "top",
  imageCaption: a = "decorative image",
  isDisabled: i = !1,
  isSelected: o = !1,
  isFocused: l = !1,
  className: s
}) => {
  const u = J(null);
  return re(() => {
    var f;
    (f = u.current) == null || f.addEventListener("click", (h) => {
      var g, v;
      (v = (g = u.current) == null ? void 0 : g.querySelector(".content label")) == null || v.dispatchEvent(new MouseEvent("click"));
    });
  }, []), /* @__PURE__ */ ie(
    "div",
    {
      "data-cy": "gudl-form-card",
      ref: u,
      className: ae(
        kT({ imagePosition: r, isDisabled: i, isSelected: o, isFocused: l }),
        s
      ),
      children: [
        n && /* @__PURE__ */ H(
          "figure",
          {
            className: ae(
              TT({ imagePosition: r, isSelected: o, isDisabled: i })
            ),
            children: /* @__PURE__ */ H(
              "img",
              {
                className: "h-full w-full object-cover object-center",
                src: n,
                alt: a
              }
            )
          }
        ),
        /* @__PURE__ */ ie("div", { className: "flex flex-1 flex-col justify-center p-4", children: [
          /* @__PURE__ */ H("div", { className: "content pointer-events-none", children: e }),
          /* @__PURE__ */ H(Ye, { variant: "label-sm", className: "text-neutral mt-2", children: t })
        ] })
      ]
    }
  );
}, kT = de(
  "overflow-hidden rounded-lg border border-neutral-300 flex bg-white transition-colors cursor-pointer",
  {
    variants: {
      imagePosition: {
        end: "flex-row-reverse",
        top: "flex-col"
      },
      isSelected: {
        true: "border-brand-accessible-blue"
      },
      isFocused: {
        true: "outline outline-2 outline-info"
      },
      isDisabled: {
        true: "border-neutral-200 cursor-not-allowed"
      }
    }
  }
), TT = de("opacity-75 transition-opacity", {
  variants: {
    imagePosition: {
      top: "h-[211px]",
      end: "h-[170px] w-[170px]"
    },
    isSelected: {
      true: "opacity-100"
    },
    isDisabled: {
      true: "opacity-50"
    }
  }
}), AT = de(
  "gudl-helper-message mt-1 flex items-center",
  {
    variants: {
      /**
       * Intent of the helper message.
       */
      intent: {
        info: "text-neutral-400",
        danger: "text-danger"
      }
    },
    defaultVariants: {
      intent: "info"
    }
  }
), gt = ({
  children: e,
  intent: t = "info",
  className: n,
  ...r
}) => /* @__PURE__ */ ie(
  "div",
  {
    className: ae(AT({ intent: t }), n),
    "data-cy": "gudl-helper-message",
    ...r,
    children: [
      /* @__PURE__ */ H(Le, { iconName: "alert-circle-outlined", size: "xs" }),
      t === "danger" && /* @__PURE__ */ H("span", { className: "sr-only", children: "Error: " }),
      /* @__PURE__ */ H(
        "span",
        {
          "data-cy": "gudl-helper-message-content",
          className: "text-label-xs ms-1",
          children: e
        }
      )
    ]
  }
), OT = de(
  "gudl-checkbox-box border h-5 w-5 rounded-[3px] ring-offset-1 ring-1 flex justify-center items-center overflow-hidden shrink-0 transition-all",
  {
    variants: {
      intent: {
        black: "bg-white border-neutral text-transparent",
        white: "bg-white/20 border-white text-transparent"
      },
      isSelected: {
        true: "bg-brand-accessible-blue border-brand-accessible-blue text-white"
      },
      isFocusVisible: {
        true: "ring-brand-accessible-blue ring-offset-white",
        false: "ring-offset-transparent ring-transparent"
      },
      isDisabled: { true: null }
    },
    compoundVariants: [
      {
        isDisabled: !0,
        intent: "black",
        class: "bg-neutral-100 border-neutral"
      },
      {
        isDisabled: !0,
        intent: "white",
        class: "bg-neutral-100 border-neutral"
      }
    ],
    defaultVariants: {
      intent: "black",
      isFocusVisible: !1,
      isSelected: !1,
      isDisabled: !1
    }
  }
), zT = de(
  "gudl-checkbox-text ms-2 transition-colors",
  {
    variants: {
      intent: {
        black: "text-black",
        white: "text-white"
      },
      multiLine: {
        true: "text-small-body",
        false: "text-label-lg"
      },
      isDisabled: {
        true: "text-neutral"
      }
    },
    defaultVariants: {
      intent: "black",
      multiLine: !1,
      isDisabled: !1
    }
  }
), tN = (e) => {
  const {
    children: t,
    name: n,
    multiLine: r,
    isDisabled: a = !1,
    intent: i,
    isRequired: o,
    errorMessage: l,
    helperMessage: s,
    validationState: u,
    labelClassName: f,
    className: h,
    onChange: g,
    card: v,
    cardOptions: E = {}
  } = e, b = P2(e), w = J(null), { inputProps: S } = S5(e, b, w), { isFocusVisible: T, focusProps: A } = vr(), V = b.isSelected, $ = () => /* @__PURE__ */ ie(
    "label",
    {
      className: ae(
        "relative flex cursor-pointer",
        r ? "items-top" : "items-center",
        a ? "cursor-not-allowed" : "cursor-pointer",
        f
      ),
      children: [
        /* @__PURE__ */ H(iv, { children: /* @__PURE__ */ H(
          "input",
          {
            ...S,
            ...A,
            ref: w,
            role: "checkbox",
            "aria-checked": a ? !1 : V,
            "aria-labelledby": n,
            "aria-disabled": a,
            "data-cy": "gudl-checkbox",
            onChange: g || S.onChange
          }
        ) }),
        /* @__PURE__ */ H(
          "div",
          {
            className: ae(
              OT({
                intent: i,
                isSelected: V,
                isFocusVisible: T,
                isDisabled: a
              })
            ),
            "data-cy": "gudl-checkbox-box",
            children: V && !a && /* @__PURE__ */ H(Le, { iconName: "check", size: "sm" })
          }
        ),
        /* @__PURE__ */ ie(
          "span",
          {
            className: ae(
              zT({ intent: i, multiLine: r, isDisabled: a })
            ),
            id: n,
            "data-cy": "gudl-checkbox-label",
            children: [
              typeof t == "string" ? ST(t) : t,
              o && /* @__PURE__ */ ie(De, { children: [
                /* @__PURE__ */ H("span", { className: "text-brand-accessible-blue", "aria-hidden": "true", children: " *" }),
                /* @__PURE__ */ H("span", { className: "hidden", children: "required" })
              ] })
            ]
          }
        )
      ]
    }
  );
  return /* @__PURE__ */ ie("div", { className: h, children: [
    v ? /* @__PURE__ */ H(
      zm,
      {
        isSelected: V,
        isDisabled: a,
        isFocused: T,
        ...E,
        children: $()
      }
    ) : $(),
    u === "invalid" && l && /* @__PURE__ */ H(gt, { intent: "danger", children: l }),
    s && /* @__PURE__ */ H(gt, { children: s })
  ] });
}, MT = de(
  "rounded-full text-[14px]/[20px] px-4 py-2 border border-[#a3a3a3] text-black bg-[#fafafa] inline-block transition-colors cursor-pointer focus:outline-1 focus:outline-offset-4 focus:outline-brand-accessible-blue",
  {
    variants: {
      disabled: {
        true: "disabled:text-[#a3a3a3] disabled:border-[#a3a3a3] disabled:cursor-not-allowed"
      },
      selected: {
        true: "border-black bg-black text-white",
        false: "enabled:hover:text-white enabled:hover:bg-[#525252] enabled:hover:border-[#525252]"
      }
    }
  }
), nN = (e) => {
  const t = J(null), n = P2(e), { buttonProps: r } = g5(e, n, t);
  return /* @__PURE__ */ H(
    "button",
    {
      ...r,
      "data-cy": "gudl-chip",
      className: ae(
        MT({ disabled: e.isDisabled, selected: n.isSelected }),
        e.className
      ),
      disabled: e.isDisabled,
      children: e.children
    }
  );
}, _T = de(
  "flex h-[56px] items-center justify-between relative rounded-lg border border-neutral-300 focus-within:border-brand-accessible-blue bg-white ring-inset transition-all focus-within:ring-1 focus-within:ring-brand-accessible-blue",
  {
    variants: {
      disabled: {
        true: "bg-neutral-50 border-neutral-200 cursor-not-allowed border"
      },
      error: {
        true: "border-danger ring-danger focus-within:border-danger focus-within:ring-danger ring-1"
      }
    },
    defaultVariants: {
      disabled: !1,
      error: !1
    }
  }
), LT = de(
  "peer text-left rtl:text-right focus:text-black  w-max min-w-full border-none bg-transparent  focus:border-0 text-label-md peer z-10 pt-6 appearance-none border-0  px-4 pb-2 text-base text-neutral-800  ring-0 focus:outline-none focus:ring-0 disabled:cursor-not-allowed disabled:text-neutral-400 opacity-0  focus-within:opacity-100",
  {
    variants: {
      withValue: {
        true: "opacity-100"
      }
    },
    defaultVariants: {
      withValue: !1
    }
  }
), IT = de(
  "text-label-md absolute start-4 z-10 origin-top-left rtl:origin-top-right text-neutral-500  transition-transform duration-150 ease-standard pointer-events-none scale-100 translate-y-0 peer-focus-within:scale-75 peer-focus-within:-translate-y-2 transform",
  {
    variants: {
      disabled: {
        true: "text-neutral-400 cursor-not-allowed"
      },
      withValue: {
        true: "-translate-y-2 scale-75",
        false: ""
      }
    },
    defaultVariants: {
      withValue: !1,
      disabled: !1
    }
  }
), DT = de(
  "absolute end-2 z-10 inline-flex h-[52px] w-8 cursor-default items-center justify-center bg-white text-neutral-800",
  {
    variants: {
      disabled: {
        true: "bg-neutral-50 cursor-not-allowed"
      }
    },
    defaultVariants: {
      disabled: !1
    }
  }
), rN = (e) => {
  const {
    disabled: t,
    required: n,
    validationState: r,
    helperMessage: a,
    touched: i,
    errorMessage: o,
    value: l,
    label: s,
    onChange: u,
    onBlur: f,
    name: h,
    containerClassName: g,
    inputClassName: v,
    labelClassName: E,
    className: b,
    ...w
  } = e, S = J(null), T = () => {
    S != null && S.current && S.current.showPicker();
  }, A = !!l;
  return /* @__PURE__ */ ie("div", { className: b, children: [
    /* @__PURE__ */ ie(
      "div",
      {
        "data-cy": "gudl-datepicker-container",
        className: ae(
          _T({
            error: r === "invalid",
            disabled: t
          }),
          g
        ),
        children: [
          /* @__PURE__ */ H(
            "input",
            {
              "data-cy": "gudl-datepicker-input",
              ref: S,
              name: h,
              type: "date",
              className: ae(
                LT({
                  withValue: A
                }),
                v
              ),
              disabled: t,
              value: l || "",
              onChange: u,
              onBlur: f,
              ...w
            }
          ),
          /* @__PURE__ */ H(
            "label",
            {
              className: ae(
                IT({ disabled: t, withValue: A }),
                E
              ),
              "data-cy": "gudl-datepicker-label",
              children: /* @__PURE__ */ ie("span", { children: [
                s,
                n && /* @__PURE__ */ ie(De, { children: [
                  /* @__PURE__ */ H("span", { className: "required  text-info", "aria-hidden": !0, children: " *" }),
                  /* @__PURE__ */ H("span", { className: "hidden", children: "required" })
                ] })
              ] })
            }
          ),
          /* @__PURE__ */ H(
            "div",
            {
              onClick: T,
              role: "button",
              "aria-haspopup": "menu",
              "aria-label": "Show date picker",
              className: ae(DT({ disabled: t })),
              children: /* @__PURE__ */ H(
                Le,
                {
                  iconName: "calendar-outlined",
                  className: "cursor-default",
                  size: "sm"
                }
              )
            }
          ),
          !t && r === "invalid" && /* @__PURE__ */ H(
            Le,
            {
              className: "text-danger absolute end-[41px]",
              iconName: "alert-circle-outlined",
              size: "sm"
            }
          ),
          !t && r !== "invalid" && i && /* @__PURE__ */ H(
            Le,
            {
              className: "text-success absolute end-[41px]",
              iconName: "check-circle-outlined",
              size: "sm"
            }
          )
        ]
      }
    ),
    r === "invalid" && o && /* @__PURE__ */ H(gt, { intent: "danger", children: o }),
    a && /* @__PURE__ */ H(gt, { children: a })
  ] });
}, NT = de("border-t-1 rounded-lg border-black", {
  variants: {
    light: {
      true: "border-neutral-300"
    }
  }
}), aN = ({
  light: e = !1,
  className: t
}) => /* @__PURE__ */ H("hr", { className: ae(NT({ light: e }), t) }), RT = de("w-full overflow-hidden", {
  variants: {
    /**
     * The aspect ratio of the image card image.
     */
    aspectRatio: {
      "2/3": "aspect-2/3",
      "3/2": "aspect-3/2",
      "4/3": "aspect-4/3",
      "3/4": "aspect-3/4",
      "5/3": "aspect-5/3",
      "7/5": "aspect-7/5",
      "5/7": "aspect-5/7",
      "16/9": "aspect-16/9",
      "9/16": "aspect-9/16",
      "21/9": "aspect-21/9",
      "1/1": "aspect-1/1"
    }
  }
}), BT = ({ tags: e }) => /* @__PURE__ */ H(
  "div",
  {
    className: "order-last flex flex-wrap gap-2 px-4 pt-4",
    "data-cy": "gudl-image-card-tags",
    children: e.slice(0, 2).map(
      (t, n) => t && /* @__PURE__ */ H(
        $1,
        {
          size: "sm",
          iconName: t.iconName,
          intent: t.variant,
          contentClassName: "line-clamp-1",
          className: "max-w-none",
          "data-cy": "gudl-image-card-tag",
          children: t.text
        },
        n
      )
    )
  }
), iN = ({
  image: e,
  title: t,
  className: n,
  contentClassName: r,
  href: a,
  hrefTarget: i = "_self",
  "aria-label": o,
  tags: l,
  description: s,
  eyebrow: u,
  aspectRatio: f = "9/16",
  dataInfo: h,
  onCardPress: g,
  style: v = "default",
  children: E,
  showGradient: b = !0
}) => {
  const w = a ? "a" : "article", S = h && { "data-info": h }, T = a && { role: "link", target: i, href: a }, A = g && { role: "button", onClick: g }, V = !!a || !!g, $ = {
    default: "heading-5-bold",
    centered: "heading-3-bold"
  }, _ = {
    default: "paragraph-body",
    centered: "paragraph-small-body"
  };
  return /* @__PURE__ */ ie(
    w,
    {
      className: ae(
        "group/card relative w-full overflow-hidden rounded-lg shadow",
        w === "a" && "block",
        n
      ),
      "aria-label": o,
      "data-cy": "gudl-image-card",
      ...S,
      ...T,
      ...A,
      children: [
        /* @__PURE__ */ ie(
          "div",
          {
            className: ae(
              "absolute bottom-0 end-0 start-0 top-0 z-20 flex h-full w-full flex-col-reverse justify-between gap-2",
              v === "centered" && "flex-col"
            ),
            children: [
              l && /* @__PURE__ */ H(BT, { tags: l }),
              /* @__PURE__ */ ie(
                "div",
                {
                  className: ae(
                    "space-y-2 hyphens-auto px-6 pb-6 text-white",
                    v === "centered" && "absolute bottom-0 end-0 start-0 top-0 flex h-full w-full flex-col items-center justify-center text-center",
                    r
                  ),
                  "data-cy": "gudl-image-card-content",
                  children: [
                    v !== "centered" && u && /* @__PURE__ */ H(Ye, { variant: "special-eyebrow", "data-cy": "gudl-image-card-eyebrow", children: u }),
                    t && /* @__PURE__ */ H(Ye, { variant: $[v], "data-cy": "gudl-image-card-title", children: t }),
                    s && /* @__PURE__ */ H(
                      Ye,
                      {
                        variant: _[v],
                        "data-cy": "gudl-image-card-description",
                        children: s
                      }
                    ),
                    E
                  ]
                }
              )
            ]
          }
        ),
        b && /* @__PURE__ */ H(
          "div",
          {
            "data-cy": "gudl-image-card-gradient",
            className: "absolute bottom-0 end-0 start-0 top-0 z-10 bg-gradient-to-t from-black to-transparent opacity-85"
          }
        ),
        /* @__PURE__ */ H("figure", { className: "overflow-hidden", children: oe.isValidElement(e) && oe.cloneElement(e, {
          className: ae(
            "relative w-auto object-cover object-center",
            V && "ease-expressive transition-all duration-300  md:group-hover/card:scale-105",
            RT({ aspectRatio: f })
          ),
          "data-cy": "gudl-image-card-image"
        }) })
      ]
    }
  );
}, VT = de(
  "luik-link focus:outline outline-2 outline-offset-1 outline-brand-accessible-blue",
  {
    variants: {
      color: {
        primary: "text-brand-accessible-blue",
        secondary: "text-black ",
        light: "text-white"
      },
      size: {
        sm: "text-sm",
        base: "text-lg"
      },
      disabled: {
        true: "cursor-not-allowed"
      }
    },
    defaultVariants: {
      color: "primary",
      size: "base"
    }
  }
), FT = (e) => {
  const t = oe.useRef(null), {
    children: n,
    href: r,
    disabled: a = !1,
    color: i = "primary",
    size: o = "base",
    iconName: l,
    iconPosition: s = "end",
    className: u,
    ...f
  } = e, { linkProps: h } = h2(
    { ...e, elementType: "a", isDisabled: a },
    t
  ), v = [
    l ? `font-normal px-2 ${{
      primary: "hover:text-black",
      secondary: "hover:text-brand-accessible-blue",
      light: "hover:text-neutral-400"
    }[i]}` : "font-bold underline decoration-1 hover:decoration-2"
  ];
  return /* @__PURE__ */ ie(
    "a",
    {
      ...h,
      href: r,
      ref: t,
      className: ae(
        VT({
          color: i,
          size: o,
          disabled: a
        }),
        v,
        l && "inline-flex items-center gap-2",
        u
      ),
      ...f,
      children: [
        n,
        l && /* @__PURE__ */ H(
          Le,
          {
            iconName: l,
            size: "sm",
            className: _n(
              s === "start" ? "order-first" : "order-last"
            )
          }
        )
      ]
    }
  );
}, HT = de(
  "gudl-icon rounded-full flex flex-col justify-center",
  {
    variants: {
      hasBackground: {
        true: "p-4 bg-opacity-100 text-white mt-1",
        false: "p-[1.5px] bg-opacity-0 h-6 lg:h-7"
      },
      colorVariant: {
        light: "text-white",
        dark: "text-black"
      }
    },
    compoundVariants: [
      {
        hasBackground: !0,
        colorVariant: "light",
        class: "text-black bg-white"
      },
      {
        hasBackground: !0,
        colorVariant: "dark",
        class: "text-white bg-black"
      }
    ]
  }
), KT = de("flex w-full items-start gap-4 p-0", {
  variants: {
    colorVariant: {
      light: "text-white",
      dark: "text-black"
    }
  }
}), oN = ({
  iconName: e,
  asDiv: t = !1,
  iconSize: n = "base",
  hasBackground: r = !1,
  iconColor: a,
  iconBackgroundClassName: i,
  title: o,
  text: l,
  titleVariant: s = "heading-5-bold",
  colorVariant: u = "dark",
  className: f = ""
}) => /* @__PURE__ */ ie(
  t ? "div" : "li",
  {
    className: ae(KT({ colorVariant: u }), f),
    "data-cy": "gudl-list-item",
    children: [
      /* @__PURE__ */ H(
        "div",
        {
          className: ae(
            HT({
              hasBackground: r,
              colorVariant: u
            }),
            i
          ),
          "data-cy": "gudl-list-item-icon-wrapper",
          children: /* @__PURE__ */ H(Le, { size: n, color: a, iconName: e })
        }
      ),
      /* @__PURE__ */ ie("div", { className: "flex flex-col justify-start gap-2", children: [
        o && /* @__PURE__ */ H(Ye, { variant: s, children: /* @__PURE__ */ H("span", { "data-cy": "gudl-list-item-title", children: o }) }),
        l && /* @__PURE__ */ H(Ye, { variant: "paragraph-body", children: /* @__PURE__ */ H("span", { "data-cy": "gudl-list-item-text", children: l }) })
      ] })
    ]
  }
);
var Mm = {}, _m = {}, Ae = {}, jT = function(t, n, r) {
  var a = document.head || document.getElementsByTagName("head")[0], i = document.createElement("script");
  typeof n == "function" && (r = n, n = {}), n = n || {}, r = r || function() {
  }, i.type = n.type || "text/javascript", i.charset = n.charset || "utf8", i.async = "async" in n ? !!n.async : !0, i.src = t, n.attrs && UT(i, n.attrs), n.text && (i.text = "" + n.text);
  var o = "onload" in i ? Qf : WT;
  o(i, r), i.onload || Qf(i, r), a.appendChild(i);
};
function UT(e, t) {
  for (var n in t)
    e.setAttribute(n, t[n]);
}
function Qf(e, t) {
  e.onload = function() {
    this.onerror = this.onload = null, t(null, e);
  }, e.onerror = function() {
    this.onerror = this.onload = null, t(new Error("Failed to load " + this.src), e);
  };
}
function WT(e, t) {
  e.onreadystatechange = function() {
    this.readyState != "complete" && this.readyState != "loaded" || (this.onreadystatechange = null, t(null, e));
  };
}
var qT = function(t) {
  return ZT(t) && !GT(t);
};
function ZT(e) {
  return !!e && typeof e == "object";
}
function GT(e) {
  var t = Object.prototype.toString.call(e);
  return t === "[object RegExp]" || t === "[object Date]" || JT(e);
}
var YT = typeof Symbol == "function" && Symbol.for, XT = YT ? Symbol.for("react.element") : 60103;
function JT(e) {
  return e.$$typeof === XT;
}
function QT(e) {
  return Array.isArray(e) ? [] : {};
}
function Qr(e, t) {
  return t.clone !== !1 && t.isMergeableObject(e) ? fr(QT(e), e, t) : e;
}
function eA(e, t, n) {
  return e.concat(t).map(function(r) {
    return Qr(r, n);
  });
}
function tA(e, t) {
  if (!t.customMerge)
    return fr;
  var n = t.customMerge(e);
  return typeof n == "function" ? n : fr;
}
function nA(e) {
  return Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols(e).filter(function(t) {
    return Object.propertyIsEnumerable.call(e, t);
  }) : [];
}
function ep(e) {
  return Object.keys(e).concat(nA(e));
}
function Lm(e, t) {
  try {
    return t in e;
  } catch {
    return !1;
  }
}
function rA(e, t) {
  return Lm(e, t) && !(Object.hasOwnProperty.call(e, t) && Object.propertyIsEnumerable.call(e, t));
}
function aA(e, t, n) {
  var r = {};
  return n.isMergeableObject(e) && ep(e).forEach(function(a) {
    r[a] = Qr(e[a], n);
  }), ep(t).forEach(function(a) {
    rA(e, a) || (Lm(e, a) && n.isMergeableObject(t[a]) ? r[a] = tA(a, n)(e[a], t[a], n) : r[a] = Qr(t[a], n));
  }), r;
}
function fr(e, t, n) {
  n = n || {}, n.arrayMerge = n.arrayMerge || eA, n.isMergeableObject = n.isMergeableObject || qT, n.cloneUnlessOtherwiseSpecified = Qr;
  var r = Array.isArray(t), a = Array.isArray(e), i = r === a;
  return i ? r ? n.arrayMerge(e, t, n) : aA(e, t, n) : Qr(t, n);
}
fr.all = function(t, n) {
  if (!Array.isArray(t))
    throw new Error("first argument should be an array");
  return t.reduce(function(r, a) {
    return fr(r, a, n);
  }, {});
};
var iA = fr, Im = iA;
Object.defineProperty(Ae, "__esModule", {
  value: !0
});
Ae.parseStartTime = gA;
Ae.parseEndTime = yA;
Ae.randomString = bA;
Ae.queryString = wA;
Ae.getSDK = xA;
Ae.getConfig = EA;
Ae.omit = $A;
Ae.callPlayer = PA;
Ae.isMediaStream = CA;
Ae.isBlobUrl = SA;
Ae.supportsWebKitPresentationMode = kA;
var oA = Dm(jT), lA = Dm(Im);
function Dm(e) {
  return e && e.__esModule ? e : { default: e };
}
function sA(e, t) {
  return fA(e) || dA(e, t) || uA(e, t) || cA();
}
function cA() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function uA(e, t) {
  if (e) {
    if (typeof e == "string")
      return tp(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return tp(e, t);
  }
}
function tp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function dA(e, t) {
  if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(e)))) {
    var n = [], r = !0, a = !1, i = void 0;
    try {
      for (var o = e[Symbol.iterator](), l; !(r = (l = o.next()).done) && (n.push(l.value), !(t && n.length === t)); r = !0)
        ;
    } catch (s) {
      a = !0, i = s;
    } finally {
      try {
        !r && o.return != null && o.return();
      } finally {
        if (a)
          throw i;
      }
    }
    return n;
  }
}
function fA(e) {
  if (Array.isArray(e))
    return e;
}
var pA = /[?&#](?:start|t)=([0-9hms]+)/, hA = /[?&#]end=([0-9hms]+)/, uc = /(\d+)(h|m|s)/g, vA = /^\d+$/;
function Nm(e, t) {
  if (!(e instanceof Array)) {
    var n = e.match(t);
    if (n) {
      var r = n[1];
      if (r.match(uc))
        return mA(r);
      if (vA.test(r))
        return parseInt(r);
    }
  }
}
function mA(e) {
  for (var t = 0, n = uc.exec(e); n !== null; ) {
    var r = n, a = sA(r, 3), i = a[1], o = a[2];
    o === "h" && (t += parseInt(i, 10) * 60 * 60), o === "m" && (t += parseInt(i, 10) * 60), o === "s" && (t += parseInt(i, 10)), n = uc.exec(e);
  }
  return t;
}
function gA(e) {
  return Nm(e, pA);
}
function yA(e) {
  return Nm(e, hA);
}
function bA() {
  return Math.random().toString(36).substr(2, 5);
}
function wA(e) {
  return Object.keys(e).map(function(t) {
    return "".concat(t, "=").concat(e[t]);
  }).join("&");
}
function fs(e) {
  return window[e] ? window[e] : window.exports && window.exports[e] ? window.exports[e] : window.module && window.module.exports && window.module.exports[e] ? window.module.exports[e] : null;
}
var er = {};
function xA(e, t) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : function() {
    return !0;
  }, a = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : oA.default, i = fs(t);
  return i && r(i) ? Promise.resolve(i) : new Promise(function(o, l) {
    if (er[e]) {
      er[e].push({
        resolve: o,
        reject: l
      });
      return;
    }
    er[e] = [{
      resolve: o,
      reject: l
    }];
    var s = function(h) {
      er[e].forEach(function(g) {
        return g.resolve(h);
      });
    };
    if (n) {
      var u = window[n];
      window[n] = function() {
        u && u(), s(fs(t));
      };
    }
    a(e, function(f) {
      f ? (er[e].forEach(function(h) {
        return h.reject(f);
      }), er[e] = null) : n || s(fs(t));
    });
  });
}
function EA(e, t) {
  return (0, lA.default)(t.config, e.config);
}
function $A(e) {
  for (var t, n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), a = 1; a < n; a++)
    r[a - 1] = arguments[a];
  for (var i = (t = []).concat.apply(t, r), o = {}, l = Object.keys(e), s = 0, u = l; s < u.length; s++) {
    var f = u[s];
    i.indexOf(f) === -1 && (o[f] = e[f]);
  }
  return o;
}
function PA(e) {
  var t;
  if (!this.player || !this.player[e]) {
    var n = "ReactPlayer: ".concat(this.constructor.displayName, " player could not call %c").concat(e, "%c – ");
    return this.player ? this.player[e] || (n += "The method was not available") : n += "The player was not available", console.warn(n, "font-weight: bold", ""), null;
  }
  for (var r = arguments.length, a = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)
    a[i - 1] = arguments[i];
  return (t = this.player)[e].apply(t, a);
}
function CA(e) {
  return typeof window < "u" && typeof window.MediaStream < "u" && e instanceof window.MediaStream;
}
function SA(e) {
  return /^blob:/.test(e);
}
function kA() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document.createElement("video"), t = /iPhone|iPod/.test(navigator.userAgent) === !1;
  return e.webkitSupportsPresentationMode && typeof e.webkitSetPresentationMode == "function" && t;
}
var fe = {};
Object.defineProperty(fe, "__esModule", {
  value: !0
});
fe.canPlay = fe.FLV_EXTENSIONS = fe.DASH_EXTENSIONS = fe.HLS_EXTENSIONS = fe.VIDEO_EXTENSIONS = fe.AUDIO_EXTENSIONS = fe.MATCH_URL_KALTURA = fe.MATCH_URL_VIDYARD = fe.MATCH_URL_MIXCLOUD = fe.MATCH_URL_DAILYMOTION = fe.MATCH_URL_TWITCH_CHANNEL = fe.MATCH_URL_TWITCH_VIDEO = fe.MATCH_URL_WISTIA = fe.MATCH_URL_STREAMABLE = fe.MATCH_URL_FACEBOOK_WATCH = fe.MATCH_URL_FACEBOOK = fe.MATCH_URL_VIMEO = fe.MATCH_URL_SOUNDCLOUD = fe.MATCH_URL_YOUTUBE = void 0;
var np = Ae;
function TA(e, t) {
  var n;
  if (typeof Symbol > "u" || e[Symbol.iterator] == null) {
    if (Array.isArray(e) || (n = AA(e)) || t && e && typeof e.length == "number") {
      n && (e = n);
      var r = 0, a = function() {
      };
      return { s: a, n: function() {
        return r >= e.length ? { done: !0 } : { done: !1, value: e[r++] };
      }, e: function(u) {
        throw u;
      }, f: a };
    }
    throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var i = !0, o = !1, l;
  return { s: function() {
    n = e[Symbol.iterator]();
  }, n: function() {
    var u = n.next();
    return i = u.done, u;
  }, e: function(u) {
    o = !0, l = u;
  }, f: function() {
    try {
      !i && n.return != null && n.return();
    } finally {
      if (o)
        throw l;
    }
  } };
}
function AA(e, t) {
  if (e) {
    if (typeof e == "string")
      return rp(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return rp(e, t);
  }
}
function rp(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
var dc = /(?:youtu\.be\/|youtube(?:-nocookie|education)?\.com\/(?:embed\/|v\/|watch\/|watch\?v=|watch\?.+&v=|shorts\/|live\/))((\w|-){11})|youtube\.com\/playlist\?list=|youtube\.com\/user\//;
fe.MATCH_URL_YOUTUBE = dc;
var Rm = /(?:soundcloud\.com|snd\.sc)\/[^.]+$/;
fe.MATCH_URL_SOUNDCLOUD = Rm;
var Bm = /vimeo\.com\/(?!progressive_redirect).+/;
fe.MATCH_URL_VIMEO = Bm;
var Vm = /^https?:\/\/(www\.)?facebook\.com.*\/(video(s)?|watch|story)(\.php?|\/).+$/;
fe.MATCH_URL_FACEBOOK = Vm;
var Fm = /^https?:\/\/fb\.watch\/.+$/;
fe.MATCH_URL_FACEBOOK_WATCH = Fm;
var Hm = /streamable\.com\/([a-z0-9]+)$/;
fe.MATCH_URL_STREAMABLE = Hm;
var Km = /(?:wistia\.(?:com|net)|wi\.st)\/(?:medias|embed)\/(?:iframe\/)?([^?]+)/;
fe.MATCH_URL_WISTIA = Km;
var jm = /(?:www\.|go\.)?twitch\.tv\/videos\/(\d+)($|\?)/;
fe.MATCH_URL_TWITCH_VIDEO = jm;
var Um = /(?:www\.|go\.)?twitch\.tv\/([a-zA-Z0-9_]+)($|\?)/;
fe.MATCH_URL_TWITCH_CHANNEL = Um;
var Wm = /^(?:(?:https?):)?(?:\/\/)?(?:www\.)?(?:(?:dailymotion\.com(?:\/embed)?\/video)|dai\.ly)\/([a-zA-Z0-9]+)(?:_[\w_-]+)?(?:[\w.#_-]+)?/;
fe.MATCH_URL_DAILYMOTION = Wm;
var qm = /mixcloud\.com\/([^/]+\/[^/]+)/;
fe.MATCH_URL_MIXCLOUD = qm;
var Zm = /vidyard.com\/(?:watch\/)?([a-zA-Z0-9-_]+)/;
fe.MATCH_URL_VIDYARD = Zm;
var Gm = /^https?:\/\/[a-zA-Z]+\.kaltura.(com|org)\/p\/([0-9]+)\/sp\/([0-9]+)00\/embedIframeJs\/uiconf_id\/([0-9]+)\/partner_id\/([0-9]+)(.*)entry_id.([a-zA-Z0-9-_].*)$/;
fe.MATCH_URL_KALTURA = Gm;
var a1 = /\.(m4a|m4b|mp4a|mpga|mp2|mp2a|mp3|m2a|m3a|wav|weba|aac|oga|spx)($|\?)/i;
fe.AUDIO_EXTENSIONS = a1;
var i1 = /\.(mp4|og[gv]|webm|mov|m4v)(#t=[,\d+]+)?($|\?)/i;
fe.VIDEO_EXTENSIONS = i1;
var o1 = /\.(m3u8)($|\?)/i;
fe.HLS_EXTENSIONS = o1;
var Ym = /\.(mpd)($|\?)/i;
fe.DASH_EXTENSIONS = Ym;
var Xm = /\.(flv)($|\?)/i;
fe.FLV_EXTENSIONS = Xm;
var OA = function e(t) {
  if (t instanceof Array) {
    var n = TA(t), r;
    try {
      for (n.s(); !(r = n.n()).done; ) {
        var a = r.value;
        if (typeof a == "string" && e(a) || e(a.src))
          return !0;
      }
    } catch (i) {
      n.e(i);
    } finally {
      n.f();
    }
    return !1;
  }
  return (0, np.isMediaStream)(t) || (0, np.isBlobUrl)(t) ? !0 : a1.test(t) || i1.test(t) || o1.test(t) || Ym.test(t) || Xm.test(t);
}, zA = {
  youtube: function(t) {
    return t instanceof Array ? t.every(function(n) {
      return dc.test(n);
    }) : dc.test(t);
  },
  soundcloud: function(t) {
    return Rm.test(t) && !a1.test(t);
  },
  vimeo: function(t) {
    return Bm.test(t) && !i1.test(t) && !o1.test(t);
  },
  facebook: function(t) {
    return Vm.test(t) || Fm.test(t);
  },
  streamable: function(t) {
    return Hm.test(t);
  },
  wistia: function(t) {
    return Km.test(t);
  },
  twitch: function(t) {
    return jm.test(t) || Um.test(t);
  },
  dailymotion: function(t) {
    return Wm.test(t);
  },
  mixcloud: function(t) {
    return qm.test(t);
  },
  vidyard: function(t) {
    return Zm.test(t);
  },
  kaltura: function(t) {
    return Gm.test(t);
  },
  file: OA
};
fe.canPlay = zA;
var ps = {}, ap;
function MA() {
  return ap || (ap = 1, function(e) {
    function t(C) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(k) {
        return typeof k;
      } : t = function(k) {
        return k && typeof Symbol == "function" && k.constructor === Symbol && k !== Symbol.prototype ? "symbol" : typeof k;
      }, t(C);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = o(oe), r = Ae, a = fe;
    function i() {
      if (typeof WeakMap != "function")
        return null;
      var C = /* @__PURE__ */ new WeakMap();
      return i = function() {
        return C;
      }, C;
    }
    function o(C) {
      if (C && C.__esModule)
        return C;
      if (C === null || t(C) !== "object" && typeof C != "function")
        return { default: C };
      var L = i();
      if (L && L.has(C))
        return L.get(C);
      var k = {}, M = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var F in C)
        if (Object.prototype.hasOwnProperty.call(C, F)) {
          var j = M ? Object.getOwnPropertyDescriptor(C, F) : null;
          j && (j.get || j.set) ? Object.defineProperty(k, F, j) : k[F] = C[F];
        }
      return k.default = C, L && L.set(C, k), k;
    }
    function l(C, L) {
      var k = Object.keys(C);
      if (Object.getOwnPropertySymbols) {
        var M = Object.getOwnPropertySymbols(C);
        L && (M = M.filter(function(F) {
          return Object.getOwnPropertyDescriptor(C, F).enumerable;
        })), k.push.apply(k, M);
      }
      return k;
    }
    function s(C) {
      for (var L = 1; L < arguments.length; L++) {
        var k = arguments[L] != null ? arguments[L] : {};
        L % 2 ? l(Object(k), !0).forEach(function(M) {
          p(C, M, k[M]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(C, Object.getOwnPropertyDescriptors(k)) : l(Object(k)).forEach(function(M) {
          Object.defineProperty(C, M, Object.getOwnPropertyDescriptor(k, M));
        });
      }
      return C;
    }
    function u(C, L) {
      return E(C) || v(C, L) || h(C, L) || f();
    }
    function f() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function h(C, L) {
      if (C) {
        if (typeof C == "string")
          return g(C, L);
        var k = Object.prototype.toString.call(C).slice(8, -1);
        if (k === "Object" && C.constructor && (k = C.constructor.name), k === "Map" || k === "Set")
          return Array.from(C);
        if (k === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(k))
          return g(C, L);
      }
    }
    function g(C, L) {
      (L == null || L > C.length) && (L = C.length);
      for (var k = 0, M = new Array(L); k < L; k++)
        M[k] = C[k];
      return M;
    }
    function v(C, L) {
      if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(C)))) {
        var k = [], M = !0, F = !1, j = void 0;
        try {
          for (var U = C[Symbol.iterator](), G; !(M = (G = U.next()).done) && (k.push(G.value), !(L && k.length === L)); M = !0)
            ;
        } catch (X) {
          F = !0, j = X;
        } finally {
          try {
            !M && U.return != null && U.return();
          } finally {
            if (F)
              throw j;
          }
        }
        return k;
      }
    }
    function E(C) {
      if (Array.isArray(C))
        return C;
    }
    function b(C, L) {
      if (!(C instanceof L))
        throw new TypeError("Cannot call a class as a function");
    }
    function w(C, L) {
      for (var k = 0; k < L.length; k++) {
        var M = L[k];
        M.enumerable = M.enumerable || !1, M.configurable = !0, "value" in M && (M.writable = !0), Object.defineProperty(C, M.key, M);
      }
    }
    function S(C, L, k) {
      return L && w(C.prototype, L), k && w(C, k), C;
    }
    function T(C, L) {
      if (typeof L != "function" && L !== null)
        throw new TypeError("Super expression must either be null or a function");
      C.prototype = Object.create(L && L.prototype, { constructor: { value: C, writable: !0, configurable: !0 } }), L && A(C, L);
    }
    function A(C, L) {
      return A = Object.setPrototypeOf || function(M, F) {
        return M.__proto__ = F, M;
      }, A(C, L);
    }
    function V(C) {
      var L = y();
      return function() {
        var M = c(C), F;
        if (L) {
          var j = c(this).constructor;
          F = Reflect.construct(M, arguments, j);
        } else
          F = M.apply(this, arguments);
        return $(this, F);
      };
    }
    function $(C, L) {
      return L && (t(L) === "object" || typeof L == "function") ? L : _(C);
    }
    function _(C) {
      if (C === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return C;
    }
    function y() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function c(C) {
      return c = Object.setPrototypeOf ? Object.getPrototypeOf : function(k) {
        return k.__proto__ || Object.getPrototypeOf(k);
      }, c(C);
    }
    function p(C, L, k) {
      return L in C ? Object.defineProperty(C, L, { value: k, enumerable: !0, configurable: !0, writable: !0 }) : C[L] = k, C;
    }
    var d = "https://www.youtube.com/iframe_api", m = "YT", O = "onYouTubeIframeAPIReady", x = /[?&](?:list|channel)=([a-zA-Z0-9_-]+)/, P = /user\/([a-zA-Z0-9_-]+)\/?/, N = /youtube-nocookie\.com/, D = "https://www.youtube-nocookie.com", I = /* @__PURE__ */ function(C) {
      T(k, C);
      var L = V(k);
      function k() {
        var M;
        b(this, k);
        for (var F = arguments.length, j = new Array(F), U = 0; U < F; U++)
          j[U] = arguments[U];
        return M = L.call.apply(L, [this].concat(j)), p(_(M), "callPlayer", r.callPlayer), p(_(M), "parsePlaylist", function(G) {
          if (G instanceof Array)
            return {
              listType: "playlist",
              playlist: G.map(M.getID).join(",")
            };
          if (x.test(G)) {
            var X = G.match(x), W = u(X, 2), q = W[1];
            return {
              listType: "playlist",
              list: q.replace(/^UC/, "UU")
            };
          }
          if (P.test(G)) {
            var ee = G.match(P), te = u(ee, 2), le = te[1];
            return {
              listType: "user_uploads",
              list: le
            };
          }
          return {};
        }), p(_(M), "onStateChange", function(G) {
          var X = G.data, W = M.props, q = W.onPlay, ee = W.onPause, te = W.onBuffer, le = W.onBufferEnd, Y = W.onEnded, ye = W.onReady, Ce = W.loop, Ke = W.config, We = Ke.playerVars, nt = Ke.onUnstarted, qe = window[m].PlayerState, we = qe.UNSTARTED, $e = qe.PLAYING, Ve = qe.PAUSED, mo = qe.BUFFERING, go = qe.ENDED, ln = qe.CUED;
          if (X === we && nt(), X === $e && (q(), le()), X === Ve && ee(), X === mo && te(), X === go) {
            var da = !!M.callPlayer("getPlaylist");
            Ce && !da && (We.start ? M.seekTo(We.start) : M.play()), Y();
          }
          X === ln && ye();
        }), p(_(M), "mute", function() {
          M.callPlayer("mute");
        }), p(_(M), "unmute", function() {
          M.callPlayer("unMute");
        }), p(_(M), "ref", function(G) {
          M.container = G;
        }), M;
      }
      return S(k, [{
        key: "componentDidMount",
        value: function() {
          this.props.onMount && this.props.onMount(this);
        }
      }, {
        key: "getID",
        value: function(F) {
          return !F || F instanceof Array || x.test(F) ? null : F.match(a.MATCH_URL_YOUTUBE)[1];
        }
      }, {
        key: "load",
        value: function(F, j) {
          var U = this, G = this.props, X = G.playing, W = G.muted, q = G.playsinline, ee = G.controls, te = G.loop, le = G.config, Y = G.onError, ye = le.playerVars, Ce = le.embedOptions, Ke = this.getID(F);
          if (j) {
            if (x.test(F) || P.test(F) || F instanceof Array) {
              this.player.loadPlaylist(this.parsePlaylist(F));
              return;
            }
            this.player.cueVideoById({
              videoId: Ke,
              startSeconds: (0, r.parseStartTime)(F) || ye.start,
              endSeconds: (0, r.parseEndTime)(F) || ye.end
            });
            return;
          }
          (0, r.getSDK)(d, m, O, function(We) {
            return We.loaded;
          }).then(function(We) {
            U.container && (U.player = new We.Player(U.container, s({
              width: "100%",
              height: "100%",
              videoId: Ke,
              playerVars: s(s({
                autoplay: X ? 1 : 0,
                mute: W ? 1 : 0,
                controls: ee ? 1 : 0,
                start: (0, r.parseStartTime)(F),
                end: (0, r.parseEndTime)(F),
                origin: window.location.origin,
                playsinline: q ? 1 : 0
              }, U.parsePlaylist(F)), ye),
              events: {
                onReady: function() {
                  te && U.player.setLoop(!0), U.props.onReady();
                },
                onPlaybackRateChange: function(qe) {
                  return U.props.onPlaybackRateChange(qe.data);
                },
                onPlaybackQualityChange: function(qe) {
                  return U.props.onPlaybackQualityChange(qe);
                },
                onStateChange: U.onStateChange,
                onError: function(qe) {
                  return Y(qe.data);
                }
              },
              host: N.test(F) ? D : void 0
            }, Ce)));
          }, Y), Ce.events && console.warn("Using `embedOptions.events` will likely break things. Use ReactPlayer’s callback props instead, eg onReady, onPlay, onPause");
        }
      }, {
        key: "play",
        value: function() {
          this.callPlayer("playVideo");
        }
      }, {
        key: "pause",
        value: function() {
          this.callPlayer("pauseVideo");
        }
      }, {
        key: "stop",
        value: function() {
          document.body.contains(this.callPlayer("getIframe")) && this.callPlayer("stopVideo");
        }
      }, {
        key: "seekTo",
        value: function(F) {
          var j = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
          this.callPlayer("seekTo", F), !j && !this.props.playing && this.pause();
        }
      }, {
        key: "setVolume",
        value: function(F) {
          this.callPlayer("setVolume", F * 100);
        }
      }, {
        key: "setPlaybackRate",
        value: function(F) {
          this.callPlayer("setPlaybackRate", F);
        }
      }, {
        key: "setLoop",
        value: function(F) {
          this.callPlayer("setLoop", F);
        }
      }, {
        key: "getDuration",
        value: function() {
          return this.callPlayer("getDuration");
        }
      }, {
        key: "getCurrentTime",
        value: function() {
          return this.callPlayer("getCurrentTime");
        }
      }, {
        key: "getSecondsLoaded",
        value: function() {
          return this.callPlayer("getVideoLoadedFraction") * this.getDuration();
        }
      }, {
        key: "render",
        value: function() {
          var F = this.props.display, j = {
            width: "100%",
            height: "100%",
            display: F
          };
          return /* @__PURE__ */ n.default.createElement("div", {
            style: j
          }, /* @__PURE__ */ n.default.createElement("div", {
            ref: this.ref
          }));
        }
      }]), k;
    }(n.Component);
    e.default = I, p(I, "displayName", "YouTube"), p(I, "canPlay", a.canPlay.youtube);
  }(ps)), ps;
}
var hs = {}, ip;
function _A() {
  return ip || (ip = 1, function(e) {
    function t(y) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(p) {
        return typeof p;
      } : t = function(p) {
        return p && typeof Symbol == "function" && p.constructor === Symbol && p !== Symbol.prototype ? "symbol" : typeof p;
      }, t(y);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = o(oe), r = Ae, a = fe;
    function i() {
      if (typeof WeakMap != "function")
        return null;
      var y = /* @__PURE__ */ new WeakMap();
      return i = function() {
        return y;
      }, y;
    }
    function o(y) {
      if (y && y.__esModule)
        return y;
      if (y === null || t(y) !== "object" && typeof y != "function")
        return { default: y };
      var c = i();
      if (c && c.has(y))
        return c.get(y);
      var p = {}, d = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var m in y)
        if (Object.prototype.hasOwnProperty.call(y, m)) {
          var O = d ? Object.getOwnPropertyDescriptor(y, m) : null;
          O && (O.get || O.set) ? Object.defineProperty(p, m, O) : p[m] = y[m];
        }
      return p.default = y, c && c.set(y, p), p;
    }
    function l(y, c) {
      var p = Object.keys(y);
      if (Object.getOwnPropertySymbols) {
        var d = Object.getOwnPropertySymbols(y);
        c && (d = d.filter(function(m) {
          return Object.getOwnPropertyDescriptor(y, m).enumerable;
        })), p.push.apply(p, d);
      }
      return p;
    }
    function s(y) {
      for (var c = 1; c < arguments.length; c++) {
        var p = arguments[c] != null ? arguments[c] : {};
        c % 2 ? l(Object(p), !0).forEach(function(d) {
          A(y, d, p[d]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(y, Object.getOwnPropertyDescriptors(p)) : l(Object(p)).forEach(function(d) {
          Object.defineProperty(y, d, Object.getOwnPropertyDescriptor(p, d));
        });
      }
      return y;
    }
    function u(y, c) {
      if (!(y instanceof c))
        throw new TypeError("Cannot call a class as a function");
    }
    function f(y, c) {
      for (var p = 0; p < c.length; p++) {
        var d = c[p];
        d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(y, d.key, d);
      }
    }
    function h(y, c, p) {
      return c && f(y.prototype, c), p && f(y, p), y;
    }
    function g(y, c) {
      if (typeof c != "function" && c !== null)
        throw new TypeError("Super expression must either be null or a function");
      y.prototype = Object.create(c && c.prototype, { constructor: { value: y, writable: !0, configurable: !0 } }), c && v(y, c);
    }
    function v(y, c) {
      return v = Object.setPrototypeOf || function(d, m) {
        return d.__proto__ = m, d;
      }, v(y, c);
    }
    function E(y) {
      var c = S();
      return function() {
        var d = T(y), m;
        if (c) {
          var O = T(this).constructor;
          m = Reflect.construct(d, arguments, O);
        } else
          m = d.apply(this, arguments);
        return b(this, m);
      };
    }
    function b(y, c) {
      return c && (t(c) === "object" || typeof c == "function") ? c : w(y);
    }
    function w(y) {
      if (y === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return y;
    }
    function S() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function T(y) {
      return T = Object.setPrototypeOf ? Object.getPrototypeOf : function(p) {
        return p.__proto__ || Object.getPrototypeOf(p);
      }, T(y);
    }
    function A(y, c, p) {
      return c in y ? Object.defineProperty(y, c, { value: p, enumerable: !0, configurable: !0, writable: !0 }) : y[c] = p, y;
    }
    var V = "https://w.soundcloud.com/player/api.js", $ = "SC", _ = /* @__PURE__ */ function(y) {
      g(p, y);
      var c = E(p);
      function p() {
        var d;
        u(this, p);
        for (var m = arguments.length, O = new Array(m), x = 0; x < m; x++)
          O[x] = arguments[x];
        return d = c.call.apply(c, [this].concat(O)), A(w(d), "callPlayer", r.callPlayer), A(w(d), "duration", null), A(w(d), "currentTime", null), A(w(d), "fractionLoaded", null), A(w(d), "mute", function() {
          d.setVolume(0);
        }), A(w(d), "unmute", function() {
          d.props.volume !== null && d.setVolume(d.props.volume);
        }), A(w(d), "ref", function(P) {
          d.iframe = P;
        }), d;
      }
      return h(p, [{
        key: "componentDidMount",
        value: function() {
          this.props.onMount && this.props.onMount(this);
        }
      }, {
        key: "load",
        value: function(m, O) {
          var x = this;
          (0, r.getSDK)(V, $).then(function(P) {
            if (x.iframe) {
              var N = P.Widget.Events, D = N.PLAY, I = N.PLAY_PROGRESS, C = N.PAUSE, L = N.FINISH, k = N.ERROR;
              O || (x.player = P.Widget(x.iframe), x.player.bind(D, x.props.onPlay), x.player.bind(C, function() {
                var M = x.duration - x.currentTime;
                M < 0.05 || x.props.onPause();
              }), x.player.bind(I, function(M) {
                x.currentTime = M.currentPosition / 1e3, x.fractionLoaded = M.loadedProgress;
              }), x.player.bind(L, function() {
                return x.props.onEnded();
              }), x.player.bind(k, function(M) {
                return x.props.onError(M);
              })), x.player.load(m, s(s({}, x.props.config.options), {}, {
                callback: function() {
                  x.player.getDuration(function(F) {
                    x.duration = F / 1e3, x.props.onReady();
                  });
                }
              }));
            }
          });
        }
      }, {
        key: "play",
        value: function() {
          this.callPlayer("play");
        }
      }, {
        key: "pause",
        value: function() {
          this.callPlayer("pause");
        }
      }, {
        key: "stop",
        value: function() {
        }
      }, {
        key: "seekTo",
        value: function(m) {
          var O = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
          this.callPlayer("seekTo", m * 1e3), O || this.pause();
        }
      }, {
        key: "setVolume",
        value: function(m) {
          this.callPlayer("setVolume", m * 100);
        }
      }, {
        key: "getDuration",
        value: function() {
          return this.duration;
        }
      }, {
        key: "getCurrentTime",
        value: function() {
          return this.currentTime;
        }
      }, {
        key: "getSecondsLoaded",
        value: function() {
          return this.fractionLoaded * this.duration;
        }
      }, {
        key: "render",
        value: function() {
          var m = this.props.display, O = {
            width: "100%",
            height: "100%",
            display: m
          };
          return /* @__PURE__ */ n.default.createElement("iframe", {
            ref: this.ref,
            src: "https://w.soundcloud.com/player/?url=".concat(encodeURIComponent(this.props.url)),
            style: O,
            frameBorder: 0,
            allow: "autoplay"
          });
        }
      }]), p;
    }(n.Component);
    e.default = _, A(_, "displayName", "SoundCloud"), A(_, "canPlay", a.canPlay.soundcloud), A(_, "loopOnEnded", !0);
  }(hs)), hs;
}
var vs = {}, op;
function LA() {
  return op || (op = 1, function(e) {
    function t(c) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(d) {
        return typeof d;
      } : t = function(d) {
        return d && typeof Symbol == "function" && d.constructor === Symbol && d !== Symbol.prototype ? "symbol" : typeof d;
      }, t(c);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = o(oe), r = Ae, a = fe;
    function i() {
      if (typeof WeakMap != "function")
        return null;
      var c = /* @__PURE__ */ new WeakMap();
      return i = function() {
        return c;
      }, c;
    }
    function o(c) {
      if (c && c.__esModule)
        return c;
      if (c === null || t(c) !== "object" && typeof c != "function")
        return { default: c };
      var p = i();
      if (p && p.has(c))
        return p.get(c);
      var d = {}, m = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var O in c)
        if (Object.prototype.hasOwnProperty.call(c, O)) {
          var x = m ? Object.getOwnPropertyDescriptor(c, O) : null;
          x && (x.get || x.set) ? Object.defineProperty(d, O, x) : d[O] = c[O];
        }
      return d.default = c, p && p.set(c, d), d;
    }
    function l(c, p) {
      var d = Object.keys(c);
      if (Object.getOwnPropertySymbols) {
        var m = Object.getOwnPropertySymbols(c);
        p && (m = m.filter(function(O) {
          return Object.getOwnPropertyDescriptor(c, O).enumerable;
        })), d.push.apply(d, m);
      }
      return d;
    }
    function s(c) {
      for (var p = 1; p < arguments.length; p++) {
        var d = arguments[p] != null ? arguments[p] : {};
        p % 2 ? l(Object(d), !0).forEach(function(m) {
          A(c, m, d[m]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(c, Object.getOwnPropertyDescriptors(d)) : l(Object(d)).forEach(function(m) {
          Object.defineProperty(c, m, Object.getOwnPropertyDescriptor(d, m));
        });
      }
      return c;
    }
    function u(c, p) {
      if (!(c instanceof p))
        throw new TypeError("Cannot call a class as a function");
    }
    function f(c, p) {
      for (var d = 0; d < p.length; d++) {
        var m = p[d];
        m.enumerable = m.enumerable || !1, m.configurable = !0, "value" in m && (m.writable = !0), Object.defineProperty(c, m.key, m);
      }
    }
    function h(c, p, d) {
      return p && f(c.prototype, p), d && f(c, d), c;
    }
    function g(c, p) {
      if (typeof p != "function" && p !== null)
        throw new TypeError("Super expression must either be null or a function");
      c.prototype = Object.create(p && p.prototype, { constructor: { value: c, writable: !0, configurable: !0 } }), p && v(c, p);
    }
    function v(c, p) {
      return v = Object.setPrototypeOf || function(m, O) {
        return m.__proto__ = O, m;
      }, v(c, p);
    }
    function E(c) {
      var p = S();
      return function() {
        var m = T(c), O;
        if (p) {
          var x = T(this).constructor;
          O = Reflect.construct(m, arguments, x);
        } else
          O = m.apply(this, arguments);
        return b(this, O);
      };
    }
    function b(c, p) {
      return p && (t(p) === "object" || typeof p == "function") ? p : w(c);
    }
    function w(c) {
      if (c === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return c;
    }
    function S() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function T(c) {
      return T = Object.setPrototypeOf ? Object.getPrototypeOf : function(d) {
        return d.__proto__ || Object.getPrototypeOf(d);
      }, T(c);
    }
    function A(c, p, d) {
      return p in c ? Object.defineProperty(c, p, { value: d, enumerable: !0, configurable: !0, writable: !0 }) : c[p] = d, c;
    }
    var V = "https://player.vimeo.com/api/player.js", $ = "Vimeo", _ = function(p) {
      return p.replace("/manage/videos", "");
    }, y = /* @__PURE__ */ function(c) {
      g(d, c);
      var p = E(d);
      function d() {
        var m;
        u(this, d);
        for (var O = arguments.length, x = new Array(O), P = 0; P < O; P++)
          x[P] = arguments[P];
        return m = p.call.apply(p, [this].concat(x)), A(w(m), "callPlayer", r.callPlayer), A(w(m), "duration", null), A(w(m), "currentTime", null), A(w(m), "secondsLoaded", null), A(w(m), "mute", function() {
          m.setMuted(!0);
        }), A(w(m), "unmute", function() {
          m.setMuted(!1);
        }), A(w(m), "ref", function(N) {
          m.container = N;
        }), m;
      }
      return h(d, [{
        key: "componentDidMount",
        value: function() {
          this.props.onMount && this.props.onMount(this);
        }
      }, {
        key: "load",
        value: function(O) {
          var x = this;
          this.duration = null, (0, r.getSDK)(V, $).then(function(P) {
            if (x.container) {
              var N = x.props.config, D = N.playerOptions, I = N.title;
              x.player = new P.Player(x.container, s({
                url: _(O),
                autoplay: x.props.playing,
                muted: x.props.muted,
                loop: x.props.loop,
                playsinline: x.props.playsinline,
                controls: x.props.controls
              }, D)), x.player.ready().then(function() {
                var C = x.container.querySelector("iframe");
                C.style.width = "100%", C.style.height = "100%", I && (C.title = I);
              }).catch(x.props.onError), x.player.on("loaded", function() {
                x.props.onReady(), x.refreshDuration();
              }), x.player.on("play", function() {
                x.props.onPlay(), x.refreshDuration();
              }), x.player.on("pause", x.props.onPause), x.player.on("seeked", function(C) {
                return x.props.onSeek(C.seconds);
              }), x.player.on("ended", x.props.onEnded), x.player.on("error", x.props.onError), x.player.on("timeupdate", function(C) {
                var L = C.seconds;
                x.currentTime = L;
              }), x.player.on("progress", function(C) {
                var L = C.seconds;
                x.secondsLoaded = L;
              }), x.player.on("bufferstart", x.props.onBuffer), x.player.on("bufferend", x.props.onBufferEnd), x.player.on("playbackratechange", function(C) {
                return x.props.onPlaybackRateChange(C.playbackRate);
              });
            }
          }, this.props.onError);
        }
      }, {
        key: "refreshDuration",
        value: function() {
          var O = this;
          this.player.getDuration().then(function(x) {
            O.duration = x;
          });
        }
      }, {
        key: "play",
        value: function() {
          var O = this.callPlayer("play");
          O && O.catch(this.props.onError);
        }
      }, {
        key: "pause",
        value: function() {
          this.callPlayer("pause");
        }
      }, {
        key: "stop",
        value: function() {
          this.callPlayer("unload");
        }
      }, {
        key: "seekTo",
        value: function(O) {
          var x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
          this.callPlayer("setCurrentTime", O), x || this.pause();
        }
      }, {
        key: "setVolume",
        value: function(O) {
          this.callPlayer("setVolume", O);
        }
      }, {
        key: "setMuted",
        value: function(O) {
          this.callPlayer("setMuted", O);
        }
      }, {
        key: "setLoop",
        value: function(O) {
          this.callPlayer("setLoop", O);
        }
      }, {
        key: "setPlaybackRate",
        value: function(O) {
          this.callPlayer("setPlaybackRate", O);
        }
      }, {
        key: "getDuration",
        value: function() {
          return this.duration;
        }
      }, {
        key: "getCurrentTime",
        value: function() {
          return this.currentTime;
        }
      }, {
        key: "getSecondsLoaded",
        value: function() {
          return this.secondsLoaded;
        }
      }, {
        key: "render",
        value: function() {
          var O = this.props.display, x = {
            width: "100%",
            height: "100%",
            overflow: "hidden",
            display: O
          };
          return /* @__PURE__ */ n.default.createElement("div", {
            key: this.props.url,
            ref: this.ref,
            style: x
          });
        }
      }]), d;
    }(n.Component);
    e.default = y, A(y, "displayName", "Vimeo"), A(y, "canPlay", a.canPlay.vimeo), A(y, "forceLoad", !0);
  }(vs)), vs;
}
var ms = {}, lp;
function IA() {
  return lp || (lp = 1, function(e) {
    function t(c) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(d) {
        return typeof d;
      } : t = function(d) {
        return d && typeof Symbol == "function" && d.constructor === Symbol && d !== Symbol.prototype ? "symbol" : typeof d;
      }, t(c);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = o(oe), r = Ae, a = fe;
    function i() {
      if (typeof WeakMap != "function")
        return null;
      var c = /* @__PURE__ */ new WeakMap();
      return i = function() {
        return c;
      }, c;
    }
    function o(c) {
      if (c && c.__esModule)
        return c;
      if (c === null || t(c) !== "object" && typeof c != "function")
        return { default: c };
      var p = i();
      if (p && p.has(c))
        return p.get(c);
      var d = {}, m = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var O in c)
        if (Object.prototype.hasOwnProperty.call(c, O)) {
          var x = m ? Object.getOwnPropertyDescriptor(c, O) : null;
          x && (x.get || x.set) ? Object.defineProperty(d, O, x) : d[O] = c[O];
        }
      return d.default = c, p && p.set(c, d), d;
    }
    function l() {
      return l = Object.assign || function(c) {
        for (var p = 1; p < arguments.length; p++) {
          var d = arguments[p];
          for (var m in d)
            Object.prototype.hasOwnProperty.call(d, m) && (c[m] = d[m]);
        }
        return c;
      }, l.apply(this, arguments);
    }
    function s(c, p) {
      if (!(c instanceof p))
        throw new TypeError("Cannot call a class as a function");
    }
    function u(c, p) {
      for (var d = 0; d < p.length; d++) {
        var m = p[d];
        m.enumerable = m.enumerable || !1, m.configurable = !0, "value" in m && (m.writable = !0), Object.defineProperty(c, m.key, m);
      }
    }
    function f(c, p, d) {
      return p && u(c.prototype, p), d && u(c, d), c;
    }
    function h(c, p) {
      if (typeof p != "function" && p !== null)
        throw new TypeError("Super expression must either be null or a function");
      c.prototype = Object.create(p && p.prototype, { constructor: { value: c, writable: !0, configurable: !0 } }), p && g(c, p);
    }
    function g(c, p) {
      return g = Object.setPrototypeOf || function(m, O) {
        return m.__proto__ = O, m;
      }, g(c, p);
    }
    function v(c) {
      var p = w();
      return function() {
        var m = S(c), O;
        if (p) {
          var x = S(this).constructor;
          O = Reflect.construct(m, arguments, x);
        } else
          O = m.apply(this, arguments);
        return E(this, O);
      };
    }
    function E(c, p) {
      return p && (t(p) === "object" || typeof p == "function") ? p : b(c);
    }
    function b(c) {
      if (c === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return c;
    }
    function w() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function S(c) {
      return S = Object.setPrototypeOf ? Object.getPrototypeOf : function(d) {
        return d.__proto__ || Object.getPrototypeOf(d);
      }, S(c);
    }
    function T(c, p, d) {
      return p in c ? Object.defineProperty(c, p, { value: d, enumerable: !0, configurable: !0, writable: !0 }) : c[p] = d, c;
    }
    var A = "https://connect.facebook.net/en_US/sdk.js", V = "FB", $ = "fbAsyncInit", _ = "facebook-player-", y = /* @__PURE__ */ function(c) {
      h(d, c);
      var p = v(d);
      function d() {
        var m;
        s(this, d);
        for (var O = arguments.length, x = new Array(O), P = 0; P < O; P++)
          x[P] = arguments[P];
        return m = p.call.apply(p, [this].concat(x)), T(b(m), "callPlayer", r.callPlayer), T(b(m), "playerID", m.props.config.playerId || "".concat(_).concat((0, r.randomString)())), T(b(m), "mute", function() {
          m.callPlayer("mute");
        }), T(b(m), "unmute", function() {
          m.callPlayer("unmute");
        }), m;
      }
      return f(d, [{
        key: "componentDidMount",
        value: function() {
          this.props.onMount && this.props.onMount(this);
        }
      }, {
        key: "load",
        value: function(O, x) {
          var P = this;
          if (x) {
            (0, r.getSDK)(A, V, $).then(function(N) {
              return N.XFBML.parse();
            });
            return;
          }
          (0, r.getSDK)(A, V, $).then(function(N) {
            N.init({
              appId: P.props.config.appId,
              xfbml: !0,
              version: P.props.config.version
            }), N.Event.subscribe("xfbml.render", function(D) {
              P.props.onLoaded();
            }), N.Event.subscribe("xfbml.ready", function(D) {
              D.type === "video" && D.id === P.playerID && (P.player = D.instance, P.player.subscribe("startedPlaying", P.props.onPlay), P.player.subscribe("paused", P.props.onPause), P.player.subscribe("finishedPlaying", P.props.onEnded), P.player.subscribe("startedBuffering", P.props.onBuffer), P.player.subscribe("finishedBuffering", P.props.onBufferEnd), P.player.subscribe("error", P.props.onError), P.props.muted ? P.callPlayer("mute") : P.callPlayer("unmute"), P.props.onReady(), document.getElementById(P.playerID).querySelector("iframe").style.visibility = "visible");
            });
          });
        }
      }, {
        key: "play",
        value: function() {
          this.callPlayer("play");
        }
      }, {
        key: "pause",
        value: function() {
          this.callPlayer("pause");
        }
      }, {
        key: "stop",
        value: function() {
        }
      }, {
        key: "seekTo",
        value: function(O) {
          var x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
          this.callPlayer("seek", O), x || this.pause();
        }
      }, {
        key: "setVolume",
        value: function(O) {
          this.callPlayer("setVolume", O);
        }
      }, {
        key: "getDuration",
        value: function() {
          return this.callPlayer("getDuration");
        }
      }, {
        key: "getCurrentTime",
        value: function() {
          return this.callPlayer("getCurrentPosition");
        }
      }, {
        key: "getSecondsLoaded",
        value: function() {
          return null;
        }
      }, {
        key: "render",
        value: function() {
          var O = this.props.config.attributes, x = {
            width: "100%",
            height: "100%"
          };
          return /* @__PURE__ */ n.default.createElement("div", l({
            style: x,
            id: this.playerID,
            className: "fb-video",
            "data-href": this.props.url,
            "data-autoplay": this.props.playing ? "true" : "false",
            "data-allowfullscreen": "true",
            "data-controls": this.props.controls ? "true" : "false"
          }, O));
        }
      }]), d;
    }(n.Component);
    e.default = y, T(y, "displayName", "Facebook"), T(y, "canPlay", a.canPlay.facebook), T(y, "loopOnEnded", !0);
  }(ms)), ms;
}
var gs = {}, sp;
function DA() {
  return sp || (sp = 1, function(e) {
    function t($) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(y) {
        return typeof y;
      } : t = function(y) {
        return y && typeof Symbol == "function" && y.constructor === Symbol && y !== Symbol.prototype ? "symbol" : typeof y;
      }, t($);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = o(oe), r = Ae, a = fe;
    function i() {
      if (typeof WeakMap != "function")
        return null;
      var $ = /* @__PURE__ */ new WeakMap();
      return i = function() {
        return $;
      }, $;
    }
    function o($) {
      if ($ && $.__esModule)
        return $;
      if ($ === null || t($) !== "object" && typeof $ != "function")
        return { default: $ };
      var _ = i();
      if (_ && _.has($))
        return _.get($);
      var y = {}, c = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var p in $)
        if (Object.prototype.hasOwnProperty.call($, p)) {
          var d = c ? Object.getOwnPropertyDescriptor($, p) : null;
          d && (d.get || d.set) ? Object.defineProperty(y, p, d) : y[p] = $[p];
        }
      return y.default = $, _ && _.set($, y), y;
    }
    function l($, _) {
      if (!($ instanceof _))
        throw new TypeError("Cannot call a class as a function");
    }
    function s($, _) {
      for (var y = 0; y < _.length; y++) {
        var c = _[y];
        c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty($, c.key, c);
      }
    }
    function u($, _, y) {
      return _ && s($.prototype, _), y && s($, y), $;
    }
    function f($, _) {
      if (typeof _ != "function" && _ !== null)
        throw new TypeError("Super expression must either be null or a function");
      $.prototype = Object.create(_ && _.prototype, { constructor: { value: $, writable: !0, configurable: !0 } }), _ && h($, _);
    }
    function h($, _) {
      return h = Object.setPrototypeOf || function(c, p) {
        return c.__proto__ = p, c;
      }, h($, _);
    }
    function g($) {
      var _ = b();
      return function() {
        var c = w($), p;
        if (_) {
          var d = w(this).constructor;
          p = Reflect.construct(c, arguments, d);
        } else
          p = c.apply(this, arguments);
        return v(this, p);
      };
    }
    function v($, _) {
      return _ && (t(_) === "object" || typeof _ == "function") ? _ : E($);
    }
    function E($) {
      if ($ === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return $;
    }
    function b() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function w($) {
      return w = Object.setPrototypeOf ? Object.getPrototypeOf : function(y) {
        return y.__proto__ || Object.getPrototypeOf(y);
      }, w($);
    }
    function S($, _, y) {
      return _ in $ ? Object.defineProperty($, _, { value: y, enumerable: !0, configurable: !0, writable: !0 }) : $[_] = y, $;
    }
    var T = "https://cdn.embed.ly/player-0.1.0.min.js", A = "playerjs", V = /* @__PURE__ */ function($) {
      f(y, $);
      var _ = g(y);
      function y() {
        var c;
        l(this, y);
        for (var p = arguments.length, d = new Array(p), m = 0; m < p; m++)
          d[m] = arguments[m];
        return c = _.call.apply(_, [this].concat(d)), S(E(c), "callPlayer", r.callPlayer), S(E(c), "duration", null), S(E(c), "currentTime", null), S(E(c), "secondsLoaded", null), S(E(c), "mute", function() {
          c.callPlayer("mute");
        }), S(E(c), "unmute", function() {
          c.callPlayer("unmute");
        }), S(E(c), "ref", function(O) {
          c.iframe = O;
        }), c;
      }
      return u(y, [{
        key: "componentDidMount",
        value: function() {
          this.props.onMount && this.props.onMount(this);
        }
      }, {
        key: "load",
        value: function(p) {
          var d = this;
          (0, r.getSDK)(T, A).then(function(m) {
            d.iframe && (d.player = new m.Player(d.iframe), d.player.setLoop(d.props.loop), d.player.on("ready", d.props.onReady), d.player.on("play", d.props.onPlay), d.player.on("pause", d.props.onPause), d.player.on("seeked", d.props.onSeek), d.player.on("ended", d.props.onEnded), d.player.on("error", d.props.onError), d.player.on("timeupdate", function(O) {
              var x = O.duration, P = O.seconds;
              d.duration = x, d.currentTime = P;
            }), d.player.on("buffered", function(O) {
              var x = O.percent;
              d.duration && (d.secondsLoaded = d.duration * x);
            }), d.props.muted && d.player.mute());
          }, this.props.onError);
        }
      }, {
        key: "play",
        value: function() {
          this.callPlayer("play");
        }
      }, {
        key: "pause",
        value: function() {
          this.callPlayer("pause");
        }
      }, {
        key: "stop",
        value: function() {
        }
      }, {
        key: "seekTo",
        value: function(p) {
          var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
          this.callPlayer("setCurrentTime", p), d || this.pause();
        }
      }, {
        key: "setVolume",
        value: function(p) {
          this.callPlayer("setVolume", p * 100);
        }
      }, {
        key: "setLoop",
        value: function(p) {
          this.callPlayer("setLoop", p);
        }
      }, {
        key: "getDuration",
        value: function() {
          return this.duration;
        }
      }, {
        key: "getCurrentTime",
        value: function() {
          return this.currentTime;
        }
      }, {
        key: "getSecondsLoaded",
        value: function() {
          return this.secondsLoaded;
        }
      }, {
        key: "render",
        value: function() {
          var p = this.props.url.match(a.MATCH_URL_STREAMABLE)[1], d = {
            width: "100%",
            height: "100%"
          };
          return /* @__PURE__ */ n.default.createElement("iframe", {
            ref: this.ref,
            src: "https://streamable.com/o/".concat(p),
            frameBorder: "0",
            scrolling: "no",
            style: d,
            allow: "encrypted-media; autoplay; fullscreen;"
          });
        }
      }]), y;
    }(n.Component);
    e.default = V, S(V, "displayName", "Streamable"), S(V, "canPlay", a.canPlay.streamable);
  }(gs)), gs;
}
var ys = {}, cp;
function NA() {
  return cp || (cp = 1, function(e) {
    function t(c) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(d) {
        return typeof d;
      } : t = function(d) {
        return d && typeof Symbol == "function" && d.constructor === Symbol && d !== Symbol.prototype ? "symbol" : typeof d;
      }, t(c);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = o(oe), r = Ae, a = fe;
    function i() {
      if (typeof WeakMap != "function")
        return null;
      var c = /* @__PURE__ */ new WeakMap();
      return i = function() {
        return c;
      }, c;
    }
    function o(c) {
      if (c && c.__esModule)
        return c;
      if (c === null || t(c) !== "object" && typeof c != "function")
        return { default: c };
      var p = i();
      if (p && p.has(c))
        return p.get(c);
      var d = {}, m = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var O in c)
        if (Object.prototype.hasOwnProperty.call(c, O)) {
          var x = m ? Object.getOwnPropertyDescriptor(c, O) : null;
          x && (x.get || x.set) ? Object.defineProperty(d, O, x) : d[O] = c[O];
        }
      return d.default = c, p && p.set(c, d), d;
    }
    function l(c, p) {
      var d = Object.keys(c);
      if (Object.getOwnPropertySymbols) {
        var m = Object.getOwnPropertySymbols(c);
        p && (m = m.filter(function(O) {
          return Object.getOwnPropertyDescriptor(c, O).enumerable;
        })), d.push.apply(d, m);
      }
      return d;
    }
    function s(c) {
      for (var p = 1; p < arguments.length; p++) {
        var d = arguments[p] != null ? arguments[p] : {};
        p % 2 ? l(Object(d), !0).forEach(function(m) {
          A(c, m, d[m]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(c, Object.getOwnPropertyDescriptors(d)) : l(Object(d)).forEach(function(m) {
          Object.defineProperty(c, m, Object.getOwnPropertyDescriptor(d, m));
        });
      }
      return c;
    }
    function u(c, p) {
      if (!(c instanceof p))
        throw new TypeError("Cannot call a class as a function");
    }
    function f(c, p) {
      for (var d = 0; d < p.length; d++) {
        var m = p[d];
        m.enumerable = m.enumerable || !1, m.configurable = !0, "value" in m && (m.writable = !0), Object.defineProperty(c, m.key, m);
      }
    }
    function h(c, p, d) {
      return p && f(c.prototype, p), d && f(c, d), c;
    }
    function g(c, p) {
      if (typeof p != "function" && p !== null)
        throw new TypeError("Super expression must either be null or a function");
      c.prototype = Object.create(p && p.prototype, { constructor: { value: c, writable: !0, configurable: !0 } }), p && v(c, p);
    }
    function v(c, p) {
      return v = Object.setPrototypeOf || function(m, O) {
        return m.__proto__ = O, m;
      }, v(c, p);
    }
    function E(c) {
      var p = S();
      return function() {
        var m = T(c), O;
        if (p) {
          var x = T(this).constructor;
          O = Reflect.construct(m, arguments, x);
        } else
          O = m.apply(this, arguments);
        return b(this, O);
      };
    }
    function b(c, p) {
      return p && (t(p) === "object" || typeof p == "function") ? p : w(c);
    }
    function w(c) {
      if (c === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return c;
    }
    function S() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function T(c) {
      return T = Object.setPrototypeOf ? Object.getPrototypeOf : function(d) {
        return d.__proto__ || Object.getPrototypeOf(d);
      }, T(c);
    }
    function A(c, p, d) {
      return p in c ? Object.defineProperty(c, p, { value: d, enumerable: !0, configurable: !0, writable: !0 }) : c[p] = d, c;
    }
    var V = "https://fast.wistia.com/assets/external/E-v1.js", $ = "Wistia", _ = "wistia-player-", y = /* @__PURE__ */ function(c) {
      g(d, c);
      var p = E(d);
      function d() {
        var m;
        u(this, d);
        for (var O = arguments.length, x = new Array(O), P = 0; P < O; P++)
          x[P] = arguments[P];
        return m = p.call.apply(p, [this].concat(x)), A(w(m), "callPlayer", r.callPlayer), A(w(m), "playerID", m.props.config.playerId || "".concat(_).concat((0, r.randomString)())), A(w(m), "onPlay", function() {
          var N;
          return (N = m.props).onPlay.apply(N, arguments);
        }), A(w(m), "onPause", function() {
          var N;
          return (N = m.props).onPause.apply(N, arguments);
        }), A(w(m), "onSeek", function() {
          var N;
          return (N = m.props).onSeek.apply(N, arguments);
        }), A(w(m), "onEnded", function() {
          var N;
          return (N = m.props).onEnded.apply(N, arguments);
        }), A(w(m), "onPlaybackRateChange", function() {
          var N;
          return (N = m.props).onPlaybackRateChange.apply(N, arguments);
        }), A(w(m), "mute", function() {
          m.callPlayer("mute");
        }), A(w(m), "unmute", function() {
          m.callPlayer("unmute");
        }), m;
      }
      return h(d, [{
        key: "componentDidMount",
        value: function() {
          this.props.onMount && this.props.onMount(this);
        }
      }, {
        key: "load",
        value: function(O) {
          var x = this, P = this.props, N = P.playing, D = P.muted, I = P.controls, C = P.onReady, L = P.config, k = P.onError;
          (0, r.getSDK)(V, $).then(function(M) {
            L.customControls && L.customControls.forEach(function(F) {
              return M.defineControl(F);
            }), window._wq = window._wq || [], window._wq.push({
              id: x.playerID,
              options: s({
                autoPlay: N,
                silentAutoPlay: "allow",
                muted: D,
                controlsVisibleOnLoad: I,
                fullscreenButton: I,
                playbar: I,
                playbackRateControl: I,
                qualityControl: I,
                volumeControl: I,
                settingsControl: I,
                smallPlayButton: I
              }, L.options),
              onReady: function(j) {
                x.player = j, x.unbind(), x.player.bind("play", x.onPlay), x.player.bind("pause", x.onPause), x.player.bind("seek", x.onSeek), x.player.bind("end", x.onEnded), x.player.bind("playbackratechange", x.onPlaybackRateChange), C();
              }
            });
          }, k);
        }
      }, {
        key: "unbind",
        value: function() {
          this.player.unbind("play", this.onPlay), this.player.unbind("pause", this.onPause), this.player.unbind("seek", this.onSeek), this.player.unbind("end", this.onEnded), this.player.unbind("playbackratechange", this.onPlaybackRateChange);
        }
        // Proxy methods to prevent listener leaks
      }, {
        key: "play",
        value: function() {
          this.callPlayer("play");
        }
      }, {
        key: "pause",
        value: function() {
          this.callPlayer("pause");
        }
      }, {
        key: "stop",
        value: function() {
          this.unbind(), this.callPlayer("remove");
        }
      }, {
        key: "seekTo",
        value: function(O) {
          var x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
          this.callPlayer("time", O), x || this.pause();
        }
      }, {
        key: "setVolume",
        value: function(O) {
          this.callPlayer("volume", O);
        }
      }, {
        key: "setPlaybackRate",
        value: function(O) {
          this.callPlayer("playbackRate", O);
        }
      }, {
        key: "getDuration",
        value: function() {
          return this.callPlayer("duration");
        }
      }, {
        key: "getCurrentTime",
        value: function() {
          return this.callPlayer("time");
        }
      }, {
        key: "getSecondsLoaded",
        value: function() {
          return null;
        }
      }, {
        key: "render",
        value: function() {
          var O = this.props.url, x = O && O.match(a.MATCH_URL_WISTIA)[1], P = "wistia_embed wistia_async_".concat(x), N = {
            width: "100%",
            height: "100%"
          };
          return /* @__PURE__ */ n.default.createElement("div", {
            id: this.playerID,
            key: x,
            className: P,
            style: N
          });
        }
      }]), d;
    }(n.Component);
    e.default = y, A(y, "displayName", "Wistia"), A(y, "canPlay", a.canPlay.wistia), A(y, "loopOnEnded", !0);
  }(ys)), ys;
}
var bs = {}, up;
function RA() {
  return up || (up = 1, function(e) {
    function t(c) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(d) {
        return typeof d;
      } : t = function(d) {
        return d && typeof Symbol == "function" && d.constructor === Symbol && d !== Symbol.prototype ? "symbol" : typeof d;
      }, t(c);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = o(oe), r = Ae, a = fe;
    function i() {
      if (typeof WeakMap != "function")
        return null;
      var c = /* @__PURE__ */ new WeakMap();
      return i = function() {
        return c;
      }, c;
    }
    function o(c) {
      if (c && c.__esModule)
        return c;
      if (c === null || t(c) !== "object" && typeof c != "function")
        return { default: c };
      var p = i();
      if (p && p.has(c))
        return p.get(c);
      var d = {}, m = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var O in c)
        if (Object.prototype.hasOwnProperty.call(c, O)) {
          var x = m ? Object.getOwnPropertyDescriptor(c, O) : null;
          x && (x.get || x.set) ? Object.defineProperty(d, O, x) : d[O] = c[O];
        }
      return d.default = c, p && p.set(c, d), d;
    }
    function l(c, p) {
      var d = Object.keys(c);
      if (Object.getOwnPropertySymbols) {
        var m = Object.getOwnPropertySymbols(c);
        p && (m = m.filter(function(O) {
          return Object.getOwnPropertyDescriptor(c, O).enumerable;
        })), d.push.apply(d, m);
      }
      return d;
    }
    function s(c) {
      for (var p = 1; p < arguments.length; p++) {
        var d = arguments[p] != null ? arguments[p] : {};
        p % 2 ? l(Object(d), !0).forEach(function(m) {
          A(c, m, d[m]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(c, Object.getOwnPropertyDescriptors(d)) : l(Object(d)).forEach(function(m) {
          Object.defineProperty(c, m, Object.getOwnPropertyDescriptor(d, m));
        });
      }
      return c;
    }
    function u(c, p) {
      if (!(c instanceof p))
        throw new TypeError("Cannot call a class as a function");
    }
    function f(c, p) {
      for (var d = 0; d < p.length; d++) {
        var m = p[d];
        m.enumerable = m.enumerable || !1, m.configurable = !0, "value" in m && (m.writable = !0), Object.defineProperty(c, m.key, m);
      }
    }
    function h(c, p, d) {
      return p && f(c.prototype, p), d && f(c, d), c;
    }
    function g(c, p) {
      if (typeof p != "function" && p !== null)
        throw new TypeError("Super expression must either be null or a function");
      c.prototype = Object.create(p && p.prototype, { constructor: { value: c, writable: !0, configurable: !0 } }), p && v(c, p);
    }
    function v(c, p) {
      return v = Object.setPrototypeOf || function(m, O) {
        return m.__proto__ = O, m;
      }, v(c, p);
    }
    function E(c) {
      var p = S();
      return function() {
        var m = T(c), O;
        if (p) {
          var x = T(this).constructor;
          O = Reflect.construct(m, arguments, x);
        } else
          O = m.apply(this, arguments);
        return b(this, O);
      };
    }
    function b(c, p) {
      return p && (t(p) === "object" || typeof p == "function") ? p : w(c);
    }
    function w(c) {
      if (c === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return c;
    }
    function S() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function T(c) {
      return T = Object.setPrototypeOf ? Object.getPrototypeOf : function(d) {
        return d.__proto__ || Object.getPrototypeOf(d);
      }, T(c);
    }
    function A(c, p, d) {
      return p in c ? Object.defineProperty(c, p, { value: d, enumerable: !0, configurable: !0, writable: !0 }) : c[p] = d, c;
    }
    var V = "https://player.twitch.tv/js/embed/v1.js", $ = "Twitch", _ = "twitch-player-", y = /* @__PURE__ */ function(c) {
      g(d, c);
      var p = E(d);
      function d() {
        var m;
        u(this, d);
        for (var O = arguments.length, x = new Array(O), P = 0; P < O; P++)
          x[P] = arguments[P];
        return m = p.call.apply(p, [this].concat(x)), A(w(m), "callPlayer", r.callPlayer), A(w(m), "playerID", m.props.config.playerId || "".concat(_).concat((0, r.randomString)())), A(w(m), "mute", function() {
          m.callPlayer("setMuted", !0);
        }), A(w(m), "unmute", function() {
          m.callPlayer("setMuted", !1);
        }), m;
      }
      return h(d, [{
        key: "componentDidMount",
        value: function() {
          this.props.onMount && this.props.onMount(this);
        }
      }, {
        key: "load",
        value: function(O, x) {
          var P = this, N = this.props, D = N.playsinline, I = N.onError, C = N.config, L = N.controls, k = a.MATCH_URL_TWITCH_CHANNEL.test(O), M = k ? O.match(a.MATCH_URL_TWITCH_CHANNEL)[1] : O.match(a.MATCH_URL_TWITCH_VIDEO)[1];
          if (x) {
            k ? this.player.setChannel(M) : this.player.setVideo("v" + M);
            return;
          }
          (0, r.getSDK)(V, $).then(function(F) {
            P.player = new F.Player(P.playerID, s({
              video: k ? "" : M,
              channel: k ? M : "",
              height: "100%",
              width: "100%",
              playsinline: D,
              autoplay: P.props.playing,
              muted: P.props.muted,
              // https://github.com/CookPete/react-player/issues/733#issuecomment-549085859
              controls: k ? !0 : L,
              time: (0, r.parseStartTime)(O)
            }, C.options));
            var j = F.Player, U = j.READY, G = j.PLAYING, X = j.PAUSE, W = j.ENDED, q = j.ONLINE, ee = j.OFFLINE, te = j.SEEK;
            P.player.addEventListener(U, P.props.onReady), P.player.addEventListener(G, P.props.onPlay), P.player.addEventListener(X, P.props.onPause), P.player.addEventListener(W, P.props.onEnded), P.player.addEventListener(te, P.props.onSeek), P.player.addEventListener(q, P.props.onLoaded), P.player.addEventListener(ee, P.props.onLoaded);
          }, I);
        }
      }, {
        key: "play",
        value: function() {
          this.callPlayer("play");
        }
      }, {
        key: "pause",
        value: function() {
          this.callPlayer("pause");
        }
      }, {
        key: "stop",
        value: function() {
          this.callPlayer("pause");
        }
      }, {
        key: "seekTo",
        value: function(O) {
          var x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
          this.callPlayer("seek", O), x || this.pause();
        }
      }, {
        key: "setVolume",
        value: function(O) {
          this.callPlayer("setVolume", O);
        }
      }, {
        key: "getDuration",
        value: function() {
          return this.callPlayer("getDuration");
        }
      }, {
        key: "getCurrentTime",
        value: function() {
          return this.callPlayer("getCurrentTime");
        }
      }, {
        key: "getSecondsLoaded",
        value: function() {
          return null;
        }
      }, {
        key: "render",
        value: function() {
          var O = {
            width: "100%",
            height: "100%"
          };
          return /* @__PURE__ */ n.default.createElement("div", {
            style: O,
            id: this.playerID
          });
        }
      }]), d;
    }(n.Component);
    e.default = y, A(y, "displayName", "Twitch"), A(y, "canPlay", a.canPlay.twitch), A(y, "loopOnEnded", !0);
  }(bs)), bs;
}
var ws = {}, dp;
function BA() {
  return dp || (dp = 1, function(e) {
    function t(P) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(D) {
        return typeof D;
      } : t = function(D) {
        return D && typeof Symbol == "function" && D.constructor === Symbol && D !== Symbol.prototype ? "symbol" : typeof D;
      }, t(P);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = o(oe), r = Ae, a = fe;
    function i() {
      if (typeof WeakMap != "function")
        return null;
      var P = /* @__PURE__ */ new WeakMap();
      return i = function() {
        return P;
      }, P;
    }
    function o(P) {
      if (P && P.__esModule)
        return P;
      if (P === null || t(P) !== "object" && typeof P != "function")
        return { default: P };
      var N = i();
      if (N && N.has(P))
        return N.get(P);
      var D = {}, I = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var C in P)
        if (Object.prototype.hasOwnProperty.call(P, C)) {
          var L = I ? Object.getOwnPropertyDescriptor(P, C) : null;
          L && (L.get || L.set) ? Object.defineProperty(D, C, L) : D[C] = P[C];
        }
      return D.default = P, N && N.set(P, D), D;
    }
    function l(P, N) {
      var D = Object.keys(P);
      if (Object.getOwnPropertySymbols) {
        var I = Object.getOwnPropertySymbols(P);
        N && (I = I.filter(function(C) {
          return Object.getOwnPropertyDescriptor(P, C).enumerable;
        })), D.push.apply(D, I);
      }
      return D;
    }
    function s(P) {
      for (var N = 1; N < arguments.length; N++) {
        var D = arguments[N] != null ? arguments[N] : {};
        N % 2 ? l(Object(D), !0).forEach(function(I) {
          p(P, I, D[I]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(P, Object.getOwnPropertyDescriptors(D)) : l(Object(D)).forEach(function(I) {
          Object.defineProperty(P, I, Object.getOwnPropertyDescriptor(D, I));
        });
      }
      return P;
    }
    function u(P, N) {
      return E(P) || v(P, N) || h(P, N) || f();
    }
    function f() {
      throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
    }
    function h(P, N) {
      if (P) {
        if (typeof P == "string")
          return g(P, N);
        var D = Object.prototype.toString.call(P).slice(8, -1);
        if (D === "Object" && P.constructor && (D = P.constructor.name), D === "Map" || D === "Set")
          return Array.from(P);
        if (D === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(D))
          return g(P, N);
      }
    }
    function g(P, N) {
      (N == null || N > P.length) && (N = P.length);
      for (var D = 0, I = new Array(N); D < N; D++)
        I[D] = P[D];
      return I;
    }
    function v(P, N) {
      if (!(typeof Symbol > "u" || !(Symbol.iterator in Object(P)))) {
        var D = [], I = !0, C = !1, L = void 0;
        try {
          for (var k = P[Symbol.iterator](), M; !(I = (M = k.next()).done) && (D.push(M.value), !(N && D.length === N)); I = !0)
            ;
        } catch (F) {
          C = !0, L = F;
        } finally {
          try {
            !I && k.return != null && k.return();
          } finally {
            if (C)
              throw L;
          }
        }
        return D;
      }
    }
    function E(P) {
      if (Array.isArray(P))
        return P;
    }
    function b(P, N) {
      if (!(P instanceof N))
        throw new TypeError("Cannot call a class as a function");
    }
    function w(P, N) {
      for (var D = 0; D < N.length; D++) {
        var I = N[D];
        I.enumerable = I.enumerable || !1, I.configurable = !0, "value" in I && (I.writable = !0), Object.defineProperty(P, I.key, I);
      }
    }
    function S(P, N, D) {
      return N && w(P.prototype, N), D && w(P, D), P;
    }
    function T(P, N) {
      if (typeof N != "function" && N !== null)
        throw new TypeError("Super expression must either be null or a function");
      P.prototype = Object.create(N && N.prototype, { constructor: { value: P, writable: !0, configurable: !0 } }), N && A(P, N);
    }
    function A(P, N) {
      return A = Object.setPrototypeOf || function(I, C) {
        return I.__proto__ = C, I;
      }, A(P, N);
    }
    function V(P) {
      var N = y();
      return function() {
        var I = c(P), C;
        if (N) {
          var L = c(this).constructor;
          C = Reflect.construct(I, arguments, L);
        } else
          C = I.apply(this, arguments);
        return $(this, C);
      };
    }
    function $(P, N) {
      return N && (t(N) === "object" || typeof N == "function") ? N : _(P);
    }
    function _(P) {
      if (P === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return P;
    }
    function y() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function c(P) {
      return c = Object.setPrototypeOf ? Object.getPrototypeOf : function(D) {
        return D.__proto__ || Object.getPrototypeOf(D);
      }, c(P);
    }
    function p(P, N, D) {
      return N in P ? Object.defineProperty(P, N, { value: D, enumerable: !0, configurable: !0, writable: !0 }) : P[N] = D, P;
    }
    var d = "https://api.dmcdn.net/all.js", m = "DM", O = "dmAsyncInit", x = /* @__PURE__ */ function(P) {
      T(D, P);
      var N = V(D);
      function D() {
        var I;
        b(this, D);
        for (var C = arguments.length, L = new Array(C), k = 0; k < C; k++)
          L[k] = arguments[k];
        return I = N.call.apply(N, [this].concat(L)), p(_(I), "callPlayer", r.callPlayer), p(_(I), "onDurationChange", function() {
          var M = I.getDuration();
          I.props.onDuration(M);
        }), p(_(I), "mute", function() {
          I.callPlayer("setMuted", !0);
        }), p(_(I), "unmute", function() {
          I.callPlayer("setMuted", !1);
        }), p(_(I), "ref", function(M) {
          I.container = M;
        }), I;
      }
      return S(D, [{
        key: "componentDidMount",
        value: function() {
          this.props.onMount && this.props.onMount(this);
        }
      }, {
        key: "load",
        value: function(C) {
          var L = this, k = this.props, M = k.controls, F = k.config, j = k.onError, U = k.playing, G = C.match(a.MATCH_URL_DAILYMOTION), X = u(G, 2), W = X[1];
          if (this.player) {
            this.player.load(W, {
              start: (0, r.parseStartTime)(C),
              autoplay: U
            });
            return;
          }
          (0, r.getSDK)(d, m, O, function(q) {
            return q.player;
          }).then(function(q) {
            if (L.container) {
              var ee = q.player;
              L.player = new ee(L.container, {
                width: "100%",
                height: "100%",
                video: W,
                params: s({
                  controls: M,
                  autoplay: L.props.playing,
                  mute: L.props.muted,
                  start: (0, r.parseStartTime)(C),
                  origin: window.location.origin
                }, F.params),
                events: {
                  apiready: L.props.onReady,
                  seeked: function() {
                    return L.props.onSeek(L.player.currentTime);
                  },
                  video_end: L.props.onEnded,
                  durationchange: L.onDurationChange,
                  pause: L.props.onPause,
                  playing: L.props.onPlay,
                  waiting: L.props.onBuffer,
                  error: function(le) {
                    return j(le);
                  }
                }
              });
            }
          }, j);
        }
      }, {
        key: "play",
        value: function() {
          this.callPlayer("play");
        }
      }, {
        key: "pause",
        value: function() {
          this.callPlayer("pause");
        }
      }, {
        key: "stop",
        value: function() {
        }
      }, {
        key: "seekTo",
        value: function(C) {
          var L = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
          this.callPlayer("seek", C), L || this.pause();
        }
      }, {
        key: "setVolume",
        value: function(C) {
          this.callPlayer("setVolume", C);
        }
      }, {
        key: "getDuration",
        value: function() {
          return this.player.duration || null;
        }
      }, {
        key: "getCurrentTime",
        value: function() {
          return this.player.currentTime;
        }
      }, {
        key: "getSecondsLoaded",
        value: function() {
          return this.player.bufferedTime;
        }
      }, {
        key: "render",
        value: function() {
          var C = this.props.display, L = {
            width: "100%",
            height: "100%",
            display: C
          };
          return /* @__PURE__ */ n.default.createElement("div", {
            style: L
          }, /* @__PURE__ */ n.default.createElement("div", {
            ref: this.ref
          }));
        }
      }]), D;
    }(n.Component);
    e.default = x, p(x, "displayName", "DailyMotion"), p(x, "canPlay", a.canPlay.dailymotion), p(x, "loopOnEnded", !0);
  }(ws)), ws;
}
var xs = {}, fp;
function VA() {
  return fp || (fp = 1, function(e) {
    function t(y) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(p) {
        return typeof p;
      } : t = function(p) {
        return p && typeof Symbol == "function" && p.constructor === Symbol && p !== Symbol.prototype ? "symbol" : typeof p;
      }, t(y);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = o(oe), r = Ae, a = fe;
    function i() {
      if (typeof WeakMap != "function")
        return null;
      var y = /* @__PURE__ */ new WeakMap();
      return i = function() {
        return y;
      }, y;
    }
    function o(y) {
      if (y && y.__esModule)
        return y;
      if (y === null || t(y) !== "object" && typeof y != "function")
        return { default: y };
      var c = i();
      if (c && c.has(y))
        return c.get(y);
      var p = {}, d = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var m in y)
        if (Object.prototype.hasOwnProperty.call(y, m)) {
          var O = d ? Object.getOwnPropertyDescriptor(y, m) : null;
          O && (O.get || O.set) ? Object.defineProperty(p, m, O) : p[m] = y[m];
        }
      return p.default = y, c && c.set(y, p), p;
    }
    function l(y, c) {
      var p = Object.keys(y);
      if (Object.getOwnPropertySymbols) {
        var d = Object.getOwnPropertySymbols(y);
        c && (d = d.filter(function(m) {
          return Object.getOwnPropertyDescriptor(y, m).enumerable;
        })), p.push.apply(p, d);
      }
      return p;
    }
    function s(y) {
      for (var c = 1; c < arguments.length; c++) {
        var p = arguments[c] != null ? arguments[c] : {};
        c % 2 ? l(Object(p), !0).forEach(function(d) {
          A(y, d, p[d]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(y, Object.getOwnPropertyDescriptors(p)) : l(Object(p)).forEach(function(d) {
          Object.defineProperty(y, d, Object.getOwnPropertyDescriptor(p, d));
        });
      }
      return y;
    }
    function u(y, c) {
      if (!(y instanceof c))
        throw new TypeError("Cannot call a class as a function");
    }
    function f(y, c) {
      for (var p = 0; p < c.length; p++) {
        var d = c[p];
        d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(y, d.key, d);
      }
    }
    function h(y, c, p) {
      return c && f(y.prototype, c), p && f(y, p), y;
    }
    function g(y, c) {
      if (typeof c != "function" && c !== null)
        throw new TypeError("Super expression must either be null or a function");
      y.prototype = Object.create(c && c.prototype, { constructor: { value: y, writable: !0, configurable: !0 } }), c && v(y, c);
    }
    function v(y, c) {
      return v = Object.setPrototypeOf || function(d, m) {
        return d.__proto__ = m, d;
      }, v(y, c);
    }
    function E(y) {
      var c = S();
      return function() {
        var d = T(y), m;
        if (c) {
          var O = T(this).constructor;
          m = Reflect.construct(d, arguments, O);
        } else
          m = d.apply(this, arguments);
        return b(this, m);
      };
    }
    function b(y, c) {
      return c && (t(c) === "object" || typeof c == "function") ? c : w(y);
    }
    function w(y) {
      if (y === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return y;
    }
    function S() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function T(y) {
      return T = Object.setPrototypeOf ? Object.getPrototypeOf : function(p) {
        return p.__proto__ || Object.getPrototypeOf(p);
      }, T(y);
    }
    function A(y, c, p) {
      return c in y ? Object.defineProperty(y, c, { value: p, enumerable: !0, configurable: !0, writable: !0 }) : y[c] = p, y;
    }
    var V = "https://widget.mixcloud.com/media/js/widgetApi.js", $ = "Mixcloud", _ = /* @__PURE__ */ function(y) {
      g(p, y);
      var c = E(p);
      function p() {
        var d;
        u(this, p);
        for (var m = arguments.length, O = new Array(m), x = 0; x < m; x++)
          O[x] = arguments[x];
        return d = c.call.apply(c, [this].concat(O)), A(w(d), "callPlayer", r.callPlayer), A(w(d), "duration", null), A(w(d), "currentTime", null), A(w(d), "secondsLoaded", null), A(w(d), "mute", function() {
        }), A(w(d), "unmute", function() {
        }), A(w(d), "ref", function(P) {
          d.iframe = P;
        }), d;
      }
      return h(p, [{
        key: "componentDidMount",
        value: function() {
          this.props.onMount && this.props.onMount(this);
        }
      }, {
        key: "load",
        value: function(m) {
          var O = this;
          (0, r.getSDK)(V, $).then(function(x) {
            O.player = x.PlayerWidget(O.iframe), O.player.ready.then(function() {
              O.player.events.play.on(O.props.onPlay), O.player.events.pause.on(O.props.onPause), O.player.events.ended.on(O.props.onEnded), O.player.events.error.on(O.props.error), O.player.events.progress.on(function(P, N) {
                O.currentTime = P, O.duration = N;
              }), O.props.onReady();
            });
          }, this.props.onError);
        }
      }, {
        key: "play",
        value: function() {
          this.callPlayer("play");
        }
      }, {
        key: "pause",
        value: function() {
          this.callPlayer("pause");
        }
      }, {
        key: "stop",
        value: function() {
        }
      }, {
        key: "seekTo",
        value: function(m) {
          var O = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
          this.callPlayer("seek", m), O || this.pause();
        }
      }, {
        key: "setVolume",
        value: function(m) {
        }
      }, {
        key: "getDuration",
        value: function() {
          return this.duration;
        }
      }, {
        key: "getCurrentTime",
        value: function() {
          return this.currentTime;
        }
      }, {
        key: "getSecondsLoaded",
        value: function() {
          return null;
        }
      }, {
        key: "render",
        value: function() {
          var m = this.props, O = m.url, x = m.config, P = O.match(a.MATCH_URL_MIXCLOUD)[1], N = {
            width: "100%",
            height: "100%"
          }, D = (0, r.queryString)(s(s({}, x.options), {}, {
            feed: "/".concat(P, "/")
          }));
          return /* @__PURE__ */ n.default.createElement("iframe", {
            key: P,
            ref: this.ref,
            style: N,
            src: "https://www.mixcloud.com/widget/iframe/?".concat(D),
            frameBorder: "0",
            allow: "autoplay"
          });
        }
      }]), p;
    }(n.Component);
    e.default = _, A(_, "displayName", "Mixcloud"), A(_, "canPlay", a.canPlay.mixcloud), A(_, "loopOnEnded", !0);
  }(xs)), xs;
}
var Es = {}, pp;
function FA() {
  return pp || (pp = 1, function(e) {
    function t(c) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(d) {
        return typeof d;
      } : t = function(d) {
        return d && typeof Symbol == "function" && d.constructor === Symbol && d !== Symbol.prototype ? "symbol" : typeof d;
      }, t(c);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = o(oe), r = Ae, a = fe;
    function i() {
      if (typeof WeakMap != "function")
        return null;
      var c = /* @__PURE__ */ new WeakMap();
      return i = function() {
        return c;
      }, c;
    }
    function o(c) {
      if (c && c.__esModule)
        return c;
      if (c === null || t(c) !== "object" && typeof c != "function")
        return { default: c };
      var p = i();
      if (p && p.has(c))
        return p.get(c);
      var d = {}, m = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var O in c)
        if (Object.prototype.hasOwnProperty.call(c, O)) {
          var x = m ? Object.getOwnPropertyDescriptor(c, O) : null;
          x && (x.get || x.set) ? Object.defineProperty(d, O, x) : d[O] = c[O];
        }
      return d.default = c, p && p.set(c, d), d;
    }
    function l(c, p) {
      var d = Object.keys(c);
      if (Object.getOwnPropertySymbols) {
        var m = Object.getOwnPropertySymbols(c);
        p && (m = m.filter(function(O) {
          return Object.getOwnPropertyDescriptor(c, O).enumerable;
        })), d.push.apply(d, m);
      }
      return d;
    }
    function s(c) {
      for (var p = 1; p < arguments.length; p++) {
        var d = arguments[p] != null ? arguments[p] : {};
        p % 2 ? l(Object(d), !0).forEach(function(m) {
          A(c, m, d[m]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(c, Object.getOwnPropertyDescriptors(d)) : l(Object(d)).forEach(function(m) {
          Object.defineProperty(c, m, Object.getOwnPropertyDescriptor(d, m));
        });
      }
      return c;
    }
    function u(c, p) {
      if (!(c instanceof p))
        throw new TypeError("Cannot call a class as a function");
    }
    function f(c, p) {
      for (var d = 0; d < p.length; d++) {
        var m = p[d];
        m.enumerable = m.enumerable || !1, m.configurable = !0, "value" in m && (m.writable = !0), Object.defineProperty(c, m.key, m);
      }
    }
    function h(c, p, d) {
      return p && f(c.prototype, p), d && f(c, d), c;
    }
    function g(c, p) {
      if (typeof p != "function" && p !== null)
        throw new TypeError("Super expression must either be null or a function");
      c.prototype = Object.create(p && p.prototype, { constructor: { value: c, writable: !0, configurable: !0 } }), p && v(c, p);
    }
    function v(c, p) {
      return v = Object.setPrototypeOf || function(m, O) {
        return m.__proto__ = O, m;
      }, v(c, p);
    }
    function E(c) {
      var p = S();
      return function() {
        var m = T(c), O;
        if (p) {
          var x = T(this).constructor;
          O = Reflect.construct(m, arguments, x);
        } else
          O = m.apply(this, arguments);
        return b(this, O);
      };
    }
    function b(c, p) {
      return p && (t(p) === "object" || typeof p == "function") ? p : w(c);
    }
    function w(c) {
      if (c === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return c;
    }
    function S() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function T(c) {
      return T = Object.setPrototypeOf ? Object.getPrototypeOf : function(d) {
        return d.__proto__ || Object.getPrototypeOf(d);
      }, T(c);
    }
    function A(c, p, d) {
      return p in c ? Object.defineProperty(c, p, { value: d, enumerable: !0, configurable: !0, writable: !0 }) : c[p] = d, c;
    }
    var V = "https://play.vidyard.com/embed/v4.js", $ = "VidyardV4", _ = "onVidyardAPI", y = /* @__PURE__ */ function(c) {
      g(d, c);
      var p = E(d);
      function d() {
        var m;
        u(this, d);
        for (var O = arguments.length, x = new Array(O), P = 0; P < O; P++)
          x[P] = arguments[P];
        return m = p.call.apply(p, [this].concat(x)), A(w(m), "callPlayer", r.callPlayer), A(w(m), "mute", function() {
          m.setVolume(0);
        }), A(w(m), "unmute", function() {
          m.props.volume !== null && m.setVolume(m.props.volume);
        }), A(w(m), "ref", function(N) {
          m.container = N;
        }), m;
      }
      return h(d, [{
        key: "componentDidMount",
        value: function() {
          this.props.onMount && this.props.onMount(this);
        }
      }, {
        key: "load",
        value: function(O) {
          var x = this, P = this.props, N = P.playing, D = P.config, I = P.onError, C = P.onDuration, L = O && O.match(a.MATCH_URL_VIDYARD)[1];
          this.player && this.stop(), (0, r.getSDK)(V, $, _).then(function(k) {
            x.container && (k.api.addReadyListener(function(M, F) {
              x.player || (x.player = F, x.player.on("ready", x.props.onReady), x.player.on("play", x.props.onPlay), x.player.on("pause", x.props.onPause), x.player.on("seek", x.props.onSeek), x.player.on("playerComplete", x.props.onEnded));
            }, L), k.api.renderPlayer(s({
              uuid: L,
              container: x.container,
              autoplay: N ? 1 : 0
            }, D.options)), k.api.getPlayerMetadata(L).then(function(M) {
              x.duration = M.length_in_seconds, C(M.length_in_seconds);
            }));
          }, I);
        }
      }, {
        key: "play",
        value: function() {
          this.callPlayer("play");
        }
      }, {
        key: "pause",
        value: function() {
          this.callPlayer("pause");
        }
      }, {
        key: "stop",
        value: function() {
          window.VidyardV4.api.destroyPlayer(this.player);
        }
      }, {
        key: "seekTo",
        value: function(O) {
          var x = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
          this.callPlayer("seek", O), x || this.pause();
        }
      }, {
        key: "setVolume",
        value: function(O) {
          this.callPlayer("setVolume", O);
        }
      }, {
        key: "setPlaybackRate",
        value: function(O) {
          this.callPlayer("setPlaybackSpeed", O);
        }
      }, {
        key: "getDuration",
        value: function() {
          return this.duration;
        }
      }, {
        key: "getCurrentTime",
        value: function() {
          return this.callPlayer("currentTime");
        }
      }, {
        key: "getSecondsLoaded",
        value: function() {
          return null;
        }
      }, {
        key: "render",
        value: function() {
          var O = this.props.display, x = {
            width: "100%",
            height: "100%",
            display: O
          };
          return /* @__PURE__ */ n.default.createElement("div", {
            style: x
          }, /* @__PURE__ */ n.default.createElement("div", {
            ref: this.ref
          }));
        }
      }]), d;
    }(n.Component);
    e.default = y, A(y, "displayName", "Vidyard"), A(y, "canPlay", a.canPlay.vidyard);
  }(Es)), Es;
}
var $s = {}, hp;
function HA() {
  return hp || (hp = 1, function(e) {
    function t($) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(y) {
        return typeof y;
      } : t = function(y) {
        return y && typeof Symbol == "function" && y.constructor === Symbol && y !== Symbol.prototype ? "symbol" : typeof y;
      }, t($);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = o(oe), r = Ae, a = fe;
    function i() {
      if (typeof WeakMap != "function")
        return null;
      var $ = /* @__PURE__ */ new WeakMap();
      return i = function() {
        return $;
      }, $;
    }
    function o($) {
      if ($ && $.__esModule)
        return $;
      if ($ === null || t($) !== "object" && typeof $ != "function")
        return { default: $ };
      var _ = i();
      if (_ && _.has($))
        return _.get($);
      var y = {}, c = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var p in $)
        if (Object.prototype.hasOwnProperty.call($, p)) {
          var d = c ? Object.getOwnPropertyDescriptor($, p) : null;
          d && (d.get || d.set) ? Object.defineProperty(y, p, d) : y[p] = $[p];
        }
      return y.default = $, _ && _.set($, y), y;
    }
    function l($, _) {
      if (!($ instanceof _))
        throw new TypeError("Cannot call a class as a function");
    }
    function s($, _) {
      for (var y = 0; y < _.length; y++) {
        var c = _[y];
        c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty($, c.key, c);
      }
    }
    function u($, _, y) {
      return _ && s($.prototype, _), y && s($, y), $;
    }
    function f($, _) {
      if (typeof _ != "function" && _ !== null)
        throw new TypeError("Super expression must either be null or a function");
      $.prototype = Object.create(_ && _.prototype, { constructor: { value: $, writable: !0, configurable: !0 } }), _ && h($, _);
    }
    function h($, _) {
      return h = Object.setPrototypeOf || function(c, p) {
        return c.__proto__ = p, c;
      }, h($, _);
    }
    function g($) {
      var _ = b();
      return function() {
        var c = w($), p;
        if (_) {
          var d = w(this).constructor;
          p = Reflect.construct(c, arguments, d);
        } else
          p = c.apply(this, arguments);
        return v(this, p);
      };
    }
    function v($, _) {
      return _ && (t(_) === "object" || typeof _ == "function") ? _ : E($);
    }
    function E($) {
      if ($ === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return $;
    }
    function b() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function w($) {
      return w = Object.setPrototypeOf ? Object.getPrototypeOf : function(y) {
        return y.__proto__ || Object.getPrototypeOf(y);
      }, w($);
    }
    function S($, _, y) {
      return _ in $ ? Object.defineProperty($, _, { value: y, enumerable: !0, configurable: !0, writable: !0 }) : $[_] = y, $;
    }
    var T = "https://cdn.embed.ly/player-0.1.0.min.js", A = "playerjs", V = /* @__PURE__ */ function($) {
      f(y, $);
      var _ = g(y);
      function y() {
        var c;
        l(this, y);
        for (var p = arguments.length, d = new Array(p), m = 0; m < p; m++)
          d[m] = arguments[m];
        return c = _.call.apply(_, [this].concat(d)), S(E(c), "callPlayer", r.callPlayer), S(E(c), "duration", null), S(E(c), "currentTime", null), S(E(c), "secondsLoaded", null), S(E(c), "mute", function() {
          c.callPlayer("mute");
        }), S(E(c), "unmute", function() {
          c.callPlayer("unmute");
        }), S(E(c), "ref", function(O) {
          c.iframe = O;
        }), c;
      }
      return u(y, [{
        key: "componentDidMount",
        value: function() {
          this.props.onMount && this.props.onMount(this);
        }
      }, {
        key: "load",
        value: function(p) {
          var d = this;
          (0, r.getSDK)(T, A).then(function(m) {
            d.iframe && (d.player = new m.Player(d.iframe), d.player.on("ready", function() {
              setTimeout(function() {
                d.player.isReady = !0, d.player.setLoop(d.props.loop), d.props.muted && d.player.mute(), d.addListeners(d.player, d.props), d.props.onReady();
              }, 500);
            }));
          }, this.props.onError);
        }
      }, {
        key: "addListeners",
        value: function(p, d) {
          var m = this;
          p.on("play", d.onPlay), p.on("pause", d.onPause), p.on("ended", d.onEnded), p.on("error", d.onError), p.on("timeupdate", function(O) {
            var x = O.duration, P = O.seconds;
            m.duration = x, m.currentTime = P;
          });
        }
      }, {
        key: "play",
        value: function() {
          this.callPlayer("play");
        }
      }, {
        key: "pause",
        value: function() {
          this.callPlayer("pause");
        }
      }, {
        key: "stop",
        value: function() {
        }
      }, {
        key: "seekTo",
        value: function(p) {
          var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
          this.callPlayer("setCurrentTime", p), d || this.pause();
        }
      }, {
        key: "setVolume",
        value: function(p) {
          this.callPlayer("setVolume", p);
        }
      }, {
        key: "setLoop",
        value: function(p) {
          this.callPlayer("setLoop", p);
        }
      }, {
        key: "getDuration",
        value: function() {
          return this.duration;
        }
      }, {
        key: "getCurrentTime",
        value: function() {
          return this.currentTime;
        }
      }, {
        key: "getSecondsLoaded",
        value: function() {
          return this.secondsLoaded;
        }
      }, {
        key: "render",
        value: function() {
          var p = {
            width: "100%",
            height: "100%"
          };
          return /* @__PURE__ */ n.default.createElement("iframe", {
            ref: this.ref,
            src: this.props.url,
            frameBorder: "0",
            scrolling: "no",
            style: p,
            allow: "encrypted-media; autoplay; fullscreen;",
            referrerPolicy: "no-referrer-when-downgrade"
          });
        }
      }]), y;
    }(n.Component);
    e.default = V, S(V, "displayName", "Kaltura"), S(V, "canPlay", a.canPlay.kaltura);
  }($s)), $s;
}
var Ps = {}, vp;
function KA() {
  return vp || (vp = 1, function(e) {
    function t(I) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(L) {
        return typeof L;
      } : t = function(L) {
        return L && typeof Symbol == "function" && L.constructor === Symbol && L !== Symbol.prototype ? "symbol" : typeof L;
      }, t(I);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = o(oe), r = Ae, a = fe;
    function i() {
      if (typeof WeakMap != "function")
        return null;
      var I = /* @__PURE__ */ new WeakMap();
      return i = function() {
        return I;
      }, I;
    }
    function o(I) {
      if (I && I.__esModule)
        return I;
      if (I === null || t(I) !== "object" && typeof I != "function")
        return { default: I };
      var C = i();
      if (C && C.has(I))
        return C.get(I);
      var L = {}, k = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var M in I)
        if (Object.prototype.hasOwnProperty.call(I, M)) {
          var F = k ? Object.getOwnPropertyDescriptor(I, M) : null;
          F && (F.get || F.set) ? Object.defineProperty(L, M, F) : L[M] = I[M];
        }
      return L.default = I, C && C.set(I, L), L;
    }
    function l() {
      return l = Object.assign || function(I) {
        for (var C = 1; C < arguments.length; C++) {
          var L = arguments[C];
          for (var k in L)
            Object.prototype.hasOwnProperty.call(L, k) && (I[k] = L[k]);
        }
        return I;
      }, l.apply(this, arguments);
    }
    function s(I, C) {
      if (!(I instanceof C))
        throw new TypeError("Cannot call a class as a function");
    }
    function u(I, C) {
      for (var L = 0; L < C.length; L++) {
        var k = C[L];
        k.enumerable = k.enumerable || !1, k.configurable = !0, "value" in k && (k.writable = !0), Object.defineProperty(I, k.key, k);
      }
    }
    function f(I, C, L) {
      return C && u(I.prototype, C), L && u(I, L), I;
    }
    function h(I, C) {
      if (typeof C != "function" && C !== null)
        throw new TypeError("Super expression must either be null or a function");
      I.prototype = Object.create(C && C.prototype, { constructor: { value: I, writable: !0, configurable: !0 } }), C && g(I, C);
    }
    function g(I, C) {
      return g = Object.setPrototypeOf || function(k, M) {
        return k.__proto__ = M, k;
      }, g(I, C);
    }
    function v(I) {
      var C = w();
      return function() {
        var k = S(I), M;
        if (C) {
          var F = S(this).constructor;
          M = Reflect.construct(k, arguments, F);
        } else
          M = k.apply(this, arguments);
        return E(this, M);
      };
    }
    function E(I, C) {
      return C && (t(C) === "object" || typeof C == "function") ? C : b(I);
    }
    function b(I) {
      if (I === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return I;
    }
    function w() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function S(I) {
      return S = Object.setPrototypeOf ? Object.getPrototypeOf : function(L) {
        return L.__proto__ || Object.getPrototypeOf(L);
      }, S(I);
    }
    function T(I, C, L) {
      return C in I ? Object.defineProperty(I, C, { value: L, enumerable: !0, configurable: !0, writable: !0 }) : I[C] = L, I;
    }
    var A = typeof navigator < "u", V = A && navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1, $ = A && (/iPad|iPhone|iPod/.test(navigator.userAgent) || V) && !window.MSStream, _ = A && /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && !window.MSStream, y = "https://cdn.jsdelivr.net/npm/hls.js@VERSION/dist/hls.min.js", c = "Hls", p = "https://cdnjs.cloudflare.com/ajax/libs/dashjs/VERSION/dash.all.min.js", d = "dashjs", m = "https://cdn.jsdelivr.net/npm/flv.js@VERSION/dist/flv.min.js", O = "flvjs", x = /www\.dropbox\.com\/.+/, P = /https:\/\/watch\.cloudflarestream\.com\/([a-z0-9]+)/, N = "https://videodelivery.net/{id}/manifest/video.m3u8", D = /* @__PURE__ */ function(I) {
      h(L, I);
      var C = v(L);
      function L() {
        var k;
        s(this, L);
        for (var M = arguments.length, F = new Array(M), j = 0; j < M; j++)
          F[j] = arguments[j];
        return k = C.call.apply(C, [this].concat(F)), T(b(k), "onReady", function() {
          var U;
          return (U = k.props).onReady.apply(U, arguments);
        }), T(b(k), "onPlay", function() {
          var U;
          return (U = k.props).onPlay.apply(U, arguments);
        }), T(b(k), "onBuffer", function() {
          var U;
          return (U = k.props).onBuffer.apply(U, arguments);
        }), T(b(k), "onBufferEnd", function() {
          var U;
          return (U = k.props).onBufferEnd.apply(U, arguments);
        }), T(b(k), "onPause", function() {
          var U;
          return (U = k.props).onPause.apply(U, arguments);
        }), T(b(k), "onEnded", function() {
          var U;
          return (U = k.props).onEnded.apply(U, arguments);
        }), T(b(k), "onError", function() {
          var U;
          return (U = k.props).onError.apply(U, arguments);
        }), T(b(k), "onPlayBackRateChange", function(U) {
          return k.props.onPlaybackRateChange(U.target.playbackRate);
        }), T(b(k), "onEnablePIP", function() {
          var U;
          return (U = k.props).onEnablePIP.apply(U, arguments);
        }), T(b(k), "onDisablePIP", function(U) {
          var G = k.props, X = G.onDisablePIP, W = G.playing;
          X(U), W && k.play();
        }), T(b(k), "onPresentationModeChange", function(U) {
          if (k.player && (0, r.supportsWebKitPresentationMode)(k.player)) {
            var G = k.player.webkitPresentationMode;
            G === "picture-in-picture" ? k.onEnablePIP(U) : G === "inline" && k.onDisablePIP(U);
          }
        }), T(b(k), "onSeek", function(U) {
          k.props.onSeek(U.target.currentTime);
        }), T(b(k), "mute", function() {
          k.player.muted = !0;
        }), T(b(k), "unmute", function() {
          k.player.muted = !1;
        }), T(b(k), "renderSourceElement", function(U, G) {
          return typeof U == "string" ? /* @__PURE__ */ n.default.createElement("source", {
            key: G,
            src: U
          }) : /* @__PURE__ */ n.default.createElement("source", l({
            key: G
          }, U));
        }), T(b(k), "renderTrack", function(U, G) {
          return /* @__PURE__ */ n.default.createElement("track", l({
            key: G
          }, U));
        }), T(b(k), "ref", function(U) {
          k.player && (k.prevPlayer = k.player), k.player = U;
        }), k;
      }
      return f(L, [{
        key: "componentDidMount",
        value: function() {
          this.props.onMount && this.props.onMount(this), this.addListeners(this.player);
          var M = this.getSource(this.props.url);
          M && (this.player.src = M), ($ || this.props.config.forceDisableHls) && this.player.load();
        }
      }, {
        key: "componentDidUpdate",
        value: function(M) {
          this.shouldUseAudio(this.props) !== this.shouldUseAudio(M) && (this.removeListeners(this.prevPlayer, M.url), this.addListeners(this.player)), this.props.url !== M.url && !(0, r.isMediaStream)(this.props.url) && !(this.props.url instanceof Array) && (this.player.srcObject = null);
        }
      }, {
        key: "componentWillUnmount",
        value: function() {
          this.player.removeAttribute("src"), this.removeListeners(this.player), this.hls && this.hls.destroy();
        }
      }, {
        key: "addListeners",
        value: function(M) {
          var F = this.props, j = F.url, U = F.playsinline;
          M.addEventListener("play", this.onPlay), M.addEventListener("waiting", this.onBuffer), M.addEventListener("playing", this.onBufferEnd), M.addEventListener("pause", this.onPause), M.addEventListener("seeked", this.onSeek), M.addEventListener("ended", this.onEnded), M.addEventListener("error", this.onError), M.addEventListener("ratechange", this.onPlayBackRateChange), M.addEventListener("enterpictureinpicture", this.onEnablePIP), M.addEventListener("leavepictureinpicture", this.onDisablePIP), M.addEventListener("webkitpresentationmodechanged", this.onPresentationModeChange), this.shouldUseHLS(j) || M.addEventListener("canplay", this.onReady), U && (M.setAttribute("playsinline", ""), M.setAttribute("webkit-playsinline", ""), M.setAttribute("x5-playsinline", ""));
        }
      }, {
        key: "removeListeners",
        value: function(M, F) {
          M.removeEventListener("canplay", this.onReady), M.removeEventListener("play", this.onPlay), M.removeEventListener("waiting", this.onBuffer), M.removeEventListener("playing", this.onBufferEnd), M.removeEventListener("pause", this.onPause), M.removeEventListener("seeked", this.onSeek), M.removeEventListener("ended", this.onEnded), M.removeEventListener("error", this.onError), M.removeEventListener("ratechange", this.onPlayBackRateChange), M.removeEventListener("enterpictureinpicture", this.onEnablePIP), M.removeEventListener("leavepictureinpicture", this.onDisablePIP), M.removeEventListener("webkitpresentationmodechanged", this.onPresentationModeChange), this.shouldUseHLS(F) || M.removeEventListener("canplay", this.onReady);
        }
        // Proxy methods to prevent listener leaks
      }, {
        key: "shouldUseAudio",
        value: function(M) {
          return M.config.forceVideo || M.config.attributes.poster ? !1 : a.AUDIO_EXTENSIONS.test(M.url) || M.config.forceAudio;
        }
      }, {
        key: "shouldUseHLS",
        value: function(M) {
          return _ && this.props.config.forceSafariHLS || this.props.config.forceHLS ? !0 : $ || this.props.config.forceDisableHls ? !1 : a.HLS_EXTENSIONS.test(M) || P.test(M);
        }
      }, {
        key: "shouldUseDASH",
        value: function(M) {
          return a.DASH_EXTENSIONS.test(M) || this.props.config.forceDASH;
        }
      }, {
        key: "shouldUseFLV",
        value: function(M) {
          return a.FLV_EXTENSIONS.test(M) || this.props.config.forceFLV;
        }
      }, {
        key: "load",
        value: function(M) {
          var F = this, j = this.props.config, U = j.hlsVersion, G = j.hlsOptions, X = j.dashVersion, W = j.flvVersion;
          if (this.hls && this.hls.destroy(), this.dash && this.dash.reset(), this.shouldUseHLS(M) && (0, r.getSDK)(y.replace("VERSION", U), c).then(function(q) {
            if (F.hls = new q(G), F.hls.on(q.Events.MANIFEST_PARSED, function() {
              F.props.onReady();
            }), F.hls.on(q.Events.ERROR, function(te, le) {
              F.props.onError(te, le, F.hls, q);
            }), P.test(M)) {
              var ee = M.match(P)[1];
              F.hls.loadSource(N.replace("{id}", ee));
            } else
              F.hls.loadSource(M);
            F.hls.attachMedia(F.player), F.props.onLoaded();
          }), this.shouldUseDASH(M) && (0, r.getSDK)(p.replace("VERSION", X), d).then(function(q) {
            F.dash = q.MediaPlayer().create(), F.dash.initialize(F.player, M, F.props.playing), F.dash.on("error", F.props.onError), parseInt(X) < 3 ? F.dash.getDebug().setLogToBrowserConsole(!1) : F.dash.updateSettings({
              debug: {
                logLevel: q.Debug.LOG_LEVEL_NONE
              }
            }), F.props.onLoaded();
          }), this.shouldUseFLV(M) && (0, r.getSDK)(m.replace("VERSION", W), O).then(function(q) {
            F.flv = q.createPlayer({
              type: "flv",
              url: M
            }), F.flv.attachMediaElement(F.player), F.flv.on(q.Events.ERROR, function(ee, te) {
              F.props.onError(ee, te, F.flv, q);
            }), F.flv.load(), F.props.onLoaded();
          }), M instanceof Array)
            this.player.load();
          else if ((0, r.isMediaStream)(M))
            try {
              this.player.srcObject = M;
            } catch {
              this.player.src = window.URL.createObjectURL(M);
            }
        }
      }, {
        key: "play",
        value: function() {
          var M = this.player.play();
          M && M.catch(this.props.onError);
        }
      }, {
        key: "pause",
        value: function() {
          this.player.pause();
        }
      }, {
        key: "stop",
        value: function() {
          this.player.removeAttribute("src"), this.dash && this.dash.reset();
        }
      }, {
        key: "seekTo",
        value: function(M) {
          var F = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
          this.player.currentTime = M, F || this.pause();
        }
      }, {
        key: "setVolume",
        value: function(M) {
          this.player.volume = M;
        }
      }, {
        key: "enablePIP",
        value: function() {
          this.player.requestPictureInPicture && document.pictureInPictureElement !== this.player ? this.player.requestPictureInPicture() : (0, r.supportsWebKitPresentationMode)(this.player) && this.player.webkitPresentationMode !== "picture-in-picture" && this.player.webkitSetPresentationMode("picture-in-picture");
        }
      }, {
        key: "disablePIP",
        value: function() {
          document.exitPictureInPicture && document.pictureInPictureElement === this.player ? document.exitPictureInPicture() : (0, r.supportsWebKitPresentationMode)(this.player) && this.player.webkitPresentationMode !== "inline" && this.player.webkitSetPresentationMode("inline");
        }
      }, {
        key: "setPlaybackRate",
        value: function(M) {
          try {
            this.player.playbackRate = M;
          } catch (F) {
            this.props.onError(F);
          }
        }
      }, {
        key: "getDuration",
        value: function() {
          if (!this.player)
            return null;
          var M = this.player, F = M.duration, j = M.seekable;
          return F === 1 / 0 && j.length > 0 ? j.end(j.length - 1) : F;
        }
      }, {
        key: "getCurrentTime",
        value: function() {
          return this.player ? this.player.currentTime : null;
        }
      }, {
        key: "getSecondsLoaded",
        value: function() {
          if (!this.player)
            return null;
          var M = this.player.buffered;
          if (M.length === 0)
            return 0;
          var F = M.end(M.length - 1), j = this.getDuration();
          return F > j ? j : F;
        }
      }, {
        key: "getSource",
        value: function(M) {
          var F = this.shouldUseHLS(M), j = this.shouldUseDASH(M), U = this.shouldUseFLV(M);
          if (!(M instanceof Array || (0, r.isMediaStream)(M) || F || j || U))
            return x.test(M) ? M.replace("www.dropbox.com", "dl.dropboxusercontent.com") : M;
        }
      }, {
        key: "render",
        value: function() {
          var M = this.props, F = M.url, j = M.playing, U = M.loop, G = M.controls, X = M.muted, W = M.config, q = M.width, ee = M.height, te = this.shouldUseAudio(this.props), le = te ? "audio" : "video", Y = {
            width: q === "auto" ? q : "100%",
            height: ee === "auto" ? ee : "100%"
          };
          return /* @__PURE__ */ n.default.createElement(le, l({
            ref: this.ref,
            src: this.getSource(F),
            style: Y,
            preload: "auto",
            autoPlay: j || void 0,
            controls: G,
            muted: X,
            loop: U
          }, W.attributes), F instanceof Array && F.map(this.renderSourceElement), W.tracks.map(this.renderTrack));
        }
      }]), L;
    }(n.Component);
    e.default = D, T(D, "displayName", "FilePlayer"), T(D, "canPlay", a.canPlay.file);
  }(Ps)), Ps;
}
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = oe, n = Ae, r = fe;
  function a(s) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? a = function(f) {
      return typeof f;
    } : a = function(f) {
      return f && typeof Symbol == "function" && f.constructor === Symbol && f !== Symbol.prototype ? "symbol" : typeof f;
    }, a(s);
  }
  function i() {
    if (typeof WeakMap != "function")
      return null;
    var s = /* @__PURE__ */ new WeakMap();
    return i = function() {
      return s;
    }, s;
  }
  function o(s) {
    if (s && s.__esModule)
      return s;
    if (s === null || a(s) !== "object" && typeof s != "function")
      return { default: s };
    var u = i();
    if (u && u.has(s))
      return u.get(s);
    var f = {}, h = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var g in s)
      if (Object.prototype.hasOwnProperty.call(s, g)) {
        var v = h ? Object.getOwnPropertyDescriptor(s, g) : null;
        v && (v.get || v.set) ? Object.defineProperty(f, g, v) : f[g] = s[g];
      }
    return f.default = s, u && u.set(s, f), f;
  }
  var l = [{
    key: "youtube",
    name: "YouTube",
    canPlay: r.canPlay.youtube,
    lazyPlayer: /* @__PURE__ */ (0, t.lazy)(function() {
      return Promise.resolve().then(function() {
        return o(MA());
      });
    })
  }, {
    key: "soundcloud",
    name: "SoundCloud",
    canPlay: r.canPlay.soundcloud,
    lazyPlayer: /* @__PURE__ */ (0, t.lazy)(function() {
      return Promise.resolve().then(function() {
        return o(_A());
      });
    })
  }, {
    key: "vimeo",
    name: "Vimeo",
    canPlay: r.canPlay.vimeo,
    lazyPlayer: /* @__PURE__ */ (0, t.lazy)(function() {
      return Promise.resolve().then(function() {
        return o(LA());
      });
    })
  }, {
    key: "facebook",
    name: "Facebook",
    canPlay: r.canPlay.facebook,
    lazyPlayer: /* @__PURE__ */ (0, t.lazy)(function() {
      return Promise.resolve().then(function() {
        return o(IA());
      });
    })
  }, {
    key: "streamable",
    name: "Streamable",
    canPlay: r.canPlay.streamable,
    lazyPlayer: /* @__PURE__ */ (0, t.lazy)(function() {
      return Promise.resolve().then(function() {
        return o(DA());
      });
    })
  }, {
    key: "wistia",
    name: "Wistia",
    canPlay: r.canPlay.wistia,
    lazyPlayer: /* @__PURE__ */ (0, t.lazy)(function() {
      return Promise.resolve().then(function() {
        return o(NA());
      });
    })
  }, {
    key: "twitch",
    name: "Twitch",
    canPlay: r.canPlay.twitch,
    lazyPlayer: /* @__PURE__ */ (0, t.lazy)(function() {
      return Promise.resolve().then(function() {
        return o(RA());
      });
    })
  }, {
    key: "dailymotion",
    name: "DailyMotion",
    canPlay: r.canPlay.dailymotion,
    lazyPlayer: /* @__PURE__ */ (0, t.lazy)(function() {
      return Promise.resolve().then(function() {
        return o(BA());
      });
    })
  }, {
    key: "mixcloud",
    name: "Mixcloud",
    canPlay: r.canPlay.mixcloud,
    lazyPlayer: /* @__PURE__ */ (0, t.lazy)(function() {
      return Promise.resolve().then(function() {
        return o(VA());
      });
    })
  }, {
    key: "vidyard",
    name: "Vidyard",
    canPlay: r.canPlay.vidyard,
    lazyPlayer: /* @__PURE__ */ (0, t.lazy)(function() {
      return Promise.resolve().then(function() {
        return o(FA());
      });
    })
  }, {
    key: "kaltura",
    name: "Kaltura",
    canPlay: r.canPlay.kaltura,
    lazyPlayer: /* @__PURE__ */ (0, t.lazy)(function() {
      return Promise.resolve().then(function() {
        return o(HA());
      });
    })
  }, {
    key: "file",
    name: "FilePlayer",
    canPlay: r.canPlay.file,
    canEnablePIP: function(u) {
      return r.canPlay.file(u) && (document.pictureInPictureEnabled || (0, n.supportsWebKitPresentationMode)()) && !r.AUDIO_EXTENSIONS.test(u);
    },
    lazyPlayer: /* @__PURE__ */ (0, t.lazy)(function() {
      return Promise.resolve().then(function() {
        return o(KA());
      });
    })
  }];
  e.default = l;
})(_m);
var eo = {}, mp = Number.isNaN || function(t) {
  return typeof t == "number" && t !== t;
};
function jA(e, t) {
  return !!(e === t || mp(e) && mp(t));
}
function UA(e, t) {
  if (e.length !== t.length)
    return !1;
  for (var n = 0; n < e.length; n++)
    if (!jA(e[n], t[n]))
      return !1;
  return !0;
}
function WA(e, t) {
  t === void 0 && (t = UA);
  var n, r = [], a, i = !1;
  function o() {
    for (var l = [], s = 0; s < arguments.length; s++)
      l[s] = arguments[s];
    return i && n === this && t(l, r) || (a = e.apply(this, l), i = !0, n = this, r = l), a;
  }
  return o;
}
const qA = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: WA
}, Symbol.toStringTag, { value: "Module" })), ZA = /* @__PURE__ */ vS(qA);
var GA = typeof Element < "u", YA = typeof Map == "function", XA = typeof Set == "function", JA = typeof ArrayBuffer == "function" && !!ArrayBuffer.isView;
function li(e, t) {
  if (e === t)
    return !0;
  if (e && t && typeof e == "object" && typeof t == "object") {
    if (e.constructor !== t.constructor)
      return !1;
    var n, r, a;
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!li(e[r], t[r]))
          return !1;
      return !0;
    }
    var i;
    if (YA && e instanceof Map && t instanceof Map) {
      if (e.size !== t.size)
        return !1;
      for (i = e.entries(); !(r = i.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      for (i = e.entries(); !(r = i.next()).done; )
        if (!li(r.value[1], t.get(r.value[0])))
          return !1;
      return !0;
    }
    if (XA && e instanceof Set && t instanceof Set) {
      if (e.size !== t.size)
        return !1;
      for (i = e.entries(); !(r = i.next()).done; )
        if (!t.has(r.value[0]))
          return !1;
      return !0;
    }
    if (JA && ArrayBuffer.isView(e) && ArrayBuffer.isView(t)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (e[r] !== t[r])
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === t.source && e.flags === t.flags;
    if (e.valueOf !== Object.prototype.valueOf && typeof e.valueOf == "function" && typeof t.valueOf == "function")
      return e.valueOf() === t.valueOf();
    if (e.toString !== Object.prototype.toString && typeof e.toString == "function" && typeof t.toString == "function")
      return e.toString() === t.toString();
    if (a = Object.keys(e), n = a.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(t, a[r]))
        return !1;
    if (GA && e instanceof Element)
      return !1;
    for (r = n; r-- !== 0; )
      if (!((a[r] === "_owner" || a[r] === "__v" || a[r] === "__o") && e.$$typeof) && !li(e[a[r]], t[a[r]]))
        return !1;
    return !0;
  }
  return e !== e && t !== t;
}
var Jm = function(t, n) {
  try {
    return li(t, n);
  } catch (r) {
    if ((r.message || "").match(/stack|recursion/i))
      return console.warn("react-fast-compare cannot handle circular refs"), !1;
    throw r;
  }
}, Dn = {}, fc = { exports: {} }, Za = { exports: {} }, ke = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var gp;
function QA() {
  if (gp)
    return ke;
  gp = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, s = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, v = e ? Symbol.for("react.memo") : 60115, E = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, w = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, T = e ? Symbol.for("react.scope") : 60119;
  function A($) {
    if (typeof $ == "object" && $ !== null) {
      var _ = $.$$typeof;
      switch (_) {
        case t:
          switch ($ = $.type, $) {
            case s:
            case u:
            case r:
            case i:
            case a:
            case h:
              return $;
            default:
              switch ($ = $ && $.$$typeof, $) {
                case l:
                case f:
                case E:
                case v:
                case o:
                  return $;
                default:
                  return _;
              }
          }
        case n:
          return _;
      }
    }
  }
  function V($) {
    return A($) === u;
  }
  return ke.AsyncMode = s, ke.ConcurrentMode = u, ke.ContextConsumer = l, ke.ContextProvider = o, ke.Element = t, ke.ForwardRef = f, ke.Fragment = r, ke.Lazy = E, ke.Memo = v, ke.Portal = n, ke.Profiler = i, ke.StrictMode = a, ke.Suspense = h, ke.isAsyncMode = function($) {
    return V($) || A($) === s;
  }, ke.isConcurrentMode = V, ke.isContextConsumer = function($) {
    return A($) === l;
  }, ke.isContextProvider = function($) {
    return A($) === o;
  }, ke.isElement = function($) {
    return typeof $ == "object" && $ !== null && $.$$typeof === t;
  }, ke.isForwardRef = function($) {
    return A($) === f;
  }, ke.isFragment = function($) {
    return A($) === r;
  }, ke.isLazy = function($) {
    return A($) === E;
  }, ke.isMemo = function($) {
    return A($) === v;
  }, ke.isPortal = function($) {
    return A($) === n;
  }, ke.isProfiler = function($) {
    return A($) === i;
  }, ke.isStrictMode = function($) {
    return A($) === a;
  }, ke.isSuspense = function($) {
    return A($) === h;
  }, ke.isValidElementType = function($) {
    return typeof $ == "string" || typeof $ == "function" || $ === r || $ === u || $ === i || $ === a || $ === h || $ === g || typeof $ == "object" && $ !== null && ($.$$typeof === E || $.$$typeof === v || $.$$typeof === o || $.$$typeof === l || $.$$typeof === f || $.$$typeof === w || $.$$typeof === S || $.$$typeof === T || $.$$typeof === b);
  }, ke.typeOf = A, ke;
}
var Te = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var yp;
function eO() {
  return yp || (yp = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, l = e ? Symbol.for("react.context") : 60110, s = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, f = e ? Symbol.for("react.forward_ref") : 60112, h = e ? Symbol.for("react.suspense") : 60113, g = e ? Symbol.for("react.suspense_list") : 60120, v = e ? Symbol.for("react.memo") : 60115, E = e ? Symbol.for("react.lazy") : 60116, b = e ? Symbol.for("react.block") : 60121, w = e ? Symbol.for("react.fundamental") : 60117, S = e ? Symbol.for("react.responder") : 60118, T = e ? Symbol.for("react.scope") : 60119;
    function A(Y) {
      return typeof Y == "string" || typeof Y == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      Y === r || Y === u || Y === i || Y === a || Y === h || Y === g || typeof Y == "object" && Y !== null && (Y.$$typeof === E || Y.$$typeof === v || Y.$$typeof === o || Y.$$typeof === l || Y.$$typeof === f || Y.$$typeof === w || Y.$$typeof === S || Y.$$typeof === T || Y.$$typeof === b);
    }
    function V(Y) {
      if (typeof Y == "object" && Y !== null) {
        var ye = Y.$$typeof;
        switch (ye) {
          case t:
            var Ce = Y.type;
            switch (Ce) {
              case s:
              case u:
              case r:
              case i:
              case a:
              case h:
                return Ce;
              default:
                var Ke = Ce && Ce.$$typeof;
                switch (Ke) {
                  case l:
                  case f:
                  case E:
                  case v:
                  case o:
                    return Ke;
                  default:
                    return ye;
                }
            }
          case n:
            return ye;
        }
      }
    }
    var $ = s, _ = u, y = l, c = o, p = t, d = f, m = r, O = E, x = v, P = n, N = i, D = a, I = h, C = !1;
    function L(Y) {
      return C || (C = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), k(Y) || V(Y) === s;
    }
    function k(Y) {
      return V(Y) === u;
    }
    function M(Y) {
      return V(Y) === l;
    }
    function F(Y) {
      return V(Y) === o;
    }
    function j(Y) {
      return typeof Y == "object" && Y !== null && Y.$$typeof === t;
    }
    function U(Y) {
      return V(Y) === f;
    }
    function G(Y) {
      return V(Y) === r;
    }
    function X(Y) {
      return V(Y) === E;
    }
    function W(Y) {
      return V(Y) === v;
    }
    function q(Y) {
      return V(Y) === n;
    }
    function ee(Y) {
      return V(Y) === i;
    }
    function te(Y) {
      return V(Y) === a;
    }
    function le(Y) {
      return V(Y) === h;
    }
    Te.AsyncMode = $, Te.ConcurrentMode = _, Te.ContextConsumer = y, Te.ContextProvider = c, Te.Element = p, Te.ForwardRef = d, Te.Fragment = m, Te.Lazy = O, Te.Memo = x, Te.Portal = P, Te.Profiler = N, Te.StrictMode = D, Te.Suspense = I, Te.isAsyncMode = L, Te.isConcurrentMode = k, Te.isContextConsumer = M, Te.isContextProvider = F, Te.isElement = j, Te.isForwardRef = U, Te.isFragment = G, Te.isLazy = X, Te.isMemo = W, Te.isPortal = q, Te.isProfiler = ee, Te.isStrictMode = te, Te.isSuspense = le, Te.isValidElementType = A, Te.typeOf = V;
  }()), Te;
}
var bp;
function Qm() {
  return bp || (bp = 1, process.env.NODE_ENV === "production" ? Za.exports = QA() : Za.exports = eO()), Za.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Cs, wp;
function tO() {
  if (wp)
    return Cs;
  wp = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var o = {}, l = 0; l < 10; l++)
        o["_" + String.fromCharCode(l)] = l;
      var s = Object.getOwnPropertyNames(o).map(function(f) {
        return o[f];
      });
      if (s.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(f) {
        u[f] = f;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Cs = a() ? Object.assign : function(i, o) {
    for (var l, s = r(i), u, f = 1; f < arguments.length; f++) {
      l = Object(arguments[f]);
      for (var h in l)
        t.call(l, h) && (s[h] = l[h]);
      if (e) {
        u = e(l);
        for (var g = 0; g < u.length; g++)
          n.call(l, u[g]) && (s[u[g]] = l[u[g]]);
      }
    }
    return s;
  }, Cs;
}
var Ss, xp;
function l1() {
  if (xp)
    return Ss;
  xp = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return Ss = e, Ss;
}
var ks, Ep;
function eg() {
  return Ep || (Ep = 1, ks = Function.call.bind(Object.prototype.hasOwnProperty)), ks;
}
var Ts, $p;
function nO() {
  if ($p)
    return Ts;
  $p = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = l1(), n = {}, r = eg();
    e = function(i) {
      var o = "Warning: " + i;
      typeof console < "u" && console.error(o);
      try {
        throw new Error(o);
      } catch {
      }
    };
  }
  function a(i, o, l, s, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var f in i)
        if (r(i, f)) {
          var h;
          try {
            if (typeof i[f] != "function") {
              var g = Error(
                (s || "React class") + ": " + l + " type `" + f + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof i[f] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw g.name = "Invariant Violation", g;
            }
            h = i[f](o, f, s, l, null, t);
          } catch (E) {
            h = E;
          }
          if (h && !(h instanceof Error) && e(
            (s || "React class") + ": type specification of " + l + " `" + f + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof h + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), h instanceof Error && !(h.message in n)) {
            n[h.message] = !0;
            var v = u ? u() : "";
            e(
              "Failed " + l + " type: " + h.message + (v ?? "")
            );
          }
        }
    }
  }
  return a.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Ts = a, Ts;
}
var As, Pp;
function rO() {
  if (Pp)
    return As;
  Pp = 1;
  var e = Qm(), t = tO(), n = l1(), r = eg(), a = nO(), i = function() {
  };
  process.env.NODE_ENV !== "production" && (i = function(l) {
    var s = "Warning: " + l;
    typeof console < "u" && console.error(s);
    try {
      throw new Error(s);
    } catch {
    }
  });
  function o() {
    return null;
  }
  return As = function(l, s) {
    var u = typeof Symbol == "function" && Symbol.iterator, f = "@@iterator";
    function h(k) {
      var M = k && (u && k[u] || k[f]);
      if (typeof M == "function")
        return M;
    }
    var g = "<<anonymous>>", v = {
      array: S("array"),
      bigint: S("bigint"),
      bool: S("boolean"),
      func: S("function"),
      number: S("number"),
      object: S("object"),
      string: S("string"),
      symbol: S("symbol"),
      any: T(),
      arrayOf: A,
      element: V(),
      elementType: $(),
      instanceOf: _,
      node: d(),
      objectOf: c,
      oneOf: y,
      oneOfType: p,
      shape: O,
      exact: x
    };
    function E(k, M) {
      return k === M ? k !== 0 || 1 / k === 1 / M : k !== k && M !== M;
    }
    function b(k, M) {
      this.message = k, this.data = M && typeof M == "object" ? M : {}, this.stack = "";
    }
    b.prototype = Error.prototype;
    function w(k) {
      if (process.env.NODE_ENV !== "production")
        var M = {}, F = 0;
      function j(G, X, W, q, ee, te, le) {
        if (q = q || g, te = te || W, le !== n) {
          if (s) {
            var Y = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw Y.name = "Invariant Violation", Y;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ye = q + ":" + W;
            !M[ye] && // Avoid spamming the console because they are often not actionable except for lib authors
            F < 3 && (i(
              "You are manually calling a React.PropTypes validation function for the `" + te + "` prop on `" + q + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), M[ye] = !0, F++);
          }
        }
        return X[W] == null ? G ? X[W] === null ? new b("The " + ee + " `" + te + "` is marked as required " + ("in `" + q + "`, but its value is `null`.")) : new b("The " + ee + " `" + te + "` is marked as required in " + ("`" + q + "`, but its value is `undefined`.")) : null : k(X, W, q, ee, te);
      }
      var U = j.bind(null, !1);
      return U.isRequired = j.bind(null, !0), U;
    }
    function S(k) {
      function M(F, j, U, G, X, W) {
        var q = F[j], ee = D(q);
        if (ee !== k) {
          var te = I(q);
          return new b(
            "Invalid " + G + " `" + X + "` of type " + ("`" + te + "` supplied to `" + U + "`, expected ") + ("`" + k + "`."),
            { expectedType: k }
          );
        }
        return null;
      }
      return w(M);
    }
    function T() {
      return w(o);
    }
    function A(k) {
      function M(F, j, U, G, X) {
        if (typeof k != "function")
          return new b("Property `" + X + "` of component `" + U + "` has invalid PropType notation inside arrayOf.");
        var W = F[j];
        if (!Array.isArray(W)) {
          var q = D(W);
          return new b("Invalid " + G + " `" + X + "` of type " + ("`" + q + "` supplied to `" + U + "`, expected an array."));
        }
        for (var ee = 0; ee < W.length; ee++) {
          var te = k(W, ee, U, G, X + "[" + ee + "]", n);
          if (te instanceof Error)
            return te;
        }
        return null;
      }
      return w(M);
    }
    function V() {
      function k(M, F, j, U, G) {
        var X = M[F];
        if (!l(X)) {
          var W = D(X);
          return new b("Invalid " + U + " `" + G + "` of type " + ("`" + W + "` supplied to `" + j + "`, expected a single ReactElement."));
        }
        return null;
      }
      return w(k);
    }
    function $() {
      function k(M, F, j, U, G) {
        var X = M[F];
        if (!e.isValidElementType(X)) {
          var W = D(X);
          return new b("Invalid " + U + " `" + G + "` of type " + ("`" + W + "` supplied to `" + j + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return w(k);
    }
    function _(k) {
      function M(F, j, U, G, X) {
        if (!(F[j] instanceof k)) {
          var W = k.name || g, q = L(F[j]);
          return new b("Invalid " + G + " `" + X + "` of type " + ("`" + q + "` supplied to `" + U + "`, expected ") + ("instance of `" + W + "`."));
        }
        return null;
      }
      return w(M);
    }
    function y(k) {
      if (!Array.isArray(k))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? i(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : i("Invalid argument supplied to oneOf, expected an array.")), o;
      function M(F, j, U, G, X) {
        for (var W = F[j], q = 0; q < k.length; q++)
          if (E(W, k[q]))
            return null;
        var ee = JSON.stringify(k, function(le, Y) {
          var ye = I(Y);
          return ye === "symbol" ? String(Y) : Y;
        });
        return new b("Invalid " + G + " `" + X + "` of value `" + String(W) + "` " + ("supplied to `" + U + "`, expected one of " + ee + "."));
      }
      return w(M);
    }
    function c(k) {
      function M(F, j, U, G, X) {
        if (typeof k != "function")
          return new b("Property `" + X + "` of component `" + U + "` has invalid PropType notation inside objectOf.");
        var W = F[j], q = D(W);
        if (q !== "object")
          return new b("Invalid " + G + " `" + X + "` of type " + ("`" + q + "` supplied to `" + U + "`, expected an object."));
        for (var ee in W)
          if (r(W, ee)) {
            var te = k(W, ee, U, G, X + "." + ee, n);
            if (te instanceof Error)
              return te;
          }
        return null;
      }
      return w(M);
    }
    function p(k) {
      if (!Array.isArray(k))
        return process.env.NODE_ENV !== "production" && i("Invalid argument supplied to oneOfType, expected an instance of array."), o;
      for (var M = 0; M < k.length; M++) {
        var F = k[M];
        if (typeof F != "function")
          return i(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + C(F) + " at index " + M + "."
          ), o;
      }
      function j(U, G, X, W, q) {
        for (var ee = [], te = 0; te < k.length; te++) {
          var le = k[te], Y = le(U, G, X, W, q, n);
          if (Y == null)
            return null;
          Y.data && r(Y.data, "expectedType") && ee.push(Y.data.expectedType);
        }
        var ye = ee.length > 0 ? ", expected one of type [" + ee.join(", ") + "]" : "";
        return new b("Invalid " + W + " `" + q + "` supplied to " + ("`" + X + "`" + ye + "."));
      }
      return w(j);
    }
    function d() {
      function k(M, F, j, U, G) {
        return P(M[F]) ? null : new b("Invalid " + U + " `" + G + "` supplied to " + ("`" + j + "`, expected a ReactNode."));
      }
      return w(k);
    }
    function m(k, M, F, j, U) {
      return new b(
        (k || "React class") + ": " + M + " type `" + F + "." + j + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + U + "`."
      );
    }
    function O(k) {
      function M(F, j, U, G, X) {
        var W = F[j], q = D(W);
        if (q !== "object")
          return new b("Invalid " + G + " `" + X + "` of type `" + q + "` " + ("supplied to `" + U + "`, expected `object`."));
        for (var ee in k) {
          var te = k[ee];
          if (typeof te != "function")
            return m(U, G, X, ee, I(te));
          var le = te(W, ee, U, G, X + "." + ee, n);
          if (le)
            return le;
        }
        return null;
      }
      return w(M);
    }
    function x(k) {
      function M(F, j, U, G, X) {
        var W = F[j], q = D(W);
        if (q !== "object")
          return new b("Invalid " + G + " `" + X + "` of type `" + q + "` " + ("supplied to `" + U + "`, expected `object`."));
        var ee = t({}, F[j], k);
        for (var te in ee) {
          var le = k[te];
          if (r(k, te) && typeof le != "function")
            return m(U, G, X, te, I(le));
          if (!le)
            return new b(
              "Invalid " + G + " `" + X + "` key `" + te + "` supplied to `" + U + "`.\nBad object: " + JSON.stringify(F[j], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(k), null, "  ")
            );
          var Y = le(W, te, U, G, X + "." + te, n);
          if (Y)
            return Y;
        }
        return null;
      }
      return w(M);
    }
    function P(k) {
      switch (typeof k) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !k;
        case "object":
          if (Array.isArray(k))
            return k.every(P);
          if (k === null || l(k))
            return !0;
          var M = h(k);
          if (M) {
            var F = M.call(k), j;
            if (M !== k.entries) {
              for (; !(j = F.next()).done; )
                if (!P(j.value))
                  return !1;
            } else
              for (; !(j = F.next()).done; ) {
                var U = j.value;
                if (U && !P(U[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function N(k, M) {
      return k === "symbol" ? !0 : M ? M["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && M instanceof Symbol : !1;
    }
    function D(k) {
      var M = typeof k;
      return Array.isArray(k) ? "array" : k instanceof RegExp ? "object" : N(M, k) ? "symbol" : M;
    }
    function I(k) {
      if (typeof k > "u" || k === null)
        return "" + k;
      var M = D(k);
      if (M === "object") {
        if (k instanceof Date)
          return "date";
        if (k instanceof RegExp)
          return "regexp";
      }
      return M;
    }
    function C(k) {
      var M = I(k);
      switch (M) {
        case "array":
        case "object":
          return "an " + M;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + M;
        default:
          return M;
      }
    }
    function L(k) {
      return !k.constructor || !k.constructor.name ? g : k.constructor.name;
    }
    return v.checkPropTypes = a, v.resetWarningCache = a.resetWarningCache, v.PropTypes = v, v;
  }, As;
}
var Os, Cp;
function aO() {
  if (Cp)
    return Os;
  Cp = 1;
  var e = l1();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Os = function() {
    function r(o, l, s, u, f, h) {
      if (h !== e) {
        var g = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw g.name = "Invariant Violation", g;
      }
    }
    r.isRequired = r;
    function a() {
      return r;
    }
    var i = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: a,
      element: r,
      elementType: r,
      instanceOf: a,
      node: r,
      objectOf: a,
      oneOf: a,
      oneOfType: a,
      shape: a,
      exact: a,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return i.PropTypes = i, i;
  }, Os;
}
if (process.env.NODE_ENV !== "production") {
  var iO = Qm(), oO = !0;
  fc.exports = rO()(iO.isElement, oO);
} else
  fc.exports = aO()();
var lO = fc.exports;
Object.defineProperty(Dn, "__esModule", {
  value: !0
});
Dn.defaultProps = Dn.propTypes = void 0;
var rn = sO(lO);
function sO(e) {
  return e && e.__esModule ? e : { default: e };
}
var rt = rn.default.string, at = rn.default.bool, tr = rn.default.number, zs = rn.default.array, Br = rn.default.oneOfType, Et = rn.default.shape, it = rn.default.object, Ue = rn.default.func, Sp = rn.default.node, cO = {
  url: Br([rt, zs, it]),
  playing: at,
  loop: at,
  controls: at,
  volume: tr,
  muted: at,
  playbackRate: tr,
  width: Br([rt, tr]),
  height: Br([rt, tr]),
  style: it,
  progressInterval: tr,
  playsinline: at,
  pip: at,
  stopOnUnmount: at,
  light: Br([at, rt, it]),
  playIcon: Sp,
  previewTabIndex: tr,
  fallback: Sp,
  oEmbedUrl: rt,
  wrapper: Br([rt, Ue, Et({
    render: Ue.isRequired
  })]),
  config: Et({
    soundcloud: Et({
      options: it
    }),
    youtube: Et({
      playerVars: it,
      embedOptions: it,
      onUnstarted: Ue
    }),
    facebook: Et({
      appId: rt,
      version: rt,
      playerId: rt,
      attributes: it
    }),
    dailymotion: Et({
      params: it
    }),
    vimeo: Et({
      playerOptions: it,
      title: rt
    }),
    file: Et({
      attributes: it,
      tracks: zs,
      forceVideo: at,
      forceAudio: at,
      forceHLS: at,
      forceSafariHLS: at,
      forceDisableHls: at,
      forceDASH: at,
      forceFLV: at,
      hlsOptions: it,
      hlsVersion: rt,
      dashVersion: rt,
      flvVersion: rt
    }),
    wistia: Et({
      options: it,
      playerId: rt,
      customControls: zs
    }),
    mixcloud: Et({
      options: it
    }),
    twitch: Et({
      options: it,
      playerId: rt
    }),
    vidyard: Et({
      options: it
    })
  }),
  onReady: Ue,
  onStart: Ue,
  onPlay: Ue,
  onPause: Ue,
  onBuffer: Ue,
  onBufferEnd: Ue,
  onEnded: Ue,
  onError: Ue,
  onDuration: Ue,
  onSeek: Ue,
  onPlaybackRateChange: Ue,
  onPlaybackQualityChange: Ue,
  onProgress: Ue,
  onClickPreview: Ue,
  onEnablePIP: Ue,
  onDisablePIP: Ue
};
Dn.propTypes = cO;
var Ge = function() {
}, uO = {
  playing: !1,
  loop: !1,
  controls: !1,
  volume: null,
  muted: !1,
  playbackRate: 1,
  width: "640px",
  height: "360px",
  style: {},
  progressInterval: 1e3,
  playsinline: !1,
  pip: !1,
  stopOnUnmount: !0,
  light: !1,
  fallback: null,
  wrapper: "div",
  previewTabIndex: 0,
  oEmbedUrl: "https://noembed.com/embed?url={url}",
  config: {
    soundcloud: {
      options: {
        visual: !0,
        // Undocumented, but makes player fill container and look better
        buying: !1,
        liking: !1,
        download: !1,
        sharing: !1,
        show_comments: !1,
        show_playcount: !1
      }
    },
    youtube: {
      playerVars: {
        playsinline: 1,
        showinfo: 0,
        rel: 0,
        iv_load_policy: 3,
        modestbranding: 1
      },
      embedOptions: {},
      onUnstarted: Ge
    },
    facebook: {
      appId: "1309697205772819",
      version: "v3.3",
      playerId: null,
      attributes: {}
    },
    dailymotion: {
      params: {
        api: 1,
        "endscreen-enable": !1
      }
    },
    vimeo: {
      playerOptions: {
        autopause: !1,
        byline: !1,
        portrait: !1,
        title: !1
      },
      title: null
    },
    file: {
      attributes: {},
      tracks: [],
      forceVideo: !1,
      forceAudio: !1,
      forceHLS: !1,
      forceDASH: !1,
      forceFLV: !1,
      hlsOptions: {},
      hlsVersion: "1.1.4",
      dashVersion: "3.1.3",
      flvVersion: "1.5.0",
      forceDisableHls: !1
    },
    wistia: {
      options: {},
      playerId: null,
      customControls: null
    },
    mixcloud: {
      options: {
        hide_cover: 1
      }
    },
    twitch: {
      options: {},
      playerId: null
    },
    vidyard: {
      options: {}
    }
  },
  onReady: Ge,
  onStart: Ge,
  onPlay: Ge,
  onPause: Ge,
  onBuffer: Ge,
  onBufferEnd: Ge,
  onEnded: Ge,
  onError: Ge,
  onDuration: Ge,
  onSeek: Ge,
  onPlaybackRateChange: Ge,
  onPlaybackQualityChange: Ge,
  onProgress: Ge,
  onClickPreview: Ge,
  onEnablePIP: Ge,
  onDisablePIP: Ge
};
Dn.defaultProps = uO;
var tg = {};
(function(e) {
  function t(y) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(p) {
      return typeof p;
    } : t = function(p) {
      return p && typeof Symbol == "function" && p.constructor === Symbol && p !== Symbol.prototype ? "symbol" : typeof p;
    }, t(y);
  }
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var n = s(oe), r = o(Jm), a = Dn, i = Ae;
  function o(y) {
    return y && y.__esModule ? y : { default: y };
  }
  function l() {
    if (typeof WeakMap != "function")
      return null;
    var y = /* @__PURE__ */ new WeakMap();
    return l = function() {
      return y;
    }, y;
  }
  function s(y) {
    if (y && y.__esModule)
      return y;
    if (y === null || t(y) !== "object" && typeof y != "function")
      return { default: y };
    var c = l();
    if (c && c.has(y))
      return c.get(y);
    var p = {}, d = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var m in y)
      if (Object.prototype.hasOwnProperty.call(y, m)) {
        var O = d ? Object.getOwnPropertyDescriptor(y, m) : null;
        O && (O.get || O.set) ? Object.defineProperty(p, m, O) : p[m] = y[m];
      }
    return p.default = y, c && c.set(y, p), p;
  }
  function u() {
    return u = Object.assign || function(y) {
      for (var c = 1; c < arguments.length; c++) {
        var p = arguments[c];
        for (var d in p)
          Object.prototype.hasOwnProperty.call(p, d) && (y[d] = p[d]);
      }
      return y;
    }, u.apply(this, arguments);
  }
  function f(y, c) {
    if (!(y instanceof c))
      throw new TypeError("Cannot call a class as a function");
  }
  function h(y, c) {
    for (var p = 0; p < c.length; p++) {
      var d = c[p];
      d.enumerable = d.enumerable || !1, d.configurable = !0, "value" in d && (d.writable = !0), Object.defineProperty(y, d.key, d);
    }
  }
  function g(y, c, p) {
    return c && h(y.prototype, c), p && h(y, p), y;
  }
  function v(y, c) {
    if (typeof c != "function" && c !== null)
      throw new TypeError("Super expression must either be null or a function");
    y.prototype = Object.create(c && c.prototype, { constructor: { value: y, writable: !0, configurable: !0 } }), c && E(y, c);
  }
  function E(y, c) {
    return E = Object.setPrototypeOf || function(d, m) {
      return d.__proto__ = m, d;
    }, E(y, c);
  }
  function b(y) {
    var c = T();
    return function() {
      var d = A(y), m;
      if (c) {
        var O = A(this).constructor;
        m = Reflect.construct(d, arguments, O);
      } else
        m = d.apply(this, arguments);
      return w(this, m);
    };
  }
  function w(y, c) {
    return c && (t(c) === "object" || typeof c == "function") ? c : S(y);
  }
  function S(y) {
    if (y === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return y;
  }
  function T() {
    if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
      return !1;
    if (typeof Proxy == "function")
      return !0;
    try {
      return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
      })), !0;
    } catch {
      return !1;
    }
  }
  function A(y) {
    return A = Object.setPrototypeOf ? Object.getPrototypeOf : function(p) {
      return p.__proto__ || Object.getPrototypeOf(p);
    }, A(y);
  }
  function V(y, c, p) {
    return c in y ? Object.defineProperty(y, c, { value: p, enumerable: !0, configurable: !0, writable: !0 }) : y[c] = p, y;
  }
  var $ = 5e3, _ = /* @__PURE__ */ function(y) {
    v(p, y);
    var c = b(p);
    function p() {
      var d;
      f(this, p);
      for (var m = arguments.length, O = new Array(m), x = 0; x < m; x++)
        O[x] = arguments[x];
      return d = c.call.apply(c, [this].concat(O)), V(S(d), "mounted", !1), V(S(d), "isReady", !1), V(S(d), "isPlaying", !1), V(S(d), "isLoading", !0), V(S(d), "loadOnReady", null), V(S(d), "startOnPlay", !0), V(S(d), "seekOnPlay", null), V(S(d), "onDurationCalled", !1), V(S(d), "handlePlayerMount", function(P) {
        if (d.player) {
          d.progress();
          return;
        }
        d.player = P, d.player.load(d.props.url), d.progress();
      }), V(S(d), "getInternalPlayer", function(P) {
        return d.player ? d.player[P] : null;
      }), V(S(d), "progress", function() {
        if (d.props.url && d.player && d.isReady) {
          var P = d.getCurrentTime() || 0, N = d.getSecondsLoaded(), D = d.getDuration();
          if (D) {
            var I = {
              playedSeconds: P,
              played: P / D
            };
            N !== null && (I.loadedSeconds = N, I.loaded = N / D), (I.playedSeconds !== d.prevPlayed || I.loadedSeconds !== d.prevLoaded) && d.props.onProgress(I), d.prevPlayed = I.playedSeconds, d.prevLoaded = I.loadedSeconds;
          }
        }
        d.progressTimeout = setTimeout(d.progress, d.props.progressFrequency || d.props.progressInterval);
      }), V(S(d), "handleReady", function() {
        if (d.mounted) {
          d.isReady = !0, d.isLoading = !1;
          var P = d.props, N = P.onReady, D = P.playing, I = P.volume, C = P.muted;
          N(), !C && I !== null && d.player.setVolume(I), d.loadOnReady ? (d.player.load(d.loadOnReady, !0), d.loadOnReady = null) : D && d.player.play(), d.handleDurationCheck();
        }
      }), V(S(d), "handlePlay", function() {
        d.isPlaying = !0, d.isLoading = !1;
        var P = d.props, N = P.onStart, D = P.onPlay, I = P.playbackRate;
        d.startOnPlay && (d.player.setPlaybackRate && I !== 1 && d.player.setPlaybackRate(I), N(), d.startOnPlay = !1), D(), d.seekOnPlay && (d.seekTo(d.seekOnPlay), d.seekOnPlay = null), d.handleDurationCheck();
      }), V(S(d), "handlePause", function(P) {
        d.isPlaying = !1, d.isLoading || d.props.onPause(P);
      }), V(S(d), "handleEnded", function() {
        var P = d.props, N = P.activePlayer, D = P.loop, I = P.onEnded;
        N.loopOnEnded && D && d.seekTo(0), D || (d.isPlaying = !1, I());
      }), V(S(d), "handleError", function() {
        var P;
        d.isLoading = !1, (P = d.props).onError.apply(P, arguments);
      }), V(S(d), "handleDurationCheck", function() {
        clearTimeout(d.durationCheckTimeout);
        var P = d.getDuration();
        P ? d.onDurationCalled || (d.props.onDuration(P), d.onDurationCalled = !0) : d.durationCheckTimeout = setTimeout(d.handleDurationCheck, 100);
      }), V(S(d), "handleLoaded", function() {
        d.isLoading = !1;
      }), d;
    }
    return g(p, [{
      key: "componentDidMount",
      value: function() {
        this.mounted = !0;
      }
    }, {
      key: "componentWillUnmount",
      value: function() {
        clearTimeout(this.progressTimeout), clearTimeout(this.durationCheckTimeout), this.isReady && this.props.stopOnUnmount && (this.player.stop(), this.player.disablePIP && this.player.disablePIP()), this.mounted = !1;
      }
    }, {
      key: "componentDidUpdate",
      value: function(m) {
        var O = this;
        if (this.player) {
          var x = this.props, P = x.url, N = x.playing, D = x.volume, I = x.muted, C = x.playbackRate, L = x.pip, k = x.loop, M = x.activePlayer, F = x.disableDeferredLoading;
          if (!(0, r.default)(m.url, P)) {
            if (this.isLoading && !M.forceLoad && !F && !(0, i.isMediaStream)(P)) {
              console.warn("ReactPlayer: the attempt to load ".concat(P, " is being deferred until the player has loaded")), this.loadOnReady = P;
              return;
            }
            this.isLoading = !0, this.startOnPlay = !0, this.onDurationCalled = !1, this.player.load(P, this.isReady);
          }
          !m.playing && N && !this.isPlaying && this.player.play(), m.playing && !N && this.isPlaying && this.player.pause(), !m.pip && L && this.player.enablePIP && this.player.enablePIP(), m.pip && !L && this.player.disablePIP && this.player.disablePIP(), m.volume !== D && D !== null && this.player.setVolume(D), m.muted !== I && (I ? this.player.mute() : (this.player.unmute(), D !== null && setTimeout(function() {
            return O.player.setVolume(D);
          }))), m.playbackRate !== C && this.player.setPlaybackRate && this.player.setPlaybackRate(C), m.loop !== k && this.player.setLoop && this.player.setLoop(k);
        }
      }
    }, {
      key: "getDuration",
      value: function() {
        return this.isReady ? this.player.getDuration() : null;
      }
    }, {
      key: "getCurrentTime",
      value: function() {
        return this.isReady ? this.player.getCurrentTime() : null;
      }
    }, {
      key: "getSecondsLoaded",
      value: function() {
        return this.isReady ? this.player.getSecondsLoaded() : null;
      }
    }, {
      key: "seekTo",
      value: function(m, O, x) {
        var P = this;
        if (!this.isReady) {
          m !== 0 && (this.seekOnPlay = m, setTimeout(function() {
            P.seekOnPlay = null;
          }, $));
          return;
        }
        var N = O ? O === "fraction" : m > 0 && m < 1;
        if (N) {
          var D = this.player.getDuration();
          if (!D) {
            console.warn("ReactPlayer: could not seek using fraction – duration not yet available");
            return;
          }
          this.player.seekTo(D * m, x);
          return;
        }
        this.player.seekTo(m, x);
      }
    }, {
      key: "render",
      value: function() {
        var m = this.props.activePlayer;
        return m ? /* @__PURE__ */ n.default.createElement(m, u({}, this.props, {
          onMount: this.handlePlayerMount,
          onReady: this.handleReady,
          onPlay: this.handlePlay,
          onPause: this.handlePause,
          onEnded: this.handleEnded,
          onLoaded: this.handleLoaded,
          onError: this.handleError
        })) : null;
      }
    }]), p;
  }(n.Component);
  e.default = _, V(_, "displayName", "Player"), V(_, "propTypes", a.propTypes), V(_, "defaultProps", a.defaultProps);
})(tg);
var Ms = {}, kp;
function dO() {
  return kp || (kp = 1, function(e) {
    function t($) {
      "@babel/helpers - typeof";
      return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? t = function(y) {
        return typeof y;
      } : t = function(y) {
        return y && typeof Symbol == "function" && y.constructor === Symbol && y !== Symbol.prototype ? "symbol" : typeof y;
      }, t($);
    }
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), e.default = void 0;
    var n = a(oe);
    function r() {
      if (typeof WeakMap != "function")
        return null;
      var $ = /* @__PURE__ */ new WeakMap();
      return r = function() {
        return $;
      }, $;
    }
    function a($) {
      if ($ && $.__esModule)
        return $;
      if ($ === null || t($) !== "object" && typeof $ != "function")
        return { default: $ };
      var _ = r();
      if (_ && _.has($))
        return _.get($);
      var y = {}, c = Object.defineProperty && Object.getOwnPropertyDescriptor;
      for (var p in $)
        if (Object.prototype.hasOwnProperty.call($, p)) {
          var d = c ? Object.getOwnPropertyDescriptor($, p) : null;
          d && (d.get || d.set) ? Object.defineProperty(y, p, d) : y[p] = $[p];
        }
      return y.default = $, _ && _.set($, y), y;
    }
    function i($, _) {
      var y = Object.keys($);
      if (Object.getOwnPropertySymbols) {
        var c = Object.getOwnPropertySymbols($);
        _ && (c = c.filter(function(p) {
          return Object.getOwnPropertyDescriptor($, p).enumerable;
        })), y.push.apply(y, c);
      }
      return y;
    }
    function o($) {
      for (var _ = 1; _ < arguments.length; _++) {
        var y = arguments[_] != null ? arguments[_] : {};
        _ % 2 ? i(Object(y), !0).forEach(function(c) {
          S($, c, y[c]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties($, Object.getOwnPropertyDescriptors(y)) : i(Object(y)).forEach(function(c) {
          Object.defineProperty($, c, Object.getOwnPropertyDescriptor(y, c));
        });
      }
      return $;
    }
    function l($, _) {
      if (!($ instanceof _))
        throw new TypeError("Cannot call a class as a function");
    }
    function s($, _) {
      for (var y = 0; y < _.length; y++) {
        var c = _[y];
        c.enumerable = c.enumerable || !1, c.configurable = !0, "value" in c && (c.writable = !0), Object.defineProperty($, c.key, c);
      }
    }
    function u($, _, y) {
      return _ && s($.prototype, _), y && s($, y), $;
    }
    function f($, _) {
      if (typeof _ != "function" && _ !== null)
        throw new TypeError("Super expression must either be null or a function");
      $.prototype = Object.create(_ && _.prototype, { constructor: { value: $, writable: !0, configurable: !0 } }), _ && h($, _);
    }
    function h($, _) {
      return h = Object.setPrototypeOf || function(c, p) {
        return c.__proto__ = p, c;
      }, h($, _);
    }
    function g($) {
      var _ = b();
      return function() {
        var c = w($), p;
        if (_) {
          var d = w(this).constructor;
          p = Reflect.construct(c, arguments, d);
        } else
          p = c.apply(this, arguments);
        return v(this, p);
      };
    }
    function v($, _) {
      return _ && (t(_) === "object" || typeof _ == "function") ? _ : E($);
    }
    function E($) {
      if ($ === void 0)
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return $;
    }
    function b() {
      if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
        return !1;
      if (typeof Proxy == "function")
        return !0;
      try {
        return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
        })), !0;
      } catch {
        return !1;
      }
    }
    function w($) {
      return w = Object.setPrototypeOf ? Object.getPrototypeOf : function(y) {
        return y.__proto__ || Object.getPrototypeOf(y);
      }, w($);
    }
    function S($, _, y) {
      return _ in $ ? Object.defineProperty($, _, { value: y, enumerable: !0, configurable: !0, writable: !0 }) : $[_] = y, $;
    }
    var T = "64px", A = {}, V = /* @__PURE__ */ function($) {
      f(y, $);
      var _ = g(y);
      function y() {
        var c;
        l(this, y);
        for (var p = arguments.length, d = new Array(p), m = 0; m < p; m++)
          d[m] = arguments[m];
        return c = _.call.apply(_, [this].concat(d)), S(E(c), "mounted", !1), S(E(c), "state", {
          image: null
        }), S(E(c), "handleKeyPress", function(O) {
          (O.key === "Enter" || O.key === " ") && c.props.onClick();
        }), c;
      }
      return u(y, [{
        key: "componentDidMount",
        value: function() {
          this.mounted = !0, this.fetchImage(this.props);
        }
      }, {
        key: "componentDidUpdate",
        value: function(p) {
          var d = this.props, m = d.url, O = d.light;
          (p.url !== m || p.light !== O) && this.fetchImage(this.props);
        }
      }, {
        key: "componentWillUnmount",
        value: function() {
          this.mounted = !1;
        }
      }, {
        key: "fetchImage",
        value: function(p) {
          var d = this, m = p.url, O = p.light, x = p.oEmbedUrl;
          if (!/* @__PURE__ */ n.default.isValidElement(O)) {
            if (typeof O == "string") {
              this.setState({
                image: O
              });
              return;
            }
            if (A[m]) {
              this.setState({
                image: A[m]
              });
              return;
            }
            return this.setState({
              image: null
            }), window.fetch(x.replace("{url}", m)).then(function(P) {
              return P.json();
            }).then(function(P) {
              if (P.thumbnail_url && d.mounted) {
                var N = P.thumbnail_url.replace("height=100", "height=480").replace("-d_295x166", "-d_640");
                d.setState({
                  image: N
                }), A[m] = N;
              }
            });
          }
        }
      }, {
        key: "render",
        value: function() {
          var p = this.props, d = p.light, m = p.onClick, O = p.playIcon, x = p.previewTabIndex, P = this.state.image, N = /* @__PURE__ */ n.default.isValidElement(d), D = {
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }, I = {
            preview: o({
              width: "100%",
              height: "100%",
              backgroundImage: P && !N ? "url(".concat(P, ")") : void 0,
              backgroundSize: "cover",
              backgroundPosition: "center",
              cursor: "pointer"
            }, D),
            shadow: o({
              background: "radial-gradient(rgb(0, 0, 0, 0.3), rgba(0, 0, 0, 0) 60%)",
              borderRadius: T,
              width: T,
              height: T,
              position: N ? "absolute" : void 0
            }, D),
            playIcon: {
              borderStyle: "solid",
              borderWidth: "16px 0 16px 26px",
              borderColor: "transparent transparent transparent white",
              marginLeft: "7px"
            }
          }, C = /* @__PURE__ */ n.default.createElement("div", {
            style: I.shadow,
            className: "react-player__shadow"
          }, /* @__PURE__ */ n.default.createElement("div", {
            style: I.playIcon,
            className: "react-player__play-icon"
          }));
          return /* @__PURE__ */ n.default.createElement("div", {
            style: I.preview,
            className: "react-player__preview",
            onClick: m,
            tabIndex: x,
            onKeyPress: this.handleKeyPress
          }, N ? d : null, O || C);
        }
      }]), y;
    }(n.Component);
    e.default = V;
  }(Ms)), Ms;
}
Object.defineProperty(eo, "__esModule", {
  value: !0
});
eo.createReactPlayer = void 0;
var Tn = rg(oe), fO = to(Im), _s = to(ZA), Tp = to(Jm), Ur = Dn, pO = Ae, hO = to(tg);
function to(e) {
  return e && e.__esModule ? e : { default: e };
}
function Gr(e) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? Gr = function(n) {
    return typeof n;
  } : Gr = function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, Gr(e);
}
function Ap(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(a) {
      return Object.getOwnPropertyDescriptor(e, a).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Op(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Ap(Object(n), !0).forEach(function(r) {
      Re(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Ap(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ei() {
  return Ei = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, Ei.apply(this, arguments);
}
function Ls(e) {
  return yO(e) || gO(e) || mO(e) || vO();
}
function vO() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function mO(e, t) {
  if (e) {
    if (typeof e == "string")
      return pc(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set")
      return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
      return pc(e, t);
  }
}
function gO(e) {
  if (typeof Symbol < "u" && Symbol.iterator in Object(e))
    return Array.from(e);
}
function yO(e) {
  if (Array.isArray(e))
    return pc(e);
}
function pc(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function bO(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function zp(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
  }
}
function wO(e, t, n) {
  return t && zp(e.prototype, t), n && zp(e, n), e;
}
function xO(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, { constructor: { value: e, writable: !0, configurable: !0 } }), t && hc(e, t);
}
function hc(e, t) {
  return hc = Object.setPrototypeOf || function(r, a) {
    return r.__proto__ = a, r;
  }, hc(e, t);
}
function EO(e) {
  var t = PO();
  return function() {
    var r = $i(e), a;
    if (t) {
      var i = $i(this).constructor;
      a = Reflect.construct(r, arguments, i);
    } else
      a = r.apply(this, arguments);
    return $O(this, a);
  };
}
function $O(e, t) {
  return t && (Gr(t) === "object" || typeof t == "function") ? t : Qe(e);
}
function Qe(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function PO() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function $i(e) {
  return $i = Object.setPrototypeOf ? Object.getPrototypeOf : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, $i(e);
}
function Re(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function ng() {
  if (typeof WeakMap != "function")
    return null;
  var e = /* @__PURE__ */ new WeakMap();
  return ng = function() {
    return e;
  }, e;
}
function rg(e) {
  if (e && e.__esModule)
    return e;
  if (e === null || Gr(e) !== "object" && typeof e != "function")
    return { default: e };
  var t = ng();
  if (t && t.has(e))
    return t.get(e);
  var n = {}, r = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var a in e)
    if (Object.prototype.hasOwnProperty.call(e, a)) {
      var i = r ? Object.getOwnPropertyDescriptor(e, a) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, a, i) : n[a] = e[a];
    }
  return n.default = e, t && t.set(e, n), n;
}
var CO = /* @__PURE__ */ (0, Tn.lazy)(function() {
  return Promise.resolve().then(function() {
    return rg(dO());
  });
}), SO = typeof window < "u" && window.document, kO = typeof vt < "u" && vt.window && vt.window.document, TO = Object.keys(Ur.propTypes), AO = SO || kO ? Tn.Suspense : function() {
  return null;
}, Vr = [], OO = function(t, n) {
  var r, a;
  return a = r = /* @__PURE__ */ function(i) {
    xO(l, i);
    var o = EO(l);
    function l() {
      var s;
      bO(this, l);
      for (var u = arguments.length, f = new Array(u), h = 0; h < u; h++)
        f[h] = arguments[h];
      return s = o.call.apply(o, [this].concat(f)), Re(Qe(s), "state", {
        showPreview: !!s.props.light
      }), Re(Qe(s), "references", {
        wrapper: function(v) {
          s.wrapper = v;
        },
        player: function(v) {
          s.player = v;
        }
      }), Re(Qe(s), "handleClickPreview", function(g) {
        s.setState({
          showPreview: !1
        }), s.props.onClickPreview(g);
      }), Re(Qe(s), "showPreview", function() {
        s.setState({
          showPreview: !0
        });
      }), Re(Qe(s), "getDuration", function() {
        return s.player ? s.player.getDuration() : null;
      }), Re(Qe(s), "getCurrentTime", function() {
        return s.player ? s.player.getCurrentTime() : null;
      }), Re(Qe(s), "getSecondsLoaded", function() {
        return s.player ? s.player.getSecondsLoaded() : null;
      }), Re(Qe(s), "getInternalPlayer", function() {
        var g = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "player";
        return s.player ? s.player.getInternalPlayer(g) : null;
      }), Re(Qe(s), "seekTo", function(g, v, E) {
        if (!s.player)
          return null;
        s.player.seekTo(g, v, E);
      }), Re(Qe(s), "handleReady", function() {
        s.props.onReady(Qe(s));
      }), Re(Qe(s), "getActivePlayer", (0, _s.default)(function(g) {
        for (var v = 0, E = [].concat(Vr, Ls(t)); v < E.length; v++) {
          var b = E[v];
          if (b.canPlay(g))
            return b;
        }
        return n || null;
      })), Re(Qe(s), "getConfig", (0, _s.default)(function(g, v) {
        var E = s.props.config;
        return fO.default.all([Ur.defaultProps.config, Ur.defaultProps.config[v] || {}, E, E[v] || {}]);
      })), Re(Qe(s), "getAttributes", (0, _s.default)(function(g) {
        return (0, pO.omit)(s.props, TO);
      })), Re(Qe(s), "renderActivePlayer", function(g) {
        if (!g)
          return null;
        var v = s.getActivePlayer(g);
        if (!v)
          return null;
        var E = s.getConfig(g, v.key);
        return /* @__PURE__ */ Tn.default.createElement(hO.default, Ei({}, s.props, {
          key: v.key,
          ref: s.references.player,
          config: E,
          activePlayer: v.lazyPlayer || v,
          onReady: s.handleReady
        }));
      }), s;
    }
    return wO(l, [{
      key: "shouldComponentUpdate",
      value: function(u, f) {
        return !(0, Tp.default)(this.props, u) || !(0, Tp.default)(this.state, f);
      }
    }, {
      key: "componentDidUpdate",
      value: function(u) {
        var f = this.props.light;
        !u.light && f && this.setState({
          showPreview: !0
        }), u.light && !f && this.setState({
          showPreview: !1
        });
      }
    }, {
      key: "renderPreview",
      value: function(u) {
        if (!u)
          return null;
        var f = this.props, h = f.light, g = f.playIcon, v = f.previewTabIndex, E = f.oEmbedUrl;
        return /* @__PURE__ */ Tn.default.createElement(CO, {
          url: u,
          light: h,
          playIcon: g,
          previewTabIndex: v,
          oEmbedUrl: E,
          onClick: this.handleClickPreview
        });
      }
    }, {
      key: "render",
      value: function() {
        var u = this.props, f = u.url, h = u.style, g = u.width, v = u.height, E = u.fallback, b = u.wrapper, w = this.state.showPreview, S = this.getAttributes(f), T = typeof b == "string" ? this.references.wrapper : void 0;
        return /* @__PURE__ */ Tn.default.createElement(b, Ei({
          ref: T,
          style: Op(Op({}, h), {}, {
            width: g,
            height: v
          })
        }, S), /* @__PURE__ */ Tn.default.createElement(AO, {
          fallback: E
        }, w ? this.renderPreview(f) : this.renderActivePlayer(f)));
      }
    }]), l;
  }(Tn.Component), Re(r, "displayName", "ReactPlayer"), Re(r, "propTypes", Ur.propTypes), Re(r, "defaultProps", Ur.defaultProps), Re(r, "addCustomPlayer", function(i) {
    Vr.push(i);
  }), Re(r, "removeCustomPlayers", function() {
    Vr.length = 0;
  }), Re(r, "canPlay", function(i) {
    for (var o = 0, l = [].concat(Vr, Ls(t)); o < l.length; o++) {
      var s = l[o];
      if (s.canPlay(i))
        return !0;
    }
    return !1;
  }), Re(r, "canEnablePIP", function(i) {
    for (var o = 0, l = [].concat(Vr, Ls(t)); o < l.length; o++) {
      var s = l[o];
      if (s.canEnablePIP && s.canEnablePIP(i))
        return !0;
    }
    return !1;
  }), a;
};
eo.createReactPlayer = OO;
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), e.default = void 0;
  var t = r(_m), n = eo;
  function r(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var a = t.default[t.default.length - 1], i = (0, n.createReactPlayer)(t.default, a);
  e.default = i;
})(Mm);
const zO = /* @__PURE__ */ Jv(Mm), MO = de("", {
  variants: {
    aspectRatio: {
      landscape: "aspect-16/9",
      portrait: "aspect-9/16",
      "2/3": "aspect-2/3",
      "3/2": "aspect-3/2",
      "4/3": "aspect-4/3",
      "3/4": "aspect-3/4",
      "5/3": "aspect-5/3",
      "7/5": "aspect-7/5",
      "5/7": "aspect-5/7",
      "16/9": "aspect-16/9",
      "9/16": "aspect-9/16",
      "21/9": "aspect-21/9",
      "1/1": "aspect-1/1"
    }
  }
}), ag = ({
  url: e,
  width: t = "100%",
  height: n = "100%",
  thumbnailImage: r,
  playing: a,
  aspectRatio: i = "landscape",
  "aria-label": o,
  className: l,
  loop: s = !1,
  showControls: u = !0,
  ...f
}) => {
  const [h, g] = ne(
    !!r
  );
  return /* @__PURE__ */ H(
    "div",
    {
      role: "tooltip",
      className: ae(
        "gudl-media-player relative",
        MO({ aspectRatio: i }),
        l
      ),
      "aria-label": o,
      children: /* @__PURE__ */ H(
        zO,
        {
          className: "absolute start-0 top-0",
          light: h ? r : !1,
          playing: r ? !0 : a,
          url: e,
          width: t,
          height: n,
          loop: s,
          controls: u,
          playIcon: /* @__PURE__ */ H(
            dr,
            {
              iconName: "play",
              className: "absolute flex justify-center",
              size: "sm",
              intent: "primary-white",
              "aria-label": "Play video",
              "data-info": "play",
              onPress: () => g(!1)
            }
          ),
          config: {
            file: {
              attributes: {
                controlsList: "nodownload",
                disablepictureinpicture: "true"
              }
            }
          },
          ...f
        }
      )
    }
  );
};
var _O = Object.defineProperty, LO = (e, t, n) => t in e ? _O(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, Is = (e, t, n) => (LO(e, typeof t != "symbol" ? t + "" : t, n), n);
let IO = class {
  constructor() {
    Is(this, "current", this.detect()), Is(this, "handoffState", "pending"), Is(this, "currentId", 0);
  }
  set(t) {
    this.current !== t && (this.handoffState = "pending", this.currentId = 0, this.current = t);
  }
  reset() {
    this.set(this.detect());
  }
  nextId() {
    return ++this.currentId;
  }
  get isServer() {
    return this.current === "server";
  }
  get isClient() {
    return this.current === "client";
  }
  detect() {
    return typeof window > "u" || typeof document > "u" ? "server" : "client";
  }
  handoff() {
    this.handoffState === "pending" && (this.handoffState = "complete");
  }
  get isHandoffComplete() {
    return this.handoffState === "complete";
  }
}, Zt = new IO(), $t = (e, t) => {
  Zt.isServer ? re(e, t) : na(e, t);
};
function Gt(e) {
  let t = J(e);
  return $t(() => {
    t.current = e;
  }, [e]), t;
}
function no(e) {
  typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch((t) => setTimeout(() => {
    throw t;
  }));
}
function Fn() {
  let e = [], t = { addEventListener(n, r, a, i) {
    return n.addEventListener(r, a, i), t.add(() => n.removeEventListener(r, a, i));
  }, requestAnimationFrame(...n) {
    let r = requestAnimationFrame(...n);
    return t.add(() => cancelAnimationFrame(r));
  }, nextFrame(...n) {
    return t.requestAnimationFrame(() => t.requestAnimationFrame(...n));
  }, setTimeout(...n) {
    let r = setTimeout(...n);
    return t.add(() => clearTimeout(r));
  }, microTask(...n) {
    let r = { current: !0 };
    return no(() => {
      r.current && n[0]();
    }), t.add(() => {
      r.current = !1;
    });
  }, style(n, r, a) {
    let i = n.style.getPropertyValue(r);
    return Object.assign(n.style, { [r]: a }), this.add(() => {
      Object.assign(n.style, { [r]: i });
    });
  }, group(n) {
    let r = Fn();
    return n(r), this.add(() => r.dispose());
  }, add(n) {
    return e.push(n), () => {
      let r = e.indexOf(n);
      if (r >= 0)
        for (let a of e.splice(r, 1))
          a();
    };
  }, dispose() {
    for (let n of e.splice(0))
      n();
  } };
  return t;
}
function s1() {
  let [e] = ne(Fn);
  return re(() => () => e.dispose(), [e]), e;
}
let Ie = function(e) {
  let t = Gt(e);
  return oe.useCallback((...n) => t.current(...n), [t]);
};
function DO() {
  let e = typeof document > "u";
  return "useSyncExternalStore" in ue ? ((t) => t.useSyncExternalStore)(ue)(() => () => {
  }, () => !1, () => !e) : !1;
}
function mr() {
  let e = DO(), [t, n] = ue.useState(Zt.isHandoffComplete);
  return t && Zt.isHandoffComplete === !1 && n(!1), ue.useEffect(() => {
    t !== !0 && n(!0);
  }, [t]), ue.useEffect(() => Zt.handoff(), []), e ? !1 : t;
}
var Mp;
let gr = (Mp = oe.useId) != null ? Mp : function() {
  let e = mr(), [t, n] = oe.useState(e ? () => Zt.nextId() : null);
  return $t(() => {
    t === null && n(Zt.nextId());
  }, [t]), t != null ? "" + t : void 0;
};
function tt(e, t, ...n) {
  if (e in t) {
    let a = t[e];
    return typeof a == "function" ? a(...n) : a;
  }
  let r = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map((a) => `"${a}"`).join(", ")}.`);
  throw Error.captureStackTrace && Error.captureStackTrace(r, tt), r;
}
function ig(e) {
  return Zt.isServer ? null : e instanceof Node ? e.ownerDocument : e != null && e.hasOwnProperty("current") && e.current instanceof Node ? e.current.ownerDocument : document;
}
let vc = ["[contentEditable=true]", "[tabindex]", "a[href]", "area[href]", "button:not([disabled])", "iframe", "input:not([disabled])", "select:not([disabled])", "textarea:not([disabled])"].map((e) => `${e}:not([tabindex='-1'])`).join(",");
var An = ((e) => (e[e.First = 1] = "First", e[e.Previous = 2] = "Previous", e[e.Next = 4] = "Next", e[e.Last = 8] = "Last", e[e.WrapAround = 16] = "WrapAround", e[e.NoScroll = 32] = "NoScroll", e))(An || {}), og = ((e) => (e[e.Error = 0] = "Error", e[e.Overflow = 1] = "Overflow", e[e.Success = 2] = "Success", e[e.Underflow = 3] = "Underflow", e))(og || {}), NO = ((e) => (e[e.Previous = -1] = "Previous", e[e.Next = 1] = "Next", e))(NO || {});
function RO(e = document.body) {
  return e == null ? [] : Array.from(e.querySelectorAll(vc)).sort((t, n) => Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (n.tabIndex || Number.MAX_SAFE_INTEGER)));
}
var lg = ((e) => (e[e.Strict = 0] = "Strict", e[e.Loose = 1] = "Loose", e))(lg || {});
function BO(e, t = 0) {
  var n;
  return e === ((n = ig(e)) == null ? void 0 : n.body) ? !1 : tt(t, { 0() {
    return e.matches(vc);
  }, 1() {
    let r = e;
    for (; r !== null; ) {
      if (r.matches(vc))
        return !0;
      r = r.parentElement;
    }
    return !1;
  } });
}
var VO = ((e) => (e[e.Keyboard = 0] = "Keyboard", e[e.Mouse = 1] = "Mouse", e))(VO || {});
typeof window < "u" && typeof document < "u" && (document.addEventListener("keydown", (e) => {
  e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", (e) => {
  e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function Mn(e) {
  e == null || e.focus({ preventScroll: !0 });
}
let FO = ["textarea", "input"].join(",");
function HO(e) {
  var t, n;
  return (n = (t = e == null ? void 0 : e.matches) == null ? void 0 : t.call(e, FO)) != null ? n : !1;
}
function KO(e, t = (n) => n) {
  return e.slice().sort((n, r) => {
    let a = t(n), i = t(r);
    if (a === null || i === null)
      return 0;
    let o = a.compareDocumentPosition(i);
    return o & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : o & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
  });
}
function si(e, t, { sorted: n = !0, relativeTo: r = null, skipElements: a = [] } = {}) {
  let i = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, o = Array.isArray(e) ? n ? KO(e) : e : RO(e);
  a.length > 0 && o.length > 1 && (o = o.filter((v) => !a.includes(v))), r = r ?? i.activeElement;
  let l = (() => {
    if (t & 5)
      return 1;
    if (t & 10)
      return -1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), s = (() => {
    if (t & 1)
      return 0;
    if (t & 2)
      return Math.max(0, o.indexOf(r)) - 1;
    if (t & 4)
      return Math.max(0, o.indexOf(r)) + 1;
    if (t & 8)
      return o.length - 1;
    throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
  })(), u = t & 32 ? { preventScroll: !0 } : {}, f = 0, h = o.length, g;
  do {
    if (f >= h || f + h <= 0)
      return 0;
    let v = s + f;
    if (t & 16)
      v = (v + h) % h;
    else {
      if (v < 0)
        return 3;
      if (v >= h)
        return 1;
    }
    g = o[v], g == null || g.focus(u), f += l;
  } while (g !== i.activeElement);
  return t & 6 && HO(g) && g.select(), 2;
}
function Ga(e, t, n) {
  let r = Gt(t);
  re(() => {
    function a(i) {
      r.current(i);
    }
    return document.addEventListener(e, a, n), () => document.removeEventListener(e, a, n);
  }, [e, n]);
}
function sg(e, t, n) {
  let r = Gt(t);
  re(() => {
    function a(i) {
      r.current(i);
    }
    return window.addEventListener(e, a, n), () => window.removeEventListener(e, a, n);
  }, [e, n]);
}
function jO(e, t, n = !0) {
  let r = J(!1);
  re(() => {
    requestAnimationFrame(() => {
      r.current = n;
    });
  }, [n]);
  function a(o, l) {
    if (!r.current || o.defaultPrevented)
      return;
    let s = l(o);
    if (s === null || !s.getRootNode().contains(s) || !s.isConnected)
      return;
    let u = function f(h) {
      return typeof h == "function" ? f(h()) : Array.isArray(h) || h instanceof Set ? h : [h];
    }(e);
    for (let f of u) {
      if (f === null)
        continue;
      let h = f instanceof HTMLElement ? f : f.current;
      if (h != null && h.contains(s) || o.composed && o.composedPath().includes(h))
        return;
    }
    return !BO(s, lg.Loose) && s.tabIndex !== -1 && o.preventDefault(), t(o, s);
  }
  let i = J(null);
  Ga("pointerdown", (o) => {
    var l, s;
    r.current && (i.current = ((s = (l = o.composedPath) == null ? void 0 : l.call(o)) == null ? void 0 : s[0]) || o.target);
  }, !0), Ga("mousedown", (o) => {
    var l, s;
    r.current && (i.current = ((s = (l = o.composedPath) == null ? void 0 : l.call(o)) == null ? void 0 : s[0]) || o.target);
  }, !0), Ga("click", (o) => {
    i.current && (a(o, () => i.current), i.current = null);
  }, !0), Ga("touchend", (o) => a(o, () => o.target instanceof HTMLElement ? o.target : null), !0), sg("blur", (o) => a(o, () => window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null), !0);
}
let cg = Symbol();
function UO(e, t = !0) {
  return Object.assign(e, { [cg]: t });
}
function Mt(...e) {
  let t = J(e);
  re(() => {
    t.current = e;
  }, [e]);
  let n = Ie((r) => {
    for (let a of t.current)
      a != null && (typeof a == "function" ? a(r) : a.current = r);
  });
  return e.every((r) => r == null || (r == null ? void 0 : r[cg])) ? void 0 : n;
}
function Pi(...e) {
  return Array.from(new Set(e.flatMap((t) => typeof t == "string" ? t.split(" ") : []))).filter(Boolean).join(" ");
}
var Ci = ((e) => (e[e.None = 0] = "None", e[e.RenderStrategy = 1] = "RenderStrategy", e[e.Static = 2] = "Static", e))(Ci || {}), fn = ((e) => (e[e.Unmount = 0] = "Unmount", e[e.Hidden = 1] = "Hidden", e))(fn || {});
function kt({ ourProps: e, theirProps: t, slot: n, defaultTag: r, features: a, visible: i = !0, name: o }) {
  let l = ug(t, e);
  if (i)
    return Ya(l, n, r, o);
  let s = a ?? 0;
  if (s & 2) {
    let { static: u = !1, ...f } = l;
    if (u)
      return Ya(f, n, r, o);
  }
  if (s & 1) {
    let { unmount: u = !0, ...f } = l;
    return tt(u ? 0 : 1, { 0() {
      return null;
    }, 1() {
      return Ya({ ...f, hidden: !0, style: { display: "none" } }, n, r, o);
    } });
  }
  return Ya(l, n, r, o);
}
function Ya(e, t = {}, n, r) {
  let { as: a = n, children: i, refName: o = "ref", ...l } = Ds(e, ["unmount", "static"]), s = e.ref !== void 0 ? { [o]: e.ref } : {}, u = typeof i == "function" ? i(t) : i;
  "className" in l && l.className && typeof l.className == "function" && (l.className = l.className(t));
  let f = {};
  if (t) {
    let h = !1, g = [];
    for (let [v, E] of Object.entries(t))
      typeof E == "boolean" && (h = !0), E === !0 && g.push(v);
    h && (f["data-headlessui-state"] = g.join(" "));
  }
  if (a === st && Object.keys(_p(l)).length > 0) {
    if (!pn(u) || Array.isArray(u) && u.length > 1)
      throw new Error(['Passing props on "Fragment"!', "", `The current component <${r} /> is rendering a "Fragment".`, "However we need to passthrough the following props:", Object.keys(l).map((E) => `  - ${E}`).join(`
`), "", "You can apply a few solutions:", ['Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".', "Render a single element as the child so that we can forward the props onto that element."].map((E) => `  - ${E}`).join(`
`)].join(`
`));
    let h = u.props, g = typeof (h == null ? void 0 : h.className) == "function" ? (...E) => Pi(h == null ? void 0 : h.className(...E), l.className) : Pi(h == null ? void 0 : h.className, l.className), v = g ? { className: g } : {};
    return en(u, Object.assign({}, ug(u.props, _p(Ds(l, ["ref"]))), f, s, WO(u.ref, s.ref), v));
  }
  return se(a, Object.assign({}, Ds(l, ["ref"]), a !== st && s, a !== st && f), u);
}
function WO(...e) {
  return { ref: e.every((t) => t == null) ? void 0 : (t) => {
    for (let n of e)
      n != null && (typeof n == "function" ? n(t) : n.current = t);
  } };
}
function ug(...e) {
  if (e.length === 0)
    return {};
  if (e.length === 1)
    return e[0];
  let t = {}, n = {};
  for (let r of e)
    for (let a in r)
      a.startsWith("on") && typeof r[a] == "function" ? (n[a] != null || (n[a] = []), n[a].push(r[a])) : t[a] = r[a];
  if (t.disabled || t["aria-disabled"])
    return Object.assign(t, Object.fromEntries(Object.keys(n).map((r) => [r, void 0])));
  for (let r in n)
    Object.assign(t, { [r](a, ...i) {
      let o = n[r];
      for (let l of o) {
        if ((a instanceof Event || (a == null ? void 0 : a.nativeEvent) instanceof Event) && a.defaultPrevented)
          return;
        l(a, ...i);
      }
    } });
  return t;
}
function yt(e) {
  var t;
  return Object.assign(Se(e), { displayName: (t = e.displayName) != null ? t : e.name });
}
function _p(e) {
  let t = Object.assign({}, e);
  for (let n in t)
    t[n] === void 0 && delete t[n];
  return t;
}
function Ds(e, t = []) {
  let n = Object.assign({}, e);
  for (let r of t)
    r in n && delete n[r];
  return n;
}
function qO(e) {
  let t = e.parentElement, n = null;
  for (; t && !(t instanceof HTMLFieldSetElement); )
    t instanceof HTMLLegendElement && (n = t), t = t.parentElement;
  let r = (t == null ? void 0 : t.getAttribute("disabled")) === "";
  return r && ZO(n) ? !1 : r;
}
function ZO(e) {
  if (!e)
    return !1;
  let t = e.previousElementSibling;
  for (; t !== null; ) {
    if (t instanceof HTMLLegendElement)
      return !1;
    t = t.previousElementSibling;
  }
  return !0;
}
let GO = "div";
var Si = ((e) => (e[e.None = 1] = "None", e[e.Focusable = 2] = "Focusable", e[e.Hidden = 4] = "Hidden", e))(Si || {});
function YO(e, t) {
  let { features: n = 1, ...r } = e, a = { ref: t, "aria-hidden": (n & 2) === 2 ? !0 : void 0, style: { position: "fixed", top: 1, left: 1, width: 1, height: 0, padding: 0, margin: -1, overflow: "hidden", clip: "rect(0, 0, 0, 0)", whiteSpace: "nowrap", borderWidth: "0", ...(n & 4) === 4 && (n & 2) !== 2 && { display: "none" } } };
  return kt({ ourProps: a, theirProps: r, slot: {}, defaultTag: GO, name: "Hidden" });
}
let mc = yt(YO), c1 = Ze(null);
c1.displayName = "OpenClosedContext";
var pt = ((e) => (e[e.Open = 1] = "Open", e[e.Closed = 2] = "Closed", e[e.Closing = 4] = "Closing", e[e.Opening = 8] = "Opening", e))(pt || {});
function u1() {
  return ze(c1);
}
function XO({ value: e, children: t }) {
  return oe.createElement(c1.Provider, { value: e }, t);
}
var dg = ((e) => (e.Space = " ", e.Enter = "Enter", e.Escape = "Escape", e.Backspace = "Backspace", e.Delete = "Delete", e.ArrowLeft = "ArrowLeft", e.ArrowUp = "ArrowUp", e.ArrowRight = "ArrowRight", e.ArrowDown = "ArrowDown", e.Home = "Home", e.End = "End", e.PageUp = "PageUp", e.PageDown = "PageDown", e.Tab = "Tab", e))(dg || {});
function d1(e, t) {
  let n = J([]), r = Ie(e);
  re(() => {
    let a = [...n.current];
    for (let [i, o] of t.entries())
      if (n.current[i] !== o) {
        let l = r(t, a);
        return n.current = t, l;
      }
  }, [r, ...t]);
}
function JO() {
  return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function oa(...e) {
  return ge(() => ig(...e), [...e]);
}
var Wr = ((e) => (e[e.Forwards = 0] = "Forwards", e[e.Backwards = 1] = "Backwards", e))(Wr || {});
function QO() {
  let e = J(0);
  return sg("keydown", (t) => {
    t.key === "Tab" && (e.current = t.shiftKey ? 1 : 0);
  }, !0), e;
}
function la() {
  let e = J(!1);
  return $t(() => (e.current = !0, () => {
    e.current = !1;
  }), []), e;
}
function fg(e, t, n, r) {
  let a = Gt(n);
  re(() => {
    e = e ?? window;
    function i(o) {
      a.current(o);
    }
    return e.addEventListener(t, i, r), () => e.removeEventListener(t, i, r);
  }, [e, t, r]);
}
function ez(e) {
  function t() {
    document.readyState !== "loading" && (e(), document.removeEventListener("DOMContentLoaded", t));
  }
  typeof window < "u" && typeof document < "u" && (document.addEventListener("DOMContentLoaded", t), t());
}
function pg(e) {
  let t = Ie(e), n = J(!1);
  re(() => (n.current = !1, () => {
    n.current = !0, no(() => {
      n.current && t();
    });
  }), [t]);
}
function hg(e) {
  if (!e)
    return /* @__PURE__ */ new Set();
  if (typeof e == "function")
    return new Set(e());
  let t = /* @__PURE__ */ new Set();
  for (let n of e.current)
    n.current instanceof HTMLElement && t.add(n.current);
  return t;
}
let tz = "div";
var vg = ((e) => (e[e.None = 1] = "None", e[e.InitialFocus = 2] = "InitialFocus", e[e.TabLock = 4] = "TabLock", e[e.FocusLock = 8] = "FocusLock", e[e.RestoreFocus = 16] = "RestoreFocus", e[e.All = 30] = "All", e))(vg || {});
function nz(e, t) {
  let n = J(null), r = Mt(n, t), { initialFocus: a, containers: i, features: o = 30, ...l } = e;
  mr() || (o = 1);
  let s = oa(n);
  iz({ ownerDocument: s }, !!(o & 16));
  let u = oz({ ownerDocument: s, container: n, initialFocus: a }, !!(o & 2));
  lz({ ownerDocument: s, container: n, containers: i, previousActiveElement: u }, !!(o & 8));
  let f = QO(), h = Ie((b) => {
    let w = n.current;
    w && ((S) => S())(() => {
      tt(f.current, { [Wr.Forwards]: () => {
        si(w, An.First, { skipElements: [b.relatedTarget] });
      }, [Wr.Backwards]: () => {
        si(w, An.Last, { skipElements: [b.relatedTarget] });
      } });
    });
  }), g = s1(), v = J(!1), E = { ref: r, onKeyDown(b) {
    b.key == "Tab" && (v.current = !0, g.requestAnimationFrame(() => {
      v.current = !1;
    }));
  }, onBlur(b) {
    let w = hg(i);
    n.current instanceof HTMLElement && w.add(n.current);
    let S = b.relatedTarget;
    S instanceof HTMLElement && S.dataset.headlessuiFocusGuard !== "true" && (mg(w, S) || (v.current ? si(n.current, tt(f.current, { [Wr.Forwards]: () => An.Next, [Wr.Backwards]: () => An.Previous }) | An.WrapAround, { relativeTo: b.target }) : b.target instanceof HTMLElement && Mn(b.target)));
  } };
  return oe.createElement(oe.Fragment, null, !!(o & 4) && oe.createElement(mc, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: h, features: Si.Focusable }), kt({ ourProps: E, theirProps: l, defaultTag: tz, name: "FocusTrap" }), !!(o & 4) && oe.createElement(mc, { as: "button", type: "button", "data-headlessui-focus-guard": !0, onFocus: h, features: Si.Focusable }));
}
let rz = yt(nz), Fr = Object.assign(rz, { features: vg }), dn = [];
ez(() => {
  function e(t) {
    t.target instanceof HTMLElement && t.target !== document.body && dn[0] !== t.target && (dn.unshift(t.target), dn = dn.filter((n) => n != null && n.isConnected), dn.splice(10));
  }
  window.addEventListener("click", e, { capture: !0 }), window.addEventListener("mousedown", e, { capture: !0 }), window.addEventListener("focus", e, { capture: !0 }), document.body.addEventListener("click", e, { capture: !0 }), document.body.addEventListener("mousedown", e, { capture: !0 }), document.body.addEventListener("focus", e, { capture: !0 });
});
function az(e = !0) {
  let t = J(dn.slice());
  return d1(([n], [r]) => {
    r === !0 && n === !1 && no(() => {
      t.current.splice(0);
    }), r === !1 && n === !0 && (t.current = dn.slice());
  }, [e, dn, t]), Ie(() => {
    var n;
    return (n = t.current.find((r) => r != null && r.isConnected)) != null ? n : null;
  });
}
function iz({ ownerDocument: e }, t) {
  let n = az(t);
  d1(() => {
    t || (e == null ? void 0 : e.activeElement) === (e == null ? void 0 : e.body) && Mn(n());
  }, [t]), pg(() => {
    t && Mn(n());
  });
}
function oz({ ownerDocument: e, container: t, initialFocus: n }, r) {
  let a = J(null), i = la();
  return d1(() => {
    if (!r)
      return;
    let o = t.current;
    o && no(() => {
      if (!i.current)
        return;
      let l = e == null ? void 0 : e.activeElement;
      if (n != null && n.current) {
        if ((n == null ? void 0 : n.current) === l) {
          a.current = l;
          return;
        }
      } else if (o.contains(l)) {
        a.current = l;
        return;
      }
      n != null && n.current ? Mn(n.current) : si(o, An.First) === og.Error && console.warn("There are no focusable elements inside the <FocusTrap />"), a.current = e == null ? void 0 : e.activeElement;
    });
  }, [r]), a;
}
function lz({ ownerDocument: e, container: t, containers: n, previousActiveElement: r }, a) {
  let i = la();
  fg(e == null ? void 0 : e.defaultView, "focus", (o) => {
    if (!a || !i.current)
      return;
    let l = hg(n);
    t.current instanceof HTMLElement && l.add(t.current);
    let s = r.current;
    if (!s)
      return;
    let u = o.target;
    u && u instanceof HTMLElement ? mg(l, u) ? (r.current = u, Mn(u)) : (o.preventDefault(), o.stopPropagation(), Mn(s)) : Mn(r.current);
  }, !0);
}
function mg(e, t) {
  for (let n of e)
    if (n.contains(t))
      return !0;
  return !1;
}
let gg = Ze(!1);
function sz() {
  return ze(gg);
}
function gc(e) {
  return oe.createElement(gg.Provider, { value: e.force }, e.children);
}
function cz(e) {
  let t = sz(), n = ze(yg), r = oa(e), [a, i] = ne(() => {
    if (!t && n !== null || Zt.isServer)
      return null;
    let o = r == null ? void 0 : r.getElementById("headlessui-portal-root");
    if (o)
      return o;
    if (r === null)
      return null;
    let l = r.createElement("div");
    return l.setAttribute("id", "headlessui-portal-root"), r.body.appendChild(l);
  });
  return re(() => {
    a !== null && (r != null && r.body.contains(a) || r == null || r.body.appendChild(a));
  }, [a, r]), re(() => {
    t || n !== null && i(n.current);
  }, [n, i, t]), a;
}
let uz = st;
function dz(e, t) {
  let n = e, r = J(null), a = Mt(UO((f) => {
    r.current = f;
  }), t), i = oa(r), o = cz(r), [l] = ne(() => {
    var f;
    return Zt.isServer ? null : (f = i == null ? void 0 : i.createElement("div")) != null ? f : null;
  }), s = ze(yc), u = mr();
  return $t(() => {
    !o || !l || o.contains(l) || (l.setAttribute("data-headlessui-portal", ""), o.appendChild(l));
  }, [o, l]), $t(() => {
    if (l && s)
      return s.register(l);
  }, [s, l]), pg(() => {
    var f;
    !o || !l || (l instanceof Node && o.contains(l) && o.removeChild(l), o.childNodes.length <= 0 && ((f = o.parentElement) == null || f.removeChild(o)));
  }), u ? !o || !l ? null : Di(kt({ ourProps: { ref: a }, theirProps: n, defaultTag: uz, name: "Portal" }), l) : null;
}
let fz = st, yg = Ze(null);
function pz(e, t) {
  let { target: n, ...r } = e, a = { ref: Mt(t) };
  return oe.createElement(yg.Provider, { value: n }, kt({ ourProps: a, theirProps: r, defaultTag: fz, name: "Popover.Group" }));
}
let yc = Ze(null);
function hz() {
  let e = ze(yc), t = J([]), n = Ie((i) => (t.current.push(i), e && e.register(i), () => r(i))), r = Ie((i) => {
    let o = t.current.indexOf(i);
    o !== -1 && t.current.splice(o, 1), e && e.unregister(i);
  }), a = ge(() => ({ register: n, unregister: r, portals: t }), [n, r, t]);
  return [t, ge(() => function({ children: i }) {
    return oe.createElement(yc.Provider, { value: a }, i);
  }, [a])];
}
let vz = yt(dz), mz = yt(pz), bc = Object.assign(vz, { Group: mz }), bg = Ze(null);
function wg() {
  let e = ze(bg);
  if (e === null) {
    let t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(t, wg), t;
  }
  return e;
}
function gz() {
  let [e, t] = ne([]);
  return [e.length > 0 ? e.join(" ") : void 0, ge(() => function(n) {
    let r = Ie((i) => (t((o) => [...o, i]), () => t((o) => {
      let l = o.slice(), s = l.indexOf(i);
      return s !== -1 && l.splice(s, 1), l;
    }))), a = ge(() => ({ register: r, slot: n.slot, name: n.name, props: n.props }), [r, n.slot, n.name, n.props]);
    return oe.createElement(bg.Provider, { value: a }, n.children);
  }, [t])];
}
let yz = "p";
function bz(e, t) {
  let n = gr(), { id: r = `headlessui-description-${n}`, ...a } = e, i = wg(), o = Mt(t);
  $t(() => i.register(r), [r, i.register]);
  let l = { ref: o, ...i.props, id: r };
  return kt({ ourProps: l, theirProps: a, slot: i.slot || {}, defaultTag: yz, name: i.name || "Description" });
}
let wz = yt(bz), xz = Object.assign(wz, {}), f1 = Ze(() => {
});
f1.displayName = "StackContext";
var wc = ((e) => (e[e.Add = 0] = "Add", e[e.Remove = 1] = "Remove", e))(wc || {});
function Ez() {
  return ze(f1);
}
function $z({ children: e, onUpdate: t, type: n, element: r, enabled: a }) {
  let i = Ez(), o = Ie((...l) => {
    t == null || t(...l), i(...l);
  });
  return $t(() => {
    let l = a === void 0 || a === !0;
    return l && o(0, n, r), () => {
      l && o(1, n, r);
    };
  }, [o, n, r, a]), oe.createElement(f1.Provider, { value: o }, e);
}
function Pz(e, t) {
  return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
const Cz = typeof Object.is == "function" ? Object.is : Pz, { useState: Sz, useEffect: kz, useLayoutEffect: Tz, useDebugValue: Az } = ue;
function Oz(e, t, n) {
  const r = t(), [{ inst: a }, i] = Sz({ inst: { value: r, getSnapshot: t } });
  return Tz(() => {
    a.value = r, a.getSnapshot = t, Ns(a) && i({ inst: a });
  }, [e, r, t]), kz(() => (Ns(a) && i({ inst: a }), e(() => {
    Ns(a) && i({ inst: a });
  })), [e]), Az(r), r;
}
function Ns(e) {
  const t = e.getSnapshot, n = e.value;
  try {
    const r = t();
    return !Cz(n, r);
  } catch {
    return !0;
  }
}
function zz(e, t, n) {
  return t();
}
const Mz = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", _z = !Mz, Lz = _z ? zz : Oz, Iz = "useSyncExternalStore" in ue ? ((e) => e.useSyncExternalStore)(ue) : Lz;
function Dz(e) {
  return Iz(e.subscribe, e.getSnapshot, e.getSnapshot);
}
function Nz(e, t) {
  let n = e(), r = /* @__PURE__ */ new Set();
  return { getSnapshot() {
    return n;
  }, subscribe(a) {
    return r.add(a), () => r.delete(a);
  }, dispatch(a, ...i) {
    let o = t[a].call(n, ...i);
    o && (n = o, r.forEach((l) => l()));
  } };
}
function Rz() {
  let e;
  return { before({ doc: t }) {
    var n;
    let r = t.documentElement;
    e = ((n = t.defaultView) != null ? n : window).innerWidth - r.clientWidth;
  }, after({ doc: t, d: n }) {
    let r = t.documentElement, a = r.clientWidth - r.offsetWidth, i = e - a;
    n.style(r, "paddingRight", `${i}px`);
  } };
}
function Bz() {
  if (!JO())
    return {};
  let e;
  return { before() {
    e = window.pageYOffset;
  }, after({ doc: t, d: n, meta: r }) {
    function a(i) {
      return r.containers.flatMap((o) => o()).some((o) => o.contains(i));
    }
    n.microTask(() => {
      if (window.getComputedStyle(t.documentElement).scrollBehavior !== "auto") {
        let o = Fn();
        o.style(t.documentElement, "scroll-behavior", "auto"), n.add(() => n.microTask(() => o.dispose()));
      }
      n.style(t.body, "marginTop", `-${e}px`), window.scrollTo(0, 0);
      let i = null;
      n.addEventListener(t, "click", (o) => {
        if (o.target instanceof HTMLElement)
          try {
            let l = o.target.closest("a");
            if (!l)
              return;
            let { hash: s } = new URL(l.href), u = t.querySelector(s);
            u && !a(u) && (i = u);
          } catch {
          }
      }, !0), n.addEventListener(t, "touchmove", (o) => {
        o.target instanceof HTMLElement && !a(o.target) && o.preventDefault();
      }, { passive: !1 }), n.add(() => {
        window.scrollTo(0, window.pageYOffset + e), i && i.isConnected && (i.scrollIntoView({ block: "nearest" }), i = null);
      });
    });
  } };
}
function Vz() {
  return { before({ doc: e, d: t }) {
    t.style(e.documentElement, "overflow", "hidden");
  } };
}
function Fz(e) {
  let t = {};
  for (let n of e)
    Object.assign(t, n(t));
  return t;
}
let zn = Nz(() => /* @__PURE__ */ new Map(), { PUSH(e, t) {
  var n;
  let r = (n = this.get(e)) != null ? n : { doc: e, count: 0, d: Fn(), meta: /* @__PURE__ */ new Set() };
  return r.count++, r.meta.add(t), this.set(e, r), this;
}, POP(e, t) {
  let n = this.get(e);
  return n && (n.count--, n.meta.delete(t)), this;
}, SCROLL_PREVENT({ doc: e, d: t, meta: n }) {
  let r = { doc: e, d: t, meta: Fz(n) }, a = [Bz(), Rz(), Vz()];
  a.forEach(({ before: i }) => i == null ? void 0 : i(r)), a.forEach(({ after: i }) => i == null ? void 0 : i(r));
}, SCROLL_ALLOW({ d: e }) {
  e.dispose();
}, TEARDOWN({ doc: e }) {
  this.delete(e);
} });
zn.subscribe(() => {
  let e = zn.getSnapshot(), t = /* @__PURE__ */ new Map();
  for (let [n] of e)
    t.set(n, n.documentElement.style.overflow);
  for (let n of e.values()) {
    let r = t.get(n.doc) === "hidden", a = n.count !== 0;
    (a && !r || !a && r) && zn.dispatch(n.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", n), n.count === 0 && zn.dispatch("TEARDOWN", n);
  }
});
function Hz(e, t, n) {
  let r = Dz(zn), a = e ? r.get(e) : void 0, i = a ? a.count > 0 : !1;
  return $t(() => {
    if (!(!e || !t))
      return zn.dispatch("PUSH", e, n), () => zn.dispatch("POP", e, n);
  }, [t, e]), i;
}
let Rs = /* @__PURE__ */ new Map(), Hr = /* @__PURE__ */ new Map();
function Lp(e, t = !0) {
  $t(() => {
    var n;
    if (!t)
      return;
    let r = typeof e == "function" ? e() : e.current;
    if (!r)
      return;
    function a() {
      var o;
      if (!r)
        return;
      let l = (o = Hr.get(r)) != null ? o : 1;
      if (l === 1 ? Hr.delete(r) : Hr.set(r, l - 1), l !== 1)
        return;
      let s = Rs.get(r);
      s && (s["aria-hidden"] === null ? r.removeAttribute("aria-hidden") : r.setAttribute("aria-hidden", s["aria-hidden"]), r.inert = s.inert, Rs.delete(r));
    }
    let i = (n = Hr.get(r)) != null ? n : 0;
    return Hr.set(r, i + 1), i !== 0 || (Rs.set(r, { "aria-hidden": r.getAttribute("aria-hidden"), inert: r.inert }), r.setAttribute("aria-hidden", "true"), r.inert = !0), a;
  }, [e, t]);
}
function Kz({ defaultContainers: e = [], portals: t, mainTreeNodeRef: n } = {}) {
  var r;
  let a = J((r = n == null ? void 0 : n.current) != null ? r : null), i = oa(a), o = Ie(() => {
    var l;
    let s = [];
    for (let u of e)
      u !== null && (u instanceof HTMLElement ? s.push(u) : "current" in u && u.current instanceof HTMLElement && s.push(u.current));
    if (t != null && t.current)
      for (let u of t.current)
        s.push(u);
    for (let u of (l = i == null ? void 0 : i.querySelectorAll("html > *, body > *")) != null ? l : [])
      u !== document.body && u !== document.head && u instanceof HTMLElement && u.id !== "headlessui-portal-root" && (u.contains(a.current) || s.some((f) => u.contains(f)) || s.push(u));
    return s;
  });
  return { resolveContainers: o, contains: Ie((l) => o().some((s) => s.contains(l))), mainTreeNodeRef: a, MainTreeNode: ge(() => function() {
    return n != null ? null : oe.createElement(mc, { features: Si.Hidden, ref: a });
  }, [a, n]) };
}
var jz = ((e) => (e[e.Open = 0] = "Open", e[e.Closed = 1] = "Closed", e))(jz || {}), Uz = ((e) => (e[e.SetTitleId = 0] = "SetTitleId", e))(Uz || {});
let Wz = { 0(e, t) {
  return e.titleId === t.id ? e : { ...e, titleId: t.id };
} }, ki = Ze(null);
ki.displayName = "DialogContext";
function sa(e) {
  let t = ze(ki);
  if (t === null) {
    let n = new Error(`<${e} /> is missing a parent <Dialog /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(n, sa), n;
  }
  return t;
}
function qz(e, t, n = () => [document.body]) {
  Hz(e, t, (r) => {
    var a;
    return { containers: [...(a = r.containers) != null ? a : [], n] };
  });
}
function Zz(e, t) {
  return tt(t.type, Wz, e, t);
}
let Gz = "div", Yz = Ci.RenderStrategy | Ci.Static;
function Xz(e, t) {
  var n;
  let r = gr(), { id: a = `headlessui-dialog-${r}`, open: i, onClose: o, initialFocus: l, __demoMode: s = !1, ...u } = e, [f, h] = ne(0), g = u1();
  i === void 0 && g !== null && (i = (g & pt.Open) === pt.Open);
  let v = J(null), E = Mt(v, t), b = oa(v), w = e.hasOwnProperty("open") || g !== null, S = e.hasOwnProperty("onClose");
  if (!w && !S)
    throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
  if (!w)
    throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
  if (!S)
    throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
  if (typeof i != "boolean")
    throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${i}`);
  if (typeof o != "function")
    throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${o}`);
  let T = i ? 0 : 1, [A, V] = Ii(Zz, { titleId: null, descriptionId: null, panelRef: ry() }), $ = Ie(() => o(!1)), _ = Ie((ee) => V({ type: 0, id: ee })), y = mr() ? s ? !1 : T === 0 : !1, c = f > 1, p = ze(ki) !== null, [d, m] = hz(), { resolveContainers: O, mainTreeNodeRef: x, MainTreeNode: P } = Kz({ portals: d, defaultContainers: [(n = A.panelRef.current) != null ? n : v.current] }), N = c ? "parent" : "leaf", D = g !== null ? (g & pt.Closing) === pt.Closing : !1, I = (() => p || D ? !1 : y)(), C = he(() => {
    var ee, te;
    return (te = Array.from((ee = b == null ? void 0 : b.querySelectorAll("body > *")) != null ? ee : []).find((le) => le.id === "headlessui-portal-root" ? !1 : le.contains(x.current) && le instanceof HTMLElement)) != null ? te : null;
  }, [x]);
  Lp(C, I);
  let L = (() => c ? !0 : y)(), k = he(() => {
    var ee, te;
    return (te = Array.from((ee = b == null ? void 0 : b.querySelectorAll("[data-headlessui-portal]")) != null ? ee : []).find((le) => le.contains(x.current) && le instanceof HTMLElement)) != null ? te : null;
  }, [x]);
  Lp(k, L);
  let M = (() => !(!y || c))();
  jO(O, $, M);
  let F = (() => !(c || T !== 0))();
  fg(b == null ? void 0 : b.defaultView, "keydown", (ee) => {
    F && (ee.defaultPrevented || ee.key === dg.Escape && (ee.preventDefault(), ee.stopPropagation(), $()));
  });
  let j = (() => !(D || T !== 0 || p))();
  qz(b, j, O), re(() => {
    if (T !== 0 || !v.current)
      return;
    let ee = new ResizeObserver((te) => {
      for (let le of te) {
        let Y = le.target.getBoundingClientRect();
        Y.x === 0 && Y.y === 0 && Y.width === 0 && Y.height === 0 && $();
      }
    });
    return ee.observe(v.current), () => ee.disconnect();
  }, [T, v, $]);
  let [U, G] = gz(), X = ge(() => [{ dialogState: T, close: $, setTitleId: _ }, A], [T, A, $, _]), W = ge(() => ({ open: T === 0 }), [T]), q = { ref: E, id: a, role: "dialog", "aria-modal": T === 0 ? !0 : void 0, "aria-labelledby": A.titleId, "aria-describedby": U };
  return oe.createElement($z, { type: "Dialog", enabled: T === 0, element: v, onUpdate: Ie((ee, te) => {
    te === "Dialog" && tt(ee, { [wc.Add]: () => h((le) => le + 1), [wc.Remove]: () => h((le) => le - 1) });
  }) }, oe.createElement(gc, { force: !0 }, oe.createElement(bc, null, oe.createElement(ki.Provider, { value: X }, oe.createElement(bc.Group, { target: v }, oe.createElement(gc, { force: !1 }, oe.createElement(G, { slot: W, name: "Dialog.Description" }, oe.createElement(Fr, { initialFocus: l, containers: O, features: y ? tt(N, { parent: Fr.features.RestoreFocus, leaf: Fr.features.All & ~Fr.features.FocusLock }) : Fr.features.None }, oe.createElement(m, null, kt({ ourProps: q, theirProps: u, slot: W, defaultTag: Gz, features: Yz, visible: T === 0, name: "Dialog" }))))))))), oe.createElement(P, null));
}
let Jz = "div";
function Qz(e, t) {
  let n = gr(), { id: r = `headlessui-dialog-overlay-${n}`, ...a } = e, [{ dialogState: i, close: o }] = sa("Dialog.Overlay"), l = Mt(t), s = Ie((f) => {
    if (f.target === f.currentTarget) {
      if (qO(f.currentTarget))
        return f.preventDefault();
      f.preventDefault(), f.stopPropagation(), o();
    }
  }), u = ge(() => ({ open: i === 0 }), [i]);
  return kt({ ourProps: { ref: l, id: r, "aria-hidden": !0, onClick: s }, theirProps: a, slot: u, defaultTag: Jz, name: "Dialog.Overlay" });
}
let eM = "div";
function tM(e, t) {
  let n = gr(), { id: r = `headlessui-dialog-backdrop-${n}`, ...a } = e, [{ dialogState: i }, o] = sa("Dialog.Backdrop"), l = Mt(t);
  re(() => {
    if (o.panelRef.current === null)
      throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.");
  }, [o.panelRef]);
  let s = ge(() => ({ open: i === 0 }), [i]);
  return oe.createElement(gc, { force: !0 }, oe.createElement(bc, null, kt({ ourProps: { ref: l, id: r, "aria-hidden": !0 }, theirProps: a, slot: s, defaultTag: eM, name: "Dialog.Backdrop" })));
}
let nM = "div";
function rM(e, t) {
  let n = gr(), { id: r = `headlessui-dialog-panel-${n}`, ...a } = e, [{ dialogState: i }, o] = sa("Dialog.Panel"), l = Mt(t, o.panelRef), s = ge(() => ({ open: i === 0 }), [i]), u = Ie((f) => {
    f.stopPropagation();
  });
  return kt({ ourProps: { ref: l, id: r, onClick: u }, theirProps: a, slot: s, defaultTag: nM, name: "Dialog.Panel" });
}
let aM = "h2";
function iM(e, t) {
  let n = gr(), { id: r = `headlessui-dialog-title-${n}`, ...a } = e, [{ dialogState: i, setTitleId: o }] = sa("Dialog.Title"), l = Mt(t);
  re(() => (o(r), () => o(null)), [r, o]);
  let s = ge(() => ({ open: i === 0 }), [i]);
  return kt({ ourProps: { ref: l, id: r }, theirProps: a, slot: s, defaultTag: aM, name: "Dialog.Title" });
}
let oM = yt(Xz), lM = yt(tM), sM = yt(rM), cM = yt(Qz), uM = yt(iM), xc = Object.assign(oM, { Backdrop: lM, Panel: sM, Overlay: cM, Title: uM, Description: xz });
function dM(e = 0) {
  let [t, n] = ne(e), r = la(), a = he((s) => {
    r.current && n((u) => u | s);
  }, [t, r]), i = he((s) => !!(t & s), [t]), o = he((s) => {
    r.current && n((u) => u & ~s);
  }, [n, r]), l = he((s) => {
    r.current && n((u) => u ^ s);
  }, [n]);
  return { flags: t, addFlag: a, hasFlag: i, removeFlag: o, toggleFlag: l };
}
function fM(e) {
  let t = { called: !1 };
  return (...n) => {
    if (!t.called)
      return t.called = !0, e(...n);
  };
}
function Bs(e, ...t) {
  e && t.length > 0 && e.classList.add(...t);
}
function Vs(e, ...t) {
  e && t.length > 0 && e.classList.remove(...t);
}
function pM(e, t) {
  let n = Fn();
  if (!e)
    return n.dispose;
  let { transitionDuration: r, transitionDelay: a } = getComputedStyle(e), [i, o] = [r, a].map((s) => {
    let [u = 0] = s.split(",").filter(Boolean).map((f) => f.includes("ms") ? parseFloat(f) : parseFloat(f) * 1e3).sort((f, h) => h - f);
    return u;
  }), l = i + o;
  if (l !== 0) {
    n.group((u) => {
      u.setTimeout(() => {
        t(), u.dispose();
      }, l), u.addEventListener(e, "transitionrun", (f) => {
        f.target === f.currentTarget && u.dispose();
      });
    });
    let s = n.addEventListener(e, "transitionend", (u) => {
      u.target === u.currentTarget && (t(), s());
    });
  } else
    t();
  return n.add(() => t()), n.dispose;
}
function hM(e, t, n, r) {
  let a = n ? "enter" : "leave", i = Fn(), o = r !== void 0 ? fM(r) : () => {
  };
  a === "enter" && (e.removeAttribute("hidden"), e.style.display = "");
  let l = tt(a, { enter: () => t.enter, leave: () => t.leave }), s = tt(a, { enter: () => t.enterTo, leave: () => t.leaveTo }), u = tt(a, { enter: () => t.enterFrom, leave: () => t.leaveFrom });
  return Vs(e, ...t.base, ...t.enter, ...t.enterTo, ...t.enterFrom, ...t.leave, ...t.leaveFrom, ...t.leaveTo, ...t.entered), Bs(e, ...t.base, ...l, ...u), i.nextFrame(() => {
    Vs(e, ...t.base, ...l, ...u), Bs(e, ...t.base, ...l, ...s), pM(e, () => (Vs(e, ...t.base, ...l), Bs(e, ...t.base, ...t.entered), o()));
  }), i.dispose;
}
function vM({ immediate: e, container: t, direction: n, classes: r, onStart: a, onStop: i }) {
  let o = la(), l = s1(), s = Gt(n);
  $t(() => {
    e && (s.current = "enter");
  }, [e]), $t(() => {
    let u = Fn();
    l.add(u.dispose);
    let f = t.current;
    if (f && s.current !== "idle" && o.current)
      return u.dispose(), a.current(s.current), u.add(hM(f, r.current, s.current === "enter", () => {
        u.dispose(), i.current(s.current);
      })), u.dispose;
  }, [n]);
}
function cn(e = "") {
  return e.split(" ").filter((t) => t.trim().length > 1);
}
let ro = Ze(null);
ro.displayName = "TransitionContext";
var mM = ((e) => (e.Visible = "visible", e.Hidden = "hidden", e))(mM || {});
function gM() {
  let e = ze(ro);
  if (e === null)
    throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}
function yM() {
  let e = ze(ao);
  if (e === null)
    throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
  return e;
}
let ao = Ze(null);
ao.displayName = "NestingContext";
function io(e) {
  return "children" in e ? io(e.children) : e.current.filter(({ el: t }) => t.current !== null).filter(({ state: t }) => t === "visible").length > 0;
}
function xg(e, t) {
  let n = Gt(e), r = J([]), a = la(), i = s1(), o = Ie((v, E = fn.Hidden) => {
    let b = r.current.findIndex(({ el: w }) => w === v);
    b !== -1 && (tt(E, { [fn.Unmount]() {
      r.current.splice(b, 1);
    }, [fn.Hidden]() {
      r.current[b].state = "hidden";
    } }), i.microTask(() => {
      var w;
      !io(r) && a.current && ((w = n.current) == null || w.call(n));
    }));
  }), l = Ie((v) => {
    let E = r.current.find(({ el: b }) => b === v);
    return E ? E.state !== "visible" && (E.state = "visible") : r.current.push({ el: v, state: "visible" }), () => o(v, fn.Unmount);
  }), s = J([]), u = J(Promise.resolve()), f = J({ enter: [], leave: [], idle: [] }), h = Ie((v, E, b) => {
    s.current.splice(0), t && (t.chains.current[E] = t.chains.current[E].filter(([w]) => w !== v)), t == null || t.chains.current[E].push([v, new Promise((w) => {
      s.current.push(w);
    })]), t == null || t.chains.current[E].push([v, new Promise((w) => {
      Promise.all(f.current[E].map(([S, T]) => T)).then(() => w());
    })]), E === "enter" ? u.current = u.current.then(() => t == null ? void 0 : t.wait.current).then(() => b(E)) : b(E);
  }), g = Ie((v, E, b) => {
    Promise.all(f.current[E].splice(0).map(([w, S]) => S)).then(() => {
      var w;
      (w = s.current.shift()) == null || w();
    }).then(() => b(E));
  });
  return ge(() => ({ children: r, register: l, unregister: o, onStart: h, onStop: g, wait: u, chains: f }), [l, o, r, h, g, f, u]);
}
function bM() {
}
let wM = ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave"];
function Ip(e) {
  var t;
  let n = {};
  for (let r of wM)
    n[r] = (t = e[r]) != null ? t : bM;
  return n;
}
function xM(e) {
  let t = J(Ip(e));
  return re(() => {
    t.current = Ip(e);
  }, [e]), t;
}
let EM = "div", Eg = Ci.RenderStrategy;
function $M(e, t) {
  var n, r;
  let { beforeEnter: a, afterEnter: i, beforeLeave: o, afterLeave: l, enter: s, enterFrom: u, enterTo: f, entered: h, leave: g, leaveFrom: v, leaveTo: E, ...b } = e, w = J(null), S = Mt(w, t), T = (n = b.unmount) == null || n ? fn.Unmount : fn.Hidden, { show: A, appear: V, initial: $ } = gM(), [_, y] = ne(A ? "visible" : "hidden"), c = yM(), { register: p, unregister: d } = c;
  re(() => p(w), [p, w]), re(() => {
    if (T === fn.Hidden && w.current) {
      if (A && _ !== "visible") {
        y("visible");
        return;
      }
      return tt(_, { hidden: () => d(w), visible: () => p(w) });
    }
  }, [_, w, p, d, A, T]);
  let m = Gt({ base: cn(b.className), enter: cn(s), enterFrom: cn(u), enterTo: cn(f), entered: cn(h), leave: cn(g), leaveFrom: cn(v), leaveTo: cn(E) }), O = xM({ beforeEnter: a, afterEnter: i, beforeLeave: o, afterLeave: l }), x = mr();
  re(() => {
    if (x && _ === "visible" && w.current === null)
      throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
  }, [w, _, x]);
  let P = $ && !V, N = V && A && $, D = (() => !x || P ? "idle" : A ? "enter" : "leave")(), I = dM(0), C = Ie((j) => tt(j, { enter: () => {
    I.addFlag(pt.Opening), O.current.beforeEnter();
  }, leave: () => {
    I.addFlag(pt.Closing), O.current.beforeLeave();
  }, idle: () => {
  } })), L = Ie((j) => tt(j, { enter: () => {
    I.removeFlag(pt.Opening), O.current.afterEnter();
  }, leave: () => {
    I.removeFlag(pt.Closing), O.current.afterLeave();
  }, idle: () => {
  } })), k = xg(() => {
    y("hidden"), d(w);
  }, c);
  vM({ immediate: N, container: w, classes: m, direction: D, onStart: Gt((j) => {
    k.onStart(w, j, C);
  }), onStop: Gt((j) => {
    k.onStop(w, j, L), j === "leave" && !io(k) && (y("hidden"), d(w));
  }) });
  let M = b, F = { ref: S };
  return N ? M = { ...M, className: Pi(b.className, ...m.current.enter, ...m.current.enterFrom) } : (M.className = Pi(b.className, (r = w.current) == null ? void 0 : r.className), M.className === "" && delete M.className), oe.createElement(ao.Provider, { value: k }, oe.createElement(XO, { value: tt(_, { visible: pt.Open, hidden: pt.Closed }) | I.flags }, kt({ ourProps: F, theirProps: M, defaultTag: EM, features: Eg, visible: _ === "visible", name: "Transition.Child" })));
}
function PM(e, t) {
  let { show: n, appear: r = !1, unmount: a = !0, ...i } = e, o = J(null), l = Mt(o, t);
  mr();
  let s = u1();
  if (n === void 0 && s !== null && (n = (s & pt.Open) === pt.Open), ![!0, !1].includes(n))
    throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
  let [u, f] = ne(n ? "visible" : "hidden"), h = xg(() => {
    f("hidden");
  }), [g, v] = ne(!0), E = J([n]);
  $t(() => {
    g !== !1 && E.current[E.current.length - 1] !== n && (E.current.push(n), v(!1));
  }, [E, n]);
  let b = ge(() => ({ show: n, appear: r, initial: g }), [n, r, g]);
  re(() => {
    if (n)
      f("visible");
    else if (!io(h))
      f("hidden");
    else {
      let A = o.current;
      if (!A)
        return;
      let V = A.getBoundingClientRect();
      V.x === 0 && V.y === 0 && V.width === 0 && V.height === 0 && f("hidden");
    }
  }, [n, h]);
  let w = { unmount: a }, S = Ie(() => {
    var A;
    g && v(!1), (A = e.beforeEnter) == null || A.call(e);
  }), T = Ie(() => {
    var A;
    g && v(!1), (A = e.beforeLeave) == null || A.call(e);
  });
  return oe.createElement(ao.Provider, { value: h }, oe.createElement(ro.Provider, { value: b }, kt({ ourProps: { ...w, as: st, children: oe.createElement($g, { ref: l, ...w, ...i, beforeEnter: S, beforeLeave: T }) }, theirProps: {}, defaultTag: st, features: Eg, visible: u === "visible", name: "Transition" })));
}
function CM(e, t) {
  let n = ze(ro) !== null, r = u1() !== null;
  return oe.createElement(oe.Fragment, null, !n && r ? oe.createElement(Ec, { ref: t, ...e }) : oe.createElement($g, { ref: t, ...e }));
}
let Ec = yt(PM), $g = yt($M), SM = yt(CM), qr = Object.assign(Ec, { Child: SM, Root: Ec });
const kM = de("", {
  variants: {
    position: {
      "top-start": "mt-0 ms-0 mb-auto me-auto",
      "top-left": "mt-0 ml-0 mb-auto mr-auto",
      "top-middle": "mt-0 mb-auto mx-auto",
      "top-end": "mt-0 ms-auto mb-auto me-0",
      "top-right": "mt-0 ml-auto mb-auto mr-0",
      "middle-start": "my-auto ms-0 me-auto",
      "middle-left": "my-auto ml-0 mr-auto",
      center: "m-auto",
      "middle-end": "my-auto ms-auto me-0",
      "middle-right": "my-auto ml-auto mr-0",
      "bottom-start": "mt-auto ms-0 mb-0 me-auto",
      "bottom-left": "mt-auto ml-0 mb-0 mr-auto",
      "bottom-middle": "mt-auto mb-0 mx-auto",
      "bottom-end": "mt-auto ms-auto mb-0 me-0",
      "bottom-right": "mt-auto ml-auto mb-0 mr-0"
    }
  }
}), Pg = Ze({}), TM = 500, p1 = ({
  children: e,
  fixedContent: t,
  initialFocus: n,
  defaultStyling: r = !0,
  isDismissable: a = !0,
  open: i = !1,
  onClose: o,
  position: l = "center",
  unmount: s = !0,
  backdropClassName: u,
  className: f,
  subregion: h = ""
}) => {
  re(() => {
    i && setTimeout(() => {
      var w;
      (w = window.EFClickMapActivator) == null || w.init();
    }, TM);
  }, [i]);
  const g = () => {
    a && (v || o());
  }, [v, E] = ne(!1), b = () => {
    E(!0), setTimeout(() => {
      E(!1);
    }, 120);
  };
  return /* @__PURE__ */ H(qr, { unmount: s, appear: !0, show: i, as: st, children: /* @__PURE__ */ H(
    xc,
    {
      as: "div",
      className: "relative z-[1000000]",
      onClose: g,
      initialFocus: n,
      unmount: s,
      "data-cy": "gudl-modal",
      "data-clickregion": "modal",
      ...a && { "data-info": "close" },
      children: /* @__PURE__ */ ie("div", { "data-clicksubregion": h, children: [
        /* @__PURE__ */ H(
          qr.Child,
          {
            as: st,
            enter: "ease-expressive duration-300",
            enterFrom: "opacity-0",
            enterTo: "opacity-100",
            leave: "ease-expressive duration-300 delay-100",
            leaveFrom: "opacity-100",
            leaveTo: "opacity-0",
            unmount: s,
            children: /* @__PURE__ */ H(
              "div",
              {
                className: ae(
                  "fixed inset-0 bg-black/80",
                  u
                ),
                "data-cy": "gudl-modal-backdrop"
              }
            )
          }
        ),
        /* @__PURE__ */ H("div", { className: "fixed inset-y-0 start-0 w-screen overflow-y-auto", children: /* @__PURE__ */ H(
          "div",
          {
            className: ae(
              "flex min-h-full items-center justify-center",
              r && "p-4"
            ),
            children: /* @__PURE__ */ H(
              qr.Child,
              {
                as: st,
                enter: "ease-expressive duration-300 delay-100",
                enterFrom: "opacity-0",
                enterTo: "opacity-100",
                leave: "ease-expressive duration-300",
                leaveFrom: "opacity-100",
                leaveTo: "opacity-0",
                unmount: s,
                children: /* @__PURE__ */ H(
                  xc.Panel,
                  {
                    role: "dialog",
                    className: ae(
                      "relative transform overflow-hidden transition-all",
                      r && "w-full max-w-[1102px] rounded-lg bg-white shadow",
                      kM({ position: l }),
                      f
                    ),
                    "data-cy": "gudl-modal-panel",
                    children: /* @__PURE__ */ H(
                      Pg.Provider,
                      {
                        value: { onDangerousClose: b },
                        children: e
                      }
                    )
                  }
                )
              }
            )
          }
        ) }),
        t && /* @__PURE__ */ H(
          qr.Child,
          {
            as: st,
            enter: "ease-expressive duration-300 delay-100",
            enterFrom: "opacity-0",
            enterTo: "opacity-100",
            leave: "ease-expressive duration-300",
            leaveFrom: "opacity-100",
            leaveTo: "opacity-0",
            unmount: s,
            children: t
          }
        )
      ] })
    }
  ) });
}, AM = ({
  children: e,
  defaultStyling: t = !0,
  className: n
}) => /* @__PURE__ */ H(
  xc.Title,
  {
    className: ae(
      t && "border-b border-neutral-300 bg-white p-3 md:p-4",
      n
    ),
    "data-cy": "gudl-modal-header",
    children: e
  }
), OM = ({
  children: e,
  defaultStyling: t = !0,
  className: n
}) => /* @__PURE__ */ H(
  "div",
  {
    "data-cy": "gudl-modal-content",
    className: ae(t && "", n),
    children: e
  }
), zM = ({
  children: e,
  defaultStyling: t = !0,
  className: n
}) => /* @__PURE__ */ H(
  "div",
  {
    className: ae(
      t && "border-t border-neutral-300 bg-white p-3 md:p-4",
      n
    ),
    "data-cy": "gudl-modal-footer",
    children: e
  }
);
p1.Header = AM;
p1.Content = OM;
p1.Footer = zM;
const MM = de(
  "gudl-radio-circle border h-5 w-5 rounded-full ring-offset-1 ring-1 flex justify-center items-center overflow-hidden shrink-0 transition-all",
  {
    variants: {
      intent: {
        black: "bg-white border-neutral text-transparent",
        white: "bg-white/20 border-white text-transparent"
      },
      isSelected: {
        true: "bg-brand-accessible-blue border-brand-accessible-blue text-white"
      },
      isFocusVisible: {
        true: "ring-brand-accessible-blue ring-offset-white",
        false: "ring-offset-transparent ring-transparent"
      },
      isDisabled: { true: "bg-neutral-300 border-neutral" }
    },
    defaultVariants: {
      intent: "black",
      isFocusVisible: !1,
      isSelected: !1,
      isDisabled: !1
    }
  }
), _M = de(
  "gudl-radio-text ms-2 transition-colors text-label-lg",
  {
    variants: {
      intent: {
        black: "text-black",
        white: "text-white"
      },
      isDisabled: {
        true: "text-neutral"
      }
    },
    defaultVariants: {
      intent: "black",
      isDisabled: !1
    }
  }
), LM = de("", {
  variants: {
    orientation: {
      vertical: "space-y-2",
      horizontal: "flex flex-row flex-wrap gap-x-6 gap-y-2"
    }
  },
  defaultVariants: {
    orientation: "horizontal"
  }
}), Cg = Ze(null), sN = (e) => {
  const {
    children: t,
    errorMessage: n,
    helperMessage: r,
    className: a,
    label: i,
    isRequired: o,
    orientation: l,
    containerClassName: s,
    validationState: u
  } = e, f = qS(e), { radioGroupProps: h, errorMessageProps: g, labelProps: v } = X5(
    e,
    f
  );
  return /* @__PURE__ */ ie(
    "div",
    {
      ...h,
      className: ae(
        "flex flex-col items-start gap-y-4",
        s
      ),
      "data-cy": "gudl-radio-group",
      children: [
        i && /* @__PURE__ */ ie(
          "div",
          {
            className: "text-label-lg flex items-baseline gap-x-1",
            ...v,
            children: [
              i,
              o && /* @__PURE__ */ ie(De, { children: [
                /* @__PURE__ */ H("span", { className: "text-brand-accessible-blue", "aria-hidden": "true", children: " *" }),
                /* @__PURE__ */ H("span", { className: "hidden", children: "required" })
              ] })
            ]
          }
        ),
        /* @__PURE__ */ H(
          "div",
          {
            "data-cy": "gudl-radio-group-items",
            className: ae(
              LM({
                orientation: l
              }),
              a
            ),
            children: /* @__PURE__ */ H(Cg.Provider, { value: f, children: t })
          }
        ),
        u === "invalid" && n && /* @__PURE__ */ H(
          gt,
          {
            ...g,
            className: "ms-[3px]",
            intent: "danger",
            children: n
          }
        ),
        r && /* @__PURE__ */ H(gt, { className: "ms-[3px]", children: r })
      ]
    }
  );
}, cN = (e) => {
  const {
    children: t,
    intent: n = "black",
    isDisabled: r = !1,
    className: a,
    value: i,
    onClick: o,
    card: l,
    cardOptions: s = {}
  } = e, f = ze(Cg), h = J(null), { inputProps: g } = Y5(e, f, h), { isFocusVisible: v, focusProps: E } = vr(), b = f.selectedValue === i, w = () => /* @__PURE__ */ ie(
    "label",
    {
      className: ae(
        "flex items-center py-3",
        r ? "cursor-not-allowed" : "cursor-pointer",
        a
      ),
      "data-cy": `gudl-radio-box-${i}`,
      children: [
        /* @__PURE__ */ H(iv, { children: /* @__PURE__ */ H(
          "input",
          {
            "data-cy": "gudl-radio",
            ref: h,
            ...g,
            ...E,
            onClick: o
          }
        ) }),
        /* @__PURE__ */ H(
          "div",
          {
            className: ae(
              MM({
                intent: n,
                isSelected: b,
                isFocusVisible: v,
                isDisabled: r
              })
            ),
            "data-cy": `gudl-radio-circle-${i}`,
            children: !r && /* @__PURE__ */ H(
              "div",
              {
                className: ae(
                  b ? "bg-white" : "bg-transparent",
                  "h-2 w-2 rounded-full transition-colors"
                )
              }
            )
          }
        ),
        /* @__PURE__ */ H("span", { className: ae(_M({ intent: n, isDisabled: r })), children: t })
      ]
    }
  );
  return l ? /* @__PURE__ */ H(
    zm,
    {
      className: "mb-4",
      isSelected: b,
      isDisabled: r,
      isFocused: v,
      ...s,
      children: w()
    }
  ) : w();
};
var IM = Object.defineProperty, DM = (e, t, n) => t in e ? IM(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n, It = (e, t, n) => (DM(e, typeof t != "symbol" ? t + "" : t, n), n);
class NM {
  constructor() {
    It(this, "isCDNUrl", (t = "") => t.indexOf("/cdn/") > -1), It(this, "getOptionsPage", (t, n = 25, r = 1) => ({
      ...t,
      per_page: n,
      page: r
    })), It(this, "delay", (t) => new Promise((n) => setTimeout(n, t))), It(this, "arrayFrom", (t = 0, n) => [...Array(t)].map(n)), It(this, "range", (t = 0, n = t) => {
      const r = Math.abs(n - t) || 0, a = t < n ? 1 : -1;
      return this.arrayFrom(r, (i, o) => o * a + t);
    }), It(this, "asyncMap", async (t, n) => Promise.all(t.map(n))), It(this, "flatMap", (t = [], n) => t.map(n).reduce((r, a) => [...r, ...a], [])), It(this, "escapeHTML", function(t) {
      const n = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      }, r = /[&<>"']/g, a = RegExp(r.source);
      return t && a.test(t) ? t.replace(r, (i) => n[i]) : t;
    });
  }
  /**
   * @method stringify
   * @param  {Object} params
   * @param  {String} prefix
   * @param  {Boolean} isArray
   * @return {String} Stringified object
   */
  stringify(t, n, r) {
    const a = [];
    for (const i in t) {
      if (!Object.prototype.hasOwnProperty.call(t, i))
        continue;
      const o = t[i], l = r ? "" : encodeURIComponent(i);
      let s;
      typeof o == "object" ? s = this.stringify(
        o,
        n ? n + encodeURIComponent("[" + l + "]") : l,
        Array.isArray(o)
      ) : s = (n ? n + encodeURIComponent("[" + l + "]") : l) + "=" + encodeURIComponent(o), a.push(s);
    }
    return a.join("&");
  }
  /**
   * @method getRegionURL
   * @param  {String} regionCode region code, could be eu, us or cn
   * @return {String} The base URL of the region
   */
  getRegionURL(t) {
    const n = "api.storyblok.com", r = "api-us.storyblok.com", a = "app.storyblokchina.cn";
    switch (t) {
      case "us":
        return r;
      case "cn":
        return a;
      default:
        return n;
    }
  }
}
const RM = function(e, t) {
  const n = {};
  for (const r in e) {
    const a = e[r];
    t.indexOf(r) > -1 && a !== null && (n[r] = a);
  }
  return n;
}, BM = (e) => e === "email", VM = () => ({
  singleTag: "hr"
}), FM = () => ({
  tag: "blockquote"
}), HM = () => ({
  tag: "ul"
}), KM = (e) => ({
  tag: [
    "pre",
    {
      tag: "code",
      attrs: e.attrs
    }
  ]
}), jM = () => ({
  singleTag: "br"
}), UM = (e) => ({
  tag: `h${e.attrs.level}`
}), WM = (e) => ({
  singleTag: [
    {
      tag: "img",
      attrs: RM(e.attrs, ["src", "alt", "title"])
    }
  ]
}), qM = () => ({
  tag: "li"
}), ZM = () => ({
  tag: "ol"
}), GM = () => ({
  tag: "p"
}), YM = (e) => ({
  tag: [
    {
      tag: "span",
      attrs: {
        "data-type": "emoji",
        "data-name": e.attrs.name,
        emoji: e.attrs.emoji
      }
    }
  ]
}), XM = () => ({
  tag: "b"
}), JM = () => ({
  tag: "strike"
}), QM = () => ({
  tag: "u"
}), e_ = () => ({
  tag: "strong"
}), t_ = () => ({
  tag: "code"
}), n_ = () => ({
  tag: "i"
}), r_ = (e) => {
  if (!e.attrs)
    return {
      tag: ""
    };
  const t = new NM().escapeHTML, n = { ...e.attrs }, { linktype: r = "url" } = e.attrs;
  if (delete n.linktype, n.href && (n.href = t(e.attrs.href || "")), BM(r) && (n.href = `mailto:${n.href}`), n.anchor && (n.href = `${n.href}#${n.anchor}`, delete n.anchor), n.custom) {
    for (const a in n.custom)
      n[a] = n.custom[a];
    delete n.custom;
  }
  return {
    tag: [
      {
        tag: "a",
        attrs: n
      }
    ]
  };
}, a_ = (e) => ({
  tag: [
    {
      tag: "span",
      attrs: e.attrs
    }
  ]
}), i_ = () => ({
  tag: "sub"
}), o_ = () => ({
  tag: "sup"
}), l_ = (e) => ({
  tag: [
    {
      tag: "span",
      attrs: e.attrs
    }
  ]
}), s_ = (e) => {
  var t;
  return (t = e.attrs) != null && t.color ? {
    tag: [
      {
        tag: "span",
        attrs: {
          style: `background-color:${e.attrs.color};`
        }
      }
    ]
  } : {
    tag: ""
  };
}, c_ = (e) => {
  var t;
  return (t = e.attrs) != null && t.color ? {
    tag: [
      {
        tag: "span",
        attrs: {
          style: `color:${e.attrs.color}`
        }
      }
    ]
  } : {
    tag: ""
  };
}, u_ = {
  nodes: {
    horizontal_rule: VM,
    blockquote: FM,
    bullet_list: HM,
    code_block: KM,
    hard_break: jM,
    heading: UM,
    image: WM,
    list_item: qM,
    ordered_list: ZM,
    paragraph: GM,
    emoji: YM
  },
  marks: {
    bold: XM,
    strike: JM,
    underline: QM,
    strong: e_,
    code: t_,
    italic: n_,
    link: r_,
    styled: a_,
    subscript: i_,
    superscript: o_,
    anchor: l_,
    highlight: s_,
    textStyle: c_
  }
}, d_ = function(e) {
  const t = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;"
  }, n = /[&<>"']/g, r = RegExp(n.source);
  return e && r.test(e) ? e.replace(n, (a) => t[a]) : e;
};
class f_ {
  constructor(t) {
    It(this, "marks"), It(this, "nodes"), t || (t = u_), this.marks = t.marks || [], this.nodes = t.nodes || [];
  }
  addNode(t, n) {
    this.nodes[t] = n;
  }
  addMark(t, n) {
    this.marks[t] = n;
  }
  render(t, n = { optimizeImages: !1 }) {
    if (t && t.content && Array.isArray(t.content)) {
      let r = "";
      return t.content.forEach((a) => {
        r += this.renderNode(a);
      }), n.optimizeImages ? this.optimizeImages(r, n.optimizeImages) : r;
    }
    return console.warn(
      `The render method must receive an Object with a "content" field.
			The "content" field must be an array of nodes as the type ISbRichtext.
			ISbRichtext:
				content?: ISbRichtext[]
				marks?: ISbRichtext[]
				attrs?: any
				text?: string
				type: string
				
				Example:
				{
					content: [
						{
							content: [
								{
									text: 'Hello World',
									type: 'text'
								}
							],
							type: 'paragraph'
						}
					],
					type: 'doc'
				}`
    ), "";
  }
  optimizeImages(t, n) {
    let r = 0, a = 0, i = "", o = "";
    typeof n != "boolean" && (typeof n.width == "number" && n.width > 0 && (i += `width="${n.width}" `, r = n.width), typeof n.height == "number" && n.height > 0 && (i += `height="${n.height}" `, a = n.height), (n.loading === "lazy" || n.loading === "eager") && (i += `loading="${n.loading}" `), typeof n.class == "string" && n.class.length > 0 && (i += `class="${n.class}" `), n.filters && (typeof n.filters.blur == "number" && n.filters.blur >= 0 && n.filters.blur <= 100 && (o += `:blur(${n.filters.blur})`), typeof n.filters.brightness == "number" && n.filters.brightness >= -100 && n.filters.brightness <= 100 && (o += `:brightness(${n.filters.brightness})`), n.filters.fill && (n.filters.fill.match(/[0-9A-Fa-f]{6}/g) || n.filters.fill === "transparent") && (o += `:fill(${n.filters.fill})`), n.filters.format && ["webp", "png", "jpeg"].includes(n.filters.format) && (o += `:format(${n.filters.format})`), typeof n.filters.grayscale == "boolean" && n.filters.grayscale && (o += ":grayscale()"), typeof n.filters.quality == "number" && n.filters.quality >= 0 && n.filters.quality <= 100 && (o += `:quality(${n.filters.quality})`), n.filters.rotate && [90, 180, 270].includes(n.filters.rotate) && (o += `:rotate(${n.filters.rotate})`), o.length > 0 && (o = "/filters" + o))), i.length > 0 && (t = t.replace(/<img/g, `<img ${i.trim()}`));
    const l = r > 0 || a > 0 || o.length > 0 ? `${r}x${a}${o}` : "";
    return t = t.replace(
      /a.storyblok.com\/f\/(\d+)\/([^.]+)\.(gif|jpg|jpeg|png|tif|tiff|bmp)/g,
      `a.storyblok.com/f/$1/$2.$3/m/${l}`
    ), typeof n != "boolean" && (n.sizes || n.srcset) && (t = t.replace(/<img.*?src=["|'](.*?)["|']/g, (s) => {
      var u, f;
      const h = s.match(
        /a.storyblok.com\/f\/(\d+)\/([^.]+)\.(gif|jpg|jpeg|png|tif|tiff|bmp)/g
      );
      if (h && h.length > 0) {
        const g = {
          srcset: (u = n.srcset) == null ? void 0 : u.map((E) => {
            if (typeof E == "number")
              return `//${h}/m/${E}x0${o} ${E}w`;
            if (typeof E == "object" && E.length === 2) {
              let b = 0, w = 0;
              return typeof E[0] == "number" && (b = E[0]), typeof E[1] == "number" && (w = E[1]), `//${h}/m/${b}x${w}${o} ${b}w`;
            }
          }).join(", "),
          sizes: (f = n.sizes) == null ? void 0 : f.map((E) => E).join(", ")
        };
        let v = "";
        return g.srcset && (v += `srcset="${g.srcset}" `), g.sizes && (v += `sizes="${g.sizes}" `), s.replace(/<img/g, `<img ${v.trim()}`);
      }
      return s;
    })), t;
  }
  renderNode(t) {
    const n = [];
    t.marks && t.marks.forEach((a) => {
      const i = this.getMatchingMark(a);
      i && i.tag !== "" && n.push(this.renderOpeningTag(i.tag));
    });
    const r = this.getMatchingNode(t);
    return r && r.tag && n.push(this.renderOpeningTag(r.tag)), t.content ? t.content.forEach((a) => {
      n.push(this.renderNode(a));
    }) : t.text ? n.push(d_(t.text)) : r && r.singleTag ? n.push(this.renderTag(r.singleTag, " /")) : r && r.html ? n.push(r.html) : t.type === "emoji" && n.push(this.renderEmoji(t)), r && r.tag && n.push(this.renderClosingTag(r.tag)), t.marks && t.marks.slice(0).reverse().forEach((a) => {
      const i = this.getMatchingMark(a);
      i && i.tag !== "" && n.push(this.renderClosingTag(i.tag));
    }), n.join("");
  }
  renderTag(t, n) {
    return t.constructor === String ? `<${t}${n}>` : t.map((r) => {
      if (r.constructor === String)
        return `<${r}${n}>`;
      {
        let a = `<${r.tag}`;
        if (r.attrs)
          for (const i in r.attrs) {
            const o = r.attrs[i];
            o !== null && (a += ` ${i}="${o}"`);
          }
        return `${a}${n}>`;
      }
    }).join("");
  }
  renderOpeningTag(t) {
    return this.renderTag(t, "");
  }
  renderClosingTag(t) {
    return t.constructor === String ? `</${t}>` : t.slice(0).reverse().map((n) => n.constructor === String ? `</${n}>` : `</${n.tag}>`).join("");
  }
  getMatchingNode(t) {
    const n = this.nodes[t.type];
    if (typeof n == "function")
      return n(t);
  }
  getMatchingMark(t) {
    const n = this.marks[t.type];
    if (typeof n == "function")
      return n(t);
  }
  renderEmoji(t) {
    if (t.attrs.emoji)
      return t.attrs.emoji;
    const n = [
      {
        tag: "img",
        attrs: {
          src: t.attrs.fallbackImage,
          draggable: "false",
          loading: "lazy",
          align: "absmiddle"
        }
      }
    ];
    return this.renderTag(n, " /");
  }
}
const Xa = {
  h1: {
    className: "mobile-h1 md:tablet-h1 lg:desktop-h1"
  },
  h2: {
    className: "mobile-h2 md:tablet-h2 lg:desktop-h2"
  },
  h3: {
    className: "mobile-h3 md:tablet-h3 lg:desktop-h3"
  },
  h4: {
    className: "mobile-h4 md:tablet-h4 lg:desktop-h4"
  },
  h5: {
    className: "mobile-h5 md:tablet-h5 lg:desktop-h5"
  },
  p: {
    className: "text-body"
  }
}, Sg = (e) => ({
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  replace: (t) => {
    const n = t.name, r = Xa == null ? void 0 : Xa[n], a = e == null ? void 0 : e[n];
    if (t.attribs && (r || a)) {
      const { concatClassNames: i, ...o } = a || {};
      i && (o != null && o.className) && (r != null && r.className) && (o.className = `${r.className} ${o.className}`);
      const l = CT({
        ...t.attribs,
        ...Xa[n],
        ...o
      }), s = t.name;
      return /* @__PURE__ */ H(s, { ...l, children: PT(t.children, Sg(e)) });
    }
  }
}), p_ = new f_(), uN = ({
  richtext: e,
  customParserOptions: t,
  className: n
}) => {
  const r = p_.render(e);
  return /* @__PURE__ */ H("div", { className: ae("richtext", n), children: nn(r, Sg(t || {})) });
};
function be() {
  return be = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, be.apply(this, arguments);
}
function h_(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function kg(...e) {
  return (t) => e.forEach(
    (n) => h_(n, t)
  );
}
function Fe(...e) {
  return he(kg(...e), e);
}
const ea = /* @__PURE__ */ Se((e, t) => {
  const { children: n, ...r } = e, a = He.toArray(n), i = a.find(m_);
  if (i) {
    const o = i.props.children, l = a.map((s) => s === i ? He.count(o) > 1 ? He.only(null) : /* @__PURE__ */ pn(o) ? o.props.children : null : s);
    return /* @__PURE__ */ se($c, be({}, r, {
      ref: t
    }), /* @__PURE__ */ pn(o) ? /* @__PURE__ */ en(o, void 0, l) : null);
  }
  return /* @__PURE__ */ se($c, be({}, r, {
    ref: t
  }), n);
});
ea.displayName = "Slot";
const $c = /* @__PURE__ */ Se((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ pn(n) ? /* @__PURE__ */ en(n, {
    ...g_(r, n.props),
    ref: t ? kg(t, n.ref) : n.ref
  }) : He.count(n) > 1 ? He.only(null) : null;
});
$c.displayName = "SlotClone";
const v_ = ({ children: e }) => /* @__PURE__ */ se(st, null, e);
function m_(e) {
  return /* @__PURE__ */ pn(e) && e.type === v_;
}
function g_(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const a = e[r], i = t[r];
    /^on[A-Z]/.test(r) ? a && i ? n[r] = (...l) => {
      i(...l), a(...l);
    } : a && (n[r] = a) : r === "style" ? n[r] = {
      ...a,
      ...i
    } : r === "className" && (n[r] = [
      a,
      i
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const y_ = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Je = y_.reduce((e, t) => {
  const n = /* @__PURE__ */ Se((r, a) => {
    const { asChild: i, ...o } = r, l = i ? ea : t;
    return re(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ se(l, be({}, o, {
      ref: a
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function b_(e, t) {
  e && zc(
    () => e.dispatchEvent(t)
  );
}
const Pt = globalThis != null && globalThis.document ? na : () => {
};
function w_(e, t) {
  return Ii((n, r) => {
    const a = t[n][r];
    return a ?? n;
  }, e);
}
const ca = (e) => {
  const { present: t, children: n } = e, r = x_(t), a = typeof n == "function" ? n({
    present: r.isPresent
  }) : He.only(n), i = Fe(r.ref, a.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ en(a, {
    ref: i
  }) : null;
};
ca.displayName = "Presence";
function x_(e) {
  const [t, n] = ne(), r = J({}), a = J(e), i = J("none"), o = e ? "mounted" : "unmounted", [l, s] = w_(o, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return re(() => {
    const u = Ja(r.current);
    i.current = l === "mounted" ? u : "none";
  }, [
    l
  ]), Pt(() => {
    const u = r.current, f = a.current;
    if (f !== e) {
      const g = i.current, v = Ja(u);
      e ? s("MOUNT") : v === "none" || (u == null ? void 0 : u.display) === "none" ? s("UNMOUNT") : s(f && g !== v ? "ANIMATION_OUT" : "UNMOUNT"), a.current = e;
    }
  }, [
    e,
    s
  ]), Pt(() => {
    if (t) {
      const u = (h) => {
        const v = Ja(r.current).includes(h.animationName);
        h.target === t && v && zc(
          () => s("ANIMATION_END")
        );
      }, f = (h) => {
        h.target === t && (i.current = Ja(r.current));
      };
      return t.addEventListener("animationstart", f), t.addEventListener("animationcancel", u), t.addEventListener("animationend", u), () => {
        t.removeEventListener("animationstart", f), t.removeEventListener("animationcancel", u), t.removeEventListener("animationend", u);
      };
    } else
      s("ANIMATION_END");
  }, [
    t,
    s
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(l),
    ref: he((u) => {
      u && (r.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function Ja(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function oo(e, t = []) {
  let n = [];
  function r(i, o) {
    const l = /* @__PURE__ */ Ze(o), s = n.length;
    n = [
      ...n,
      o
    ];
    function u(h) {
      const { scope: g, children: v, ...E } = h, b = (g == null ? void 0 : g[e][s]) || l, w = ge(
        () => E,
        Object.values(E)
      );
      return /* @__PURE__ */ se(b.Provider, {
        value: w
      }, v);
    }
    function f(h, g) {
      const v = (g == null ? void 0 : g[e][s]) || l, E = ze(v);
      if (E)
        return E;
      if (o !== void 0)
        return o;
      throw new Error(`\`${h}\` must be used within \`${i}\``);
    }
    return u.displayName = i + "Provider", [
      u,
      f
    ];
  }
  const a = () => {
    const i = n.map((o) => /* @__PURE__ */ Ze(o));
    return function(l) {
      const s = (l == null ? void 0 : l[e]) || i;
      return ge(
        () => ({
          [`__scope${e}`]: {
            ...l,
            [e]: s
          }
        }),
        [
          l,
          s
        ]
      );
    };
  };
  return a.scopeName = e, [
    r,
    E_(a, ...t)
  ];
}
function E_(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map(
      (a) => ({
        useScope: a(),
        scopeName: a.scopeName
      })
    );
    return function(i) {
      const o = r.reduce((l, { useScope: s, scopeName: u }) => {
        const h = s(i)[`__scope${u}`];
        return {
          ...l,
          ...h
        };
      }, {});
      return ge(
        () => ({
          [`__scope${t.scopeName}`]: o
        }),
        [
          o
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
function et(e) {
  const t = J(e);
  return re(() => {
    t.current = e;
  }), ge(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
const $_ = /* @__PURE__ */ Ze(void 0);
function Tg(e) {
  const t = ze($_);
  return e || t || "ltr";
}
function Pc(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function Be(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(a) {
    if (e == null || e(a), n === !1 || !a.defaultPrevented)
      return t == null ? void 0 : t(a);
  };
}
function P_(e, t) {
  return Ii((n, r) => {
    const a = t[n][r];
    return a ?? n;
  }, e);
}
const Ag = "ScrollArea", [Og, dN] = oo(Ag), [C_, Vt] = Og(Ag), S_ = /* @__PURE__ */ Se((e, t) => {
  const { __scopeScrollArea: n, type: r = "hover", dir: a, scrollHideDelay: i = 600, ...o } = e, [l, s] = ne(null), [u, f] = ne(null), [h, g] = ne(null), [v, E] = ne(null), [b, w] = ne(null), [S, T] = ne(0), [A, V] = ne(0), [$, _] = ne(!1), [y, c] = ne(!1), p = Fe(
    t,
    (m) => s(m)
  ), d = Tg(a);
  return /* @__PURE__ */ se(C_, {
    scope: n,
    type: r,
    dir: d,
    scrollHideDelay: i,
    scrollArea: l,
    viewport: u,
    onViewportChange: f,
    content: h,
    onContentChange: g,
    scrollbarX: v,
    onScrollbarXChange: E,
    scrollbarXEnabled: $,
    onScrollbarXEnabledChange: _,
    scrollbarY: b,
    onScrollbarYChange: w,
    scrollbarYEnabled: y,
    onScrollbarYEnabledChange: c,
    onCornerWidthChange: T,
    onCornerHeightChange: V
  }, /* @__PURE__ */ se(Je.div, be({
    dir: d
  }, o, {
    ref: p,
    style: {
      position: "relative",
      // Pass corner sizes as CSS vars to reduce re-renders of context consumers
      "--radix-scroll-area-corner-width": S + "px",
      "--radix-scroll-area-corner-height": A + "px",
      ...e.style
    }
  })));
}), k_ = "ScrollAreaViewport", T_ = /* @__PURE__ */ Se((e, t) => {
  const { __scopeScrollArea: n, children: r, ...a } = e, i = Vt(k_, n), o = J(null), l = Fe(t, o, i.onViewportChange);
  return /* @__PURE__ */ se(st, null, /* @__PURE__ */ se("style", {
    dangerouslySetInnerHTML: {
      __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
    }
  }), /* @__PURE__ */ se(Je.div, be({
    "data-radix-scroll-area-viewport": ""
  }, a, {
    ref: l,
    style: {
      /**
      * We don't support `visible` because the intention is to have at least one scrollbar
      * if this component is used and `visible` will behave like `auto` in that case
      * https://developer.mozilla.org/en-US/docs/Web/CSS/overflowed#description
      *
      * We don't handle `auto` because the intention is for the native implementation
      * to be hidden if using this component. We just want to ensure the node is scrollable
      * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
      * the browser from having to work out whether to render native scrollbars or not,
      * we tell it to with the intention of hiding them in CSS.
      */
      overflowX: i.scrollbarXEnabled ? "scroll" : "hidden",
      overflowY: i.scrollbarYEnabled ? "scroll" : "hidden",
      ...e.style
    }
  }), /* @__PURE__ */ se("div", {
    ref: i.onContentChange,
    style: {
      minWidth: "100%",
      display: "table"
    }
  }, r)));
}), an = "ScrollAreaScrollbar", A_ = /* @__PURE__ */ Se((e, t) => {
  const { forceMount: n, ...r } = e, a = Vt(an, e.__scopeScrollArea), { onScrollbarXEnabledChange: i, onScrollbarYEnabledChange: o } = a, l = e.orientation === "horizontal";
  return re(() => (l ? i(!0) : o(!0), () => {
    l ? i(!1) : o(!1);
  }), [
    l,
    i,
    o
  ]), a.type === "hover" ? /* @__PURE__ */ se(O_, be({}, r, {
    ref: t,
    forceMount: n
  })) : a.type === "scroll" ? /* @__PURE__ */ se(z_, be({}, r, {
    ref: t,
    forceMount: n
  })) : a.type === "auto" ? /* @__PURE__ */ se(zg, be({}, r, {
    ref: t,
    forceMount: n
  })) : a.type === "always" ? /* @__PURE__ */ se(h1, be({}, r, {
    ref: t
  })) : null;
}), O_ = /* @__PURE__ */ Se((e, t) => {
  const { forceMount: n, ...r } = e, a = Vt(an, e.__scopeScrollArea), [i, o] = ne(!1);
  return re(() => {
    const l = a.scrollArea;
    let s = 0;
    if (l) {
      const u = () => {
        window.clearTimeout(s), o(!0);
      }, f = () => {
        s = window.setTimeout(
          () => o(!1),
          a.scrollHideDelay
        );
      };
      return l.addEventListener("pointerenter", u), l.addEventListener("pointerleave", f), () => {
        window.clearTimeout(s), l.removeEventListener("pointerenter", u), l.removeEventListener("pointerleave", f);
      };
    }
  }, [
    a.scrollArea,
    a.scrollHideDelay
  ]), /* @__PURE__ */ se(ca, {
    present: n || i
  }, /* @__PURE__ */ se(zg, be({
    "data-state": i ? "visible" : "hidden"
  }, r, {
    ref: t
  })));
}), z_ = /* @__PURE__ */ Se((e, t) => {
  const { forceMount: n, ...r } = e, a = Vt(an, e.__scopeScrollArea), i = e.orientation === "horizontal", o = so(
    () => s("SCROLL_END"),
    100
  ), [l, s] = P_("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return re(() => {
    if (l === "idle") {
      const u = window.setTimeout(
        () => s("HIDE"),
        a.scrollHideDelay
      );
      return () => window.clearTimeout(u);
    }
  }, [
    l,
    a.scrollHideDelay,
    s
  ]), re(() => {
    const u = a.viewport, f = i ? "scrollLeft" : "scrollTop";
    if (u) {
      let h = u[f];
      const g = () => {
        const v = u[f];
        h !== v && (s("SCROLL"), o()), h = v;
      };
      return u.addEventListener("scroll", g), () => u.removeEventListener("scroll", g);
    }
  }, [
    a.viewport,
    i,
    s,
    o
  ]), /* @__PURE__ */ se(ca, {
    present: n || l !== "hidden"
  }, /* @__PURE__ */ se(h1, be({
    "data-state": l === "hidden" ? "hidden" : "visible"
  }, r, {
    ref: t,
    onPointerEnter: Be(
      e.onPointerEnter,
      () => s("POINTER_ENTER")
    ),
    onPointerLeave: Be(
      e.onPointerLeave,
      () => s("POINTER_LEAVE")
    )
  })));
}), zg = /* @__PURE__ */ Se((e, t) => {
  const n = Vt(an, e.__scopeScrollArea), { forceMount: r, ...a } = e, [i, o] = ne(!1), l = e.orientation === "horizontal", s = so(() => {
    if (n.viewport) {
      const u = n.viewport.offsetWidth < n.viewport.scrollWidth, f = n.viewport.offsetHeight < n.viewport.scrollHeight;
      o(l ? u : f);
    }
  }, 10);
  return Ai(n.viewport, s), Ai(n.content, s), /* @__PURE__ */ se(ca, {
    present: r || i
  }, /* @__PURE__ */ se(h1, be({
    "data-state": i ? "visible" : "hidden"
  }, a, {
    ref: t
  })));
}), h1 = /* @__PURE__ */ Se((e, t) => {
  const { orientation: n = "vertical", ...r } = e, a = Vt(an, e.__scopeScrollArea), i = J(null), o = J(0), [l, s] = ne({
    content: 0,
    viewport: 0,
    scrollbar: {
      size: 0,
      paddingStart: 0,
      paddingEnd: 0
    }
  }), u = Lg(l.viewport, l.content), f = {
    ...r,
    sizes: l,
    onSizesChange: s,
    hasThumb: u > 0 && u < 1,
    onThumbChange: (g) => i.current = g,
    onThumbPointerUp: () => o.current = 0,
    onThumbPointerDown: (g) => o.current = g
  };
  function h(g, v) {
    return N_(g, o.current, l, v);
  }
  return n === "horizontal" ? /* @__PURE__ */ se(M_, be({}, f, {
    ref: t,
    onThumbPositionChange: () => {
      if (a.viewport && i.current) {
        const g = a.viewport.scrollLeft, v = Dp(g, l, a.dir);
        i.current.style.transform = `translate3d(${v}px, 0, 0)`;
      }
    },
    onWheelScroll: (g) => {
      a.viewport && (a.viewport.scrollLeft = g);
    },
    onDragScroll: (g) => {
      a.viewport && (a.viewport.scrollLeft = h(g, a.dir));
    }
  })) : n === "vertical" ? /* @__PURE__ */ se(__, be({}, f, {
    ref: t,
    onThumbPositionChange: () => {
      if (a.viewport && i.current) {
        const g = a.viewport.scrollTop, v = Dp(g, l);
        i.current.style.transform = `translate3d(0, ${v}px, 0)`;
      }
    },
    onWheelScroll: (g) => {
      a.viewport && (a.viewport.scrollTop = g);
    },
    onDragScroll: (g) => {
      a.viewport && (a.viewport.scrollTop = h(g));
    }
  })) : null;
}), M_ = /* @__PURE__ */ Se((e, t) => {
  const { sizes: n, onSizesChange: r, ...a } = e, i = Vt(an, e.__scopeScrollArea), [o, l] = ne(), s = J(null), u = Fe(t, s, i.onScrollbarXChange);
  return re(() => {
    s.current && l(getComputedStyle(s.current));
  }, [
    s
  ]), /* @__PURE__ */ se(_g, be({
    "data-orientation": "horizontal"
  }, a, {
    ref: u,
    sizes: n,
    style: {
      bottom: 0,
      left: i.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
      right: i.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
      "--radix-scroll-area-thumb-width": lo(n) + "px",
      ...e.style
    },
    onThumbPointerDown: (f) => e.onThumbPointerDown(f.x),
    onDragScroll: (f) => e.onDragScroll(f.x),
    onWheelScroll: (f, h) => {
      if (i.viewport) {
        const g = i.viewport.scrollLeft + f.deltaX;
        e.onWheelScroll(g), Dg(g, h) && f.preventDefault();
      }
    },
    onResize: () => {
      s.current && i.viewport && o && r({
        content: i.viewport.scrollWidth,
        viewport: i.viewport.offsetWidth,
        scrollbar: {
          size: s.current.clientWidth,
          paddingStart: Ti(o.paddingLeft),
          paddingEnd: Ti(o.paddingRight)
        }
      });
    }
  }));
}), __ = /* @__PURE__ */ Se((e, t) => {
  const { sizes: n, onSizesChange: r, ...a } = e, i = Vt(an, e.__scopeScrollArea), [o, l] = ne(), s = J(null), u = Fe(t, s, i.onScrollbarYChange);
  return re(() => {
    s.current && l(getComputedStyle(s.current));
  }, [
    s
  ]), /* @__PURE__ */ se(_g, be({
    "data-orientation": "vertical"
  }, a, {
    ref: u,
    sizes: n,
    style: {
      top: 0,
      right: i.dir === "ltr" ? 0 : void 0,
      left: i.dir === "rtl" ? 0 : void 0,
      bottom: "var(--radix-scroll-area-corner-height)",
      "--radix-scroll-area-thumb-height": lo(n) + "px",
      ...e.style
    },
    onThumbPointerDown: (f) => e.onThumbPointerDown(f.y),
    onDragScroll: (f) => e.onDragScroll(f.y),
    onWheelScroll: (f, h) => {
      if (i.viewport) {
        const g = i.viewport.scrollTop + f.deltaY;
        e.onWheelScroll(g), Dg(g, h) && f.preventDefault();
      }
    },
    onResize: () => {
      s.current && i.viewport && o && r({
        content: i.viewport.scrollHeight,
        viewport: i.viewport.offsetHeight,
        scrollbar: {
          size: s.current.clientHeight,
          paddingStart: Ti(o.paddingTop),
          paddingEnd: Ti(o.paddingBottom)
        }
      });
    }
  }));
}), [L_, Mg] = Og(an), _g = /* @__PURE__ */ Se((e, t) => {
  const { __scopeScrollArea: n, sizes: r, hasThumb: a, onThumbChange: i, onThumbPointerUp: o, onThumbPointerDown: l, onThumbPositionChange: s, onDragScroll: u, onWheelScroll: f, onResize: h, ...g } = e, v = Vt(an, n), [E, b] = ne(null), w = Fe(
    t,
    (p) => b(p)
  ), S = J(null), T = J(""), A = v.viewport, V = r.content - r.viewport, $ = et(f), _ = et(s), y = so(h, 10);
  function c(p) {
    if (S.current) {
      const d = p.clientX - S.current.left, m = p.clientY - S.current.top;
      u({
        x: d,
        y: m
      });
    }
  }
  return re(() => {
    const p = (d) => {
      const m = d.target;
      (E == null ? void 0 : E.contains(m)) && $(d, V);
    };
    return document.addEventListener("wheel", p, {
      passive: !1
    }), () => document.removeEventListener("wheel", p, {
      passive: !1
    });
  }, [
    A,
    E,
    V,
    $
  ]), re(_, [
    r,
    _
  ]), Ai(E, y), Ai(v.content, y), /* @__PURE__ */ se(L_, {
    scope: n,
    scrollbar: E,
    hasThumb: a,
    onThumbChange: et(i),
    onThumbPointerUp: et(o),
    onThumbPositionChange: _,
    onThumbPointerDown: et(l)
  }, /* @__PURE__ */ se(Je.div, be({}, g, {
    ref: w,
    style: {
      position: "absolute",
      ...g.style
    },
    onPointerDown: Be(e.onPointerDown, (p) => {
      p.button === 0 && (p.target.setPointerCapture(p.pointerId), S.current = E.getBoundingClientRect(), T.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", v.viewport && (v.viewport.style.scrollBehavior = "auto"), c(p));
    }),
    onPointerMove: Be(e.onPointerMove, c),
    onPointerUp: Be(e.onPointerUp, (p) => {
      const d = p.target;
      d.hasPointerCapture(p.pointerId) && d.releasePointerCapture(p.pointerId), document.body.style.webkitUserSelect = T.current, v.viewport && (v.viewport.style.scrollBehavior = ""), S.current = null;
    })
  })));
}), Cc = "ScrollAreaThumb", I_ = /* @__PURE__ */ Se((e, t) => {
  const { forceMount: n, ...r } = e, a = Mg(Cc, e.__scopeScrollArea);
  return /* @__PURE__ */ se(ca, {
    present: n || a.hasThumb
  }, /* @__PURE__ */ se(D_, be({
    ref: t
  }, r)));
}), D_ = /* @__PURE__ */ Se((e, t) => {
  const { __scopeScrollArea: n, style: r, ...a } = e, i = Vt(Cc, n), o = Mg(Cc, n), { onThumbPositionChange: l } = o, s = Fe(
    t,
    (h) => o.onThumbChange(h)
  ), u = J(), f = so(() => {
    u.current && (u.current(), u.current = void 0);
  }, 100);
  return re(() => {
    const h = i.viewport;
    if (h) {
      const g = () => {
        if (f(), !u.current) {
          const v = R_(h, l);
          u.current = v, l();
        }
      };
      return l(), h.addEventListener("scroll", g), () => h.removeEventListener("scroll", g);
    }
  }, [
    i.viewport,
    f,
    l
  ]), /* @__PURE__ */ se(Je.div, be({
    "data-state": o.hasThumb ? "visible" : "hidden"
  }, a, {
    ref: s,
    style: {
      width: "var(--radix-scroll-area-thumb-width)",
      height: "var(--radix-scroll-area-thumb-height)",
      ...r
    },
    onPointerDownCapture: Be(e.onPointerDownCapture, (h) => {
      const v = h.target.getBoundingClientRect(), E = h.clientX - v.left, b = h.clientY - v.top;
      o.onThumbPointerDown({
        x: E,
        y: b
      });
    }),
    onPointerUp: Be(e.onPointerUp, o.onThumbPointerUp)
  }));
});
function Ti(e) {
  return e ? parseInt(e, 10) : 0;
}
function Lg(e, t) {
  const n = e / t;
  return isNaN(n) ? 0 : n;
}
function lo(e) {
  const t = Lg(e.viewport, e.content), n = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, r = (e.scrollbar.size - n) * t;
  return Math.max(r, 18);
}
function N_(e, t, n, r = "ltr") {
  const a = lo(n), i = a / 2, o = t || i, l = a - o, s = n.scrollbar.paddingStart + o, u = n.scrollbar.size - n.scrollbar.paddingEnd - l, f = n.content - n.viewport, h = r === "ltr" ? [
    0,
    f
  ] : [
    f * -1,
    0
  ];
  return Ig([
    s,
    u
  ], h)(e);
}
function Dp(e, t, n = "ltr") {
  const r = lo(t), a = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, i = t.scrollbar.size - a, o = t.content - t.viewport, l = i - r, s = n === "ltr" ? [
    0,
    o
  ] : [
    o * -1,
    0
  ], u = Pc(e, s);
  return Ig([
    0,
    o
  ], [
    0,
    l
  ])(u);
}
function Ig(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1])
      return t[0];
    const r = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + r * (n - e[0]);
  };
}
function Dg(e, t) {
  return e > 0 && e < t;
}
const R_ = (e, t = () => {
}) => {
  let n = {
    left: e.scrollLeft,
    top: e.scrollTop
  }, r = 0;
  return function a() {
    const i = {
      left: e.scrollLeft,
      top: e.scrollTop
    }, o = n.left !== i.left, l = n.top !== i.top;
    (o || l) && t(), n = i, r = window.requestAnimationFrame(a);
  }(), () => window.cancelAnimationFrame(r);
};
function so(e, t) {
  const n = et(e), r = J(0);
  return re(
    () => () => window.clearTimeout(r.current),
    []
  ), he(() => {
    window.clearTimeout(r.current), r.current = window.setTimeout(n, t);
  }, [
    n,
    t
  ]);
}
function Ai(e, t) {
  const n = et(t);
  Pt(() => {
    let r = 0;
    if (e) {
      const a = new ResizeObserver(() => {
        cancelAnimationFrame(r), r = window.requestAnimationFrame(n);
      });
      return a.observe(e), () => {
        window.cancelAnimationFrame(r), a.unobserve(e);
      };
    }
  }, [
    e,
    n
  ]);
}
const B_ = S_, V_ = T_, F_ = I_;
function H_(e) {
  const t = e + "CollectionProvider", [n, r] = oo(t), [a, i] = n(t, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), o = (v) => {
    const { scope: E, children: b } = v, w = oe.useRef(null), S = oe.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ oe.createElement(a, {
      scope: E,
      itemMap: S,
      collectionRef: w
    }, b);
  }, l = e + "CollectionSlot", s = /* @__PURE__ */ oe.forwardRef((v, E) => {
    const { scope: b, children: w } = v, S = i(l, b), T = Fe(E, S.collectionRef);
    return /* @__PURE__ */ oe.createElement(ea, {
      ref: T
    }, w);
  }), u = e + "CollectionItemSlot", f = "data-radix-collection-item", h = /* @__PURE__ */ oe.forwardRef((v, E) => {
    const { scope: b, children: w, ...S } = v, T = oe.useRef(null), A = Fe(E, T), V = i(u, b);
    return oe.useEffect(() => (V.itemMap.set(T, {
      ref: T,
      ...S
    }), () => void V.itemMap.delete(T))), /* @__PURE__ */ oe.createElement(ea, {
      [f]: "",
      ref: A
    }, w);
  });
  function g(v) {
    const E = i(e + "CollectionConsumer", v);
    return oe.useCallback(() => {
      const w = E.collectionRef.current;
      if (!w)
        return [];
      const S = Array.from(w.querySelectorAll(`[${f}]`));
      return Array.from(E.itemMap.values()).sort(
        (V, $) => S.indexOf(V.ref.current) - S.indexOf($.ref.current)
      );
    }, [
      E.collectionRef,
      E.itemMap
    ]);
  }
  return [
    {
      Provider: o,
      Slot: s,
      ItemSlot: h
    },
    g,
    r
  ];
}
function K_(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = et(e);
  re(() => {
    const r = (a) => {
      a.key === "Escape" && n(a);
    };
    return t.addEventListener("keydown", r), () => t.removeEventListener("keydown", r);
  }, [
    n,
    t
  ]);
}
const Sc = "dismissableLayer.update", j_ = "dismissableLayer.pointerDownOutside", U_ = "dismissableLayer.focusOutside";
let Np;
const W_ = /* @__PURE__ */ Ze({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), q_ = /* @__PURE__ */ Se((e, t) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: a, onPointerDownOutside: i, onFocusOutside: o, onInteractOutside: l, onDismiss: s, ...u } = e, f = ze(W_), [h, g] = ne(null), v = (n = h == null ? void 0 : h.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, E] = ne({}), b = Fe(
    t,
    (c) => g(c)
  ), w = Array.from(f.layers), [S] = [
    ...f.layersWithOutsidePointerEventsDisabled
  ].slice(-1), T = w.indexOf(S), A = h ? w.indexOf(h) : -1, V = f.layersWithOutsidePointerEventsDisabled.size > 0, $ = A >= T, _ = Z_((c) => {
    const p = c.target, d = [
      ...f.branches
    ].some(
      (m) => m.contains(p)
    );
    !$ || d || (i == null || i(c), l == null || l(c), c.defaultPrevented || s == null || s());
  }, v), y = G_((c) => {
    const p = c.target;
    [
      ...f.branches
    ].some(
      (m) => m.contains(p)
    ) || (o == null || o(c), l == null || l(c), c.defaultPrevented || s == null || s());
  }, v);
  return K_((c) => {
    A === f.layers.size - 1 && (a == null || a(c), !c.defaultPrevented && s && (c.preventDefault(), s()));
  }, v), re(() => {
    if (h)
      return r && (f.layersWithOutsidePointerEventsDisabled.size === 0 && (Np = v.body.style.pointerEvents, v.body.style.pointerEvents = "none"), f.layersWithOutsidePointerEventsDisabled.add(h)), f.layers.add(h), Rp(), () => {
        r && f.layersWithOutsidePointerEventsDisabled.size === 1 && (v.body.style.pointerEvents = Np);
      };
  }, [
    h,
    v,
    r,
    f
  ]), re(() => () => {
    h && (f.layers.delete(h), f.layersWithOutsidePointerEventsDisabled.delete(h), Rp());
  }, [
    h,
    f
  ]), re(() => {
    const c = () => E({});
    return document.addEventListener(Sc, c), () => document.removeEventListener(Sc, c);
  }, []), /* @__PURE__ */ se(Je.div, be({}, u, {
    ref: b,
    style: {
      pointerEvents: V ? $ ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: Be(e.onFocusCapture, y.onFocusCapture),
    onBlurCapture: Be(e.onBlurCapture, y.onBlurCapture),
    onPointerDownCapture: Be(e.onPointerDownCapture, _.onPointerDownCapture)
  }));
});
function Z_(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = et(e), r = J(!1), a = J(() => {
  });
  return re(() => {
    const i = (l) => {
      if (l.target && !r.current) {
        let u = function() {
          Ng(j_, n, s, {
            discrete: !0
          });
        };
        const s = {
          originalEvent: l
        };
        l.pointerType === "touch" ? (t.removeEventListener("click", a.current), a.current = u, t.addEventListener("click", a.current, {
          once: !0
        })) : u();
      }
      r.current = !1;
    }, o = window.setTimeout(() => {
      t.addEventListener("pointerdown", i);
    }, 0);
    return () => {
      window.clearTimeout(o), t.removeEventListener("pointerdown", i), t.removeEventListener("click", a.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function G_(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = et(e), r = J(!1);
  return re(() => {
    const a = (i) => {
      i.target && !r.current && Ng(U_, n, {
        originalEvent: i
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", a), () => t.removeEventListener("focusin", a);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function Rp() {
  const e = new CustomEvent(Sc);
  document.dispatchEvent(e);
}
function Ng(e, t, n, { discrete: r }) {
  const a = n.originalEvent.target, i = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && a.addEventListener(e, t, {
    once: !0
  }), r ? b_(a, i) : a.dispatchEvent(i);
}
let Fs = 0;
function Y_() {
  re(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : Bp()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : Bp()), Fs++, () => {
      Fs === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), Fs--;
    };
  }, []);
}
function Bp() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
const Hs = "focusScope.autoFocusOnMount", Ks = "focusScope.autoFocusOnUnmount", Vp = {
  bubbles: !1,
  cancelable: !0
}, X_ = /* @__PURE__ */ Se((e, t) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: a, onUnmountAutoFocus: i, ...o } = e, [l, s] = ne(null), u = et(a), f = et(i), h = J(null), g = Fe(
    t,
    (b) => s(b)
  ), v = J({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  re(() => {
    if (r) {
      let b = function(A) {
        if (v.paused || !l)
          return;
        const V = A.target;
        l.contains(V) ? h.current = V : un(h.current, {
          select: !0
        });
      }, w = function(A) {
        if (v.paused || !l)
          return;
        const V = A.relatedTarget;
        V !== null && (l.contains(V) || un(h.current, {
          select: !0
        }));
      }, S = function(A) {
        const V = document.activeElement;
        for (const $ of A)
          $.removedNodes.length > 0 && (l != null && l.contains(V) || un(l));
      };
      document.addEventListener("focusin", b), document.addEventListener("focusout", w);
      const T = new MutationObserver(S);
      return l && T.observe(l, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", b), document.removeEventListener("focusout", w), T.disconnect();
      };
    }
  }, [
    r,
    l,
    v.paused
  ]), re(() => {
    if (l) {
      Hp.add(v);
      const b = document.activeElement;
      if (!l.contains(b)) {
        const S = new CustomEvent(Hs, Vp);
        l.addEventListener(Hs, u), l.dispatchEvent(S), S.defaultPrevented || (J_(rL(Rg(l)), {
          select: !0
        }), document.activeElement === b && un(l));
      }
      return () => {
        l.removeEventListener(Hs, u), setTimeout(() => {
          const S = new CustomEvent(Ks, Vp);
          l.addEventListener(Ks, f), l.dispatchEvent(S), S.defaultPrevented || un(b ?? document.body, {
            select: !0
          }), l.removeEventListener(Ks, f), Hp.remove(v);
        }, 0);
      };
    }
  }, [
    l,
    u,
    f,
    v
  ]);
  const E = he((b) => {
    if (!n && !r || v.paused)
      return;
    const w = b.key === "Tab" && !b.altKey && !b.ctrlKey && !b.metaKey, S = document.activeElement;
    if (w && S) {
      const T = b.currentTarget, [A, V] = Q_(T);
      A && V ? !b.shiftKey && S === V ? (b.preventDefault(), n && un(A, {
        select: !0
      })) : b.shiftKey && S === A && (b.preventDefault(), n && un(V, {
        select: !0
      })) : S === T && b.preventDefault();
    }
  }, [
    n,
    r,
    v.paused
  ]);
  return /* @__PURE__ */ se(Je.div, be({
    tabIndex: -1
  }, o, {
    ref: g,
    onKeyDown: E
  }));
});
function J_(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (un(r, {
      select: t
    }), document.activeElement !== n)
      return;
}
function Q_(e) {
  const t = Rg(e), n = Fp(t, e), r = Fp(t.reverse(), e);
  return [
    n,
    r
  ];
}
function Rg(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const a = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || a ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function Fp(e, t) {
  for (const n of e)
    if (!eL(n, {
      upTo: t
    }))
      return n;
}
function eL(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function tL(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function un(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && tL(e) && t && e.select();
  }
}
const Hp = nL();
function nL() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Kp(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Kp(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function Kp(e, t) {
  const n = [
    ...e
  ], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function rL(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const aL = ue["useId".toString()] || (() => {
});
let iL = 0;
function Bg(e) {
  const [t, n] = ue.useState(aL());
  return Pt(() => {
    e || n(
      (r) => r ?? String(iL++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
const oL = ["top", "right", "bottom", "left"], mn = Math.min, ht = Math.max, Oi = Math.round, Qa = Math.floor, gn = (e) => ({
  x: e,
  y: e
}), lL = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, sL = {
  start: "end",
  end: "start"
};
function kc(e, t, n) {
  return ht(e, mn(t, n));
}
function Xt(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Jt(e) {
  return e.split("-")[0];
}
function yr(e) {
  return e.split("-")[1];
}
function v1(e) {
  return e === "x" ? "y" : "x";
}
function m1(e) {
  return e === "y" ? "height" : "width";
}
function br(e) {
  return ["top", "bottom"].includes(Jt(e)) ? "y" : "x";
}
function g1(e) {
  return v1(br(e));
}
function cL(e, t, n) {
  n === void 0 && (n = !1);
  const r = yr(e), a = g1(e), i = m1(a);
  let o = a === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[i] > t.floating[i] && (o = zi(o)), [o, zi(o)];
}
function uL(e) {
  const t = zi(e);
  return [Tc(e), t, Tc(t)];
}
function Tc(e) {
  return e.replace(/start|end/g, (t) => sL[t]);
}
function dL(e, t, n) {
  const r = ["left", "right"], a = ["right", "left"], i = ["top", "bottom"], o = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? a : r : t ? r : a;
    case "left":
    case "right":
      return t ? i : o;
    default:
      return [];
  }
}
function fL(e, t, n, r) {
  const a = yr(e);
  let i = dL(Jt(e), n === "start", r);
  return a && (i = i.map((o) => o + "-" + a), t && (i = i.concat(i.map(Tc)))), i;
}
function zi(e) {
  return e.replace(/left|right|bottom|top/g, (t) => lL[t]);
}
function pL(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Vg(e) {
  return typeof e != "number" ? pL(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Mi(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function jp(e, t, n) {
  let {
    reference: r,
    floating: a
  } = e;
  const i = br(t), o = g1(t), l = m1(o), s = Jt(t), u = i === "y", f = r.x + r.width / 2 - a.width / 2, h = r.y + r.height / 2 - a.height / 2, g = r[l] / 2 - a[l] / 2;
  let v;
  switch (s) {
    case "top":
      v = {
        x: f,
        y: r.y - a.height
      };
      break;
    case "bottom":
      v = {
        x: f,
        y: r.y + r.height
      };
      break;
    case "right":
      v = {
        x: r.x + r.width,
        y: h
      };
      break;
    case "left":
      v = {
        x: r.x - a.width,
        y: h
      };
      break;
    default:
      v = {
        x: r.x,
        y: r.y
      };
  }
  switch (yr(t)) {
    case "start":
      v[o] -= g * (n && u ? -1 : 1);
      break;
    case "end":
      v[o] += g * (n && u ? -1 : 1);
      break;
  }
  return v;
}
const hL = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: a = "absolute",
    middleware: i = [],
    platform: o
  } = n, l = i.filter(Boolean), s = await (o.isRTL == null ? void 0 : o.isRTL(t));
  let u = await o.getElementRects({
    reference: e,
    floating: t,
    strategy: a
  }), {
    x: f,
    y: h
  } = jp(u, r, s), g = r, v = {}, E = 0;
  for (let b = 0; b < l.length; b++) {
    const {
      name: w,
      fn: S
    } = l[b], {
      x: T,
      y: A,
      data: V,
      reset: $
    } = await S({
      x: f,
      y: h,
      initialPlacement: r,
      placement: g,
      strategy: a,
      middlewareData: v,
      rects: u,
      platform: o,
      elements: {
        reference: e,
        floating: t
      }
    });
    if (f = T ?? f, h = A ?? h, v = {
      ...v,
      [w]: {
        ...v[w],
        ...V
      }
    }, $ && E <= 50) {
      E++, typeof $ == "object" && ($.placement && (g = $.placement), $.rects && (u = $.rects === !0 ? await o.getElementRects({
        reference: e,
        floating: t,
        strategy: a
      }) : $.rects), {
        x: f,
        y: h
      } = jp(u, g, s)), b = -1;
      continue;
    }
  }
  return {
    x: f,
    y: h,
    placement: g,
    strategy: a,
    middlewareData: v
  };
};
async function ta(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: a,
    platform: i,
    rects: o,
    elements: l,
    strategy: s
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: h = "floating",
    altBoundary: g = !1,
    padding: v = 0
  } = Xt(t, e), E = Vg(v), w = l[g ? h === "floating" ? "reference" : "floating" : h], S = Mi(await i.getClippingRect({
    element: (n = await (i.isElement == null ? void 0 : i.isElement(w))) == null || n ? w : w.contextElement || await (i.getDocumentElement == null ? void 0 : i.getDocumentElement(l.floating)),
    boundary: u,
    rootBoundary: f,
    strategy: s
  })), T = h === "floating" ? {
    ...o.floating,
    x: r,
    y: a
  } : o.reference, A = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(l.floating)), V = await (i.isElement == null ? void 0 : i.isElement(A)) ? await (i.getScale == null ? void 0 : i.getScale(A)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, $ = Mi(i.convertOffsetParentRelativeRectToViewportRelativeRect ? await i.convertOffsetParentRelativeRectToViewportRelativeRect({
    rect: T,
    offsetParent: A,
    strategy: s
  }) : T);
  return {
    top: (S.top - $.top + E.top) / V.y,
    bottom: ($.bottom - S.bottom + E.bottom) / V.y,
    left: (S.left - $.left + E.left) / V.x,
    right: ($.right - S.right + E.right) / V.x
  };
}
const Up = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: a,
      rects: i,
      platform: o,
      elements: l
    } = t, {
      element: s,
      padding: u = 0
    } = Xt(e, t) || {};
    if (s == null)
      return {};
    const f = Vg(u), h = {
      x: n,
      y: r
    }, g = g1(a), v = m1(g), E = await o.getDimensions(s), b = g === "y", w = b ? "top" : "left", S = b ? "bottom" : "right", T = b ? "clientHeight" : "clientWidth", A = i.reference[v] + i.reference[g] - h[g] - i.floating[v], V = h[g] - i.reference[g], $ = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(s));
    let _ = $ ? $[T] : 0;
    (!_ || !await (o.isElement == null ? void 0 : o.isElement($))) && (_ = l.floating[T] || i.floating[v]);
    const y = A / 2 - V / 2, c = _ / 2 - E[v] / 2 - 1, p = mn(f[w], c), d = mn(f[S], c), m = p, O = _ - E[v] - d, x = _ / 2 - E[v] / 2 + y, P = kc(m, x, O), D = yr(a) != null && x != P && i.reference[v] / 2 - (x < m ? p : d) - E[v] / 2 < 0 ? x < m ? m - x : O - x : 0;
    return {
      [g]: h[g] - D,
      data: {
        [g]: P,
        centerOffset: x - P + D
      }
    };
  }
}), vL = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n;
      const {
        placement: r,
        middlewareData: a,
        rects: i,
        initialPlacement: o,
        platform: l,
        elements: s
      } = t, {
        mainAxis: u = !0,
        crossAxis: f = !0,
        fallbackPlacements: h,
        fallbackStrategy: g = "bestFit",
        fallbackAxisSideDirection: v = "none",
        flipAlignment: E = !0,
        ...b
      } = Xt(e, t), w = Jt(r), S = Jt(o) === o, T = await (l.isRTL == null ? void 0 : l.isRTL(s.floating)), A = h || (S || !E ? [zi(o)] : uL(o));
      !h && v !== "none" && A.push(...fL(o, E, v, T));
      const V = [o, ...A], $ = await ta(t, b), _ = [];
      let y = ((n = a.flip) == null ? void 0 : n.overflows) || [];
      if (u && _.push($[w]), f) {
        const m = cL(r, i, T);
        _.push($[m[0]], $[m[1]]);
      }
      if (y = [...y, {
        placement: r,
        overflows: _
      }], !_.every((m) => m <= 0)) {
        var c, p;
        const m = (((c = a.flip) == null ? void 0 : c.index) || 0) + 1, O = V[m];
        if (O)
          return {
            data: {
              index: m,
              overflows: y
            },
            reset: {
              placement: O
            }
          };
        let x = (p = y.filter((P) => P.overflows[0] <= 0).sort((P, N) => P.overflows[1] - N.overflows[1])[0]) == null ? void 0 : p.placement;
        if (!x)
          switch (g) {
            case "bestFit": {
              var d;
              const P = (d = y.map((N) => [N.placement, N.overflows.filter((D) => D > 0).reduce((D, I) => D + I, 0)]).sort((N, D) => N[1] - D[1])[0]) == null ? void 0 : d[0];
              P && (x = P);
              break;
            }
            case "initialPlacement":
              x = o;
              break;
          }
        if (r !== x)
          return {
            reset: {
              placement: x
            }
          };
      }
      return {};
    }
  };
};
function Wp(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function qp(e) {
  return oL.some((t) => e[t] >= 0);
}
const mL = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...a
      } = Xt(e, t);
      switch (r) {
        case "referenceHidden": {
          const i = await ta(t, {
            ...a,
            elementContext: "reference"
          }), o = Wp(i, n.reference);
          return {
            data: {
              referenceHiddenOffsets: o,
              referenceHidden: qp(o)
            }
          };
        }
        case "escaped": {
          const i = await ta(t, {
            ...a,
            altBoundary: !0
          }), o = Wp(i, n.floating);
          return {
            data: {
              escapedOffsets: o,
              escaped: qp(o)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function gL(e, t) {
  const {
    placement: n,
    platform: r,
    elements: a
  } = e, i = await (r.isRTL == null ? void 0 : r.isRTL(a.floating)), o = Jt(n), l = yr(n), s = br(n) === "y", u = ["left", "top"].includes(o) ? -1 : 1, f = i && s ? -1 : 1, h = Xt(t, e);
  let {
    mainAxis: g,
    crossAxis: v,
    alignmentAxis: E
  } = typeof h == "number" ? {
    mainAxis: h,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...h
  };
  return l && typeof E == "number" && (v = l === "end" ? E * -1 : E), s ? {
    x: v * f,
    y: g * u
  } : {
    x: g * u,
    y: v * f
  };
}
const yL = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r
      } = t, a = await gL(t, e);
      return {
        x: n + a.x,
        y: r + a.y,
        data: a
      };
    }
  };
}, bL = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: a
      } = t, {
        mainAxis: i = !0,
        crossAxis: o = !1,
        limiter: l = {
          fn: (w) => {
            let {
              x: S,
              y: T
            } = w;
            return {
              x: S,
              y: T
            };
          }
        },
        ...s
      } = Xt(e, t), u = {
        x: n,
        y: r
      }, f = await ta(t, s), h = br(Jt(a)), g = v1(h);
      let v = u[g], E = u[h];
      if (i) {
        const w = g === "y" ? "top" : "left", S = g === "y" ? "bottom" : "right", T = v + f[w], A = v - f[S];
        v = kc(T, v, A);
      }
      if (o) {
        const w = h === "y" ? "top" : "left", S = h === "y" ? "bottom" : "right", T = E + f[w], A = E - f[S];
        E = kc(T, E, A);
      }
      const b = l.fn({
        ...t,
        [g]: v,
        [h]: E
      });
      return {
        ...b,
        data: {
          x: b.x - n,
          y: b.y - r
        }
      };
    }
  };
}, wL = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: a,
        rects: i,
        middlewareData: o
      } = t, {
        offset: l = 0,
        mainAxis: s = !0,
        crossAxis: u = !0
      } = Xt(e, t), f = {
        x: n,
        y: r
      }, h = br(a), g = v1(h);
      let v = f[g], E = f[h];
      const b = Xt(l, t), w = typeof b == "number" ? {
        mainAxis: b,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...b
      };
      if (s) {
        const A = g === "y" ? "height" : "width", V = i.reference[g] - i.floating[A] + w.mainAxis, $ = i.reference[g] + i.reference[A] - w.mainAxis;
        v < V ? v = V : v > $ && (v = $);
      }
      if (u) {
        var S, T;
        const A = g === "y" ? "width" : "height", V = ["top", "left"].includes(Jt(a)), $ = i.reference[h] - i.floating[A] + (V && ((S = o.offset) == null ? void 0 : S[h]) || 0) + (V ? 0 : w.crossAxis), _ = i.reference[h] + i.reference[A] + (V ? 0 : ((T = o.offset) == null ? void 0 : T[h]) || 0) - (V ? w.crossAxis : 0);
        E < $ ? E = $ : E > _ && (E = _);
      }
      return {
        [g]: v,
        [h]: E
      };
    }
  };
}, xL = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      const {
        placement: n,
        rects: r,
        platform: a,
        elements: i
      } = t, {
        apply: o = () => {
        },
        ...l
      } = Xt(e, t), s = await ta(t, l), u = Jt(n), f = yr(n), h = br(n) === "y", {
        width: g,
        height: v
      } = r.floating;
      let E, b;
      u === "top" || u === "bottom" ? (E = u, b = f === (await (a.isRTL == null ? void 0 : a.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (b = u, E = f === "end" ? "top" : "bottom");
      const w = v - s[E], S = g - s[b], T = !t.middlewareData.shift;
      let A = w, V = S;
      if (h) {
        const _ = g - s.left - s.right;
        V = f || T ? mn(S, _) : _;
      } else {
        const _ = v - s.top - s.bottom;
        A = f || T ? mn(w, _) : _;
      }
      if (T && !f) {
        const _ = ht(s.left, 0), y = ht(s.right, 0), c = ht(s.top, 0), p = ht(s.bottom, 0);
        h ? V = g - 2 * (_ !== 0 || y !== 0 ? _ + y : ht(s.left, s.right)) : A = v - 2 * (c !== 0 || p !== 0 ? c + p : ht(s.top, s.bottom));
      }
      await o({
        ...t,
        availableWidth: V,
        availableHeight: A
      });
      const $ = await a.getDimensions(i.floating);
      return g !== $.width || v !== $.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function yn(e) {
  return Fg(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function mt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function on(e) {
  var t;
  return (t = (Fg(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function Fg(e) {
  return e instanceof Node || e instanceof mt(e).Node;
}
function Qt(e) {
  return e instanceof Element || e instanceof mt(e).Element;
}
function Rt(e) {
  return e instanceof HTMLElement || e instanceof mt(e).HTMLElement;
}
function Zp(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof mt(e).ShadowRoot;
}
function ua(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: a
  } = Ct(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(a);
}
function EL(e) {
  return ["table", "td", "th"].includes(yn(e));
}
function y1(e) {
  const t = b1(), n = Ct(e);
  return n.transform !== "none" || n.perspective !== "none" || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function $L(e) {
  let t = pr(e);
  for (; Rt(t) && !co(t); ) {
    if (y1(t))
      return t;
    t = pr(t);
  }
  return null;
}
function b1() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function co(e) {
  return ["html", "body", "#document"].includes(yn(e));
}
function Ct(e) {
  return mt(e).getComputedStyle(e);
}
function uo(e) {
  return Qt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function pr(e) {
  if (yn(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    Zp(e) && e.host || // Fallback.
    on(e)
  );
  return Zp(t) ? t.host : t;
}
function Hg(e) {
  const t = pr(e);
  return co(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Rt(t) && ua(t) ? t : Hg(t);
}
function _i(e, t) {
  var n;
  t === void 0 && (t = []);
  const r = Hg(e), a = r === ((n = e.ownerDocument) == null ? void 0 : n.body), i = mt(r);
  return a ? t.concat(i, i.visualViewport || [], ua(r) ? r : []) : t.concat(r, _i(r));
}
function Kg(e) {
  const t = Ct(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const a = Rt(e), i = a ? e.offsetWidth : n, o = a ? e.offsetHeight : r, l = Oi(n) !== i || Oi(r) !== o;
  return l && (n = i, r = o), {
    width: n,
    height: r,
    $: l
  };
}
function w1(e) {
  return Qt(e) ? e : e.contextElement;
}
function ur(e) {
  const t = w1(e);
  if (!Rt(t))
    return gn(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: a,
    $: i
  } = Kg(t);
  let o = (i ? Oi(n.width) : n.width) / r, l = (i ? Oi(n.height) : n.height) / a;
  return (!o || !Number.isFinite(o)) && (o = 1), (!l || !Number.isFinite(l)) && (l = 1), {
    x: o,
    y: l
  };
}
const PL = /* @__PURE__ */ gn(0);
function jg(e) {
  const t = mt(e);
  return !b1() || !t.visualViewport ? PL : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function CL(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== mt(e) ? !1 : t;
}
function Nn(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const a = e.getBoundingClientRect(), i = w1(e);
  let o = gn(1);
  t && (r ? Qt(r) && (o = ur(r)) : o = ur(e));
  const l = CL(i, n, r) ? jg(i) : gn(0);
  let s = (a.left + l.x) / o.x, u = (a.top + l.y) / o.y, f = a.width / o.x, h = a.height / o.y;
  if (i) {
    const g = mt(i), v = r && Qt(r) ? mt(r) : r;
    let E = g.frameElement;
    for (; E && r && v !== g; ) {
      const b = ur(E), w = E.getBoundingClientRect(), S = Ct(E), T = w.left + (E.clientLeft + parseFloat(S.paddingLeft)) * b.x, A = w.top + (E.clientTop + parseFloat(S.paddingTop)) * b.y;
      s *= b.x, u *= b.y, f *= b.x, h *= b.y, s += T, u += A, E = mt(E).frameElement;
    }
  }
  return Mi({
    width: f,
    height: h,
    x: s,
    y: u
  });
}
function SL(e) {
  let {
    rect: t,
    offsetParent: n,
    strategy: r
  } = e;
  const a = Rt(n), i = on(n);
  if (n === i)
    return t;
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = gn(1);
  const s = gn(0);
  if ((a || !a && r !== "fixed") && ((yn(n) !== "body" || ua(i)) && (o = uo(n)), Rt(n))) {
    const u = Nn(n);
    l = ur(n), s.x = u.x + n.clientLeft, s.y = u.y + n.clientTop;
  }
  return {
    width: t.width * l.x,
    height: t.height * l.y,
    x: t.x * l.x - o.scrollLeft * l.x + s.x,
    y: t.y * l.y - o.scrollTop * l.y + s.y
  };
}
function kL(e) {
  return Array.from(e.getClientRects());
}
function Ug(e) {
  return Nn(on(e)).left + uo(e).scrollLeft;
}
function TL(e) {
  const t = on(e), n = uo(e), r = e.ownerDocument.body, a = ht(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), i = ht(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let o = -n.scrollLeft + Ug(e);
  const l = -n.scrollTop;
  return Ct(r).direction === "rtl" && (o += ht(t.clientWidth, r.clientWidth) - a), {
    width: a,
    height: i,
    x: o,
    y: l
  };
}
function AL(e, t) {
  const n = mt(e), r = on(e), a = n.visualViewport;
  let i = r.clientWidth, o = r.clientHeight, l = 0, s = 0;
  if (a) {
    i = a.width, o = a.height;
    const u = b1();
    (!u || u && t === "fixed") && (l = a.offsetLeft, s = a.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: l,
    y: s
  };
}
function OL(e, t) {
  const n = Nn(e, !0, t === "fixed"), r = n.top + e.clientTop, a = n.left + e.clientLeft, i = Rt(e) ? ur(e) : gn(1), o = e.clientWidth * i.x, l = e.clientHeight * i.y, s = a * i.x, u = r * i.y;
  return {
    width: o,
    height: l,
    x: s,
    y: u
  };
}
function Gp(e, t, n) {
  let r;
  if (t === "viewport")
    r = AL(e, n);
  else if (t === "document")
    r = TL(on(e));
  else if (Qt(t))
    r = OL(t, n);
  else {
    const a = jg(e);
    r = {
      ...t,
      x: t.x - a.x,
      y: t.y - a.y
    };
  }
  return Mi(r);
}
function Wg(e, t) {
  const n = pr(e);
  return n === t || !Qt(n) || co(n) ? !1 : Ct(n).position === "fixed" || Wg(n, t);
}
function zL(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = _i(e).filter((l) => Qt(l) && yn(l) !== "body"), a = null;
  const i = Ct(e).position === "fixed";
  let o = i ? pr(e) : e;
  for (; Qt(o) && !co(o); ) {
    const l = Ct(o), s = y1(o);
    !s && l.position === "fixed" && (a = null), (i ? !s && !a : !s && l.position === "static" && !!a && ["absolute", "fixed"].includes(a.position) || ua(o) && !s && Wg(e, o)) ? r = r.filter((f) => f !== o) : a = l, o = pr(o);
  }
  return t.set(e, r), r;
}
function ML(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: a
  } = e;
  const o = [...n === "clippingAncestors" ? zL(t, this._c) : [].concat(n), r], l = o[0], s = o.reduce((u, f) => {
    const h = Gp(t, f, a);
    return u.top = ht(h.top, u.top), u.right = mn(h.right, u.right), u.bottom = mn(h.bottom, u.bottom), u.left = ht(h.left, u.left), u;
  }, Gp(t, l, a));
  return {
    width: s.right - s.left,
    height: s.bottom - s.top,
    x: s.left,
    y: s.top
  };
}
function _L(e) {
  return Kg(e);
}
function LL(e, t, n) {
  const r = Rt(t), a = on(t), i = n === "fixed", o = Nn(e, !0, i, t);
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const s = gn(0);
  if (r || !r && !i)
    if ((yn(t) !== "body" || ua(a)) && (l = uo(t)), r) {
      const u = Nn(t, !0, i, t);
      s.x = u.x + t.clientLeft, s.y = u.y + t.clientTop;
    } else
      a && (s.x = Ug(a));
  return {
    x: o.left + l.scrollLeft - s.x,
    y: o.top + l.scrollTop - s.y,
    width: o.width,
    height: o.height
  };
}
function Yp(e, t) {
  return !Rt(e) || Ct(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function qg(e, t) {
  const n = mt(e);
  if (!Rt(e))
    return n;
  let r = Yp(e, t);
  for (; r && EL(r) && Ct(r).position === "static"; )
    r = Yp(r, t);
  return r && (yn(r) === "html" || yn(r) === "body" && Ct(r).position === "static" && !y1(r)) ? n : r || $L(e) || n;
}
const IL = async function(e) {
  let {
    reference: t,
    floating: n,
    strategy: r
  } = e;
  const a = this.getOffsetParent || qg, i = this.getDimensions;
  return {
    reference: LL(t, await a(n), r),
    floating: {
      x: 0,
      y: 0,
      ...await i(n)
    }
  };
};
function DL(e) {
  return Ct(e).direction === "rtl";
}
const NL = {
  convertOffsetParentRelativeRectToViewportRelativeRect: SL,
  getDocumentElement: on,
  getClippingRect: ML,
  getOffsetParent: qg,
  getElementRects: IL,
  getClientRects: kL,
  getDimensions: _L,
  getScale: ur,
  isElement: Qt,
  isRTL: DL
};
function RL(e, t) {
  let n = null, r;
  const a = on(e);
  function i() {
    clearTimeout(r), n && n.disconnect(), n = null;
  }
  function o(l, s) {
    l === void 0 && (l = !1), s === void 0 && (s = 1), i();
    const {
      left: u,
      top: f,
      width: h,
      height: g
    } = e.getBoundingClientRect();
    if (l || t(), !h || !g)
      return;
    const v = Qa(f), E = Qa(a.clientWidth - (u + h)), b = Qa(a.clientHeight - (f + g)), w = Qa(u), T = {
      rootMargin: -v + "px " + -E + "px " + -b + "px " + -w + "px",
      threshold: ht(0, mn(1, s)) || 1
    };
    let A = !0;
    function V($) {
      const _ = $[0].intersectionRatio;
      if (_ !== s) {
        if (!A)
          return o();
        _ ? o(!1, _) : r = setTimeout(() => {
          o(!1, 1e-7);
        }, 100);
      }
      A = !1;
    }
    try {
      n = new IntersectionObserver(V, {
        ...T,
        // Handle <iframe>s
        root: a.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(V, T);
    }
    n.observe(e);
  }
  return o(!0), i;
}
function BL(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: a = !0,
    ancestorResize: i = !0,
    elementResize: o = typeof ResizeObserver == "function",
    layoutShift: l = typeof IntersectionObserver == "function",
    animationFrame: s = !1
  } = r, u = w1(e), f = a || i ? [...u ? _i(u) : [], ..._i(t)] : [];
  f.forEach((S) => {
    a && S.addEventListener("scroll", n, {
      passive: !0
    }), i && S.addEventListener("resize", n);
  });
  const h = u && l ? RL(u, n) : null;
  let g = -1, v = null;
  o && (v = new ResizeObserver((S) => {
    let [T] = S;
    T && T.target === u && v && (v.unobserve(t), cancelAnimationFrame(g), g = requestAnimationFrame(() => {
      v && v.observe(t);
    })), n();
  }), u && !s && v.observe(u), v.observe(t));
  let E, b = s ? Nn(e) : null;
  s && w();
  function w() {
    const S = Nn(e);
    b && (S.x !== b.x || S.y !== b.y || S.width !== b.width || S.height !== b.height) && n(), b = S, E = requestAnimationFrame(w);
  }
  return n(), () => {
    f.forEach((S) => {
      a && S.removeEventListener("scroll", n), i && S.removeEventListener("resize", n);
    }), h && h(), v && v.disconnect(), v = null, s && cancelAnimationFrame(E);
  };
}
const VL = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), a = {
    platform: NL,
    ...n
  }, i = {
    ...a.platform,
    _c: r
  };
  return hL(e, t, {
    ...a,
    platform: i
  });
}, FL = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: a
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? Up({
        element: r.current,
        padding: a
      }).fn(n) : {} : r ? Up({
        element: r,
        padding: a
      }).fn(n) : {};
    }
  };
};
var ci = typeof document < "u" ? na : re;
function Li(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, a;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n != t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!Li(e[r], t[r]))
          return !1;
      return !0;
    }
    if (a = Object.keys(e), n = a.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, a[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const i = a[r];
      if (!(i === "_owner" && e.$$typeof) && !Li(e[i], t[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Zg(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Xp(e, t) {
  const n = Zg(e);
  return Math.round(t * n) / n;
}
function Jp(e) {
  const t = ue.useRef(e);
  return ci(() => {
    t.current = e;
  }), t;
}
function HL(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: a,
    elements: {
      reference: i,
      floating: o
    } = {},
    transform: l = !0,
    whileElementsMounted: s,
    open: u
  } = e, [f, h] = ue.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [g, v] = ue.useState(r);
  Li(g, r) || v(r);
  const [E, b] = ue.useState(null), [w, S] = ue.useState(null), T = ue.useCallback((D) => {
    D != _.current && (_.current = D, b(D));
  }, [b]), A = ue.useCallback((D) => {
    D !== y.current && (y.current = D, S(D));
  }, [S]), V = i || E, $ = o || w, _ = ue.useRef(null), y = ue.useRef(null), c = ue.useRef(f), p = Jp(s), d = Jp(a), m = ue.useCallback(() => {
    if (!_.current || !y.current)
      return;
    const D = {
      placement: t,
      strategy: n,
      middleware: g
    };
    d.current && (D.platform = d.current), VL(_.current, y.current, D).then((I) => {
      const C = {
        ...I,
        isPositioned: !0
      };
      O.current && !Li(c.current, C) && (c.current = C, ay.flushSync(() => {
        h(C);
      }));
    });
  }, [g, t, n, d]);
  ci(() => {
    u === !1 && c.current.isPositioned && (c.current.isPositioned = !1, h((D) => ({
      ...D,
      isPositioned: !1
    })));
  }, [u]);
  const O = ue.useRef(!1);
  ci(() => (O.current = !0, () => {
    O.current = !1;
  }), []), ci(() => {
    if (V && (_.current = V), $ && (y.current = $), V && $) {
      if (p.current)
        return p.current(V, $, m);
      m();
    }
  }, [V, $, m, p]);
  const x = ue.useMemo(() => ({
    reference: _,
    floating: y,
    setReference: T,
    setFloating: A
  }), [T, A]), P = ue.useMemo(() => ({
    reference: V,
    floating: $
  }), [V, $]), N = ue.useMemo(() => {
    const D = {
      position: n,
      left: 0,
      top: 0
    };
    if (!P.floating)
      return D;
    const I = Xp(P.floating, f.x), C = Xp(P.floating, f.y);
    return l ? {
      ...D,
      transform: "translate(" + I + "px, " + C + "px)",
      ...Zg(P.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: I,
      top: C
    };
  }, [n, l, P.floating, f.x, f.y]);
  return ue.useMemo(() => ({
    ...f,
    update: m,
    refs: x,
    elements: P,
    floatingStyles: N
  }), [f, m, x, P, N]);
}
function KL(e) {
  const [t, n] = ne(void 0);
  return Pt(() => {
    if (e) {
      n({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const r = new ResizeObserver((a) => {
        if (!Array.isArray(a) || !a.length)
          return;
        const i = a[0];
        let o, l;
        if ("borderBoxSize" in i) {
          const s = i.borderBoxSize, u = Array.isArray(s) ? s[0] : s;
          o = u.inlineSize, l = u.blockSize;
        } else
          o = e.offsetWidth, l = e.offsetHeight;
        n({
          width: o,
          height: l
        });
      });
      return r.observe(e, {
        box: "border-box"
      }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [
    e
  ]), t;
}
const Gg = "Popper", [Yg, Xg] = oo(Gg), [jL, Jg] = Yg(Gg), UL = (e) => {
  const { __scopePopper: t, children: n } = e, [r, a] = ne(null);
  return /* @__PURE__ */ se(jL, {
    scope: t,
    anchor: r,
    onAnchorChange: a
  }, n);
}, WL = "PopperAnchor", qL = /* @__PURE__ */ Se((e, t) => {
  const { __scopePopper: n, virtualRef: r, ...a } = e, i = Jg(WL, n), o = J(null), l = Fe(t, o);
  return re(() => {
    i.onAnchorChange((r == null ? void 0 : r.current) || o.current);
  }), r ? null : /* @__PURE__ */ se(Je.div, be({}, a, {
    ref: l
  }));
}), Qg = "PopperContent", [ZL, fN] = Yg(Qg), GL = /* @__PURE__ */ Se((e, t) => {
  var n, r, a, i, o, l, s, u;
  const { __scopePopper: f, side: h = "bottom", sideOffset: g = 0, align: v = "center", alignOffset: E = 0, arrowPadding: b = 0, collisionBoundary: w = [], collisionPadding: S = 0, sticky: T = "partial", hideWhenDetached: A = !1, avoidCollisions: V = !0, onPlaced: $, ..._ } = e, y = Jg(Qg, f), [c, p] = ne(null), d = Fe(
    t,
    (Ce) => p(Ce)
  ), [m, O] = ne(null), x = KL(m), P = (n = x == null ? void 0 : x.width) !== null && n !== void 0 ? n : 0, N = (r = x == null ? void 0 : x.height) !== null && r !== void 0 ? r : 0, D = h + (v !== "center" ? "-" + v : ""), I = typeof S == "number" ? S : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...S
  }, C = Array.isArray(w) ? w : [
    w
  ], L = C.length > 0, k = {
    padding: I,
    boundary: C.filter(YL),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: L
  }, { refs: M, floatingStyles: F, placement: j, isPositioned: U, middlewareData: G } = HL({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: D,
    whileElementsMounted: BL,
    elements: {
      reference: y.anchor
    },
    middleware: [
      yL({
        mainAxis: g + N,
        alignmentAxis: E
      }),
      V && bL({
        mainAxis: !0,
        crossAxis: !1,
        limiter: T === "partial" ? wL() : void 0,
        ...k
      }),
      V && vL({
        ...k
      }),
      xL({
        ...k,
        apply: ({ elements: Ce, rects: Ke, availableWidth: We, availableHeight: nt }) => {
          const { width: qe, height: we } = Ke.reference, $e = Ce.floating.style;
          $e.setProperty("--radix-popper-available-width", `${We}px`), $e.setProperty("--radix-popper-available-height", `${nt}px`), $e.setProperty("--radix-popper-anchor-width", `${qe}px`), $e.setProperty("--radix-popper-anchor-height", `${we}px`);
        }
      }),
      m && FL({
        element: m,
        padding: b
      }),
      XL({
        arrowWidth: P,
        arrowHeight: N
      }),
      A && mL({
        strategy: "referenceHidden"
      })
    ]
  }), [X, W] = e3(j), q = et($);
  Pt(() => {
    U && (q == null || q());
  }, [
    U,
    q
  ]);
  const ee = (a = G.arrow) === null || a === void 0 ? void 0 : a.x, te = (i = G.arrow) === null || i === void 0 ? void 0 : i.y, le = ((o = G.arrow) === null || o === void 0 ? void 0 : o.centerOffset) !== 0, [Y, ye] = ne();
  return Pt(() => {
    c && ye(window.getComputedStyle(c).zIndex);
  }, [
    c
  ]), /* @__PURE__ */ se("div", {
    ref: M.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...F,
      transform: U ? F.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: Y,
      "--radix-popper-transform-origin": [
        (l = G.transformOrigin) === null || l === void 0 ? void 0 : l.x,
        (s = G.transformOrigin) === null || s === void 0 ? void 0 : s.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ se(ZL, {
    scope: f,
    placedSide: X,
    onArrowChange: O,
    arrowX: ee,
    arrowY: te,
    shouldHideArrow: le
  }, /* @__PURE__ */ se(Je.div, be({
    "data-side": X,
    "data-align": W
  }, _, {
    ref: d,
    style: {
      ..._.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: U ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (u = G.hide) !== null && u !== void 0 && u.referenceHidden ? 0 : void 0
    }
  }))));
});
function YL(e) {
  return e !== null;
}
const XL = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var n, r, a, i, o;
    const { placement: l, rects: s, middlewareData: u } = t, h = ((n = u.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, g = h ? 0 : e.arrowWidth, v = h ? 0 : e.arrowHeight, [E, b] = e3(l), w = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[b], S = ((r = (a = u.arrow) === null || a === void 0 ? void 0 : a.x) !== null && r !== void 0 ? r : 0) + g / 2, T = ((i = (o = u.arrow) === null || o === void 0 ? void 0 : o.y) !== null && i !== void 0 ? i : 0) + v / 2;
    let A = "", V = "";
    return E === "bottom" ? (A = h ? w : `${S}px`, V = `${-v}px`) : E === "top" ? (A = h ? w : `${S}px`, V = `${s.floating.height + v}px`) : E === "right" ? (A = `${-v}px`, V = h ? w : `${T}px`) : E === "left" && (A = `${s.floating.width + v}px`, V = h ? w : `${T}px`), {
      data: {
        x: A,
        y: V
      }
    };
  }
});
function e3(e) {
  const [t, n = "center"] = e.split("-");
  return [
    t,
    n
  ];
}
const JL = UL, QL = qL, eI = GL, tI = /* @__PURE__ */ Se((e, t) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...a } = e;
  return r ? /* @__PURE__ */ iy.createPortal(/* @__PURE__ */ se(Je.div, be({}, a, {
    ref: t
  })), r) : null;
});
function Qp({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, a] = nI({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, o = i ? e : r, l = et(n), s = he((u) => {
    if (i) {
      const h = typeof u == "function" ? u(e) : u;
      h !== e && l(h);
    } else
      a(u);
  }, [
    i,
    e,
    a,
    l
  ]);
  return [
    o,
    s
  ];
}
function nI({ defaultProp: e, onChange: t }) {
  const n = ne(e), [r] = n, a = J(r), i = et(t);
  return re(() => {
    a.current !== r && (i(r), a.current = r);
  }, [
    r,
    a,
    i
  ]), n;
}
function rI(e) {
  const t = J({
    value: e,
    previous: e
  });
  return ge(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [
    e
  ]);
}
const aI = /* @__PURE__ */ Se((e, t) => /* @__PURE__ */ se(Je.span, be({}, e, {
  ref: t,
  style: {
    // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal",
    ...e.style
  }
})));
var iI = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, nr = /* @__PURE__ */ new WeakMap(), ei = /* @__PURE__ */ new WeakMap(), ti = {}, js = 0, t3 = function(e) {
  return e && (e.host || t3(e.parentNode));
}, oI = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = t3(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, lI = function(e, t, n, r) {
  var a = oI(t, Array.isArray(e) ? e : [e]);
  ti[n] || (ti[n] = /* @__PURE__ */ new WeakMap());
  var i = ti[n], o = [], l = /* @__PURE__ */ new Set(), s = new Set(a), u = function(h) {
    !h || l.has(h) || (l.add(h), u(h.parentNode));
  };
  a.forEach(u);
  var f = function(h) {
    !h || s.has(h) || Array.prototype.forEach.call(h.children, function(g) {
      if (l.has(g))
        f(g);
      else {
        var v = g.getAttribute(r), E = v !== null && v !== "false", b = (nr.get(g) || 0) + 1, w = (i.get(g) || 0) + 1;
        nr.set(g, b), i.set(g, w), o.push(g), b === 1 && E && ei.set(g, !0), w === 1 && g.setAttribute(n, "true"), E || g.setAttribute(r, "true");
      }
    });
  };
  return f(t), l.clear(), js++, function() {
    o.forEach(function(h) {
      var g = nr.get(h) - 1, v = i.get(h) - 1;
      nr.set(h, g), i.set(h, v), g || (ei.has(h) || h.removeAttribute(r), ei.delete(h)), v || h.removeAttribute(n);
    }), js--, js || (nr = /* @__PURE__ */ new WeakMap(), nr = /* @__PURE__ */ new WeakMap(), ei = /* @__PURE__ */ new WeakMap(), ti = {});
  };
}, sI = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), a = t || iI(e);
  return a ? (r.push.apply(r, Array.from(a.querySelectorAll("[aria-live]"))), lI(r, a, n, "aria-hidden")) : function() {
    return null;
  };
}, ui = "right-scroll-bar-position", di = "width-before-scroll-bar", cI = "with-scroll-bars-hidden", uI = "--removed-body-scroll-bar-size";
function dI(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function fI(e, t) {
  var n = ne(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var a = n.value;
          a !== r && (n.value = r, n.callback(r, a));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
function pI(e, t) {
  return fI(t || null, function(n) {
    return e.forEach(function(r) {
      return dI(r, n);
    });
  });
}
function hI(e) {
  return e;
}
function vI(e, t) {
  t === void 0 && (t = hI);
  var n = [], r = !1, a = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(i) {
      var o = t(i, r);
      return n.push(o), function() {
        n = n.filter(function(l) {
          return l !== o;
        });
      };
    },
    assignSyncMedium: function(i) {
      for (r = !0; n.length; ) {
        var o = n;
        n = [], o.forEach(i);
      }
      n = {
        push: function(l) {
          return i(l);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(i) {
      r = !0;
      var o = [];
      if (n.length) {
        var l = n;
        n = [], l.forEach(i), o = n;
      }
      var s = function() {
        var f = o;
        o = [], f.forEach(i);
      }, u = function() {
        return Promise.resolve().then(s);
      };
      u(), n = {
        push: function(f) {
          o.push(f), u();
        },
        filter: function(f) {
          return o = o.filter(f), n;
        }
      };
    }
  };
  return a;
}
function mI(e) {
  e === void 0 && (e = {});
  var t = vI(null);
  return t.options = Dt({ async: !0, ssr: !1 }, e), t;
}
var n3 = function(e) {
  var t = e.sideCar, n = g2(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return ue.createElement(r, Dt({}, n));
};
n3.isSideCarExport = !0;
function gI(e, t) {
  return e.useMedium(t), n3;
}
var r3 = mI(), Us = function() {
}, fo = ue.forwardRef(function(e, t) {
  var n = ue.useRef(null), r = ue.useState({
    onScrollCapture: Us,
    onWheelCapture: Us,
    onTouchMoveCapture: Us
  }), a = r[0], i = r[1], o = e.forwardProps, l = e.children, s = e.className, u = e.removeScrollBar, f = e.enabled, h = e.shards, g = e.sideCar, v = e.noIsolation, E = e.inert, b = e.allowPinchZoom, w = e.as, S = w === void 0 ? "div" : w, T = g2(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), A = g, V = pI([n, t]), $ = Dt(Dt({}, T), a);
  return ue.createElement(
    ue.Fragment,
    null,
    f && ue.createElement(A, { sideCar: r3, removeScrollBar: u, shards: h, noIsolation: v, inert: E, setCallbacks: i, allowPinchZoom: !!b, lockRef: n }),
    o ? ue.cloneElement(ue.Children.only(l), Dt(Dt({}, $), { ref: V })) : ue.createElement(S, Dt({}, $, { className: s, ref: V }), l)
  );
});
fo.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
fo.classNames = {
  fullWidth: di,
  zeroRight: ui
};
var eh, yI = function() {
  if (eh)
    return eh;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function bI() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = yI();
  return t && e.setAttribute("nonce", t), e;
}
function wI(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function xI(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var EI = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = bI()) && (wI(t, n), xI(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, $I = function() {
  var e = EI();
  return function(t, n) {
    ue.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, a3 = function() {
  var e = $I(), t = function(n) {
    var r = n.styles, a = n.dynamic;
    return e(r, a), null;
  };
  return t;
}, PI = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Ws = function(e) {
  return parseInt(e || "", 10) || 0;
}, CI = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], a = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Ws(n), Ws(r), Ws(a)];
}, SI = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return PI;
  var t = CI(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, kI = a3(), TI = function(e, t, n, r) {
  var a = e.left, i = e.top, o = e.right, l = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(cI, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(l, "px ").concat(r, `;
  }
  body {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(a, `px;
    padding-top: `).concat(i, `px;
    padding-right: `).concat(o, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(l, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(l, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(ui, ` {
    right: `).concat(l, "px ").concat(r, `;
  }
  
  .`).concat(di, ` {
    margin-right: `).concat(l, "px ").concat(r, `;
  }
  
  .`).concat(ui, " .").concat(ui, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(di, " .").concat(di, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body {
    `).concat(uI, ": ").concat(l, `px;
  }
`);
}, AI = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, a = r === void 0 ? "margin" : r, i = ue.useMemo(function() {
    return SI(a);
  }, [a]);
  return ue.createElement(kI, { styles: TI(i, !t, a, n ? "" : "!important") });
}, Ac = !1;
if (typeof window < "u")
  try {
    var ni = Object.defineProperty({}, "passive", {
      get: function() {
        return Ac = !0, !0;
      }
    });
    window.addEventListener("test", ni, ni), window.removeEventListener("test", ni, ni);
  } catch {
    Ac = !1;
  }
var rr = Ac ? { passive: !1 } : !1, OI = function(e) {
  return e.tagName === "TEXTAREA";
}, i3 = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !OI(e) && n[t] === "visible")
  );
}, zI = function(e) {
  return i3(e, "overflowY");
}, MI = function(e) {
  return i3(e, "overflowX");
}, th = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = o3(e, n);
    if (r) {
      var a = l3(e, n), i = a[1], o = a[2];
      if (i > o)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, _I = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, LI = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, o3 = function(e, t) {
  return e === "v" ? zI(t) : MI(t);
}, l3 = function(e, t) {
  return e === "v" ? _I(t) : LI(t);
}, II = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, DI = function(e, t, n, r, a) {
  var i = II(e, window.getComputedStyle(t).direction), o = i * r, l = n.target, s = t.contains(l), u = !1, f = o > 0, h = 0, g = 0;
  do {
    var v = l3(e, l), E = v[0], b = v[1], w = v[2], S = b - w - i * E;
    (E || S) && o3(e, l) && (h += S, g += E), l = l.parentNode;
  } while (
    // portaled content
    !s && l !== document.body || // self content
    s && (t.contains(l) || t === l)
  );
  return (f && (a && h === 0 || !a && o > h) || !f && (a && g === 0 || !a && -o > g)) && (u = !0), u;
}, ri = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, nh = function(e) {
  return [e.deltaX, e.deltaY];
}, rh = function(e) {
  return e && "current" in e ? e.current : e;
}, NI = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, RI = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, BI = 0, ar = [];
function VI(e) {
  var t = ue.useRef([]), n = ue.useRef([0, 0]), r = ue.useRef(), a = ue.useState(BI++)[0], i = ue.useState(function() {
    return a3();
  })[0], o = ue.useRef(e);
  ue.useEffect(function() {
    o.current = e;
  }, [e]), ue.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(a));
      var b = p5([e.lockRef.current], (e.shards || []).map(rh), !0).filter(Boolean);
      return b.forEach(function(w) {
        return w.classList.add("allow-interactivity-".concat(a));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(a)), b.forEach(function(w) {
          return w.classList.remove("allow-interactivity-".concat(a));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var l = ue.useCallback(function(b, w) {
    if ("touches" in b && b.touches.length === 2)
      return !o.current.allowPinchZoom;
    var S = ri(b), T = n.current, A = "deltaX" in b ? b.deltaX : T[0] - S[0], V = "deltaY" in b ? b.deltaY : T[1] - S[1], $, _ = b.target, y = Math.abs(A) > Math.abs(V) ? "h" : "v";
    if ("touches" in b && y === "h" && _.type === "range")
      return !1;
    var c = th(y, _);
    if (!c)
      return !0;
    if (c ? $ = y : ($ = y === "v" ? "h" : "v", c = th(y, _)), !c)
      return !1;
    if (!r.current && "changedTouches" in b && (A || V) && (r.current = $), !$)
      return !0;
    var p = r.current || $;
    return DI(p, w, b, p === "h" ? A : V, !0);
  }, []), s = ue.useCallback(function(b) {
    var w = b;
    if (!(!ar.length || ar[ar.length - 1] !== i)) {
      var S = "deltaY" in w ? nh(w) : ri(w), T = t.current.filter(function($) {
        return $.name === w.type && $.target === w.target && NI($.delta, S);
      })[0];
      if (T && T.should) {
        w.cancelable && w.preventDefault();
        return;
      }
      if (!T) {
        var A = (o.current.shards || []).map(rh).filter(Boolean).filter(function($) {
          return $.contains(w.target);
        }), V = A.length > 0 ? l(w, A[0]) : !o.current.noIsolation;
        V && w.cancelable && w.preventDefault();
      }
    }
  }, []), u = ue.useCallback(function(b, w, S, T) {
    var A = { name: b, delta: w, target: S, should: T };
    t.current.push(A), setTimeout(function() {
      t.current = t.current.filter(function(V) {
        return V !== A;
      });
    }, 1);
  }, []), f = ue.useCallback(function(b) {
    n.current = ri(b), r.current = void 0;
  }, []), h = ue.useCallback(function(b) {
    u(b.type, nh(b), b.target, l(b, e.lockRef.current));
  }, []), g = ue.useCallback(function(b) {
    u(b.type, ri(b), b.target, l(b, e.lockRef.current));
  }, []);
  ue.useEffect(function() {
    return ar.push(i), e.setCallbacks({
      onScrollCapture: h,
      onWheelCapture: h,
      onTouchMoveCapture: g
    }), document.addEventListener("wheel", s, rr), document.addEventListener("touchmove", s, rr), document.addEventListener("touchstart", f, rr), function() {
      ar = ar.filter(function(b) {
        return b !== i;
      }), document.removeEventListener("wheel", s, rr), document.removeEventListener("touchmove", s, rr), document.removeEventListener("touchstart", f, rr);
    };
  }, []);
  var v = e.removeScrollBar, E = e.inert;
  return ue.createElement(
    ue.Fragment,
    null,
    E ? ue.createElement(i, { styles: RI(a) }) : null,
    v ? ue.createElement(AI, { gapMode: "margin" }) : null
  );
}
const FI = gI(r3, VI);
var s3 = ue.forwardRef(function(e, t) {
  return ue.createElement(fo, Dt({}, e, { ref: t, sideCar: FI }));
});
s3.classNames = fo.classNames;
const HI = s3, KI = [
  " ",
  "Enter",
  "ArrowUp",
  "ArrowDown"
], jI = [
  " ",
  "Enter"
], po = "Select", [ho, x1, UI] = H_(po), [wr, pN] = oo(po, [
  UI,
  Xg
]), E1 = Xg(), [WI, Hn] = wr(po), [qI, ZI] = wr(po), GI = (e) => {
  const { __scopeSelect: t, children: n, open: r, defaultOpen: a, onOpenChange: i, value: o, defaultValue: l, onValueChange: s, dir: u, name: f, autoComplete: h, disabled: g, required: v } = e, E = E1(t), [b, w] = ne(null), [S, T] = ne(null), [A, V] = ne(!1), $ = Tg(u), [_ = !1, y] = Qp({
    prop: r,
    defaultProp: a,
    onChange: i
  }), [c, p] = Qp({
    prop: o,
    defaultProp: l,
    onChange: s
  }), d = J(null), m = b ? !!b.closest("form") : !0, [O, x] = ne(/* @__PURE__ */ new Set()), P = Array.from(O).map(
    (N) => N.props.value
  ).join(";");
  return /* @__PURE__ */ se(JL, E, /* @__PURE__ */ se(WI, {
    required: v,
    scope: t,
    trigger: b,
    onTriggerChange: w,
    valueNode: S,
    onValueNodeChange: T,
    valueNodeHasChildren: A,
    onValueNodeHasChildrenChange: V,
    contentId: Bg(),
    value: c,
    onValueChange: p,
    open: _,
    onOpenChange: y,
    dir: $,
    triggerPointerDownPosRef: d,
    disabled: g
  }, /* @__PURE__ */ se(ho.Provider, {
    scope: t
  }, /* @__PURE__ */ se(qI, {
    scope: e.__scopeSelect,
    onNativeOptionAdd: he((N) => {
      x(
        (D) => new Set(D).add(N)
      );
    }, []),
    onNativeOptionRemove: he((N) => {
      x((D) => {
        const I = new Set(D);
        return I.delete(N), I;
      });
    }, [])
  }, n)), m ? /* @__PURE__ */ se(u3, {
    key: P,
    "aria-hidden": !0,
    required: v,
    tabIndex: -1,
    name: f,
    autoComplete: h,
    value: c,
    onChange: (N) => p(N.target.value),
    disabled: g
  }, c === void 0 ? /* @__PURE__ */ se("option", {
    value: ""
  }) : null, Array.from(O)) : null));
}, YI = "SelectTrigger", XI = /* @__PURE__ */ Se((e, t) => {
  const { __scopeSelect: n, disabled: r = !1, ...a } = e, i = E1(n), o = Hn(YI, n), l = o.disabled || r, s = Fe(t, o.onTriggerChange), u = x1(n), [f, h, g] = d3((E) => {
    const b = u().filter(
      (T) => !T.disabled
    ), w = b.find(
      (T) => T.value === o.value
    ), S = f3(b, E, w);
    S !== void 0 && o.onValueChange(S.value);
  }), v = () => {
    l || (o.onOpenChange(!0), g());
  };
  return /* @__PURE__ */ se(QL, be({
    asChild: !0
  }, i), /* @__PURE__ */ se(Je.button, be({
    type: "button",
    role: "combobox",
    "aria-controls": o.contentId,
    "aria-expanded": o.open,
    "aria-required": o.required,
    "aria-autocomplete": "none",
    dir: o.dir,
    "data-state": o.open ? "open" : "closed",
    disabled: l,
    "data-disabled": l ? "" : void 0,
    "data-placeholder": o.value === void 0 ? "" : void 0
  }, a, {
    ref: s,
    onClick: Be(a.onClick, (E) => {
      E.currentTarget.focus();
    }),
    onPointerDown: Be(a.onPointerDown, (E) => {
      const b = E.target;
      b.hasPointerCapture(E.pointerId) && b.releasePointerCapture(E.pointerId), E.button === 0 && E.ctrlKey === !1 && (v(), o.triggerPointerDownPosRef.current = {
        x: Math.round(E.pageX),
        y: Math.round(E.pageY)
      }, E.preventDefault());
    }),
    onKeyDown: Be(a.onKeyDown, (E) => {
      const b = f.current !== "";
      !(E.ctrlKey || E.altKey || E.metaKey) && E.key.length === 1 && h(E.key), !(b && E.key === " ") && KI.includes(E.key) && (v(), E.preventDefault());
    })
  })));
}), JI = "SelectValue", QI = /* @__PURE__ */ Se((e, t) => {
  const { __scopeSelect: n, className: r, style: a, children: i, placeholder: o, ...l } = e, s = Hn(JI, n), { onValueNodeHasChildrenChange: u } = s, f = i !== void 0, h = Fe(t, s.onValueNodeChange);
  return Pt(() => {
    u(f);
  }, [
    u,
    f
  ]), /* @__PURE__ */ se(Je.span, be({}, l, {
    ref: h,
    style: {
      pointerEvents: "none"
    }
  }), s.value === void 0 && o !== void 0 ? o : i);
}), eD = /* @__PURE__ */ Se((e, t) => {
  const { __scopeSelect: n, children: r, ...a } = e;
  return /* @__PURE__ */ se(Je.span, be({
    "aria-hidden": !0
  }, a, {
    ref: t
  }), r || "▼");
}), tD = (e) => /* @__PURE__ */ se(tI, be({
  asChild: !0
}, e)), hr = "SelectContent", nD = /* @__PURE__ */ Se((e, t) => {
  const n = Hn(hr, e.__scopeSelect), [r, a] = ne();
  if (Pt(() => {
    a(new DocumentFragment());
  }, []), !n.open) {
    const i = r;
    return i ? /* @__PURE__ */ Di(/* @__PURE__ */ se(c3, {
      scope: e.__scopeSelect
    }, /* @__PURE__ */ se(ho.Slot, {
      scope: e.__scopeSelect
    }, /* @__PURE__ */ se("div", null, e.children))), i) : null;
  }
  return /* @__PURE__ */ se(rD, be({}, e, {
    ref: t
  }));
}), Wt = 10, [c3, vo] = wr(hr), rD = /* @__PURE__ */ Se((e, t) => {
  const {
    __scopeSelect: n,
    position: r = "item-aligned",
    onCloseAutoFocus: a,
    onEscapeKeyDown: i,
    onPointerDownOutside: o,
    side: l,
    sideOffset: s,
    align: u,
    alignOffset: f,
    arrowPadding: h,
    collisionBoundary: g,
    collisionPadding: v,
    sticky: E,
    hideWhenDetached: b,
    avoidCollisions: w,
    //
    ...S
  } = e, T = Hn(hr, n), [A, V] = ne(null), [$, _] = ne(null), y = Fe(
    t,
    (W) => V(W)
  ), [c, p] = ne(null), [d, m] = ne(null), O = x1(n), [x, P] = ne(!1), N = J(!1);
  re(() => {
    if (A)
      return sI(A);
  }, [
    A
  ]), Y_();
  const D = he((W) => {
    const [q, ...ee] = O().map(
      (Y) => Y.ref.current
    ), [te] = ee.slice(-1), le = document.activeElement;
    for (const Y of W)
      if (Y === le || (Y == null || Y.scrollIntoView({
        block: "nearest"
      }), Y === q && $ && ($.scrollTop = 0), Y === te && $ && ($.scrollTop = $.scrollHeight), Y == null || Y.focus(), document.activeElement !== le))
        return;
  }, [
    O,
    $
  ]), I = he(
    () => D([
      c,
      A
    ]),
    [
      D,
      c,
      A
    ]
  );
  re(() => {
    x && I();
  }, [
    x,
    I
  ]);
  const { onOpenChange: C, triggerPointerDownPosRef: L } = T;
  re(() => {
    if (A) {
      let W = {
        x: 0,
        y: 0
      };
      const q = (te) => {
        var le, Y, ye, Ce;
        W = {
          x: Math.abs(Math.round(te.pageX) - ((le = (Y = L.current) === null || Y === void 0 ? void 0 : Y.x) !== null && le !== void 0 ? le : 0)),
          y: Math.abs(Math.round(te.pageY) - ((ye = (Ce = L.current) === null || Ce === void 0 ? void 0 : Ce.y) !== null && ye !== void 0 ? ye : 0))
        };
      }, ee = (te) => {
        W.x <= 10 && W.y <= 10 ? te.preventDefault() : A.contains(te.target) || C(!1), document.removeEventListener("pointermove", q), L.current = null;
      };
      return L.current !== null && (document.addEventListener("pointermove", q), document.addEventListener("pointerup", ee, {
        capture: !0,
        once: !0
      })), () => {
        document.removeEventListener("pointermove", q), document.removeEventListener("pointerup", ee, {
          capture: !0
        });
      };
    }
  }, [
    A,
    C,
    L
  ]), re(() => {
    const W = () => C(!1);
    return window.addEventListener("blur", W), window.addEventListener("resize", W), () => {
      window.removeEventListener("blur", W), window.removeEventListener("resize", W);
    };
  }, [
    C
  ]);
  const [k, M] = d3((W) => {
    const q = O().filter(
      (le) => !le.disabled
    ), ee = q.find(
      (le) => le.ref.current === document.activeElement
    ), te = f3(q, W, ee);
    te && setTimeout(
      () => te.ref.current.focus()
    );
  }), F = he((W, q, ee) => {
    const te = !N.current && !ee;
    (T.value !== void 0 && T.value === q || te) && (p(W), te && (N.current = !0));
  }, [
    T.value
  ]), j = he(
    () => A == null ? void 0 : A.focus(),
    [
      A
    ]
  ), U = he((W, q, ee) => {
    const te = !N.current && !ee;
    (T.value !== void 0 && T.value === q || te) && m(W);
  }, [
    T.value
  ]), G = r === "popper" ? ah : aD, X = G === ah ? {
    side: l,
    sideOffset: s,
    align: u,
    alignOffset: f,
    arrowPadding: h,
    collisionBoundary: g,
    collisionPadding: v,
    sticky: E,
    hideWhenDetached: b,
    avoidCollisions: w
  } : {};
  return /* @__PURE__ */ se(c3, {
    scope: n,
    content: A,
    viewport: $,
    onViewportChange: _,
    itemRefCallback: F,
    selectedItem: c,
    onItemLeave: j,
    itemTextRefCallback: U,
    focusSelectedItem: I,
    selectedItemText: d,
    position: r,
    isPositioned: x,
    searchRef: k
  }, /* @__PURE__ */ se(HI, {
    as: ea,
    allowPinchZoom: !0
  }, /* @__PURE__ */ se(X_, {
    asChild: !0,
    trapped: T.open,
    onMountAutoFocus: (W) => {
      W.preventDefault();
    },
    onUnmountAutoFocus: Be(a, (W) => {
      var q;
      (q = T.trigger) === null || q === void 0 || q.focus({
        preventScroll: !0
      }), W.preventDefault();
    })
  }, /* @__PURE__ */ se(q_, {
    asChild: !0,
    disableOutsidePointerEvents: !0,
    onEscapeKeyDown: i,
    onPointerDownOutside: o,
    onFocusOutside: (W) => W.preventDefault(),
    onDismiss: () => T.onOpenChange(!1)
  }, /* @__PURE__ */ se(G, be({
    role: "listbox",
    id: T.contentId,
    "data-state": T.open ? "open" : "closed",
    dir: T.dir,
    onContextMenu: (W) => W.preventDefault()
  }, S, X, {
    onPlaced: () => P(!0),
    ref: y,
    style: {
      // flex layout so we can place the scroll buttons properly
      display: "flex",
      flexDirection: "column",
      // reset the outline by default as the content MAY get focused
      outline: "none",
      ...S.style
    },
    onKeyDown: Be(S.onKeyDown, (W) => {
      const q = W.ctrlKey || W.altKey || W.metaKey;
      if (W.key === "Tab" && W.preventDefault(), !q && W.key.length === 1 && M(W.key), [
        "ArrowUp",
        "ArrowDown",
        "Home",
        "End"
      ].includes(W.key)) {
        let te = O().filter(
          (le) => !le.disabled
        ).map(
          (le) => le.ref.current
        );
        if ([
          "ArrowUp",
          "End"
        ].includes(W.key) && (te = te.slice().reverse()), [
          "ArrowUp",
          "ArrowDown"
        ].includes(W.key)) {
          const le = W.target, Y = te.indexOf(le);
          te = te.slice(Y + 1);
        }
        setTimeout(
          () => D(te)
        ), W.preventDefault();
      }
    })
  }))))));
}), aD = /* @__PURE__ */ Se((e, t) => {
  const { __scopeSelect: n, onPlaced: r, ...a } = e, i = Hn(hr, n), o = vo(hr, n), [l, s] = ne(null), [u, f] = ne(null), h = Fe(
    t,
    (y) => f(y)
  ), g = x1(n), v = J(!1), E = J(!0), { viewport: b, selectedItem: w, selectedItemText: S, focusSelectedItem: T } = o, A = he(() => {
    if (i.trigger && i.valueNode && l && u && b && w && S) {
      const y = i.trigger.getBoundingClientRect(), c = u.getBoundingClientRect(), p = i.valueNode.getBoundingClientRect(), d = S.getBoundingClientRect();
      if (i.dir !== "rtl") {
        const le = d.left - c.left, Y = p.left - le, ye = y.left - Y, Ce = y.width + ye, Ke = Math.max(Ce, c.width), We = window.innerWidth - Wt, nt = Pc(Y, [
          Wt,
          We - Ke
        ]);
        l.style.minWidth = Ce + "px", l.style.left = nt + "px";
      } else {
        const le = c.right - d.right, Y = window.innerWidth - p.right - le, ye = window.innerWidth - y.right - Y, Ce = y.width + ye, Ke = Math.max(Ce, c.width), We = window.innerWidth - Wt, nt = Pc(Y, [
          Wt,
          We - Ke
        ]);
        l.style.minWidth = Ce + "px", l.style.right = nt + "px";
      }
      const m = g(), O = window.innerHeight - Wt * 2, x = b.scrollHeight, P = window.getComputedStyle(u), N = parseInt(P.borderTopWidth, 10), D = parseInt(P.paddingTop, 10), I = parseInt(P.borderBottomWidth, 10), C = parseInt(P.paddingBottom, 10), L = N + D + x + C + I, k = Math.min(w.offsetHeight * 5, L), M = window.getComputedStyle(b), F = parseInt(M.paddingTop, 10), j = parseInt(M.paddingBottom, 10), U = y.top + y.height / 2 - Wt, G = O - U, X = w.offsetHeight / 2, W = w.offsetTop + X, q = N + D + W, ee = L - q;
      if (q <= U) {
        const le = w === m[m.length - 1].ref.current;
        l.style.bottom = "0px";
        const Y = u.clientHeight - b.offsetTop - b.offsetHeight, ye = Math.max(G, X + (le ? j : 0) + Y + I), Ce = q + ye;
        l.style.height = Ce + "px";
      } else {
        const le = w === m[0].ref.current;
        l.style.top = "0px";
        const ye = Math.max(U, N + b.offsetTop + (le ? F : 0) + X) + ee;
        l.style.height = ye + "px", b.scrollTop = q - U + b.offsetTop;
      }
      l.style.margin = `${Wt}px 0`, l.style.minHeight = k + "px", l.style.maxHeight = O + "px", r == null || r(), requestAnimationFrame(
        () => v.current = !0
      );
    }
  }, [
    g,
    i.trigger,
    i.valueNode,
    l,
    u,
    b,
    w,
    S,
    i.dir,
    r
  ]);
  Pt(
    () => A(),
    [
      A
    ]
  );
  const [V, $] = ne();
  Pt(() => {
    u && $(window.getComputedStyle(u).zIndex);
  }, [
    u
  ]);
  const _ = he((y) => {
    y && E.current === !0 && (A(), T == null || T(), E.current = !1);
  }, [
    A,
    T
  ]);
  return /* @__PURE__ */ se(iD, {
    scope: n,
    contentWrapper: l,
    shouldExpandOnScrollRef: v,
    onScrollButtonChange: _
  }, /* @__PURE__ */ se("div", {
    ref: s,
    style: {
      display: "flex",
      flexDirection: "column",
      position: "fixed",
      zIndex: V
    }
  }, /* @__PURE__ */ se(Je.div, be({}, a, {
    ref: h,
    style: {
      // When we get the height of the content, it includes borders. If we were to set
      // the height without having `boxSizing: 'border-box'` it would be too big.
      boxSizing: "border-box",
      // We need to ensure the content doesn't get taller than the wrapper
      maxHeight: "100%",
      ...a.style
    }
  }))));
}), ah = /* @__PURE__ */ Se((e, t) => {
  const { __scopeSelect: n, align: r = "start", collisionPadding: a = Wt, ...i } = e, o = E1(n);
  return /* @__PURE__ */ se(eI, be({}, o, i, {
    ref: t,
    align: r,
    collisionPadding: a,
    style: {
      // Ensure border-box for floating-ui calculations
      boxSizing: "border-box",
      ...i.style,
      "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-select-content-available-width": "var(--radix-popper-available-width)",
      "--radix-select-content-available-height": "var(--radix-popper-available-height)",
      "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
}), [iD, oD] = wr(hr, {}), ih = "SelectViewport", lD = /* @__PURE__ */ Se((e, t) => {
  const { __scopeSelect: n, ...r } = e, a = vo(ih, n), i = oD(ih, n), o = Fe(t, a.onViewportChange), l = J(0);
  return /* @__PURE__ */ se(st, null, /* @__PURE__ */ se("style", {
    dangerouslySetInnerHTML: {
      __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
    }
  }), /* @__PURE__ */ se(ho.Slot, {
    scope: n
  }, /* @__PURE__ */ se(Je.div, be({
    "data-radix-select-viewport": "",
    role: "presentation"
  }, r, {
    ref: o,
    style: {
      // we use position: 'relative' here on the `viewport` so that when we call
      // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
      // (independent of the scrollUpButton).
      position: "relative",
      flex: 1,
      overflow: "auto",
      ...r.style
    },
    onScroll: Be(r.onScroll, (s) => {
      const u = s.currentTarget, { contentWrapper: f, shouldExpandOnScrollRef: h } = i;
      if (h != null && h.current && f) {
        const g = Math.abs(l.current - u.scrollTop);
        if (g > 0) {
          const v = window.innerHeight - Wt * 2, E = parseFloat(f.style.minHeight), b = parseFloat(f.style.height), w = Math.max(E, b);
          if (w < v) {
            const S = w + g, T = Math.min(v, S), A = S - T;
            f.style.height = T + "px", f.style.bottom === "0px" && (u.scrollTop = A > 0 ? A : 0, f.style.justifyContent = "flex-end");
          }
        }
      }
      l.current = u.scrollTop;
    })
  }))));
}), sD = "SelectGroup";
wr(sD);
const Oc = "SelectItem", [cD, uD] = wr(Oc), dD = /* @__PURE__ */ Se((e, t) => {
  const { __scopeSelect: n, value: r, disabled: a = !1, textValue: i, ...o } = e, l = Hn(Oc, n), s = vo(Oc, n), u = l.value === r, [f, h] = ne(i ?? ""), [g, v] = ne(!1), E = Fe(t, (S) => {
    var T;
    return (T = s.itemRefCallback) === null || T === void 0 ? void 0 : T.call(s, S, r, a);
  }), b = Bg(), w = () => {
    a || (l.onValueChange(r), l.onOpenChange(!1));
  };
  return /* @__PURE__ */ se(cD, {
    scope: n,
    value: r,
    disabled: a,
    textId: b,
    isSelected: u,
    onItemTextChange: he((S) => {
      h((T) => {
        var A;
        return T || ((A = S == null ? void 0 : S.textContent) !== null && A !== void 0 ? A : "").trim();
      });
    }, [])
  }, /* @__PURE__ */ se(ho.ItemSlot, {
    scope: n,
    value: r,
    disabled: a,
    textValue: f
  }, /* @__PURE__ */ se(Je.div, be({
    role: "option",
    "aria-labelledby": b,
    "data-highlighted": g ? "" : void 0,
    "aria-selected": u && g,
    "data-state": u ? "checked" : "unchecked",
    "aria-disabled": a || void 0,
    "data-disabled": a ? "" : void 0,
    tabIndex: a ? void 0 : -1
  }, o, {
    ref: E,
    onFocus: Be(
      o.onFocus,
      () => v(!0)
    ),
    onBlur: Be(
      o.onBlur,
      () => v(!1)
    ),
    onPointerUp: Be(o.onPointerUp, w),
    onPointerMove: Be(o.onPointerMove, (S) => {
      if (a) {
        var T;
        (T = s.onItemLeave) === null || T === void 0 || T.call(s);
      } else
        S.currentTarget.focus({
          preventScroll: !0
        });
    }),
    onPointerLeave: Be(o.onPointerLeave, (S) => {
      if (S.currentTarget === document.activeElement) {
        var T;
        (T = s.onItemLeave) === null || T === void 0 || T.call(s);
      }
    }),
    onKeyDown: Be(o.onKeyDown, (S) => {
      var T;
      ((T = s.searchRef) === null || T === void 0 ? void 0 : T.current) !== "" && S.key === " " || (jI.includes(S.key) && w(), S.key === " " && S.preventDefault());
    })
  }))));
}), ai = "SelectItemText", fD = /* @__PURE__ */ Se((e, t) => {
  const { __scopeSelect: n, className: r, style: a, ...i } = e, o = Hn(ai, n), l = vo(ai, n), s = uD(ai, n), u = ZI(ai, n), [f, h] = ne(null), g = Fe(
    t,
    (S) => h(S),
    s.onItemTextChange,
    (S) => {
      var T;
      return (T = l.itemTextRefCallback) === null || T === void 0 ? void 0 : T.call(l, S, s.value, s.disabled);
    }
  ), v = f == null ? void 0 : f.textContent, E = ge(
    () => /* @__PURE__ */ se("option", {
      key: s.value,
      value: s.value,
      disabled: s.disabled
    }, v),
    [
      s.disabled,
      s.value,
      v
    ]
  ), { onNativeOptionAdd: b, onNativeOptionRemove: w } = u;
  return Pt(() => (b(E), () => w(E)), [
    b,
    w,
    E
  ]), /* @__PURE__ */ se(st, null, /* @__PURE__ */ se(Je.span, be({
    id: s.textId
  }, i, {
    ref: g
  })), s.isSelected && o.valueNode && !o.valueNodeHasChildren ? /* @__PURE__ */ Di(i.children, o.valueNode) : null);
}), u3 = /* @__PURE__ */ Se((e, t) => {
  const { value: n, ...r } = e, a = J(null), i = Fe(t, a), o = rI(n);
  return re(() => {
    const l = a.current, s = window.HTMLSelectElement.prototype, f = Object.getOwnPropertyDescriptor(s, "value").set;
    if (o !== n && f) {
      const h = new Event("change", {
        bubbles: !0
      });
      f.call(l, n), l.dispatchEvent(h);
    }
  }, [
    o,
    n
  ]), /* @__PURE__ */ se(aI, {
    asChild: !0
  }, /* @__PURE__ */ se("select", be({}, r, {
    ref: i,
    defaultValue: n
  })));
});
u3.displayName = "BubbleSelect";
function d3(e) {
  const t = et(e), n = J(""), r = J(0), a = he((o) => {
    const l = n.current + o;
    t(l), function s(u) {
      n.current = u, window.clearTimeout(r.current), u !== "" && (r.current = window.setTimeout(
        () => s(""),
        1e3
      ));
    }(l);
  }, [
    t
  ]), i = he(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return re(() => () => window.clearTimeout(r.current), []), [
    n,
    a,
    i
  ];
}
function f3(e, t, n) {
  const a = t.length > 1 && Array.from(t).every(
    (u) => u === t[0]
  ) ? t[0] : t, i = n ? e.indexOf(n) : -1;
  let o = pD(e, Math.max(i, 0));
  a.length === 1 && (o = o.filter(
    (u) => u !== n
  ));
  const s = o.find(
    (u) => u.textValue.toLowerCase().startsWith(a.toLowerCase())
  );
  return s !== n ? s : void 0;
}
function pD(e, t) {
  return e.map(
    (n, r) => e[(t + r) % e.length]
  );
}
const hD = GI, vD = XI, mD = QI, gD = eD, yD = tD, bD = nD, wD = lD, xD = dD, ED = fD, $D = de(
  "relative isolate mt-4 flex flex-col rounded-lg",
  {
    variants: {
      isOpen: { true: "rounded-b-none" }
    }
  }
), PD = de(
  "flex h-[56px] items-center justify-between relative rounded-lg border border-solid border-neutral-300 focus-within:border-brand-accessible-blue bg-white ring-inset transition-all focus-within:ring-1 focus-within:ring-brand-accessible-blue outline-none",
  {
    variants: {
      disabled: {
        true: "bg-neutral-50 border-neutral-200 cursor-not-allowed pointer-events-none"
      },
      showError: {
        true: "border-danger ring-danger focus-within:border-danger focus-within:ring-danger ring-1"
      },
      isOpen: {
        true: "border-brand-accessible-blue ring-brand-accessible-blue ring-1"
      }
    }
  }
), CD = de(
  "text-label-md absolute start-4 z-10 origin-top-left rtl:origin-top-right transform transition-transform duration-150 ease-standard scale-100 translate-y-0 text-neutral-500 pointer-events-none",
  {
    variants: {
      hasSelectedItem: {
        true: "scale-75 -translate-y-2"
      },
      disabled: {
        true: "text-neutral-400"
      }
    }
  }
), SD = de(
  "text-label-md absolute mt-4 px-4 py-2 text-neutral-900",
  {
    variants: {
      disabled: {
        true: "text-neutral-400"
      }
    }
  }
), kD = ({
  isDisabled: e,
  showError: t,
  hasSelectedItem: n
}) => e ? null : t ? /* @__PURE__ */ H(oh, { type: "danger" }) : n ? /* @__PURE__ */ H(oh, { type: "success" }) : null, oh = ({ type: e }) => /* @__PURE__ */ H(
  Le,
  {
    iconName: e === "success" ? "check-circle-outlined" : "alert-circle-outlined",
    className: `text-${e} me-[13px] ms-auto`,
    size: "sm"
  }
), hN = ({
  children: e,
  className: t,
  value: n,
  currentValue: r,
  ...a
}) => /* @__PURE__ */ H(
  xD,
  {
    className: ae(
      TD({ isSelected: r === n })
    ),
    ...a,
    value: n,
    children: /* @__PURE__ */ H(ED, { children: e })
  }
), TD = de(
  "select-none focus:bg-neutral-50 focus:text-neutral-900 active:bg-info-dark active:text-white text-body cursor-pointer px-6 py-3 outline-none active:bg-inherit active:text-inherit",
  {
    variants: {
      isSelected: {
        true: "bg-brand-accessible-blue hover:bg-brand-accessible-blue/80 focus:bg-brand-accessible-blue/80 hover:text-white focus:text-white text-white"
      }
    }
  }
), vN = (e) => {
  const {
    disabled: t,
    validationState: n,
    errorMessage: r,
    helperMessage: a,
    className: i,
    label: o,
    isRequired: l,
    onCloseAutoFocus: s,
    name: u,
    defaultSelectedKey: f = "",
    hideValidationIcon: h,
    onSelectionChange: g,
    children: v,
    trackingInfo: E,
    onOpenChange: b
  } = e, [w, S] = ne(!1), [T, A] = ne(f), V = !t && n === "invalid", $ = He.map(v, (c) => pn(c) ? en(c, {
    ...c.props,
    value: c.key,
    currentValue: T
  }) : c);
  re(() => {
    var c;
    (c = window.EFClickMapActivator) == null || c.init();
  }, []);
  const { onDangerousClose: _ } = ze(Pg), y = (c) => {
    b && b(c), c || _ && _(), S(c);
  };
  return /* @__PURE__ */ ie("div", { className: ae($D({ isOpen: w }), i), children: [
    /* @__PURE__ */ ie(
      hD,
      {
        defaultValue: f,
        value: T,
        onValueChange: (c) => {
          g && g(c), A(c);
        },
        onOpenChange: y,
        open: w,
        name: u,
        disabled: t,
        required: l,
        children: [
          /* @__PURE__ */ ie(
            vD,
            {
              "data-cy": "gudl-select",
              className: ae(PD({ isOpen: w, showError: V, disabled: t })),
              "aria-labelledby": u,
              "data-info": E,
              "data-clicklabel": "",
              onBlur: e.onBlur,
              children: [
                /* @__PURE__ */ ie(
                  "div",
                  {
                    id: u,
                    className: ae(
                      CD({
                        hasSelectedItem: !!T,
                        disabled: t
                      })
                    ),
                    "data-cy": "gudl-select-label",
                    children: [
                      o,
                      l && !t && /* @__PURE__ */ H("span", { className: "text-brand-accessible-blue", children: " *" })
                    ]
                  }
                ),
                T && /* @__PURE__ */ H(
                  "span",
                  {
                    className: ae(SD({ disabled: t })),
                    "data-cy": "gudl-select-value",
                    "aria-label": T,
                    children: /* @__PURE__ */ H(mD, {})
                  }
                ),
                /* @__PURE__ */ ie(gD, { className: "absolute right-4 top-1/2 -translate-y-1/2", children: [
                  !h && kD({
                    isDisabled: t,
                    showError: V,
                    hasSelectedItem: !!T
                  }),
                  /* @__PURE__ */ H(gh, { open: w, intent: "black", className: "h-3 w-3" })
                ] })
              ]
            }
          ),
          /* @__PURE__ */ H(yD, { children: /* @__PURE__ */ H(
            bD,
            {
              position: "popper",
              ref: (c) => c == null ? void 0 : c.addEventListener("touchend", (p) => p.preventDefault()),
              onCloseAutoFocus: s,
              className: "!z-[1000001] mt-1 overflow-hidden rounded-lg border border-neutral-300 bg-white shadow",
              children: /* @__PURE__ */ ie(
                B_,
                {
                  className: "h-full w-[var(--radix-select-trigger-width)]",
                  type: "auto",
                  children: [
                    /* @__PURE__ */ H(wD, { className: "h-full max-h-[260px] w-full", children: /* @__PURE__ */ H(
                      V_,
                      {
                        className: "w-full divide-y divide-neutral-300",
                        "data-cy": "gudl-select-options",
                        asChild: !0,
                        children: $
                      }
                    ) }),
                    /* @__PURE__ */ H(
                      A_,
                      {
                        className: "h-full w-2.5 border-l border-l-transparent p-0.5",
                        orientation: "vertical",
                        children: /* @__PURE__ */ H(F_, { className: "h-2 w-2.5 rounded-sm bg-black/30" })
                      }
                    )
                  ]
                }
              )
            }
          ) })
        ]
      }
    ),
    V && r && /* @__PURE__ */ H(gt, { intent: "danger", children: r }),
    a && /* @__PURE__ */ H(gt, { children: a })
  ] });
}, mN = ({ title: e, subtitle: t }) => /* @__PURE__ */ ie(De, { children: [
  /* @__PURE__ */ H(
    Ye,
    {
      variant: "label-md",
      className: "overflow-hidden text-ellipsis whitespace-nowrap",
      children: e
    }
  ),
  t && /* @__PURE__ */ H(Ye, { variant: "label-xs", className: "text-neutral", children: t })
] }), AD = () => /* @__PURE__ */ ie(De, { children: [
  /* @__PURE__ */ ie("li", { className: "flex animate-pulse flex-col gap-2 p-4", children: [
    /* @__PURE__ */ H("span", { className: "h-[22px] w-1/2 bg-neutral-200 " }),
    /* @__PURE__ */ H("span", { className: "h-4 w-1/4 bg-neutral-100" })
  ] }),
  /* @__PURE__ */ ie("li", { className: "flex animate-pulse flex-col gap-2 p-4", children: [
    /* @__PURE__ */ H("span", { className: "h-[22px] w-1/2 bg-neutral-200" }),
    /* @__PURE__ */ H("span", { className: "h-4 w-1/4 bg-neutral-100" })
  ] })
] }), OD = ({
  item: e,
  state: t,
  shouldUseVirtualFocus: n
}) => {
  const r = J(null), a = t.disabledKeys.has(e.key), i = t.selectionManager.isSelected(e.key), o = t.selectionManager.focusedKey === e.key, { optionProps: l } = U5(
    {
      key: e.key,
      isDisabled: a,
      isSelected: i,
      shouldSelectOnPressUp: !0,
      shouldFocusOnHover: !0,
      shouldUseVirtualFocus: n
    },
    t,
    r
  );
  return /* @__PURE__ */ H(
    "li",
    {
      ...l,
      ref: r,
      className: ae(
        'over hover:bg-neutral-50" flex cursor-pointer flex-col justify-center bg-white p-4',
        o && "bg-neutral-50"
      ),
      children: e.rendered
    }
  );
}, zD = ({
  inputRef: e,
  popoverRef: t,
  searchListRef: n,
  state: r,
  shouldUseVirtualFocus: a,
  linkBehavior: i,
  shouldFocusOnHover: o,
  shouldSelectOnPressUp: l,
  isLoading: s,
  isSearchListOpen: u,
  searchListWidth: f,
  ...h
}) => {
  const [g, v] = ne(""), { listBoxProps: E } = j5(
    {
      autoFocus: r.focusStrategy,
      shouldUseVirtualFocus: a,
      linkBehavior: i,
      shouldFocusOnHover: o,
      shouldSelectOnPressUp: l,
      ...h
    },
    r,
    n
  ), { overlayProps: b } = A5(
    {
      onClose: () => r.close(),
      shouldCloseOnBlur: !0,
      isOpen: r.isOpen,
      isDismissable: !0
    },
    t
  ), w = he(() => {
    var A, V;
    const S = (A = e.current) == null ? void 0 : A.getBoundingClientRect(), T = (V = n.current) == null ? void 0 : V.getBoundingClientRect();
    if (S && T) {
      let $ = 0;
      const _ = getComputedStyle(
        n.current
      ).marginTop;
      _ && ($ = +_.replace(/px/g, ""));
      const y = S.left - T.left, c = S.top - T.top + S.height + $;
      v(`translate(${y}px, ${c}px)`);
    }
  }, [e, n]);
  return re(() => {
    w();
  }, [w]), Di(
    /* @__PURE__ */ H(
      "div",
      {
        className: ae(
          "invisible absolute",
          g && (u || s) && "visible"
          // We need to hide the popover when it is not visible instead of not rendering it because React Aria will throw an error.
        ),
        ...b,
        ref: t,
        children: /* @__PURE__ */ H(
          "ul",
          {
            ...Pe(E, h),
            ref: n,
            "data-cy": "gudl-search-list",
            className: "focus:bg-red absolute z-50 mt-2 max-h-[356px] w-full divide-y divide-neutral-300 overflow-auto rounded-md border border-neutral-300 bg-white shadow-[0px_4px_6px_0px_rgba(26,26,26,0.06),0px_6px_20px_-2px_rgba(26,26,26,0.14)] ring-1 ring-black ring-opacity-5 focus:outline-none",
            style: {
              width: f,
              transform: g
            },
            children: s ? /* @__PURE__ */ H(AD, {}) : [...r.collection].map((S) => /* @__PURE__ */ H(
              OD,
              {
                shouldUseVirtualFocus: !0,
                item: S,
                state: r
              },
              S.key
            ))
          }
        )
      }
    ),
    document.body
  );
}, MD = de(
  "flex h-[56px] items-center justify-between relative rounded-lg border border-neutral-300 focus-within:border-brand-accessible-blue bg-white ring-inset transition-all focus-within:ring-1 focus-within:ring-brand-accessible-blue",
  {
    variants: {
      disabled: {
        true: "bg-neutral-50 border-neutral-200 cursor-not-allowed"
      },
      error: {
        true: "border-danger ring-danger focus-within:border-danger focus-within:ring-danger ring-1"
      }
    },
    defaultVariants: {
      disabled: !1,
      error: !1
    }
  }
), gN = (e, t) => {
  const n = OS(
    t == null ? void 0 : t.filterText,
    (t == null ? void 0 : t.fetchDelay) || 400
  ), r = jS({
    async load({ signal: a, filterText: i }) {
      var o;
      if (e) {
        const l = e.replace(
          "{filterText}",
          i
        ), u = await (await fetch(l, { signal: a })).json();
        let f = u;
        return t != null && t.pathToListItems && (f = (o = t == null ? void 0 : t.pathToListItems) == null ? void 0 : o.reduce(
          (h, g) => h[g],
          u
        )), {
          items: f
        };
      }
      return { items: [] };
    }
  });
  return re(() => {
    n != null && r.setFilterText(n);
  }, [n]), e || (r.loadingState = "error", r.error = new Error("No URL provided")), r;
}, yN = ({
  inputClassName: e,
  containerClassName: t,
  labelClassName: n,
  label: r,
  children: a,
  disabled: i,
  required: o,
  isLoading: l,
  touched: s,
  validationState: u,
  errorMessage: f,
  minChar: h = 1,
  onSelectionChange: g,
  onInputChange: v,
  ...E
}) => {
  const b = J(null), w = J(null), S = J(null), { contains: T } = f5({ sensitivity: "base" }), [A, V] = ne(0), $ = he((D) => {
    if (!D)
      return;
    new ResizeObserver(([C]) => {
      V(C.target.clientWidth);
    }).observe(D);
  }, []), _ = He.map(
    a,
    (D) => /* @__PURE__ */ H(N5, { textValue: D.props.title, children: D }, D.key)
  ), y = VS({
    children: _,
    label: r,
    allowsEmptyCollection: !0,
    // Fix for correctly updating re-fetched data when quickly typing and deleting the input value.
    defaultFilter: T,
    menuTrigger: "focus",
    onSelectionChange: (D) => {
      var C;
      const I = (C = y.collection.getItem(D)) == null ? void 0 : C.props.children.key;
      I && (g == null || g(I));
    },
    onInputChange: v && ((D) => {
      D.length >= h && v(D);
    }),
    ...E
  });
  re(() => {
    !y.inputValue && !y.selectedKey && (y.selectionManager.setSelectedKeys([]), y.setSelectedKey(null), y.setInputValue(""), g == null || g(""));
  }, [y.inputValue, y.selectedKey]);
  const { inputProps: c, listBoxProps: p, labelProps: d } = G5(
    {
      ...E,
      label: r,
      inputRef: b,
      listBoxRef: w,
      popoverRef: S
    },
    y
  ), { placeholder: m = "", name: O } = c, x = () => {
    var D;
    y.setInputValue(""), y.setSelectedKey(null), (D = b.current) == null || D.focus();
  }, P = !i && !!f && (u === "invalid" || s), N = y.isOpen && y.inputValue.length >= h && y.collection.size > 0;
  return /* @__PURE__ */ ie("div", { "data-cy": "gudl-search", children: [
    /* @__PURE__ */ ie(
      "div",
      {
        "data-cy": "gudl-search-container",
        ref: $,
        className: ae(
          MD({
            error: P,
            disabled: i
          }),
          t
        ),
        children: [
          /* @__PURE__ */ H(
            "input",
            {
              "data-cy": "gudl-search-input",
              ...c,
              name: O,
              ref: b,
              disabled: i,
              placeholder: m,
              className: ae(
                "text-label-md peer z-10 w-full appearance-none border-0 bg-transparent px-4 pb-2 pt-6 text-neutral-800 placeholder-transparent ring-0 focus-within:placeholder-neutral-500 focus:outline-none focus:ring-0 disabled:cursor-not-allowed disabled:text-neutral-400",
                e
              )
            }
          ),
          /* @__PURE__ */ ie(
            "label",
            {
              "data-cy": "gudl-search-label",
              ...d,
              className: ae(
                "text-label-md ease-standard absolute start-4 z-10 origin-top-left -translate-y-2 scale-75 transform cursor-text text-neutral-500 transition-transform duration-150 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:-translate-y-2 peer-focus:scale-75 peer-disabled:pointer-events-none peer-disabled:text-neutral-400 rtl:origin-top-right ",
                n
              ),
              children: [
                r,
                o && !i && /* @__PURE__ */ ie(
                  "span",
                  {
                    "data-cy": "gudl-search-required",
                    className: "text-brand-accessible-blue",
                    children: [
                      " ",
                      "*"
                    ]
                  }
                )
              ]
            }
          ),
          y.inputValue ? /* @__PURE__ */ H(
            dr,
            {
              intent: "primary-white",
              size: "xs",
              isDisabled: i,
              "aria-label": "Clear search input button",
              className: "me-2 ms-2.5",
              iconName: "close",
              onPress: x
            }
          ) : /* @__PURE__ */ H(
            Le,
            {
              iconName: "search",
              size: "sm",
              className: ae(
                "absolute end-0 pe-4 ps-2.5",
                i && "text-neutral-400"
              )
            }
          ),
          y.isOpen && /* @__PURE__ */ H(
            zD,
            {
              ...p,
              shouldUseVirtualFocus: !0,
              searchListRef: w,
              popoverRef: S,
              inputRef: b,
              state: y,
              isLoading: l,
              isSearchListOpen: N,
              searchListWidth: A
            }
          )
        ]
      }
    ),
    P && /* @__PURE__ */ H(gt, { intent: "danger", children: f })
  ] });
}, _D = de(
  "gudl-tag inline-flex align-middle items-center justify-center gap-1.5 rounded-[4px]",
  {
    variants: {
      /**
       * The intent of the tag.
       */
      intent: {
        "accessible-blue": "text-white bg-brand-accessible-blue",
        "info-lighter": "text-black bg-info-lighter",
        ilsy: "text-white bg-ilsy",
        "ilsy-lighter": "text-black bg-ilsy-lighter",
        ils: "text-black bg-ils",
        "ils-lighter": "text-black bg-ils-lighter",
        aya: "text-white bg-aya",
        "aya-lighter": "text-black bg-aya-lighter",
        upa: "text-white bg-upa",
        "upa-lighter": "text-black bg-upa-lighter",
        black: "text-white bg-black",
        white: "text-black bg-white"
      },
      /**
       * The size of the tag.
       */
      size: {
        sm: "px-3 py-[6px] text-label-sm-bold max-w-[200px]",
        lg: "px-4 py-[10px] text-label-lg max-w-[250px]"
      }
    },
    defaultVariants: {
      intent: "accessible-blue",
      size: "lg"
    }
  }
), $1 = ({
  intent: e = "accessible-blue",
  size: t = "lg",
  className: n,
  contentClassName: r,
  iconName: a,
  children: i,
  ...o
}) => /* @__PURE__ */ ie(
  "div",
  {
    "aria-label": i,
    "data-cy": "gudl-tag",
    className: ae(_D({ intent: e, size: t }), n),
    ...o,
    children: [
      a && /* @__PURE__ */ H(Le, { iconName: a, size: "sm" }),
      /* @__PURE__ */ H(
        "span",
        {
          "data-cy": "gudl-tag-content",
          className: ae("line-clamp-2 leading-[1.1em]", r),
          children: typeof i == "string" ? i : null
        }
      )
    ]
  }
), LD = de(
  "flex items-center justify-between relative rounded-lg border border-neutral-300 bg-white ring-inset transition-all focus-within:ring-2 focus-within:ring-brand-accessible-blue",
  {
    variants: {
      disabled: {
        true: "bg-neutral-50 border-neutral-200 cursor-not-allowed border"
      },
      error: {
        true: "border-danger ring-danger focus-within:ring-danger ring-1"
      }
    },
    defaultVariants: {
      disabled: !1,
      error: !1
    }
  }
), bN = (e) => {
  const {
    rows: t = 3,
    label: n,
    validationState: r,
    touched: a,
    errorMessage: i,
    isRequired: o,
    containerClassName: l,
    textAreaClassName: s,
    labelClassName: u,
    helperMessage: f,
    onBlur: h,
    onChange: g,
    className: v
  } = e, E = J(null), { labelProps: b, inputProps: w, errorMessageProps: S } = Uc(
    e,
    E
  ), { disabled: T, placeholder: A = " ", name: V, value: $ } = w, _ = !!$;
  return /* @__PURE__ */ ie("div", { className: v, children: [
    /* @__PURE__ */ ie(
      "div",
      {
        className: ae(
          LD({
            error: r === "invalid",
            disabled: T
          }),
          l
        ),
        "data-cy": "gudl-text-area-container",
        children: [
          /* @__PURE__ */ H(
            "textarea",
            {
              ...w,
              "data-cy": "gudl-text-area",
              id: `text-area-${V}`,
              name: V,
              rows: t,
              disabled: T,
              placeholder: A,
              className: ae(
                "focus-within:placeholder-text-label-md peer min-h-[80px] w-[calc(100%-2px)] appearance-none border-0 bg-transparent placeholder-transparent focus-within:placeholder-neutral-500 disabled:cursor-not-allowed disabled:text-neutral-400",
                "text-label-md mb-0.5 mt-7 px-4 pt-0 text-neutral-800 ring-0 focus:outline-none focus:ring-0",
                s
              ),
              required: o,
              ref: E,
              onChange: g || w.onChange,
              onBlur: h || w.onBlur
            }
          ),
          /* @__PURE__ */ H(
            "label",
            {
              className: ae(
                "text-label-md ease-standard absolute start-4 top-4 z-10 origin-left -translate-y-2 scale-75 transform cursor-text text-neutral-500 transition-transform duration-300 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:-translate-y-2 peer-focus:scale-75 peer-disabled:text-neutral-400 rtl:origin-right",
                u
              ),
              "aria-label": V,
              ...b,
              htmlFor: `text-area-${V}`,
              "data-cy": "gudl-text-area-label",
              children: /* @__PURE__ */ ie("span", { children: [
                n,
                o && /* @__PURE__ */ ie(De, { children: [
                  /* @__PURE__ */ ie("span", { className: "text-info", children: [
                    " ",
                    " *"
                  ] }),
                  /* @__PURE__ */ H("span", { className: "hidden", "aria-hidden": !0, children: "required" })
                ] })
              ] })
            }
          ),
          !T && r === "invalid" && /* @__PURE__ */ H(
            Le,
            {
              className: "text-danger absolute end-4",
              iconName: "alert-circle-outlined",
              size: "sm"
            }
          ),
          !T && r !== "invalid" && _ && a && /* @__PURE__ */ H(
            Le,
            {
              className: "text-success absolute end-4",
              iconName: "check-circle-outlined",
              size: "sm"
            }
          )
        ]
      }
    ),
    r === "invalid" && i && /* @__PURE__ */ H(gt, { intent: "danger", ...S, children: i }),
    f && /* @__PURE__ */ H(gt, { children: f })
  ] });
}, ID = de(
  "flex h-[56px] items-center justify-between relative rounded-lg border border-neutral-300 focus-within:border-brand-accessible-blue bg-white ring-inset transition-all focus-within:ring-1 focus-within:ring-brand-accessible-blue",
  {
    variants: {
      disabled: {
        true: "bg-neutral-50 border-neutral-200 cursor-not-allowed"
      },
      error: {
        true: "border-danger ring-danger focus-within:border-danger focus-within:ring-danger ring-1"
      }
    },
    defaultVariants: {
      disabled: !1,
      error: !1
    }
  }
), wN = (e) => {
  const {
    label: t,
    validationState: n,
    touched: r,
    errorMessage: a,
    isRequired: i,
    containerClassName: o,
    inputClassName: l,
    labelClassName: s,
    helperMessage: u,
    onBlur: f,
    onChange: h,
    className: g
  } = e, v = J(null), { labelProps: E, inputProps: b, errorMessageProps: w } = Uc(
    e,
    v
  ), { disabled: S, placeholder: T = " ", name: A, value: V } = b, $ = !!V;
  return /* @__PURE__ */ ie("div", { className: g, children: [
    /* @__PURE__ */ ie(
      "div",
      {
        className: ae(
          ID({
            error: n === "invalid",
            disabled: S
          }),
          o
        ),
        "data-cy": "gudl-text-input-container",
        children: [
          /* @__PURE__ */ H(
            "input",
            {
              ...b,
              "data-cy": "gudl-text-input",
              id: `text-input-${A}`,
              "aria-labelledby": `text-input-${A}-label`,
              name: A,
              disabled: S,
              placeholder: T,
              className: ae(
                "text-label-md peer z-10 min-w-full appearance-none border-0 bg-transparent px-4 pb-2 pt-6 text-neutral-800 placeholder-transparent ring-0 focus-within:placeholder-neutral-500 focus:outline-none focus:ring-0 disabled:cursor-not-allowed disabled:text-neutral-400",
                l
              ),
              required: i,
              ref: v,
              onChange: h || b.onChange,
              onBlur: f || b.onBlur
            }
          ),
          /* @__PURE__ */ H(
            "label",
            {
              className: ae(
                "text-label-md ease-standard absolute start-4 z-10 origin-top-left -translate-y-2 scale-75 transform cursor-text text-neutral-500 transition-transform duration-150 peer-placeholder-shown:translate-y-0 peer-placeholder-shown:scale-100 peer-focus:-translate-y-2 peer-focus:scale-75 peer-disabled:text-neutral-400 rtl:origin-top-right",
                s
              ),
              "aria-label": A,
              ...E,
              id: `text-input-${A}-label`,
              htmlFor: `text-input-${A}`,
              "data-cy": "gudl-text-input-label",
              children: /* @__PURE__ */ ie("span", { children: [
                t,
                i && /* @__PURE__ */ ie(De, { children: [
                  /* @__PURE__ */ ie("span", { className: "text-info", children: [
                    " ",
                    " *"
                  ] }),
                  /* @__PURE__ */ H("span", { className: "hidden", "aria-hidden": !0, children: "required" })
                ] })
              ] })
            }
          ),
          !S && n === "invalid" && /* @__PURE__ */ H(
            Le,
            {
              className: "text-danger absolute end-4",
              iconName: "alert-circle-outlined",
              size: "sm"
            }
          ),
          !S && n !== "invalid" && $ && r && /* @__PURE__ */ H(
            Le,
            {
              className: "text-success absolute end-4",
              iconName: "check-circle-outlined",
              size: "sm"
            }
          )
        ]
      }
    ),
    n === "invalid" && a && /* @__PURE__ */ H(gt, { intent: "danger", ...w, children: a }),
    u && /* @__PURE__ */ H(gt, { children: u })
  ] });
}, DD = de("w-full overflow-hidden", {
  variants: {
    /**
     * The aspect ratio of the video.
     */
    aspectRatio: {
      "2/3": "aspect-2/3",
      "3/2": "aspect-3/2",
      "4/3": "aspect-4/3",
      "3/4": "aspect-3/4",
      "5/3": "aspect-5/3",
      "7/5": "aspect-7/5",
      "5/7": "aspect-5/7",
      "16/9": "aspect-16/9",
      "9/16": "aspect-9/16",
      "21/9": "aspect-21/9",
      "1/1": "aspect-1/1"
    }
  }
}), xN = ({
  title: e,
  className: t,
  contentClassName: n,
  "aria-label": r,
  video: a,
  thumbnailImage: i,
  aspectRatio: o = "16/9",
  dataInfo: l
}) => {
  const [s, u] = ne(!1), f = l ? { "data-info": l } : {};
  return /* @__PURE__ */ ie(
    "div",
    {
      className: ae(
        "group/card focus-within:ring-primary-500 focus-within:shadow-outline-primary-500 relative flex w-full flex-col self-start overflow-hidden rounded-lg transition-shadow focus-within:ring-2",
        t
      ),
      "aria-label": r,
      "data-cy": "gudl-video-card",
      ...f,
      children: [
        /* @__PURE__ */ ie("figure", { className: "relative overflow-hidden", children: [
          /* @__PURE__ */ H(
            "img",
            {
              className: ae(
                DD({ aspectRatio: o }),
                "relative z-30 h-full w-full object-cover object-center transition-opacity",
                s ? "opacity-0" : "opacity-100"
              ),
              decoding: "async",
              loading: "lazy",
              src: i.url,
              alt: i.alt,
              "data-cy": "gudl-video-card-image"
            }
          ),
          /* @__PURE__ */ H("div", { className: "absolute top-0 z-20 flex h-full w-full", children: /* @__PURE__ */ H(
            ag,
            {
              "aria-label": a.ariaLabel,
              url: a.url,
              aspectRatio: o,
              loop: !0,
              playing: s,
              className: "h-full w-full",
              showControls: !1
            }
          ) })
        ] }),
        /* @__PURE__ */ H(
          "div",
          {
            className: "group group absolute bottom-0 end-0 start-0 top-0 z-50 flex items-center justify-center",
            "data-cy": "gudl-card-video-button",
            children: /* @__PURE__ */ H(
              dr,
              {
                iconName: s ? "pause" : "play",
                onPress: () => u(!s),
                intent: "primary-white",
                "aria-label": "Play video",
                className: ae(
                  "transition-opacity",
                  s ? "opacity-0" : "opacity-100",
                  "group-hover:opacity-100"
                )
              }
            )
          }
        ),
        e && // TODO: Q design about background/gradient for title
        /* @__PURE__ */ H(
          "div",
          {
            className: ae(
              "pointer-events-none absolute bottom-0 end-0 start-0 z-50 flex flex-col gap-4 hyphens-auto px-6 py-8 text-white",
              n
            ),
            "data-cy": "gudl-video-card-content",
            children: /* @__PURE__ */ H(Ye, { variant: "heading-5-bold", "data-cy": "gudl-video-card-title", children: e })
          }
        )
      ]
    }
  );
}, p3 = Ze({
  notifications: [],
  addNotification: () => {
  },
  addSuccessNotification: () => {
  },
  addErrorNotification: () => {
  },
  addInfoNotification: () => {
  },
  addWarningNotification: () => {
  },
  removeNotification: () => {
  }
}), EN = ({
  children: e
}) => {
  const [t, n] = ne([]), r = (f) => {
    const h = +/* @__PURE__ */ new Date();
    n([
      ...t,
      /* @__PURE__ */ se(VD, { ...f, key: h })
    ]);
  }, u = {
    notifications: t,
    addNotification: r,
    addSuccessNotification: (f) => {
      r({
        intent: "success",
        iconName: "check",
        ...f
      });
    },
    addErrorNotification: (f) => {
      r({
        intent: "danger",
        iconName: "error-circle-outlined",
        ...f
      });
    },
    addInfoNotification: (f) => {
      r({
        intent: "info",
        iconName: "info-circle-outlined",
        ...f
      });
    },
    addWarningNotification: (f) => {
      r({
        intent: "info",
        iconName: "alert-circle-outlined",
        ...f
      });
    },
    removeNotification: () => {
      n((f) => f.slice(1));
    }
  };
  return /* @__PURE__ */ ie(p3.Provider, { value: u, children: [
    e,
    /* @__PURE__ */ H(
      "div",
      {
        role: "alert",
        className: "gudl-notification-provider fixed bottom-4 end-4 start-4 z-[1] flex flex-col gap-4 md:bottom-auto md:end-12 md:start-auto md:top-12 md:max-w-md",
        "data-cy": "gudl-notification-provider",
        children: t && t
      }
    )
  ] });
}, ND = de(
  "gudl-notification relative inline-flex place-items-start gap-4 overflow-hidden rounded-lg p-6 shadow",
  {
    variants: {
      /**
       * Intent of the notification.
       */
      intent: {
        default: "bg-white",
        danger: "bg-danger-lighter",
        warning: "bg-warning-lighter",
        success: "bg-success-lighter",
        info: "bg-info-lighter"
      }
    }
  }
), RD = de("gudl-notification-icon -mt-0.5", {
  variants: {
    intent: {
      default: "text-black",
      danger: "text-danger",
      warning: "text-warning",
      success: "text-success",
      info: "text-info"
    }
  }
}), BD = () => {
  const e = ze(p3);
  if (!e)
    throw new Error(
      "useNotifications must be used within a NotificationProvider"
    );
  return e;
}, VD = ({
  title: e,
  description: t,
  intent: n = "default",
  iconName: r = "alert-circle-outlined",
  linkText: a,
  href: i,
  closeEnabled: o = !0,
  className: l
}) => {
  const { removeNotification: s } = BD(), [u, f] = ne(!0), h = () => {
    f(!1), setTimeout(s, 300);
  };
  return /* @__PURE__ */ ie(
    qr,
    {
      show: u,
      enter: "transition-all duration-300 ease-expressive",
      enterFrom: "opacity-0 -translate-y-4",
      enterTo: "opacity-100 translate-y-0",
      leave: "transition-all duration-300 ease-expressive",
      leaveFrom: "opacity-100 translate-y-0",
      leaveTo: "opacity-0 translate-y-4",
      className: ae(ND({ intent: n }), l),
      role: "alert",
      "data-cy": "gudl-notification",
      children: [
        /* @__PURE__ */ H(
          Le,
          {
            iconName: r,
            className: RD({ intent: n })
          }
        ),
        /* @__PURE__ */ ie("div", { children: [
          /* @__PURE__ */ H("div", { className: "text-label-lg-bold", "data-cy": "gudl-notification-title", children: e }),
          /* @__PURE__ */ H(
            "div",
            {
              className: "text-label-md mt-0.5",
              "data-cy": "gudl-notification-description",
              children: t
            }
          ),
          i && /* @__PURE__ */ H(
            FT,
            {
              href: i,
              color: "secondary",
              className: "mt-3.5",
              "data-cy": "gudl-notification-link",
              children: a
            }
          )
        ] }),
        o && /* @__PURE__ */ H(
          "button",
          {
            "aria-label": "Close the notification",
            onClick: () => h(),
            "data-cy": "gudl-notification-close",
            children: /* @__PURE__ */ H(Le, { iconName: "error" })
          }
        )
      ]
    }
  );
}, FD = de(
  "group py-3 relative transition-colors outline-none hover:text-black whitespace-nowrap px-4 flex",
  {
    variants: {
      isSelected: {
        true: "text-black",
        false: "text-neutral-500"
      },
      isFocusVisible: {
        true: "-outline-offset-2 outline-brand-accessible-blue outline-2"
      }
    }
  }
), lh = de(
  "ease-expressive absolute -bottom-3 left-0 w-full opacity-0 motion-safe:transition-opacity",
  {
    variants: {
      isActive: {
        true: "h-[2px] rounded-t-sm",
        false: "h-1 rounded-t-[4px] group-hover:opacity-100"
      },
      color: {
        black: "bg-black",
        "accessible-blue": "bg-brand-accessible-blue"
      },
      isSelected: {
        true: ""
      }
    },
    compoundVariants: [
      {
        isActive: !0,
        isSelected: !0,
        className: "opacity-100"
      }
    ]
  }
), $N = ({ color: e = "black", ...t }) => {
  var s;
  const n = ZS(t), r = J(null), { tabListProps: a } = t4(t, n, r), [i, o] = ne(!1), l = (u) => {
    const { scrollWidth: f, scrollLeft: h, clientWidth: g } = u;
    o(g + h < f);
  };
  return re(() => {
    var g;
    const u = (g = r.current) == null ? void 0 : g.querySelector(
      '[role="tab"][aria-selected="true"]'
    );
    if (!u)
      return;
    const { clientWidth: f, offsetLeft: h } = u;
    if (r.current) {
      const { clientWidth: v } = r.current;
      r.current.scrollLeft = h - v / 2 + f / 2;
    }
  }, [n.selectedKey]), na(() => {
    r.current && l(r.current);
  }, [r]), /* @__PURE__ */ ie(De, { children: [
    /* @__PURE__ */ ie(
      "div",
      {
        className: ae("gudl-tabs relative bg-white", t.orientation),
        children: [
          /* @__PURE__ */ H(
            "ul",
            {
              className: "scrollbar-hide gudl-tabs-selector text-body-bold flex max-w-full overflow-x-auto scroll-smooth bg-white px-6",
              ...a,
              ref: r,
              "data-cy": "gudl-tabs-selector",
              onScroll: (u) => l(u.currentTarget),
              children: [...n.collection].map((u) => /* @__PURE__ */ H(KD, { item: u, state: n, color: e }, u.key))
            }
          ),
          /* @__PURE__ */ H(
            "span",
            {
              className: ae(
                "pointer-events-none absolute right-0 top-0 h-full w-24 bg-gradient-to-r from-transparent to-white opacity-0 motion-safe:transition-opacity",
                i && "opacity-100"
              )
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ H(HD, { state: n }, (s = n.selectedItem) == null ? void 0 : s.key)
  ] });
}, HD = ({
  state: e,
  ...t
}) => {
  var a;
  const n = J(null), { tabPanelProps: r } = Q5(t, e, n);
  return /* @__PURE__ */ H("div", { ...r, ref: n, "data-cy": "gudl-tabs-panel", children: (a = e.selectedItem) == null ? void 0 : a.props.children });
}, KD = ({ color: e, item: t, state: n }) => {
  const { key: r, rendered: a } = t, i = J(null), { tabProps: o, isSelected: l } = J5({ key: r }, n, i), { isFocusVisible: s, focusProps: u } = vr();
  return /* @__PURE__ */ H(
    "button",
    {
      ...Pe(o, u),
      ref: i,
      className: FD({ isSelected: l, isFocusVisible: s }),
      children: /* @__PURE__ */ ie("div", { className: "relative", children: [
        a,
        /* @__PURE__ */ H(
          "span",
          {
            className: lh({
              isSelected: l,
              isActive: !0,
              color: e
            })
          }
        ),
        /* @__PURE__ */ H(
          "span",
          {
            className: lh({
              isActive: !1,
              color: e
            })
          }
        )
      ] })
    }
  );
}, PN = ({ icon: e, iconPosition: t = "start", children: n }) => {
  const r = () => e ? /* @__PURE__ */ H(Le, { iconName: e, size: "sm" }) : null;
  return /* @__PURE__ */ ie("div", { className: "flex items-center gap-2 whitespace-nowrap rtl:flex-row-reverse", children: [
    t === "start" && /* @__PURE__ */ H(r, {}),
    n,
    t === "end" && /* @__PURE__ */ H(r, {})
  ] });
}, sh = "M28.6644 47.5404C22.9509 48.6722 17.0208 47.6875 11.9797 44.7699L2.6326 47.8873C2.28023 48.0048 1.90209 48.0219 1.54056 47.9365C1.17904 47.8512 0.848419 47.6669 0.585761 47.4042C0.323103 47.1416 0.138785 46.811 0.0534675 46.4494C-0.0318499 46.0879 -0.0147961 45.7098 0.102718 45.3574L3.23008 36.0203C0.312497 30.9792 -0.672195 25.0491 0.459589 19.3356C1.59137 13.6221 4.76238 8.51521 9.38141 4.96704C14.0004 1.41886 19.7522 -0.328408 25.5643 0.0509996C31.3765 0.430407 36.8523 2.91059 40.9709 7.02915C45.0894 11.1477 47.5696 16.6235 47.949 22.4357C48.3284 28.2478 46.5811 33.9996 43.033 38.6186C39.4848 43.2376 34.3779 46.4086 28.6644 47.5404Z", CN = (e) => {
  const [t, n] = ne(!0), r = J(), a = () => {
    switch (dispatchEvent(new Event("chatOpen")), e.intent) {
      case "ori":
        try {
          window != null && window.openChatbot && window.openChatbot();
        } catch {
          console.error(
            "ORI Chatbot not available, please check that the script is loaded correctly."
          );
        }
        break;
    }
  };
  return re(() => {
    if (!e.isDisabled && e.intent === "ori") {
      const i = (/* @__PURE__ */ new Date()).getTime();
      return r.current = setInterval(() => {
        (/* @__PURE__ */ new Date()).getTime() - i > 1e4 && clearInterval(r.current), window.openChatbot && (n(!1), clearInterval(r.current));
      }, 500), () => clearInterval(r.current);
    }
  }, [e.isDisabled, e.intent]), /* @__PURE__ */ H(
    jD,
    {
      ...e,
      onPress: a,
      isDisabled: t || e.isDisabled
    }
  );
}, jD = ({ className: e, ...t }) => {
  const n = J(null), { buttonProps: r, isPressed: a } = Fi(t, n), { focusProps: i, isFocusVisible: o } = vr();
  return /* @__PURE__ */ ie(
    "button",
    {
      className: ae("group relative outline-none", e),
      ref: n,
      ...r,
      "aria-label": "chat-button",
      "data-cy": "gudl-chat-button",
      ...i,
      children: [
        o && /* @__PURE__ */ H(
          "svg",
          {
            width: "56",
            height: "56",
            viewBox: "-1 -1 50 50",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: "absolute left-[-4px] top-[-4px]",
            "aria-label": "chat-button-icon",
            children: /* @__PURE__ */ H(
              "path",
              {
                d: sh,
                className: "stroke-brand-digital-first-blue fill-transparent",
                strokeWidth: 2
              }
            )
          }
        ),
        /* @__PURE__ */ H(
          "svg",
          {
            width: "48",
            height: "48",
            viewBox: "-1 -1 50 50",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: "ease-expressive transition-all group-hover:scale-105 group-disabled:scale-100",
            "aria-label": "chat-button-icon",
            children: /* @__PURE__ */ H(
              "path",
              {
                d: sh,
                className: ae(
                  "group-disabled:fill-neutral-400 ",
                  a ? "fill-info-dark" : "fill-info"
                ),
                strokeWidth: 1,
                stroke: "white"
              }
            )
          }
        ),
        /* @__PURE__ */ ie(
          "svg",
          {
            width: "48",
            height: "48",
            viewBox: "0 0 48 48",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            className: "absolute left-0 top-0",
            "aria-label": "chat-button-icon-dots",
            children: [
              /* @__PURE__ */ H(
                "path",
                {
                  d: "M18 24C18 25.1046 17.1046 26 16 26C14.8954 26 14 25.1046 14 24C14 22.8954 14.8954 22 16 22C17.1046 22 18 22.8954 18 24Z",
                  fill: "white"
                }
              ),
              /* @__PURE__ */ H(
                "path",
                {
                  d: "M26 24C26 25.1046 25.1046 26 24 26C22.8954 26 22 25.1046 22 24C22 22.8954 22.8954 22 24 22C25.1046 22 26 22.8954 26 24Z",
                  fill: "white"
                }
              ),
              /* @__PURE__ */ H(
                "path",
                {
                  d: "M34 24C34 25.1046 33.1046 26 32 26C30.8954 26 30 25.1046 30 24C30 22.8954 30.8954 22 32 22C33.1046 22 34 22.8954 34 24Z",
                  fill: "white"
                }
              )
            ]
          }
        )
      ]
    }
  );
}, SN = ({ market: e }) => {
  let t = /* @__PURE__ */ ie(De, { children: [
    /* @__PURE__ */ H(
      "link",
      {
        rel: "stylesheet",
        href: "https://ef.com/assetscdn/gudl/styles/latin.min.css"
      }
    ),
    /* @__PURE__ */ H("style", { children: "html { font-family: EF Circular Latin, Helvetica, Open Sans, Gill Sans MT, Gill Sans, Corbel, Arial, sans-serif; }" })
  ] });
  switch (e) {
    case "ae":
    case "ar":
    case "dx":
    case "dz":
    case "ly":
    case "sa":
    case "tx":
    case "wm":
    case "wwar":
      t = /* @__PURE__ */ ie(De, { children: [
        /* @__PURE__ */ H(
          "link",
          {
            rel: "stylesheet",
            href: "https://ef.com/assetscdn/gudl/styles/arabic.min.css"
          }
        ),
        /* @__PURE__ */ H("style", { children: "html { font-family: EF Circular Latin, Noto Sans AR, Geeza Pro, Arabic Typesetting, Roboto, Noto, Noto Naskh Arabic, Times New Roman, serif; }" })
      ] });
      break;
    case "cn":
    case "zh-cn":
    case "zh-hans":
    case "tw":
    case "zh-tw":
    case "hk":
    case "zh-hk":
      t = /* @__PURE__ */ ie(De, { children: [
        /* @__PURE__ */ H(
          "link",
          {
            rel: "stylesheet",
            href: "https://ef.com/assetscdn/gudl/styles/chinese.min.css"
          }
        ),
        /* @__PURE__ */ H("style", { children: "html { font-family: EF Circular Latin, PingFang HK, Microsoft Yahei, sans-serif; }" })
      ] });
      break;
    case "jp":
    case "ja":
      t = /* @__PURE__ */ ie(De, { children: [
        /* @__PURE__ */ H(
          "link",
          {
            rel: "stylesheet",
            href: "https://ef.com/assetscdn/gudl/styles/japanese.min.css"
          }
        ),
        /* @__PURE__ */ H("style", { children: "html { font-family: EF Circular, Noto Sans JP, Hiragino Kaku Gothic Pro, Osaka, メイリオ, Meiryo, ＭＳ Ｐゴシック, sans-serif; }" })
      ] });
      break;
    case "kr":
    case "ko":
      t = /* @__PURE__ */ ie(De, { children: [
        /* @__PURE__ */ H(
          "link",
          {
            rel: "stylesheet",
            href: "https://ef.com/assetscdn/gudl/styles/korean.min.css"
          }
        ),
        /* @__PURE__ */ H("style", { children: "html { font-family: EF Circular Latin, Noto Sans KR, Nanum Gothic, Apple SD Gothic Neo, Malgun Gothic, Roboto, Noto, sans-serif; }" })
      ] });
      break;
    case "ax":
    case "az":
    case "ch":
    case "cl":
    case "co":
    case "cs":
    case "cz":
    case "de":
    case "fi":
    case "fr":
    case "hu":
    case "kz":
    case "lv":
    case "pl":
    case "ro":
    case "ru":
    case "si":
    case "sk":
    case "tn":
    case "tr":
    case "wc":
    case "wr":
    case "wwru":
      t = /* @__PURE__ */ ie(De, { children: [
        /* @__PURE__ */ H(
          "link",
          {
            rel: "stylesheet",
            href: "https://ef.com/assetscdn/gudl/styles/latin-extended.min.css"
          }
        ),
        /* @__PURE__ */ H("style", { children: "html { font-family: EF Circular, Helvetica, Open Sans, Gill Sans MT, Gill Sans, Corbel, Arial, sans-serif; }" })
      ] });
      break;
    case "at":
    case "au":
    case "be":
    case "br":
    case "bx":
    case "ca":
    case "ct":
    case "dk":
    case "ec":
    case "en":
    case "es":
    case "fc":
    case "gb":
    case "id":
    case "ie":
    case "ir":
    case "it":
    case "lg":
    case "lu":
    case "mx":
    case "nl":
    case "no":
    case "nz":
    case "pa":
    case "pe":
    case "pt":
    case "se":
    case "sg":
    case "sx":
    case "uk":
    case "us":
    case "uy":
    case "ve":
    case "we":
    case "wl":
    case "wp":
      break;
    case "th":
      t = /* @__PURE__ */ ie(De, { children: [
        /* @__PURE__ */ H(
          "link",
          {
            rel: "stylesheet",
            href: "https://ef.com/assetscdn/gudl/styles/thai.min.css"
          }
        ),
        /* @__PURE__ */ H("style", { children: "html { font-family: Noto Sans Thai UI, EF Circular Latin, Noto Sans Thai, Thonburi, Leelawadee UI, sans-serif; }" })
      ] });
      break;
    case "vn":
    case "vi":
      t = /* @__PURE__ */ ie(De, { children: [
        /* @__PURE__ */ H(
          "link",
          {
            rel: "stylesheet",
            href: "https://ef.com/assetscdn/gudl/styles/vietnamese.min.css"
          }
        ),
        /* @__PURE__ */ H("style", { children: "html { font-family: Noto Sans, EF Circular Latin, Helvetica, Open Sans, Arial, sans-serif; }" })
      ] });
      break;
  }
  return /* @__PURE__ */ ie(De, { children: [
    /* @__PURE__ */ H("link", { rel: "preconnect", as: "style", href: "https://ef.com/" }),
    /* @__PURE__ */ H(
      "link",
      {
        rel: "preconnect",
        as: "font",
        crossOrigin: "anonymous",
        href: "https://ef.com/"
      }
    ),
    t
  ] });
};
export {
  GD as Accordion,
  YD as Banner,
  GC as BreadcrumbItem,
  YC as Breadcrumbs,
  Xv as Button,
  XD as ButtonGroup,
  JD as Card,
  eN as Carousel,
  CN as ChatButton,
  tN as Checkbox,
  gh as Chevron,
  nN as Chip,
  rN as DatePicker,
  aN as Divider,
  gt as HelperMessage,
  Le as Icon,
  dr as IconButton,
  iN as ImageCard,
  SN as ImportMarketFontCSS,
  hN as Item,
  QD as LegacyCard,
  FT as Link,
  oN as ListItem,
  JC as Loading,
  ag as MediaPlayer,
  p1 as Modal,
  EN as NotificationProvider,
  cN as Radio,
  sN as RadioGroup,
  uN as RichText,
  yN as Search,
  mN as SearchItem,
  vN as Select,
  N5 as TabItem,
  PN as TabItemTitle,
  $N as Tabs,
  $1 as Tag,
  Ye as Text,
  bN as TextArea,
  wN as TextInput,
  xN as VideoCard,
  ae as twMerge,
  TS as useBreakpoints,
  BD as useNotifications,
  gN as useSearchAsyncList
};
